var dibs_buyer_layout =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpdibs_buyer_layout"];
/******/ 	window["webpackJsonpdibs_buyer_layout"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		4: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"tradeOnboarding","1":"contactModal","2":"AuthModal","3":"mobileAds"}[chunkId]||chunkId) + "_dibs_buyer_layout_14.0.7_" + "88ae53ee0fe598c268fd" + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://a.1stdibscdn.com/assets/buyer-layout/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/babel-runtime/core-js/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(386);

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(388);

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/core-js/library/fn/object/get-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/classCallCheck.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(3);

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/createClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(89);

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/extends.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(10);

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/inherits.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(17);

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/objectWithoutProperties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(18);

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/typeof.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(261);

/***/ }),

/***/ "./node_modules/charenc/charenc.js":
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),

/***/ "./node_modules/classnames/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "./node_modules/cookie/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ "./node_modules/core-js/library/fn/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/core-js/library/modules/es6.object.get-prototype-of.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_core.js").Object.getPrototypeOf;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/library/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("./node_modules/core-js/library/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
var document = __webpack_require__("./node_modules/core-js/library/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var ctx = __webpack_require__("./node_modules/core-js/library/modules/_ctx.js");
var hide = __webpack_require__("./node_modules/core-js/library/modules/_hide.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "./node_modules/core-js/library/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "./node_modules/core-js/library/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("./node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("./node_modules/core-js/library/modules/_property-desc.js");
module.exports = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__("./node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("./node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "./node_modules/core-js/library/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("./node_modules/core-js/library/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("./node_modules/core-js/library/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("./node_modules/core-js/library/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("./node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("./node_modules/core-js/library/modules/_has.js");
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var IE_PROTO = __webpack_require__("./node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("./node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("./node_modules/core-js/library/modules/_core.js");
var fails = __webpack_require__("./node_modules/core-js/library/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("./node_modules/core-js/library/modules/_shared.js")('keys');
var uid = __webpack_require__("./node_modules/core-js/library/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("./node_modules/core-js/library/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("./node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("./node_modules/core-js/library/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "./node_modules/core-js/library/modules/es6.object.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("./node_modules/core-js/library/modules/_to-object.js");
var $getPrototypeOf = __webpack_require__("./node_modules/core-js/library/modules/_object-gpo.js");

__webpack_require__("./node_modules/core-js/library/modules/_object-sap.js")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "./node_modules/crypt/crypt.js":
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),

/***/ "./node_modules/css-loader/lib/css-base.js":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),

/***/ "./node_modules/deep-freeze/index.js":
/***/ (function(module, exports) {

module.exports = function deepFreeze (o) {
  Object.freeze(o);

  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (o.hasOwnProperty(prop)
    && o[prop] !== null
    && (typeof o[prop] === "object" || typeof o[prop] === "function")
    && !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop]);
    }
  });
  
  return o;
};


/***/ }),

/***/ "./node_modules/dibs-browser-storage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var Cookies = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");

var root = 'undefined' === typeof window ? global : window;
var LocalStorage;
var SessionStorage;
var initializedSessionStorage;

function Storage() {
    this.data = {};
}

Storage.prototype = {
    _storage: {},
    _supported: false,
    initialize: function (storage) {
        this._storage = storage || root.localStorage;
        this._supported = this.isSupported();
        return this;
    },
    isSupported: function () {
        try {
            // FINDING-1393 - trying this first fixes private mode browsing in safari
            // https://github.com/marcuswestin/store.js/issues/42
            this._storage.setItem('dibsy', '');
            this._storage.removeItem('dibsy');
            return true;
        } catch (e) {
            return false;
        }
    },
    /**
     * Sets whether or not local/session storage is supported
     * @param {boolean} supported
     */
    setSupported: function (supported) {
        this._supported = supported;
    },
    getItems: function () {
        if (!this._supported) {
            return 'localStorage is not supported';
        }
        return this._storage;
    },
    /**
     * Set storage value by the key
     *
     * @param key - {string}
     * @param value - {mixed}
     * @returns {Storage}
     */
    setItem: function (key, value) {
        switch (typeof value) {
            case 'object':
                value = JSON.stringify(value);
                break;
            default:
                value += '';
        }

        if (!this._supported) {
            this.data[key] = value;
            Cookies.set(key, value, {path: '/', domain: '.1stdibs.com'});
        } else {
            try {
                this._storage.setItem(key, value);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    },
    /**
     * Get storage value by the key
     *
     * @param key - {string}
     * @returns {mixed}
     */
    getItem: function (key) {
        var value;

        if (!key) {
            return false;
        }
        if (!this._supported) {
            value = Cookies.get(key);
            if (!value && this.data[key]) {
                value = this.data[key];
            }
        } else {
            value = this._storage[key];
        }

        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    },
    /**
     * Delete storage by the key
     *
     * @param key - {string}
     * @returns {Storage}
     */
    deleteItem: function (key) {
        if (!this._supported) {
            delete this.data[key];
            Cookies.remove(key, {path: '/'});
        } else {
            try {
                this._storage.removeItem(key);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    }
};

LocalStorage = new Storage();
SessionStorage = new Storage();
initializedSessionStorage = SessionStorage.initialize(root.sessionStorage);

module.exports = {
    localStorage: LocalStorage.initialize(),
    sessionStorage: initializedSessionStorage
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/dibs-client-check/dist/mobileCheck.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 6/23/14
 * Time: 10:44 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * formerly:
 * js/global/core/dibs.js#isMobile
 * js/global/core/dibs.js#isTouchDevice
 * dibs.isMobile
 * dibs.isTouchDevice
 */


var getUserAgent = function () { // eslint-disable-line no-var
    return window.navigator && window.navigator.userAgent;
};

/**
 * Detect if user is on mobile device
 * this is a jenky solution since it relies on the user agent
 * it should rely on feature detection instead
 */
module.exports = {
    Android: function (ua) {
        return (/Android/i).test(ua || getUserAgent());
    },
    BlackBerry: function (ua) {
        return (/BlackBerry/i).test(ua || getUserAgent());
    },
    BlackBerry10: function (ua) {
        return (/BB10/i).test(ua || getUserAgent());
    },
    iPhone: function (ua) {
        return (/iPhone/i).test(ua || getUserAgent());
    },
    iPad: function (ua) {
        return (/iPad/i).test(ua || getUserAgent());
    },
    iPod: function (ua) {
        return (/iPod/i).test(ua || getUserAgent());
    },
    iOS: function (ua) {
        return this.iPhone(ua) || this.iPad(ua) || this.iPod(ua);
    },
    Opera: function (ua) {
        return (/Opera Mobi/i).test(ua || getUserAgent());
    },
    Windows: function (ua) {
        return (/IEMobile/i).test(ua || getUserAgent());
    },
    iOSVersion: function (version, ua) {
        var r = new RegExp('(iPad|iPhone|iPod);.*CPU.*OS ' + version + '_\\d', 'i'); // eslint-disable-line no-var
        return r.test(ua || getUserAgent());
    },
    any: function (ua) {
        var isMobile = false; // eslint-disable-line no-var
        var blacklist = [ // eslint-disable-line no-var
            'hasTouch',
            'isTouchDevice',
            'any',
            'iOSVersion'
        ];
        var p; // eslint-disable-line no-var

        for (p in this) {
            if (this.hasOwnProperty(p) && blacklist.indexOf(p) === -1) {
                isMobile = this[p](ua || getUserAgent());
                if (isMobile) {
                    return isMobile;
                }
            }
        }
        return isMobile;
    },
    /**
     * @returns {boolean}
     */
    hasTouch: function () {
        // http://stackoverflow.com/a/4819886
        // reference  GFoley83 Sep 4 '13 at 6:20 comment
        //
        // added non-prefixed maxTouchPoints based on this post:
        // http://msdn.microsoft.com/en-us/library/ie/hh772144%28v=vs.85%29.aspx
        return (window.navigator && !!(window.navigator.msMaxTouchPoints) || !!(window.navigator.maxTouchPoints)) || 'ontouchstart' in window;
    }
};


//DETECT TOUCH CAPABILITIES


/***/ }),

/***/ "./node_modules/dibs-cookie-jar/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var cookieMonster = __webpack_require__("./node_modules/cookie/index.js");

/**
 * @ignore
 * Created by daletan on 9/13/16.
 */

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var undefined = void 0;

var keys = Object.freeze({
    USER: 'userToken', // <id>_<hash>
    SELLER: 'sellerToken', // <VERTICAL PREFIX>_<id>_<hash>
    MASQUERADE_BUYER: 'masqueradeBuyer', // U_<id>
    MASQUERADE_SELLER: 'masqueradeSeller', // S_<id>_<VERTICAL PREFIX>
    USER_TYPE: 'userType',
    USER_EMAIL: 'userEmail',
    USER_LEGACY: 'userreg',
    GUEST_ID: 'guestId',
    EVER_LOGGED_IN: 'eli',
    PASSWORD_RESET: 'passwordToken'
});

/**
 * @param {string} value
 * @returns {object|null}
 */
var getMasqueradeValues = function getMasqueradeValues() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (!value) {
        return null;
    }

    var _value$split = value.split('_'),
        _value$split2 = _slicedToArray(_value$split, 3),
        type = _value$split2[0],
        id = _value$split2[1],
        vertical = _value$split2[2];

    var parts = {
        type: type,
        id: id
    };
    if (vertical) {
        parts.vertical = vertical;
    }
    return parts;
};

/**
 * @param {string|object} cookie
 * @param {string} cookieKey
 * @returns {string|undefined}
 */
var getCookieValue = function getCookieValue(cookie, cookieKey) {
    var parsed = typeof cookie === 'string' ? cookieMonster.parse(cookie) : cookie;
    return parsed && parsed[cookieKey] || undefined;
};

/**
 * @param {string|object} cookie
 * @returns {object|null}
 */
var getMasqueradeSellerInfo = function getMasqueradeSellerInfo(cookie) {
    var token = getCookieValue(cookie, keys.MASQUERADE_SELLER);
    return getMasqueradeValues(token);
};

/**
 * @param {string|object} cookie
 * @returns {object|null}
 */
var getMasqueradeBuyerInfo = function getMasqueradeBuyerInfo(cookie) {
    var token = getCookieValue(cookie, keys.MASQUERADE_BUYER);
    return getMasqueradeValues(token);
};

/**
 * @param {string|object} cookie
 * @returns {string|null}
 */
var getMasqueradeSellerId = function getMasqueradeSellerId(cookie) {
    var parts = getMasqueradeSellerInfo(cookie);
    return parts ? parts.vertical.toLowerCase() + '_' + parts.id : null;
};

/**
 * @param {string|object} cookie
 * @returns {string|null}
 */
var getMasqueradeBuyerId = function getMasqueradeBuyerId(cookie) {
    var parts = getMasqueradeBuyerInfo(cookie);
    return parts ? parts.id : null;
};

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
var getUserTokenString = function getUserTokenString(cookie) {
    return getCookieValue(cookie, keys.USER);
};

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
var getSellerTokenString = function getSellerTokenString(cookie) {
    return getCookieValue(cookie, keys.SELLER);
};

/**
 * @param {*} token seller token
 * @returns {boolean}
 */
var isSellerToken = function isSellerToken(token) {
    return (/^[fjva]_/i.test(token)
    );
};

/**
 * @param {*} token user token
 * @returns {boolean}
 */
var isBuyerToken = function isBuyerToken(token) {
    return (/^\d+_/i.test(token)
    );
};

/**
 *
 * @param {string} token user or seller token
 * @returns {string|null}
 */
var splitToken = function splitToken() {
    var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var parts = token.split('_');
    // an empty string will still return an array length of 1
    if (parts[0] !== '') {
        if (isSellerToken(token)) {
            return parts[0] + '_' + parts[1];
        } else if (isBuyerToken(token)) {
            // need this check otherwise an invalid
            // seller token will be used
            return parts[0];
        }
    }
    return null;
};

/**
 * based off of bunsen/libraries/bunsen#getMasqueradeAsUserId
 * The bunsen version returned an `object.userId`
 * This version only returns a string or null
 * @param {string|object} cookie
 * @param {string} type
 * @returns {string|null}
 */
var getMasqueradeUserIdByType = function getMasqueradeUserIdByType(cookie, type) {
    if (type === keys.MASQUERADE_SELLER) {
        return getMasqueradeSellerId(cookie);
    } else if (type === keys.MASQUERADE_BUYER) {
        return getMasqueradeBuyerId(cookie);
    }
    return null;
};

/**
 * @param {string} cookie
 * @param {string} [userType] The type of user masquerade info to return
 * @returns {string|null}
 */
var getMasqueradeValue = function getMasqueradeValue(cookie, userType) {
    var parsed = cookieMonster.parse(cookie);
    return getMasqueradeUserIdByType(parsed, userType) || null;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var cookieJarConstants = keys;

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getPasswordReset(cookie) {
    return getCookieValue(cookie, keys.PASSWORD_RESET);
}

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getUserType(cookie) {
    return getCookieValue(cookie, keys.USER_TYPE);
}

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getGuestId(cookie) {
    return getCookieValue(cookie, keys.GUEST_ID);
}

/**
 * backwards compatibility
 * public api method will be removed in next major release, use {@link getBuyerToken}
 * @deprecated
 * @param {string} cookie
 */
var getUserToken = getUserTokenString;

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getEverLoggedIn(cookie) {
    return getCookieValue(cookie, keys.EVER_LOGGED_IN);
}

/**
 * based off of bunsen/models/identity/User#getUserId
 * The additional change here is adding the `userType` as the bunsen
 * version only assumed the buyer. The seller is also taken into account
 * @param {string} cookie document.cookie or req.cookie string
 * @param {string} [userType] The type of user masquerade info to return
 * @param {boolean} [getRealUser] returns the actual user (usually internal) if you happen to be masquerading
 * @returns {string|null}
 */
function getUserId(cookie, userType, getRealUser) {

    if (typeof cookie !== 'string') {
        throw new Error('a cookie string must be passed in. a ' + (typeof cookie === 'undefined' ? 'undefined' : _typeof(cookie)) + ' was passed passed in instead.');
    }

    var masqueradeInfo = getMasqueradeValue(cookie, userType);

    if (masqueradeInfo && !getRealUser) {
        return masqueradeInfo;
    }

    var userId = splitToken(getUserTokenString(cookie));
    return userId || null;
}

/**
 *
 * @param {string} cookie
 * @returns {string|null}
 */
function getSellerId(cookie) {
    var sellerId = splitToken(getSellerTokenString(cookie));
    return sellerId || null;
}

/**
 *
 * @param {string} cookie
 * @returns {function}
 */
function isMasqueradingByType(cookie) {
    var userId = getUserId(cookie, null, true);
    /**
     * @param {string} userType
     * @returns {boolean}
     */
    return function (userType) {
        // return `false` instead of `null`
        return (userId ? userId : false) && !!getMasqueradeUserIdByType(cookie, userType);
    };
}

/**
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasqueradingAsSeller(cookie) {
    return isMasqueradingByType(cookie)(keys.MASQUERADE_SELLER);
}

/**
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasqueradingAsBuyer(cookie) {
    return isMasqueradingByType(cookie)(keys.MASQUERADE_BUYER);
}

/**
 * based off of bunsen/helpers/actingUser#isMasquerading
 * The bunsen version would pull the buyer user info from server vars
 * There should be a `userToken` cookie value set for the internal
 * user if you are masquerading
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasquerading(cookie) {
    var sellerId = isMasqueradingAsSeller(cookie);
    var buyerId = isMasqueradingAsBuyer(cookie);
    return !!(sellerId || buyerId);
}

/**
 * based off of bunsen#getToken, only used for admin functionality
 * @param {string} cookie
 * @returns {object}
 */
function getBuyerToken(cookie) {
    var userToken = getUserTokenString(cookie);
    if (userToken) {
        return {
            userToken: userToken
        };
    }
    return {};
}

/**
 * based off of bunsen#getToken, only used for admin functionality
 * sellerToken takes precedence over userToken (userToken case should
 * only be hit while masquerading)
 * @param {string} cookie
 * @returns {object}
 */
function getAdminToken(cookie) {
    // if seller token, return seller token
    var sellerToken = getSellerTokenString(cookie);
    if (sellerToken) {
        return {
            sellerToken: sellerToken
        };
    }

    // either a logged in admin user or masquerading as a seller
    // leveraging `getBuyerToken` logic
    // returns an object already
    // and will also return an empty object
    // for a falsey value
    return getBuyerToken(cookie);
}

exports.cookieJarConstants = cookieJarConstants;
exports.getPasswordReset = getPasswordReset;
exports.getUserType = getUserType;
exports.getGuestId = getGuestId;
exports.getUserToken = getUserToken;
exports.getEverLoggedIn = getEverLoggedIn;
exports.getUserId = getUserId;
exports.getSellerId = getSellerId;
exports.isMasqueradingByType = isMasqueradingByType;
exports.isMasqueradingAsSeller = isMasqueradingAsSeller;
exports.isMasqueradingAsBuyer = isMasqueradingAsBuyer;
exports.isMasquerading = isMasquerading;
exports.getBuyerToken = getBuyerToken;
exports.getAdminToken = getAdminToken;


/***/ }),

/***/ "./node_modules/dibs-currency-helpers/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var currencies = __webpack_require__("./node_modules/dibs-currency-helpers/currencies.js");
var constants = {
    currencies: {},
    symbols: {
        GBP: '£',
        EUR: '€',
        USD: '$',
        CAD: '$',
        AUD: '$',
        CHF: '', // Swiss francs don't have a currency symbol
        MXN: '$'
    },
    abbreviations: {
        CAD: 'CAD',
        AUD: 'AUD',
        MXN: 'MXN',
        CHF: 'CHF'
    },
    flags: {
        sm: {},
        md: {}
    }
};
currencies.forEach(function (currency) {
    constants.flags.sm[currency] = 'https://a.1stdibscdn.com/assets/currency-flags/1x/flag_'+currency.toLowerCase()+'.png';
    constants.flags.md[currency] = 'https://a.1stdibscdn.com/assets/currency-flags/2x/flag_'+currency.toLowerCase()+'.png';
});
currencies.forEach(function (currency) {
    constants.currencies['CURRENCY_' + currency] = currency;
});

module.exports = constants;


/***/ }),

/***/ "./node_modules/dibs-currency-helpers/currencies.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ['USD', 'GBP', 'EUR', 'CAD', 'AUD', 'CHF', 'MXN'];


/***/ }),

/***/ "./node_modules/dibs-currency-helpers/getCurrencySymbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var symbols = __webpack_require__("./node_modules/dibs-currency-helpers/constants.js").symbols;

module.exports = function getCurrencySymbol(currencyENUM) {
    return symbols[currencyENUM];
};


/***/ }),

/***/ "./node_modules/dibs-currency-helpers/intelligentFormat.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__("./node_modules/dibs-currency-helpers/util.js");

/*
 * @param  {number} amount - The number to format.
 * @param  {string} currency - Accepts any currency from currencies file
 * @param  {object} passedOptions - Additional options for localizedCashFormat
 * @return {string} - Formatted price string
 */
module.exports = function intelligentFormat(amount, currency, passedOptions) {
    var options = util.getFormatOptions(amount, currency, passedOptions);
    return util.localizedCashFormat(amount, options);
};


/***/ }),

/***/ "./node_modules/dibs-currency-helpers/util.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constants = __webpack_require__("./node_modules/dibs-currency-helpers/constants.js");
var currencies = constants.currencies;
var currencySymbols = constants.symbols;
var abbreviations = constants.abbreviations;
var flags = constants.flags;

/**
 * A more forgiving parseFloat
 * This is useful when consuming user-input
 * @param {number|string} number Either a formatted string (3,000) or integer (3000)
 * @returns {Number}
 */
exports.parseFloat = function dibsParsFloat(number) {
    return parseFloat(String(number).replace(/[^\d\.e-]/ig, '')) || 0;
};

/**
 * Round to the given precision
 * @param {number|string} number @see Number.parseFloat#number
 * @param {number} digits
 * @returns {number}
 */
exports.round = function round(number, digits) {
    var powed = Math.pow(10, digits);
    return Math.round(exports.parseFloat(number) * powed) / powed;
};

/**
 * Similar to PHP's number_format
 * @param number
 * @param {number} significantDigits The decimal place to round and fix a number to, Defaults to 0
 * @param {String} thousandsSeparator Defaults to ,
 * @param {String} decimalMark Defaults to .
 */
exports.format = function format(number, significantDigits, thousandsSeparator, decimalMark) {
    var suffix = '';
    var isNegative = number < 0;
    var bits;
    var i;

    if (isNegative) {
        number = number * -1;
    }

    significantDigits = significantDigits > -1 ? significantDigits : 0;
    thousandsSeparator = thousandsSeparator === undefined ? ',' : thousandsSeparator;
    decimalMark = decimalMark === undefined ? '.' : decimalMark;
    number = exports.round(number, significantDigits).toFixed(significantDigits);
    if (thousandsSeparator && number.match(/^\d{4}/)) {
        if (significantDigits) {
            suffix = number.substr(number.indexOf('.'));
            number = number.split('.')[0];
        }
        bits = number.split('');
        i = bits.length - 3;
        while (i > 0) {
            bits.splice(i, 0, thousandsSeparator);
            i -= 3;
        }
        number = bits.concat(suffix).join('');
    }
    if (decimalMark !== '.' && significantDigits) {
        number = number.replace(/\.(\d+)$/, decimalMark + '$1');
    }

    if (isNegative) {
        number = '-' + number;
    }

    return number;
};

/**
 *
 * @param {number} number The number to format
 * @param {object} [options] Formatting options
 * @param {boolean} [options.showDecimal] Show a decimal or not. Defaults to true
 * @param {string} [options.thousandsSeparator] What separates the thousands? Defaults to comma ","
 * @param {string} [options.decimalMark] What separates decimals? Defaults to period "."
 * @param {string} [options.abbreviation] Wheter to include an abbreviation or not
 * @param {boolean} [options.includeCurrencySymbol] Wheter to include a currency symbol or not
 * @param {string} [options.currencySymbol] Which currency symbol to use. Defaults to USD "$"
 * @returns {object}
 */
exports.localizedCashFormatObj = function (number, options) {
    options = Object.assign({
        includeCurrencySymbol: true
    }, options);
    var decimalsToShow = options.showDecimal === false ?  0 : 2;
    var thousandsSeparator = options.thousandsSeparator || ',';
    var decimalMark = options.decimalMark || '.';
    var currencySymbol = options.currencySymbol || '$';
    var abbreviation = options.abbreviation || '';
    var sign = '';

    number = exports.format(number, decimalsToShow, thousandsSeparator, decimalMark);
    currencySymbol = options.includeCurrencySymbol ? currencySymbol : '';

    // if it's negative we need to put the negative sign in front
    if (number.indexOf('-') !== -1) {
        sign = '-';
        number = number.replace('-', '');
    }

    return {
        sign: sign,
        currencySymbol: currencySymbol,
        number: number,
        abbreviation: abbreviation
    };
};

/**
 *
 * @param {number} number The number to format
 * @param {object} [options] Formatting options
 * @param {boolean} [options.showDecimal] Show a decimal or not. Defaults to true
 * @param {string} [options.thousandsSeparator] What separates the thousands? Defaults to comma ","
 * @param {string} [options.decimalMark] What separates decimals? Defaults to period "."
 * @param {string} [options.abbreviation] Wheter to include an abbreviation or not
 * @param {boolean} [options.includeCurrencySymbol] Wheter to include a currency symbol or not
 * @param {string} [options.currencySymbol] Which currency symbol to use. Defaults to USD "$"
 * @returns {string}
 */
exports.localizedCashFormat = function (number, options) {
    var localizedObject = exports.localizedCashFormatObj(number, options);
    var localizedNumber = localizedObject.number;
    var currencySymbol = localizedObject.currencySymbol;
    var abbreviation = localizedObject.abbreviation;
    var sign = localizedObject.sign;

    // if it's negative we need to put the negative sign in front
    if (sign) {
        sign = sign + ' ';
    }

    if (abbreviation.length) {
        abbreviation = ' ' + abbreviation;
    }

    if (options.formatNegativeAmount && sign) {
        return '(' + currencySymbol + localizedNumber + abbreviation + ')';
    }

    return sign + currencySymbol + localizedNumber + abbreviation;
};

/**
 * Converts a string containing numbers to an integer
 * @param  {string} amount
 * @return {number}
 */
exports.currencyToInteger = function (amount) {
    // Match all numbers and - sign
    var regexp = /-?[0-9]*/g;
    if (typeof amount === 'number') {
        return amount;
    } else if (typeof amount === 'string') {
        return parseInt(amount.match(regexp).join(''), 10);
    } else {
        return NaN;
    }
};

/**
 * Used internaly for intelligentFormat
 * @param  {number} The number to format
 * @param  {string}
 * @param  {object} passedOptions
 * @return {object}
 */
exports.getFormatOptions = function (amount, currency, passedOptions) {
    var options;
    var num = exports.parseFloat(amount);
    var currencyUppercase = (currency + '').toUpperCase();
    options = {
        // Only if there are decimals do we show them
        showDecimal : Math.ceil(num) !== Math.floor(num),
        thousandsSeparator : ',',
        decimalMark : '.',
        currencySymbol : currencySymbols.USD,
        abbreviation: abbreviations[currencyUppercase],
        formatNegativeAmount: false
    };

    switch (currencyUppercase) {
        case currencies.CURRENCY_GBP:
        case currencySymbols.GBP:
            options.currencySymbol = currencySymbols.GBP;
            break;
        case currencies.CURRENCY_CHF:
        case currencySymbols.CHF:
            options.includeCurrencySymbol = false;
            break;
        case currencies.CURRENCY_EUR:
        case currencySymbols.EUR:
            options.thousandsSeparator = '.';
            options.decimalMark = ',';
            options.currencySymbol = currencySymbols.EUR;
            break;
    }

    return Object.assign(options, passedOptions);
};

/**
 * @param  {string} currency currency abbreviation
 * @param  {string} size sm || md
 * @return {string} image url
 */
exports.getCurrencyFlags = function getCurrencyFlags(currency, size) {
    return flags[size || 'sm'][currency];
};


/***/ }),

/***/ "./node_modules/dibs-elements/dist/BarHeader/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BarHeader = __webpack_require__("./node_modules/dibs-elements/lib/BarHeader/index.js");

var _BarHeader2 = _interopRequireDefault(_BarHeader);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'headerWrapper': 'BarHeader__headerWrapper___1tOVZ',
  'title': 'BarHeader__title___3Yc_T',
  'small': 'BarHeader__small___2CPVz',
  'medium': 'BarHeader__medium___1WY1g',
  'large': 'BarHeader__large___2oKY6',
  'subtitle': 'BarHeader__subtitle___2DgA6',
  'bottomBorder': 'BarHeader__bottomBorder___3GVMZ'
};

var DefaultBarHeader = (0, _mergeThemeHoc2.default)(style)(_BarHeader2.default);
DefaultBarHeader.displayName = 'DefaultBarHeader';
exports.default = DefaultBarHeader;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/BasicSelect/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BasicSelect = __webpack_require__("./node_modules/dibs-elements/lib/BasicSelect/index.js");

var _BasicSelect2 = _interopRequireDefault(_BasicSelect);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'fieldContainer': 'BasicSelect__fieldContainer___2RAwF',
  'inputContainer': 'BasicSelect__inputContainer___6KIo_',
  'error': 'BasicSelect__error___1jTWl',
  'disabled': 'BasicSelect__disabled___1WPa9',
  'inputPlaceholderContainer': 'BasicSelect__inputPlaceholderContainer___3om7J',
  'horizontalSpacingSmall': 'BasicSelect__horizontalSpacingSmall___3zuC5',
  'animatedPlaceholderStart': 'BasicSelect__animatedPlaceholderStart___3LA4D',
  'animatedPlaceholderEnd': 'BasicSelect__animatedPlaceholderEnd___1mds-',
  'heightSmall': 'BasicSelect__heightSmall___ZMTIb',
  'heightDefault': 'BasicSelect__heightDefault___3Oyz0',
  'heightMedium': 'BasicSelect__heightMedium___1ZymC',
  'iconContainer': 'BasicSelect__iconContainer___1xret',
  'iconSpacingSmall': 'BasicSelect__iconSpacingSmall___x8uZR',
  'icon': 'BasicSelect__icon___2x0vJ',
  'errorMessage': 'BasicSelect__errorMessage____Xou_',
  'errorMessageRight': 'BasicSelect__errorMessageRight___3s91s',
  'label': 'BasicSelect__label___2_a4i',
  'withFakeNativePlaceholder': 'BasicSelect__withFakeNativePlaceholder___eXtuh',
  'heightLarge': 'BasicSelect__heightLarge___utsX-',
  'withAnimatedPlaceholder': 'BasicSelect__withAnimatedPlaceholder___3q8j0',
  'inputFocus': 'BasicSelect__inputFocus___2TxFP'
};

var DefaultBasicSelect = (0, _mergeThemeHoc2.default)(style)(_BasicSelect2.default);
DefaultBasicSelect.displayName = 'DefaultBasicSelect';
exports.default = DefaultBasicSelect;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Button/Primary.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__("./node_modules/dibs-elements/lib/Button/index.js");

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'small': 'Button__small___1mUB3',
  'medium': 'Button__medium___GQjew',
  'large': 'Button__large___27Jt8',
  'button': 'Button__button___3Jloz',
  'isDangerousAction': 'Button__isDangerousAction___1ZqcB'
};

var PrimaryButton = (0, _mergeThemeHoc2.default)(style)(_Button2.default);
PrimaryButton.displayName = 'PrimaryButton';
exports.default = PrimaryButton;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Button/Secondary.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__("./node_modules/dibs-elements/lib/Button/index.js");

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'small': 'Button__small___1JjIL',
  'medium': 'Button__medium___2PQuO',
  'large': 'Button__large___eBhCW',
  'button': 'Button__button___183vh',
  'isDangerousAction': 'Button__isDangerousAction___3jNzY'
};

var SecondaryButton = (0, _mergeThemeHoc2.default)(style)(_Button2.default);
SecondaryButton.displayName = 'SecondaryButton';
exports.default = SecondaryButton;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Button/TextCta.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__("./node_modules/dibs-elements/lib/Button/index.js");

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'small': 'Button__small___2QO7m',
  'medium': 'Button__medium___1tG9s',
  'large': 'Button__large___3Yc6J',
  'button': 'Button__button___1QI-C',
  'isDangerousAction': 'Button__isDangerousAction___aw3xt'
};

var TextCtaButton = (0, _mergeThemeHoc2.default)(style)(_Button2.default);
TextCtaButton.displayName = 'TextCtaButton';
exports.default = TextCtaButton;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Button/buyer/Primary.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Button__small___1mUB3":"Button__small___1mUB3","Button__medium___GQjew":"Button__medium___GQjew","Button__large___27Jt8":"Button__large___27Jt8","Button__button___3Jloz":"Button__button___3Jloz","Button__isDangerousAction___1ZqcB":"Button__isDangerousAction___1ZqcB"};

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Button/buyer/Secondary.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Button__small___1JjIL":"Button__small___1JjIL","Button__medium___2PQuO":"Button__medium___2PQuO","Button__large___eBhCW":"Button__large___eBhCW","Button__button___183vh":"Button__button___183vh","Button__isDangerousAction___3jNzY":"Button__isDangerousAction___3jNzY"};

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Checkbox/Circle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__("./node_modules/dibs-elements/lib/Checkbox/index.js");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'hiddenInput': 'Checkbox__hiddenInput___2Ugww',
  'container': 'Checkbox__container___wO1uF',
  'label': 'Checkbox__label___25y9M',
  'labelContainerDisabled': 'Checkbox__labelContainerDisabled___1r24R',
  'labelDisabled': 'Checkbox__labelDisabled___30VEp',
  'children': 'Checkbox__children___30LWU',
  'childrenDisabled': 'Checkbox__childrenDisabled___3iTW5',
  'checkbox': 'Checkbox__checkbox___3AZdc',
  'checkboxUnchecked': 'Checkbox__checkboxUnchecked___1KJ60',
  'checkmark': 'Checkbox__checkmark___3Lp1U',
  'checkboxDisabled': 'Checkbox__checkboxDisabled___1-kNB',
  'checkboxChecked': 'Checkbox__checkboxChecked___26445'
};

var CircleCheckbox = (0, _mergeThemeHoc2.default)(style)(_Checkbox2.default);
CircleCheckbox.displayName = 'CircleCheckbox';
exports.default = CircleCheckbox;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Checkbox/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__("./node_modules/dibs-elements/lib/Checkbox/index.js");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'hiddenInput': 'Checkbox__hiddenInput___3fGAk',
  'container': 'Checkbox__container___2viz_',
  'label': 'Checkbox__label___2_a4i',
  'labelContainerDisabled': 'Checkbox__labelContainerDisabled___1mvHZ',
  'labelDisabled': 'Checkbox__labelDisabled___2iVhW',
  'children': 'Checkbox__children___3tJgD',
  'childrenDisabled': 'Checkbox__childrenDisabled___VMApn',
  'checkbox': 'Checkbox__checkbox___2gFBy',
  'checkboxUnchecked': 'Checkbox__checkboxUnchecked___2TvQ-',
  'checkmark': 'Checkbox__checkmark___ApF0J',
  'checkboxDisabled': 'Checkbox__checkboxDisabled___Ie3Mk',
  'checkboxChecked': 'Checkbox__checkboxChecked___3pdpQ'
};

var DefaultCheckbox = (0, _mergeThemeHoc2.default)(style)(_Checkbox2.default);
DefaultCheckbox.displayName = 'DefaultCheckbox';
exports.default = DefaultCheckbox;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/ExpandingArea/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExpandingArea = __webpack_require__("./node_modules/dibs-elements/lib/ExpandingArea/index.js");

var _ExpandingArea2 = _interopRequireDefault(_ExpandingArea);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'labelWrapper': 'ExpandingArea__labelWrapper___6un6d',
  'label': 'ExpandingArea__label___2_a4i',
  'stringLabel': 'ExpandingArea__stringLabel___YMHHN',
  'arrow': 'ExpandingArea__arrow___1DJV2',
  'arrowUp': 'ExpandingArea__arrowUp___c2fvN',
  'expandingArea': 'ExpandingArea__expandingArea___1T-S5',
  'expanded': 'ExpandingArea__expanded___3KFdW'
};

var DefaultExpandingArea = (0, _mergeThemeHoc2.default)(style)(_ExpandingArea2.default);
DefaultExpandingArea.displayName = 'DefaultExpandingArea';
exports.default = DefaultExpandingArea;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Input/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Input = __webpack_require__("./node_modules/dibs-elements/lib/Input/index.js");

var _Input2 = _interopRequireDefault(_Input);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'fieldContainer': 'Input__fieldContainer___2RAwF',
  'inputContainer': 'Input__inputContainer___6KIo_',
  'error': 'Input__error___1jTWl',
  'disabled': 'Input__disabled___1WPa9',
  'inputPlaceholderContainer': 'Input__inputPlaceholderContainer___3om7J',
  'horizontalSpacingSmall': 'Input__horizontalSpacingSmall___3zuC5',
  'animatedPlaceholderStart': 'Input__animatedPlaceholderStart___3LA4D',
  'animatedPlaceholderEnd': 'Input__animatedPlaceholderEnd___1mds-',
  'heightSmall': 'Input__heightSmall___ZMTIb',
  'heightDefault': 'Input__heightDefault___3Oyz0',
  'heightMedium': 'Input__heightMedium___1ZymC',
  'iconContainer': 'Input__iconContainer___1xret',
  'iconSpacingSmall': 'Input__iconSpacingSmall___x8uZR',
  'icon': 'Input__icon___2x0vJ',
  'errorMessage': 'Input__errorMessage____Xou_',
  'errorMessageRight': 'Input__errorMessageRight___3s91s',
  'label': 'Input__label___2_a4i',
  'bootstrapPadding': 'Input__bootstrapPadding___3rgDQ',
  'readOnlyContainer': 'Input__readOnlyContainer___3MxeP',
  'withLeftDecorator': 'Input__withLeftDecorator___1LUlg',
  'withRightDecorator': 'Input__withRightDecorator___3YhZZ',
  'heightLarge': 'Input__heightLarge___utsX-',
  'withAnimatedPlaceholder': 'Input__withAnimatedPlaceholder___3q8j0',
  'input': 'Input__input___bRf3p',
  'decorator': 'Input__decorator___1aG4Q',
  'errorIcon': 'Input__errorIcon___13Rs9 Input__icon___2x0vJ',
  'validatedIcon': 'Input__validatedIcon___1O9r6 Input__icon___2x0vJ',
  'readOnlyInput': 'Input__readOnlyInput___2NgAi',
  'inputFocus': 'Input__inputFocus___2TxFP'
};

var DefaultInput = (0, _mergeThemeHoc2.default)(style)(_Input2.default);
DefaultInput.displayName = 'DefaultInput';
exports.default = DefaultInput;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/ModalBackButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalBackButton = __webpack_require__("./node_modules/dibs-elements/lib/ModalBackButton/index.js");

var _ModalBackButton2 = _interopRequireDefault(_ModalBackButton);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'backButtonClickableArea': 'ModalBackButton__backButtonClickableArea___20Pmi',
  'backIcon': 'ModalBackButton__backIcon___30oHQ',
  'backButtonDisabled': 'ModalBackButton__backButtonDisabled___3UhhH'
};

var DefaultModalBackButton = (0, _mergeThemeHoc2.default)(style)(_ModalBackButton2.default);
DefaultModalBackButton.displayName = 'DefaultModalBackButton';
exports.default = DefaultModalBackButton;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/ModalBody/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalBody = __webpack_require__("./node_modules/dibs-elements/lib/ModalBody/index.js");

var _ModalBody2 = _interopRequireDefault(_ModalBody);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'modalBody': 'ModalBody__modalBody___2EzQf'
};

var DefaultModalBody = (0, _mergeThemeHoc2.default)(style)(_ModalBody2.default);
DefaultModalBody.displayName = 'DefaultModalBody';
exports.default = DefaultModalBody;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/ModalCloseButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalCloseButton = __webpack_require__("./node_modules/dibs-elements/lib/ModalCloseButton/index.js");

var _ModalCloseButton2 = _interopRequireDefault(_ModalCloseButton);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'closeClickableArea': 'ModalCloseButton__closeClickableArea___H4Qno',
  'closeIcon': 'ModalCloseButton__closeIcon___39hKL',
  'closeButtonDisabled': 'ModalCloseButton__closeButtonDisabled___1LelM'
};

var DefaultModalCloseButton = (0, _mergeThemeHoc2.default)(style)(_ModalCloseButton2.default);
DefaultModalCloseButton.displayName = 'DefaultModalCloseButton';
exports.default = DefaultModalCloseButton;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/ModalContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalContainer = __webpack_require__("./node_modules/dibs-elements/lib/ModalContainer/index.js");

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'stopBodyScroll': 'ModalContainer__stopBodyScroll___3oNKK',
  'overlayDefault': 'ModalContainer__overlayDefault___1Vj5A',
  'overlayFadeStart': 'ModalContainer__overlayFadeStart___sMsD1',
  'overlayDefaultOpening': 'ModalContainer__overlayDefaultOpening___8a5KA',
  'overlayDefaultClosing': 'ModalContainer__overlayDefaultClosing___3ToWB',
  'modalDefault': 'ModalContainer__modalDefault___2BfP6',
  'modalMedium': 'ModalContainer__modalMedium___yt_fR',
  'modalLarge': 'ModalContainer__modalLarge___1yXsP',
  'modalFullscreen': 'ModalContainer__modalFullscreen___1Un8X',
  'modalHeightCenter': 'ModalContainer__modalHeightCenter___1uOBs'
};

var DefaultModalContainer = (0, _mergeThemeHoc2.default)(style)(_ModalContainer2.default);
DefaultModalContainer.displayName = 'DefaultModalContainer';
exports.default = DefaultModalContainer;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Radio/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Radio = __webpack_require__("./node_modules/dibs-elements/lib/Radio/index.js");

var _Radio2 = _interopRequireDefault(_Radio);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'hiddenInput': 'Radio__hiddenInput___3fGAk',
  'labelContainer': 'Radio__labelContainer___hF4Uy',
  'labelContainerDisabled': 'Radio__labelContainerDisabled___1mvHZ',
  'radioButton': 'Radio__radioButton___n0CA5',
  'innerButton': 'Radio__innerButton___Vm1Wp',
  'innerButtonChecked': 'Radio__innerButtonChecked___PtR7P',
  'label': 'Radio__label___2_a4i',
  'children': 'Radio__children___3tJgD',
  'childrenDisabled': 'Radio__childrenDisabled___VMApn',
  'buttonChecked': 'Radio__buttonChecked___1uG0_',
  'innerButtonDisabled': 'Radio__innerButtonDisabled___21pZ4',
  'buttonDisabled': 'Radio__buttonDisabled___1DSTu'
};

var DefaultRadio = (0, _mergeThemeHoc2.default)(style)(_Radio2.default);
DefaultRadio.displayName = 'DefaultRadio';
exports.default = DefaultRadio;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Select/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = __webpack_require__("./node_modules/dibs-elements/lib/Select/index.js");

var _Select2 = _interopRequireDefault(_Select);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'field': 'Select__field___3wlin',
  'sizeLarge': 'Select__sizeLarge___3FsSh',
  'select': 'Select__select___Uuaqu',
  'heightLarge': 'Select__heightLarge___utsX-',
  'heightDefault': 'Select__heightDefault___3Oyz0',
  'placeholderWithoutValue': 'Select__placeholderWithoutValue___qbTTE',
  'sizeSmall': 'Select__sizeSmall___23w5-',
  'heightSmall': 'Select__heightSmall___ZMTIb',
  'withPlaceholder': 'Select__withPlaceholder___bxjO1',
  'placeholder': 'Select__placeholder___2m6Hv',
  'withoutAnimatedPlaceholder': 'Select__withoutAnimatedPlaceholder___UCR95',
  'sizeMedium': 'Select__sizeMedium___33BFk',
  'heightMedium': 'Select__heightMedium___1ZymC',
  'disabled': 'Select__disabled___1WPa9',
  'valid': 'Select__valid___1yyDb',
  'error': 'Select__error___1jTWl',
  'inputErrorMessage': 'Select__inputErrorMessage___2Pp2Q',
  'multiSelectValueContainer': 'Select__multiSelectValueContainer___HjO_F',
  'multiSelectLabel': 'Select__multiSelectLabel___HFebX',
  'multiSelectCloseContainer': 'Select__multiSelectCloseContainer___hJCVY',
  'multiSelectClose': 'Select__multiSelectClose___2H5-M'
};

var DefaultSelect = (0, _mergeThemeHoc2.default)(style)(_Select2.default);
DefaultSelect.displayName = 'DefaultSelect';
exports.default = DefaultSelect;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Spinner/buyer/Default.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Spinner__spinner___2UZXy":"Spinner__spinner___2UZXy","Spinner__spin___23ZhJ":"Spinner__spin___23ZhJ","Spinner__shadow___3mQfN":"Spinner__shadow___3mQfN","Spinner__small___2CPVz":"Spinner__small___2CPVz","Spinner__tiny___mLmnI":"Spinner__tiny___mLmnI","Spinner__colorDarkSolid___2nYuq":"Spinner__colorDarkSolid___2nYuq","Spinner__colorLightSolid___198aF":"Spinner__colorLightSolid___198aF","Spinner__colorDarkTransparent___KH8Vy":"Spinner__colorDarkTransparent___KH8Vy","Spinner__colorLightTransparent___3vGaM":"Spinner__colorLightTransparent___3vGaM","Spinner__colorDarkShadow___3N9s_":"Spinner__colorDarkShadow___3N9s_","Spinner__colorLightShadow___275Pk":"Spinner__colorLightShadow___275Pk"};

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Spinner/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Spinner = __webpack_require__("./node_modules/dibs-elements/lib/Spinner/index.js");

var _Spinner2 = _interopRequireDefault(_Spinner);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'spinner': 'Spinner__spinner___2UZXy',
  'spin': 'Spinner__spin___23ZhJ',
  'shadow': 'Spinner__shadow___3mQfN',
  'small': 'Spinner__small___2CPVz',
  'tiny': 'Spinner__tiny___mLmnI',
  'colorDarkSolid': 'Spinner__colorDarkSolid___2nYuq',
  'colorLightSolid': 'Spinner__colorLightSolid___198aF',
  'colorDarkTransparent': 'Spinner__colorDarkTransparent___KH8Vy Spinner__colorDarkSolid___2nYuq',
  'colorLightTransparent': 'Spinner__colorLightTransparent___3vGaM Spinner__colorLightSolid___198aF',
  'colorDarkShadow': 'Spinner__colorDarkShadow___3N9s_',
  'colorLightShadow': 'Spinner__colorLightShadow___275Pk'
};

var DefaultSpinner = (0, _mergeThemeHoc2.default)(style)(_Spinner2.default);
DefaultSpinner.displayName = 'DefaultSpinner';
exports.default = DefaultSpinner;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Switch/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Switch = __webpack_require__("./node_modules/dibs-elements/lib/Switch/index.js");

var _Switch2 = _interopRequireDefault(_Switch);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'hiddenInput': 'Switch__hiddenInput___3fGAk',
  'wrapper': 'Switch__wrapper___5CfDV',
  'label': 'Switch__label___2_a4i',
  'switch': 'Switch__switch___1A_eG',
  'slider': 'Switch__slider___3pYya',
  'isActive': 'Switch__isActive___13rcF',
  'dot': 'Switch__dot___88yY4',
  'sliderTextOn': 'Switch__sliderTextOn___i5xz3',
  'sliderTextOff': 'Switch__sliderTextOff___1Kc8h',
  'isChecked': 'Switch__isChecked___373wR'
};

var DefaultSwitch = (0, _mergeThemeHoc2.default)(style)(_Switch2.default);
DefaultSwitch.displayName = 'DefaultSwitch';
exports.default = DefaultSwitch;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Tabs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tabs = __webpack_require__("./node_modules/dibs-elements/lib/Tabs/index.js");

var _Tabs2 = _interopRequireDefault(_Tabs);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'tabs': 'Tabs__tabs___1Ur8h',
  'tab': 'Tabs__tab___1-pJG',
  'tabItem': 'Tabs__tabItem___xh5Kp',
  'active': 'Tabs__active___1EPBD',
  'collapsed': 'Tabs__collapsed___VOgGk'
};

var DefaultTabs = (0, _mergeThemeHoc2.default)(style)(_Tabs2.default);
DefaultTabs.displayName = 'DefaultTabs';
exports.default = DefaultTabs;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/TextArea/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextArea = __webpack_require__("./node_modules/dibs-elements/lib/TextArea/index.js");

var _TextArea2 = _interopRequireDefault(_TextArea);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'textAreaContainer': 'TextArea__textAreaContainer___2-d4m',
  'fieldContainer': 'TextArea__fieldContainer___2RAwF',
  'label': 'TextArea__label___2_a4i',
  'message': 'TextArea__message___30F-_',
  'error': 'TextArea__error___1jTWl',
  'errorMessage': 'TextArea__errorMessage____Xou_',
  'errorMessageRight': 'TextArea__errorMessageRight___3s91s'
};

var DefaultTextArea = (0, _mergeThemeHoc2.default)(style)(_TextArea2.default);
DefaultTextArea.displayName = 'DefaultTextArea';
exports.default = DefaultTextArea;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Well/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Well = __webpack_require__("./node_modules/dibs-elements/lib/Well/index.js");

var _Well2 = _interopRequireDefault(_Well);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'well': 'Well__well___-PRFz',
  'label': 'Well__label___2_a4i'
};

var DefaultWell = (0, _mergeThemeHoc2.default)(style)(_Well2.default);
DefaultWell.displayName = 'DefaultWell';
exports.default = DefaultWell;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/buyer.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BarHeader__headerWrapper___1tOVZ":"BarHeader__headerWrapper___1tOVZ","BarHeader__title___3Yc_T":"BarHeader__title___3Yc_T","BarHeader__small___2CPVz":"BarHeader__small___2CPVz","BarHeader__medium___1WY1g":"BarHeader__medium___1WY1g","BarHeader__large___2oKY6":"BarHeader__large___2oKY6","BarHeader__subtitle___2DgA6":"BarHeader__subtitle___2DgA6","BarHeader__bottomBorder___3GVMZ":"BarHeader__bottomBorder___3GVMZ","BasicSelect__fieldContainer___2RAwF":"BasicSelect__fieldContainer___2RAwF","BasicSelect__inputContainer___6KIo_":"BasicSelect__inputContainer___6KIo_","BasicSelect__error___1jTWl":"BasicSelect__error___1jTWl","BasicSelect__disabled___1WPa9":"BasicSelect__disabled___1WPa9","BasicSelect__inputPlaceholderContainer___3om7J":"BasicSelect__inputPlaceholderContainer___3om7J","BasicSelect__horizontalSpacingSmall___3zuC5":"BasicSelect__horizontalSpacingSmall___3zuC5","BasicSelect__animatedPlaceholderStart___3LA4D":"BasicSelect__animatedPlaceholderStart___3LA4D","BasicSelect__animatedPlaceholderEnd___1mds-":"BasicSelect__animatedPlaceholderEnd___1mds-","BasicSelect__heightSmall___ZMTIb":"BasicSelect__heightSmall___ZMTIb","BasicSelect__heightMedium___1ZymC":"BasicSelect__heightMedium___1ZymC","BasicSelect__iconContainer___1xret":"BasicSelect__iconContainer___1xret","BasicSelect__iconSpacingSmall___x8uZR":"BasicSelect__iconSpacingSmall___x8uZR","BasicSelect__icon___2x0vJ":"BasicSelect__icon___2x0vJ","BasicSelect__errorMessage____Xou_":"BasicSelect__errorMessage____Xou_","BasicSelect__errorMessageRight___3s91s":"BasicSelect__errorMessageRight___3s91s","BasicSelect__label___2_a4i":"BasicSelect__label___2_a4i","BasicSelect__withFakeNativePlaceholder___eXtuh":"BasicSelect__withFakeNativePlaceholder___eXtuh","BasicSelect__heightLarge___utsX-":"BasicSelect__heightLarge___utsX-","BasicSelect__heightDefault___3Oyz0":"BasicSelect__heightDefault___3Oyz0","BasicSelect__withAnimatedPlaceholder___3q8j0":"BasicSelect__withAnimatedPlaceholder___3q8j0","BasicSelect__inputFocus___2TxFP":"BasicSelect__inputFocus___2TxFP","Button__small___1mUB3":"Button__small___1mUB3","Button__medium___GQjew":"Button__medium___GQjew","Button__large___27Jt8":"Button__large___27Jt8","Button__button___3Jloz":"Button__button___3Jloz","Button__isDangerousAction___1ZqcB":"Button__isDangerousAction___1ZqcB","Button__small___1JjIL":"Button__small___1JjIL","Button__medium___2PQuO":"Button__medium___2PQuO","Button__large___eBhCW":"Button__large___eBhCW","Button__button___183vh":"Button__button___183vh","Button__isDangerousAction___3jNzY":"Button__isDangerousAction___3jNzY","Checkbox__hiddenInput___2Ugww":"Checkbox__hiddenInput___2Ugww","Checkbox__container___wO1uF":"Checkbox__container___wO1uF","Checkbox__label___25y9M":"Checkbox__label___25y9M","Checkbox__labelContainerDisabled___1r24R":"Checkbox__labelContainerDisabled___1r24R","Checkbox__labelDisabled___30VEp":"Checkbox__labelDisabled___30VEp","Checkbox__children___30LWU":"Checkbox__children___30LWU","Checkbox__childrenDisabled___3iTW5":"Checkbox__childrenDisabled___3iTW5","Checkbox__checkbox___3AZdc":"Checkbox__checkbox___3AZdc","Checkbox__checkboxUnchecked___1KJ60":"Checkbox__checkboxUnchecked___1KJ60","Checkbox__checkmark___3Lp1U":"Checkbox__checkmark___3Lp1U","Checkbox__checkboxDisabled___1-kNB":"Checkbox__checkboxDisabled___1-kNB","Checkbox__checkboxChecked___26445":"Checkbox__checkboxChecked___26445","Checkbox__hiddenInput___3fGAk":"Checkbox__hiddenInput___3fGAk","Checkbox__container___2viz_":"Checkbox__container___2viz_","Checkbox__label___2_a4i":"Checkbox__label___2_a4i","Checkbox__labelContainerDisabled___1mvHZ":"Checkbox__labelContainerDisabled___1mvHZ","Checkbox__labelDisabled___2iVhW":"Checkbox__labelDisabled___2iVhW","Checkbox__children___3tJgD":"Checkbox__children___3tJgD","Checkbox__childrenDisabled___VMApn":"Checkbox__childrenDisabled___VMApn","Checkbox__checkbox___2gFBy":"Checkbox__checkbox___2gFBy","Checkbox__checkboxUnchecked___2TvQ-":"Checkbox__checkboxUnchecked___2TvQ-","Checkbox__checkmark___ApF0J":"Checkbox__checkmark___ApF0J","Checkbox__checkboxDisabled___Ie3Mk":"Checkbox__checkboxDisabled___Ie3Mk","Checkbox__checkboxChecked___3pdpQ":"Checkbox__checkboxChecked___3pdpQ","ExpandingArea__labelWrapper___6un6d":"ExpandingArea__labelWrapper___6un6d","ExpandingArea__label___2_a4i":"ExpandingArea__label___2_a4i","ExpandingArea__stringLabel___YMHHN":"ExpandingArea__stringLabel___YMHHN","ExpandingArea__arrow___1DJV2":"ExpandingArea__arrow___1DJV2","ExpandingArea__arrowUp___c2fvN":"ExpandingArea__arrowUp___c2fvN","ExpandingArea__expandingArea___1T-S5":"ExpandingArea__expandingArea___1T-S5","ExpandingArea__expanded___3KFdW":"ExpandingArea__expanded___3KFdW","Input__fieldContainer___2RAwF":"Input__fieldContainer___2RAwF","Input__inputContainer___6KIo_":"Input__inputContainer___6KIo_","Input__error___1jTWl":"Input__error___1jTWl","Input__disabled___1WPa9":"Input__disabled___1WPa9","Input__inputPlaceholderContainer___3om7J":"Input__inputPlaceholderContainer___3om7J","Input__horizontalSpacingSmall___3zuC5":"Input__horizontalSpacingSmall___3zuC5","Input__animatedPlaceholderStart___3LA4D":"Input__animatedPlaceholderStart___3LA4D","Input__animatedPlaceholderEnd___1mds-":"Input__animatedPlaceholderEnd___1mds-","Input__heightSmall___ZMTIb":"Input__heightSmall___ZMTIb","Input__heightMedium___1ZymC":"Input__heightMedium___1ZymC","Input__iconContainer___1xret":"Input__iconContainer___1xret","Input__iconSpacingSmall___x8uZR":"Input__iconSpacingSmall___x8uZR","Input__icon___2x0vJ":"Input__icon___2x0vJ","Input__errorMessage____Xou_":"Input__errorMessage____Xou_","Input__errorMessageRight___3s91s":"Input__errorMessageRight___3s91s","Input__label___2_a4i":"Input__label___2_a4i","Input__bootstrapPadding___3rgDQ":"Input__bootstrapPadding___3rgDQ","Input__readOnlyContainer___3MxeP":"Input__readOnlyContainer___3MxeP","Input__withLeftDecorator___1LUlg":"Input__withLeftDecorator___1LUlg","Input__withRightDecorator___3YhZZ":"Input__withRightDecorator___3YhZZ","Input__heightLarge___utsX-":"Input__heightLarge___utsX-","Input__heightDefault___3Oyz0":"Input__heightDefault___3Oyz0","Input__withAnimatedPlaceholder___3q8j0":"Input__withAnimatedPlaceholder___3q8j0","Input__input___bRf3p":"Input__input___bRf3p","Input__decorator___1aG4Q":"Input__decorator___1aG4Q","Input__errorIcon___13Rs9":"Input__errorIcon___13Rs9","Input__validatedIcon___1O9r6":"Input__validatedIcon___1O9r6","Input__readOnlyInput___2NgAi":"Input__readOnlyInput___2NgAi","Input__inputFocus___2TxFP":"Input__inputFocus___2TxFP","ModalBackButton__backButtonClickableArea___20Pmi":"ModalBackButton__backButtonClickableArea___20Pmi","ModalBackButton__backIcon___30oHQ":"ModalBackButton__backIcon___30oHQ","ModalBackButton__backButtonDisabled___3UhhH":"ModalBackButton__backButtonDisabled___3UhhH","ModalBody__modalBody___2EzQf":"ModalBody__modalBody___2EzQf","ModalCloseButton__closeClickableArea___H4Qno":"ModalCloseButton__closeClickableArea___H4Qno","ModalCloseButton__closeIcon___39hKL":"ModalCloseButton__closeIcon___39hKL","ModalCloseButton__closeButtonDisabled___1LelM":"ModalCloseButton__closeButtonDisabled___1LelM","ModalContainer__stopBodyScroll___3oNKK":"ModalContainer__stopBodyScroll___3oNKK","ModalContainer__overlayDefault___1Vj5A":"ModalContainer__overlayDefault___1Vj5A","ModalContainer__overlayFadeStart___sMsD1":"ModalContainer__overlayFadeStart___sMsD1","ModalContainer__overlayDefaultOpening___8a5KA":"ModalContainer__overlayDefaultOpening___8a5KA","ModalContainer__overlayDefaultClosing___3ToWB":"ModalContainer__overlayDefaultClosing___3ToWB","ModalContainer__modalDefault___2BfP6":"ModalContainer__modalDefault___2BfP6","ModalContainer__modalMedium___yt_fR":"ModalContainer__modalMedium___yt_fR","ModalContainer__modalLarge___1yXsP":"ModalContainer__modalLarge___1yXsP","ModalContainer__modalFullscreen___1Un8X":"ModalContainer__modalFullscreen___1Un8X","ModalContainer__modalHeightCenter___1uOBs":"ModalContainer__modalHeightCenter___1uOBs","Radio__hiddenInput___3fGAk":"Radio__hiddenInput___3fGAk","Radio__labelContainer___hF4Uy":"Radio__labelContainer___hF4Uy","Radio__labelContainerDisabled___1mvHZ":"Radio__labelContainerDisabled___1mvHZ","Radio__radioButton___n0CA5":"Radio__radioButton___n0CA5","Radio__innerButton___Vm1Wp":"Radio__innerButton___Vm1Wp","Radio__innerButtonChecked___PtR7P":"Radio__innerButtonChecked___PtR7P","Radio__label___2_a4i":"Radio__label___2_a4i","Radio__children___3tJgD":"Radio__children___3tJgD","Radio__childrenDisabled___VMApn":"Radio__childrenDisabled___VMApn","Radio__buttonChecked___1uG0_":"Radio__buttonChecked___1uG0_","Radio__innerButtonDisabled___21pZ4":"Radio__innerButtonDisabled___21pZ4","Radio__buttonDisabled___1DSTu":"Radio__buttonDisabled___1DSTu","Select__field___3wlin":"Select__field___3wlin","Select__sizeLarge___3FsSh":"Select__sizeLarge___3FsSh","Select-value":"Select-value","Select__select___Uuaqu":"Select__select___Uuaqu","Select__heightLarge___utsX-":"Select__heightLarge___utsX-","Select__heightDefault___3Oyz0":"Select__heightDefault___3Oyz0","Select-input":"Select-input","Select-placeholder":"Select-placeholder","Select__placeholderWithoutValue___qbTTE":"Select__placeholderWithoutValue___qbTTE","Select__sizeSmall___23w5-":"Select__sizeSmall___23w5-","Select__heightSmall___ZMTIb":"Select__heightSmall___ZMTIb","Select__withPlaceholder___bxjO1":"Select__withPlaceholder___bxjO1","Select__placeholder___2m6Hv":"Select__placeholder___2m6Hv","Select__withoutAnimatedPlaceholder___UCR95":"Select__withoutAnimatedPlaceholder___UCR95","Select__sizeMedium___33BFk":"Select__sizeMedium___33BFk","Select__heightMedium___1ZymC":"Select__heightMedium___1ZymC","Select__disabled___1WPa9":"Select__disabled___1WPa9","Select-control":"Select-control","Select-multi-value-wrapper":"Select-multi-value-wrapper","Select--multi":"Select--multi","Select-menu-outer":"Select-menu-outer","Select-option":"Select-option","Select__valid___1yyDb":"Select__valid___1yyDb","Select":"Select","is-open":"is-open","Select__error___1jTWl":"Select__error___1jTWl","Select__inputErrorMessage___2Pp2Q":"Select__inputErrorMessage___2Pp2Q","Select__multiSelectValueContainer___HjO_F":"Select__multiSelectValueContainer___HjO_F","Select__multiSelectLabel___HFebX":"Select__multiSelectLabel___HFebX","Select__multiSelectCloseContainer___hJCVY":"Select__multiSelectCloseContainer___hJCVY","Select__multiSelectClose___2H5-M":"Select__multiSelectClose___2H5-M","is-focused":"is-focused","Spinner__spinner___2UZXy":"Spinner__spinner___2UZXy","Spinner__spin___23ZhJ":"Spinner__spin___23ZhJ","Spinner__shadow___3mQfN":"Spinner__shadow___3mQfN","Spinner__small___2CPVz":"Spinner__small___2CPVz","Spinner__tiny___mLmnI":"Spinner__tiny___mLmnI","Spinner__colorDarkSolid___2nYuq":"Spinner__colorDarkSolid___2nYuq","Spinner__colorLightSolid___198aF":"Spinner__colorLightSolid___198aF","Spinner__colorDarkTransparent___KH8Vy":"Spinner__colorDarkTransparent___KH8Vy","Spinner__colorLightTransparent___3vGaM":"Spinner__colorLightTransparent___3vGaM","Spinner__colorDarkShadow___3N9s_":"Spinner__colorDarkShadow___3N9s_","Spinner__colorLightShadow___275Pk":"Spinner__colorLightShadow___275Pk","Switch__hiddenInput___3fGAk":"Switch__hiddenInput___3fGAk","Switch__wrapper___5CfDV":"Switch__wrapper___5CfDV","Switch__label___2_a4i":"Switch__label___2_a4i","Switch__switch___1A_eG":"Switch__switch___1A_eG","Switch__slider___3pYya":"Switch__slider___3pYya","Switch__isActive___13rcF":"Switch__isActive___13rcF","Switch__dot___88yY4":"Switch__dot___88yY4","Switch__sliderTextOn___i5xz3":"Switch__sliderTextOn___i5xz3","Switch__sliderTextOff___1Kc8h":"Switch__sliderTextOff___1Kc8h","Switch__isChecked___373wR":"Switch__isChecked___373wR","TextArea__textAreaContainer___2-d4m":"TextArea__textAreaContainer___2-d4m","TextArea__fieldContainer___2RAwF":"TextArea__fieldContainer___2RAwF","TextArea__label___2_a4i":"TextArea__label___2_a4i","TextArea__message___30F-_":"TextArea__message___30F-_","TextArea__error___1jTWl":"TextArea__error___1jTWl","TextArea__errorMessage____Xou_":"TextArea__errorMessage____Xou_","TextArea__errorMessageRight___3s91s":"TextArea__errorMessageRight___3s91s"};

/***/ }),

/***/ "./node_modules/dibs-elements/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__("./node_modules/dibs-elements/dist/BarHeader/index.js");

Object.defineProperty(exports, 'BarHeader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index).default;
  }
});

var _index2 = __webpack_require__("./node_modules/dibs-elements/dist/BasicSelect/index.js");

Object.defineProperty(exports, 'BasicSelect', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index2).default;
  }
});

var _Primary = __webpack_require__("./node_modules/dibs-elements/dist/Button/Primary.js");

Object.defineProperty(exports, 'PrimaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Primary).default;
  }
});

var _Secondary = __webpack_require__("./node_modules/dibs-elements/dist/Button/Secondary.js");

Object.defineProperty(exports, 'SecondaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Secondary).default;
  }
});

var _TextCta = __webpack_require__("./node_modules/dibs-elements/dist/Button/TextCta.js");

Object.defineProperty(exports, 'TextCtaButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextCta).default;
  }
});

var _Circle = __webpack_require__("./node_modules/dibs-elements/dist/Checkbox/Circle.js");

Object.defineProperty(exports, 'CircleCheckbox', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default;
  }
});

var _index3 = __webpack_require__("./node_modules/dibs-elements/dist/Checkbox/index.js");

Object.defineProperty(exports, 'Checkbox', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index3).default;
  }
});

var _index4 = __webpack_require__("./node_modules/dibs-elements/dist/ExpandingArea/index.js");

Object.defineProperty(exports, 'ExpandingArea', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index4).default;
  }
});

var _index5 = __webpack_require__("./node_modules/dibs-elements/dist/Input/index.js");

Object.defineProperty(exports, 'Input', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index5).default;
  }
});

var _index6 = __webpack_require__("./node_modules/dibs-elements/dist/ModalBackButton/index.js");

Object.defineProperty(exports, 'ModalBackButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index6).default;
  }
});

var _index7 = __webpack_require__("./node_modules/dibs-elements/dist/ModalBody/index.js");

Object.defineProperty(exports, 'ModalBody', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index7).default;
  }
});

var _index8 = __webpack_require__("./node_modules/dibs-elements/dist/ModalCloseButton/index.js");

Object.defineProperty(exports, 'ModalCloseButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index8).default;
  }
});

var _index9 = __webpack_require__("./node_modules/dibs-elements/dist/ModalContainer/index.js");

Object.defineProperty(exports, 'ModalContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index9).default;
  }
});

var _index10 = __webpack_require__("./node_modules/dibs-elements/dist/Radio/index.js");

Object.defineProperty(exports, 'Radio', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index10).default;
  }
});

var _index11 = __webpack_require__("./node_modules/dibs-elements/dist/Select/index.js");

Object.defineProperty(exports, 'Select', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index11).default;
  }
});

var _index12 = __webpack_require__("./node_modules/dibs-elements/dist/Spinner/index.js");

Object.defineProperty(exports, 'Spinner', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index12).default;
  }
});

var _index13 = __webpack_require__("./node_modules/dibs-elements/dist/Switch/index.js");

Object.defineProperty(exports, 'Switch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index13).default;
  }
});

var _index14 = __webpack_require__("./node_modules/dibs-elements/dist/Tabs/index.js");

Object.defineProperty(exports, 'Tabs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index14).default;
  }
});

var _index15 = __webpack_require__("./node_modules/dibs-elements/dist/TextArea/index.js");

Object.defineProperty(exports, 'TextArea', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index15).default;
  }
});

var _index16 = __webpack_require__("./node_modules/dibs-elements/dist/Well/index.js");

Object.defineProperty(exports, 'Well', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_index16).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/dibs-elements/lib/BarHeader/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BarHeader = function BarHeader(props) {
    var _props$size = props.size,
        size = _props$size === undefined ? 'large' : _props$size,
        title = props.title,
        subtitle = props.subtitle,
        theme = props.theme,
        dataTn = props.dataTn;


    if (!theme) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: theme.headerWrapper },
        _react2.default.createElement(
            'div',
            {
                'data-tn': 'bar-header-title' + (dataTn ? '-' + dataTn : ''),
                className: (0, _classnames2.default)(theme.title, theme[size])
            },
            title
        ),
        subtitle && _react2.default.createElement(
            'div',
            {
                'data-tn': 'bar-header-subtitle' + (dataTn ? '-' + dataTn : ''),
                className: (0, _classnames2.default)(theme.subtitle, theme[size])
            },
            subtitle
        ),
        _react2.default.createElement('div', { className: theme.bottomBorder })
    );
};

BarHeader.displayName = 'BarHeader';

exports.default = BarHeader;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/BasicSelect/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames7 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames8 = _interopRequireDefault(_classnames7);

var _arrowDown = __webpack_require__("./node_modules/dibs-vg/dist/react/arrow-down.js");

var _arrowDown2 = _interopRequireDefault(_arrowDown);

var _ErrorMessage = __webpack_require__("./node_modules/dibs-elements/lib/Common/ErrorMessage.js");

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ANIMATION_DELAY = 10;
var ANIMATION_DURATION = 100;

var BasicSelect = function (_Component) {
    (0, _inherits3.default)(BasicSelect, _Component);

    function BasicSelect(props) {
        (0, _classCallCheck3.default)(this, BasicSelect);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BasicSelect.__proto__ || (0, _getPrototypeOf2.default)(BasicSelect)).call(this, props));

        _initialiseProps.call(_this);

        _this.onSelect = _this.onSelect.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.selectElement = null;

        var placeholder = props.placeholder,
            hasAnimatedPlaceholder = props.hasAnimatedPlaceholder,
            autoFocus = props.autoFocus,
            isFocused = props.isFocused,
            value = props.value;

        var isPlaceholderUp = !!placeholder && !!hasAnimatedPlaceholder && !!value;

        _this.state = {
            isAnimatedPlaceholderUp: isPlaceholderUp,
            isFocused: autoFocus || !!isFocused,
            showAnimatedPlaceholder: isPlaceholderUp,
            value: props.value || ''
        };
        return _this;
    }

    (0, _createClass3.default)(BasicSelect, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            var willUpdate = false;
            var value = this.state.value;
            var isFocused = this.state.isFocused;

            /* istanbul ignore else */
            if (typeof nextProps.value !== 'undefined' && !(this.state.value === nextProps.value === this.props.value)) {
                willUpdate = true;
                value = nextProps.value;
            }

            /* istanbul ignore else */
            if (typeof nextProps.isFocused !== 'undefined') {
                willUpdate = true;

                isFocused = nextProps.isFocused;
            }

            /* istanbul ignore else */
            if (willUpdate) {
                var _props = this.props,
                    _hasAnimatedPlaceholder = _props.hasAnimatedPlaceholder,
                    _placeholder = _props.placeholder;
                var _isAnimatedPlaceholderUp = this.state.isAnimatedPlaceholderUp;


                if (_hasAnimatedPlaceholder && _placeholder) {
                    if (_isAnimatedPlaceholderUp && !value) {
                        this.setState({
                            isAnimatedPlaceholderUp: false,
                            value: value,
                            isFocused: isFocused
                        }, function () {
                            setTimeout(function () {
                                _this2.setState({ showAnimatedPlaceholder: false });
                            }, ANIMATION_DURATION);
                        });
                    } else if (!_isAnimatedPlaceholderUp && !!value) {
                        this.setState({ value: value, isFocused: isFocused, showAnimatedPlaceholder: true }, function () {
                            setTimeout(function () {
                                _this2.setState({ isAnimatedPlaceholderUp: true });
                            }, ANIMATION_DELAY);
                        });
                    } else {
                        this.setState({ value: value, isFocused: isFocused });
                    }
                } else {
                    this.setState({ value: value, isFocused: isFocused });
                }
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (!prevState.isFocused && this.state.isFocused) {
                this.focusInput();
            } else if (prevState.isFocused && !this.state.isFocused) {
                this.blurInput();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this3 = this;

            var _props2 = this.props,
                autoComplete = _props2.autoComplete,
                autoFocus = _props2.autoFocus,
                dataTn = _props2.dataTn,
                disabled = _props2.disabled,
                errorDataTn = _props2.errorDataTn,
                errorMessage = _props2.errorMessage,
                errorMessageAlignment = _props2.errorMessageAlignment,
                hasAnimatedPlaceholder = _props2.hasAnimatedPlaceholder,
                hasError = _props2.hasError,
                horizontalSpacing = _props2.horizontalSpacing,
                label = _props2.label,
                name = _props2.name,
                options = _props2.options,
                placeholder = _props2.placeholder,
                size = _props2.size,
                theme = _props2.theme;
            var _state = this.state,
                isFocused = _state.isFocused,
                showAnimatedPlaceholder = _state.showAnimatedPlaceholder,
                value = _state.value;


            if (!theme) {
                return null;
            }

            var showError = hasError || !!errorMessage;
            var fakeNativePlaceholder = showAnimatedPlaceholder ? "" : !value && placeholder;
            var errorDataTnString = errorDataTn ? errorDataTn : dataTn + '-error';
            var inputContainerClasses = (0, _classnames8.default)(theme.inputContainer, (_classnames = {}, (0, _defineProperty3.default)(_classnames, theme.heightDefault, !size), (0, _defineProperty3.default)(_classnames, theme.heightSmall, size === 'small'), (0, _defineProperty3.default)(_classnames, theme.heightMedium, size === 'medium'), (0, _defineProperty3.default)(_classnames, theme.heightLarge, size === 'large'), (0, _defineProperty3.default)(_classnames, theme.error, showError), (0, _defineProperty3.default)(_classnames, theme.inputFocus, !showError && isFocused), (0, _defineProperty3.default)(_classnames, theme.disabled, disabled), (0, _defineProperty3.default)(_classnames, theme.withAnimatedPlaceholder, hasAnimatedPlaceholder && !!placeholder && !!value), (0, _defineProperty3.default)(_classnames, theme.withFakeNativePlaceholder, fakeNativePlaceholder), _classnames));

            var inputClasses = (0, _classnames8.default)((0, _defineProperty3.default)({}, theme.disabled, disabled));
            var arrowClasses = (0, _classnames8.default)(theme.icon, theme.arrowDown);

            var placeholderContainerClasses = (0, _classnames8.default)(theme.inputPlaceholderContainer, (0, _defineProperty3.default)({}, theme.horizontalSpacingSmall, horizontalSpacing === 'small'));

            return _react2.default.createElement(
                'div',
                { className: theme.fieldContainer },
                label ? _react2.default.createElement(
                    'div',
                    { className: theme.label },
                    label
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: inputContainerClasses },
                    _react2.default.createElement(
                        'div',
                        { className: placeholderContainerClasses },
                        _react2.default.createElement(
                            'select',
                            {
                                autoComplete: autoComplete,
                                autoFocus: autoFocus,
                                className: inputClasses,
                                'data-tn': dataTn,
                                disabled: disabled,
                                name: name,
                                onBlur: this.onBlur,
                                onChange: this.onSelect,
                                onFocus: this.onFocus,
                                ref: function ref(select) {
                                    _this3.selectElement = select;
                                },
                                value: value
                            },
                            fakeNativePlaceholder && _react2.default.createElement(
                                'option',
                                { value: '', disabled: true },
                                fakeNativePlaceholder
                            ),
                            options.map(function (option, index) {
                                return _react2.default.createElement(
                                    'option',
                                    { key: index, value: option.value },
                                    option.label
                                );
                            })
                        ),
                        this.renderPlaceholder()
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            onClick: this.onIconClick,
                            className: (0, _classnames8.default)(theme.iconContainer, (0, _defineProperty3.default)({}, theme.iconSpacingSmall, horizontalSpacing === 'small'))
                        },
                        _react2.default.createElement(_arrowDown2.default, { className: arrowClasses })
                    )
                ),
                _react2.default.createElement(_ErrorMessage2.default, {
                    message: errorMessage,
                    dataTn: errorDataTnString,
                    className: (0, _classnames8.default)(theme.errorMessage, (0, _defineProperty3.default)({}, theme.errorMessageRight, errorMessageAlignment === 'right'))
                })
            );
        }
    }]);
    return BasicSelect;
}(_react.Component);

BasicSelect.defaultProps = {
    autoComplete: "",
    autoFocus: false,
    disabled: false,
    errorMessageAlignment: 'right',
    hasAnimatedPlaceholder: false,
    hasError: false,
    horizontalSpacing: 'default',
    options: []
};

var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.blurInput = function () {
        var selectElement = _this4.selectElement;
        /* istanbul ignore else */
        if (selectElement) {
            selectElement.blur();
        }
    };

    this.focusInput = function () {
        var selectElement = _this4.selectElement;
        /* istanbul ignore else */
        if (selectElement) {
            selectElement.focus();
        }
    };

    this.onBlur = function () {
        _this4.setState({
            isFocused: false
        });
    };

    this.onIconClick = function () {
        var disabled = _this4.props.disabled;
        var isFocused = _this4.state.isFocused;

        /* istanbul ignore else */

        if (!disabled && !isFocused) {
            _this4.onFocus();
        }
    };

    this.onSelect = function (e) {
        var _props3 = _this4.props,
            onChange = _props3.onChange,
            hasAnimatedPlaceholder = _props3.hasAnimatedPlaceholder,
            placeholder = _props3.placeholder;

        var value = e.target.value;

        var isAnimatedPlaceholderUp = _this4.state.isAnimatedPlaceholderUp;

        if (hasAnimatedPlaceholder && placeholder) {
            if (isAnimatedPlaceholderUp && !value) {
                _this4.setState({
                    isAnimatedPlaceholderUp: false,
                    value: value
                }, function () {
                    setTimeout(function () {
                        _this4.setState({ showAnimatedPlaceholder: false });
                    }, ANIMATION_DURATION);
                });
            } else if (!isAnimatedPlaceholderUp && !!value) {
                _this4.setState({
                    value: value,
                    showAnimatedPlaceholder: true
                }, function () {
                    setTimeout(function () {
                        _this4.setState({ isAnimatedPlaceholderUp: true });
                    }, ANIMATION_DELAY);
                });
            } else {
                _this4.setState({ value: value });
            }
        } else {
            _this4.setState({ value: value });
        }

        if (onChange) {
            onChange(e);
        }
    };

    this.onFocus = function () {
        _this4.setState({
            isFocused: true
        });
    };

    this.renderPlaceholder = function () {
        var _props4 = _this4.props,
            placeholder = _props4.placeholder,
            theme = _props4.theme;
        var _state2 = _this4.state,
            isAnimatedPlaceholderUp = _state2.isAnimatedPlaceholderUp,
            showAnimatedPlaceholder = _state2.showAnimatedPlaceholder;


        if (!theme || !showAnimatedPlaceholder) {
            return null;
        }

        var placeholderClasses = (0, _classnames8.default)(theme.animatedPlaceholderStart, (0, _defineProperty3.default)({}, theme.animatedPlaceholderEnd, isAnimatedPlaceholderUp));

        return _react2.default.createElement(
            'span',
            { className: placeholderClasses },
            placeholder
        );
    };
};

exports.default = BasicSelect;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/Button/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
    var _props$size = props.size,
        size = _props$size === undefined ? 'large' : _props$size,
        children = props.children,
        theme = props.theme,
        className = props.className,
        dataTn = props.dataTn,
        isDangerousAction = props.isDangerousAction,
        href = props.href,
        btnProps = (0, _objectWithoutProperties3.default)(props, ['size', 'children', 'theme', 'className', 'dataTn', 'isDangerousAction', 'href']);


    if (theme) {
        var outputClassName = (0, _classnames2.default)((0, _defineProperty3.default)({}, theme.isDangerousAction, isDangerousAction), theme.button, theme[size], className);
        if (href) {
            return _react2.default.createElement(
                'a',
                (0, _extends3.default)({}, btnProps, {
                    className: outputClassName,
                    'data-tn': dataTn,
                    href: href
                }),
                children
            );
        }
        return _react2.default.createElement(
            'button',
            (0, _extends3.default)({}, btnProps, {
                className: outputClassName,
                'data-tn': dataTn
            }),
            children
        );
    }
    return null;
};

Button.displayName = 'Button';

exports.default = Button;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/Checkbox/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _checkmark = __webpack_require__("./node_modules/dibs-vg/dist/react/checkmark.js");

var _checkmark2 = _interopRequireDefault(_checkmark);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = function (_React$Component) {
    (0, _inherits3.default)(Checkbox, _React$Component);

    function Checkbox(props) {
        (0, _classCallCheck3.default)(this, Checkbox);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call(this, props));

        _this._onChange = function (e) {
            var onChange = _this.props.onChange;

            var _ref = e && e.currentTarget,
                checked = _ref.checked;

            /* istanbul ignore else */


            if (typeof checked === 'boolean') {
                _this.setState({ checked: checked });
                if (onChange) {
                    onChange(checked, e);
                }
            }
        };

        _this.state = {
            checked: _this.props.checked
        };

        _this._onChange = _this._onChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Checkbox, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            /* istanbul ignore else */
            if (this.props.checked !== nextProps.checked) {
                this.setState({ checked: nextProps.checked });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames3;

            var _props = this.props,
                dataTn = _props.dataTn,
                wrapperClass = _props.wrapperClass,
                labelClass = _props.labelClass,
                name = _props.name,
                label = _props.label,
                disabled = _props.disabled,
                theme = _props.theme,
                children = _props.children,
                value = _props.value;
            var checked = this.state.checked;


            if (!theme) {
                return null;
            }

            var labelContainerClassName = (0, _classnames2.default)(theme.container, (0, _defineProperty3.default)({}, theme.labelContainerDisabled, disabled));

            var labelClassName = (0, _classnames2.default)(theme.label, labelClass, (0, _defineProperty3.default)({}, theme.labelDisabled, disabled));

            var checkboxClassName = (0, _classnames2.default)(theme.checkbox, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, theme.checkboxChecked, checked), (0, _defineProperty3.default)(_classNames3, theme.checkboxUnchecked, !checked), (0, _defineProperty3.default)(_classNames3, theme.checkboxDisabled, disabled), _classNames3));

            var childClasses = (0, _classnames2.default)(theme.children, (0, _defineProperty3.default)({}, theme.childrenDisabled, disabled));

            return _react2.default.createElement(
                'div',
                { className: wrapperClass },
                _react2.default.createElement('input', {
                    id: name,
                    name: name,
                    type: 'checkbox',
                    className: theme.hiddenInput,
                    checked: checked,
                    disabled: disabled,
                    onChange: this._onChange,
                    value: value
                }),
                _react2.default.createElement(
                    'label',
                    { 'data-tn': dataTn, htmlFor: name, className: labelContainerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: checkboxClassName },
                        _react2.default.createElement(_checkmark2.default, { className: theme.checkmark })
                    ),
                    label && _react2.default.createElement(
                        'div',
                        { className: labelClassName },
                        label
                    )
                ),
                children && _react2.default.createElement(
                    'div',
                    { className: childClasses },
                    children
                )
            );
        }
    }]);
    return Checkbox;
}(_react2.default.Component);

Checkbox.defaultProps = {
    disabled: false
};


Checkbox.displayName = 'Checkbox';

exports.default = Checkbox;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/Common/ErrorMessage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__("./node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ErrorMessage(props) {
    var message = props.message,
        dataTn = props.dataTn,
        className = props.className;


    if (!message) {
        return null;
    }

    return (typeof message === 'undefined' ? 'undefined' : (0, _typeof3.default)(message)) === 'object' && message.hasOwnProperty('__html') ? _react2.default.createElement('div', {
        'data-tn': dataTn,
        className: className,
        dangerouslySetInnerHTML: message
    }) : _react2.default.createElement(
        'div',
        { 'data-tn': dataTn, className: className },
        message
    );
}

exports.default = ErrorMessage;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/ExpandingArea/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames4 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames5 = _interopRequireDefault(_classnames4);

var _arrowDown = __webpack_require__("./node_modules/dibs-vg/dist/react/arrow-down.js");

var _arrowDown2 = _interopRequireDefault(_arrowDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpandingArea = function (_React$Component) {
    (0, _inherits3.default)(ExpandingArea, _React$Component);

    function ExpandingArea(props) {
        (0, _classCallCheck3.default)(this, ExpandingArea);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ExpandingArea.__proto__ || (0, _getPrototypeOf2.default)(ExpandingArea)).call(this, props));

        _this.state = {
            isFullyExpanded: props.showOverflow && props.expanded
        };
        return _this;
    }

    (0, _createClass3.default)(ExpandingArea, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.showOverflow && this.props.expanded !== nextProps.expanded) {
                // need to remove overflow scroll when fully expanded
                // 200ms is css transition time
                var timeout = nextProps.expanded ? 200 : 0;
                setTimeout(function () {
                    _this2.setState({ isFullyExpanded: nextProps.expanded });
                }, timeout);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var isFullyExpanded = this.state.isFullyExpanded;
            var _props = this.props,
                children = _props.children,
                dataTn = _props.dataTn,
                expanded = _props.expanded,
                label = _props.label,
                labelClass = _props.labelClass,
                maxHeight = _props.maxHeight,
                showArrow = _props.showArrow,
                onClick = _props.onClick,
                wrapperClass = _props.wrapperClass,
                theme = _props.theme,
                expandingAreaClass = _props.expandingAreaClass;


            if (!theme) {
                return null;
            }

            var labelStyles = (0, _classnames5.default)(theme.labelWrapper, (0, _defineProperty3.default)({}, theme.stringLabel, typeof label === 'string' || showArrow), labelClass);

            var arrowStyles = (0, _classnames5.default)(theme.arrow, (0, _defineProperty3.default)({}, theme.arrowUp, expanded));

            var expandingAreaClassName = (0, _classnames5.default)(theme.expandingArea, (0, _defineProperty3.default)({}, theme.expanded, isFullyExpanded), expandingAreaClass);

            return _react2.default.createElement(
                'div',
                { className: wrapperClass },
                label && _react2.default.createElement(
                    'div',
                    { className: labelStyles, 'data-tn': dataTn, onClick: onClick },
                    _react2.default.createElement(
                        'div',
                        { className: theme.label },
                        label
                    ),
                    (typeof label === 'string' || showArrow) && _react2.default.createElement(_arrowDown2.default, { className: arrowStyles })
                ),
                children && _react2.default.createElement(
                    'div',
                    { className: expandingAreaClassName, style: { maxHeight: expanded ? maxHeight : "0px" } },
                    children
                )
            );
        }
    }]);
    return ExpandingArea;
}(_react2.default.Component);

ExpandingArea.defaultProps = {
    expanded: false
};


ExpandingArea.defaultProps = {
    showArrow: false,
    maxHeight: "90vh"
};

ExpandingArea.displayName = 'ExpandingArea';

exports.default = ExpandingArea;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/Input/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames7 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames8 = _interopRequireDefault(_classnames7);

var _uploadFailed = __webpack_require__("./node_modules/dibs-vg/dist/react/upload-failed.js");

var _uploadFailed2 = _interopRequireDefault(_uploadFailed);

var _circleCheck = __webpack_require__("./node_modules/dibs-vg/dist/react/circle-check.js");

var _circleCheck2 = _interopRequireDefault(_circleCheck);

var _ErrorMessage = __webpack_require__("./node_modules/dibs-elements/lib/Common/ErrorMessage.js");

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ANIMATION_DELAY = 10;

var ANIMATION_DURATION = 100;

var Input = function (_Component) {
    (0, _inherits3.default)(Input, _Component);

    function Input(props) {
        (0, _classCallCheck3.default)(this, Input);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).call(this, props));

        _initialiseProps.call(_this);

        var placeholder = props.placeholder,
            hasAnimatedPlaceholder = props.hasAnimatedPlaceholder,
            autoFocus = props.autoFocus,
            value = props.value;

        var isPlaceholderUp = !!placeholder && !!hasAnimatedPlaceholder && (!!value || !!autoFocus);

        _this.state = {
            isAnimatedPlaceholderUp: isPlaceholderUp,
            isFocused: !!autoFocus,
            showAnimatedPlaceholder: isPlaceholderUp,
            value: value || ''
        };

        _this.inputNode = null;
        return _this;
    }

    (0, _createClass3.default)(Input, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // initial call to focus element if autoFocus is passed in as true
            /* istanbul ignore if */
            if (this.props.autoFocus && this.inputNode && this.inputNode.focus) {
                this.inputNode.focus();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            /* istanbul ignore else */
            if (typeof nextProps.value !== 'undefined' && !(this.state.value === nextProps.value === this.props.value)) {
                var _hasAnimatedPlaceholder = nextProps.hasAnimatedPlaceholder,
                    _placeholder = nextProps.placeholder;
                var _state = this.state,
                    _isAnimatedPlaceholderUp = _state.isAnimatedPlaceholderUp,
                    _isFocused = _state.isFocused;


                if (_hasAnimatedPlaceholder && _placeholder && !_isFocused) {
                    if (_isAnimatedPlaceholderUp && !nextProps.value) {
                        this.setState({
                            isAnimatedPlaceholderUp: false,
                            value: nextProps.value
                        }, function () {
                            setTimeout(function () {
                                _this2.setState({ showAnimatedPlaceholder: false });
                            }, ANIMATION_DURATION);
                        });
                    } else if (!_isAnimatedPlaceholderUp && !!nextProps.value) {
                        this.setState({ value: nextProps.value, showAnimatedPlaceholder: true }, function () {
                            setTimeout(function () {
                                _this2.setState({ isAnimatedPlaceholderUp: true });
                            }, ANIMATION_DELAY);
                        });
                    } else {
                        this.setState({ value: nextProps.value });
                    }
                } else {
                    this.setState({ value: nextProps.value });
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                autoComplete = _props.autoComplete,
                autoFocus = _props.autoFocus,
                className = _props.className,
                dataTn = _props.dataTn,
                disabled = _props.disabled,
                errorDataTn = _props.errorDataTn,
                errorMessage = _props.errorMessage,
                errorMessageAlignment = _props.errorMessageAlignment,
                hasError = _props.hasError,
                hasValidText = _props.hasValidText,
                horizontalSpacing = _props.horizontalSpacing,
                label = _props.label,
                leftDecorator = _props.leftDecorator,
                leftDecoratorClass = _props.leftDecoratorClass,
                max = _props.max,
                maxLength = _props.maxLength,
                min = _props.min,
                name = _props.name,
                onKeyDown = _props.onKeyDown,
                pattern = _props.pattern,
                placeholder = _props.placeholder,
                readOnly = _props.readOnly,
                rightDecorator = _props.rightDecorator,
                rightDecoratorClass = _props.rightDecoratorClass,
                size = _props.size,
                showIcons = _props.showIcons,
                theme = _props.theme,
                type = _props.type;
            var _state2 = this.state,
                isFocused = _state2.isFocused,
                showAnimatedPlaceholder = _state2.showAnimatedPlaceholder,
                value = _state2.value;

            if (theme) {
                var _classnames, _classnames2, _classnames3;

                var showError = hasError || !!errorMessage;
                var nativePlaceholder = showAnimatedPlaceholder ? "" : placeholder;
                var showErrorIcon = showError;
                var showSuccessIcon = !showErrorIcon && hasValidText;
                var shouldShowIcon = showIcons && (showErrorIcon || showSuccessIcon);
                var errorDataTnString = errorDataTn ? errorDataTn : dataTn + '-error';
                var inputContainerClasses = (0, _classnames8.default)(theme.inputContainer, theme.bootstrapPadding, (_classnames = {}, (0, _defineProperty3.default)(_classnames, theme.heightDefault, !size), (0, _defineProperty3.default)(_classnames, theme.heightSmall, size === 'small'), (0, _defineProperty3.default)(_classnames, theme.heightMedium, size === 'medium'), (0, _defineProperty3.default)(_classnames, theme.heightLarge, size === 'large'), (0, _defineProperty3.default)(_classnames, theme.error, showError), (0, _defineProperty3.default)(_classnames, theme.inputFocus, !showError && isFocused), (0, _defineProperty3.default)(_classnames, theme.disabled, disabled), (0, _defineProperty3.default)(_classnames, theme.readOnlyContainer, readOnly), (0, _defineProperty3.default)(_classnames, theme.withAnimatedPlaceholder, readOnly || showAnimatedPlaceholder), _classnames));

                var placeholderContainerClasses = (0, _classnames8.default)(theme.inputPlaceholderContainer, (_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, theme.horizontalSpacingSmall, horizontalSpacing === 'small'), (0, _defineProperty3.default)(_classnames2, theme.withLeftDecorator, !!leftDecorator), (0, _defineProperty3.default)(_classnames2, theme.withRightDecorator, !!rightDecorator), _classnames2));

                var leftDecoratorClasses = (0, _classnames8.default)(theme.decorator, leftDecoratorClass);
                var rightDecoratorClasses = (0, _classnames8.default)(theme.decorator, rightDecoratorClass);

                var inputClasses = (0, _classnames8.default)(theme.input, className, (_classnames3 = {}, (0, _defineProperty3.default)(_classnames3, theme.disabled, disabled), (0, _defineProperty3.default)(_classnames3, theme.readOnlyInput, readOnly), _classnames3));
                var correctedAutocomplete = typeof autoComplete === 'boolean' ? autoComplete ? 'on' : 'off' : autoComplete;
                return _react2.default.createElement(
                    'div',
                    { className: theme.fieldContainer },
                    label && !readOnly ? _react2.default.createElement(
                        'div',
                        { className: theme.label },
                        label
                    ) : null,
                    _react2.default.createElement(
                        'div',
                        { className: inputContainerClasses },
                        !readOnly && leftDecorator && _react2.default.createElement(
                            'div',
                            { className: leftDecoratorClasses },
                            leftDecorator
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: placeholderContainerClasses },
                            _react2.default.createElement('input', {
                                autoComplete: correctedAutocomplete,
                                autoFocus: autoFocus,
                                className: inputClasses,
                                'data-tn': dataTn,
                                disabled: disabled,
                                max: max || null,
                                maxLength: maxLength || null,
                                min: min || null,
                                name: name,
                                onBlur: this.onBlur,
                                onChange: this.onChange,
                                onFocus: this.onFocus,
                                onKeyDown: onKeyDown,
                                pattern: pattern,
                                placeholder: nativePlaceholder,
                                readOnly: readOnly,
                                ref: function ref(input) {
                                    _this3.inputNode = input;
                                },
                                type: type,
                                value: value || ''
                            }),
                            this.renderPlaceholder()
                        ),
                        rightDecorator && _react2.default.createElement(
                            'div',
                            { className: rightDecoratorClasses },
                            rightDecorator
                        ),
                        shouldShowIcon && _react2.default.createElement(
                            'div',
                            { className: (0, _classnames8.default)(theme.iconContainer, (0, _defineProperty3.default)({}, theme.iconSpacingSmall, horizontalSpacing === 'small')) },
                            showErrorIcon && _react2.default.createElement(_uploadFailed2.default, { className: theme.errorIcon }),
                            showSuccessIcon && _react2.default.createElement(_circleCheck2.default, { className: theme.validatedIcon })
                        )
                    ),
                    _react2.default.createElement(_ErrorMessage2.default, {
                        message: errorMessage,
                        dataTn: errorDataTnString,
                        className: (0, _classnames8.default)(theme.errorMessage, (0, _defineProperty3.default)({}, theme.errorMessageRight, errorMessageAlignment === 'right'))
                    })
                );
            }
            return null;
        }
    }]);
    return Input;
}(_react.Component);

Input.defaultProps = {
    autoComplete: "",
    autoFocus: false,
    disabled: false,
    errorMessageAlignment: 'right',
    hasAnimatedPlaceholder: false,
    hasError: false,
    horizontalSpacing: 'default',
    onKeyDown: function onKeyDown(e) {
        return e;
    },
    readOnly: false,
    showIcons: true,
    type: "text"
};

var _initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.onBlur = function (e) {
        var onBlur = _this4.props.onBlur;
        var _state3 = _this4.state,
            isAnimatedPlaceholderUp = _state3.isAnimatedPlaceholderUp,
            value = _state3.value;


        if (isAnimatedPlaceholderUp && !value) {
            _this4.setState({ isFocused: false, isAnimatedPlaceholderUp: false }, function () {
                setTimeout(function () {
                    _this4.setState({ showAnimatedPlaceholder: false });
                }, ANIMATION_DURATION);
            });
        } else {
            _this4.setState({ isFocused: false });
        }
        /* istanbul ignore else */
        if (onBlur) {
            onBlur(e);
        }
    };

    this.onChange = function (e) {
        _this4.setState({ value: e.currentTarget.value });

        if (_this4.props.onChange) {
            _this4.props.onChange(e);
        }
    };

    this.onFocus = function (e) {
        var _props2 = _this4.props,
            onFocus = _props2.onFocus,
            hasAnimatedPlaceholder = _props2.hasAnimatedPlaceholder,
            placeholder = _props2.placeholder;
        var isAnimatedPlaceholderUp = _this4.state.isAnimatedPlaceholderUp;

        /* istanbul ignore else */

        if (onFocus) {
            onFocus(e);
        }

        if (hasAnimatedPlaceholder && placeholder && !isAnimatedPlaceholderUp) {
            _this4.setState({ isFocused: true, showAnimatedPlaceholder: true }, function () {
                setTimeout(function () {
                    _this4.setState({ isAnimatedPlaceholderUp: true });
                }, ANIMATION_DELAY);
            });
        } else {
            _this4.setState({ isFocused: true });
        }
    };

    this.renderPlaceholder = function () {
        var _props3 = _this4.props,
            label = _props3.label,
            placeholder = _props3.placeholder,
            readOnly = _props3.readOnly,
            theme = _props3.theme;
        var _state4 = _this4.state,
            showAnimatedPlaceholder = _state4.showAnimatedPlaceholder,
            isAnimatedPlaceholderUp = _state4.isAnimatedPlaceholderUp;


        var shouldRender = readOnly || showAnimatedPlaceholder;
        var text = readOnly ? label || placeholder : placeholder;

        if (!theme || !shouldRender) {
            return null;
        }
        var placeholderClasses = (0, _classnames8.default)(theme.animatedPlaceholderStart, (0, _defineProperty3.default)({}, theme.animatedPlaceholderEnd, isAnimatedPlaceholderUp || readOnly));

        return _react2.default.createElement(
            'span',
            { className: placeholderClasses },
            text
        );
    };
};

Input.displayName = 'Input';

exports.default = Input;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/ModalBackButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _arrowLeft = __webpack_require__("./node_modules/dibs-vg/dist/react/arrow-left.js");

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBackButton = function ModalBackButton(props) {
    var theme = props.theme,
        className = props.className,
        onClick = props.onClick,
        disabled = props.disabled;

    if (!theme) {
        return null;
    }

    var wrapperClass = (0, _classnames3.default)(theme.backButtonClickableArea, className, (0, _defineProperty3.default)({}, theme.backButtonDisabled, disabled));

    return _react2.default.createElement(
        'div',
        { className: wrapperClass, onClick: disabled ? function () {} : onClick },
        _react2.default.createElement(
            'div',
            { className: theme.backIcon },
            _react2.default.createElement(_arrowLeft2.default, null)
        )
    );
};

ModalBackButton.displayName = 'ModalBackButton';

exports.default = ModalBackButton;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/ModalBody/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBody = function ModalBody(props) {
    var theme = props.theme,
        className = props.className,
        children = props.children;

    if (!theme) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(theme.modalBody, className) },
        children
    );
};

ModalBody.displayName = 'ModalBody';

exports.default = ModalBody;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/ModalCloseButton/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _close = __webpack_require__("./node_modules/dibs-vg/dist/react/close.js");

var _close2 = _interopRequireDefault(_close);

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalCloseButton = function ModalCloseButton(props) {
    var theme = props.theme,
        className = props.className,
        onClick = props.onClick,
        disabled = props.disabled;

    if (!theme) {
        return null;
    }

    var wrapperClass = (0, _classnames3.default)(theme.closeClickableArea, className, (0, _defineProperty3.default)({}, theme.closeButtonDisabled, disabled));

    return _react2.default.createElement(
        'div',
        { 'data-tn': 'modal-close-button', className: wrapperClass, onClick: disabled ? function () {} : onClick },
        _react2.default.createElement(
            'div',
            { className: theme.closeIcon },
            _react2.default.createElement(_close2.default, null)
        )
    );
};

ModalCloseButton.displayName = 'ModalCloseButton';

exports.default = ModalCloseButton;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/ModalContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactPortal = __webpack_require__("./node_modules/react-portal/build/portal.js");

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _elementClass = __webpack_require__("./node_modules/element-class/index.js");

var _elementClass2 = _interopRequireDefault(_elementClass);

var _classnames3 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames4 = _interopRequireDefault(_classnames3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isTest = "production" === 'test';

var ModalContainer = function (_Component) {
    (0, _inherits3.default)(ModalContainer, _Component);

    function ModalContainer(props) {
        (0, _classCallCheck3.default)(this, ModalContainer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ModalContainer.__proto__ || (0, _getPrototypeOf2.default)(ModalContainer)).call(this, props));

        _this.handleKeydown = _this.handleKeydown.bind(_this);
        _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        _this.openModal = _this.openModal.bind(_this);
        _this.endCloseAnimation = _this.endCloseAnimation.bind(_this);
        _this.timeouts = [];
        _this.scrollY = 0;
        _this.state = {
            modalOpened: false,
            animation: null
        };
        return _this;
    }

    (0, _createClass3.default)(ModalContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            /* istanbul ignore else */
            if (this.props.isOpen && !this.state.modalOpened) {
                this.openModal();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            /* istanbul ignore else */
            if (nextProps.isOpen && !this.state.modalOpened) {
                this.openModal();
            } else if (!nextProps.isOpen && this.state.modalOpened) {
                this.closeModal();
            };
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
            var _props = this.props,
                theme = _props.theme,
                preventBackScroll = _props.preventBackScroll;
            /* istanbul ignore else */

            if (theme && preventBackScroll) {
                (0, _elementClass2.default)(document.body).remove(theme.stopBodyScroll);
            }
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            this.timeouts.forEach(clearTimeout);
        }
    }, {
        key: 'openModal',
        value: function openModal() {
            var _this2 = this;

            var _props2 = this.props,
                closeOnEsc = _props2.closeOnEsc,
                theme = _props2.theme,
                preventBackScroll = _props2.preventBackScroll,
                animates = _props2.animates,
                onOpen = _props2.onOpen;

            /* istanbul ignore else */

            if (closeOnEsc) {
                document.addEventListener('keydown', this.handleKeydown);
            }

            if (theme && preventBackScroll) {
                this.scrollY = window.pageYOffset;
                (0, _elementClass2.default)(document.body).add(theme.stopBodyScroll);

                // No need to scroll if position doesn't change - look at `.stopBodyScroll` styles
                if (this.scrollY === window.pageYOffset) {
                    this.scrollY = 0;
                }
            }

            if (onOpen) {
                onOpen();
            }

            if (animates) {
                this.setState({
                    modalOpened: true
                }, function () {
                    _this2.timeouts.push(setTimeout(function () {
                        return _this2.setState({ animation: "opening" });
                    }, 10));
                });
            } else {
                this.setState({
                    modalOpened: true
                });
            }
        }
    }, {
        key: 'endCloseAnimation',
        value: function endCloseAnimation() {
            this.setState({ modalOpened: false, animation: null });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            var _this3 = this;

            var _props3 = this.props,
                closeOnEsc = _props3.closeOnEsc,
                theme = _props3.theme,
                preventBackScroll = _props3.preventBackScroll,
                animates = _props3.animates;
            /* istanbul ignore else */

            if (closeOnEsc) {
                document.removeEventListener('keydown', this.handleKeydown);
            }

            if (theme && preventBackScroll) {
                (0, _elementClass2.default)(document.body).remove(theme.stopBodyScroll);

                // Scroll back to previous position
                if (this.scrollY) {
                    window.scrollTo(0, this.scrollY);
                }
            }

            if (animates && this.state.modalOpened) {
                this.setState({
                    animation: "closing"
                }, function () {
                    _this3.timeouts.push(setTimeout(_this3.endCloseAnimation, 300));
                });
            } else {
                this.setState({
                    modalOpened: false
                });
            }
        }
    }, {
        key: 'handleKeydown',
        value: function handleKeydown(e) {
            switch (e.key) {
                case "Esc":
                case "Escape":
                    if (this.props.closeOnEsc) {
                        this.props.onClose();
                    };
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'handleOutsideClick',
        value: function handleOutsideClick() {
            var _props4 = this.props,
                closeOnOutsideClick = _props4.closeOnOutsideClick,
                onClose = _props4.onClose;
            /* istanbul ignore else */

            if (closeOnOutsideClick) {
                onClose();
            }
        }
    }, {
        key: 'handleInsideClick',
        value: function handleInsideClick(e) {
            e.stopPropagation();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames, _classnames2;

            var _props5 = this.props,
                animates = _props5.animates,
                overlayClass = _props5.overlayClass,
                modalClass = _props5.modalClass,
                children = _props5.children,
                dataTn = _props5.dataTn,
                modalPosition = _props5.modalPosition,
                modalSize = _props5.modalSize,
                theme = _props5.theme,
                appendToBody = _props5.appendToBody;
            var _state = this.state,
                modalOpened = _state.modalOpened,
                animation = _state.animation;


            if (!theme) {
                return null;
            }

            var overlayClasses = (0, _classnames4.default)(theme.overlayDefault, (_classnames = {}, (0, _defineProperty3.default)(_classnames, theme.overlayFadeStart, animates), (0, _defineProperty3.default)(_classnames, theme.overlayDefaultOpening, animates && animation === "opening"), (0, _defineProperty3.default)(_classnames, theme.overlayDefaultClosing, animates && animation === "closing"), _classnames), overlayClass);

            var modalClasses = (0, _classnames4.default)(theme.modalDefault, (_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, theme.modalMedium, modalSize === 'medium'), (0, _defineProperty3.default)(_classnames2, theme.modalLarge, modalSize === 'large'), (0, _defineProperty3.default)(_classnames2, theme.modalFullscreen, modalSize === 'fullscreen'), (0, _defineProperty3.default)(_classnames2, theme.modalHeightCenter, modalPosition === 'center'), _classnames2), modalClass);

            var modal = _react2.default.createElement(
                'div',
                { onClick: this.handleOutsideClick, id: 'ModalOverlay', className: overlayClasses },
                _react2.default.createElement(
                    'div',
                    {
                        id: 'Modal',
                        onClick: this.handleInsideClick,
                        className: modalClasses,
                        'data-tn': dataTn
                    },
                    children
                )
            );
            if (appendToBody) {
                return _react2.default.createElement(
                    _reactPortal2.default,
                    {
                        isOpened: modalOpened,
                        closeOnOutsideClick: false,
                        closeOnEsc: false
                    },
                    modal
                );
            }

            return modal;
        }
    }]);
    return ModalContainer;
}(_react.Component);

ModalContainer.defaultProps = {
    animates: true,
    closeOnEsc: true,
    closeOnOutsideClick: true,
    modalPosition: 'top',
    modalSize: 'default',
    appendToBody: !isTest,
    preventBackScroll: true
};
;

ModalContainer.displayName = 'ModalContainer';

exports.default = ModalContainer;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/Radio/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames6 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames7 = _interopRequireDefault(_classnames6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Radio(props) {
    var _classnames2, _classnames3;

    var checked = props.checked,
        children = props.children,
        dataTn = props.dataTn,
        disabled = props.disabled,
        inputId = props.inputId,
        label = props.label,
        labelClass = props.labelClass,
        name = props.name,
        onChange = props.onChange,
        radioClass = props.radioClass,
        theme = props.theme,
        value = props.value,
        wrapperClass = props.wrapperClass;


    if (!theme) {
        return null;
    }

    var labelContainerClasses = (0, _classnames7.default)(theme.labelContainer, (0, _defineProperty3.default)({}, theme.labelContainerDisabled, disabled));
    var buttonClasses = (0, _classnames7.default)(theme.radioButton, radioClass, (_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, theme.buttonDisabled, disabled), (0, _defineProperty3.default)(_classnames2, theme.buttonChecked, checked), _classnames2));
    var innerButtonClasses = (0, _classnames7.default)(theme.innerButton, (_classnames3 = {}, (0, _defineProperty3.default)(_classnames3, theme.innerButtonDisabled, disabled), (0, _defineProperty3.default)(_classnames3, theme.innerButtonChecked, checked), _classnames3));
    var labelClasses = (0, _classnames7.default)(theme.label, labelClass, (0, _defineProperty3.default)({}, theme.labelContainerDisabled, disabled));
    var childClasses = (0, _classnames7.default)(theme.children, (0, _defineProperty3.default)({}, theme.childrenDisabled, disabled));
    var id = inputId ? inputId : name + '-' + value.toString();

    return _react2.default.createElement(
        'div',
        { className: wrapperClass },
        _react2.default.createElement('input', {
            id: id,
            type: 'radio',
            name: name,
            value: value,
            checked: checked,
            disabled: disabled,
            onChange: function (_onChange) {
                function onChange(_x) {
                    return _onChange.apply(this, arguments);
                }

                onChange.toString = function () {
                    return _onChange.toString();
                };

                return onChange;
            }(function (e) {
                return onChange(value, e);
            }),
            className: theme.hiddenInput
        }),
        _react2.default.createElement(
            'label',
            {
                htmlFor: id,
                className: labelContainerClasses,
                'data-id': value,
                'data-tn': dataTn
            },
            _react2.default.createElement(
                'div',
                { className: buttonClasses },
                _react2.default.createElement('div', { className: innerButtonClasses })
            ),
            label && _react2.default.createElement(
                'div',
                { className: labelClasses },
                label
            )
        ),
        children && _react2.default.createElement(
            'div',
            { className: childClasses },
            children
        )
    );
}

Radio.displayName = 'Radio';

exports.default = Radio;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/Select/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _assign = __webpack_require__("./node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSelect = __webpack_require__("./node_modules/react-select/lib/index.js");

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _close = __webpack_require__("./node_modules/dibs-vg/dist/react/close.js");

var _close2 = _interopRequireDefault(_close);

var _ErrorMessage = __webpack_require__("./node_modules/dibs-elements/lib/Common/ErrorMessage.js");

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function themedMultiValueComponent(theme) {
    return function (_React$Component) {
        (0, _inherits3.default)(MultiValueComponent, _React$Component);

        function MultiValueComponent() {
            var _ref;

            var _temp, _this, _ret;

            (0, _classCallCheck3.default)(this, MultiValueComponent);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MultiValueComponent.__proto__ || (0, _getPrototypeOf2.default)(MultiValueComponent)).call.apply(_ref, [this].concat(args))), _this), _this.onRemove = function (event) {
                event.preventDefault();
                event.stopPropagation();
                _this.props.onRemove(_this.props.value);
            }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
        }

        (0, _createClass3.default)(MultiValueComponent, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(
                    'div',
                    {
                        className: theme.multiSelectValueContainer,
                        onMouseDown: this.onRemove
                    },
                    _react2.default.createElement(
                        'span',
                        { className: theme.multiSelectLabel },
                        this.props.children
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: theme.multiSelectCloseContainer },
                        _react2.default.createElement(_close2.default, { className: theme.multiSelectClose })
                    )
                );
            }
        }]);
        return MultiValueComponent;
    }(_react2.default.Component);
}

var Select = function Select(props) {
    var _classNames;

    var name = props.name,
        onChange = props.onChange,
        options = props.options,
        autoComplete = props.autoComplete,
        _props$clearable = props.clearable,
        clearable = _props$clearable === undefined ? false : _props$clearable,
        creatable = props.creatable,
        dataTn = props.dataTn,
        _props$disabled = props.disabled,
        disabled = _props$disabled === undefined ? false : _props$disabled,
        _props$emptyValuePlac = props.emptyValuePlaceholder,
        emptyValuePlaceholder = _props$emptyValuePlac === undefined ? '' : _props$emptyValuePlac,
        errorMessage = props.errorMessage,
        filterOptions = props.filterOptions,
        inputErrorDataTn = props.inputErrorDataTn,
        _props$hasAnimatedPla = props.hasAnimatedPlaceholder,
        hasAnimatedPlaceholder = _props$hasAnimatedPla === undefined ? false : _props$hasAnimatedPla,
        _props$isLoading = props.isLoading,
        isLoading = _props$isLoading === undefined ? false : _props$isLoading,
        isOptionUnique = props.isOptionUnique,
        isValid = props.isValid,
        isValidNewOption = props.isValidNewOption,
        multi = props.multi,
        newOptionCreator = props.newOptionCreator,
        onInputChange = props.onInputChange,
        onNewOptionClick = props.onNewOptionClick,
        _props$placeholder = props.placeholder,
        placeholder = _props$placeholder === undefined ? '' : _props$placeholder,
        promptTextCreator = props.promptTextCreator,
        _props$searchable = props.searchable,
        searchable = _props$searchable === undefined ? false : _props$searchable,
        size = props.size,
        shouldKeyDownEventCreateNewOption = props.shouldKeyDownEventCreateNewOption,
        theme = props.theme,
        value = props.value,
        wrapperClass = props.wrapperClass;


    if (!theme) {
        return null;
    }

    if (false) {
        if (placeholder) {
            console.warn("dibs-elements | Select | property 'placeholder' has changed! If you intend to see the placholder animate and go above the selected value when chosen, please add the property 'hasAnimatedPlaceholder'. Otherwise, the default behavior will make the placeholder disappear. <3 Majd");
        }

        if (emptyValuePlaceholder) {
            console.warn("dibs-elements | Select | property 'emptyValuePlaceholder' is deprecated. Use 'placeholder' instead. <3 Majd");
        }
    }

    var inputProps = { name: name, autoComplete: autoComplete ? 'on' : 'off' };
    var selectWrapperClasses = (0, _classnames2.default)(wrapperClass, theme.field);
    var selectClasses = (0, _classnames2.default)(theme.select, (_classNames = {}, (0, _defineProperty3.default)(_classNames, theme.valid, isValid), (0, _defineProperty3.default)(_classNames, theme.disabled, disabled), (0, _defineProperty3.default)(_classNames, theme.error, !!errorMessage), (0, _defineProperty3.default)(_classNames, theme.withPlaceholder, placeholder || emptyValuePlaceholder), (0, _defineProperty3.default)(_classNames, theme.withoutAnimatedPlaceholder, !hasAnimatedPlaceholder || searchable), (0, _defineProperty3.default)(_classNames, theme.heightDefault, !size), (0, _defineProperty3.default)(_classNames, theme.heightSmall, size === 'small'), (0, _defineProperty3.default)(_classNames, theme.heightMedium, size === 'medium'), (0, _defineProperty3.default)(_classNames, theme.heightLarge, size === 'large'), _classNames));

    var placeholderClasses = (0, _classnames2.default)(theme.placeholder, (0, _defineProperty3.default)({}, theme.placeholderWithoutValue, (placeholder || emptyValuePlaceholder) && !value));

    var noResultsText = props.noResultsText;

    if (isLoading && options.length === 0) {
        noResultsText = '';
    }

    var additionalOptions = {};
    var SelectElement = _reactSelect2.default;

    if (creatable) {
        SelectElement = _reactSelect2.default.Creatable;
        additionalOptions = {
            isOptionUnique: isOptionUnique,
            isValidNewOption: isValidNewOption,
            newOptionCreator: newOptionCreator,
            onNewOptionClick: onNewOptionClick,
            shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
            promptTextCreator: promptTextCreator
        };
    }

    var nativePlaceholder = searchable || !hasAnimatedPlaceholder ? placeholder || emptyValuePlaceholder : "";

    return _react2.default.createElement(
        'div',
        { className: selectWrapperClasses, 'data-field': name },
        _react2.default.createElement(
            'div',
            {
                className: selectClasses,
                'data-tn': dataTn
            },
            _react2.default.createElement(SelectElement, (0, _extends3.default)({}, additionalOptions, {
                name: name,
                value: value,
                isLoading: isLoading,
                inputProps: inputProps,
                options: options,
                disabled: disabled,
                clearable: clearable,
                searchable: searchable,
                filterOptions: filterOptions,
                noResultsText: noResultsText,
                scrollMenuIntoView: false,
                placeholder: nativePlaceholder,
                onChange: function (_onChange) {
                    function onChange(_x) {
                        return _onChange.apply(this, arguments);
                    }

                    onChange.toString = function () {
                        return _onChange.toString();
                    };

                    return onChange;
                }(function (opts) {
                    if (onChange) {
                        if (Array.isArray(opts)) {
                            onChange(opts.map(function (opt) {
                                return (0, _assign2.default)({}, opt, { name: name });
                            }));
                        } else {
                            onChange(opts ? (0, _assign2.default)({}, opts, { name: name }) : null);
                        }
                    }
                }),
                onInputChange: function (_onInputChange) {
                    function onInputChange(_x2) {
                        return _onInputChange.apply(this, arguments);
                    }

                    onInputChange.toString = function () {
                        return _onInputChange.toString();
                    };

                    return onInputChange;
                }(function (inputValue) {
                    if (onInputChange) {
                        var result = onInputChange(inputValue);
                        return result || inputValue;
                    } else {
                        return inputValue;
                    }
                }),
                multi: multi,
                valueComponent: multi && themedMultiValueComponent(theme)
            })),
            !searchable && hasAnimatedPlaceholder && (placeholder || emptyValuePlaceholder) && _react2.default.createElement(
                'span',
                { className: placeholderClasses },
                placeholder || emptyValuePlaceholder
            )
        ),
        _react2.default.createElement(_ErrorMessage2.default, {
            message: errorMessage,
            dataTn: inputErrorDataTn,
            className: theme.inputErrorMessage
        })
    );
};

Select.displayName = 'Select';

exports.default = Select;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/Spinner/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GRADIENT_ID = 'dibs-spinner-gradient';

var renderGradient = function renderGradient(gradientId, solidClass, transparentClass) {
    return _react2.default.createElement(
        'linearGradient',
        { id: gradientId, x1: '1', y1: '0', x2: '0', y2: '1', gradientUnits: 'objectBoundingBox' },
        _react2.default.createElement('stop', { offset: '40%', className: transparentClass }),
        _react2.default.createElement('stop', { offset: '85%', className: solidClass }),
        _react2.default.createElement('stop', { offset: '100%', className: solidClass })
    );
};

var Spinner = function Spinner(props) {
    var _classNames, _classNames2;

    var theme = props.theme,
        _props$dark = props.dark,
        dark = _props$dark === undefined ? false : _props$dark,
        _props$containerClass = props.containerClass,
        containerClass = _props$containerClass === undefined ? '' : _props$containerClass,
        _props$size = props.size,
        size = _props$size === undefined ? 'small' : _props$size;


    if (!theme) {
        return null;
    }

    var solid = dark ? theme.colorDarkSolid : theme.colorLightSolid;
    var transparent = dark ? theme.colorDarkTransparent : theme.colorLightTransparent;
    var shadow = (0, _classnames2.default)(theme.shadow, (_classNames = {}, (0, _defineProperty3.default)(_classNames, theme.colorDarkShadow, dark), (0, _defineProperty3.default)(_classNames, theme.colorLightShadow, !dark), _classNames));
    var container = (0, _classnames2.default)(containerClass, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, theme.small, size === 'small'), (0, _defineProperty3.default)(_classNames2, theme.tiny, size === 'tiny'), _classNames2));

    return _react2.default.createElement(
        'div',
        { className: container },
        _react2.default.createElement(
            'svg',
            { className: theme.spinner, viewBox: '0 0 250 250' },
            _react2.default.createElement(
                'defs',
                null,
                renderGradient(GRADIENT_ID, solid, transparent)
            ),
            _react2.default.createElement('circle', {
                className: shadow,
                cx: 125,
                cy: 125,
                r: 106
            }),
            _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement('path', { fill: 'url(#' + GRADIENT_ID + ')', d: 'M125,250 C194.035937,250 250,194.035937 250,125 L212.5,125 C212.5,173.246875 173.248437,212.5 125,212.5' }),
                _react2.default.createElement('path', { className: solid, d: 'M125.217391,212.5 C76.8850435,212.5 37.5652174,173.246875 37.5652174,125 C37.5652174,76.753125 76.8850435,37.5 125.217391,37.5 C135.590087,37.5 144,29.1046875 144,18.75 C144,8.3953125 135.590087,0 125.217391,0 C56.0613913,0 0,55.9640625 0,125 C0,194.035937 56.0613913,250 125.217391,250' })
            )
        )
    );
};

exports.default = Spinner;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/Switch/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Switch = function (_React$Component) {
    (0, _inherits3.default)(Switch, _React$Component);

    function Switch(props) {
        (0, _classCallCheck3.default)(this, Switch);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Switch.__proto__ || (0, _getPrototypeOf2.default)(Switch)).call(this, props));

        _this.onChange = function (e) {
            var onChange = _this.props.onChange;

            var _ref = e && e.currentTarget,
                checked = _ref.checked;

            /* istanbul ignore else */


            if (typeof checked === 'boolean') {
                _this.setState({ checked: checked });
                if (onChange) {
                    onChange(checked, e);
                }
            }
        };

        _this.state = {
            checked: _this.props.checked
        };

        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(Switch, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var checked = nextProps.checked;
            /* istanbul ignore else */

            if (this.props.checked !== checked) {
                this.setState({ checked: checked });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                dataTn = _props.dataTn,
                label = _props.label,
                name = _props.name,
                onText = _props.onText,
                offText = _props.offText,
                theme = _props.theme,
                value = _props.value;
            var checked = this.state.checked;


            if (!theme) {
                return null;
            }

            var switchClasses = (0, _classnames2.default)(theme.switch, (0, _defineProperty3.default)({}, theme.isChecked, checked));

            var sliderClasses = (0, _classnames2.default)(theme.slider, (0, _defineProperty3.default)({}, theme.isActive, checked));

            return _react2.default.createElement(
                'div',
                { className: theme.wrapper },
                label && _react2.default.createElement(
                    'div',
                    { className: theme.label },
                    label
                ),
                _react2.default.createElement(
                    'label',
                    { htmlFor: name, className: switchClasses, 'data-tn': dataTn },
                    _react2.default.createElement('input', {
                        id: name,
                        name: name,
                        type: 'checkbox',
                        className: theme.hiddenInput,
                        checked: checked,
                        onChange: this.onChange,
                        value: value
                    }),
                    _react2.default.createElement('div', { className: theme.dot }),
                    _react2.default.createElement(
                        'div',
                        { className: sliderClasses },
                        _react2.default.createElement(
                            'div',
                            { className: theme.sliderTextOn },
                            onText
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: theme.sliderTextOff },
                            offText
                        )
                    )
                ),
                children
            );
        }
    }]);
    return Switch;
}(_react2.default.Component);

Switch.defaultProps = {
    onText: 'I',
    offText: 'O'
};


Switch.displayName = 'Switch';

exports.default = Switch;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/Tabs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tabs = function Tabs(_ref) {
    var activeTabIndex = _ref.activeTabIndex,
        activeTabClassName = _ref.activeTabClassName,
        collapsed = _ref.collapsed,
        containerClassName = _ref.containerClassName,
        onKeyDownTab = _ref.onKeyDownTab,
        onSelectTab = _ref.onSelectTab,
        tabClassName = _ref.tabClassName,
        tabLabels = _ref.tabLabels,
        theme = _ref.theme;

    var style = theme;
    return style ? _react2.default.createElement(
        'ul',
        { className: (0, _classnames2.default)(style.tabs, containerClassName, (0, _defineProperty3.default)({}, style.collapsed, collapsed)) },
        tabLabels.map(function (tabLabel, index) {
            var active = activeTabIndex === index;
            var finalTabClassName = (0, _classnames2.default)(style.tab, (0, _defineProperty3.default)({}, (0, _classnames2.default)(style.active, activeTabClassName), active), tabClassName);
            return _react2.default.createElement(
                'li',
                {
                    className: finalTabClassName,
                    key: [index, tabLabel].join('_'),
                    role: 'tablist'
                },
                _react2.default.createElement(
                    'a',
                    {
                        className: style.tabItem,
                        'aria-selected': active ? 'true' : 'false',
                        onClick: onSelectTab ? onSelectTab(index) : undefined,
                        onKeyDown: onKeyDownTab ? onKeyDownTab(index) : undefined,
                        onFocus: onSelectTab ? onSelectTab(index) : undefined,
                        role: 'tab'
                    },
                    tabLabel
                )
            );
        })
    ) : null;
};

Tabs.displayName = 'Tabs';

exports.default = Tabs;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/TextArea/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames3 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames4 = _interopRequireDefault(_classnames3);

var _ErrorMessage = __webpack_require__("./node_modules/dibs-elements/lib/Common/ErrorMessage.js");

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextArea = function (_React$Component) {
    (0, _inherits3.default)(TextArea, _React$Component);

    function TextArea(props) {
        (0, _classCallCheck3.default)(this, TextArea);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TextArea.__proto__ || (0, _getPrototypeOf2.default)(TextArea)).call(this, props));

        _this.onBlur = function (e) {
            if (_this.props.onBlur) {
                _this.props.onBlur(e);
            }
        };

        _this.onChange = function (e) {
            _this.setState({ value: e.currentTarget.value });

            if (_this.props.onChange) {
                _this.props.onChange(e);
            }
        };

        _this.state = {
            value: props.value || ''
        };
        return _this;
    }

    (0, _createClass3.default)(TextArea, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            /* istanbul ignore else */
            if (!(this.state.value === this.props.value === nextProps.value)) {
                this.setState({ value: nextProps.value });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                autoFocus = _props.autoFocus,
                className = _props.className,
                dataTn = _props.dataTn,
                errorMessageAlignment = _props.errorMessageAlignment,
                label = _props.label,
                name = _props.name,
                maxLength = _props.maxLength,
                placeholder = _props.placeholder,
                _props$disabled = _props.disabled,
                disabled = _props$disabled === undefined ? false : _props$disabled,
                errorMessage = _props.errorMessage,
                errorDataTn = _props.errorDataTn,
                rows = _props.rows,
                theme = _props.theme;


            var errorDataTnString = errorDataTn ? errorDataTn : dataTn + '-error';

            if (theme) {
                var textareaClasses = (0, _classnames4.default)((0, _defineProperty3.default)({}, theme.error, !!errorMessage), theme.message, className);
                return _react2.default.createElement(
                    'div',
                    { className: theme.textAreaContainer },
                    label && _react2.default.createElement(
                        'div',
                        { className: theme.label },
                        label
                    ),
                    _react2.default.createElement('textarea', {
                        autoFocus: autoFocus,
                        className: textareaClasses,
                        'data-tn': dataTn,
                        maxLength: maxLength || null,
                        onBlur: this.onBlur,
                        onChange: this.onChange,
                        placeholder: placeholder,
                        rows: rows || 6,
                        name: name,
                        value: this.state.value || '',
                        disabled: disabled
                    }),
                    _react2.default.createElement(_ErrorMessage2.default, {
                        message: errorMessage,
                        dataTn: errorDataTnString,
                        className: (0, _classnames4.default)(theme.errorMessage, (0, _defineProperty3.default)({}, theme.errorMessageRight, errorMessageAlignment === 'right'))
                    })
                );
            }
            return null;
        }
    }]);
    return TextArea;
}(_react2.default.Component);

TextArea.defaultProps = {
    autoFocus: false,
    errorMessageAlignment: 'right',
    value: ''
};


TextArea.displayName = 'TextArea';

exports.default = TextArea;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/Well/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Well = function Well(_ref) {
    var className = _ref.className,
        children = _ref.children,
        label = _ref.label,
        labelClassName = _ref.labelClassName,
        theme = _ref.theme;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('clearfix', className, theme && theme.well) },
        label && _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(labelClassName, theme && theme.label) },
            label
        ),
        children
    );
};

Well.displayName = 'Well';

exports.default = Well;

/***/ }),

/***/ "./node_modules/dibs-gas/index.js":
/***/ (function(module, exports) {

/**
 * @preserve Copyright 2013, Cardinal Path and DigitalInc.
 *
 * GAS - Google Analytics on Steroids
 * https://github.com/CardinalPath/gas
 *
 * @author Eduardo Cereto <eduardocereto@gmail.com>
 * Licensed under the GPLv3 license.
 *
 */

// Modified 2013-07-30 by Michael Harrison
// Added non-interaction flags to event tracking and added dc.js reference

(function (e, t) {
    if (!e) {
        // not in the client aka window
        return;
    }
    var global = e;
    try {
        if (Object.prototype.toString.call(global.process) === '[object process]') {
            return;
        }
    } catch(e) {}

    function p() {
        var e = this;
        e.version = "1.9", e._accounts = {}, e._accounts_length = 0, e._queue = r, e._default_tracker = "_gas1", e.gh = {}, e._hooks = {
            _addHook: [e._addHook]
        }, e.push(function () {
            e.gh = new n
        })
    }

    function d(e) {
        return e === _gas._default_tracker ? "" : e + "."
    }

    function v(t) {
        if (_gas.debug_mode) try {
            console.log(t)
        } catch (n) {}
        return e._gaq.push(t)
    }

    function m(e, t) {
        if (typeof e != "string") return !1;
        var n = e.split("?")[0];
        return n = n.split("."), n = n[n.length - 1], n && this.inArray(t, n) ? n : !1
    }

    function y(e) {
        while (e && e.nodeName !== "HTML") {
            if (e.nodeName === "FORM") break;
            e = e.parentNode
        }
        return e.nodeName === "FORM" ? e.name || e.id || "none" : "none"
    }

    function w(e) {
        _gas.push(["_trackEvent", this.tagName, e.type, this.currentSrc])
    }

    function N() {
        return e.innerHeight || h.clientHeight || i.body.clientHeight || 0
    }

    function C() {
        return e.pageYOffset || i.body.scrollTop || h.scrollTop || 0
    }

    function k() {
        return Math.max(i.body.scrollHeight || 0, h.scrollHeight || 0, i.body.offsetHeight || 0, h.offsetHeight || 0, i.body.clientHeight || 0, h.clientHeight || 0)
    }

    function L() {
        return (C() + N()) / k() * 100
    }

    function M(e) {
        A && clearTimeout(A);
        if (e === !0) {
            O = Math.max(L(), O);
            return
        }
        A = setTimeout(function () {
            O = Math.max(L(), O)
        }, 400)
    }

    function _() {
        M(!0), O = Math.floor(O);
        if (O <= 0 || O > 100) return;
        var e = (O > 10 ? 1 : 0) * (Math.floor((O - 1) / 10) * 10 + 1);
        e = String(e) + "-" + String(Math.ceil(O / 10) * 10), _gas.push(["_trackEvent", D.category, c, e, Math.floor(O), !0])
    }

    function P(t) {
        if ( !! this._maxScrollTracked) return;
        this._maxScrollTracked = !0, D = t || {}, D.category = D.category || "Max Scroll", this._addEventListener(e, "scroll", M), this._addEventListener(e, "beforeunload", _)
    }

    function j(e) {
        if (!this._multidomainTracked) {
            this._multidomainTracked = !0;
            var t = i.location.hostname,
                n = this,
                r, s, o, u = i.getElementsByTagName("a");
            e !== "now" && e !== "mousedown" && (e = "click");
            for (r = 0; r < u.length; r++) {
                o = u[r];
                if (l.call(o.href, "http") === 0) {
                    if (o.hostname == t || l.call(o.hostname, B) >= 0) continue;
                    for (s = 0; s < H.length; s++) l.call(o.hostname, H[s]) >= 0 && (e === "now" ? o.href = n.tracker._getLinkerUrl(o.href, _gas._allowAnchor) : e === "click" ? this._addEventListener(o, e, function (e) {
                        return _gas.push(["_link", this.href, _gas._allowAnchor]), e.preventDefault ? e.preventDefault() : e.returnValue = !1, !1
                    }) : this._addEventListener(o, e, function () {
                        this.href = n.tracker._getLinkerUrl(this.href, _gas._allowAnchor)
                    }))
                }
            }
            return !1
        }
        return
    }

    function z(e) {
        R[e.player_id] || (R[e.player_id] = {}, R[e.player_id].timeTriggers = a.call(q));
        if (R[e.player_id].timeTriggers.length > 0 && e.data.percent * 100 >= R[e.player_id].timeTriggers[0]) {
            var t = R[e.player_id].timeTriggers.shift();
            _gas.push(["_trackEvent", "Vimeo Video", t + "%", U[e.player_id], 0, true])
        }
    }

    function W(e, t, n) {
        if (!n.contentWindow || !n.contentWindow.postMessage || !JSON) return !1;
        var r = n.getAttribute("src").split("?")[0],
            i = JSON.stringify({
                method: e,
                value: t
            });
        return n.contentWindow.postMessage(i, r), !0
    }

    function $(e) {
        if (l.call(e.origin, "//player.vimeo.com") > -1) {
            var t = JSON.parse(e.data);
            t.event === "ready" ? J.call(_gas.gh) : t.method ? t.method == "getVideoUrl" && (U[t.player_id] = t.value) : t.event === "playProgress" ? z(t) : _gas.push(["_trackEvent", V.category, t.event, U[t.player_id], 0, true])
        }
    }

    function J() {
        var t = i.getElementsByTagName("iframe"),
            n = 0,
            r, s, o, u = V.force,
            a = V.percentages;
        for (var f = 0; f < t.length; f++)
            if (l.call(t[f].src, "//player.vimeo.com") > -1) {
                r = "gas_vimeo_" + f, s = t[f].src, o = "?", l.call(s, "?") > -1 && (o = "&");
                if (l.call(s, "api=1") < 0) {
                    if (!u) continue;
                    s += o + "api=1&player_id=" + r
                } else l.call(s, "player_id=") < -1 && (s += o + "player_id=" + r);
                n++, t[f].id = r;
                if (t[f].src !== s) {
                    t[f].src = s;
                    break
                }
                W("getVideoUrl", "", t[f]), W("addEventListener", "play", t[f]), W("addEventListener", "pause", t[f]), W("addEventListener", "finish", t[f]), a && (q = a, W("addEventListener", "playProgress", t[f]))
            }
        n > 0 && X === !1 && (this._addEventListener(e, "message", $, !1), X = !0)
    }

    function Z(e) {
        if (Q && Q.length) {
            var t = e.getVideoData().video_id;
            Y[t] ? tt(e) : (Y[t] = {}, Y[t].timeTriggers = a.call(Q)), Y[t].timer = setTimeout(et, 1e3, e, t)
        }
    }

    function et(e, n) {
        if (Y[n] == t || Y[n].timeTriggers.length <= 0) return !1;
        var r = e.getCurrentTime() / e.getDuration() * 100;
        if (r >= Y[n].timeTriggers[0]) {
            var i = Y[n].timeTriggers.shift();
            _gas.push(["_trackEvent", G.category, i + "%", e.getVideoUrl(), 0, true])
        }
        Y[n].timer = setTimeout(et, 1e3, e, n)
    }

    function tt(e) {
        var t = e.getVideoData().video_id;
        Y[t] && Y[t].timer && (et(e, t), clearTimeout(Y[t].timer))
    }

    function nt(e) {
        var t = "";
        switch (e.data) {
            case 0:
                t = "finish", tt(e.target);
                break;
            case 1:
                t = "play", Z(e.target);
                break;
            case 2:
                t = "pause", tt(e.target)
        }
        t && _gas.push(["_trackEvent", G.category, t, e.target.getVideoUrl(), 0, true])
    }

    function rt(e) {
        _gas.push(["_trackEvent", G.category, "error (" + e.data + ")", e.target.getVideoUrl(), true])
    }

    function it() {
        var e = i.getElementsByTagName("object"),
            t, n, r, s = /(https?:\/\/www\.youtube(-nocookie)?\.com[^/]*).*\/v\/([^&?]+)/;
        for (var o = 0; o < e.length; o++) {
            t = e[o].getElementsByTagName("param");
            for (var u = 0; u < t.length; u++)
                if (t[u].name == "movie" && t[u].value) {
                    r = t[u].value.match(s), r && r[1] && r[3] && (n = i.createElement("iframe"), n.src = r[1] + "/embed/" + r[3] + "?enablejsapi=1", n.width = e[o].width, n.height = e[o].height, n.setAttribute("frameBorder", "0"), n.setAttribute("allowfullscreen", ""), e[o].parentNode.insertBefore(n, e[o]), e[o].parentNode.removeChild(e[o]), o--);
                    break
                }
        }
    }

    function st(t) {
        var n = t.force,
            r = t.percentages;
        if (n) try {
            it()
        } catch (s) {
            _gas.push(["_trackException", s, "GAS Error on youtube.js:_ytMigrateObjectEmbed"])
        }
        var o = [],
            u = i.getElementsByTagName("iframe");
        for (var a = 0; a < u.length; a++)
            if (l.call(u[a].src, "//www.youtube.com/embed") > -1) {
                if (l.call(u[a].src, "enablejsapi=1") < 0) {
                    if (!n) continue;
                    l.call(u[a].src, "?") < 0 ? u[a].src += "?enablejsapi=1" : u[a].src += "&enablejsapi=1"
                }
                o.push(u[a])
            }
        if (o.length > 0) {
            r && r.length && (Q = r), e.onYouTubePlayerAPIReady = function () {
                var t;
                for (var n = 0; n < o.length; n++) t = new e.YT.Player(o[n]), t.addEventListener("onStateChange", nt), t.addEventListener("onError", rt)
            };
            var f = i.createElement("script"),
                c = "http:";
            i.location.protocol === "https:" && (c = "https:"), f.src = c + "//www.youtube.com/player_api", f.type = "text/javascript", f.async = !0;
            var h = i.getElementsByTagName("script")[0];
            h.parentNode.insertBefore(f, h)
        }
    }
    var n = function () {
        this._setDummyTracker()
    };
    n.prototype._setDummyTracker = function () {
        if (!this.tracker) {
            var t = e._gat._getTrackers();
            t.length > 0 && (this.tracker = t[0])
        }
    }, n.prototype.inArray = function (e, t) {
        if (e && e.length)
            for (var n = 0; n < e.length; n++)
                if (e[n] === t) return !0;
        return !1
    }, n.prototype._sanitizeString = function (e, t) {
        return e = e.toLowerCase().replace(/^\ +/, "").replace(/\ +$/, "").replace(/\s+/g, "_").replace(/[\u00e1\u00e0\u00e2\u00e3\u00e5\u00e4\u00e6\u00aa]/g, "a").replace(/[\u00e9\u00e8\u00ea\u00eb\u0404\u20ac]/g, "e").replace(/[\u00ed\u00ec\u00ee\u00ef]/g, "i").replace(/[\u00f3\u00f2\u00f4\u00f5\u00f6\u00f8\u00ba]/g, "o").replace(/[\u00fa\u00f9\u00fb\u00fc]/g, "u").replace(/[\u00e7\u00a2\u00a9]/g, "c"), t && (e = e.replace(/[^a-z0-9_-]/g, "_")), e.replace(/_+/g, "_")
    }, n.prototype._addEventListener = function (t, n, r, i) {
        var s = function (n) {
            if (!n || !n.target) n = e.event, n.target = n.srcElement;
            return r.call(t, n)
        };
        return t.addEventListener ? (t.addEventListener(n, s, !! i), !0) : t.attachEvent ? t.attachEvent("on" + n, s) : (n = "on" + n, typeof t[n] == "function" && (s = function (e, t) {
            return function () {
                e.apply(this, arguments), t.apply(this, arguments)
            }
        }(t[n], s)), t[n] = s, !0)
    }, n.prototype._liveEvent = function (e, t, n) {
        var r = this;
        e = e.toUpperCase(), e = e.split(","), r._addEventListener(i, t, function (t) {
            for (var i = t.target; i.nodeName !== "HTML"; i = i.parentNode)
                if (r.inArray(e, i.nodeName) || i.parentNode === null) break;
            i && r.inArray(e, i.nodeName) && n.call(i, t)
        }, !0)
    }, n.prototype._DOMReady = function (t) {
        function r() {
            if (r.done) return;
            r.done = !0, t.apply(n, arguments)
        }
        var n = this;
        if (/^(interactive|complete)/.test(i.readyState)) return r();
        this._addEventListener(i, "DOMContentLoaded", r, !1), this._addEventListener(e, "load", r, !1)
    }, e._gaq = e._gaq || [];
    var r = e._gas || [];
    if (r._accounts_length >= 0) return;
    var i = e.document,
        s = Object.prototype.toString,
        o = Object.prototype.hasOwnProperty,
        u = Array.prototype.push,
        a = Array.prototype.slice,
        f = String.prototype.trim,
        l = String.prototype.indexOf,
        c = i.location.href,
        h = i.documentElement;
    p.prototype._addHook = function (e, t) {
        return typeof e == "string" && typeof t == "function" && (typeof _gas._hooks[e] == "undefined" && (_gas._hooks[e] = []), _gas._hooks[e].push(t)), !1
    }, p.prototype._execute = function () {
        var e = a.call(arguments),
            n = this,
            r = e.shift(),
            i = !0,
            s, u, f, c, h, p = 0;
        if (typeof r == "function") return v(function (e, t) {
            return function () {
                e.call(t)
            }
        }(r, n.gh));
        if (typeof r == "object" && r.length > 0) {
            u = r.shift(), l.call(u, ".") >= 0 ? (c = u.split(".")[0], u = u.split(".")[1]) : c = t, f = n._hooks[u];
            if (f && f.length > 0)
                for (s = 0; s < f.length; s++) try {
                    h = f[s].apply(n.gh, r), h === !1 ? i = !1 : h && h.length > 0 && (r = h)
                } catch (m) {
                    u !== "_trackException" && n.push(["_trackException", m])
                }
            if (i === !1) return 1;
            if (u === "_setAccount") {
                for (s in n._accounts)
                    if (n._accounts[s] == r[0] && c === t) return 1;
                return c = c || "_gas" + String(n._accounts_length + 1), typeof n._accounts["_gas1"] == "undefined" && l.call(c, "_gas") != -1 && (c = "_gas1"), n._accounts[c] = r[0], n._accounts_length += 1, c = d(c), p = v([c + u, r[0]]), n.gh._setDummyTracker(), p
            }
            if (u === "_link" || u === "_linkByPost" || u === "_require" || u === "_anonymizeIp") return g = d(c) + u, e = a.call(r), e.unshift(g), v(e);
            var g;
            if (c && n._accounts[c]) return g = d(c) + u, e = a.call(r), e.unshift(g), v(e);
            if (n._accounts_length > 0) {
                for (s in n._accounts) o.call(n._accounts, s) && (g = d(s) + u, e = a.call(r), e.unshift(g), p += v(e));
                return p ? 1 : 0
            }
            return e = a.call(r), e.unshift(u), v(e)
        }
    }, p.prototype.push = function () {
        var t = this,
            n = a.call(arguments);
        for (var r = 0; r < n.length; r++)(function (t, n) {
            e._gaq.push(function () {
                n._execute.call(n, t)
            })
        })(n[r], t)
    }, e._gas = _gas = new p, _gas.push(["_addHook", "_trackException",
        function (e, t) {
            return _gas.push(["_trackEvent", "Exception " + (e.name || "Error"), t || e.message || e, c, 0, true]), !1
        }
    ]), _gas.push(["_addHook", "_setDebug",
        function (e) {
            _gas.debug_mode = !! e
        }
    ]), _gas.push(["_addHook", "_popHook",
        function (e) {
            var t = _gas._hooks[e];
            return t && t.pop && t.pop(), !1
        }
    ]), _gas.push(["_addHook", "_gasSetDefaultTracker",
        function (e) {
            return _gas._default_tracker = e, !1
        }
    ]), _gas.push(["_addHook", "_trackPageview",
        function () {
            var e = a.call(arguments);
            return e.length >= 2 && typeof e[0] == "string" && typeof e[1] == "string" ? [{
                page: e[0],
                title: e[1]
            }] : e
        }
    ]);
    var g = function (e) {
        var t = this;
        if (!t._downloadTracked) {
            t._downloadTracked = !0, e ? typeof e == "string" ? e = {
                extensions: e.split(",")
            } : e.length >= 1 && (e = {
                extensions: e
            }) : e = {
                extensions: []
            }, e.category = e.category || "Download";
            var n = "xls,xlsx,doc,docx,ppt,pptx,pdf,txt,zip";
            return n += ",rar,7z,exe,wma,mov,avi,wmv,mp3,csv,tsv", n = n.split(","), e.extensions = e.extensions.concat(n), t._liveEvent("a", "mousedown", function (n) {
                var r = this;
                if (r.href) {
                    var i = m.call(t, r.href, e.extensions);
                    i && _gas.push(["_trackEvent", e.category, i, r.href])
                }
            }), !1
        }
        return
    };
    _gas.push(["_addHook", "_trackDownloads", g]), _gas.push(["_addHook", "_trackEvent",
        function () {
            var e = a.call(arguments);
            return e[3] && (e[3] = (e[3] < 0 ? 0 : Math.round(e[3])) || 0), e
        }
    ]);
    var b = function (e) {
        if ( !! this._formTracked) return;
        this._formTracked = !0;
        var t = this;
        typeof e != "object" && (e = {}), e.category = e.category || "Form Tracking";
        var n = function (t) {
            var n = t.target,
                r = n.name || n.id || n.type || n.nodeName,
                i = y(n),
                s = "form (" + i + ")",
                o = r + " (" + t.type + ")";
            _gas.push(["_trackEvent", e.category, s, o, 0, true])
        };
        t._DOMReady(function () {
            var e = ["input", "select", "textarea", "hidden"],
                r = ["form"],
                s = [],
                o, u;
            for (o = 0; o < e.length; o++) {
                s = i.getElementsByTagName(e[o]);
                for (u = 0; u < s.length; u++) t._addEventListener(s[u], "change", n)
            }
            for (o = 0; o < r.length; o++) {
                s = i.getElementsByTagName(r[o]);
                for (u = 0; u < s.length; u++) t._addEventListener(s[u], "submit", n)
            }
        })
    };
    _gas.push(["_addHook", "_trackForms", b]);
    var E = function (e) {
        var t = this;
        t._liveEvent(e, "play", w), t._liveEvent(e, "pause", w), t._liveEvent(e, "ended", w)
    }, S = function () {
        if ( !! this._videoTracked) return;
        this._videoTracked = !0, E.call(this, "video")
    }, x = function () {
        if ( !! this._audioTracked) return;
        this._audioTracked = !0, E.call(this, "audio")
    };
    _gas.push(["_addHook", "_trackVideo", S]), _gas.push(["_addHook", "_trackAudio", x]);
    var T = function (e) {
        if (!this._mailtoTracked) return this._mailtoTracked = !0, e || (e = {}), e.category = e.category || "Mailto", this._liveEvent("a", "mousedown", function (t) {
            var n = t.target;
            n && n.href && n.href.toLowerCase && l.call(n.href.toLowerCase(), "mailto:") === 0 && _gas.push(["_trackEvent", e.category, n.href.substr(7), undefined, 0, true])
        }), !1;
        return
    };
    _gas.push(["_addHook", "_trackMailto", T]);
    var A = null,
        O = 0,
        D;
    _gas.push(["_addHook", "_trackMaxScroll", P]), _gas._allowAnchor = !1, _gas.push(["_addHook", "_setAllowAnchor",
        function (e) {
            _gas._allowAnchor = !! e
        }
    ]), _gas.push(["_addHook", "_link",
        function (e, n) {
            return n === t && (n = _gas._allowAnchor), [e, n]
        }
    ]), _gas.push(["_addHook", "_linkByPost",
        function (e, n) {
            return n === t && (n = _gas._allowAnchor), [e, n]
        }
    ]);
    var H = [],
        B = t;
    _gas.push(["_addHook", "_setDomainName",
        function (e) {
            if (l.call("." + i.location.hostname, e) < 0) return H.push(e), !1;
            B = e
        }
    ]), _gas.push(["_addHook", "_addExternalDomainName",
        function (e) {
            return H.push(e), !1
        }
    ]);
    var F = function () {
        var e = this,
            t = a.call(arguments);
        e._DOMReady(function () {
            j.apply(e, t)
        })
    };
    _gas.push(["_addHook", "_setMultiDomain", F]);
    var I = function (e) {
        if ( !! this._outboundTracked) return;
        this._outboundTracked = !0;
        var t = this;
        e || (e = {}), e.category = e.category || "Outbound", t._liveEvent("a", "mousedown", function (t) {
            var n = this;
            if ((n.protocol == "http:" || n.protocol == "https:") && l.call(n.hostname, i.location.hostname) === -1) {
                var r = n.pathname + n.search + "",
                    s = l.call(r, "__utm");
                s !== -1 && (r = r.substring(0, s)), _gas.push(["_trackEvent", e.category, n.hostname, r, 0, true])
            }
        })
    };
    _gas.push(["_addHook", "_trackOutboundLinks", I]);
    var q = [],
        R = {}, U = {}, X = !1,
        V, K = function (e) {
            var t = this;
            if (typeof e == "boolean" || e === "force") e = {
                force: !! e
            };
            return e = e || {}, e.category = e.category || "Vimeo Video", e.percentages = e.percentages || [], e.force = e.force || !1, V = e, t._DOMReady(function () {
                J.call(t)
            }), !1
        };
    _gas.push(["_addHook", "_trackVimeo", K]);
    var Q = [],
        G, Y = {}, ot = function (e) {
            var t = a.call(arguments);
            t[0] && (typeof t[0] == "boolean" || t[0] === "force") && (e = {
                force: !! t[0]
            }, t[1] && t[1].length && (e.percentages = t[1])), e = e || {}, e.force = e.force || !1, e.category = e.category || "YouTube Video", e.percentages = e.percentages || [], G = e;
            var n = this;
            return n._DOMReady(function () {
                st.call(n, e)
            }), !1
        };
    _gas.push(["_addHook", "_trackYoutube", ot]);
    while (_gas._queue.length > 0) _gas.push(_gas._queue.shift());
    global._gaq && global._gaq.length >= 0 && function () {
        var e = i.createElement("script");
        e.type = "text/javascript", e.async = !0, e.src = ("https:" == i.location.protocol ? "https://" : "http://") + "stats.g.doubleclick.net/dc.js";
        if (window.document.body) {
            // This is used by the unit test
            window.document.body.appendChild(e, t);
        } else {
            // Removing this causes a JS error since document.body may not be defined at the time it's called
            var t = i.getElementsByTagName("script")[0];
            t.parentNode.insertBefore(e, t);
        }
    }()
})(typeof window !== 'undefined' ? window : null);


/***/ }),

/***/ "./node_modules/dibs-overlay-spinner/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * User: daletan
	 * Date: 3/12/16
	 * Time: 8:57 PM
	 * Copyright 1stdibs.com, Inc. 2016. All Rights Reserved.
	 */

	'use strict';

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(2);
	var classnames = __webpack_require__(3);
	var styles = __webpack_require__(4);

	/**
	 * @param {object} props
	 * @param {string} [props.additionalOverlayClasses]
	 * @param {string} [props.additionalSpinnerClasses]
	 * @param {string} [props.position="isFixed"] Accepts `isAbsolute`, `isStatic`, `isRelative`, defaults to `isFixed`
	*  @param {string} [props.size] only 'small' and 'medium' for now
	 * @returns
	 * @constructor
	 */
	var Overlay = function Overlay() {
	    var _classnames2, _classnames3;

	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var additionalWrapperClasses = props.additionalWrapperClasses,
	        additionalOverlayClasses = props.additionalOverlayClasses,
	        additionalSpinnerClasses = props.additionalSpinnerClasses,
	        _props$position = props.position,
	        position = _props$position === undefined ? "isFixed" : _props$position,
	        _props$size = props.size,
	        size = _props$size === undefined ? 'medium' : _props$size;

	    var wrapperClasses = classnames(_defineProperty({
	        'overlay-spinner-wrapper': true
	    }, additionalWrapperClasses, !!additionalWrapperClasses));
	    var overlayClasses = classnames((_classnames2 = {}, _defineProperty(_classnames2, styles.spinnerWrapper, styles.spinnerWrapper), _defineProperty(_classnames2, 'ajax-overlay', true), _defineProperty(_classnames2, additionalOverlayClasses, !!additionalOverlayClasses), _classnames2));
	    var spinnerClasses = classnames((_classnames3 = {}, _defineProperty(_classnames3, styles.large, size === 'large' && styles.large), _defineProperty(_classnames3, styles.medium, size === 'medium' && styles.medium), _defineProperty(_classnames3, styles.small, size === 'small' && styles.small), _defineProperty(_classnames3, 'tn-overlaySpinner', true), _defineProperty(_classnames3, additionalSpinnerClasses, !!additionalSpinnerClasses), _defineProperty(_classnames3, styles[position], !!position), _classnames3));
	    return React.createElement(
	        'div',
	        { className: wrapperClasses },
	        React.createElement('div', { className: overlayClasses }),
	        React.createElement('div', { className: spinnerClasses, 'data-tn': 'loading-check' })
	    );
	};

	Overlay.propTypes = {
	    additionalWrapperClasses: PropTypes.string,
	    additionalOverlayClasses: PropTypes.string,
	    additionalSpinnerClasses: PropTypes.string,
	    position: PropTypes.string,
	    size: PropTypes.oneOf(['large', 'medium', 'small'])
	};

	module.exports = Overlay;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __webpack_require__("./node_modules/react/react.js");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __webpack_require__("./node_modules/prop-types/index.js");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __webpack_require__("./node_modules/classnames/index.js");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"large":"_spinner__large__1nVe5","spin":"_spinner__spin__3Rf99","isFixed":"_spinner__isFixed__1TEmG","isAbsolute":"_spinner__isAbsolute__2m1Rz","isStatic":"_spinner__isStatic__1SdOj","isRelative":"_spinner__isRelative__1sFOo","medium":"_spinner__medium__2UQim","small":"_spinner__small__1DEW1"};

/***/ })
/******/ ]);

/***/ }),

/***/ "./node_modules/dibs-tracking/gas.js":
/***/ (function(module, exports) {

/*
 * File created for running jasmine tests in node.
 * Webpack config makes require call to _gas return window._gas.
 * However webpack is not used when running tests from node. Hence,
 * check if _gas exists on window (as webpack does) and return it if it exists
 * else it returns []
 */

// check for `window` since `window` is undefined if this file is run via node
module.exports = typeof window !== 'undefined' ? (window._gas || []) : [];


/***/ }),

/***/ "./node_modules/dibs-tracking/gtmDataLayer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * For Google Tag Manager
 */


var root = typeof window === 'undefined' ? global : window;
root.dataLayer = root.dataLayer || [];
module.exports = root.dataLayer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/dibs-tracking/tracking.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__("./node_modules/dibs-gas/index.js");

var serverVars = __webpack_require__("./node_modules/server-vars/index.js");
var _gas = __webpack_require__("./node_modules/dibs-tracking/gas.js");
var gtmDataLayer = __webpack_require__("./node_modules/dibs-tracking/gtmDataLayer.js");
var parseurl = __webpack_require__("./node_modules/parseurl/index.js");
var jsCookie = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");
var Deferred = __webpack_require__("./node_modules/simply-deferred/deferred.js").Deferred;
var merge = __webpack_require__("./node_modules/lodash.merge/index.js");

var undefined = void(0);
var root = typeof window === 'undefined' ? global : window;
var location = root.document ? root.document.location : {hostname: ''};
var cookieSettings = {
    path : '/',
    domain : location.hostname.split('.').slice(-2).join('.')
};

function isEmpty(value) {
    return value ? !Object.keys(value).length : true;
}

function pick(data, dataKeys) {
    var newObject = {};
    Object.keys(data).forEach(function (key) {
        if (dataKeys.indexOf(key) !== -1) {
            newObject[key] = data[key];
        }
    });
    return newObject;
}

function omit(data, dataKeys) {
    var newObject = {};
    Object.keys(data).forEach(function (key) {
        if (dataKeys.indexOf(key) === -1) {
            newObject[key] = data[key];
        }
    });
    return newObject;
}

/*
 *
 * SETUP 1STDIBS-SPECIFIC TRACKING HERE, DON'T PUT OUTSIDE DEPENDENCIES IN GAS.SETUP
 *
 */

// serverVars is undefined on legacy pages
// TODO: May have to do this for data layers
serverVars = serverVars || {};
var serverVarsTracking = serverVars.tracking;
var customVarLoginStr = 'login='; // used for tracking.getLoggedInStatus
var tracking = {};
var defaults = {
    'opt_label': undefined,
    'opt_value': undefined,
    'opt_noninteraction': undefined
};

// provide backward-compatibility for the legacy
// dibs.tracking.customVars array
if (serverVarsTracking) {
    tracking.customVars = serverVarsTracking.customVars || [];
}

// Boolean flags and methods used to ensure events are fired to Google Tag Manager in the correct order
// (see startTrackingEvents method description)
var gtmInitialInfoFired     = false;
var gtmInitialPageViewFired = false;
var startTrackingEvents;

var ecomParseUrl;
var ecomGetProducts;
var mergeAdditionalData;
var useShippingStatusData;
var shippingStatusDfd       = Deferred();
var gtmEventQueue           = [];
var gtmPageInfo             = serverVars.get('tracking.initialDataLayerInfo');
var gtmUserAttributeKeys    = [
    'loginStatus',
    'registrationStatus',
    'userID',
    'guestID',
    'userEmail',
    'userEmailAddress',
    'emailToken',
    'userZip',
    'defaultCurrency',
    'firstSessionDate',
    'contactDealerStatus',
    'buyerStatus',
    'firstPurchaseDate',
    'firstPurchasePrice',
    'tradeStatus',
    'customerType',
    'tradeTier',
    'tradeFirmId'
];
var gtmContentGroupKeys     = ['pageType', 'pageSubType', 'pageLevel', 'pageSection', 'pageCategory'];
var comCustomDimensionMap = {
    dimension1  : 'timePeriod',
    dimension2  : 'creator',
    dimension8  : 'onSale',
    dimension9  : 'newListing',
    dimension11 : 'dealerName',
    dimension12 : 'dealerID',
    dimension13 : 'dealerLocation',
    dimension20 : 'itemPostingLocation',
    dimension37 : 'purchaseStatus',
    dimension38 : 'askingPrice',
    dimension76 : 'priceType'
};

/**
 * For Google Tag Manager to work properly the order in which data is added to the dataLayer is important
 *  1. initial page data/user info
 *  2. initial page view event
 *  3. any ga events fired on the page
 * This is a private function which is called by either tracking.trackPageView or tracking.addUserAttributes and
 * controls this flow of how events are fired.
 * @private
 */
startTrackingEvents = function () {
    // need to check that we aren't already tracking events so that forEach call
    // doesn't accidentally put us in an infinite loop
    if (gtmEventQueue === gtmDataLayer) {
        return;
    }

    // add each of the events in the queue to the gtmDataLayer (in fifo order)
    gtmEventQueue.forEach(function (event, index) {
        gtmDataLayer.push(event);
    });

    // change reference
    gtmEventQueue = gtmDataLayer;
};

/**
 * helper method used to parse a pdp url for an item's category level (L1/L2/L3), name and id
 * @param url
 * @returns {*}
 */
ecomParseUrl = function (url) {
    var pathArr;
    if (typeof url !== 'string') {
        return {};
    }
    // given a pdp url of the form -->
    //      https://www.1stdibs.com/{L1}/{l2}/{L3}/{product name}/id-{item pk}/?{random params}
    // set pathArr to
    //      [path, {L1/L2/L3}, {L1}, {L2}, {L3}, {product name}, {item pk}]
    pathArr = /^\/(?:([^\/]*)\/([^\/]*)(?:(?:\/([^\/]*)(?:\/([^\/]*)))|(?:\/([^\/]*))?))\/id-([^/]+)\/?$/i.exec(parseurl({url: url}).pathname);
    if (isEmpty(pathArr)) {
        return {};
    }
    // grab the item id, the product name and the uri substring for the categories
    return {
        category: [pathArr[1], pathArr[2], pathArr[3]].filter(function (elem) {
            return !!elem;
        }).join('/'),  // {L1/L2/L3}
        name: (pathArr[4] || pathArr[5] || '').split('-').join(' '),
        id: pathArr[6]
    };
};

/**
 * helper method (used in ecommerceProduct) that takes the trackObj products array and returns a product array
 * formatted for the GTM tracking object.
 * @param prodArr
 * @returns {Array}
 */
ecomGetProducts = function (productArray) {
    var outArr = [];
    var productData;
    if (productArray !== undefined && productArray.length) {
        productArray.forEach(function (product, index) {
            productData = merge(ecomParseUrl(product.url), product);
            productData = mergeAdditionalData(productData, product);
            productData = omit(productData, ['url', 'additional']);
            outArr.push(productData);
        });
    }
    return outArr;
};

/**
 * this helper function is used in tracking.trackPageView, tracking.trackSocial, and tracking.trackEvent
 * to merge additional data into the trackObject that is pushed to the dataLayer
 * @param gtmData
 * @param trackObj
 */
mergeAdditionalData = function (gtmData, trackObj) {
    var additionalData = trackObj ? trackObj.additional : {};
    return merge({}, gtmData, additionalData);
};

/**
 * Sets flag to ensure we wait for shipping status data to resolve before we track it
 */
tracking.setupShippingStatusTracking = function () {
    useShippingStatusData = true;
};

/**
 * Resolves the shippingStatusDfd singleton with the passed data
 */
tracking.resolveShippingStatusDfdWith = function (data) {
    shippingStatusDfd.resolve(data);
};

/**
 * check for this value at run time instead of setting it once at run time
 * @returns {boolean}
 */
tracking.isGaAllowed = function () {
    // phpstorm says this condition can be simplified
    // but it makes it less readable IMO
    // return !(serverVars.settings && serverVars.settings.allowGa === false);
    // is what it like instead
    if (serverVars.settings && serverVars.settings.allowGa === false) {
        return false;
    }
    return true;
};

/**
 * returns the logged in status of the user
 * @param {boolean} status Whether the user is logged in or not
 * @returns {string}
 */
tracking.getLoggedInStatus = function (status) {
    if (typeof status !== 'boolean') {
        return customVarLoginStr + 'n';
    }
    return customVarLoginStr + (status ? 'y' : 'n');
};

/**
 * pushes userAttributes into the dataLayer (along with the gtmPageInfo)
 * @param trackObj
 */
tracking.addUserAttributes = function addUserAttributes(trackObj) {
    var gtmUserAttributes;
    if (!isEmpty(trackObj) && !gtmInitialInfoFired) {
        // filters out invalid userAttribute keys
        gtmUserAttributes = pick(trackObj, gtmUserAttributeKeys);

        // Once the shipping status data is available, proceed setting attributes to the gtmDataLayer
        // If not using shipping status data, go forward and resolve the deferred object
        if (!useShippingStatusData) {
            shippingStatusDfd.resolve();
        }
        shippingStatusDfd.done(function (userQuoteData) {

            // pushing the initial dataLayerInfo directly to the dataLayer
            gtmDataLayer.push(merge(gtmUserAttributes, gtmPageInfo, userQuoteData));
            gtmInitialInfoFired = true;

            // if the pageView has not been fired then we want to wait for it to be fired to start tracking events
            if (gtmInitialPageViewFired) {
                startTrackingEvents();
            }
        });

    }
};

tracking.resetGTMPageView = function resetGTMPageView() {
    gtmInitialPageViewFired = false;
    gtmEventQueue           = [];
};

/**
 * resets the google tag manager tracking by setting all the flags back to false, recreating the event queue
 * ** FOR TESTING **
 */
tracking.resetGtmTracking = function resetGtmTracking() {
    gtmInitialInfoFired     = false;
    gtmPageInfo             = serverVars.get('tracking.initialDataLayerInfo');
    this.resetGTMPageView();
};

/**
 * when tracking object is not known in client, there has to be a way
 * around setting it without using server-vars.
 */
tracking.setGtmPageInfo = function setGtmPageInfo(trackingObj) {
    gtmPageInfo = trackingObj;
};

/**
 * add/update aditional page info vars
 */
tracking.updateGtmPageInfo = function updateGtmPageInfo(trackingObj) {
    gtmPageInfo = merge(gtmPageInfo, trackingObj);
};

/**
 * sets te google tag manager tracking flags to true and calls startTrackingEvents()
 * ** FOR TESTING **
 */
tracking.setGtmFlagsTrue = function setGtmFlagsTrue() {
    gtmInitialInfoFired     = true;
    gtmInitialPageViewFired = true;
    startTrackingEvents();
};

/**
 * The main page view tracking call
 * @param {string || object} trackObj       Can either be the literal url or an object with a url key
 *                                          (can also be undefined in which case GTM will internally grab
 *                                          the url from the page)
 * @param {string} trackObj.url
 * @param {object} [trackObj.additional]    An object with any additional key/value pairs to pass to GTM
 *                                          added to gtmData in mergeAdditionalData(gtmData, trackObj)
 */
tracking.trackPageview = function trackPageview(trackObj) {
    var gtmData;

    // this is necessary for stale logins on checkout
    // so that the page view tracking doesn't fire twice
    if (this.isGaAllowed()) {

        gtmData = {
            'event'         : 'e_ga_pageview',
            'opt_pageURL'   : (typeof trackObj === 'object') ? trackObj.url : trackObj
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);
        gtmData.opt_pageURL = gtmData.opt_pageURL || undefined; // eslint-disable-line

        // If this is not the initial page view then just push it like a regular event
        if (gtmInitialPageViewFired) {
            gtmEventQueue.push(gtmData);

            // If it is the initial page view then add it to the beginning of the queue, switch flag
        } else {
            gtmEventQueue.unshift(gtmData);
            gtmInitialPageViewFired = true;

            // if the initial dataLayer info has not been added then we want to wait to start tracking events
            if (gtmInitialInfoFired) {
                startTrackingEvents();
            }
        }
    }
};

// TODO: REMOVE CUSTOM VARIABLE STUFF BECAUSE GA IS NO LONGER USING CUSTOM VARIABLES IN UNIVERSAL ANALYTICS
/**
 * set a custom var for google analytics.  Having one spot to set this allows for better control of determining
 * when to fire and when not to fire these events
 * FINDING-2644 - do not allow browser "previews" from firing tracking
 * https://developers.google.com/analytics/devguides/collection/gajs/gaTrackingCustomVariables
 *
 * @param {object}  trackObj        The tracking object used by google analytics
 * @param {int}     trackObj.slot   The slot number for the custom var. Defaults to 1
 * @param {string}  trackObj.name   The 2nd-level name for your online content categories
 * @param {string}  trackObj.value  The value to set trackObj.name to
 * @param {int}     trackObj.scope  The scope of the page level based on the GA docs (1, 2 or 3).  Defaults to 1
 */
tracking.setCustomVar = function setCustomVar(trackObj) {
    if (this.isGaAllowed() && !isEmpty(trackObj)) {
        _gas.push([
            '_setCustomVar',
            trackObj.slot || 1,
            trackObj.name || 'No Page Name',
            trackObj.value || 'No Page Value',
            trackObj.scope || 1
        ]);
        this.setCustomVarLocal(trackObj);
    }
};

/**
 * Sets the tracking object to a 'local' cookie representing the
 * current state of custom vars in GA
 * @param {object} trackingObj The tracking object used by google analytics
 */
tracking.setCustomVarLocal = function setCustomVarLocal(trackingObj) {
    var localCustomVars;
    jsCookie.json = true;
    localCustomVars = jsCookie.getJSON('lcv') || {};
    localCustomVars[trackingObj.slot] = trackingObj;
    jsCookie.set('lcv', localCustomVars, cookieSettings);
    delete jsCookie.json;
};

/**
 * Gets the "local" copy of the GA custom vars for the given slot
 * @param {int}     slotNumber
 *
 * @returns {object}
 */
tracking.getCustomVar = function getCustomVar(slotNumber) {
    var localCustomVars;

    jsCookie.json = true;
    localCustomVars = jsCookie.get('lcv') || {};
    delete jsCookie.json;

    return localCustomVars[slotNumber];
};

/**
 * Event tracking using Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.category    The tracking category - a way to group objects to track
 * @param {string} trackObj.action      The tracking action - typically the type of event or interaction
 * @param {string} [trackObj.label]     The tracking label - additional dimension to use for tracking
 * @param {number} [trackObj.value]     The tracking value
 * @param {boolean} [trackObj.noninteraction] Affects bounce rate (must be explicitly passed in to trigger a page view)
 *                                            - `true` (default) will not count as another page view which will mean if a user visits one page, interacts, and leaves, a bounce will be triggered (expected)
 *                                            - `false` will essentially treat the interaction as a page view and not trigger a bounce if the user leaves the page
 * @param {object} [trackObj.additional] An object with any additional key/value pairs to pass to GTM
 */
tracking.trackEvent = function trackEvent(trackObj) {
    var gtmData;
    if (!isEmpty(trackObj)) {
        trackObj.value          = (trackObj.value !== undefined) ? trackObj.value : 0;
        trackObj.noninteraction = (trackObj.noninteraction !== undefined) ? trackObj.noninteraction : 1;

        gtmData = {
            'event'         : 'e_ga_event',
            'category'      : (trackObj.category || 'no category').toLowerCase(),
            'action'        : trackObj.action || 'no action',
            'label'         : trackObj.label || 'none',
            'value'         : trackObj.value,
            'noninteraction': trackObj.noninteraction
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};
/**
 * Form Error tracking using Google Tag Manager
 * @param trackObj
 */
tracking.trackFormError = function (trackObj) {
    var gtmData;
    if (!isEmpty(trackObj)) {
        trackObj.value          = (trackObj.value !== undefined) ? trackObj.value : 0;
        trackObj.noninteraction = (trackObj.noninteraction !== undefined) ? trackObj.noninteraction : 1;

        gtmData = {
            'event'         : 'e_form_error',
            'category'      : 'form error',
            'action'        : trackObj.action || 'no action',
            'label'         : trackObj.label || 'none',
            'value'         : trackObj.value,
            'noninteraction': trackObj.noninteraction
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};

/**
 * Social tracking using Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.name            The social network name
 * @param {string} trackObj.event           The type of event it is firing
 * @param {object} [trackObj.additional]    An object with any additional key/value pairs to pass to GTM
 */
tracking.trackSocial = function trackSocial(trackObj) {
    var gtmData;

    if (trackObj.name && trackObj.event) {
        gtmData = {
            'event'         : 'e_ga_social',
            'network'       : trackObj.name,
            'socialAction'  : trackObj.event,
            'opt_target'    : trackObj.opt_target   || undefined,
            'opt_pagePath'  : trackObj.opt_pagePath || undefined
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};

/**
 * Ecommerce Tracking used in Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.type            - productImpression/productClick/productDetail
 * @param {Array}  trackObj.products        - an array of objects, each containing one product's info
 *                                              {   url     : product url,
 *                                                  brand   : dealer id,
 *                                                  price   : USD price     ... }
 * @param {object} [trackObj.actionField]   - an object containing additional information specific to each tracking type
 *                                          { list : list,
 *                                            step : 1      ... }
 */
tracking.trackEcommerce = function ecommerceProduct(trackObj) {
    var products;
    var ecommerce = {};

    if (!isEmpty(trackObj) && trackObj.type) {
        products = ecomGetProducts(trackObj.products);
        switch (trackObj.type) {
            case 'productImpression' :
                if (products.length) {
                    ecommerce.impressions = products;
                } else {
                    ecommerce = undefined;
                }
                break;
            case 'productClick':
                if (trackObj.actionField && trackObj.actionField.list && products.length) {
                    ecommerce.click = {
                        'actionField' : { list : trackObj.actionField.list },
                        'products'    : products
                    };
                }
                break;
            case 'productDetail':
                if (products.length) {
                    ecommerce.detail = { 'products' : products };
                } else {
                    ecommerce = undefined;
                }
                break;
            case 'addToCart':
                if (products.length) {
                    ecommerce.add = { 'products'  : products };
                }
                break;
            case 'checkout':
                if (trackObj.actionField && trackObj.actionField.step && products.length) {
                    ecommerce.checkout = {
                        'actionField'   : { 'step' : trackObj.actionField.step },
                        'products'      : products
                    };
                    if (trackObj.option) {
                        ecommerce.checkout.option = trackObj.option;
                    }
                }
                break;
            case 'promotionImpression' :
                if (trackObj.promotions && trackObj.promotions.length) {
                    ecommerce.promoView = { promotions : trackObj.promotions };
                }
                break;
            case 'promoClick' :
                if (trackObj.promotions && trackObj.promotions.length) {
                    ecommerce.promoClick = { promotions : trackObj.promotions };
                }
                break;
        }
        // FINDING-8606 allow ecommerce === undefined because when ecommerce
        // is undefined it removes the event from the data layer. Which stops it from
        // being tracked on every vpv
        if (!isEmpty(ecommerce) || ecommerce === undefined) {
            gtmEventQueue.push({
                'event'     : 'ecommerce_' + trackObj.type,
                'ecommerce' : ecommerce
            });
        }
    }
};

/**
 * Maps the data values to the appropriate custom dimension indexes used by google analytics
 * (e.g. returns object { dimension1 : '1900s', dimension38 : '1000' } which ga will then map on their end
 * to 'timePeriod' and 'askingPrice' respectively).
 * @param   {object} data
 * @param   {array}  [dataKeys]         optional parameter to specify which specific keys in the
 *                                      data param should be tracked.
 * @returns {object} customDimensions
 */
tracking.getCustomDimensions = function (data, dataKeys) {
    var customDimensions = {};

    if (data !== undefined) {
        // removes any key/values that are not wanted
        data = dataKeys ? pick(data, dataKeys) : data;

        // returns an object with the data object values associated with the correct dimension key
        var keys = Object.keys(comCustomDimensionMap);
        keys.forEach(function (key) {
            if (data[comCustomDimensionMap[key]] !== undefined) {
                customDimensions[key] = data[comCustomDimensionMap[key]];
            }
        });
    }

    return customDimensions;
};

/**
 * Ecommerce tracking function (specifically for tracking transactions)
 * This need to be sent to Google before userAttributes, gtmPageInfo or pageview is fired.
 * @param {object} trackObj
 * @param {array} trackObj.products
 * @param {object} trackObj.actionField
 */
tracking.trackEcommercePurchase = function (trackObj) {
    var products = ecomGetProducts(trackObj.products);
    var ecommerce = {};

    if (trackObj.actionField && products.length) {
        ecommerce.purchase = {
            'actionField'   : trackObj.actionField,
            'products'      : products
        };
    }

    if (!isEmpty(ecommerce)) {
        gtmDataLayer.push({
            'event'     : 'ecommerce_' + trackObj.type,
            'ecommerce' : ecommerce
        });
    }
};

tracking.addGTMMessage = function (message) {
    gtmDataLayer.push(message);
};

/**
 * Grabs a page's current content groupings
 * (This is needed when modals are opened and closed so that events are attributed to the correct page without firing
 * pageviews that will inflate GA's page hit numbers)
 * @return {object} contentGroupings
 */
tracking.getOriginContentGroupings = function () {
    return pick(gtmPageInfo || {}, gtmContentGroupKeys);
};

tracking.fireDummyEvent = function () {
    //we need to fire a dummy trackEvent in order to send the custom variable to the GA server
    //http://stackoverflow.com/questions/10038450/setting-a-custom-variable-in-google-analytics-after-trackpageview-is-called
    this.trackEvent({
        category: 'Dummy Event',
        action: 'Dummy Event',
        label: ''
    });
};

tracking.setDefault = function setDefault(what, toWhat) {
    var i;
    if (what && typeof what === 'object') {
        for (i in what) {
            if (what.hasOwnProperty(i)) {
                this.setDefault(i, what[i]);
            }
        }
    }
    what = '' + what;
    if (defaults.hasOwnProperty(what)) {
        defaults[what] = toWhat;
    }
};

tracking.clearDefault = function (what) {
    return this.setDefault(what, undefined);
};

module.exports = tracking;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/account-outlined.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-account-outlined'].join(' '), 'data-tn': 'account-outlined', viewBox: '0 0 500 500' },
                React.createElement('path', { d: 'M278.088764,500 C190.723711,500 100.959616,499.78903 11.3954418,499.367089 L0,499.367089 L0.799680128,487.552743 C1.19952019,480.801688 4.9980008,421.940928 14.3942423,399.78903 C15.9936026,395.780591 26.1895242,370.886076 51.9792083,361.181435 L130.747701,327.637131 L163.934426,312.236287 C164.534186,312.025316 179.128349,305.696203 183.126749,287.341772 C183.526589,284.599156 183.326669,280.801688 182.926829,279.746835 C181.127549,276.160338 181.127549,276.160338 176.729308,270.886076 L176.529388,270.675105 C175.129948,268.987342 143.942423,229.957806 136.745302,173.628692 C136.345462,170.886076 132.546981,144.092827 136.145542,112.447257 C141.143543,67.5105485 158.336665,34.3881857 186.12555,16.6666667 C187.32507,15.8227848 213.714514,0 251.09956,0 C272.890844,0 294.082367,5.48523207 314.07437,16.0337553 C321.271491,19.4092827 381.847261,51.0548523 365.253898,175.316456 C364.854058,179.324895 358.656537,228.691983 325.669732,270.675105 C324.870052,271.518987 324.070372,272.57384 323.070772,273.839662 C321.471411,275.738397 319.272291,278.059072 318.072771,280.168776 C317.872851,281.223629 317.473011,283.966245 318.472611,287.130802 L318.672531,287.763713 L318.872451,288.607595 C319.072371,289.029536 322.271092,304.219409 341.463415,313.080169 L384.446222,333.544304 L447.820872,360.337553 C449.220312,360.970464 487.005198,376.793249 495.001999,429.324895 L495.201919,430.379747 L500,499.578059 L488.604558,499.578059 C487.604958,499.367089 407.836865,500 278.088764,500 L278.088764,500 L278.088764,500 L278.088764,500 L278.088764,500 Z M22.7908836,476.793249 C108.556577,477.21519 194.322271,477.42616 277.888844,477.42616 C379.448221,477.42616 450.219912,477.004219 476.609356,477.004219 L473.610556,432.278481 C467.612955,393.459916 441.023591,381.64557 439.82407,381.223629 L375.64974,354.219409 L332.666933,333.755274 C305.677729,321.097046 299.080368,298.734177 297.880848,293.670886 C294.482207,282.278481 297.680928,272.78481 298.080768,271.729958 L298.480608,270.675105 C300.879648,265.400844 304.678129,261.392405 307.277089,258.227848 C307.876849,257.383966 308.676529,256.751055 309.076369,256.118143 C338.464614,218.776371 343.862455,172.995781 343.862455,172.362869 L343.862455,172.151899 C358.656537,61.6033755 307.477009,37.5527426 305.277889,36.4978903 L304.478209,36.0759494 C287.485006,27.0042194 269.492203,22.3628692 250.89964,22.3628692 C219.312275,22.3628692 197.121152,35.6540084 196.921232,35.8649789 C143.142743,70.2531646 157.736905,168.987342 157.736905,170.042194 L157.736905,170.464135 C163.734506,218.776371 190.723711,253.586498 192.522991,255.907173 C198.320672,262.658228 198.920432,263.50211 201.919232,269.831224 C205.517793,277.42616 204.518193,287.974684 204.118353,290.92827 L203.918433,291.772152 C197.920832,321.097046 174.930028,331.85654 171.731307,333.333333 L138.544582,348.523207 L59.1763295,382.489451 C41.1835266,389.240506 34.1863255,408.016878 34.1863255,408.227848 L33.7864854,409.07173 C28.3886445,421.308017 24.5901639,455.485232 22.7908836,476.793249 L22.7908836,476.793249 L22.7908836,476.793249 L22.7908836,476.793249 L22.7908836,476.793249 Z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/alert-bell.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-alert-bell'].join(' '), 'data-tn': 'alert-bell', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M246.3,194.1c-1.3-0.2-31-4.4-30.1-58.4V85.4c0-0.1,0-0.1,0-0.2c-0.1-2.3-2.7-55.9-47.1-74.6 c-3.4-1.8-43.1-21.2-82.5,0.1c-3.1,1.5-44.9,22.5-46,74.2v52.4c0,0,0,0.1,0,0.1c0,0.3,0.6,31.9-14.7,47.8 c-5.6,5.9-12.6,8.8-21.2,8.9c-2.5,0-4.5,2.1-4.4,4.5c0,2.5,2,4.5,4.5,4.5h77.8c0.3,3.8,1.4,12.9,5.7,22.1 c7.5,16.1,20.8,24.4,38.5,24.1c0.2,0,0.5,0,0.8,0c3.4,0,14.3-0.7,24-9.2c9.2-8,14.5-20.5,15.8-37h78.4c2.4,0,4.3-1.9,4.5-4.2 S248.6,194.4,246.3,194.1z M127.1,240.2c-0.1,0-0.3,0-0.4,0c-29.8,0.6-34.5-29-35.2-37.2h66.8C155,241.4,128.3,240.3,127.1,240.2z M29.6,194.1c1-0.8,1.9-1.7,2.8-2.6c17.7-18.4,17.2-52,17.2-54.2l0-52.3c1-46.8,39.3-65.5,40.9-66.2c0.1,0,0.2-0.1,0.2-0.1 c36.1-19.5,74-0.2,74.4,0c0.1,0.1,0.2,0.1,0.4,0.2C204,35,207.1,83.3,207.2,85.5l0,50.1c-0.5,25.9,5.6,45,18,57 c0.5,0.5,1.1,1,1.6,1.5H29.6z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/app-store.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
  _inherits(Component, _React$Component);

  function Component() {
    _classCallCheck(this, Component);

    return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
  }

  _createClass(Component, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'svg',
        { className: [this.props.className, 'dibsvg-svg dibsvg-app-store'].join(' '), 'data-tn': 'app-store', viewBox: '0 -47 135 135' },
        React.createElement(
          'g',
          null,
          React.createElement('path', { d: 'M130.197,40 L4.729,40 C2.122,40 0,37.872 0,35.267 L0,4.726 C0,2.12 2.122,0 4.729,0 L130.197,0 C132.803,0 135,2.12 135,4.726 L135,35.267 C135,37.872 132.803,40 130.197,40 L130.197,40 L130.197,40 Z', fill: '#404040' }),
          React.createElement('path', { d: 'M134.032,35.268 C134.032,37.384 132.318,39.098 130.198,39.098 L4.729,39.098 C2.61,39.098 0.89,37.384 0.89,35.268 L0.89,4.725 C0.89,2.61 2.61,0.89 4.729,0.89 L130.197,0.89 C132.318,0.89 134.031,2.61 134.031,4.725 L134.032,35.268 L134.032,35.268 L134.032,35.268 Z', fill: '#404040' }),
          React.createElement(
            'g',
            { transform: 'translate(12.000000, 6.000000)', fill: '#000000' },
            React.createElement('path', { d: 'M18.128,13.784 C18.099,10.561 20.767,8.993 20.889,8.92 C19.378,6.717 17.036,6.416 16.213,6.392 C14.246,6.185 12.338,7.569 11.336,7.569 C10.314,7.569 8.771,6.412 7.108,6.446 C4.968,6.479 2.966,7.718 1.868,9.642 C-0.398,13.565 1.292,19.33 3.463,22.501 C4.549,24.054 5.818,25.788 7.479,25.727 C9.104,25.66 9.711,24.691 11.672,24.691 C13.615,24.691 14.185,25.727 15.879,25.688 C17.623,25.66 18.721,24.128 19.769,22.561 C21.024,20.781 21.528,19.028 21.548,18.938 C21.507,18.924 18.161,17.647 18.128,13.784 L18.128,13.784 Z' }),
            React.createElement('path', { d: 'M14.928,4.306 C15.802,3.213 16.4,1.726 16.234,0.217 C14.969,0.273 13.387,1.092 12.476,2.161 C11.67,3.103 10.95,4.647 11.136,6.099 C12.557,6.205 14.016,5.382 14.928,4.306 L14.928,4.306 Z' })
          ),
          React.createElement(
            'g',
            { transform: 'translate(42.000000, 18.000000)', fill: '#000000' },
            React.createElement('path', { d: 'M11.645,13.504 L9.374,13.504 L8.13,9.595 L3.806,9.595 L2.621,13.504 L0.41,13.504 L4.694,0.196 L7.34,0.196 L11.645,13.504 L11.645,13.504 Z M7.755,7.955 L6.63,4.48 C6.511,4.125 6.288,3.289 5.959,1.973 L5.919,1.973 C5.788,2.539 5.577,3.375 5.287,4.48 L4.182,7.955 L7.755,7.955 L7.755,7.955 Z' }),
            React.createElement('path', { d: 'M22.662,8.588 C22.662,10.22 22.221,11.51 21.339,12.457 C20.549,13.3 19.568,13.721 18.397,13.721 C17.133,13.721 16.225,13.267 15.672,12.359 L15.632,12.359 L15.632,17.414 L13.5,17.414 L13.5,7.067 C13.5,6.041 13.473,4.988 13.421,3.908 L15.296,3.908 L15.415,5.429 L15.455,5.429 C16.166,4.283 17.245,3.711 18.693,3.711 C19.825,3.711 20.77,4.158 21.526,5.053 C22.284,5.949 22.662,7.127 22.662,8.588 L22.662,8.588 Z M20.49,8.666 C20.49,7.732 20.28,6.962 19.858,6.356 C19.397,5.724 18.778,5.408 18.002,5.408 C17.476,5.408 16.998,5.584 16.571,5.931 C16.143,6.281 15.863,6.738 15.732,7.304 C15.666,7.568 15.633,7.784 15.633,7.954 L15.633,9.554 C15.633,10.252 15.847,10.841 16.275,11.322 C16.703,11.803 17.259,12.043 17.943,12.043 C18.746,12.043 19.371,11.733 19.818,11.115 C20.266,10.496 20.49,9.68 20.49,8.666 L20.49,8.666 Z' }),
            React.createElement('path', { d: 'M33.699,8.588 C33.699,10.22 33.258,11.51 32.375,12.457 C31.586,13.3 30.605,13.721 29.434,13.721 C28.17,13.721 27.262,13.267 26.71,12.359 L26.67,12.359 L26.67,17.414 L24.538,17.414 L24.538,7.067 C24.538,6.041 24.511,4.988 24.459,3.908 L26.334,3.908 L26.453,5.429 L26.493,5.429 C27.203,4.283 28.282,3.711 29.731,3.711 C30.862,3.711 31.807,4.158 32.565,5.053 C33.32,5.949 33.699,7.127 33.699,8.588 L33.699,8.588 Z M31.527,8.666 C31.527,7.732 31.316,6.962 30.894,6.356 C30.433,5.724 29.816,5.408 29.039,5.408 C28.512,5.408 28.035,5.584 27.607,5.931 C27.179,6.281 26.9,6.738 26.769,7.304 C26.704,7.568 26.67,7.784 26.67,7.954 L26.67,9.554 C26.67,10.252 26.884,10.841 27.31,11.322 C27.738,11.802 28.294,12.043 28.98,12.043 C29.783,12.043 30.408,11.733 30.855,11.115 C31.303,10.496 31.527,9.68 31.527,8.666 L31.527,8.666 Z' }),
            React.createElement('path', { d: 'M46.039,9.772 C46.039,10.904 45.646,11.825 44.857,12.536 C43.99,13.313 42.783,13.701 41.232,13.701 C39.8,13.701 38.652,13.425 37.783,12.872 L38.277,11.095 C39.213,11.661 40.24,11.945 41.359,11.945 C42.162,11.945 42.787,11.763 43.236,11.401 C43.683,11.039 43.906,10.553 43.906,9.947 C43.906,9.407 43.722,8.952 43.353,8.583 C42.986,8.214 42.373,7.871 41.517,7.554 C39.187,6.685 38.023,5.412 38.023,3.738 C38.023,2.644 38.431,1.747 39.248,1.049 C40.062,0.35 41.148,0.001 42.506,0.001 C43.717,0.001 44.723,0.212 45.526,0.633 L44.993,2.371 C44.243,1.963 43.395,1.759 42.446,1.759 C41.696,1.759 41.11,1.944 40.69,2.312 C40.335,2.641 40.157,3.042 40.157,3.517 C40.157,4.043 40.36,4.478 40.768,4.82 C41.123,5.136 41.768,5.478 42.704,5.847 C43.849,6.308 44.69,6.847 45.231,7.465 C45.77,8.081 46.039,8.852 46.039,9.772 L46.039,9.772 Z' }),
            React.createElement('path', { d: 'M53.088,5.508 L50.738,5.508 L50.738,10.167 C50.738,11.352 51.152,11.944 51.982,11.944 C52.363,11.944 52.679,11.911 52.929,11.845 L52.988,13.464 C52.568,13.621 52.015,13.7 51.33,13.7 C50.488,13.7 49.83,13.443 49.355,12.93 C48.882,12.416 48.644,11.554 48.644,10.343 L48.644,5.506 L47.244,5.506 L47.244,3.906 L48.644,3.906 L48.644,2.149 L50.738,1.517 L50.738,3.906 L53.088,3.906 L53.088,5.508 L53.088,5.508 Z' }),
            React.createElement('path', { d: 'M63.691,8.627 C63.691,10.102 63.269,11.313 62.427,12.26 C61.544,13.235 60.372,13.721 58.911,13.721 C57.503,13.721 56.382,13.254 55.546,12.32 C54.71,11.386 54.292,10.207 54.292,8.786 C54.292,7.299 54.722,6.081 55.585,5.134 C56.446,4.186 57.608,3.712 59.069,3.712 C60.477,3.712 61.61,4.179 62.465,5.114 C63.283,6.021 63.691,7.192 63.691,8.627 L63.691,8.627 Z M61.479,8.696 C61.479,7.811 61.29,7.052 60.907,6.419 C60.46,5.653 59.821,5.271 58.993,5.271 C58.136,5.271 57.485,5.654 57.038,6.419 C56.655,7.053 56.466,7.824 56.466,8.736 C56.466,9.621 56.655,10.38 57.038,11.012 C57.499,11.778 58.143,12.16 58.974,12.16 C59.788,12.16 60.427,11.77 60.888,10.992 C61.281,10.347 61.479,9.58 61.479,8.696 L61.479,8.696 Z' }),
            React.createElement('path', { d: 'M70.621,5.783 C70.41,5.744 70.185,5.724 69.949,5.724 C69.199,5.724 68.619,6.007 68.211,6.574 C67.856,7.074 67.678,7.706 67.678,8.469 L67.678,13.504 L65.547,13.504 L65.567,6.93 C65.567,5.824 65.54,4.817 65.487,3.909 L67.344,3.909 L67.422,5.745 L67.481,5.745 C67.706,5.114 68.061,4.606 68.547,4.225 C69.022,3.882 69.535,3.711 70.088,3.711 C70.285,3.711 70.463,3.725 70.621,3.75 L70.621,5.783 L70.621,5.783 Z' }),
            React.createElement('path', { d: 'M80.156,8.252 C80.156,8.634 80.131,8.956 80.078,9.219 L73.682,9.219 C73.707,10.167 74.016,10.892 74.61,11.392 C75.149,11.839 75.846,12.063 76.702,12.063 C77.649,12.063 78.513,11.912 79.29,11.609 L79.624,13.089 C78.716,13.485 77.644,13.682 76.407,13.682 C74.919,13.682 73.751,13.244 72.901,12.369 C72.053,11.494 71.628,10.319 71.628,8.845 C71.628,7.398 72.023,6.193 72.814,5.232 C73.642,4.206 74.761,3.693 76.169,3.693 C77.552,3.693 78.599,4.206 79.31,5.232 C79.873,6.047 80.156,7.055 80.156,8.252 L80.156,8.252 Z M78.123,7.699 C78.137,7.067 77.998,6.521 77.709,6.06 C77.34,5.467 76.773,5.171 76.01,5.171 C75.313,5.171 74.746,5.46 74.313,6.04 C73.958,6.501 73.747,7.054 73.682,7.698 L78.123,7.698 L78.123,7.699 Z' })
          ),
          React.createElement(
            'g',
            { transform: 'translate(43.000000, 6.000000)', fill: '#000000' },
            React.createElement('path', { d: 'M6.05,4.009 C6.05,5.186 5.697,6.072 4.992,6.667 C4.339,7.216 3.411,7.491 2.209,7.491 C1.613,7.491 1.103,7.465 0.676,7.413 L0.676,0.982 C1.233,0.892 1.833,0.846 2.481,0.846 C3.626,0.846 4.489,1.095 5.071,1.593 C5.723,2.156 6.05,2.961 6.05,4.009 L6.05,4.009 Z M4.945,4.038 C4.945,3.275 4.743,2.69 4.339,2.282 C3.935,1.875 3.345,1.671 2.568,1.671 C2.238,1.671 1.957,1.693 1.724,1.739 L1.724,6.628 C1.853,6.648 2.089,6.657 2.432,6.657 C3.234,6.657 3.853,6.434 4.289,5.988 C4.725,5.542 4.945,4.892 4.945,4.038 L4.945,4.038 Z' }),
            React.createElement('path', { d: 'M11.909,5.037 C11.909,5.762 11.702,6.356 11.288,6.822 C10.854,7.301 10.279,7.54 9.561,7.54 C8.869,7.54 8.318,7.311 7.907,6.851 C7.497,6.392 7.292,5.813 7.292,5.115 C7.292,4.385 7.503,3.786 7.927,3.321 C8.351,2.856 8.921,2.623 9.639,2.623 C10.331,2.623 10.887,2.852 11.308,3.311 C11.708,3.757 11.909,4.333 11.909,5.037 L11.909,5.037 Z M10.822,5.071 C10.822,4.636 10.728,4.263 10.541,3.952 C10.321,3.576 10.008,3.388 9.601,3.388 C9.18,3.388 8.86,3.576 8.64,3.952 C8.452,4.263 8.359,4.642 8.359,5.09 C8.359,5.525 8.453,5.898 8.64,6.209 C8.867,6.585 9.183,6.773 9.591,6.773 C9.991,6.773 10.305,6.582 10.531,6.199 C10.725,5.882 10.822,5.506 10.822,5.071 L10.822,5.071 Z' }),
            React.createElement('path', { d: 'M19.765,2.719 L18.29,7.433 L17.33,7.433 L16.719,5.386 C16.564,4.875 16.438,4.367 16.34,3.863 L16.321,3.863 C16.23,4.381 16.104,4.888 15.942,5.386 L15.293,7.433 L14.322,7.433 L12.935,2.719 L14.012,2.719 L14.545,4.96 C14.674,5.49 14.78,5.995 14.865,6.473 L14.884,6.473 C14.962,6.079 15.091,5.577 15.273,4.97 L15.942,2.72 L16.796,2.72 L17.437,4.922 C17.592,5.459 17.718,5.976 17.815,6.474 L17.844,6.474 C17.915,5.989 18.022,5.472 18.164,4.922 L18.736,2.72 L19.765,2.72 L19.765,2.719 Z' }),
            React.createElement('path', { d: 'M25.198,7.433 L24.15,7.433 L24.15,4.733 C24.15,3.901 23.834,3.485 23.2,3.485 C22.889,3.485 22.638,3.599 22.443,3.828 C22.25,4.057 22.152,4.327 22.152,4.636 L22.152,7.432 L21.104,7.432 L21.104,4.066 C21.104,3.652 21.091,3.203 21.066,2.717 L21.987,2.717 L22.036,3.454 L22.065,3.454 C22.187,3.225 22.369,3.036 22.608,2.885 C22.892,2.709 23.21,2.62 23.558,2.62 C23.998,2.62 24.364,2.762 24.655,3.047 C25.017,3.396 25.198,3.917 25.198,4.609 L25.198,7.433 L25.198,7.433 Z' }),
            React.createElement('path', { d: 'M28.088,7.433 L27.041,7.433 L27.041,0.556 L28.088,0.556 L28.088,7.433 L28.088,7.433 Z' }),
            React.createElement('path', { d: 'M34.258,5.037 C34.258,5.762 34.051,6.356 33.637,6.822 C33.203,7.301 32.627,7.54 31.91,7.54 C31.217,7.54 30.666,7.311 30.256,6.851 C29.846,6.392 29.641,5.813 29.641,5.115 C29.641,4.385 29.852,3.786 30.276,3.321 C30.7,2.856 31.27,2.623 31.987,2.623 C32.68,2.623 33.235,2.852 33.657,3.311 C34.057,3.757 34.258,4.333 34.258,5.037 L34.258,5.037 Z M33.17,5.071 C33.17,4.636 33.076,4.263 32.889,3.952 C32.67,3.576 32.356,3.388 31.95,3.388 C31.528,3.388 31.208,3.576 30.989,3.952 C30.801,4.263 30.708,4.642 30.708,5.09 C30.708,5.525 30.802,5.898 30.989,6.209 C31.216,6.585 31.532,6.773 31.94,6.773 C32.34,6.773 32.653,6.582 32.879,6.199 C33.074,5.882 33.17,5.506 33.17,5.071 L33.17,5.071 Z' }),
            React.createElement('path', { d: 'M39.33,7.433 L38.389,7.433 L38.311,6.89 L38.282,6.89 C37.96,7.323 37.501,7.54 36.905,7.54 C36.46,7.54 36.1,7.397 35.829,7.113 C35.583,6.855 35.46,6.534 35.46,6.153 C35.46,5.577 35.7,5.138 36.183,4.834 C36.665,4.53 37.343,4.381 38.216,4.388 L38.216,4.3 C38.216,3.679 37.89,3.369 37.237,3.369 C36.772,3.369 36.362,3.486 36.008,3.718 L35.795,3.03 C36.233,2.759 36.774,2.623 37.412,2.623 C38.644,2.623 39.262,3.273 39.262,4.573 L39.262,6.309 C39.262,6.78 39.285,7.155 39.33,7.433 L39.33,7.433 Z M38.242,5.813 L38.242,5.086 C37.086,5.066 36.508,5.383 36.508,6.036 C36.508,6.282 36.574,6.466 36.709,6.589 C36.844,6.712 37.016,6.773 37.221,6.773 C37.451,6.773 37.666,6.7 37.862,6.555 C38.059,6.409 38.18,6.224 38.225,5.997 C38.236,5.946 38.242,5.884 38.242,5.813 L38.242,5.813 Z' }),
            React.createElement('path', { d: 'M45.285,7.433 L44.355,7.433 L44.306,6.676 L44.277,6.676 C43.98,7.252 43.474,7.54 42.763,7.54 C42.195,7.54 41.722,7.317 41.347,6.871 C40.972,6.425 40.785,5.846 40.785,5.135 C40.785,4.372 40.988,3.754 41.396,3.282 C41.791,2.842 42.275,2.622 42.851,2.622 C43.484,2.622 43.927,2.835 44.179,3.262 L44.199,3.262 L44.199,0.556 L45.248,0.556 L45.248,6.163 C45.248,6.622 45.26,7.045 45.285,7.433 L45.285,7.433 Z M44.199,5.445 L44.199,4.659 C44.199,4.523 44.189,4.413 44.17,4.329 C44.111,4.077 43.984,3.865 43.791,3.694 C43.596,3.523 43.361,3.437 43.09,3.437 C42.699,3.437 42.393,3.592 42.168,3.903 C41.945,4.214 41.832,4.611 41.832,5.096 C41.832,5.562 41.939,5.94 42.154,6.231 C42.381,6.541 42.687,6.696 43.07,6.696 C43.414,6.696 43.689,6.567 43.898,6.308 C44.1,6.069 44.199,5.781 44.199,5.445 L44.199,5.445 Z' }),
            React.createElement('path', { d: 'M54.248,5.037 C54.248,5.762 54.041,6.356 53.627,6.822 C53.193,7.301 52.619,7.54 51.9,7.54 C51.209,7.54 50.658,7.311 50.246,6.851 C49.836,6.392 49.631,5.813 49.631,5.115 C49.631,4.385 49.842,3.786 50.266,3.321 C50.69,2.856 51.26,2.623 51.979,2.623 C52.67,2.623 53.227,2.852 53.647,3.311 C54.047,3.757 54.248,4.333 54.248,5.037 L54.248,5.037 Z M53.162,5.071 C53.162,4.636 53.068,4.263 52.881,3.952 C52.66,3.576 52.348,3.388 51.94,3.388 C51.52,3.388 51.2,3.576 50.979,3.952 C50.791,4.263 50.698,4.642 50.698,5.09 C50.698,5.525 50.792,5.898 50.979,6.209 C51.206,6.585 51.522,6.773 51.93,6.773 C52.33,6.773 52.645,6.582 52.871,6.199 C53.064,5.882 53.162,5.506 53.162,5.071 L53.162,5.071 Z' }),
            React.createElement('path', { d: 'M59.883,7.433 L58.836,7.433 L58.836,4.733 C58.836,3.901 58.52,3.485 57.885,3.485 C57.574,3.485 57.323,3.599 57.129,3.828 C56.935,4.057 56.838,4.327 56.838,4.636 L56.838,7.432 L55.789,7.432 L55.789,4.066 C55.789,3.652 55.777,3.203 55.752,2.717 L56.672,2.717 L56.721,3.454 L56.75,3.454 C56.873,3.225 57.055,3.036 57.293,2.885 C57.578,2.709 57.895,2.62 58.244,2.62 C58.683,2.62 59.049,2.762 59.34,3.047 C59.703,3.396 59.883,3.917 59.883,4.609 L59.883,7.433 L59.883,7.433 Z' }),
            React.createElement('path', { d: 'M66.936,3.504 L65.782,3.504 L65.782,5.794 C65.782,6.376 65.987,6.667 66.393,6.667 C66.581,6.667 66.737,6.651 66.86,6.618 L66.887,7.413 C66.68,7.491 66.408,7.53 66.073,7.53 C65.659,7.53 65.337,7.404 65.104,7.152 C64.87,6.9 64.754,6.476 64.754,5.881 L64.754,3.504 L64.065,3.504 L64.065,2.719 L64.754,2.719 L64.754,1.855 L65.781,1.545 L65.781,2.718 L66.935,2.718 L66.935,3.504 L66.936,3.504 Z' }),
            React.createElement('path', { d: 'M72.484,7.433 L71.435,7.433 L71.435,4.753 C71.435,3.908 71.119,3.485 70.486,3.485 C70,3.485 69.668,3.73 69.486,4.22 C69.455,4.323 69.437,4.449 69.437,4.597 L69.437,7.432 L68.39,7.432 L68.39,0.556 L69.437,0.556 L69.437,3.397 L69.457,3.397 C69.787,2.88 70.26,2.622 70.873,2.622 C71.307,2.622 71.666,2.764 71.951,3.049 C72.306,3.404 72.484,3.932 72.484,4.63 L72.484,7.433 L72.484,7.433 Z' }),
            React.createElement('path', { d: 'M78.207,4.853 C78.207,5.041 78.193,5.199 78.168,5.328 L75.025,5.328 C75.039,5.794 75.189,6.149 75.48,6.395 C75.746,6.615 76.089,6.725 76.509,6.725 C76.974,6.725 77.398,6.651 77.78,6.502 L77.944,7.23 C77.497,7.424 76.971,7.521 76.362,7.521 C75.632,7.521 75.057,7.306 74.641,6.876 C74.223,6.446 74.016,5.869 74.016,5.145 C74.016,4.434 74.209,3.842 74.598,3.37 C75.004,2.866 75.553,2.614 76.246,2.614 C76.924,2.614 77.439,2.866 77.787,3.37 C78.068,3.77 78.207,4.265 78.207,4.853 L78.207,4.853 Z M77.207,4.582 C77.215,4.271 77.146,4.003 77.004,3.777 C76.822,3.486 76.545,3.34 76.17,3.34 C75.828,3.34 75.549,3.482 75.336,3.767 C75.162,3.994 75.059,4.265 75.025,4.582 L77.207,4.582 L77.207,4.582 Z' })
          )
        )
      );
    }
  }]);

  return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/arrow-down.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-arrow-down'].join(' '), 'data-tn': 'arrow-down', viewBox: '0 -8.5 32 32' },
                React.createElement('path', { d: 'M32,1c0,0.3-0.1,0.6-0.3,0.8l-15,13c-0.4,0.3-0.9,0.3-1.3,0l-15-13c-0.4-0.4-0.5-1-0.1-1.4 c0.4-0.4,1-0.5,1.4-0.1L16,12.6L30.3,0.2c0.4-0.4,1-0.3,1.4,0.1C31.9,0.5,32,0.8,32,1z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/arrow-left.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-arrow-left'].join(' '), 'data-tn': 'arrow-left', viewBox: '-8.5 0 32 32' },
                React.createElement('path', { d: 'M14,32c-0.3,0-0.6-0.1-0.8-0.3l-13-15c-0.3-0.4-0.3-0.9,0-1.3l13-15c0.4-0.4,1-0.5,1.4-0.1 c0.4,0.4,0.5,1,0.1,1.4L2.3,16l12.4,14.3c0.4,0.4,0.3,1-0.1,1.4C14.4,31.9,14.2,32,14,32z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/arrow-right.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-arrow-right'].join(' '), 'data-tn': 'arrow-right', viewBox: '-8.5 0 32 32' },
                React.createElement('path', { d: 'M1,0c0.3,0,0.6,0.1,0.8,0.3l13,15c0.3,0.4,0.3,0.9,0,1.3l-13,15c-0.4,0.4-1,0.5-1.4,0.1 c-0.4-0.4-0.5-1-0.1-1.4L12.6,16L0.2,1.7c-0.4-0.4-0.3-1,0.1-1.4C0.5,0.1,0.8,0,1,0z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/cart-open.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-cart-open'].join(' '), 'data-tn': 'cart-open', viewBox: '0 0 250 250' },
                React.createElement('polygon', { points: '239.5,73.2 216.5,163 83.2,163 51.8,37 1,37 1,47 44,47 75.4,173 224.3,173 250.3,73.2' }),
                React.createElement('circle', { cx: '107.3', cy: '201.7', r: '11.7' }),
                React.createElement('circle', { cx: '193.3', cy: '201.7', r: '11.7' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/chair-outlined.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-chair-outlined'].join(' '), 'data-tn': 'chair-outlined', viewBox: '0 0 38 50' },
                React.createElement('path', { d: 'M20.2462,38.6456 C19.6062,38.6456 18.9232,38.6066 18.2442,38.5476 C18.1652,38.5476 9.7122,37.8686 5.1072,30.3186 L5.0672,30.2596 C5.0482,30.2196 2.3232,26.4746 1.7032,14.8216 L1.7032,14.8016 C1.7032,14.7426 1.1412,7.7936 2.5232,3.6276 L2.5432,3.5686 C2.5432,3.5496 3.0652,1.6256 4.2232,1.6256 C4.5452,1.6256 4.9022,1.7666 5.3222,2.0066 C5.3812,2.0456 5.9622,2.4066 7.1052,2.8266 C7.1442,4.2676 7.0462,7.8126 5.4832,11.3976 C5.4442,11.4956 4.4432,13.8596 4.4432,17.1026 C4.4232,17.4046 4.3412,20.2276 5.7232,23.0116 L5.7432,23.0306 C5.8412,23.2116 6.6852,24.7116 8.0042,24.9746 C8.4242,25.0526 9.0642,25.0526 9.7472,24.5156 L9.8262,24.4566 C10.3052,23.9776 11.1882,23.1136 11.5892,22.8736 C11.6672,22.8156 13.5132,21.6526 14.9342,23.3336 C15.0952,23.5926 16.1752,25.2966 17.2392,27.7776 C17.3372,27.9976 19.5632,33.1646 23.7682,34.2246 C24.3882,34.3856 25.9122,34.4446 26.8112,34.4446 L27.2112,34.4446 C28.5542,34.4056 30.7132,34.0636 32.8182,32.6226 C31.2002,34.8996 27.4982,38.6456 20.2462,38.6456 M27.0932,32.8586 C26.2732,32.8776 24.5492,32.7996 24.0902,32.6776 C22.4292,32.2576 21.1062,30.9736 20.1832,29.7336 C25.8292,29.4736 30.9172,29.5916 33.6192,29.7136 C31.4002,32.3206 28.6172,32.8196 27.0932,32.8586 M18.0242,3.6436 L22.5902,2.7206 L22.6292,2.7016 C22.6492,2.7016 23.8502,2.3796 25.2522,2.3796 C26.3322,2.3796 27.7762,2.5796 28.5152,3.5416 L28.5542,3.6006 L28.6322,3.6596 C28.7542,3.7806 29.5942,4.7586 28.1302,7.3226 C27.7692,7.8446 23.7252,13.8906 23.2462,19.1956 C23.1872,19.5176 23.0262,20.8366 23.8462,21.8576 C24.4082,22.5596 25.2872,22.8976 26.4102,22.8976 L26.5082,22.8976 C26.5872,22.8976 27.3882,22.8776 28.9702,22.3946 C28.9902,22.3946 31.0312,21.7546 32.9162,21.7546 C33.8392,21.7546 34.5772,21.9156 35.0402,22.2146 C35.1812,22.3366 36.5632,23.7966 34.9182,28.1626 C32.6762,28.0406 26.2492,27.8016 19.1392,28.1826 C18.7972,27.5816 18.6172,27.1806 18.6172,27.1616 C17.3962,24.3186 16.1942,22.4976 16.1552,22.4346 L16.1162,22.3756 C14.2552,20.1136 11.7102,20.8516 10.6502,21.5746 C10.0302,21.9746 8.9072,23.0976 8.6482,23.3376 C8.4672,23.4786 8.3502,23.4786 8.2672,23.4586 C7.8672,23.3806 7.3252,22.7366 7.1052,22.3166 C5.8842,19.8116 5.9822,17.2126 5.9822,17.1886 L5.9822,17.1496 C5.9822,14.2246 6.8852,12.0656 6.9052,12.0416 C8.4482,8.5156 8.6872,5.1116 8.6872,3.2906 C10.0502,3.6116 11.8522,3.8906 14.0742,3.8906 C15.3422,3.9066 16.6812,3.8236 18.0242,3.6436 M36.0252,20.9466 L36.0252,20.9466 C35.2642,20.4236 34.2432,20.1646 32.9632,20.1646 C30.8192,20.1646 28.6172,20.8636 28.5382,20.8876 C27.1952,21.2876 26.5552,21.3076 26.5362,21.3076 L26.4572,21.3076 C25.8372,21.3076 25.3782,21.1466 25.1342,20.8476 C24.7732,20.4086 24.8122,19.6856 24.8752,19.4466 L24.8952,19.3486 C25.3342,14.3386 29.4772,8.2296 29.5202,8.1706 L29.5592,8.1116 C31.5812,4.6056 30.1792,2.8656 29.7792,2.4656 C28.8562,1.3426 27.3172,0.7416 25.2952,0.7416 C23.7952,0.7416 22.4922,1.0636 22.2922,1.1226 L17.8432,2.0216 C16.5632,2.1826 15.2992,2.2616 14.1172,2.2616 C8.8132,2.2616 6.2292,0.6596 6.1862,0.6396 C5.5072,0.2196 4.8432,-0.0004 4.2232,-0.0004 C2.3232,-0.0004 1.2982,1.9436 1.0002,3.1256 C-0.4368,7.5496 0.0852,14.4566 0.1242,14.8996 C0.7642,26.5336 3.4892,30.6986 3.8072,31.1586 C8.4912,38.8266 16.6022,39.9686 18.0042,40.1096 L18.0042,45.6386 L12.5982,44.0716 L12.1382,45.6146 L15.6012,46.6156 L10.4342,48.2966 L10.9372,49.8196 L18.7272,47.2946 L26.5162,49.8196 L27.0192,48.2966 L21.8522,46.6156 L25.3152,45.6146 L24.8952,44.0716 L19.6262,45.6146 L19.6262,40.2086 C19.8262,40.2086 20.0852,40.2276 20.3282,40.2276 C26.1752,40.2276 29.9012,37.9036 32.0212,35.9636 C34.3212,33.8396 35.2052,31.7196 35.2442,31.6376 L36.4852,28.8336 L36.5042,28.7946 C38.6292,23.0276 36.3042,21.1466 36.0252,20.9466z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/checkmark.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-checkmark'].join(' '), 'data-tn': 'checkmark', viewBox: '0 0 250 250' },
                React.createElement('polygon', { points: '86.1,218.4 2.2,140.1 28.8,112 86.1,165.5 222.7,37.9 248.8,65.4 ' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/circle-check.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-circle-check'].join(' '), 'data-tn': 'circle-check', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M125.3-0.8C56.3-0.8,0.2,55.3,0.2,124.3s56.2,125.2,125.2,125.2s125.2-56.2,125.2-125.2S194.4-0.8,125.3-0.8z M125.3,240.5c-64.1,0-116.2-52.1-116.2-116.2S61.3,8.2,125.3,8.2s116.2,52.1,116.2,116.2S189.4,240.5,125.3,240.5z' }),
                React.createElement('polygon', { points: '106.2,145.1 74.6,113.8 62,126.6 105.8,169.9 195.1,88.1 182.9,74.9' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/close.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-close'].join(' '), 'data-tn': 'close', viewBox: '0 0 500 500' },
                React.createElement('path', { d: 'M274.1,250L495,470.9c6.7,6.7,6.7,17.5,0,24.1s-17.5,6.7-24.1,0L250,274.1L29.1,495 c-6.7,6.7-17.5,6.7-24.1,0s-6.7-17.5,0-24.1L225.9,250L5,29.1C-1.7,22.4-1.7,11.6,5,5s17.5-6.7,24.1,0L250,225.9L470.9,5 c6.7-6.7,17.5-6.7,24.1,0s6.7,17.5,0,24.1L274.1,250z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/email.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-email'].join(' '), 'data-tn': 'email', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M0,224V26h250v198H0z M239,213V37h-8.4L126.3,160.9L19.6,37H11v176H239z M126.1,144.3L216.4,37H34L126.1,144.3z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/facebook.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-facebook'].join(' '), 'data-tn': 'facebook', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M141.7,250V135.8H180l5.7-44.3h-44.2V63.2c0-13,3.6-21.5,21.9-21.5H187v-40C183,1.1,169.1,0,152.8,0c-34,0-57.2,20.8-57.2,58.7v32.8H57.6v44.3h38.3V250H141.7L141.7,250z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/hamburger-menu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-hamburger-menu'].join(' '), 'data-tn': 'hamburger-menu', viewBox: '-220.7 -160.7 500 500' },
                React.createElement('path', { d: 'M260.8,107.7h-463c-10.2,0-18.5-8.2-18.5-18.4s8.3-18.4,18.5-18.4h463 c10.2,0,18.5,8.2,18.5,18.4S271,107.7,260.8,107.7z M260.8-30h-463c-10.2,0-18.5-8.2-18.5-18.4s8.3-18.4,18.5-18.4h463 c10.2,0,18.5,8.2,18.5,18.4S271-30,260.8-30z M-202.2,208.6h463c10.2,0,18.5,8.2,18.5,18.4c0,10.1-8.3,18.4-18.5,18.4h-463 c-10.2,0-18.5-8.2-18.5-18.4C-220.7,216.8-212.4,208.6-202.2,208.6z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/heart-outlined.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-heart-outlined'].join(' '), 'data-tn': 'heart-outlined', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M29.2,129.3c-6.5-8.5-27.7-37.7-28.9-57.4C-0.9,51.8,4,35.7,15,24.1C30,8.1,51.4,6.3,59.8,6.3c1.3,0,2.2,0,2.8,0.1 c16.2,0.4,39.5,7.6,58.9,39.4l3.4,5.6l3.6-5.5c16.8-25.7,37.1-39,60.3-39.5c3,0,28.9-0.9,48,20.6c7.2,8.1,15.3,21.4,12.5,45.6 c-1.9,16.9-12.5,34.8-22.5,48.4c-11.8,16.1-90.2,110.3-101.9,124L29.2,129.3z M59.8,16c-7.2,0-25.6,1.2-37.8,14.7 C12.6,41.2,8.5,54,10,71.3C10.7,80.2,15,90,23.6,104c6.4,10.4,12.6,18.7,13.3,19.6l88,106.4l83.8-101c0,0,11.1-13.7,18.1-25.5 c6.2-10.5,12-22.5,13-31.3c1.7-15.7-1.6-29.1-10.2-38.6c-17.9-19.8-40-17.3-41-17.3C163,16.6,141.4,36,124.4,73.8 c-2.3-6.2-5.9-14.6-11-22.9C99.8,28.5,82.1,16.4,62.1,16.1l0,0C61.4,16,60.6,16,59.8,16z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/instagram.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-instagram'].join(' '), 'data-tn': 'instagram', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M32.2,0h186c17.6,0,32.1,14.5,32.1,32.2v186c0,17.7-14.5,32.1-32.1,32.1h-186C14.5,250.2,0,235.7,0,218.1v-186C0,14.5,14.5,0,32.2,0 M182.3,27.9c-6.2,0-11.3,5.1-11.3,11.3v27c0,6.2,5.1,11.3,11.3,11.3h28.3c6.2,0,11.3-5.1,11.3-11.3v-27c0-6.2-5.1-11.3-11.3-11.3H182.3z M221.9,105.8h-22c2.1,6.8,3.2,14,3.2,21.5c0,41.7-34.8,75.3-77.8,75.3s-77.8-33.7-77.8-75.3c0-7.5,1.1-14.7,3.2-21.5H27.7v105.7c0,5.5,4.5,10,10,10h174.2c5.5,0,10-4.5,10-10V105.8z M125.3,75.9c-27.8,0-50.2,21.8-50.2,48.6s22.4,48.7,50.2,48.7s50.2-21.8,50.2-48.7S153.1,75.9,125.3,75.9' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/logo-trade.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-logo-trade'].join(' '), 'data-tn': 'logo-trade', viewBox: '0 0 124 44' },
                React.createElement('polygon', { className: 'dibsvg-logo-trade-fill', points: '79.4003136 43.0832419 79.4003136 35.8335867 84.3411082 35.8335867 84.3411082 36.9539315 80.6644532 36.9539315 80.6644532 38.8346212 84.2654759 38.8346212 84.2654759 39.9534143 80.6644532 39.9534143 80.6644532 41.962897 84.3411082 41.962897 84.3411082 43.0832419' }),
                React.createElement('polygon', { className: 'dibsvg-logo-trade-fill', points: '32.605077 35.8337414 32.605077 36.9540862 34.789152 36.9540862 34.789152 43.0833966 36.0548351 43.0833966 36.0548351 36.9540862 38.2389102 36.9540862 38.2389102 35.8337414' }),
                React.createElement('polygon', { className: 'dibsvg-logo-trade-bar-fill', points: '90.7078029 40.6222074 116.947574 40.6222074 116.947574 38.2946212 90.7078029 38.2946212' }),
                React.createElement('polygon', { className: 'dibsvg-logo-trade-bar-fill', points: '0 40.6222074 26.2397715 40.6222074 26.2397715 38.2946212 0 38.2946212' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M72.2931943,39.4646212 C72.2931943,38.0634143 71.4272819,36.9539315 69.8173947,36.9539315 L68.4019906,36.9539315 L68.4019906,41.962897 L69.8173947,41.962897 C71.3856069,41.962897 72.2931943,40.8332419 72.2931943,39.4646212 L72.2931943,39.4646212 Z M67.1363075,43.0832419 L67.1363075,35.8335867 L69.8173947,35.8335867 C72.067841,35.8335867 73.5912913,37.3341039 73.5912913,39.4646212 C73.5912913,41.5935867 72.067841,43.0832419 69.8173947,43.0832419 L67.1363075,43.0832419 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M58.1393074,37.1173279 L56.8412105,40.5730175 L59.4358608,40.5730175 L58.1393074,37.1173279 Z M60.321839,43.0837072 L59.792413,41.6918107 L56.4846583,41.6918107 L55.9552323,43.0837072 L54.5166754,43.0837072 L57.3490272,35.834052 L58.928044,35.834052 L61.7603958,43.0837072 L60.321839,43.0837072 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M48.1237408,38.1053108 C48.1237408,37.4101384 47.6051195,36.9539315 46.8920151,36.9539315 L45.1617337,36.9539315 L45.1617337,39.2566901 L46.8920151,39.2566901 C47.6051195,39.2566901 48.1237408,38.8004832 48.1237408,38.1053108 Z M48.0156947,43.0832419 L46.4150687,40.377035 L45.1617337,40.377035 L45.1617337,43.0832419 L43.8960506,43.0832419 L43.8960506,35.8335867 L47.0633454,35.8335867 C48.4910976,35.8335867 49.4202943,36.7692763 49.4202943,38.1053108 C49.4202943,39.3994488 48.5775345,40.0946212 47.7131656,40.2358281 L49.4743173,43.0832419 L48.0156947,43.0832419 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M119.348668,26.8801384 L120.83353,26.8801384 C121.370674,26.8801384 121.719508,27.0151384 121.932513,27.2292763 C122.113105,27.4108281 122.208803,27.642035 122.208803,27.9601384 L122.208803,27.9756557 C122.208803,28.4116901 121.980362,28.722035 121.608375,28.8973798 L122.319936,29.937035 L121.165386,29.937035 L120.581937,29.0634143 L120.564958,29.0634143 L120.367388,29.0634143 L120.367388,29.937035 L119.348668,29.937035 L119.348668,26.8801384 Z M120.80266,28.3325522 C121.048079,28.3325522 121.1978,28.2285867 121.1978,28.0392763 L121.1978,28.0237591 C121.1978,27.832897 121.038818,27.7366901 120.810377,27.7366901 L120.367388,27.7366901 L120.367388,28.3325522 L120.80266,28.3325522 Z M117.823674,28.507897 L117.823674,28.4908281 C117.823674,26.9266901 119.087814,25.5922074 120.691527,25.5922074 C122.29524,25.5922074 123.543944,26.9111729 123.543944,28.4753108 L123.543944,28.4908281 C123.543944,30.0565177 122.279805,31.3894488 120.676092,31.3894488 C119.072378,31.3894488 117.823674,30.072035 117.823674,28.507897 Z M123.212088,28.4908281 L123.212088,28.4753108 C123.212088,27.0694488 122.130084,25.9103108 120.691527,25.9103108 C119.246796,25.9103108 118.15553,27.0865177 118.15553,28.4908281 L118.15553,28.507897 C118.15553,29.9137591 119.239078,31.072897 120.676092,31.072897 C122.122366,31.072897 123.212088,29.8966901 123.212088,28.4908281 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M117.049909,10.254966 L116.117626,16.7846212 L115.327346,16.7846212 C115.216212,15.1072074 114.702222,13.7851384 113.786917,12.819966 C112.870068,11.8563453 111.888392,11.3737591 110.840345,11.3737591 C110.196699,11.3737591 109.665729,11.5630694 109.247436,11.9432419 C108.8276,12.3234143 108.617682,12.7811729 108.617682,13.314966 C108.617682,13.7665177 108.708749,14.1885867 108.890884,14.5811729 C109.073019,14.9768626 109.478964,15.5106557 110.108718,16.1872074 C112.32212,18.579966 113.666522,20.2247936 114.145012,21.1216901 C114.621959,22.0201384 114.861204,22.9806557 114.861204,24.0032419 C114.861204,25.1111729 114.580284,26.1601384 114.018444,27.1485867 C113.456604,28.137035 112.618475,28.929966 111.502513,29.5258281 C110.386551,30.1216901 109.224283,30.4196212 108.017254,30.4196212 C107.203821,30.4196212 106.200536,30.262897 105.007398,29.9525522 C104.221748,29.7353108 103.632125,29.6282419 103.238529,29.6282419 C102.88815,29.6282419 102.613405,29.677897 102.417378,29.7803108 C102.219808,29.8811729 102.002172,30.0937591 101.764471,30.4196212 L100.975734,30.4196212 L102.016064,23.3856557 L102.696754,23.3856557 C103.187593,25.1003108 103.64756,26.3230694 104.075114,27.0539315 C104.502668,27.7832419 105.073769,28.3651384 105.788417,28.7965177 C106.503065,29.2294488 107.189929,29.4451384 107.849011,29.4451384 C108.620769,29.4451384 109.258241,29.2030694 109.762971,28.7173798 C110.2677,28.2316901 110.519293,27.6513453 110.519293,26.9747936 C110.519293,26.3137591 110.354137,25.672897 110.025368,25.0537591 C109.695056,24.4346212 108.935646,23.4710005 107.744052,22.1613453 C106.103294,20.3737591 105.022833,18.9927246 104.502668,18.0166901 C104.135311,17.3106557 103.953176,16.5037591 103.953176,15.5991039 C103.953176,14.0722074 104.504212,12.7997936 105.606282,11.7818626 C106.708352,10.7639315 108.256499,10.254966 110.250722,10.254966 C111.121265,10.254966 112.189378,10.4163453 113.453517,10.7375522 C114.084815,10.8989315 114.591089,10.9780694 114.96925,10.9780694 C115.517198,10.9780694 115.958644,10.7375522 116.296674,10.254966 L117.049909,10.254966 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M93.6522139,0.55234531 L89.9277099,13.243897 C90.9850183,12.045966 91.8679095,11.2483798 92.5779268,10.8511384 C93.2864007,10.453897 94.0566151,10.2552763 94.8854832,10.2552763 C96.4922833,10.2552763 97.6931387,10.8635522 98.489593,12.0816557 C99.2860472,13.2997591 99.6842743,14.7025177 99.6842743,16.293035 C99.6842743,20.0947591 98.3398719,23.4868281 95.6526106,26.4707936 C93.2663349,29.1025177 90.5512904,30.4183798 87.5074769,30.4183798 C85.2446825,30.4183798 82.8522327,29.7402763 80.3301276,28.3840694 L86.840678,6.11062117 C87.1432071,5.05079359 87.3145374,4.31062117 87.3562123,3.88855221 C87.3562123,3.52700048 87.2049477,3.23993152 86.9024186,3.02889703 C86.4779517,2.72941428 85.8358491,2.6021729 84.9730237,2.64406945 L85.1520715,1.81389703 L92.3587476,0.55234531 L93.6522139,0.55234531 Z M85.4252738,28.5935522 C86.0550283,29.0171729 86.6245857,29.2282074 87.1324025,29.2282074 C87.8424198,29.2282074 88.438217,29.0807936 88.9213375,28.7844143 C89.6838344,28.3049315 90.4849192,27.4375177 91.3215048,26.1806212 C92.159634,24.9252763 92.8588467,23.4076901 93.4222301,21.630966 C93.9840699,19.8526901 94.2649898,18.0821729 94.2649898,16.3178626 C94.2649898,15.3170005 94.0550716,14.5535522 93.6383223,14.0321729 C93.2200295,13.5107936 92.7353655,13.2485522 92.1858738,13.2485522 C91.2705688,13.2485522 90.472571,13.7420005 89.793424,14.7257936 C89.3349998,15.3635522 88.8379876,16.7182074 88.3023876,18.7882074 L85.4252738,28.5935522 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M78.995295,10.254966 L74.3138111,25.1484143 C74.0560439,26.0003108 73.9263886,26.5589315 73.9263886,26.8242763 C73.9263886,26.9856557 73.9881292,27.1346212 74.113154,27.2742763 C74.2381788,27.4123798 74.3709212,27.4822074 74.5098376,27.4822074 C74.7459956,27.4822074 74.9821535,27.372035 75.2183114,27.1532419 C75.8434354,26.6116901 76.5935842,25.6325522 77.4687577,24.2142763 L78.1864926,24.6534143 C76.0548971,28.497035 73.7890157,30.4196212 71.3888483,30.4196212 C70.4704563,30.4196212 69.7403733,30.1635867 69.1970556,29.6515177 C68.6521945,29.1410005 68.3805357,28.4923798 68.3805357,27.7072074 C68.3805357,27.1858281 68.5117346,26.5216901 68.7756758,25.717897 L71.9985371,15.6037591 C72.3072403,14.6308281 72.4615919,13.8968626 72.4615919,13.4034143 C72.4615919,13.0930694 72.3195885,12.8184143 72.037125,12.577897 C71.7531181,12.3373798 71.3656956,12.217897 70.873314,12.217897 C70.6495042,12.217897 70.3809324,12.2241039 70.0675987,12.2396212 L70.3546926,11.4094488 L77.6956546,10.254966 L78.995295,10.254966 Z M77.2866228,0.552034966 C78.1633399,0.552034966 78.9011405,0.8561729 79.5015682,1.46444876 C80.1004524,2.07272462 80.4014381,2.80824186 80.4014381,3.67255221 C80.4014381,4.53531083 80.0973654,5.27082807 79.4907636,5.87910393 C78.8826183,6.48893152 78.1479047,6.79151772 77.2866228,6.79151772 C76.4392326,6.79151772 75.7122365,6.48893152 75.1056348,5.87910393 C74.4974895,5.27082807 74.1934168,4.53531083 74.1934168,3.67255221 C74.1934168,2.80824186 74.4944024,2.07272462 75.0948302,1.46444876 C75.6937144,0.8561729 76.4253409,0.552034966 77.2866228,0.552034966 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M69.8085967,0.551414276 L62.683727,24.1515867 C62.2299333,25.6288281 62.0045799,26.5210694 62.0045799,26.8298626 C62.0045799,26.9865867 62.058603,27.1215867 62.1712797,27.2348626 C62.2824128,27.3481384 62.4012635,27.4040005 62.5262883,27.4040005 C62.7639898,27.4040005 63.0356486,27.282966 63.3428083,27.0424488 C63.8583426,26.6467591 64.4850101,25.8972763 65.2243542,24.7924488 L65.97759,25.195897 C64.0018896,28.677966 61.8317062,30.4190005 59.4639527,30.4190005 C58.62428,30.4190005 57.9760033,30.1971039 57.5206661,29.7548626 C57.0653288,29.3126212 56.838432,28.7477936 56.838432,28.0588281 C56.838432,27.3977936 57.0205669,26.4574488 57.3848366,25.2346901 L58.0485485,23.0777936 C56.2904838,26.1874488 54.7654901,28.255897 53.4720237,29.2815867 C52.488804,30.0403798 51.5318241,30.4190005 50.6057145,30.4190005 C49.5499496,30.4190005 48.6608844,29.9891729 47.9369754,29.1310694 C47.2146099,28.272966 46.8518837,27.0207246 46.8518837,25.3727936 C46.8518837,23.2764143 47.319569,21.2064143 48.2533962,19.165897 C49.1887669,17.1238281 50.2676845,15.4215867 51.4932362,14.0560694 C52.7172444,12.6905522 53.885686,11.7160694 54.998561,11.1310694 C56.1083489,10.5476212 57.2027018,10.2543453 58.2800759,10.2543453 C58.8311111,10.2543453 59.3234927,10.3707246 59.7556772,10.6003798 C60.1878616,10.8315867 60.6786997,11.262966 61.2312784,11.8960694 L62.8766665,6.66055221 C63.2965028,5.34313841 63.506421,4.39813841 63.506421,3.82555221 C63.506421,3.48106945 63.362874,3.18779359 63.0773235,2.94572462 C62.7902296,2.70210393 62.4089811,2.58106945 61.9320347,2.58106945 C61.7082249,2.58106945 61.430392,2.60279359 61.0969926,2.64313841 L61.2760404,1.81451772 L68.4919776,0.551414276 L69.8085967,0.551414276 Z M60.368453,13.917966 C60.368453,13.0583108 60.1971227,12.4314143 59.8544622,12.0372763 C59.5118017,11.6431384 59.112031,11.4460694 58.6566938,11.4460694 C58.1998131,11.4460694 57.7074315,11.6788281 57.179549,12.1427936 C56.165459,13.0443453 55.1066071,14.8583108 53.9999061,17.5846901 C52.8947487,20.3110694 52.34217,22.6045177 52.34217,24.465035 C52.34217,25.1415867 52.4625642,25.6412419 52.7064398,25.9655522 C52.9487718,26.2898626 53.2188871,26.4512419 53.5198727,26.4512419 C54.0184283,26.4512419 54.5185275,26.2262419 55.0170832,25.7746901 C56.2302867,24.7040005 57.4249681,22.8621039 58.6026707,20.2474488 C59.7803734,17.6343453 60.368453,15.5240005 60.368453,13.917966 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M46.8691711,5.09672462 L45.1080193,10.831897 L47.4618812,10.831897 L46.7256241,13.2494832 L44.3378049,13.2494832 L40.5222334,25.6679315 C40.2783579,26.4391384 40.1564201,27.0241384 40.1564201,27.4244832 C40.1564201,27.5594832 40.2181608,27.6758626 40.3447291,27.7751729 C40.4712974,27.8729315 40.6102138,27.9225867 40.7645654,27.9225867 C41.0022669,27.9225867 41.2476859,27.8232763 41.499279,27.6262074 C42.1429252,27.1327591 42.8915304,26.2715522 43.7435512,25.0441384 L44.4983305,25.5096557 C43.5290025,27.2025867 42.462433,28.443966 41.2986219,29.2337936 C40.1332674,30.0236212 38.989522,30.4193108 37.8673859,30.4193108 C36.9119496,30.4193108 36.1726054,30.1772419 35.6462665,29.6946557 C35.1199275,29.2105177 34.8575298,28.5975867 34.8575298,27.8558626 C34.8575298,27.0365522 35.0535563,25.986035 35.4456094,24.7012074 L39.0219359,13.2494832 L36.32387,13.2494832 L36.7220971,11.6900005 C38.4276822,11.0305177 39.9110011,10.2577591 41.1720536,9.37327634 C42.4331062,8.48879359 43.9519259,7.0627591 45.7300563,5.09672462 L46.8691711,5.09672462 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M33.3110812,10.254966 L32.3787975,16.7846212 L31.5885173,16.7846212 C31.4773842,15.1072074 30.9633934,13.7851384 30.0480884,12.819966 C29.1312399,11.8563453 28.1495638,11.3737591 27.1015164,11.3737591 C26.4578703,11.3737591 25.9269008,11.5630694 25.5086079,11.9432419 C25.0887716,12.3234143 24.8788534,12.7811729 24.8788534,13.314966 C24.8788534,13.7665177 24.9699209,14.1885867 25.1520557,14.5811729 C25.3341906,14.9768626 25.7401353,15.5106557 26.3698898,16.1872074 C28.5832917,18.579966 29.9276942,20.2247936 30.4061841,21.1216901 C30.8831305,22.0201384 31.1223755,22.9806557 31.1223755,24.0032419 C31.1223755,25.1111729 30.8414556,26.1601384 30.2796158,27.1485867 C29.717776,28.137035 28.8796468,28.929966 27.7636848,29.5258281 C26.6477227,30.1216901 25.4854552,30.4196212 24.2784257,30.4196212 C23.4649928,30.4196212 22.4617074,30.262897 21.2685696,29.9525522 C20.4829199,29.7353108 19.8932968,29.6282419 19.4997003,29.6282419 C19.1493222,29.6282419 18.8745763,29.677897 18.6785498,29.7803108 C18.4809797,29.8811729 18.263344,30.0937591 18.0256425,30.4196212 L17.2369059,30.4196212 L18.2772356,23.3856557 L18.9579262,23.3856557 C19.4487642,25.1003108 19.908732,26.3230694 20.3362859,27.0539315 C20.7638399,27.7832419 21.3349408,28.3651384 22.0495887,28.7965177 C22.7642365,29.2294488 23.4511012,29.4451384 24.1101825,29.4451384 C24.8819405,29.4451384 25.5194125,29.2030694 26.0241423,28.7173798 C26.528872,28.2316901 26.7804651,27.6513453 26.7804651,26.9747936 C26.7804651,26.3137591 26.6153089,25.672897 26.28654,25.0537591 C25.9562276,24.4346212 25.1968177,23.4710005 24.0052234,22.1613453 C22.3644659,20.3737591 21.2840047,18.9927246 20.7638399,18.0166901 C20.3964831,17.3106557 20.2143482,16.5037591 20.2143482,15.5991039 C20.2143482,14.0722074 20.7653834,12.7997936 21.8674538,11.7818626 C22.9695242,10.7639315 24.5176707,10.254966 26.5118933,10.254966 C27.3824363,10.254966 28.4505494,10.4163453 29.714689,10.7375522 C30.345987,10.8989315 30.8522602,10.9780694 31.2304216,10.9780694 C31.7783698,10.9780694 32.2198154,10.7375522 32.5578454,10.254966 L33.3110812,10.254966 Z' }),
                React.createElement('path', { className: 'dibsvg-logo-trade-fill', d: 'M18.3369697,0.623879793 L11.2136435,24.6492246 C10.8493737,25.9076729 10.6672389,26.7083626 10.6672389,27.0466384 C10.6672389,27.386466 10.7968942,27.7371557 11.0562049,28.0971557 C11.3155156,28.4587074 11.5948919,28.6930177 11.8974211,28.798535 C12.1984067,28.9040522 13.1059941,29.0002591 14.6186397,29.0840522 L14.3886559,29.8428453 L0,29.8428453 L0.231527395,29.0840522 C1.66082318,29.0561212 2.65639098,28.9366384 3.21668728,28.7240522 C3.77698357,28.511466 4.23695133,28.1654315 4.59350352,27.684397 C4.95159922,27.2033626 5.35445689,26.1916384 5.80207652,24.6492246 L9.99117886,10.3795694 C10.6518037,8.21181083 10.9960078,7.06353497 11.0253346,6.93629359 C11.113315,6.57008669 11.1580769,6.22560393 11.1580769,5.90129359 C11.1580769,5.27284531 10.9635939,4.77319014 10.5777149,4.40232807 C10.1902924,4.031466 9.6377137,3.8452591 8.91997878,3.8452591 C8.56805714,3.8452591 7.87193144,3.9026729 6.83160167,4.01439703 L6.65101031,3.221466 L17.446361,0.623879793 L18.3369697,0.623879793 Z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/logo.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-logo'].join(' '), 'data-tn': 'logo', title: '1stdibs.com', viewBox: '543 138 2021.4 500' },
                React.createElement('path', { d: 'M843.7,139.2L726.9,531c-6,20.5-9,33.6-9,39.1c0,5.5,2.1,11.3,6.4,17.1c4.2,5.9,8.8,9.7,13.8,11.4 c4.9,1.7,19.8,3.3,44.6,4.7l-3.8,12.4H543l3.8-12.4c23.4-0.5,39.8-2.4,48.9-5.9c9.2-3.5,16.7-9.1,22.6-17 c5.9-7.9,12.5-24.4,19.8-49.5l68.7-232.7c10.8-35.4,16.5-54.1,17-56.2c1.4-6,2.2-11.6,2.2-16.9c0-10.3-3.2-18.4-9.5-24.5 c-6.3-6-15.4-9.1-27.2-9.1c-5.8,0-17.2,0.9-34.3,2.8l-2.9-12.9l177-42.4H843.7z' }),
                React.createElement('path', { d: 'M1089.2,296.3l-15.3,106.5h-12.9c-1.8-27.4-10.3-48.9-25.3-64.6c-15-15.7-31.1-23.6-48.3-23.6 c-10.5,0-19.2,3.1-26.1,9.3c-6.9,6.2-10.3,13.7-10.3,22.4c0,7.3,1.5,14.2,4.5,20.7c3,6.4,9.6,15.2,20,26.2 c36.3,39,58.3,65.9,66.2,80.5c7.8,14.6,11.7,30.3,11.7,47c0,18.1-4.6,35.2-13.8,51.3c-9.2,16.1-23,29-41.3,38.8 c-18.3,9.7-37.3,14.6-57.1,14.6c-13.3,0-29.8-2.5-49.4-7.6c-12.9-3.5-22.6-5.3-29-5.3c-5.8,0-10.2,0.8-13.5,2.5 c-3.2,1.7-6.8,5.1-10.7,10.4h-12.9l17.1-114.7h11.2c8,28,15.6,47.9,22.6,59.8c7,11.9,16.4,21.4,28.1,28.4 c11.7,7.1,23,10.6,33.8,10.6c12.6,0,23.1-4,31.4-11.9c8.3-7.9,12.4-17.4,12.4-28.4c0-10.8-2.7-21.2-8.1-31.3 c-5.4-10.1-17.9-25.8-37.4-47.2c-26.9-29.1-44.6-51.7-53.1-67.6c-6-11.5-9-24.7-9-39.4c0-24.9,9-45.7,27.1-62.3 c18.1-16.6,43.5-24.9,76.1-24.9c14.3,0,31.8,2.6,52.5,7.9c10.4,2.6,18.7,3.9,24.9,3.9c9,0,16.2-3.9,21.8-11.8H1089.2z' }),
                React.createElement('path', { d: 'M1311.5,212.1l-28.9,93.5h38.6l-12.1,39.4H1270l-62.6,202.6c-4,12.6-6,22.1-6,28.6c0,2.2,1,4.1,3.1,5.7 c2.1,1.6,4.4,2.4,6.9,2.4c3.9,0,7.9-1.6,12-4.8c10.6-8.1,22.8-22.1,36.8-42.1l12.4,7.6c-15.9,27.6-33.4,47.9-52.5,60.7 c-19.1,12.9-37.9,19.3-56.3,19.3c-15.6,0-27.8-3.9-36.4-11.8c-8.6-7.9-12.9-17.9-12.9-30c0-13.3,3.2-30.5,9.7-51.4l58.6-186.8 h-44.2l6.5-25.4c28-10.8,52.3-23.4,73-37.8c20.7-14.4,45.6-37.7,74.7-69.7H1311.5z' }),
                React.createElement('path', { d: 'M1687.6,138l-116.8,384.9c-7.4,24.1-11.1,38.6-11.1,43.7c0,2.5,0.9,4.7,2.7,6.6c1.8,1.8,3.8,2.8,5.8,2.8 c3.9,0,8.3-2,13.4-5.9c8.5-6.5,18.7-18.7,30.9-36.7l12.4,6.6c-32.4,56.8-68,85.2-106.8,85.2c-13.8,0-24.4-3.6-31.9-10.8 c-7.5-7.2-11.2-16.4-11.2-27.7c0-10.8,3-26.1,9-46.1l10.9-35.2c-28.8,50.7-53.8,84.4-75,101.2c-16.1,12.4-31.8,18.6-47,18.6 c-17.3,0-31.9-7-43.7-21c-11.9-14-17.8-34.4-17.8-61.3c0-34.2,7.7-67.9,23-101.2c15.3-33.3,33-61.1,53.1-83.3 c20.1-22.3,39.2-38.2,57.5-47.7c18.2-9.5,36.2-14.3,53.8-14.3c9.1,0,17.1,1.9,24.2,5.6c7.1,3.8,15.1,10.8,24.2,21.1l27-85.4 c6.9-21.5,10.3-36.9,10.3-46.2c0-5.6-2.4-10.4-7-14.3c-4.7-4-11-5.9-18.8-5.9c-3.7,0-8.2,0.3-13.7,1l2.9-13.5L1666,138H1687.6z M1532.8,356c0-14-2.8-24.2-8.4-30.7c-5.6-6.4-12.2-9.7-19.7-9.7c-7.5,0-15.6,3.8-24.2,11.4c-16.6,14.7-34,44.3-52.1,88.8 c-18.1,44.5-27.2,81.9-27.2,112.2c0,11,2,19.2,6,24.5c4,5.3,8.4,7.9,13.3,7.9c8.2,0,16.4-3.7,24.6-11 c19.9-17.5,39.5-47.5,58.8-90.1C1523.1,416.6,1532.8,382.2,1532.8,356z' }),
                React.createElement('path', { d: 'M1810.2,138c14.4,0,26.5,5,36.3,14.9c9.8,9.9,14.8,21.9,14.8,36c0,14.1-5,26.1-14.9,36 c-10,9.9-22,14.9-36.1,14.9c-13.9,0-25.8-5-35.8-14.9c-10-9.9-14.9-21.9-14.9-36c0-14.1,4.9-26.1,14.8-36 C1784.1,143,1796.1,138,1810.2,138z M1838.2,296.3l-76.7,242.9c-4.2,13.9-6.4,23-6.4,27.3c0,2.6,1,5.1,3.1,7.3 c2.1,2.3,4.2,3.4,6.5,3.4c3.9,0,7.7-1.8,11.6-5.4c10.2-8.8,22.5-24.8,36.9-47.9l11.8,7.2c-35,62.7-72.1,94-111.5,94 c-15,0-27-4.2-35.9-12.5c-8.9-8.3-13.4-18.9-13.4-31.7c0-8.5,2.2-19.3,6.5-32.4l52.8-165c5.1-15.9,7.6-27.8,7.6-35.9 c0-5.1-2.3-9.5-7-13.5c-4.7-3.9-11-5.9-19.1-5.9c-3.7,0-8.1,0.1-13.2,0.3l4.7-13.5l120.4-18.8H1838.2z' }),
                React.createElement('path', { d: 'M2078.5,138l-61.1,207c17.3-19.5,31.8-32.5,43.4-39c11.6-6.5,24.2-9.7,37.9-9.7c26.3,0,46,9.9,59.1,29.8 c13.1,19.9,19.6,42.8,19.6,68.7c0,62-22,117.3-66.1,166c-39.1,42.9-83.6,64.4-133.5,64.4c-37.1,0-76.3-11.1-117.7-33.2l106.8-363.3 c5-17.3,7.8-29.3,8.5-36.2c0-5.9-2.5-10.6-7.4-14c-6.9-4.9-17.5-7-31.6-6.3l2.9-13.5l118.2-20.6H2078.5z M1943.6,595.3 c10.3,6.9,19.7,10.4,28,10.4c11.6,0,21.4-2.4,29.3-7.3c12.5-7.8,25.6-22,39.4-42.5c13.7-20.5,25.2-45.2,34.4-74.2 c9.2-29,13.8-57.9,13.8-86.6c0-16.3-3.4-28.8-10.3-37.3c-6.9-8.5-14.8-12.8-23.8-12.8c-15,0-28.1,8-39.2,24.1 c-7.5,10.4-15.7,32.5-24.4,66.3L1943.6,595.3z' }),
                React.createElement('path', { d: 'M2462.1,296.3l-15.3,106.5h-12.9c-1.8-27.4-10.3-48.9-25.3-64.6c-15-15.7-31.1-23.6-48.3-23.6 c-10.5,0-19.2,3.1-26.1,9.3c-6.9,6.2-10.3,13.7-10.3,22.4c0,7.3,1.5,14.2,4.5,20.7c3,6.4,9.6,15.2,20,26.2 c36.3,39,58.3,65.9,66.2,80.5c7.8,14.6,11.7,30.3,11.7,47c0,18.1-4.6,35.2-13.8,51.3c-9.2,16.1-23,29-41.3,38.8 c-18.3,9.7-37.3,14.6-57.1,14.6c-13.3,0-29.8-2.5-49.4-7.6c-12.9-3.5-22.6-5.3-29-5.3c-5.8,0-10.2,0.8-13.5,2.5 c-3.2,1.7-6.8,5.1-10.7,10.4h-12.9l17.1-114.7h11.2c8,28,15.6,47.9,22.6,59.8c7,11.9,16.4,21.4,28.1,28.4 c11.7,7.1,23,10.6,33.8,10.6c12.6,0,23.1-4,31.4-11.9c8.3-7.9,12.4-17.4,12.4-28.4c0-10.8-2.7-21.2-8.1-31.3 c-5.4-10.1-17.9-25.8-37.4-47.2c-26.9-29.1-44.6-51.7-53.1-67.6c-6-11.5-9-24.7-9-39.4c0-24.9,9-45.7,27.1-62.3 c18.1-16.6,43.5-24.9,76.1-24.9c14.3,0,31.8,2.6,52.5,7.9c10.4,2.6,18.7,3.9,24.9,3.9c9,0,16.2-3.9,21.8-11.8H2462.1z' }),
                React.createElement('path', { d: 'M2471.2,591.3V591c0-25.4,20.6-47,46.7-47c26.1,0,46.5,21.4,46.5,46.7v0.3c0,25.4-20.6,47-46.7,47 C2491.5,638,2471.2,616.6,2471.2,591.3z M2559,591v-0.3c0-22.8-17.6-41.6-41.1-41.6c-23.6,0-41.3,19.1-41.3,41.8v0.3 c0,22.8,17.6,41.6,41.1,41.6C2541.2,632.9,2559,613.8,2559,591z M2496,564.9h24.2c8.8,0,14.4,2.2,17.9,5.7c3,3,4.5,6.7,4.5,11.8 v0.3c0,7.1-3.7,12.1-9.8,14.9l11.6,16.9h-18.8l-9.5-14.2h-0.3h-3.2v14.2H2496V564.9z M2519.7,588.4c4,0,6.4-1.7,6.4-4.8v-0.3 c0-3.1-2.6-4.6-6.3-4.6h-7.2v9.7H2519.7z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/magnifying-glass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-magnifying-glass'].join(' '), 'data-tn': 'magnifying-glass', viewBox: '0 0 518 518' },
                React.createElement('path', { d: 'M494.2,470.1l-158-160.6c25.1-32.4,40.1-73.2,40.1-117.7C376.4,86.4,292.3,1,188.7,1C85,1,0.9,86.4,0.9,191.8s84,190.8,187.7,190.8c47.9,0,91.5-18.4,124.7-48.4L470.6,494c6.5,6.6,17.1,6.6,23.6,0C500.7,487.4,500.7,476.7,494.2,470.1z M188.8,348.8c-88.7,0-156.4-68.4-156.4-158c0-89.6,67.7-158,156.4-158s156.4,68.5,156.4,158S277.5,348.8,188.8,348.8z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/mask.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-mask'].join(' '), 'data-tn': 'mask', viewBox: '0 -300 1060 1060' },
                React.createElement('path', { d: 'M1044.6,5c-47,44.5-253.2,94.9-330,115.2C637.2,140.8,572,176.4,530,216.9c-42-40.5-107.2-76.1-184.6-96.6 C268.5,99.9,62.3,49.6,15.3,5c-40-37.8,9.4,148.4,21.3,186.3C98.8,388.4,142.1,389.4,268.5,411c70.6,12.1,146.6,12.3,206-1.6 c26.6-15.4,23.3-89.8,55.5-89.8c32.3,0,28.9,74.4,55.5,89.8c59.4,13.9,135.4,13.7,206,1.6c126.3-21.7,169.7-22.6,231.8-219.7 C1035.3,153.5,1084.6-32.8,1044.6,5z M441.6,306.6c-11.7,44.2-89,62.1-172.8,39.7c-83.5-22.1-142-75.9-130.3-120.2 c11.7-44.1,89.2-61.9,172.8-39.7C395.1,208.6,453.3,262.4,441.6,306.6z M793,346.3c-83.7,22.5-161,4.5-172.7-39.7 c-11.7-44.2,46.6-98,130.3-120.2c83.6-22.2,161-4.4,172.7,39.7C935,270.3,876.5,324.2,793,346.3z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/phone.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-phone'].join(' '), 'data-tn': 'phone', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M199.1,248.7l-0.2,0c-24.3-0.7-51.7-13.1-81.5-36.6c-20.9-16.5-35.2-32.6-37.1-34.7C35.6,137,9.4,87.5,8.3,85.4l-0.1-0.3C-5.9,53.3,11.2,32.7,12,31.9l0.2-0.2l19.6-19.8c4.2-3.6,9.6-8,11.8-8.9C46.7,1.6,49.9,1,53,1c9.8,0,16.5,6.2,16.7,6.4l0.1,0.1l29.9,29.9c6.9,6.4,10.3,13.2,10.2,20.3c-0.2,10-7.6,16.4-8,16.7l-13.7,12c-7.9,5.6-2.6,16.9-1.8,18.5c23.3,35.2,60.1,58.1,60.5,58.4c4,2.5,7.8,3.8,11.5,3.8c3.8,0,6.2-1.4,6.7-1.8l16.6-15.6c4.5-3.4,9.2-5.1,14.2-5.1c10.1,0,17.4,7.3,18.6,8.6l26.9,25.2c10.6,7.9,12.9,20.4,6.2,34.3c-1.1,2.4-4.3,6.3-5.3,7.5l-0.1,0.1l-13.6,15.3C216.3,248.3,200.8,248.7,199.1,248.7z M16.3,81.4c1.5,2.8,27.6,51.1,70.2,89.4l0.4,0.4c0.1,0.2,14.9,17.1,36.2,33.9c19.4,15.3,48.3,33.8,76,34.6l0,0c0.5,0,13.2-0.1,23.1-10.3l13.3-15c1.6-2,3.6-4.7,4.1-5.6c3.3-7,5.4-16.7-3.6-23.3l-0.4-0.4l-27.5-25.8c0,0-5.3-5.8-12-5.8c-2.9,0-5.8,1.1-8.6,3.2l-16.7,15.6c-0.5,0.4-5,3.7-12.3,3.7c-5.4,0-10.8-1.7-16.2-5.2c-1.5-0.9-39-24.3-63.3-61.2l-0.2-0.4c-3.6-6.8-7.3-21.7,4.3-30.1l13.3-11.6c0.1-0.1,4.7-4.2,4.8-10.1c0.1-4.4-2.4-8.9-7.3-13.5l-0.1-0.1L63.6,13.9C63.2,13.6,59,10,53,10c-2,0-4,0.4-5.9,1.2c-1.2,0.6-5.7,4.3-9.3,7.3L18.7,37.8C17.5,39.4,5.1,55.8,16.3,81.4z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/pinterest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-pinterest'].join(' '), 'data-tn': 'pinterest', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M130.7,2C63.6,2,29.9,50,29.9,90c0,24.3,9.2,45.8,28.9,53.7c3.3,1.3,6.2,0,7.1-3.5c0.8-2.5,2.1-8.9,2.9-11.4c1-3.5,0.8-4.8-2.1-7.7c-5.6-6.7-9.4-15.4-9.4-27.7c0-35.6,26.6-67.6,69.5-67.6c37.9,0,58.7,23.1,58.7,53.9c0,40.8-17.9,74.9-44.9,74.9c-14.6,0-25.8-12.1-22.1-27c4.2-17.9,12.5-37,12.5-50.1c0-11.7-6.2-21.2-19.1-21.2c-15,0-27.2,15.8-27.2,36.6c0,13.3,4.6,22.3,4.6,22.3s-15.6,65.5-18.1,76.8c-5.2,22.7-0.8,50.7-0.6,53.5c0.2,1.7,2.3,2.1,3.3,0.8c1.3-1.9,19.5-24.1,25.6-46.2c1.7-6.2,9.8-38.9,9.8-38.9c4.8,9.4,19.3,17.5,34.5,17.5c45.3,0,76.1-41.2,76.1-96.7C220,40.7,184.6,2,130.7,2z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/twitter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-twitter'].join(' '), 'data-tn': 'twitter', viewBox: '0 -40 613 613' },
                React.createElement('path', { d: 'M0,441.8h29.9c60.4,0,113.8-16.8,160.1-50c-53.7-1.2-99.2-39-120.2-91.2c5.8,3.3,13.7,5.2,23.2,5.2c3.9,0,10.4-1,18.9-2.7 c8.2-1.5,14-2.5,17.4-2.5c-60.1-10.1-105-60.7-105-123c17.4,7,22.3,9.4,36.9,12.1c7.3,1.5,15,2.1,22.9,2.1 c-35.1-22-59.8-61.9-59.8-101.3c0-30.2,5.2-48.2,19.9-68.7c60.7,78.5,154.6,127.9,255,134.9c0-3.9-0.4-9.2-0.6-15.6 c-0.4-6.4-0.6-11-0.6-14.3c0-45.5,25.4-87.5,63.5-110.1C380.7,5.5,400.8,0,422.3,0c34.8,0,67.1,13.5,97,40.6 c17-2.1,33-8.2,55.2-18.3c11-5.2,18.9-8.6,23.5-10.4c-9.4,27.1-28.1,46.7-60.1,68.9c29.6-3.1,54.6-10.1,75-20.7 c-13.1,22.9-32.6,45.1-58.6,66.8v15c0,54.9-15.2,112.3-42.4,165.6c-27.1,53.3-71.1,101-122.6,136.1S268.5,500,194.3,500 C123.8,500,58.9,480.5,0,441.8z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/upload-failed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-upload-failed'].join(' '), 'data-tn': 'upload-failed', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M124.5,249.3c-68.8,0-124.8-56-124.8-124.8S55.7-0.3,124.5-0.3s124.8,56,124.8,124.8S193.3,249.3,124.5,249.3z M124.5,9.7C61.2,9.7,9.7,61.2,9.7,124.5c0,63.3,51.5,114.8,114.8,114.8c63.3,0,114.8-51.5,114.8-114.8C239.3,61.2,187.8,9.7,124.5,9.7z' }),
                React.createElement('path', { d: 'M125.1,197.2c-6.2,0-11.1-4.9-11.1-11.1c0-6.2,4.9-11.3,11.1-11.3s11.3,5.1,11.3,11.3C136.5,192.3,131.4,197.2,125.1,197.2z M126.7,155.5h-3.1c-1.4-34-8.4-77.7-8.4-84.7c0-6.2,4.1-11.9,10.1-11.9c6.1,0,10.1,5.7,10.1,11.9C135.5,77.6,128.8,121.1,126.7,155.5z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-visit-tracking/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackPreRegistrationPageVisit = exports.clearSourceAttribution = exports.getSourceAttribution = exports.VisitorTracking = exports.VisitCountModel = undefined;

var _visitCountModel = __webpack_require__("./node_modules/dibs-visit-tracking/dist/visitCountModel.js");

var _visitCountModel2 = _interopRequireDefault(_visitCountModel);

var _visitorTracking = __webpack_require__("./node_modules/dibs-visit-tracking/dist/visitorTracking.js");

var _visitorTracking2 = _interopRequireDefault(_visitorTracking);

var _sourceAttribution = __webpack_require__("./node_modules/dibs-visit-tracking/dist/sourceAttribution.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.VisitCountModel = _visitCountModel2.default;
exports.VisitorTracking = _visitorTracking2.default;
exports.getSourceAttribution = _sourceAttribution.getSourceAttribution;
exports.clearSourceAttribution = _sourceAttribution.clearSourceAttribution;
exports.trackPreRegistrationPageVisit = _sourceAttribution.trackPreRegistrationPageVisit;

/***/ }),

/***/ "./node_modules/dibs-visit-tracking/dist/sourceAttribution.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSourceAttribution = getSourceAttribution;
exports.clearSourceAttribution = clearSourceAttribution;
exports.trackPreRegistrationPageVisit = trackPreRegistrationPageVisit;

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _dibsBrowserStorage2 = _interopRequireDefault(_dibsBrowserStorage);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _visitCountConstants = __webpack_require__("./node_modules/dibs-visit-tracking/dist/visitCountConstants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MASQUERADE_BUYER = _dibsCookieJar.cookieJarConstants.MASQUERADE_BUYER;


function prepareTimeNr(number) {
    var num = Math.abs(Math.floor(number));
    return (num < 10 ? '0' : '') + num;
};

function getDateTime() {
    var now = new Date();
    var timezoneOffset = -now.getTimezoneOffset();
    var dif = timezoneOffset >= 0 ? '+' : '-';

    var date = now.getFullYear() + '-' + prepareTimeNr(now.getMonth() + 1) + '-' + prepareTimeNr(now.getDate()) + 'T' + prepareTimeNr(now.getHours()) + ':' + prepareTimeNr(now.getMinutes()) + ':' + prepareTimeNr(now.getSeconds()) + '.' + now.getMilliseconds() + dif + prepareTimeNr(timezoneOffset / 60) + ':' + prepareTimeNr(timezoneOffset % 60);

    return {
        date: date,
        time: now.getTime()
    };
};

function getSourceAttributionFromStorage() {
    return _dibsBrowserStorage2.default.localStorage.getItem(_visitCountConstants.KEY_PRE_REGISTRATION_PAGE_VISIT) || [];
};

function prepareSourceAttributionToSave(element) {
    delete element.time;
    return element;
};

function getSourceAttribution() {
    var sourceAttribution = getSourceAttributionFromStorage();
    return sourceAttribution.map(prepareSourceAttributionToSave);
};

function clearSourceAttribution() {
    _dibsBrowserStorage2.default.localStorage.deleteItem(_visitCountConstants.KEY_PRE_REGISTRATION_PAGE_VISIT);
}

function trackPreRegistrationPageVisit(page) {
    if ((0, _dibsCookieJar.getUserId)(document.cookie, MASQUERADE_BUYER)) {
        return;
    }

    page = page || window.location.pathname;
    var sourceAttribution = getSourceAttributionFromStorage();
    var attributionElement = sourceAttribution.filter(function (_ref) {
        var landingPage = _ref.utmParams.landingPage;
        return landingPage === page;
    })[0];

    if (attributionElement) {
        attributionElement.utmParams.visitCount++;

        Object.assign(attributionElement, getDateTime());
    } else {
        var atribution = Object.assign(getDateTime(), {
            type: _visitCountConstants.TYPE_PRE_REGISTRATION_PAGE_VISIT,
            utmParams: {
                landingPage: page,
                visitCount: 1
            }
        });
        sourceAttribution.push(atribution);
    }

    sourceAttribution = sourceAttribution.sort(function (a, b) {
        if (a.time < b.time) {
            return 1;
        } else if (a.time > b.time) {
            return -1;
        }
        return 0;
    }).slice(0, _visitCountConstants.CAP_PRE_REGISTRATION_PAGE_VISIT);

    _dibsBrowserStorage2.default.localStorage.setItem(_visitCountConstants.KEY_PRE_REGISTRATION_PAGE_VISIT, sourceAttribution);
};

/***/ }),

/***/ "./node_modules/dibs-visit-tracking/dist/visitCountConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * number of (non iframe) page views per session before login/registration auto prompt
 */
var VISITS_PER_SESSION_LOGIN_PROMPT = exports.VISITS_PER_SESSION_LOGIN_PROMPT = 3;

/**
 * length of time before local storage values "expire" as session values
 * 4 hrs: (4 * 60 minutes x 60 seconds * 1000 milliseconds)
 */
var PSEUDO_SESSION_EXPIRES_AT = exports.PSEUDO_SESSION_EXPIRES_AT = 14400000;

var KEY_STORAGE = exports.KEY_STORAGE = 'visitCount';
var KEY_PSEUDO_SESSION_STORAGE = exports.KEY_PSEUDO_SESSION_STORAGE = 'pseudoSessionVisitCount';
var KEY_PRE_REGISTRATION_PAGE_VISIT = exports.KEY_PRE_REGISTRATION_PAGE_VISIT = '_dibsPreRegistrationPageVisit';
var TYPE_PRE_REGISTRATION_PAGE_VISIT = exports.TYPE_PRE_REGISTRATION_PAGE_VISIT = 'PRE_REGISTRATION_PAGE_VISIT';
var CAP_PRE_REGISTRATION_PAGE_VISIT = exports.CAP_PRE_REGISTRATION_PAGE_VISIT = 100;

/***/ }),

/***/ "./node_modules/dibs-visit-tracking/dist/visitCountModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _dibsBrowserStorage2 = _interopRequireDefault(_dibsBrowserStorage);

var _visitCountConstants = __webpack_require__("./node_modules/dibs-visit-tracking/dist/visitCountConstants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VisitCountModel = function () {
    function VisitCountModel() {
        _classCallCheck(this, VisitCountModel);

        this.data = {
            totalVisitCount: 0,
            session: 0,
            sinceRegPrompt: 0,
            regPromptLimit: _visitCountConstants.VISITS_PER_SESSION_LOGIN_PROMPT,
            pseudoSessionExpiration: _visitCountConstants.PSEUDO_SESSION_EXPIRES_AT,
            gaSessionPageCount: 0,
            priorPagePdp: 0,
            gaTrackerEventFired: 0
        };

        if (_dibsBrowserStorage2.default.localStorage) {
            this.parseIntStorageData(_visitCountConstants.KEY_STORAGE);
            this.parseIntStorageData(_visitCountConstants.KEY_PSEUDO_SESSION_STORAGE);

            if (this.isPseudoSessionExpired()) {
                this.data = {
                    session: 0,
                    regPromptLimit: _visitCountConstants.VISITS_PER_SESSION_LOGIN_PROMPT,
                    gaSessionPageCount: 0,
                    priorPagePdp: 0,
                    gaTrackerEventFired: 0
                };
            }
        }
    }

    /**
     * checks to see if time stamp on "session" storage has expired
     * @returns {boolean}
     */


    _createClass(VisitCountModel, [{
        key: 'isPseudoSessionExpired',
        value: function isPseudoSessionExpired() {
            var limit = this.data.pseudoSessionExpiration;
            var now = new Date().getTime();
            // if no timestamp assume it's brand new
            return now - (this.data.pseudoTimeStamp || now) >= limit;
        }

        /**
         * fetches an object from local storage and parses its fields to integers
         * @param key {string} the key in local storage
         */

    }, {
        key: 'parseIntStorageData',
        value: function parseIntStorageData(key) {
            var _this = this;

            var source = _dibsBrowserStorage2.default.localStorage;

            var data = source.getItem(key) || {};

            // parseInt over all fields
            Object.keys(data).forEach(function (field) {
                var values = parseInt(data[field], 10) || 0;
                _this.set(field, values);
            });
        }

        /**
         * gets value from class object
         *  @param field {string} - class object property
         *  @returns object property
         */

    }, {
        key: 'get',
        value: function get(field) {
            return this.data[field];
        }

        /**
         * sets value to class object
         * @params field {string}
         * @params value {number}
         */

    }, {
        key: 'set',
        value: function set(field, value) {
            this.data[field] = value;
        }

        /**
        * increments tracking related visitor model values
        */

    }, {
        key: 'incrementTracking',
        value: function incrementTracking() {
            var _this2 = this;

            var incrementValues = ['session', 'totalVisitCount', 'sinceRegPrompt', 'gaSessionPageCount'];
            incrementValues.forEach(function (value) {
                _this2.increment(value);
            });
        }

        /**
         * increments a field by 1
         * @param field {string}
         */

    }, {
        key: 'increment',
        value: function increment(field) {
            var val = this.get(field) || 0;
            this.set(field, val + 1);
        }

        /**
         * saves visit counts to local and session storage
         */

    }, {
        key: 'save',
        value: function save() {
            var localData = {
                totalVisitCount: this.get('totalVisitCount'),
                sinceRegPrompt: this.get('sinceRegPrompt'),
                regPromptLimit: this.get('regPromptLimit')
            };

            _dibsBrowserStorage2.default.localStorage.setItem(_visitCountConstants.KEY_STORAGE, localData);

            var pseudoSessionData = {
                session: this.get('session'),
                pseudoTimeStamp: new Date().getTime(),
                gaSessionPageCount: this.get('gaSessionPageCount'),
                priorPagePdp: this.get('priorPagePdp'),
                gaTrackerEventFired: this.get('gaTrackerEventFired')
            };

            _dibsBrowserStorage2.default.localStorage.setItem(_visitCountConstants.KEY_PSEUDO_SESSION_STORAGE, pseudoSessionData);
        }

        /**
         * removes visit counts from session and local storage
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            _dibsBrowserStorage2.default.localStorage.deleteItem(_visitCountConstants.KEY_STORAGE);
            _dibsBrowserStorage2.default.localStorage.deleteItem(_visitCountConstants.KEY_PSEUDO_SESSION_STORAGE);
        }
    }]);

    return VisitCountModel;
}();

exports.default = VisitCountModel;

/***/ }),

/***/ "./node_modules/dibs-visit-tracking/dist/visitorTracking.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _dibsTracking2 = _interopRequireDefault(_dibsTracking);

var _visitCountModel = __webpack_require__("./node_modules/dibs-visit-tracking/dist/visitCountModel.js");

var _visitCountModel2 = _interopRequireDefault(_visitCountModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VisitorTracking = function () {
    function VisitorTracking() {
        _classCallCheck(this, VisitorTracking);

        this.model = new _visitCountModel2.default();

        this.model.incrementTracking();
        this.checkPdpEngaged(document);
        this.trackNonBouncePdp(_dibsTracking2.default);
        this.model.save();
    }

    /**
     * Was the prior page pdp?
     *
     * @param document
     * @property {number} priorPagePdp - is prior page PDP
     */


    _createClass(VisitorTracking, [{
        key: 'checkPdpEngaged',
        value: function checkPdpEngaged(document) {
            var value = 0;
            if (this.wasInPreviousUrl(document, '1stdibs.com') && this.wasInPreviousUrl(document, 'id-') || document.location.href.indexOf('id-') > -1) {
                value = 1;
            }
            this.model.set('priorPagePdp', value);
        }

        /**
         * check if nonBound Pdp Tracking event can be fired
         * @returns {boolean}
         */

    }, {
        key: 'canFireNonBoundPdpTracking',
        value: function canFireNonBoundPdpTracking() {
            return !this.model.get('gaTrackerEventFired') && this.model.get('priorPagePdp') && this.model.get('gaSessionPageCount') >= 2;
        }

        /**
         * @param  {Object} gaTracker [dibs-tracking wrapper around google analytics that fires events]
         * @return {None}
         */

    }, {
        key: 'trackNonBouncePdp',
        value: function trackNonBouncePdp(gaTracker) {
            if (this.canFireNonBoundPdpTracking()) {
                gaTracker.trackEvent({
                    'category': 'adwords',
                    'action': 'session type',
                    'label': 'nbpdp'
                });
                this.model.set('gaTrackerEventFired', 1);
            }
        }

        /**
         * Is the text in the url?
         * @returns {boolean}
         */

    }, {
        key: 'wasInPreviousUrl',
        value: function wasInPreviousUrl(document, linkText) {
            return document.referrer.indexOf(linkText) > -1;
        }
    }]);

    return VisitorTracking;
}();

exports.default = VisitorTracking;

/***/ }),

/***/ "./node_modules/dom-helpers/class/addClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__("./node_modules/dom-helpers/class/hasClass.js");

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/dom-helpers/class/hasClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),

/***/ "./node_modules/dom-helpers/class/removeClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),

/***/ "./node_modules/element-class/index.js":
/***/ (function(module, exports) {

module.exports = function(opts) {
  return new ElementClass(opts)
}

function indexOf(arr, prop) {
  if (arr.indexOf) return arr.indexOf(prop)
  for (var i = 0, len = arr.length; i < len; i++)
    if (arr[i] === prop) return i
  return -1
}

function ElementClass(opts) {
  if (!(this instanceof ElementClass)) return new ElementClass(opts)
  var self = this
  if (!opts) opts = {}

  // similar doing instanceof HTMLElement but works in IE8
  if (opts.nodeType) opts = {el: opts}

  this.opts = opts
  this.el = opts.el || document.body
  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
}

ElementClass.prototype.add = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return el.className = className
  var classes = el.className.split(' ')
  if (indexOf(classes, className) > -1) return classes
  classes.push(className)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.remove = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return
  var classes = el.className.split(' ')
  var idx = indexOf(classes, className)
  if (idx > -1) classes.splice(idx, 1)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.has = function(className) {
  var el = this.el
  if (!el) return
  var classes = el.className.split(' ')
  return indexOf(classes, className) > -1
}

ElementClass.prototype.toggle = function(className) {
  var el = this.el
  if (!el) return
  if (this.has(className)) this.remove(className)
  else this.add(className)
}


/***/ }),

/***/ "./node_modules/fbjs/lib/areEqual.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(25);

/***/ }),

/***/ "./node_modules/hoist-non-react-statics/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),

/***/ "./node_modules/intl-format-cache/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__("./node_modules/intl-format-cache/lib/memoizer.js")['default'];
exports['default'] = exports;


/***/ }),

/***/ "./node_modules/intl-format-cache/lib/es5.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill

var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs   = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP    = function() {},
        fBound  = function() {
          return fToBind.apply(this instanceof fNOP
                 ? this
                 : oThis,
                 aArgs.concat(Array.prototype.slice.call(arguments)));
        };

    if (this.prototype) {
      // native functions don't have a prototype
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),

/***/ "./node_modules/intl-format-cache/lib/memoizer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var src$es5$$ = __webpack_require__("./node_modules/intl-format-cache/lib/es5.js");
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args    = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format  = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') { return; }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys  = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key  = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i]  = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__("./node_modules/intl-messageformat/lib/main.js")['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(2);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),

/***/ "./node_modules/intl-messageformat/lib/compiler.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/lib/core.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__("./node_modules/intl-messageformat/lib/utils.js"), src$es5$$ = __webpack_require__("./node_modules/intl-messageformat/lib/es5.js"), src$compiler$$ = __webpack_require__("./node_modules/intl-messageformat/lib/compiler.js"), intl$messageformat$parser$$ = __webpack_require__("./node_modules/intl-messageformat/node_modules/intl-messageformat-parser/index.js");
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/lib/en.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/lib/es5.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__("./node_modules/intl-messageformat/lib/utils.js");

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/lib/main.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__("./node_modules/intl-messageformat/lib/core.js"), src$en$$ = __webpack_require__("./node_modules/intl-messageformat/lib/en.js");

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/lib/utils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "./node_modules/intl-messageformat/node_modules/intl-messageformat-parser/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__("./node_modules/intl-messageformat/node_modules/intl-messageformat-parser/lib/parser.js")['default'];
exports['default'] = exports;


/***/ }),

/***/ "./node_modules/intl-messageformat/node_modules/intl-messageformat-parser/lib/parser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  /*
   * Generated by PEG.js 0.8.0.
   *
   * http://pegjs.majda.cz/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function SyntaxError(message, expected, found, offset, line, column) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.offset   = offset;
    this.line     = line;
    this.column   = column;

    this.name     = "SyntaxError";
  }

  peg$subclass(SyntaxError, Error);

  function parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = [],
        peg$c1 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements
                };
            },
        peg$c2 = peg$FAILED,
        peg$c3 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c4 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText
                };
            },
        peg$c5 = /^[^ \t\n\r,.+={}#]/,
        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c7 = "{",
        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c9 = null,
        peg$c10 = ",",
        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
        peg$c12 = "}",
        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c14 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2]
                };
            },
        peg$c15 = "number",
        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c17 = "date",
        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c19 = "time",
        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c21 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2]
                };
            },
        peg$c22 = "plural",
        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                };
            },
        peg$c25 = "selectordinal",
        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c27 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options
                }
            },
        peg$c28 = "select",
        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c30 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options
                };
            },
        peg$c31 = "=",
        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c33 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern
                };
            },
        peg$c34 = "offset:",
        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c36 = function(number) {
                return number;
            },
        peg$c37 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options
                };
            },
        peg$c38 = { type: "other", description: "whitespace" },
        peg$c39 = /^[ \t\n\r]/,
        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c41 = { type: "other", description: "optionalWhitespace" },
        peg$c42 = /^[0-9]/,
        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c44 = /^[0-9a-f]/i,
        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c46 = "0",
        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c48 = /^[1-9]/,
        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c50 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
        peg$c53 = "\\\\",
        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c55 = function() { return '\\'; },
        peg$c56 = "\\#",
        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c58 = function() { return '\\#'; },
        peg$c59 = "\\{",
        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c61 = function() { return '\u007B'; },
        peg$c62 = "\\}",
        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c64 = function() { return '\u007D'; },
        peg$c65 = "\\u",
        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c67 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c68 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$reportedPos      = 0,
        peg$cachedPos        = 0,
        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$reportedPos, peg$currPos);
    }

    function offset() {
      return peg$reportedPos;
    }

    function line() {
      return peg$computePosDetails(peg$reportedPos).line;
    }

    function column() {
      return peg$computePosDetails(peg$reportedPos).column;
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        peg$reportedPos
      );
    }

    function error(message) {
      throw peg$buildException(message, null, peg$reportedPos);
    }

    function peg$computePosDetails(pos) {
      function advance(details, startPos, endPos) {
        var p, ch;

        for (p = startPos; p < endPos; p++) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }
        }
      }

      if (peg$cachedPos !== pos) {
        if (peg$cachedPos > pos) {
          peg$cachedPos = 0;
          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
        }
        advance(peg$cachedPosDetails, peg$cachedPos, pos);
        peg$cachedPos = pos;
      }

      return peg$cachedPosDetails;
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, pos) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      var posDetails = peg$computePosDetails(pos),
          found      = pos < input.length ? input.charAt(pos) : null;

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        pos,
        posDetails.line,
        posDetails.column
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$c2;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$c2;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$c2;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c4(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c5.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c6); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c5.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
          }
        } else {
          s1 = peg$c2;
        }
        if (s1 !== peg$FAILED) {
          s1 = input.substring(s0, peg$currPos);
        }
        s0 = s1;
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c7;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c8); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c10;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c11); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$c2;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$c2;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$c2;
              }
              if (s5 === peg$FAILED) {
                s5 = peg$c9;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c12;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c14(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c15) {
        s1 = peg$c15;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c16); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c17) {
          s1 = peg$c17;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c18); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c19) {
            s1 = peg$c19;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c20); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c10;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$c2;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$c2;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$c2;
          }
          if (s3 === peg$FAILED) {
            s3 = peg$c9;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c21(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c28) {
        s1 = peg$c28;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c11); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$c2;
              }
              if (s5 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c30(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c31;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$c2;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c7;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c8); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c12;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$reportedPos = s0;
                      s1 = peg$c33(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$c2;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$c2;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$c2;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c34) {
        s1 = peg$c34;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c36(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = peg$c9;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$c2;
          }
          if (s3 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c37(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$c2;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$c2;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$c2;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c39.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c39.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c40); }
          }
        }
      } else {
        s0 = peg$c2;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s1 = input.substring(s0, peg$currPos);
      }
      s0 = s1;
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c41); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c42.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c43); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c44.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c45); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c46;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c47); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c48.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c49); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$c2;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$c2;
        }
        if (s2 !== peg$FAILED) {
          s2 = input.substring(s1, peg$currPos);
        }
        s1 = s2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c50(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c51.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c52); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c53) {
          s1 = peg$c53;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c54); }
        }
        if (s1 !== peg$FAILED) {
          peg$reportedPos = s0;
          s1 = peg$c55();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c56) {
            s1 = peg$c56;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c57); }
          }
          if (s1 !== peg$FAILED) {
            peg$reportedPos = s0;
            s1 = peg$c58();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c59) {
              s1 = peg$c59;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c60); }
            }
            if (s1 !== peg$FAILED) {
              peg$reportedPos = s0;
              s1 = peg$c61();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c62) {
                s1 = peg$c62;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c63); }
              }
              if (s1 !== peg$FAILED) {
                peg$reportedPos = s0;
                s1 = peg$c64();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c65) {
                  s1 = peg$c65;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$c2;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$c2;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$c2;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$c2;
                  }
                  if (s3 !== peg$FAILED) {
                    s3 = input.substring(s2, peg$currPos);
                  }
                  s2 = s3;
                  if (s2 !== peg$FAILED) {
                    peg$reportedPos = s0;
                    s1 = peg$c67(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$c2;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$c2;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$c2;
      }
      if (s1 !== peg$FAILED) {
        peg$reportedPos = s0;
        s1 = peg$c68(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
    }
  }

  return {
    SyntaxError: SyntaxError,
    parse:       parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),

/***/ "./node_modules/intl-relativeformat/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__("./node_modules/intl-relativeformat/lib/main.js")['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(3);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),

/***/ "./node_modules/intl-relativeformat/lib/core.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var intl$messageformat$$ = __webpack_require__("./node_modules/intl-messageformat/index.js"), src$diff$$ = __webpack_require__("./node_modules/intl-relativeformat/lib/diff.js"), src$es5$$ = __webpack_require__("./node_modules/intl-relativeformat/lib/es5.js");
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
    src$es5$$.defineProperty(this, '_options', {value: {
        style: this._resolveStyle(options.style),
        units: this._isValidUnits(options.units) && options.units
    }});

    src$es5$$.defineProperty(this, '_locales', {value: locales});
    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlRelativeFormat is missing a ' +
            '`locale` property value'
        );
    }

    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

    // Add data to IntlMessageFormat.
    intl$messageformat$$["default"].__addLocaleData(data);
}});

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45, 'second-short': 45,  // seconds to minute
        minute: 45, 'minute-short': 45, // minutes to hour
        hour  : 22, 'hour-short': 22, // hours to day
        day   : 26, 'day-short': 26, // days to month
        month : 11, 'month-short': 11 // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style : this._options.style,
        units : this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales        = this._locales;
    var resolvedLocale = this._locale;

    var field        = this._fields[units];
    var relativeTime = field.relativeTime;
    var future       = '';
    var past         = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' +
                                 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale
    );
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError(
            'The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    if (!isFinite(date)) {
        throw new RangeError(
            'The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.'
        );
    }

    var diffReport  = src$diff$$["default"](now, date);
    var units       = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0' : Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error(
                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion
            );
        }
    }

    throw new Error(
        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"'
    );
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error(
        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"'
    );
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function(field) {
        return field.indexOf('-short') < 1;
    });

    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),

/***/ "./node_modules/intl-relativeformat/lib/diff.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to   = +to;

    var millisecond = round(to - from),
        second      = round(millisecond / 1000),
        minute      = round(second / 60),
        hour        = round(minute / 60),
        day         = round(hour / 24),
        week        = round(day / 7);

    var rawYears = daysToYears(day),
        month    = round(rawYears * 12),
        year     = round(rawYears);

    return {
        millisecond    : millisecond,
        second         : second,
        'second-short' : second,
        minute         : minute,
        'minute-short' : minute,
        hour           : hour,
        'hour-short'   : hour,
        day            : day,
        'day-short'    : day,
        week           : week,
        'week-short'   : week,
        month          : month,
        'month-short'  : month,
        year           : year,
        'year-short'   : year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),

/***/ "./node_modules/intl-relativeformat/lib/en.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"year-short":{"displayName":"yr.","relative":{"0":"this yr.","1":"next yr.","-1":"last yr."},"relativeTime":{"future":{"one":"in {0} yr.","other":"in {0} yr."},"past":{"one":"{0} yr. ago","other":"{0} yr. ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"month-short":{"displayName":"mo.","relative":{"0":"this mo.","1":"next mo.","-1":"last mo."},"relativeTime":{"future":{"one":"in {0} mo.","other":"in {0} mo."},"past":{"one":"{0} mo. ago","other":"{0} mo. ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"day-short":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"hour-short":{"displayName":"hr.","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hr.","other":"in {0} hr."},"past":{"one":"{0} hr. ago","other":"{0} hr. ago"}}},"minute":{"displayName":"minute","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"minute-short":{"displayName":"min.","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} min.","other":"in {0} min."},"past":{"one":"{0} min. ago","other":"{0} min. ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}},"second-short":{"displayName":"sec.","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} sec.","other":"in {0} sec."},"past":{"one":"{0} sec. ago","other":"{0} sec. ago"}}}}};

//# sourceMappingURL=en.js.map

/***/ }),

/***/ "./node_modules/intl-relativeformat/lib/es5.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License



var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),

/***/ "./node_modules/intl-relativeformat/lib/main.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__("./node_modules/intl-relativeformat/lib/core.js"), src$en$$ = __webpack_require__("./node_modules/intl-relativeformat/lib/en.js");

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),

/***/ "./node_modules/invariant/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),

/***/ "./node_modules/is-buffer/index.js":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "./node_modules/js-cookie/src/js.cookie.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.1.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "./node_modules/lodash-es/_Symbol.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__("./node_modules/lodash-es/_root.js");


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["default"].Symbol;

/* harmony default export */ __webpack_exports__["default"] = (Symbol);


/***/ }),

/***/ "./node_modules/lodash-es/_baseGetTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("./node_modules/lodash-es/_Symbol.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__("./node_modules/lodash-es/_getRawTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__("./node_modules/lodash-es/_objectToString.js");




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["default"] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["default"].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["default"])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["default"])(value);
}

/* harmony default export */ __webpack_exports__["default"] = (baseGetTag);


/***/ }),

/***/ "./node_modules/lodash-es/_freeGlobal.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["default"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash-es/_getPrototype.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__("./node_modules/lodash-es/_overArg.js");


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["default"])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["default"] = (getPrototype);


/***/ }),

/***/ "./node_modules/lodash-es/_getRawTag.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__("./node_modules/lodash-es/_Symbol.js");


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["default"] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["default"].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (getRawTag);


/***/ }),

/***/ "./node_modules/lodash-es/_objectToString.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["default"] = (objectToString);


/***/ }),

/***/ "./node_modules/lodash-es/_overArg.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["default"] = (overArg);


/***/ }),

/***/ "./node_modules/lodash-es/_root.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__("./node_modules/lodash-es/_freeGlobal.js");


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["default"] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["default"] = (root);


/***/ }),

/***/ "./node_modules/lodash-es/isObjectLike.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["default"] = (isObjectLike);


/***/ }),

/***/ "./node_modules/lodash-es/isPlainObject.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__("./node_modules/lodash-es/_baseGetTag.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__("./node_modules/lodash-es/_getPrototype.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__("./node_modules/lodash-es/isObjectLike.js");




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["default"])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["default"])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["default"])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["default"] = (isPlainObject);


/***/ }),

/***/ "./node_modules/lodash.get/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash.merge/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (typeof key == 'number' && value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  if (!(isArray(source) || isTypedArray(source))) {
    var props = baseKeysIn(source);
  }
  arrayEach(props || source, function(srcValue, key) {
    if (props) {
      key = srcValue;
      srcValue = source[key];
    }
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  });
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    newValue = srcValue;
    if (isArray(srcValue) || isTypedArray(srcValue)) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        isCommon = false;
        newValue = baseClone(srcValue, true);
      }
      else {
        newValue = objValue;
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js"), __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/lodash.shuffle/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    iteratorSymbol = Symbol ? Symbol.iterator : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeKeys = overArg(Object.keys, Object),
    nativeRandom = Math.random;

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  var index = -1,
      result = toArray(collection),
      length = result.length,
      lastIndex = length - 1;

  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = baseClamp(toInteger(n), 0, length);
  }
  while (++index < n) {
    var rand = baseRandom(index, lastIndex),
        value = result[rand];

    result[rand] = result[index];
    result[index] = value;
  }
  result.length = n;
  return result;
}

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  return sampleSize(collection, MAX_ARRAY_LENGTH);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (isArrayLike(value)) {
    return isString(value) ? stringToArray(value) : copyArray(value);
  }
  if (iteratorSymbol && value[iteratorSymbol]) {
    return iteratorToArray(value[iteratorSymbol]());
  }
  var tag = getTag(value),
      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

  return func(value);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object ? baseValues(object, keys(object)) : [];
}

module.exports = shuffle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash/_Symbol.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("./node_modules/lodash/_root.js");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "./node_modules/lodash/_baseGetTag.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js"),
    getRawTag = __webpack_require__("./node_modules/lodash/_getRawTag.js"),
    objectToString = __webpack_require__("./node_modules/lodash/_objectToString.js");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "./node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash/_getPrototype.js":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("./node_modules/lodash/_overArg.js");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "./node_modules/lodash/_getRawTag.js":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("./node_modules/lodash/_Symbol.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "./node_modules/lodash/_objectToString.js":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "./node_modules/lodash/_overArg.js":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "./node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("./node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "./node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "./node_modules/lodash/isPlainObject.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("./node_modules/lodash/_baseGetTag.js"),
    getPrototype = __webpack_require__("./node_modules/lodash/_getPrototype.js"),
    isObjectLike = __webpack_require__("./node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "./node_modules/md5/md5.js":
/***/ (function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__("./node_modules/crypt/crypt.js"),
      utf8 = __webpack_require__("./node_modules/charenc/charenc.js").utf8,
      isBuffer = __webpack_require__("./node_modules/is-buffer/index.js"),
      bin = __webpack_require__("./node_modules/charenc/charenc.js").bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),

/***/ "./node_modules/merge-theme-hoc/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _withProps = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/withProps.js");

var _withProps2 = _interopRequireDefault(_withProps);

var _setDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/setDisplayName.js");

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/wrapDisplayName.js");

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeTheme(injectedTheme) {
    return function (BaseComponent) {
        var Themed = (0, _withProps2.default)(function (ownProps) {
            var theme = injectedTheme;
            if (ownProps && ownProps.theme) {
                var ownTheme = ownProps.theme;
                theme = Object.keys(ownTheme).filter(function (key) {
                    return !!injectedTheme[key];
                }).reduce(function (accum, key) {
                    accum[key] = (0, _classnames2.default)(ownTheme[key], injectedTheme[key]);
                    return accum;
                }, _extends({}, ownTheme, injectedTheme));
            }
            return { theme: theme };
        })(BaseComponent);
        (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'themed'))(Themed);
        return Themed;
    };
}

exports.default = mergeTheme;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/createEagerFactory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createEagerElementUtil = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/utils/createEagerElementUtil.js");

var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);

var _isReferentiallyTransparentFunctionComponent = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/isReferentiallyTransparentFunctionComponent.js");

var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
  return function (p, c) {
    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
  };
};

exports.default = createFactory;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/getDisplayName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/isClassComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

exports.default = isClassComponent;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/isReferentiallyTransparentFunctionComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isClassComponent = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/isClassComponent.js");

var _isClassComponent2 = _interopRequireDefault(_isClassComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && ("production" === 'production' || !Component.propTypes));
};

exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/mapProps.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/setDisplayName.js");

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/wrapDisplayName.js");

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/createEagerFactory.js");

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

exports.default = mapProps;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/setDisplayName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/setStatic.js");

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/setStatic.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/utils/createEagerElementUtil.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component = type;

  if (children) {
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  }

  return _react2.default.createElement(Component, props);
};

exports.default = createEagerElementUtil;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/withProps.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _wrapDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/wrapDisplayName.js");

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _setDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/setDisplayName.js");

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _mapProps = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/mapProps.js");

var _mapProps2 = _interopRequireDefault(_mapProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withProps = function withProps(input) {
  var hoc = (0, _mapProps2.default)(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

exports.default = withProps;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/wrapDisplayName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/getDisplayName.js");

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/punycode/punycode.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module), __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/url/url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__("./node_modules/node-libs-browser/node_modules/punycode/punycode.js");
var util = __webpack_require__("./node_modules/node-libs-browser/node_modules/url/util.js");

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/url/util.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),

/***/ "./node_modules/parseurl/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * parseurl
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2014-2017 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module dependencies.
 * @private
 */

var url = __webpack_require__("./node_modules/node-libs-browser/node_modules/url/url.js")
var parse = url.parse
var Url = url.Url

/**
 * Module exports.
 * @public
 */

module.exports = parseurl
module.exports.original = originalurl

/**
 * Parse the `req` url with memoization.
 *
 * @param {ServerRequest} req
 * @return {Object}
 * @public
 */

function parseurl (req) {
  var url = req.url

  if (url === undefined) {
    // URL is undefined
    return undefined
  }

  var parsed = req._parsedUrl

  if (fresh(url, parsed)) {
    // Return cached URL parse
    return parsed
  }

  // Parse the URL
  parsed = fastparse(url)
  parsed._raw = url

  return (req._parsedUrl = parsed)
};

/**
 * Parse the `req` original url with fallback and memoization.
 *
 * @param {ServerRequest} req
 * @return {Object}
 * @public
 */

function originalurl (req) {
  var url = req.originalUrl

  if (typeof url !== 'string') {
    // Fallback
    return parseurl(req)
  }

  var parsed = req._parsedOriginalUrl

  if (fresh(url, parsed)) {
    // Return cached URL parse
    return parsed
  }

  // Parse the URL
  parsed = fastparse(url)
  parsed._raw = url

  return (req._parsedOriginalUrl = parsed)
};

/**
 * Parse the `str` url with fast-path short-cut.
 *
 * @param {string} str
 * @return {Object}
 * @private
 */

function fastparse (str) {
  if (typeof str !== 'string' || str.charCodeAt(0) !== 0x2f /* / */) {
    return parse(str)
  }

  var pathname = str
  var query = null
  var search = null

  // This takes the regexp from https://github.com/joyent/node/pull/7878
  // Which is /^(\/[^?#\s]*)(\?[^#\s]*)?$/
  // And unrolls it into a for loop
  for (var i = 1; i < str.length; i++) {
    switch (str.charCodeAt(i)) {
      case 0x3f: /* ?  */
        if (search === null) {
          pathname = str.substring(0, i)
          query = str.substring(i + 1)
          search = str.substring(i)
        }
        break
      case 0x09: /* \t */
      case 0x0a: /* \n */
      case 0x0c: /* \f */
      case 0x0d: /* \r */
      case 0x20: /*    */
      case 0x23: /* #  */
      case 0xa0:
      case 0xfeff:
        return parse(str)
    }
  }

  var url = Url !== undefined
    ? new Url()
    : {}
  url.path = str
  url.href = str
  url.pathname = pathname
  url.query = query
  url.search = search

  return url
}

/**
 * Determine if parsed is still fresh for url.
 *
 * @param {string} url
 * @param {object} parsedUrl
 * @return {boolean}
 * @private
 */

function fresh (url, parsedUrl) {
  return typeof parsedUrl === 'object' &&
    parsedUrl !== null &&
    (Url === undefined || parsedUrl instanceof Url) &&
    parsedUrl._raw === url
}


/***/ }),

/***/ "./node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(34);

/***/ }),

/***/ "./node_modules/querystring-es3/decode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),

/***/ "./node_modules/querystring-es3/encode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),

/***/ "./node_modules/querystring-es3/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__("./node_modules/querystring-es3/decode.js");
exports.encode = exports.stringify = __webpack_require__("./node_modules/querystring-es3/encode.js");


/***/ }),

/***/ "./node_modules/react-dom/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(320);

/***/ }),

/***/ "./node_modules/react-input-autosize/lib/AutosizeInput.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: '_' + Math.random().toString(36).substr(2, 12)
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyle = this.input && window.getComputedStyle(this.input);
			if (!inputStyle) {
				return;
			}
			var widthNode = this.sizer;
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.fontWeight = inputStyle.fontWeight;
			widthNode.style.fontStyle = inputStyle.fontStyle;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			widthNode.style.textTransform = inputStyle.textTransform;
			if (this.props.placeholder) {
				var placeholderNode = this.placeHolderSizer;
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.fontWeight = inputStyle.fontWeight;
				placeholderNode.style.fontStyle = inputStyle.fontStyle;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
				placeholderNode.style.textTransform = inputStyle.textTransform;
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth + 'px';
			inputStyle.boxSizing = 'content-box';

			var inputProps = _objectWithoutProperties(this.props, []);

			inputProps.className = this.props.inputClassName;
			inputProps.style = inputStyle;
			// ensure props meant for `AutosizeInput` don't end up on the `input`
			delete inputProps.inputClassName;
			delete inputProps.inputStyle;
			delete inputProps.minWidth;
			delete inputProps.onAutosize;
			delete inputProps.placeholderIsMinWidth;
			delete inputProps.inputRef;
			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				_react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
					} }),
				_react2.default.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

;

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(newValue) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1
};

exports.default = AutosizeInput;

/***/ }),

/***/ "./node_modules/react-intl/lib/index.es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__("./node_modules/intl-messageformat/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__("./node_modules/intl-relativeformat/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("./node_modules/prop-types/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("./node_modules/react/react.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__("./node_modules/invariant/browser.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache__ = __webpack_require__("./node_modules/intl-format-cache/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_intl_format_cache__);
/*
 * Copyright 2017, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */









// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this.refs.wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? 'wrappedInstance' : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return InjectIntl;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 // months to year
};

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
}

function getNamedFormat(formats, type, name) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  if (false) {
    console.error('[React Intl] No ' + type + ' format named: ' + name);
  }
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'date', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting date.\n' + e);
    }
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var defaults$$1 = format && getNamedFormat(formats, 'time', format);
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting time.\n' + e);
    }
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting relative time.\n' + e);
    }
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var defaults$$1 = format && getNamedFormat(formats, 'number', format);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting number.\n' + e);
    }
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    if (false) {
      console.error('[React Intl] Error formatting plural.\n' + e);
    }
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // `id` is a required field of a Message Descriptor.

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
      }
    }
  } else {
    if (false) {
      // This prevents warnings from littering the console in development
      // when no `messages` are passed into the <IntlProvider> for the
      // default locale, and a default message is in the source.
      if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
        console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
      }
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      if (false) {
        console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
      }
    }
  }

  if (!formattedMessage) {
    if (false) {
      console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
    }
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {}
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.DateTimeFormat),
      getNumberFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(Intl.NumberFormat),
      getMessageFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: __WEBPACK_IMPORTED_MODULE_6_intl_format_cache___default()(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats;


        if (false) {
          console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
        }

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatMessage = _context$intl.formatMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),

/***/ "./node_modules/react-portal/build/portal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYCODES = {
  ESCAPE: 27
};

var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));

    _this.state = { active: false };
    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    _this.portal = null;
    _this.node = null;
    return _this;
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.addEventListener('mouseup', this.handleOutsideMouseClick);
        document.addEventListener('touchstart', this.handleOutsideMouseClick);
      }

      if (this.props.isOpened) {
        this.openPortal();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // portal's 'is open' state is handled through the prop isOpened
      if (typeof newProps.isOpened !== 'undefined') {
        if (newProps.isOpened) {
          if (this.state.active) {
            this.renderPortal(newProps);
          } else {
            this.openPortal(newProps);
          }
        }
        if (!newProps.isOpened && this.state.active) {
          this.closePortal();
        }
      }

      // portal handles its own 'is open' state
      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
        this.renderPortal(newProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
      }

      this.closePortal(true);
    }
  }, {
    key: 'handleWrapperClick',
    value: function handleWrapperClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.state.active) {
        return;
      }
      this.openPortal();
    }
  }, {
    key: 'openPortal',
    value: function openPortal() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setState({ active: true });
      this.renderPortal(props);
      this.props.onOpen(this.node);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      var _this2 = this;

      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var resetPortalState = function resetPortalState() {
        if (_this2.node) {
          _reactDom2.default.unmountComponentAtNode(_this2.node);
          document.body.removeChild(_this2.node);
        }
        _this2.portal = null;
        _this2.node = null;
        if (isUnmounted !== true) {
          _this2.setState({ active: false });
        }
      };

      if (this.state.active) {
        if (this.props.beforeClose) {
          this.props.beforeClose(this.node, resetPortalState);
        } else {
          resetPortalState();
        }

        this.props.onClose();
      }
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }

      var root = (0, _reactDom.findDOMNode)(this.portal);
      if (root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      e.stopPropagation();
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.node) {
        this.node = document.createElement('div');
        document.body.appendChild(this.node);
      }

      var children = props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof props.children.type === 'function') {
        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
      }

      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.openByClickOn) {
        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
      }
      return null;
    }
  }]);

  return Portal;
}(_react2.default.Component);

exports.default = Portal;


Portal.propTypes = {
  children: _propTypes2.default.element.isRequired,
  openByClickOn: _propTypes2.default.element,
  closeOnEsc: _propTypes2.default.bool,
  closeOnOutsideClick: _propTypes2.default.bool,
  isOpened: _propTypes2.default.bool,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  beforeClose: _propTypes2.default.func,
  onUpdate: _propTypes2.default.func
};

Portal.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onUpdate: function onUpdate() {}
};
module.exports = exports['default'];


/***/ }),

/***/ "./node_modules/react-redux/lib/components/Provider.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = undefined;

var _react = __webpack_require__("./node_modules/react/react.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _storeShape = __webpack_require__("./node_modules/react-redux/lib/utils/storeShape.js");

var _storeShape2 = _interopRequireDefault(_storeShape);

var _warning = __webpack_require__("./node_modules/react-redux/lib/utils/warning.js");

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  Provider.prototype.getChildContext = function getChildContext() {
    return { store: this.store };
  };

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.store = props.store;
    return _this;
  }

  Provider.prototype.render = function render() {
    return _react.Children.only(this.props.children);
  };

  return Provider;
}(_react.Component);

exports["default"] = Provider;


if (false) {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;


    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: _storeShape2["default"].isRequired,
  children: _propTypes2["default"].element.isRequired
};
Provider.childContextTypes = {
  store: _storeShape2["default"].isRequired
};

/***/ }),

/***/ "./node_modules/react-redux/lib/components/connect.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = connect;

var _react = __webpack_require__("./node_modules/react/react.js");

var _storeShape = __webpack_require__("./node_modules/react-redux/lib/utils/storeShape.js");

var _storeShape2 = _interopRequireDefault(_storeShape);

var _shallowEqual = __webpack_require__("./node_modules/react-redux/lib/utils/shallowEqual.js");

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _wrapActionCreators = __webpack_require__("./node_modules/react-redux/lib/utils/wrapActionCreators.js");

var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);

var _warning = __webpack_require__("./node_modules/react-redux/lib/utils/warning.js");

var _warning2 = _interopRequireDefault(_warning);

var _isPlainObject = __webpack_require__("./node_modules/lodash/isPlainObject.js");

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _hoistNonReactStatics = __webpack_require__("./node_modules/hoist-non-react-statics/index.js");

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__("./node_modules/invariant/browser.js");

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultMapStateToProps = function defaultMapStateToProps(state) {
  return {};
}; // eslint-disable-line no-unused-vars
var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
};
var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
  return _extends({}, parentProps, stateProps, dispatchProps);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var errorObject = { value: null };
function tryCatch(fn, ctx) {
  try {
    return fn.apply(ctx);
  } catch (e) {
    errorObject.value = e;
    return errorObject;
  }
}

// Helps track hot reloading.
var nextVersion = 0;

function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var shouldSubscribe = Boolean(mapStateToProps);
  var mapState = mapStateToProps || defaultMapStateToProps;

  var mapDispatch = void 0;
  if (typeof mapDispatchToProps === 'function') {
    mapDispatch = mapDispatchToProps;
  } else if (!mapDispatchToProps) {
    mapDispatch = defaultMapDispatchToProps;
  } else {
    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
  }

  var finalMergeProps = mergeProps || defaultMergeProps;
  var _options$pure = options.pure,
      pure = _options$pure === undefined ? true : _options$pure,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;

  // Helps track hot reloading.
  var version = nextVersion++;

  return function wrapWithConnect(WrappedComponent) {
    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';

    function checkStateShape(props, methodName) {
      if (!(0, _isPlainObject2["default"])(props)) {
        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
      }
    }

    function computeMergedProps(stateProps, dispatchProps, parentProps) {
      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
      if (false) {
        checkStateShape(mergedProps, 'mergeProps');
      }
      return mergedProps;
    }

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
      };

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.store = props.store || context.store;

        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));

        var storeState = _this.store.getState();
        _this.state = { storeState: storeState };
        _this.clearCache();
        return _this;
      }

      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
        if (!this.finalMapStateToProps) {
          return this.configureFinalMapState(store, props);
        }

        var state = store.getState();
        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);

        if (false) {
          checkStateShape(stateProps, 'mapStateToProps');
        }
        return stateProps;
      };

      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
        var mappedState = mapState(store.getState(), props);
        var isFactory = typeof mappedState === 'function';

        this.finalMapStateToProps = isFactory ? mappedState : mapState;
        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;

        if (isFactory) {
          return this.computeStateProps(store, props);
        }

        if (false) {
          checkStateShape(mappedState, 'mapStateToProps');
        }
        return mappedState;
      };

      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
        if (!this.finalMapDispatchToProps) {
          return this.configureFinalMapDispatch(store, props);
        }

        var dispatch = store.dispatch;

        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);

        if (false) {
          checkStateShape(dispatchProps, 'mapDispatchToProps');
        }
        return dispatchProps;
      };

      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
        var mappedDispatch = mapDispatch(store.dispatch, props);
        var isFactory = typeof mappedDispatch === 'function';

        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;

        if (isFactory) {
          return this.computeDispatchProps(store, props);
        }

        if (false) {
          checkStateShape(mappedDispatch, 'mapDispatchToProps');
        }
        return mappedDispatch;
      };

      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
        var nextStateProps = this.computeStateProps(this.store, this.props);
        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
          return false;
        }

        this.stateProps = nextStateProps;
        return true;
      };

      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
          return false;
        }

        this.dispatchProps = nextDispatchProps;
        return true;
      };

      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
          return false;
        }

        this.mergedProps = nextMergedProps;
        return true;
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return typeof this.unsubscribe === 'function';
      };

      Connect.prototype.trySubscribe = function trySubscribe() {
        if (shouldSubscribe && !this.unsubscribe) {
          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
          this.handleChange();
        }
      };

      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        this.trySubscribe();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
          this.haveOwnPropsChanged = true;
        }
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        this.tryUnsubscribe();
        this.clearCache();
      };

      Connect.prototype.clearCache = function clearCache() {
        this.dispatchProps = null;
        this.stateProps = null;
        this.mergedProps = null;
        this.haveOwnPropsChanged = true;
        this.hasStoreStateChanged = true;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;
        this.renderedElement = null;
        this.finalMapDispatchToProps = null;
        this.finalMapStateToProps = null;
      };

      Connect.prototype.handleChange = function handleChange() {
        if (!this.unsubscribe) {
          return;
        }

        var storeState = this.store.getState();
        var prevStoreState = this.state.storeState;
        if (pure && prevStoreState === storeState) {
          return;
        }

        if (pure && !this.doStatePropsDependOnOwnProps) {
          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
          if (!haveStatePropsChanged) {
            return;
          }
          if (haveStatePropsChanged === errorObject) {
            this.statePropsPrecalculationError = errorObject.value;
          }
          this.haveStatePropsBeenPrecalculated = true;
        }

        this.hasStoreStateChanged = true;
        this.setState({ storeState: storeState });
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');

        return this.refs.wrappedInstance;
      };

      Connect.prototype.render = function render() {
        var haveOwnPropsChanged = this.haveOwnPropsChanged,
            hasStoreStateChanged = this.hasStoreStateChanged,
            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
            statePropsPrecalculationError = this.statePropsPrecalculationError,
            renderedElement = this.renderedElement;


        this.haveOwnPropsChanged = false;
        this.hasStoreStateChanged = false;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;

        if (statePropsPrecalculationError) {
          throw statePropsPrecalculationError;
        }

        var shouldUpdateStateProps = true;
        var shouldUpdateDispatchProps = true;
        if (pure && renderedElement) {
          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
        }

        var haveStatePropsChanged = false;
        var haveDispatchPropsChanged = false;
        if (haveStatePropsBeenPrecalculated) {
          haveStatePropsChanged = true;
        } else if (shouldUpdateStateProps) {
          haveStatePropsChanged = this.updateStatePropsIfNeeded();
        }
        if (shouldUpdateDispatchProps) {
          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
        }

        var haveMergedPropsChanged = true;
        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
        } else {
          haveMergedPropsChanged = false;
        }

        if (!haveMergedPropsChanged && renderedElement) {
          return renderedElement;
        }

        if (withRef) {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
            ref: 'wrappedInstance'
          }));
        } else {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
        }

        return this.renderedElement;
      };

      return Connect;
    }(_react.Component);

    Connect.displayName = connectDisplayName;
    Connect.WrappedComponent = WrappedComponent;
    Connect.contextTypes = {
      store: _storeShape2["default"]
    };
    Connect.propTypes = {
      store: _storeShape2["default"]
    };

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        if (this.version === version) {
          return;
        }

        // We are hot reloading!
        this.version = version;
        this.trySubscribe();
        this.clearCache();
      };
    }

    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
  };
}

/***/ }),

/***/ "./node_modules/react-redux/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.connect = exports.Provider = undefined;

var _Provider = __webpack_require__("./node_modules/react-redux/lib/components/Provider.js");

var _Provider2 = _interopRequireDefault(_Provider);

var _connect = __webpack_require__("./node_modules/react-redux/lib/components/connect.js");

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.Provider = _Provider2["default"];
exports.connect = _connect2["default"];

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/shallowEqual.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/storeShape.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _propTypes2["default"].shape({
  subscribe: _propTypes2["default"].func.isRequired,
  dispatch: _propTypes2["default"].func.isRequired,
  getState: _propTypes2["default"].func.isRequired
});

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/warning.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),

/***/ "./node_modules/react-redux/lib/utils/wrapActionCreators.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = wrapActionCreators;

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

function wrapActionCreators(actionCreators) {
  return function (dispatch) {
    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
  };
}

/***/ }),

/***/ "./node_modules/react-relay/compat.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(673);

/***/ }),

/***/ "./node_modules/react-select/lib/Async.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__("./node_modules/react-select/lib/Select.js");

var _Select2 = _interopRequireDefault(_Select);

var _stripDiacritics = __webpack_require__("./node_modules/react-select/lib/utils/stripDiacritics.js");

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
	autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
	children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
	_propTypes2.default.string, _propTypes2.default.node]),
	multi: _propTypes2.default.bool, // multi-value input
	noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
	_propTypes2.default.string, _propTypes2.default.node]),
	onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
	onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
	options: _propTypes2.default.array.isRequired, // array of options
	placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	_propTypes2.default.string, _propTypes2.default.node]),
	searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
	_propTypes2.default.string, _propTypes2.default.node]),
	value: _propTypes2.default.any // initial field value
};

var defaultCache = {};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	_inherits(Async, _Component);

	function Async(props, context) {
		_classCallCheck(this, Async);

		var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	_createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this.setState({
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				if (callback === _this2._callback) {
					_this2._callback = null;

					var options = data && data.options || [];

					if (cache) {
						cache[inputValue] = options;
					}

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var transformedInputValue = inputValue;

			if (ignoreAccents) {
				transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			if (onInputChange) {
				onInputChange(transformedInputValue);
			}

			this.setState({ inputValue: inputValue });
			this.loadOptions(transformedInputValue);

			// Return the original input value to avoid modifying the user's view of the input while typing.
			return inputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    multi = _props3.multi,
			    onChange = _props3.onChange,
			    placeholder = _props3.placeholder,
			    value = _props3.value;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);

	return Async;
}(_react.Component);

exports.default = Async;


Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

function defaultChildren(props) {
	return _react2.default.createElement(_Select2.default, props);
}

/***/ }),

/***/ "./node_modules/react-select/lib/AsyncCreatable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__("./node_modules/react-select/lib/Select.js");

var _Select2 = _interopRequireDefault(_Select);

var _Async = __webpack_require__("./node_modules/react-select/lib/Async.js");

var _Async2 = _interopRequireDefault(_Async);

var _Creatable = __webpack_require__("./node_modules/react-select/lib/Creatable.js");

var _Creatable2 = _interopRequireDefault(_Creatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function reduce(obj) {
	var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	return Object.keys(obj).reduce(function (props, key) {
		var value = obj[key];
		if (value !== undefined) props[key] = value;
		return props;
	}, props);
}

var AsyncCreatableSelect = function (_React$Component) {
	_inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		_classCallCheck(this, AsyncCreatableSelect);

		return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	_createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_Async2.default,
				this.props,
				function (asyncProps) {
					return _react2.default.createElement(
						_Creatable2.default,
						_this2.props,
						function (creatableProps) {
							return _react2.default.createElement(_Select2.default, _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
								onInputChange: function onInputChange(input) {
									creatableProps.onInputChange(input);
									return asyncProps.onInputChange(input);
								},
								ref: function ref(_ref) {
									_this2.select = _ref;
									creatableProps.ref(_ref);
									asyncProps.ref(_ref);
								}
							}));
						}
					);
				}
			);
		}
	}]);

	return AsyncCreatableSelect;
}(_react2.default.Component);

;

exports.default = AsyncCreatableSelect;

/***/ }),

/***/ "./node_modules/react-select/lib/Creatable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__("./node_modules/react-select/lib/Select.js");

var _Select2 = _interopRequireDefault(_Select);

var _defaultFilterOptions = __webpack_require__("./node_modules/react-select/lib/utils/defaultFilterOptions.js");

var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);

var _defaultMenuRenderer = __webpack_require__("./node_modules/react-select/lib/utils/defaultMenuRenderer.js");

var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreatableSelect = function (_React$Component) {
	_inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		_classCallCheck(this, CreatableSelect);

		var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	_createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options,
			    shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions() {
			var _props2 = this.props,
			    filterOptions = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    options = _props2.options,
			    promptTextCreator = _props2.promptTextCreator;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.select.filterOptions();

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer(params) {
			var menuRenderer = this.props.menuRenderer;


			return menuRenderer(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;


			if (onInputChange) {
				onInputChange(input);
			}

			// This value may be needed in between Select mounts (when this.select is null)
			this.inputValue = input;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option, event) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    newOptionCreator = _props4.newOptionCreator,
			    shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption,
			    restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);

			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
				}
			});

			return children(props);
		}
	}]);

	return CreatableSelect;
}(_react2.default.Component);

;

function defaultChildren(props) {
	return _react2.default.createElement(_Select2.default, props);
};

function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

function isValidNewOption(_ref4) {
	var label = _ref4.label;

	return !!label;
};

function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';
	return option;
};

function promptTextCreator(label) {
	return 'Create option "' + label + '"';
}

function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
	}

	return false;
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: _defaultFilterOptions2.default,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: _defaultMenuRenderer2.default,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: _propTypes2.default.func,

	// See Select.propTypes.filterOptions
	filterOptions: _propTypes2.default.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: _propTypes2.default.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: _propTypes2.default.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: _propTypes2.default.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: _propTypes2.default.func,

	// input change handler: function (inputValue) {}
	onInputChange: _propTypes2.default.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: _propTypes2.default.func,

	// new option click handler: function (option) {}
	onNewOptionClick: _propTypes2.default.func,

	// See Select.propTypes.options
	options: _propTypes2.default.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: _propTypes2.default.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: _propTypes2.default.func
};

exports.default = CreatableSelect;

/***/ }),

/***/ "./node_modules/react-select/lib/Option.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Option = function (_React$Component) {
	_inherits(Option, _React$Component);

	function Option(props) {
		_classCallCheck(this, Option);

		var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	_createClass(Option, [{
		key: 'blockEvent',
		value: function blockEvent(event) {
			event.preventDefault();
			event.stopPropagation();
			if (event.target.tagName !== 'A' || !('href' in event.target)) {
				return;
			}
			if (event.target.target) {
				window.open(event.target.href, event.target.target);
			} else {
				window.location.href = event.target.href;
			}
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = (0, _classnames2.default)(this.props.className, option.className);

			return option.disabled ? _react2.default.createElement(
				'div',
				{ className: className,
					onMouseDown: this.blockEvent,
					onClick: this.blockEvent },
				this.props.children
			) : _react2.default.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);

	return Option;
}(_react2.default.Component);

;

Option.propTypes = {
	children: _propTypes2.default.node,
	className: _propTypes2.default.string, // className (based on mouse position)
	instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: _propTypes2.default.bool, // the option is disabled
	isFocused: _propTypes2.default.bool, // the option is focused
	isSelected: _propTypes2.default.bool, // the option is selected
	onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
	onSelect: _propTypes2.default.func, // method to handle click on option element
	onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
	option: _propTypes2.default.object.isRequired, // object that is base for that option
	optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
};

exports.default = Option;

/***/ }),

/***/ "./node_modules/react-select/lib/Select.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactInputAutosize = __webpack_require__("./node_modules/react-input-autosize/lib/AutosizeInput.js");

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultArrowRenderer = __webpack_require__("./node_modules/react-select/lib/utils/defaultArrowRenderer.js");

var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);

var _defaultFilterOptions = __webpack_require__("./node_modules/react-select/lib/utils/defaultFilterOptions.js");

var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);

var _defaultMenuRenderer = __webpack_require__("./node_modules/react-select/lib/utils/defaultMenuRenderer.js");

var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);

var _defaultClearRenderer = __webpack_require__("./node_modules/react-select/lib/utils/defaultClearRenderer.js");

var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);

var _Option = __webpack_require__("./node_modules/react-select/lib/Option.js");

var _Option2 = _interopRequireDefault(_Option);

var _Value = __webpack_require__("./node_modules/react-select/lib/Value.js");

var _Value2 = _interopRequireDefault(_Value);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Copyright (c) 2017 Jed Watson.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Licensed under the MIT License (MIT), see
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 http://jedwatson.github.io/react-select
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);

var instanceId = 1;

var Select = function (_React$Component) {
	_inherits(Select, _React$Component);

	function Select(props) {
		_classCallCheck(this, Select);

		var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleRequired', 'handleTouchOutside', 'handleTouchMove', 'handleTouchStart', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleValueClick', 'getOptionLabel', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	_createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps, nextState) {
			if (nextState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(nextState.isOpen);
				var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = _reactDom2.default.findDOMNode(this.focused);
				var menuNode = _reactDom2.default.findDOMNode(this.menu);
				menuNode.scrollTop = focusedOptionNode.offsetTop;
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = _reactDom2.default.findDOMNode(this.focused);
				var menuDOM = _reactDom2.default.findDOMNode(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				return;
			}

			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// TODO: This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: true,
					isPseudoFocused: false
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If the menu isn't open, let the event bubble to the main handleMouseDown
			if (!this.state.isOpen) {
				return;
			}
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
			// close the menu
			this.closeMenu();
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: this.handleInputValueChange('')
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;
			var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
			this.setState({
				isFocused: true,
				isOpen: isOpen
			});
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				isOpen: true,
				isPseudoFocused: false,
				inputValue: newInputValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						return;
					}
					this.selectFocusedOption();
					return;
				case 13:
					// enter
					if (!this.state.isOpen) return;
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 27:
					// escape
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 38:
					// up
					this.focusPreviousOption();
					break;
				case 40:
					// down
					this.focusNextOption();
					break;
				case 33:
					// page up
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						return;
					}
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						return;
					}
					this.focusStartOption();
					break;
				case 46:
					// backspace
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				default:
					return;
			}
			event.preventDefault();
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'handleRequired',
		value: function handleRequired(value, multi) {
			if (!value) return true;
			return multi ? value.length === 0 : Object.keys(value).length === 0;
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param	{String|Number|Array}	value		- the value of the select input
   * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value, nextProps) {
			var _this2 = this;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') value = value.split(props.delimiter);
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return _this2.expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = this.expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}

		/**
   * Retrieve a value from the given options and valueKey
   * @param	{String|Number|Array}	value	- the selected value(s)
   * @param	{Object}		props	- the Select component's props (or nextProps)
   */

	}, {
		key: 'expandValue',
		value: function expandValue(value, props) {
			var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
			if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
			var options = props.options,
			    valueKey = props.valueKey;

			if (!options) return;
			for (var i = 0; i < options.length; i++) {
				if (options[i][valueKey] === value) return options[i];
			}
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this3 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = this.handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.onChange) {
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this3.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this4 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			if (this.props.multi) {
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					_this4.addValue(value);
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this4.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i !== value;
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
			this.setValue(this.getResetValue());
			this.setState({
				isOpen: false,
				inputValue: this.handleInputValueChange('')
			}, this.focus);
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
				});
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var potentialIndex = focusedIndex + this.props.pageSize;
				if (potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'getInputValue',
		value: function getInputValue() {
			return this.state.inputValue;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return _react2.default.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				_react2.default.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				return !this.state.inputValue ? _react2.default.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return _react2.default.createElement(
						ValueComponent,
						{
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							disabled: _this5.props.disabled || value.clearableValue === false,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							value: value
						},
						renderLabel(value, i),
						_react2.default.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (!this.state.inputValue) {
				if (isOpen) onClick = null;
				return _react2.default.createElement(
					ValueComponent,
					{
						id: this._instancePrefix + '-value-item',
						disabled: this.props.disabled,
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
			var isOpen = !!this.state.isOpen;

			var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var inputProps = _extends({}, this.props.inputProps, {
				role: 'combobox',
				'aria-expanded': '' + isOpen,
				'aria-owns': ariaOwns,
				'aria-haspopup': '' + isOpen,
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-label': this.props['aria-label'],
				className: className,
				tabIndex: this.props.tabIndex,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				required: this.state.required,
				value: this.state.inputValue
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var _props$inputProps = this.props.inputProps,
				    inputClassName = _props$inputProps.inputClassName,
				    divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);

				var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));

				return _react2.default.createElement('div', _extends({}, divProps, {
					role: 'combobox',
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					className: className,
					tabIndex: this.props.tabIndex || 0,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					'aria-readonly': '' + !!this.props.disabled,
					style: { border: 0, width: 1, display: 'inline-block' } }));
			}

			if (this.props.autosize) {
				return _react2.default.createElement(_reactInputAutosize2.default, _extends({}, inputProps, { minWidth: '5' }));
			}
			return _react2.default.createElement(
				'div',
				{ className: className },
				_react2.default.createElement('input', inputProps)
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			if (!this.props.clearable || this.props.value === undefined || this.props.value === null || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
			var clear = this.props.clearRenderer();

			return _react2.default.createElement(
				'span',
				{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					onMouseDown: this.clearValue,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEndClearValue
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			return _react2.default.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;

				return filterOptions(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey,
					onOptionRef: this.onOptionRef
				});
			} else if (this.props.noResultsText) {
				return _react2.default.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return _react2.default.createElement('input', {
					type: 'hidden',
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					name: this.props.name,
					value: value,
					disabled: this.props.disabled });
			}
			return valueArray.map(function (item, index) {
				return _react2.default.createElement('input', { key: 'hidden.' + index,
					type: 'hidden',
					ref: 'value' + index,
					name: _this7.props.name,
					value: stringifyValue(item[_this7.props.valueKey]),
					disabled: _this7.props.disabled });
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return _react2.default.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				_react2.default.createElement(
					'div',
					{ ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						}, role: 'listbox', tabIndex: -1, className: 'Select-menu', id: this._instancePrefix + '-list',
						style: this.props.menuStyle,
						onScroll: this.handleMenuScroll,
						onMouseDown: this.handleMouseDownOnMenu },
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = (0, _classnames2.default)('Select', this.props.className, {
				'Select--multi': this.props.multi,
				'Select--single': !this.props.multi,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'has-value': valueArray.length
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = _react2.default.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return _react2.default.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				_react2.default.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						style: this.props.style,
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove
					},
					_react2.default.createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
			);
		}
	}]);

	return Select;
}(_react2.default.Component);

;

Select.propTypes = {
	'aria-describedby': _propTypes2.default.string, // HTML ID(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': _propTypes2.default.string, // Aria label (for assistive tech)
	'aria-labelledby': _propTypes2.default.string, // HTML ID of an element that should be used as the label (for assistive tech)
	addLabelText: _propTypes2.default.string, // placeholder displayed when you want to add a label on a multi-value input
	arrowRenderer: _propTypes2.default.func, // Create drop-down caret element
	autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
	autofocus: _propTypes2.default.bool, // autofocus the component on mount
	autosize: _propTypes2.default.bool, // whether to enable autosizing or not
	backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: _propTypes2.default.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: _propTypes2.default.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: _propTypes2.default.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: _propTypes2.default.bool, // should it be possible to reset value
	closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
	deleteRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
	delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
	disabled: _propTypes2.default.bool, // whether the Select is disabled or not
	escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
	filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
	filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
	ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
	inputProps: _propTypes2.default.object, // custom attributes for the Input
	inputRenderer: _propTypes2.default.func, // returns a custom input component
	instanceId: _propTypes2.default.string, // set the components instanceId
	isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: _propTypes2.default.string, // path of the label value in option objects
	matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
	matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
	menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
	menuRenderer: _propTypes2.default.func, // renders a custom menu with options
	menuStyle: _propTypes2.default.object, // optional style to apply to the menu
	multi: _propTypes2.default.bool, // multi-value input
	name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
	onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
	onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
	onClose: _propTypes2.default.func, // fires when the menu is closed
	onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
	onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: _propTypes2.default.func, // fires when the menu is opened
	onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: _propTypes2.default.bool, // always open options menu on focus
	optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: _propTypes2.default.func, // option component to render in dropdown
	optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
	options: _propTypes2.default.array, // array of options
	pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
	resetValue: _propTypes2.default.any, // value to use when you clear the control
	scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: _propTypes2.default.bool, // whether to enable searching feature or not
	simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: _propTypes2.default.object, // optional style to apply to the control
	tabIndex: _propTypes2.default.string, // optional tab index of the control
	tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
	value: _propTypes2.default.any, // initial field value
	valueComponent: _propTypes2.default.func, // value component to render
	valueKey: _propTypes2.default.string, // path of the label value in option objects
	valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
	wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
};

Select.defaultProps = {
	addLabelText: 'Add "{label}"?',
	arrowRenderer: _defaultArrowRenderer2.default,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: _defaultClearRenderer2.default,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: _defaultFilterOptions2.default,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: _defaultMenuRenderer2.default,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onSelectResetsInput: true,
	onCloseResetsInput: true,
	openOnClick: true,
	optionComponent: _Option2.default,
	pageSize: 5,
	placeholder: 'Select...',
	required: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	valueComponent: _Value2.default,
	valueKey: 'value'
};

exports.default = Select;

/***/ }),

/***/ "./node_modules/react-select/lib/Value.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Value = function (_React$Component) {
	_inherits(Value, _React$Component);

	function Value(props) {
		_classCallCheck(this, Value);

		var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	_createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return _react2.default.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? _react2.default.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : _react2.default.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);

	return Value;
}(_react2.default.Component);

;

Value.propTypes = {
	children: _propTypes2.default.node,
	disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
	id: _propTypes2.default.string, // Unique id for the value - used for aria
	onClick: _propTypes2.default.func, // method to handle click on value label
	onRemove: _propTypes2.default.func, // method to handle removal of the value
	value: _propTypes2.default.object.isRequired // the option object for this value
};

exports.default = Value;

/***/ }),

/***/ "./node_modules/react-select/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;

var _Select = __webpack_require__("./node_modules/react-select/lib/Select.js");

var _Select2 = _interopRequireDefault(_Select);

var _Async = __webpack_require__("./node_modules/react-select/lib/Async.js");

var _Async2 = _interopRequireDefault(_Async);

var _AsyncCreatable = __webpack_require__("./node_modules/react-select/lib/AsyncCreatable.js");

var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);

var _Creatable = __webpack_require__("./node_modules/react-select/lib/Creatable.js");

var _Creatable2 = _interopRequireDefault(_Creatable);

var _Value = __webpack_require__("./node_modules/react-select/lib/Value.js");

var _Value2 = _interopRequireDefault(_Value);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Select2.default.Async = _Async2.default;
_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
_Select2.default.Creatable = _Creatable2.default;
_Select2.default.Value = _Value2.default;

exports.default = _Select2.default;
exports.Async = _Async2.default;
exports.AsyncCreatable = _AsyncCreatable2.default;
exports.Creatable = _Creatable2.default;
exports.Value = _Value2.default;

/***/ }),

/***/ "./node_modules/react-select/lib/utils/defaultArrowRenderer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = arrowRenderer;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return _react2.default.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: _propTypes2.default.func
};

/***/ }),

/***/ "./node_modules/react-select/lib/utils/defaultClearRenderer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = clearRenderer;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clearRenderer() {
	return _react2.default.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

/***/ }),

/***/ "./node_modules/react-select/lib/utils/defaultFilterOptions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stripDiacritics = __webpack_require__("./node_modules/react-select/lib/utils/stripDiacritics.js");

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterOptions(options, filterValue, excludeOptions, props) {
	var _this = this;

	if (props.ignoreAccents) {
		filterValue = (0, _stripDiacritics2.default)(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
		if (!filterValue) return true;
		var valueTest = String(option[props.valueKey]);
		var labelTest = String(option[props.labelKey]);
		if (props.ignoreAccents) {
			if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
			if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
		}
		if (props.ignoreCase) {
			if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}
		return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
}

exports.default = filterOptions;

/***/ }),

/***/ "./node_modules/react-select/lib/utils/defaultMenuRenderer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    instancePrefix = _ref.instancePrefix,
	    labelKey = _ref.labelKey,
	    onFocus = _ref.onFocus,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey,
	    onOptionRef = _ref.onOptionRef;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.indexOf(option) > -1;
		var isFocused = option === focusedOption;
		var optionClass = (0, _classnames2.default)(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return _react2.default.createElement(
			Option,
			{
				className: optionClass,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				}
			},
			optionRenderer(option, i)
		);
	});
}

exports.default = menuRenderer;

/***/ }),

/***/ "./node_modules/react-select/lib/utils/stripDiacritics.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = stripDiacritics;
var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

/***/ }),

/***/ "./node_modules/react-transition-group/CSSTransition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__("./node_modules/dom-helpers/class/addClass.js");

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__("./node_modules/dom-helpers/class/removeClass.js");

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__("./node_modules/react-transition-group/Transition.js");

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters or exits.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-exit`, `fade-exit-active`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   * }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  exit?: string,
   *  exitActive?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** from the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** from the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ```js
 * import CSSTransition from 'react-transition-group/CSSTransition';
 *
 * const Fade = ({ children, ...props }) => (
 *  <CSSTransition
 *    {...props}
 *    timeout={500}
 *    classNames="fade"
 *  >
 *   {children}
 *  </CSSTransition>
 * );
 *
 * class FadeInAndOut extends React.Component {
 *   constructor(...args) {
 *     super(...args);
 *     this.state= { show: false }
 *
 *     setInterval(() => {
 *       this.setState({ show: !this.state.show })
 *     }, 5000)
 *   }
 *   render() {
 *     return (
 *       <Fade in={this.state.show}>
 *         <div>Hello world</div>
 *       </Fade>
 *     )
 *   }
 * }
 * ```
 *
 * And the coorresponding CSS for the `<Fade>` component:
 *
 * ```css
 * .fade-enter {
 *   opacity: 0.01;
 * }
 *
 * .fade-enter.fade-enter-active {
 *   opacity: 1;
 *   transition: opacity 500ms ease-in;
 * }
 *
 * .fade-exit {
 *   opacity: 1;
 * }
 *
 * .fade-exit.fade-exit-active {
 *   opacity: 0.01;
 *   transition: opacity 300ms ease-in;
 * }
 * ```
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      _this.removeClasses(node, 'exit');

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      return { className: className, activeClassName: activeClassName };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    /* eslint-disable no-unused-expressions */
    node.scrollTop;
    /* eslint-enable no-unused-expressions */
    addClass(node, className);
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/Transition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__("./node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm A fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `ENTERING`
 *  - `ENTERED`
 *  - `EXITING`
 *  - `EXITED`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state= { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEventListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),

/***/ "./node_modules/react-transition-group/TransitionGroup.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _ChildMapping = __webpack_require__("./node_modules/react-transition-group/utils/ChildMapping.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disabled appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disabled enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disabled exit animations
    * for all children. Note that specifying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ```jsx
 * import TransitionGroup from 'react-transition-group/TransitionGroup';
 *
 * class TodoList extends React.Component {
 *   constructor(props) {
 *     super(props)
 *     this.state = {items: ['hello', 'world', 'click', 'me']}
 *   }
 *   handleAdd() {
 *     const newItems = this.state.items.concat([
 *       prompt('Enter some text')
 *     ]);
 *     this.setState({ items: newItems });
 *   }
 *   handleRemove(i) {
 *     let newItems = this.state.items.slice();
 *     newItems.splice(i, 1);
 *     this.setState({items: newItems});
 *   }
 *   render() {
 *     return (
 *       <div>
 *         <button onClick={() => this.handleAdd()}>Add Item</button>
 *         <TransitionGroup>
 *           {this.state.items.map((item, i) => (
 *             <FadeTransition key={item}>
 *               <div>
 *                 {item}{' '}
 *                 <button onClick={() => this.handleRemove(i)}>
 *                   remove
 *                 </button>
 *               </div>
 *             </FadeTransition>
 *           ))}
 *         </TransitionGroup>
 *       </div>
 *     );
 *   }
 * }
 * ```
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleExited = function (key, node, originalHandler) {
      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (key in currentChildMapping) return;

      if (originalHandler) originalHandler(node);

      _this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[key];
        return { children: children };
      });
    };

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
        var onExited = function onExited(node) {
          _this.handleExited(child.key, node, child.props.onExited);
        };

        return (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);

    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, _react.isValidElement)(child)) return;

      var onExited = function onExited(node) {
        _this2.handleExited(child.key, node, child.props.onExited);
      };

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, _react.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, _react.cloneElement)(child, {
              onExited: onExited,
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = this.state.children;


    delete props.appear;
    delete props.enter;
    delete props.exit;

    return _react2.default.createElement(
      Component,
      props,
      values(children).map(childFactory)
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/react-transition-group/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__("./node_modules/react-transition-group/CSSTransition.js");

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _TransitionGroup = __webpack_require__("./node_modules/react-transition-group/TransitionGroup.js");

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__("./node_modules/react-transition-group/Transition.js");

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),

/***/ "./node_modules/react-transition-group/utils/ChildMapping.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__("./node_modules/react/react.js");

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),

/***/ "./node_modules/react-transition-group/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),

/***/ "./node_modules/react/react.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(22);

/***/ }),

/***/ "./node_modules/redux-thunk/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),

/***/ "./node_modules/redux/es/applyMiddleware.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__("./node_modules/redux/es/compose.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["default"].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),

/***/ "./node_modules/redux/es/bindActionCreators.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),

/***/ "./node_modules/redux/es/combineReducers.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__("./node_modules/redux/es/createStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__("./node_modules/lodash-es/isPlainObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__("./node_modules/redux/es/utils/warning.js");




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["ActionTypes"].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["default"])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["ActionTypes"].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["ActionTypes"].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) {
    var unexpectedKeyCache = {};
  }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),

/***/ "./node_modules/redux/es/compose.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}

/***/ }),

/***/ "./node_modules/redux/es/createStore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActionTypes", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["default"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__("./node_modules/lodash-es/isPlainObject.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__("./node_modules/symbol-observable/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["default"])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),

/***/ "./node_modules/redux/es/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__("./node_modules/redux/es/createStore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__("./node_modules/redux/es/combineReducers.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__("./node_modules/redux/es/bindActionCreators.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__("./node_modules/redux/es/applyMiddleware.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__("./node_modules/redux/es/compose.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__("./node_modules/redux/es/utils/warning.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["default"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),

/***/ "./node_modules/redux/es/utils/warning.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),

/***/ "./node_modules/relay-query-lookup-renderer/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/react.js");
var PropTypes = __webpack_require__("./node_modules/prop-types/index.js");
var areEqual = __webpack_require__("./node_modules/fbjs/lib/areEqual.js");
var deepFreeze = __webpack_require__("./node_modules/deep-freeze/index.js");

/**
 * Taken from react-relay QueryRenderer with one addition.
 * - lookup prop will check the relay store for data first and if present will
 * immediately call `render` with props.
 *
 * This will not be necessary if this PR is merged:
 * https://github.com/facebook/relay/pull/1760
 */

var ReactRelayQueryRenderer = function (_React$Component) {
    _inherits(ReactRelayQueryRenderer, _React$Component);

    function ReactRelayQueryRenderer(props, context) {
        _classCallCheck(this, ReactRelayQueryRenderer);

        var _this = _possibleConstructorReturn(this, (ReactRelayQueryRenderer.__proto__ || Object.getPrototypeOf(ReactRelayQueryRenderer)).call(this, props, context));

        _this._onChange = function (snapshot) {
            _this.setState({
                readyState: _extends({}, _this.state.readyState, {
                    props: snapshot.data
                })
            });
        };

        var query = props.query,
            variables = props.variables,
            lookup = props.lookup;

        var environment = props.environment;
        var operation = null;
        if (query) {
            var _environment$unstable = environment.unstable_internal,
                createOperationSelector = _environment$unstable.createOperationSelector,
                getOperation = _environment$unstable.getOperation;

            query = getOperation(query);
            operation = createOperationSelector(query, variables);
            variables = operation.variables;
        }

        _this._mounted = false;
        _this._operation = operation;
        _this._pendingFetch = null;
        _this._relayContext = {
            environment: environment,
            variables: variables
        };
        _this._rootSubscription = null;
        _this._selectionReference = null;

        if (operation) {
            if (lookup && environment.check(operation.root)) {
                // data is available in the store, render without making any requests
                var snapshot = environment.lookup(operation.fragment);
                _this.state = {
                    readyState: {
                        error: null,
                        props: snapshot.data,
                        retry: function retry() {
                            _this._fetch(operation, props.cacheConfig);
                        }
                    }
                };
            } else {
                _this.state = {
                    readyState: getDefaultState()
                };
                _this._fetch(operation, props.cacheConfig);
            }
        } else {
            _this.state = {
                readyState: {
                    error: null,
                    props: {},
                    retry: null
                }
            };
        }
        return _this;
    }

    _createClass(ReactRelayQueryRenderer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._mounted = true;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _this2 = this;

            if (nextProps.query !== this.props.query || nextProps.environment !== this.props.environment || !areEqual(nextProps.variables, this.props.variables)) {
                var query = nextProps.query,
                    variables = nextProps.variables;

                var environment = nextProps.environment;
                if (query) {
                    var _environment$unstable2 = environment.unstable_internal,
                        createOperationSelector = _environment$unstable2.createOperationSelector,
                        getOperation = _environment$unstable2.getOperation;

                    var operation = createOperationSelector(getOperation(query), variables);
                    this._operation = operation;
                    this._relayContext = {
                        environment: environment,
                        variables: operation.variables
                    };
                    if (nextProps.lookup && environment.check(operation.root)) {
                        var snapshot = environment.lookup(operation.fragment);
                        this.setState({
                            readyState: {
                                error: null,
                                props: snapshot.data,
                                retry: function retry() {
                                    _this2._fetch(operation, nextProps.cacheConfig);
                                }
                            }
                        });
                    } else {
                        this._fetch(operation, nextProps.cacheConfig);
                        this.setState({
                            readyState: getDefaultState()
                        });
                    }
                } else {
                    this._operation = null;
                    this._relayContext = {
                        environment: environment,
                        variables: variables
                    };
                    this._release();
                    this.setState({
                        readyState: {
                            error: null,
                            props: {},
                            retry: null
                        }
                    });
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._release();
            this._mounted = false;
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextProps.render !== this.props.render || nextState.readyState !== this.state.readyState;
        }
    }, {
        key: '_release',
        value: function _release() {
            if (this._pendingFetch) {
                this._pendingFetch.dispose();
                this._pendingFetch = null;
            }
            if (this._rootSubscription) {
                this._rootSubscription.dispose();
                this._rootSubscription = null;
            }
            if (this._selectionReference) {
                this._selectionReference.dispose();
                this._selectionReference = null;
            }
        }
    }, {
        key: '_fetch',
        value: function _fetch(operation, cacheConfig) {
            var _this3 = this;

            var environment = this._relayContext.environment;

            // Immediately retain the results of the new query to prevent relevant data
            // from being freed. This is not strictly required if all new data is
            // fetched in a single step, but is necessary if the network could attempt
            // to incrementally load data (ex: multiple query entries or incrementally
            // loading records from disk cache).

            var nextReference = environment.retain(operation.root);

            var readyState = getDefaultState();
            var snapshot = void 0; // results of the root fragment
            var onCompleted = function onCompleted() {
                _this3._pendingFetch = null;
            };
            var onError = function onError(error) {
                readyState = {
                    error: error,
                    props: null,
                    retry: function retry() {
                        _this3._fetch(operation, cacheConfig);
                    }
                };
                if (_this3._selectionReference) {
                    _this3._selectionReference.dispose();
                }
                _this3._pendingFetch = null;
                _this3._selectionReference = nextReference;
                _this3.setState({ readyState: readyState });
            };
            var onNext = function onNext() {
                // `onNext` can be called multiple times by network layers that support
                // data subscriptions. Wait until the first payload to render `props` and
                // subscribe for data updates.
                if (snapshot) {
                    return;
                }
                snapshot = environment.lookup(operation.fragment);
                readyState = {
                    error: null,
                    props: snapshot.data,
                    retry: function retry() {
                        _this3._fetch(operation, cacheConfig);
                    }
                };

                if (_this3._selectionReference) {
                    _this3._selectionReference.dispose();
                }
                _this3._rootSubscription = environment.subscribe(snapshot, _this3._onChange);
                _this3._selectionReference = nextReference;
                _this3.setState({ readyState: readyState });
            };

            if (this._pendingFetch) {
                this._pendingFetch.dispose();
            }
            if (this._rootSubscription) {
                this._rootSubscription.dispose();
            }
            var request = environment.streamQuery({
                cacheConfig: cacheConfig,
                onCompleted: onCompleted,
                onError: onError,
                onNext: onNext,
                operation: operation
            });
            this._pendingFetch = {
                dispose: function dispose() {
                    request.dispose();
                    nextReference.dispose();
                }
            };
        }
    }, {
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                relay: this._relayContext
            };
        }
    }, {
        key: 'render',
        value: function render() {
            // Note that the root fragment results in `readyState.props` is already
            // frozen by the store; this call is to freeze the readyState object and
            // error property if set.
            if (false) {
                deepFreeze(this.state.readyState);
            }
            return this.props.render(this.state.readyState);
        }
    }]);

    return ReactRelayQueryRenderer;
}(React.Component);

ReactRelayQueryRenderer.childContextTypes = {
    relay: PropTypes.object.isRequired
};

function getDefaultState() {
    return {
        error: null,
        props: null,
        retry: null
    };
}

module.exports = ReactRelayQueryRenderer;

/***/ }),

/***/ "./node_modules/relay-runtime/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(16);

/***/ }),

/***/ "./node_modules/server-vars/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var get = __webpack_require__("./node_modules/lodash.get/index.js");

var serverVarsFactory = function () {
    return Object.create({
        store: {},
        add: function (key, val) {
            if (typeof key === 'object') {
                // copy all properties into the store
                Object.assign(this.store, key);
            } else {
                // set on the store (copy if an object)
                this.store[key] = (!Array.isArray(val) && typeof val === 'object') ? Object.assign({}, val) : val;
            }
        },
        get: function(key) {
            if (!key) {
                // return a copy of the entire store
                return Object.create({}, this.store);
            }
            return get(this.store, key);
        },
        inject: function () {
            return '<script type="text/javascript">' +
                'window.__SERVER_VARS__ = ' +
                    // safely embed JSON within HTML
                    // see http://stackoverflow.com/a/4180424/266795
                JSON.stringify(this.store)
                    .replace(/</g, '\\u003c')
                    .replace(/-->/g, '--\\>')
                    .replace(/\u2028/g, '\\u2028')
                    .replace(/\u2029/g, '\\u2029') +
                ';</script>';
        }
    });
};

var serverVars = serverVarsFactory();

serverVars.middleware = function (req, res, next) {
    if (res.serverVars === undefined) {
        res.serverVars = res.locals.serverVars = serverVarsFactory();
        res.serverVars.add(Object.assign({}, serverVars.store)); // get a copy of app-wide serverVars
    }
    next();
};

// on the client, this module exports the bootstrapped serverVars
if (typeof window !== 'undefined' && window.__SERVER_VARS__) {
    serverVars = window.__SERVER_VARS__;
    serverVars.get = function (key) {
        return get(serverVars, key);
    };
}

module.exports = serverVars;


/***/ }),

/***/ "./node_modules/simply-deferred/deferred.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.6.3
(function() {
  var Deferred, PENDING, REJECTED, RESOLVED, VERSION, after, execute, flatten, has, installInto, isArguments, isPromise, wrap, _when,
    __slice = [].slice;

  VERSION = '3.0.0';

  PENDING = "pending";

  RESOLVED = "resolved";

  REJECTED = "rejected";

  has = function(obj, prop) {
    return obj != null ? obj.hasOwnProperty(prop) : void 0;
  };

  isArguments = function(obj) {
    return has(obj, 'length') && has(obj, 'callee');
  };

  isPromise = function(obj) {
    return has(obj, 'promise') && typeof (obj != null ? obj.promise : void 0) === 'function';
  };

  flatten = function(array) {
    if (isArguments(array)) {
      return flatten(Array.prototype.slice.call(array));
    }
    if (!Array.isArray(array)) {
      return [array];
    }
    return array.reduce(function(memo, value) {
      if (Array.isArray(value)) {
        return memo.concat(flatten(value));
      }
      memo.push(value);
      return memo;
    }, []);
  };

  after = function(times, func) {
    if (times <= 0) {
      return func();
    }
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  wrap = function(func, wrapper) {
    return function() {
      var args;
      args = [func].concat(Array.prototype.slice.call(arguments, 0));
      return wrapper.apply(this, args);
    };
  };

  execute = function(callbacks, args, context) {
    var callback, _i, _len, _ref, _results;
    _ref = flatten(callbacks);
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      callback = _ref[_i];
      _results.push(callback.call.apply(callback, [context].concat(__slice.call(args))));
    }
    return _results;
  };

  Deferred = function() {
    var candidate, close, closingArguments, doneCallbacks, failCallbacks, progressCallbacks, state;
    state = PENDING;
    doneCallbacks = [];
    failCallbacks = [];
    progressCallbacks = [];
    closingArguments = {
      'resolved': {},
      'rejected': {},
      'pending': {}
    };
    this.promise = function(candidate) {
      var pipe, storeCallbacks;
      candidate = candidate || {};
      candidate.state = function() {
        return state;
      };
      storeCallbacks = function(shouldExecuteImmediately, holder, holderState) {
        return function() {
          if (state === PENDING) {
            holder.push.apply(holder, flatten(arguments));
          }
          if (shouldExecuteImmediately()) {
            execute(arguments, closingArguments[holderState]);
          }
          return candidate;
        };
      };
      candidate.done = storeCallbacks((function() {
        return state === RESOLVED;
      }), doneCallbacks, RESOLVED);
      candidate.fail = storeCallbacks((function() {
        return state === REJECTED;
      }), failCallbacks, REJECTED);
      candidate.progress = storeCallbacks((function() {
        return state !== PENDING;
      }), progressCallbacks, PENDING);
      candidate.always = function() {
        var _ref;
        return (_ref = candidate.done.apply(candidate, arguments)).fail.apply(_ref, arguments);
      };
      pipe = function(doneFilter, failFilter, progressFilter) {
        var filter, master;
        master = new Deferred();
        filter = function(source, funnel, callback) {
          if (!callback) {
            return candidate[source](master[funnel]);
          }
          return candidate[source](function() {
            var args, value;
            args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
            value = callback.apply(null, args);
            if (isPromise(value)) {
              return value.done(master.resolve).fail(master.reject).progress(master.notify);
            } else {
              return master[funnel](value);
            }
          });
        };
        filter('done', 'resolve', doneFilter);
        filter('fail', 'reject', failFilter);
        filter('progress', 'notify', progressFilter);
        return master;
      };
      candidate.pipe = pipe;
      candidate.then = pipe;
      if (candidate.promise == null) {
        candidate.promise = function() {
          return candidate;
        };
      }
      return candidate;
    };
    this.promise(this);
    candidate = this;
    close = function(finalState, callbacks, context) {
      return function() {
        if (state === PENDING) {
          state = finalState;
          closingArguments[finalState] = arguments;
          execute(callbacks, closingArguments[finalState], context);
          return candidate;
        }
        return this;
      };
    };
    this.resolve = close(RESOLVED, doneCallbacks);
    this.reject = close(REJECTED, failCallbacks);
    this.notify = close(PENDING, progressCallbacks);
    this.resolveWith = function(context, args) {
      return close(RESOLVED, doneCallbacks, context).apply(null, args);
    };
    this.rejectWith = function(context, args) {
      return close(REJECTED, failCallbacks, context).apply(null, args);
    };
    this.notifyWith = function(context, args) {
      return close(PENDING, progressCallbacks, context).apply(null, args);
    };
    return this;
  };

  _when = function() {
    var def, defs, finish, resolutionArgs, trigger, _i, _len;
    defs = flatten(arguments);
    if (defs.length === 1) {
      if (isPromise(defs[0])) {
        return defs[0];
      } else {
        return (new Deferred()).resolve(defs[0]).promise();
      }
    }
    trigger = new Deferred();
    if (!defs.length) {
      return trigger.resolve().promise();
    }
    resolutionArgs = [];
    finish = after(defs.length, function() {
      return trigger.resolve.apply(trigger, resolutionArgs);
    });
    defs.forEach(function(def, index) {
      if (isPromise(def)) {
        return def.done(function() {
          var args;
          args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
          resolutionArgs[index] = args.length > 1 ? args : args[0];
          return finish();
        });
      } else {
        resolutionArgs[index] = def;
        return finish();
      }
    });
    for (_i = 0, _len = defs.length; _i < _len; _i++) {
      def = defs[_i];
      isPromise(def) && def.fail(trigger.reject);
    }
    return trigger.promise();
  };

  installInto = function(fw) {
    fw.Deferred = function() {
      return new Deferred();
    };
    fw.ajax = wrap(fw.ajax, function(ajax, options) {
      var createWrapper, def, promise, xhr;
      if (options == null) {
        options = {};
      }
      def = new Deferred();
      createWrapper = function(wrapped, finisher) {
        return wrap(wrapped, function() {
          var args, func;
          func = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
          if (func) {
            func.apply(null, args);
          }
          return finisher.apply(null, args);
        });
      };
      options.success = createWrapper(options.success, def.resolve);
      options.error = createWrapper(options.error, def.reject);
      xhr = ajax(options);
      promise = def.promise();
      promise.abort = function() {
        return xhr.abort();
      };
      return promise;
    });
    return fw.when = _when;
  };

  if (true) {
    exports.Deferred = function() {
      return new Deferred();
    };
    exports.when = _when;
    exports.installInto = installInto;
  } else if (typeof define === 'function' && define.amd) {
    define(function() {
      if (typeof Zepto !== 'undefined') {
        return installInto(Zepto);
      } else {
        Deferred.when = _when;
        Deferred.installInto = installInto;
        return Deferred;
      }
    });
  } else if (typeof Zepto !== 'undefined') {
    installInto(Zepto);
  } else {
    this.Deferred = function() {
      return new Deferred();
    };
    this.Deferred.when = _when;
    this.Deferred.installInto = installInto;
  }

}).call(this);


/***/ }),

/***/ "./node_modules/style-loader/addStyles.js":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "./node_modules/symbol-observable/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./node_modules/symbol-observable/lib/index.js");


/***/ }),

/***/ "./node_modules/symbol-observable/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__("./node_modules/symbol-observable/lib/ponyfill.js");

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js"), __webpack_require__("./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/symbol-observable/lib/ponyfill.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(110);

/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./node_modules/yaDeferred/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {

    var resolveRef;
    var rejectRef;

    var promise = new Promise(function (resolve, reject) {
        resolveRef = resolve;
        rejectRef = reject;
    });

    return {
        resolve: function () {
            resolveRef.apply(this, arguments);
            return promise;
        },
        reject: function () {
            rejectRef.apply(this, arguments);
            return promise;
        },
        then: promise.then.bind(promise),
        catch: promise.catch.bind(promise)
    };
};


/***/ }),

/***/ "./src/abandonedCheckout/autoModalHelper.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wasModalShown = exports.setModalShown = exports.loadAutoModal = undefined;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars
var AUTO_MODAL_SHOWN = 'autoModalShown';
var MODAL_SHOW_DELAY = 2000;

var loadAutoModal = exports.loadAutoModal = function loadAutoModal(_ref) {
    var AutoModal = _ref.AutoModal,
        modalProps = _ref.modalProps;

    if (AutoModal) {
        setTimeout(function () {
            var div = document.createElement('div');
            document.body.appendChild(div);
            _reactDom2.default.render(_react2.default.createElement(AutoModal, modalProps), div);
        }, MODAL_SHOW_DELAY);
    }
};

var setModalShown = exports.setModalShown = function setModalShown() {
    _dibsBrowserStorage.sessionStorage.setItem(AUTO_MODAL_SHOWN, true);
};

var wasModalShown = exports.wasModalShown = function wasModalShown() {
    return _dibsBrowserStorage.sessionStorage.getItem(AUTO_MODAL_SHOWN) || _dibsBrowserStorage.sessionStorage.getItem('authModalShown');
};

/***/ }),

/***/ "./src/abandonedCheckout/checkoutStorage.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/19/14
 * Time: 10:33 AM
 */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _require = __webpack_require__("./node_modules/dibs-browser-storage/index.js"),
    localStorage = _require.localStorage;

var _require2 = __webpack_require__("./src/utils/checkoutStorageConstants.js"),
    STORAGE = _require2.STORAGE;

exports.default = {
    clearPreAuthOfferModalInfo: function clearPreAuthOfferModalInfo() {
        return localStorage.deleteItem('checkoutPreAuthOfferModalInfo');
    },
    unsetAutoModalInfo: function unsetAutoModalInfo() {
        localStorage.deleteItem(STORAGE.AUTO_MODAL_INFO);
    },
    unsetSurveyInfo: function unsetSurveyInfo() {
        return localStorage.deleteItem(STORAGE.SURVEY_INFO);
    }
};

/***/ }),

/***/ "./src/abandonedCheckout/components/AutoModal.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _BarHeader = __webpack_require__("./node_modules/dibs-elements/dist/BarHeader/index.js");

var _BarHeader2 = _interopRequireDefault(_BarHeader);

var _ModalBody = __webpack_require__("./node_modules/dibs-elements/dist/ModalBody/index.js");

var _ModalBody2 = _interopRequireDefault(_ModalBody);

var _ModalContainer = __webpack_require__("./node_modules/dibs-elements/dist/ModalContainer/index.js");

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _Primary = __webpack_require__("./node_modules/dibs-elements/dist/Button/Primary.js");

var _Primary2 = _interopRequireDefault(_Primary);

__webpack_require__("./node_modules/dibs-elements/dist/Button/buyer/Primary.css");

var _AutoModal = __webpack_require__("./src/abandonedCheckout/components/AutoModal.scss");

var _AutoModal2 = _interopRequireDefault(_AutoModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoModal = function (_Component) {
    _inherits(AutoModal, _Component);

    function AutoModal() {
        _classCallCheck(this, AutoModal);

        var _this = _possibleConstructorReturn(this, (AutoModal.__proto__ || Object.getPrototypeOf(AutoModal)).call(this));

        _this.state = {
            modalOpened: true
        };

        _this.closeModal = _this.closeModal.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(AutoModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.trackModalEvents({
                modalAction: 'displayed'
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.setState({
                modalOpened: false
            });
        }
    }, {
        key: 'trackModalEvents',
        value: function trackModalEvents(_ref) {
            var modalAction = _ref.modalAction;
            var tracking = this.props.tracking;

            if (tracking) {
                var category = tracking.category,
                    action = tracking.action,
                    label = tracking.label;

                (0, _dibsTracking.trackEvent)({
                    category: category,
                    action: action + ' ' + modalAction,
                    label: label
                });
            }
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            this.trackModalEvents({
                modalAction: 'clicked'
            });
            this.closeModal();
            this.props.onCtaClick();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                item = _props.item,
                copy = _props.copy,
                children = _props.children;

            var _ref2 = item || {},
                title = _ref2.title,
                image = _ref2.image;

            return _react2.default.createElement(
                _ModalContainer2.default,
                { isOpen: this.state.modalOpened, modalPosition: 'center', onClose: this.closeModal },
                _react2.default.createElement(_BarHeader2.default, { title: copy.title, subtitle: copy.subtitle }),
                _react2.default.createElement(
                    _ModalBody2.default,
                    { className: _AutoModal2.default.modalBody },
                    item && _react2.default.createElement(
                        'div',
                        { className: _AutoModal2.default.infoContainer },
                        _react2.default.createElement('img', { className: _AutoModal2.default.image, src: image }),
                        title
                    ),
                    children,
                    _react2.default.createElement(
                        _Primary2.default,
                        {
                            size: 'large',
                            className: _AutoModal2.default.button,
                            onClick: this.onClick
                        },
                        copy.cta
                    ),
                    _react2.default.createElement(
                        'a',
                        {
                            className: _AutoModal2.default.link,
                            onClick: this.closeModal
                        },
                        copy.closeCta
                    )
                )
            );
        }
    }]);

    return AutoModal;
}(_react.Component);

;

exports.default = AutoModal;

/***/ }),

/***/ "./src/abandonedCheckout/components/AutoModal.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalBody":"AutoModal__modalBody__ba3e073e","infoContainer":"AutoModal__infoContainer__ba3e073e","image":"AutoModal__image__ba3e073e","button":"AutoModal__button__ba3e073e","link":"AutoModal__link__ba3e073e"};

/***/ }),

/***/ "./src/abandonedCheckout/components/CheckoutAutoModal.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _authFlowConstants = __webpack_require__("./src/authModal/authentication/authFlowConstants.js");

var _relayClientEnvironment = __webpack_require__("./src/relayClientEnvironment.js");

var _relayClientEnvironment2 = _interopRequireDefault(_relayClientEnvironment);

var _AutoModal = __webpack_require__("./src/abandonedCheckout/components/AutoModal.jsx");

var _AutoModal2 = _interopRequireDefault(_AutoModal);

var _AuthModalLoader = __webpack_require__("./src/utils/AuthModalLoader.js");

var _AuthModalLoader2 = _interopRequireDefault(_AuthModalLoader);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _checkoutAutoModalCopy = __webpack_require__("./src/abandonedCheckout/copy/checkoutAutoModalCopy.json");

var _checkoutAutoModalCopy2 = _interopRequireDefault(_checkoutAutoModalCopy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var label = 'abandoned fp checkout - item favoriting';

var mutation = {
    modern: function modern() {
        return __webpack_require__("./src/abandonedCheckout/components/__generated__/CheckoutAutoModalMutation.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'input'
            }],
            name: 'CheckoutAutoModalMutation',
            operation: 'mutation',
            node: function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'modifyPortfolioItems',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'ModifyPortfolioItemsInput!'
                    },
                    name: 'CheckoutAutoModalMutation',
                    responseType: 'ModifyPortfolioItemsPayload'
                };
            }()
        };
    }
};

var trackItemFavorited = function trackItemFavorited() {
    (0, _dibsTracking.trackEvent)({
        category: 'item favoriting',
        action: 'item added',
        label: label
    });
};

var itemAddingFailure = function itemAddingFailure(errors) {
    console.error('Item was not added to HEART portfolio.', errors);
};

var addItemToHeartPortfolio = function addItemToHeartPortfolio(_ref) {
    var itemId = _ref.itemId,
        userId = _ref.userId;

    var input = {
        action: 'ADD',
        portfolioType: 'HEART',
        userId: userId,
        itemsIds: [itemId]
    };

    (0, _reactRelay.commitMutation)((0, _relayClientEnvironment2.default)(), {
        mutation: mutation,
        variables: { input: input },
        onCompleted: function onCompleted(payload, errors) {
            if (errors) {
                itemAddingFailure(errors);
                return;
            }
            trackItemFavorited();
        },
        onError: function onError(error) {
            itemAddingFailure([error]);
        }
    });
};

var authModalShow = function authModalShow(_ref2) {
    var item = _ref2.item,
        email = _ref2.email;

    var id = (0, _dibsCookieJar.getUserId)(document.cookie);
    if (!id) {
        _AuthModalLoader2.default.show({
            action: (0, _dibsCookieJar.getEverLoggedIn)(document.cookie) ? _AuthModalLoader2.default.constants.LOGIN : _AuthModalLoader2.default.constants.REGISTER,
            flow: _authFlowConstants.SAVE_ITEM_PDP_FLOW,
            ga: label,
            additionalProps: {},
            email: email
        }).then(function (_ref3) {
            var userId = _ref3.userId;

            addItemToHeartPortfolio({ itemId: item.id, userId: userId });
        });
    } else {
        addItemToHeartPortfolio({ itemId: item.id, id: id });
    }
};

var CheckoutAutoModal = function CheckoutAutoModal(_ref4) {
    var item = _ref4.item,
        email = _ref4.email;
    return _react2.default.createElement(_AutoModal2.default, {
        copy: _checkoutAutoModalCopy2.default,
        item: item,
        onCtaClick: function onCtaClick() {
            authModalShow({ item: item, email: email });
        },
        tracking: {
            category: 'promo interaction',
            action: label,
            label: label
        }
    });
};

exports.default = CheckoutAutoModal;

/***/ }),

/***/ "./src/abandonedCheckout/components/CheckoutSurvey.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Lior Elrom
 * Date: 4/12/16
 * Time: 5:47 PM
 */



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var shuffle = __webpack_require__("./node_modules/lodash.shuffle/index.js");
var React = __webpack_require__("./node_modules/react/react.js");
var tracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");
var chatUtils = __webpack_require__("./src/utils/chat.js").default;

var _require = __webpack_require__("./node_modules/dibs-browser-storage/index.js"),
    localStorage = _require.localStorage;

var _require2 = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js"),
    getUserId = _require2.getUserId,
    getUserToken = _require2.getUserToken,
    isMasquerading = _require2.isMasquerading,
    cookieJarConstants = _require2.cookieJarConstants;

var copy = __webpack_require__("./src/abandonedCheckout/copy/checkoutSurvey.json");
var styles = __webpack_require__("./src/abandonedCheckout/components/CheckoutSurvey.scss");

__webpack_require__("./node_modules/dibs-elements/dist/buyer.css");

// components

var _require3 = __webpack_require__("./node_modules/dibs-elements/dist/index.js"),
    PrimaryButton = _require3.PrimaryButton,
    ModalContainer = _require3.ModalContainer,
    ModalCloseButton = _require3.ModalCloseButton,
    BarHeader = _require3.BarHeader,
    ModalBody = _require3.ModalBody,
    Radio = _require3.Radio,
    TextArea = _require3.TextArea,
    ExpandingArea = _require3.ExpandingArea;

var getCurrentUserId = function getCurrentUserId() {
    var cookie = document.cookie || '';
    var isLoggedIn = !!getUserToken(cookie);
    return isLoggedIn ? getUserId(cookie, cookieJarConstants.MASQUERADE_BUYER, !isMasquerading(cookie)) : "Not logged in";
};
var trackSurvey = function trackSurvey(label) {
    var _ref = localStorage.getItem('checkoutSurveyInfo') || {},
        step = _ref.step;

    tracking.trackEvent({
        category: 'checkout',
        action: 'checkout form interaction',
        label: [label, step].join('|')
    });
};

var CheckoutSurvey = function (_React$Component) {
    _inherits(CheckoutSurvey, _React$Component);

    function CheckoutSurvey(props) {
        _classCallCheck(this, CheckoutSurvey);

        var _this = _possibleConstructorReturn(this, (CheckoutSurvey.__proto__ || Object.getPrototypeOf(CheckoutSurvey)).call(this, props));

        _this.onRadioClick = _this.onRadioClick.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.state = {
            isOpen: true,
            isDisabled: false,
            selected: '',
            additionalInfo: ''
        };
        return _this;
    }

    _createClass(CheckoutSurvey, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.radioOptions = shuffle(copy.radioOptions);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            localStorage.setItem('hasSeenCheckoutSurvey', true);
            trackSurvey('abandon checkout survey displayed');
        }
    }, {
        key: 'onRadioClick',
        value: function onRadioClick(value) {
            this.setState({ selected: value });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.setState({ isOpen: false });
        }
    }, {
        key: 'onChange',
        value: function onChange(event) {
            this.setState({ additionalInfo: event.target.value });
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit() {
            var _state = this.state,
                reason = _state.selected,
                additionalInfo = _state.additionalInfo;

            trackSurvey('abandon checkout survey submitted');
            chatUtils.track.checkoutSurveySubmitted({ reason: reason, additionalInfo: additionalInfo });
            this.setState({
                isOpen: false,
                isDisabled: true
            });
        }
    }, {
        key: 'getRadioOptions',
        value: function getRadioOptions() {
            var _this2 = this;

            var shuffledOptions = this.radioOptions;
            var RadioOptions = shuffledOptions.map(function (option) {
                return _this2.renderRadio(option);
            });
            RadioOptions.push(this.renderRadio('Other'));
            return RadioOptions;
        }
    }, {
        key: 'renderRadio',
        value: function renderRadio(value) {
            var _this3 = this;

            var selected = this.state.selected;

            var isSelected = selected === value;
            var radioDataTag = value.replace(/\s/g, '-').replace('.', '').toLowerCase();

            return React.createElement(Radio, {
                key: value,
                name: 'reason',
                value: value,
                inputId: value,
                dataTn: radioDataTag,
                label: value,
                wrapperClass: styles.radioOption,
                checked: isSelected,
                onChange: function onChange(selectedValue) {
                    return _this3.onRadioClick(selectedValue);
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state2 = this.state,
                selected = _state2.selected,
                isOpen = _state2.isOpen,
                isDisabled = _state2.isDisabled,
                additionalInfo = _state2.additionalInfo;

            var _localStorage$getItem = localStorage.getItem('checkoutSurveyInfo'),
                itemId = _localStorage$getItem.itemId,
                orderType = _localStorage$getItem.orderType;

            var radioOptions = this.getRadioOptions();
            var baseDataTn = 'checkout-survey';

            return React.createElement(
                ModalContainer,
                { isOpen: isOpen, modalPosition: 'center', dataTn: baseDataTn, onClose: this.closeModal },
                React.createElement(ModalCloseButton, { onClick: this.closeModal }),
                React.createElement(BarHeader, { title: copy.title }),
                React.createElement(
                    ModalBody,
                    null,
                    React.createElement(
                        'form',
                        {
                            id: 'tfa_0',
                            method: 'post',
                            action: 'https://www.tfaforms.com/responses/processor',
                            'data-tn': baseDataTn + '-form',
                            ref: 'form',
                            onSubmit: this.onSubmit
                        },
                        React.createElement(
                            ExpandingArea,
                            {
                                label: React.createElement(
                                    'div',
                                    null,
                                    radioOptions
                                ),
                                expanded: selected,
                                maxHeight: '320px'
                            },
                            React.createElement(
                                'div',
                                { className: styles.textareaWrapper },
                                React.createElement(TextArea, {
                                    label: copy.textAreaLabel,
                                    name: 'tfa_6',
                                    maxLength: 1000,
                                    placeholder: copy.placeholder,
                                    dataTn: baseDataTn + '-text-input',
                                    onChange: this.onChange,
                                    value: additionalInfo
                                })
                            ),
                            React.createElement(
                                PrimaryButton,
                                {
                                    dataTn: baseDataTn + '-submit',
                                    disabled: isDisabled,
                                    onClick: this.onSubmit,
                                    className: styles.submit
                                },
                                copy.submit
                            )
                        ),
                        React.createElement('input', { type: 'hidden', id: 'tfa_9', name: 'tfa_9', value: navigator.userAgent }),
                        React.createElement('input', { type: 'hidden', id: 'tfa_8', name: 'tfa_8', value: getCurrentUserId() }),
                        React.createElement('input', { type: 'hidden', id: 'tfa_10', name: 'tfa_10', value: itemId }),
                        React.createElement('input', { type: 'hidden', id: 'tfa_11', name: 'tfa_11', value: orderType }),
                        React.createElement('input', { type: 'hidden', id: 'tfa_13', name: 'tfa_13', value: document.URL }),
                        React.createElement('input', { type: 'hidden', id: 'tfa_12', name: 'tfa_12', value: selected }),
                        React.createElement('input', { type: 'hidden', id: 'tfa_dbFormId', name: 'tfa_dbFormId', value: '413075' }),
                        React.createElement('input', { type: 'hidden', id: 'tfa_dbControl', name: 'tfa_dbControl', value: 'c6cdf45727af0ab1bbf30b6ec6c49e33' }),
                        React.createElement('input', { type: 'hidden', id: 'tfa_dbVersionId', name: 'tfa_dbVersionId', value: '5' }),
                        React.createElement('input', { type: 'hidden', id: 'tfa_switchedoff', name: 'tfa_switchedoff', value: '' }),
                        React.createElement('input', { type: 'hidden', id: 'tfa_dbResponseId', name: 'tfa_dbResponseId', value: '' })
                    )
                )
            );
        }
    }]);

    return CheckoutSurvey;
}(React.Component);

module.exports = CheckoutSurvey;

/***/ }),

/***/ "./src/abandonedCheckout/components/CheckoutSurvey.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"form-radio":"CheckoutSurvey__form-radio__593bd62c","form-radio-label-text":"CheckoutSurvey__form-radio-label-text__593bd62c","container":"CheckoutSurvey__container__593bd62c","radioOption":"CheckoutSurvey__radioOption__593bd62c","textareaWrapper":"CheckoutSurvey__textareaWrapper__593bd62c","submit":"CheckoutSurvey__submit__593bd62c"};

/***/ }),

/***/ "./src/abandonedCheckout/components/MakeOfferRenderer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _relayClientEnvironment = __webpack_require__("./src/relayClientEnvironment.js");

var _relayClientEnvironment2 = _interopRequireDefault(_relayClientEnvironment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__("./node_modules/react/react.js");
var PropTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _require = __webpack_require__("./node_modules/react-relay/compat.js"),
    QueryRenderer = _require.QueryRenderer;

var abExperiments = __webpack_require__("./src/utils/abExperiments.js");

var _require2 = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js"),
    getUserId = _require2.getUserId,
    cookieJarConstants = _require2.cookieJarConstants;

var checkoutStorage = __webpack_require__("./src/abandonedCheckout/checkoutStorage.js");

var optimizelyVariant = 'control';
if (abExperiments.makeOfferCheckbox) {
    Promise.resolve(abExperiments.makeOfferCheckbox).then(function (res) {
        optimizelyVariant = res;
    });
}

function MakeOfferRenderer(props) {
    var modalProps = props.modalProps;
    var _modalProps$contactCo = modalProps.contactComponents,
        MakeOfferModal = _modalProps$contactCo.MakeOfferModal,
        LowBall = _modalProps$contactCo.LowBall,
        MakeOffer = _modalProps$contactCo.MakeOffer,
        AbandonMakeOfferModal = _modalProps$contactCo.AbandonMakeOfferModal,
        ModalWrapper = _modalProps$contactCo.ModalWrapper,
        Confirmation = _modalProps$contactCo.Confirmation,
        queries = _modalProps$contactCo.queries;
    var makeOffer = queries.makeOffer;
    var itemId = modalProps.itemId,
        sellerId = modalProps.sellerId;

    var userId = getUserId(document.cookie, cookieJarConstants.MASQUERADE_BUYER) || '';
    var params = {
        userId: userId,
        userIds: [userId],
        itemId: itemId,
        itemIds: [itemId],
        sellerId: sellerId,
        shouldFetchUser: !!userId,
        shouldFetchTransaction: !!userId,
        isMC: false
    };

    return React.createElement(QueryRenderer, {
        environment: (0, _relayClientEnvironment2.default)(),
        query: makeOffer,
        variables: params,
        render: function render(_ref) {
            var error = _ref.error,
                rendererProps = _ref.props;
            // eslint-disable-line react/display-name, react/prop-types
            if (error) {
                return React.createElement(ModalWrapper, {
                    openOnRender: true,
                    isError: true
                });
            } else if (rendererProps) {
                return React.createElement(
                    MakeOfferModal,
                    _extends({
                        viewer: rendererProps.viewer,
                        item: rendererProps.viewer.item,
                        conversation: null
                    }, modalProps, {
                        optimizelyVariant: optimizelyVariant
                    }),
                    React.createElement(MakeOffer, null),
                    React.createElement(LowBall, null),
                    React.createElement(AbandonMakeOfferModal, {
                        onAbandonMakeOfferSuccess: function onAbandonMakeOfferSuccess() {
                            checkoutStorage.clearPreAuthOfferModalInfo();
                            checkoutStorage.unsetSurveyInfo();
                            checkoutStorage.unsetAutoModalInfo();
                        },
                        onLeaveAbandonMakeOffer: checkoutStorage.clearPreAuthOfferModalInfo
                    }),
                    React.createElement(Confirmation, null)
                );
            } else {
                return React.createElement(ModalWrapper, {
                    openOnRender: true,
                    isLoading: true
                });
            }
        }
    });
};

exports.default = MakeOfferRenderer;

/***/ }),

/***/ "./src/abandonedCheckout/components/__generated__/CheckoutAutoModalMutation.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash f84d7085a20648ad3f66b64caca745ea
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type CheckoutAutoModalMutationVariables = {|
  input: {
    action: "ADD" | "EDIT" | "REMOVE" | "REORDER";
    endPortfolioItemId?: ?string;
    itemsIds?: ?$ReadOnlyArray<?string>;
    note?: ?string;
    portfolioItemsIds?: ?$ReadOnlyArray<?string>;
    portfolioId?: ?string;
    portfolioType?: ?"HEART" | "CART";
    startPortfolioItemId?: ?string;
    targetPortfolioItemId?: ?string;
    userId: string;
    clientMutationId?: ?string;
  };
|};

export type CheckoutAutoModalMutationResponse = {|
  +modifyPortfolioItems: ?{|
    +clientMutationId: ?string;
  |};
|};
*/

/*
mutation CheckoutAutoModalMutation(
  $input: ModifyPortfolioItemsInput!
) {
  modifyPortfolioItems(input: $input) {
    clientMutationId
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "ModifyPortfolioItemsInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckoutAutoModalMutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ModifyPortfolioItemsInput!"
      }],
      "concreteType": "ModifyPortfolioItemsPayload",
      "name": "modifyPortfolioItems",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "clientMutationId",
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "CheckoutAutoModalMutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "ModifyPortfolioItemsInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "CheckoutAutoModalMutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ModifyPortfolioItemsInput!"
      }],
      "concreteType": "ModifyPortfolioItemsPayload",
      "name": "modifyPortfolioItems",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "clientMutationId",
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation CheckoutAutoModalMutation(\n  $input: ModifyPortfolioItemsInput!\n) {\n  modifyPortfolioItems(input: $input) {\n    clientMutationId\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/abandonedCheckout/components/makeOfferLauncher.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__("./node_modules/react/react.js");
var ReactDOM = __webpack_require__("./node_modules/react-dom/index.js");
var get = __webpack_require__("./node_modules/lodash.get/index.js");

var _require = __webpack_require__("./node_modules/react-redux/lib/index.js"),
    Provider = _require.Provider;

var _require2 = __webpack_require__("./node_modules/redux/es/index.js"),
    combineReducers = _require2.combineReducers,
    createStore = _require2.createStore,
    applyMiddleware = _require2.applyMiddleware;

var track = __webpack_require__("./src/utils/chat.js").default.track;

var authModalLoader = __webpack_require__("./src/utils/AuthModalLoader.js").default;
var MakeOfferRenderer = __webpack_require__("./src/abandonedCheckout/components/MakeOfferRenderer.jsx").default;
var contactModal = __webpack_require__("./src/contactModal/async.js").default;

var authProcess = function authProcess(authProps) {
    var action = authProps.action,
        email = authProps.email,
        flow = authProps.flow,
        ga = authProps.ga;

    return authModalLoader.show({
        action: action,
        email: email,
        flow: flow || authModalLoader.constants.CONTACT_DEALER_FLOW,
        ga: ga
    });
};

exports.default = function (options) {
    var modalContainer = document.createElement('div');
    var item = options.item,
        linkLocation = options.linkLocation,
        currency = options.currency,
        currentStep = options.currentStep,
        _options$preloadedSta = options.preloadedState,
        preloadedState = _options$preloadedSta === undefined ? {} : _options$preloadedSta;


    var itemId = void 0;
    var sellerId = void 0;

    // If backbone model passed
    if (item && item.get) {
        itemId = item.get('id');
        sellerId = item.get('seller.id');
    } else {
        itemId = get(item, 'id') || get(item, 'serviceId');
        sellerId = get(item, 'seller.id') || get(item, 'seller.serviceId');
    }
    contactModal().then(function (mod) {
        var reducers = mod.reducers,
            MakeOfferModal = mod.MakeOfferModal,
            LowBall = mod.LowBall,
            MakeOffer = mod.MakeOffer,
            AbandonMakeOfferModal = mod.AbandonMakeOfferModal,
            ModalWrapper = mod.ModalWrapper,
            Confirmation = mod.Confirmation,
            queries = mod.queries;


        var modalProps = {
            contactComponents: {
                MakeOfferModal: MakeOfferModal,
                LowBall: LowBall,
                MakeOffer: MakeOffer,
                AbandonMakeOfferModal: AbandonMakeOfferModal,
                ModalWrapper: ModalWrapper,
                Confirmation: Confirmation,
                queries: queries
            },
            itemId: itemId,
            sellerId: sellerId,
            chatTracking: track,
            pageCurrency: currency,
            linkLocation: linkLocation,
            startAuth: function startAuth(authProps) {
                return authProcess(_extends({}, authProps, { flow: authProps.makeOffer && authModalLoader.constants.CONTACT_DEALER_FORM_FLOW }));
            },
            currentStep: currentStep
        };

        var store = createStore(combineReducers(reducers), preloadedState, applyMiddleware(__webpack_require__("./node_modules/redux-thunk/lib/index.js").default));

        ReactDOM.render(React.createElement(
            Provider,
            { store: store },
            React.createElement(MakeOfferRenderer, { modalProps: modalProps })
        ), modalContainer);
    });
};

/***/ }),

/***/ "./src/abandonedCheckout/copy/checkoutAutoModalCopy.json":
/***/ (function(module, exports) {

module.exports = {"title":"Not ready to purchase?","subtitle":"We can send you an update if it goes on sale.","cta":"Yes, Send Me Updates","closeCta":"No, Thanks"}

/***/ }),

/***/ "./src/abandonedCheckout/copy/checkoutSurvey.json":
/***/ (function(module, exports) {

module.exports = {"title":"Can you tell us why you didn't complete checkout?","radioOptions":["I wanted to use a shipping method that was not provided.","I wanted to use a payment method that was not available.","The page was too complicated and hard to use.","I did not intend to go to checkout.","I changed my mind based on new details I saw."],"placeholder":"Optional","textAreaLabel":"If you'd like, please tell us more about your experience.","submit":"Submit"}

/***/ }),

/***/ "./src/actions/cartActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadLocalCart = loadLocalCart;
exports.consolidateCart = consolidateCart;
exports.setCartItems = setCartItems;

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _constants = __webpack_require__("./src/actions/constants.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CART_ID = 'cart';

function getLocalStorageItems() {
    return _dibsBrowserStorage.localStorage.getItem(CART_ID) || [];
}

/**
 * MW-541 - Bug caused local storage item IDs to be wrapped in an array. 
 * This causes an error so fix any bad local storage items
 */
function fixLocalStorageItems(items) {
    return items.map(function (item) {
        if (Array.isArray(item.id)) {
            item.id = item.id[0];
        }

        return item;
    });
}

/**
* The desktop stores each cart item as an object, with an id key containing the item id.
*/
function buildLocalStorageItems(current, next) {
    return current.map(function (_ref) {
        var id = _ref.id;
        return id;
    }).filter(function (id) {
        return !next.includes(id);
    }).concat(next).map(function (id) {
        return { id: id };
    });
}

function loadLocalCart() {
    var currentCart = fixLocalStorageItems(getLocalStorageItems());
    // will be ignored if componentShouldUpdate is on
    // if we remove that, then the type needs to change to be handled by reducer appropriately
    return { type: _constants.actionTypes.SET_CART_ITEMS, payload: { items: currentCart } };
}

function consolidateCart(payload) {
    var items = (0, _lodash2.default)(payload, 'res.addCartItem.portfolioItems');
    var cart = (0, _lodash2.default)(payload, 'cartItems');
    // once the request to save new cart items is successful,
    // theres no need to keep the local cart anymore
    _dibsBrowserStorage.localStorage.deleteItem(CART_ID);
    return { type: _constants.actionTypes.SET_CART_ITEMS, payload: { items: cart.concat(items) } };
}

function setCartItems(itemId) {
    var currentCart = getLocalStorageItems();
    var cartItems = buildLocalStorageItems(currentCart, itemId);
    _dibsBrowserStorage.localStorage.setItem(CART_ID, cartItems);
    return { type: _constants.actionTypes.SET_CART_ITEMS, payload: { items: cartItems } };
}

/***/ }),

/***/ "./src/actions/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Action Types
 */
var headerActionTypes = {
    SET_DRAWER_ANIMATION: 'SET_DRAWER_ANIMATION',
    SET_BANNER_MESSAGES: 'SET_BANNER_MESSAGES',
    SET_UPDATE_USER_STATE: 'SET_UPDATE_USER_STATE',
    SET_USER_TYPE_TRADE: 'SET_USER_TYPE_TRADE',
    SET_USER_TYPE_VIP: 'SET_USER_TYPE_VIP',
    SET_CART_ITEMS: 'SET_CART_ITEMS',
    SET_DEVICE_TYPE: 'SET_DEVICE_TYPE',
    TOGGLE_MOBILE_MENU: 'TOGGLE_MOBILE_MENU',
    INITIAL_TRACKING_FIRED: 'INITIAL_TRACKING_FIRED'
};

var footerActionTypes = {
    SET_CURRENCY: 'SET_CURRENCY'
};

var actionTypes = _extends({}, headerActionTypes, footerActionTypes);

/**
 * Other Constants
 */

var headerActionValues = {
    drawerAnimations: {
        SLIDE_IN: 'SLIDE_IN',
        SLIDE_OUT: 'SLIDE_OUT',
        NONE: 'NONE'
    }
};

var actionValues = _extends({}, headerActionValues);

exports.actionTypes = actionTypes;
exports.actionValues = actionValues;
exports.default = { actionTypes: actionTypes, actionValues: actionValues };

/***/ }),

/***/ "./src/actions/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actionCreators = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__("./src/actions/constants.js");

var _cartActions = __webpack_require__("./src/actions/cartActions.js");

var headerActionCreators = {
    setDrawerAnimation: function setDrawerAnimation(animation) {
        return { type: _constants.actionTypes.SET_DRAWER_ANIMATION, animation: animation };
    },
    setUpdateUserState: function setUpdateUserState(updateUserState) {
        return { type: _constants.actionTypes.SET_UPDATE_USER_STATE, updateUserState: updateUserState };
    },
    setUserTypeTrade: function setUserTypeTrade(isUserTypeTrade) {
        return { type: _constants.actionTypes.SET_USER_TYPE_TRADE, isUserTypeTrade: isUserTypeTrade };
    },
    setUserTypeVip: function setUserTypeVip(isUserTypeVip) {
        return { type: _constants.actionTypes.SET_USER_TYPE_VIP, isUserTypeVip: isUserTypeVip };
    },
    setInitialTrackingFired: function setInitialTrackingFired() {
        return { type: _constants.actionTypes.INITIAL_TRACKING_FIRED };
    },
    setBannerMessages: function setBannerMessages(bannerMessages) {
        return { type: _constants.actionTypes.SET_BANNER_MESSAGES, bannerMessages: bannerMessages };
    }
};

var footerActionCreators = {
    setCurrency: function setCurrency(currency) {
        return { type: _constants.actionTypes.SET_CURRENCY, currency: currency };
    },
    toggleMobileMenu: function toggleMobileMenu(isMobileMenuOpen) {
        return { type: _constants.actionTypes.TOGGLE_MOBILE_MENU, isMobileMenuOpen: isMobileMenuOpen };
    },
    setCartItems: _cartActions.setCartItems
};

var actionCreators = _extends({}, headerActionCreators, footerActionCreators);

exports.actionCreators = actionCreators;
exports.default = { actionCreators: actionCreators };

/***/ }),

/***/ "./src/authModal/async.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = authModal;
function authModal() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "./src/authModal/index.js")).then(function (mod) {
        return mod;
    });
};

/***/ }),

/***/ "./src/authModal/authentication/authFlowConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var REGISTER = exports.REGISTER = 'register';
var REGISTRATION = exports.REGISTRATION = 'registration';
var LOGIN = exports.LOGIN = 'login';
var FORGOT_PASSWORD = exports.FORGOT_PASSWORD = 'forgot-password';
var RESET_PASSWORD = exports.RESET_PASSWORD = 'reset-password';
var UPDATE_PASSWORD = exports.UPDATE_PASSWORD = 'update-password';
var RESET_INVALID = exports.RESET_INVALID = 'reset-invalid';
var SOCIAL_ACCOUNT_LINKED = exports.SOCIAL_ACCOUNT_LINKED = 'social-account-linked';
var AUTO_PROMPT_REGISTER = exports.AUTO_PROMPT_REGISTER = 'AUTO_PROMPT_REGISTER';
var SOCIAL_CASE_CONNECTION_LINKED = exports.SOCIAL_CASE_CONNECTION_LINKED = 'LINKED_SOCIAL_CONNECTION';
var SOCIAL_CASE_ACCOUNT_CREATED = exports.SOCIAL_CASE_ACCOUNT_CREATED = 'Created';
var SOCIAL_CASE_NO_EMAIL_RETURNED = exports.SOCIAL_CASE_NO_EMAIL_RETURNED = 'NO_EMAIL_RETURNED';

var DEFAULT_FLOW = exports.DEFAULT_FLOW = 'DEFAULT';
var PAGEVIEW_LIMIT_FLOW = exports.PAGEVIEW_LIMIT_FLOW = 'PAGEVIEW_LIMIT';
var CONTACT_DEALER_FLOW = exports.CONTACT_DEALER_FLOW = 'CONTACT_DEALER';
var CONTACT_DEALER_FORM_FLOW = exports.CONTACT_DEALER_FORM_FLOW = 'CONTACT_DEALER_FORM';
var CONTACT_DEALER_CALL_FLOW = exports.CONTACT_DEALER_CALL_FLOW = 'CONTACT_DEALER_CALL';
var EMBEDDED_CHECKOUT_FLOW = exports.EMBEDDED_CHECKOUT_FLOW = 'EMBEDDED_CHECKOUT_FLOW';
var FOLLOW_DEALER_FLOW = exports.FOLLOW_DEALER_FLOW = 'FOLLOW_DEALER';
var MAKE_OFFER_FLOW = exports.MAKE_OFFER_FLOW = 'MAKE_OFFER';
var SAVE_ITEM_FLOW = exports.SAVE_ITEM_FLOW = 'SAVE_ITEM';
var SAVE_ITEM_TO_FOLDER_FLOW = exports.SAVE_ITEM_TO_FOLDER_FLOW = 'SAVE_ITEM_TO_FOLDER';
var STALE_LOGIN_FLOW = exports.STALE_LOGIN_FLOW = 'STALE_LOGIN_FLOW';
var TRADE_APPLICATION_FLOW = exports.TRADE_APPLICATION_FLOW = 'TRADE_APPLICATION';
var ALT_REGISTRATION_TRADE_FLOW = exports.ALT_REGISTRATION_TRADE_FLOW = 'ALT_REGISTRATION_TRADE';
var ALT_REGISTRATION_CONSUMER_FLOW = exports.ALT_REGISTRATION_CONSUMER_FLOW = 'ALT_REGISTRATION_CONSUMER';
var SAVE_ITEM_PDP_FLOW = exports.SAVE_ITEM_PDP_FLOW = 'SAVE_ITEM_PDP';
var REQUEST_SHIPPING_FLOW = exports.REQUEST_SHIPPING_FLOW = 'REQUEST_SHIPPING';
var BENEFITS_MODAL_FLOW = exports.BENEFITS_MODAL_FLOW = 'BENEFITS_MODAL_FLOW';

var CLOSE = exports.CLOSE = 'closed';

/***/ }),

/***/ "./src/components/AccountManagerLink/AccountManagerLink-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"AccountManagerLink-style__wrapper__3c7358a0","link":"AccountManagerLink-style__link__3c7358a0","separator":"AccountManagerLink-style__separator__3c7358a0","sectionWrapper":"AccountManagerLink-style__sectionWrapper__3c7358a0","section":"AccountManagerLink-style__section__3c7358a0","title":"AccountManagerLink-style__title__3c7358a0","copy":"AccountManagerLink-style__copy__3c7358a0","cta":"AccountManagerLink-style__cta__3c7358a0"};

/***/ }),

/***/ "./src/components/AccountManagerLink/AccountManagerLink.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AccountManagerLink = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _Dropdown = __webpack_require__("./src/components/Dropdown/Dropdown.jsx");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _chat = __webpack_require__("./src/utils/chat.js");

var _chat2 = _interopRequireDefault(_chat);

var _AccountManagerLinkStyle = __webpack_require__("./src/components/AccountManagerLink/AccountManagerLink-style.scss");

var _AccountManagerLinkStyle2 = _interopRequireDefault(_AccountManagerLinkStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountManagerLink = exports.AccountManagerLink = function (_React$Component) {
    _inherits(AccountManagerLink, _React$Component);

    function AccountManagerLink(props) {
        _classCallCheck(this, AccountManagerLink);

        var _this = _possibleConstructorReturn(this, (AccountManagerLink.__proto__ || Object.getPrototypeOf(AccountManagerLink)).call(this, props));

        _this.handleChatClick = _this.handleChatClick.bind(_this);
        return _this;
    }

    _createClass(AccountManagerLink, [{
        key: 'handleChatClick',
        value: function handleChatClick(e) {
            e.preventDefault();
            _chat2.default.show();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _Dropdown2.default,
                {
                    align: _Dropdown.alignConstants.ALIGN_CENTER,
                    size: _Dropdown.sizeConstants.SIZE_SMALL,
                    className: _AccountManagerLinkStyle2.default.wrapper
                },
                _react2.default.createElement(
                    'div',
                    { className: _AccountManagerLinkStyle2.default.link },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'dbl.Header.AccountManagerLink.label',
                        defaultMessage: 'Trade Concierge'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _AccountManagerLinkStyle2.default.sectionWrapper },
                    _react2.default.createElement(
                        'div',
                        { className: _AccountManagerLinkStyle2.default.section },
                        _react2.default.createElement(
                            'div',
                            { className: _AccountManagerLinkStyle2.default.title },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'dbl.Header.AccountManagerLink.contact_title',
                                defaultMessage: 'For direct access to our trade concierge specialists, contact:'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _AccountManagerLinkStyle2.default.copy },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'dbl.Header.AccountManagerLink.contact_phone_number',
                                defaultMessage: '{phoneNumber} or',
                                values: { phoneNumber: "+1 646 454 2651" },
                                tagName: 'div'
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'dbl.Header.AccountManagerLink.contact_toll_free',
                                defaultMessage: 'toll free: {phoneNumber}',
                                values: { phoneNumber: "+1 877 721 3427" },
                                tagName: 'div'
                            }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'dbl.Header.AccountManagerLink.contact_email',
                                defaultMessage: 'trade@1stdibs.com',
                                tagName: 'div'
                            })
                        ),
                        _react2.default.createElement(
                            'a',
                            { className: _AccountManagerLinkStyle2.default.cta, onClick: this.handleChatClick },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'dbl.Header.AccountManagerLink.contact_chat',
                                defaultMessage: 'Chat Now'
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_AccountManagerLinkStyle2.default.sectionWrapper, _AccountManagerLinkStyle2.default.separator) },
                    _react2.default.createElement(
                        'div',
                        { className: _AccountManagerLinkStyle2.default.section },
                        _react2.default.createElement(
                            'div',
                            { className: _AccountManagerLinkStyle2.default.title },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'dbl.Header.AccountManagerLink.sourcing_title',
                                defaultMessage: 'Free Sourcing for Designers'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _AccountManagerLinkStyle2.default.copy },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'dbl.Header.AccountManagerLink.sourcing_content',
                                defaultMessage: 'Let our team of experts find what you need for your project.'
                            })
                        ),
                        _react2.default.createElement(
                            'a',
                            { className: _AccountManagerLinkStyle2.default.cta, href: '/trade/sourcing/' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'dbl.Header.AccountManagerLink.sourcing_cta',
                                defaultMessage: 'Learn more'
                            })
                        )
                    )
                )
            );
        }
    }]);

    return AccountManagerLink;
}(_react2.default.Component);

exports.default = AccountManagerLink;

/***/ }),

/***/ "./src/components/AccountNav/AccountNav-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"AccountNav-style__wrapper__e6b05d20","accountIcon":"AccountNav-style__accountIcon__e6b05d20","label":"AccountNav-style__label__e6b05d20","maskIcon":"AccountNav-style__maskIcon__e6b05d20","name":"AccountNav-style__name__e6b05d20","authLinks":"AccountNav-style__authLinks__e6b05d20","authLink":"AccountNav-style__authLink__e6b05d20","dropdownContent":"AccountNav-style__dropdownContent__e6b05d20","dropdownLinkWrapper":"AccountNav-style__dropdownLinkWrapper__e6b05d20","dropdownLink":"AccountNav-style__dropdownLink__e6b05d20","unreadCount":"AccountNav-style__unreadCount__e6b05d20"};

/***/ }),

/***/ "./src/components/AccountNav/AccountNav.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _accountOutlined = __webpack_require__("./node_modules/dibs-vg/dist/react/account-outlined.js");

var _accountOutlined2 = _interopRequireDefault(_accountOutlined);

var _mask = __webpack_require__("./node_modules/dibs-vg/dist/react/mask.js");

var _mask2 = _interopRequireDefault(_mask);

var _Dropdown = __webpack_require__("./src/components/Dropdown/Dropdown.jsx");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _DropdownBody = __webpack_require__("./src/components/Dropdown/DropdownBody.jsx");

var _DropdownBody2 = _interopRequireDefault(_DropdownBody);

var _AccountNavContent = __webpack_require__("./src/components/AccountNav/AccountNavContent.jsx");

var _AccountNavContent2 = _interopRequireDefault(_AccountNavContent);

var _AuthModalLoader = __webpack_require__("./src/utils/AuthModalLoader.js");

var _AuthModalLoader2 = _interopRequireDefault(_AuthModalLoader);

var _accountConstants = __webpack_require__("./src/components/AccountNav/accountConstants.js");

var _AccountNavStyle = __webpack_require__("./src/components/AccountNav/AccountNav-style.scss");

var _AccountNavStyle2 = _interopRequireDefault(_AccountNavStyle);

var _actions = __webpack_require__("./src/actions/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountNavTrigger = function AccountNavTrigger(_ref) {
    var isMasquerading = _ref.isMasquerading,
        name = _ref.name;

    return _react2.default.createElement(
        'div',
        { 'data-tn': 'user-menu-logged-in', className: _AccountNavStyle2.default.label },
        _react2.default.createElement(
            'div',
            { 'data-tn': 'user-menu-logged-in-name', className: _AccountNavStyle2.default.name },
            isMasquerading ? _react2.default.createElement(
                'span',
                { 'data-tn': 'user-menu-masq-icon', className: _AccountNavStyle2.default.maskIcon },
                _react2.default.createElement(_mask2.default, null)
            ) : null,
            isMasquerading ? _react2.default.createElement(
                'span',
                null,
                '(',
                name,
                ')'
            ) : name
        ),
        _react2.default.createElement(
            'div',
            { className: _AccountNavStyle2.default.accountIcon },
            _react2.default.createElement(_accountOutlined2.default, null)
        )
    );
};

var AccountNav = function (_React$Component) {
    _inherits(AccountNav, _React$Component);

    function AccountNav(props) {
        _classCallCheck(this, AccountNav);

        var _this = _possibleConstructorReturn(this, (AccountNav.__proto__ || Object.getPrototypeOf(AccountNav)).call(this, props));

        _this.state = {
            isMasquerading: false
        };
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(AccountNav, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ // eslint-disable-line react/no-did-mount-set-state
                isMasquerading: (0, _dibsCookieJar.isMasqueradingAsBuyer)(document.cookie)
            });
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var _this2 = this;

            e.preventDefault();
            var action = e.currentTarget.dataset.action;
            Promise.resolve(_AuthModalLoader2.default.show({
                relayEnvironment: this.props.relay.environment,
                email: _dibsBrowserStorage.localStorage.getItem('userEmail'),
                action: action,
                ga: {
                    label: action + ' link - global header',
                    value: !!window.scrollY
                }
            })).then(function () {
                _this2.props.dispatch(_actions.actionCreators.setUpdateUserState(true));
            }).catch(function (err) {
                console.warn('Auth Modal could not be loaded\n', err);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                hasUser = _props.hasUser,
                hasUserId = _props.hasUserId,
                isClient = _props.isClient,
                user = _props.user;


            if (!isClient || hasUserId && !hasUser) {
                return null;
            }

            var name = (0, _lodash2.default)(user, 'profile.firstName') || _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'dbl.Header.AccountNav.name',
                defaultMessage: 'My Account'
            });

            var totalUnreadConversations = (0, _lodash2.default)(user, 'conversationSummary.totalUnreadConversationCount', 0);
            var tradeLoyaltyStatus = (0, _lodash2.default)(user, 'tradeFirm.loyalty.status') || '';

            return _react2.default.createElement(
                'div',
                { 'data-tn': 'account-nav', className: _AccountNavStyle2.default.wrapper },
                hasUser ? _react2.default.createElement(
                    _Dropdown2.default,
                    { align: _Dropdown.alignConstants.ALIGN_CENTER, size: _Dropdown.sizeConstants.SIZE_SMALL },
                    _react2.default.createElement(AccountNavTrigger, { isMasquerading: this.state.isMasquerading, name: name }),
                    _react2.default.createElement(
                        _DropdownBody2.default,
                        null,
                        _react2.default.createElement(_AccountNavContent2.default, {
                            totalUnreadConversations: totalUnreadConversations,
                            tradeLoyaltyStatus: tradeLoyaltyStatus
                        })
                    )
                ) : _react2.default.createElement(
                    'div',
                    { className: _AccountNavStyle2.default.authLinks },
                    _react2.default.createElement(
                        'span',
                        {
                            className: _AccountNavStyle2.default.authLink,
                            'data-tn': 'user-menu-nav-item-link-log-in',
                            'data-action': _accountConstants.ACTION_LOGIN,
                            onClick: this.handleClick
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'dbl.Header.AccountNav.log_in',
                            defaultMessage: 'Log In'
                        })
                    ),
                    _react2.default.createElement(
                        'span',
                        {
                            className: _AccountNavStyle2.default.authLink,
                            'data-tn': 'user-menu-nav-item-link-sign-up',
                            'data-action': _accountConstants.ACTION_REGISTER,
                            onClick: this.handleClick
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'dbl.Header.AccountNav.sign_up',
                            defaultMessage: 'Sign Up'
                        })
                    )
                )
            );
        }
    }]);

    return AccountNav;
}(_react2.default.Component);

exports.default = (0, _reactRelay.createFragmentContainer)((0, _reactRedux.connect)(function () {
    return {};
})(AccountNav), // for dispatch
{
    user: {
        modern: function modern() {
            return __webpack_require__("./src/components/AccountNav/__generated__/AccountNav_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            children: [{
                                fieldName: 'firstName',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            children: [{
                                fieldName: 'totalUnreadConversationCount',
                                kind: 'Field',
                                metadata: {},
                                type: 'Int'
                            }],
                            fieldName: 'conversationSummary',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Summary'
                        }, {
                            children: [{
                                children: [{
                                    fieldName: 'status',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'TradeFirmLoyaltyStatus'
                                }],
                                fieldName: 'loyalty',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'TradeFirmLoyaltyType'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'tradeFirm',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'TradeFirmType'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'AccountNav_user',
                        type: 'User'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/AccountNav/AccountNavContent.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ELIGIBLE_LOYALTY_STATUS = exports.ENROLLED_LOYALTY_STATUS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _AccountNavStyle = __webpack_require__("./src/components/AccountNav/AccountNav-style.scss");

var _AccountNavStyle2 = _interopRequireDefault(_AccountNavStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ENROLLED_LOYALTY_STATUS = exports.ENROLLED_LOYALTY_STATUS = 'ENROLLED';
var ELIGIBLE_LOYALTY_STATUS = exports.ELIGIBLE_LOYALTY_STATUS = 'ELIGIBLE';
var trackingObj = {
    category: 'navigation',
    action: 'header navigation click'
};

var AccountNavDropdownContent = function (_React$Component) {
    _inherits(AccountNavDropdownContent, _React$Component);

    function AccountNavDropdownContent(props) {
        _classCallCheck(this, AccountNavDropdownContent);

        var _this = _possibleConstructorReturn(this, (AccountNavDropdownContent.__proto__ || Object.getPrototypeOf(AccountNavDropdownContent)).call(this, props));

        _this.onLogoutClick = _this.onLogoutClick.bind(_this);
        _this.showTradeRewardsItem = _this.showTradeRewardsItem.bind(_this);
        return _this;
    }

    _createClass(AccountNavDropdownContent, [{
        key: 'onLogoutClick',
        value: function onLogoutClick() {
            (0, _dibsTracking.trackEvent)(Object.assign({}, trackingObj, { label: 'user-nav|logout' }));
            this.props.logoutUser();
        }
    }, {
        key: 'showTradeRewardsItem',
        value: function showTradeRewardsItem() {
            return [ENROLLED_LOYALTY_STATUS, ELIGIBLE_LOYALTY_STATUS].includes(this.props.tradeLoyaltyStatus);
        }
    }, {
        key: 'render',
        value: function render() {
            var totalUnreadConversations = this.props.totalUnreadConversations;


            return _react2.default.createElement(
                'div',
                { className: _AccountNavStyle2.default.dropdownContent },
                _react2.default.createElement(
                    'div',
                    { className: _AccountNavStyle2.default.dropdownLinkWrapper, 'data-tn': 'sub-nav-list-item-account-information' },
                    _react2.default.createElement(
                        'a',
                        {
                            className: _AccountNavStyle2.default.dropdownLink,
                            href: '/my/account/',
                            'data-tn': 'sub-nav-list-item-link-account-information',
                            onClick: function onClick() {
                                (0, _dibsTracking.trackEvent)(Object.assign({}, trackingObj, { label: 'user-nav|account information' }));
                            }
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'dbl.Header.AccountNavContent.account_information',
                            defaultMessage: 'Account Information'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _AccountNavStyle2.default.dropdownLinkWrapper, 'data-tn': 'sub-nav-list-item-my-orders' },
                    _react2.default.createElement(
                        'a',
                        {
                            className: _AccountNavStyle2.default.dropdownLink,
                            href: '/my/orders/',
                            'data-tn': 'sub-nav-list-item-link-my-orders',
                            onClick: function onClick() {
                                (0, _dibsTracking.trackEvent)(Object.assign({}, trackingObj, { label: 'user-nav|my orders' }));
                            }
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'dbl.Header.AccountNavContent.my_orders',
                            defaultMessage: 'My Orders'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _AccountNavStyle2.default.dropdownLinkWrapper, 'data-tn': 'sub-nav-list-item-my-conversations' },
                    _react2.default.createElement(
                        'a',
                        {
                            className: _AccountNavStyle2.default.dropdownLink,
                            href: '/my/conversations/',
                            'data-tn': 'sub-nav-list-item-link-my-conversations',
                            onClick: function onClick() {
                                (0, _dibsTracking.trackEvent)(Object.assign({}, trackingObj, { label: 'user-nav|my conversations' }));
                            }
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'dbl.Header.AccountNavContent.my_conversations',
                            defaultMessage: 'My Conversations'
                        }),
                        totalUnreadConversations ? _react2.default.createElement(
                            'span',
                            { className: _AccountNavStyle2.default.unreadCount },
                            ' (',
                            totalUnreadConversations,
                            ')'
                        ) : null
                    )
                ),
                this.showTradeRewardsItem() && _react2.default.createElement(
                    'div',
                    { className: _AccountNavStyle2.default.dropdownLinkWrapper, 'data-tn': 'sub-nav-list-item-loyalty' },
                    _react2.default.createElement(
                        'a',
                        {
                            className: _AccountNavStyle2.default.dropdownLink,
                            'data-tn': 'sub-nav-list-item-link-loyalty',
                            href: '/trade/loyalty/rewards/'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'dbl.Header.AccountNavContent.my_rewards',
                            defaultMessage: 'My Rewards'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _AccountNavStyle2.default.dropdownLinkWrapper, 'data-tn': 'sub-nav-list-item-logout' },
                    _react2.default.createElement(
                        'span',
                        {
                            className: _AccountNavStyle2.default.dropdownLink,
                            'data-tn': 'sub-nav-list-item-link-logout',
                            onClick: this.onLogoutClick
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'dbl.Header.AccountNavContent.logout',
                            defaultMessage: 'Logout'
                        })
                    )
                )
            );
        }
    }]);

    return AccountNavDropdownContent;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
    var header = _ref.header;
    var logoutUser = header.logoutUser;

    return {
        logoutUser: logoutUser
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AccountNavDropdownContent);

/***/ }),

/***/ "./src/components/AccountNav/__generated__/AccountNav_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type AccountNav_user = {|
  +profile: ?{|
    +firstName: ?string;
  |};
  +conversationSummary: ?{|
    +totalUnreadConversationCount: ?number;
  |};
  +tradeFirm: ?{|
    +loyalty: ?{|
      +status: ?"ENROLLED" | "ELIGIBLE" | "NOT_ELIGIBLE" | "BLACKLISTED";
    |};
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountNav_user",
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Profile",
    "name": "profile",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "firstName",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Summary",
    "name": "conversationSummary",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "totalUnreadConversationCount",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "TradeFirmType",
    "name": "tradeFirm",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmLoyaltyType",
      "name": "loyalty",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "status",
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/AccountNav/accountConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ACTION_REGISTER = 'register';
var ACTION_LOGIN = 'login';

exports.ACTION_LOGIN = ACTION_LOGIN;
exports.ACTION_REGISTER = ACTION_REGISTER;
exports.default = {
    ACTION_LOGIN: ACTION_LOGIN,
    ACTION_REGISTER: ACTION_REGISTER
};

/***/ }),

/***/ "./src/components/BottomBar/BottomBar-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bar":"BottomBar-style__bar__f9b39100 Header-style__bar__da67c0c0","barContent":"BottomBar-style__barContent__f9b39100 Header-style__barContent__da67c0c0","wrapper":"BottomBar-style__wrapper__f9b39100"};

/***/ }),

/***/ "./src/components/BottomBar/BottomBar.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _AccountManagerLink = __webpack_require__("./src/components/AccountManagerLink/AccountManagerLink.jsx");

var _AccountManagerLink2 = _interopRequireDefault(_AccountManagerLink);

var _VipAccountManagerLink = __webpack_require__("./src/components/VipAccountManagerLink/VipAccountManagerLink.jsx");

var _VipAccountManagerLink2 = _interopRequireDefault(_VipAccountManagerLink);

var _SiteNav = __webpack_require__("./src/components/SiteNav/SiteNav.jsx");

var _SiteNav2 = _interopRequireDefault(_SiteNav);

var _BottomBarStyle = __webpack_require__("./src/components/BottomBar/BottomBar-style.scss");

var _BottomBarStyle2 = _interopRequireDefault(_BottomBarStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BottomBar = function BottomBar(props) {
    var isUserTypeTrade = props.isUserTypeTrade,
        isUserTypeVip = props.isUserTypeVip;

    var showVipAccountManagerLink = !isUserTypeTrade && isUserTypeVip;
    return _react2.default.createElement(
        'div',
        { className: _BottomBarStyle2.default.bar },
        _react2.default.createElement(
            'div',
            { className: _BottomBarStyle2.default.barContent },
            _react2.default.createElement(
                'div',
                { className: _BottomBarStyle2.default.wrapper },
                _react2.default.createElement(_SiteNav2.default, { navigation: props.navigation }),
                props.isUserTypeTrade ? _react2.default.createElement(_AccountManagerLink2.default, null) : null,
                showVipAccountManagerLink ? _react2.default.createElement(_VipAccountManagerLink2.default, {
                    hasRootPendingRefetch: props.hasRootPendingRefetch,
                    hasUserId: props.hasUserId,
                    isClient: props.isClient,
                    userIds: props.userIds,
                    viewer: props.viewer
                }) : null
            )
        )
    );
};

var mapStateToProps = function mapStateToProps(_ref) {
    var header = _ref.header;
    var isUserTypeTrade = header.isUserTypeTrade,
        isUserTypeVip = header.isUserTypeVip;

    return {
        isUserTypeTrade: isUserTypeTrade, isUserTypeVip: isUserTypeVip
    };
};

exports.default = (0, _reactRelay.createFragmentContainer)((0, _reactRedux.connect)(mapStateToProps)(BottomBar), {
    navigation: {
        modern: function modern() {
            return __webpack_require__("./src/components/BottomBar/__generated__/BottomBar_navigation.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var SiteNav_navigation = _SiteNav2.default.getFragment('navigation');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(SiteNav_navigation)]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'BottomBar_navigation',
                        type: 'Navigation'
                    };
                }()
            };
        }
    },
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/BottomBar/__generated__/BottomBar_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var VipAccountManagerLink_viewer = _VipAccountManagerLink2.default.getFragment('viewer');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(VipAccountManagerLink_viewer)]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'BottomBar_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/BottomBar/__generated__/BottomBar_navigation.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type BottomBar_navigation = {| |};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BottomBar_navigation",
  "selections": [{
    "kind": "FragmentSpread",
    "name": "SiteNav_navigation",
    "args": null
  }],
  "type": "Navigation"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/BottomBar/__generated__/BottomBar_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type BottomBar_viewer = {| |};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BottomBar_viewer",
  "selections": [{
    "kind": "FragmentSpread",
    "name": "VipAccountManagerLink_viewer",
    "args": null
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/CartNav/AddCartItemMutation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var mutation = {
    modern: function modern() {
        return __webpack_require__("./src/components/CartNav/__generated__/AddCartItemMutation.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'input'
            }],
            name: 'AddCartItemMutation',
            operation: 'mutation',
            node: function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'modifyPortfolios',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        children: [{
                            children: [{
                                fieldName: 'totalResults',
                                kind: 'Field',
                                metadata: {},
                                type: 'Int'
                            }],
                            fieldName: 'items',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'PortfolioItemsConnection'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'portfolios',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id',
                            isPlural: true
                        },
                        type: 'PortfolioV2'
                    }, {
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'ModifyPortfoliosInput!'
                    },
                    name: 'AddCartItemMutation',
                    responseType: 'ModifyPortfoliosPayload'
                };
            }()
        };
    }
};

function addCartItem(_ref) {
    var environment = _ref.environment,
        itemsIds = _ref.itemsIds,
        userId = _ref.userId,
        onCompleted = _ref.onCompleted,
        onError = _ref.onError;

    return (0, _reactRelay.commitMutation)(environment, {
        mutation: mutation,
        variables: {
            input: {
                action: 'ADD',
                portfoliosType: 'CART',
                itemsIds: itemsIds,
                userId: userId
            }
        },
        onCompleted: onCompleted,
        onError: onError
    });
}

exports.default = { commit: addCartItem };

/***/ }),

/***/ "./src/components/CartNav/CartNav-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"iconWrapper":"CartNav-style__iconWrapper__89d29e40","icon":"CartNav-style__icon__89d29e40","countWrapper":"CartNav-style__countWrapper__89d29e40","count":"CartNav-style__count__89d29e40","emptyCart":"CartNav-style__emptyCart__89d29e40","dropdownLoadingContent":"CartNav-style__dropdownLoadingContent__89d29e40","dropdownRow":"CartNav-style__dropdownRow__89d29e40","dropdownRowLink":"CartNav-style__dropdownRowLink__89d29e40","dropdownColumn":"CartNav-style__dropdownColumn__89d29e40","dropdownItemImageWrapper":"CartNav-style__dropdownItemImageWrapper__89d29e40","dropdownItemImage":"CartNav-style__dropdownItemImage__89d29e40","dropdownItemTitle":"CartNav-style__dropdownItemTitle__89d29e40","isSold":"CartNav-style__isSold__89d29e40","dropdownCtaWrapper":"CartNav-style__dropdownCtaWrapper__89d29e40"};

/***/ }),

/***/ "./src/components/CartNav/CartNav.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _dibsBrowserStorage2 = _interopRequireDefault(_dibsBrowserStorage);

var _AddCartItemMutation = __webpack_require__("./src/components/CartNav/AddCartItemMutation.js");

var _AddCartItemMutation2 = _interopRequireDefault(_AddCartItemMutation);

var _Dropdown = __webpack_require__("./src/components/Dropdown/Dropdown.jsx");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _DropdownHeader = __webpack_require__("./src/components/Dropdown/DropdownHeader.jsx");

var _DropdownHeader2 = _interopRequireDefault(_DropdownHeader);

var _DropdownBody = __webpack_require__("./src/components/Dropdown/DropdownBody.jsx");

var _DropdownBody2 = _interopRequireDefault(_DropdownBody);

var _CartNavDropdownTrigger = __webpack_require__("./src/components/CartNav/CartNavDropdownTrigger.jsx");

var _CartNavDropdownTrigger2 = _interopRequireDefault(_CartNavDropdownTrigger);

var _CartNavDropdownContent = __webpack_require__("./src/components/CartNav/CartNavDropdownContent.jsx");

var _CartNavDropdownContent2 = _interopRequireDefault(_CartNavDropdownContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CART_ID = 'cart';

var CartNav = function (_React$Component) {
    _inherits(CartNav, _React$Component);

    _createClass(CartNav, null, [{
        key: 'getLocalCart',
        value: function getLocalCart() {
            var localStorage = _dibsBrowserStorage2.default.localStorage;

            return localStorage.getItem(CART_ID) || [];
        }
    }, {
        key: 'deleteLocalCart',
        value: function deleteLocalCart() {
            var localStorage = _dibsBrowserStorage2.default.localStorage;

            return localStorage.deleteItem(CART_ID);
        }
    }]);

    function CartNav(props) {
        _classCallCheck(this, CartNav);

        var _this = _possibleConstructorReturn(this, (CartNav.__proto__ || Object.getPrototypeOf(CartNav)).call(this, props));

        _this.state = {
            fragmentVariables: {
                fetchLocalItems: false,
                fetchPortfolioItems: false,
                itemIds: "",
                userId: ""
            }
        };

        _this.triggerItemsFetch = _this.triggerItemsFetch.bind(_this);
        return _this;
    }

    _createClass(CartNav, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _props = this.props,
                relay = _props.relay,
                user = _props.user,
                userId = _props.userId;

            var localCart = CartNav.getLocalCart();

            if (!!user && localCart.length > 0) {

                _AddCartItemMutation2.default.commit({
                    environment: relay.environment,
                    itemsIds: localCart.map(function (_ref) {
                        var id = _ref.id;
                        return id;
                    }),
                    userId: userId,
                    onCompleted: function onCompleted() {
                        CartNav.deleteLocalCart();
                    },
                    onError: function onError(error) {
                        var _ref2 = error.getError ? error.getError() : {},
                            source = _ref2.source;

                        if (source) {
                            var message = (0, _lodash2.default)(source, 'errors[0].message', '');
                            var isDuplicate = message.includes('409');

                            if (isDuplicate) {
                                CartNav.deleteLocalCart();
                            }
                        }
                    }
                });
            }
        }

        /**
         * Inventory SOLR doesn't guarantee returning items in the order itemIds were passed to it
         * Sort response from Inventory SOLR by order of itemIds in local cart
         */

    }, {
        key: 'getSortedLocalItems',
        value: function getSortedLocalItems() {
            var viewer = this.props.viewer;

            var itemIds = CartNav.getLocalCart().map(function (id) {
                return id;
            });
            var localItems = (0, _lodash2.default)(viewer, 'items');

            if (itemIds.length < 2 || !!localItems) {
                return localItems;
            }

            var map = itemIds.reduce(function (acc, itemId, index) {
                acc[itemId] = index;
                return acc;
            }, {});

            var edges = localItems.edges;


            edges.sort(function (_ref3, _ref4) {
                var nodeA = _ref3.node;
                var nodeB = _ref4.node;
                var a = nodeA.serviceId;
                var b = nodeB.serviceId;

                return map[a] - map[b];
            });

            return localItems;
        }
    }, {
        key: 'isEmptyState',
        value: function isEmptyState() {
            var hasUserId = this.props.hasUserId;


            if (!hasUserId && CartNav.getLocalCart().length === 0) {
                return true;
            }

            var items = this.getItems();
            return !!(items && items.edges && items.edges.length === 0);
        }
    }, {
        key: 'getCurrency',
        value: function getCurrency() {
            var _props2 = this.props,
                hasUserId = _props2.hasUserId,
                user = _props2.user;
            var sessionStorage = _dibsBrowserStorage2.default.sessionStorage;

            var currency = hasUserId ? (0, _lodash2.default)(user, 'profile.currency') : sessionStorage.getItem('userCurrency');
            return currency || 'USD';
        }
    }, {
        key: 'getItems',
        value: function getItems() {
            var _props3 = this.props,
                hasUserId = _props3.hasUserId,
                viewer = _props3.viewer;


            return hasUserId ? (0, _lodash2.default)(viewer, 'portfolios.edges[0].node.items') : this.getSortedLocalItems();
        }
    }, {
        key: 'getCount',
        value: function getCount() {
            var _props4 = this.props,
                hasUserId = _props4.hasUserId,
                viewer = _props4.viewer;


            return hasUserId ? (0, _lodash2.default)(viewer, 'portfolios.edges[0].node.items.totalResults') || 0 : CartNav.getLocalCart().length;
        }
    }, {
        key: 'triggerItemsFetch',
        value: function triggerItemsFetch() {
            var _props5 = this.props,
                hasRootPendingRefetch = _props5.hasRootPendingRefetch,
                hasUserId = _props5.hasUserId;


            if (hasRootPendingRefetch) {
                return;
            }

            if (hasUserId && !this.state.fragmentVariables.fetchPortfolioItems) {
                this.fetchPortfolioItems();
            }

            if (!hasUserId && !this.state.fragmentVariables.fetchLocalItems) {
                this.fetchLocalItems();
            }
        }
    }, {
        key: 'fetchPortfolioItems',
        value: function fetchPortfolioItems() {
            var _this2 = this;

            this.setState({
                fragmentVariables: _extends({}, this.state.fragmentVariables, {
                    hasUserId: this.props.hasUserId,
                    fetchLocalItems: false,
                    fetchPortfolioItems: true,
                    userId: this.props.userId
                })

            }, function () {
                _this2.props.relay.refetch(_this2.state.fragmentVariables, null);
            });
        }
    }, {
        key: 'fetchLocalItems',
        value: function fetchLocalItems() {
            var _this3 = this;

            var localCart = CartNav.getLocalCart();
            var itemIds = localCart.map(function (_ref5) {
                var id = _ref5.id;
                return id;
            });

            if (itemIds.length > 0) {
                this.setState({
                    fragmentVariables: _extends({}, this.state.fragmentVariables, {
                        fetchLocalItems: true,
                        localItemIds: itemIds
                    })

                }, function () {
                    _this3.props.relay.refetch(_this3.state.fragmentVariables, null);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var isClient = this.props.isClient;


            return isClient ? _react2.default.createElement(
                _Dropdown2.default,
                { align: _Dropdown.alignConstants.ALIGN_RIGHT },
                _react2.default.createElement(_CartNavDropdownTrigger2.default, { count: this.getCount(), handleMouseEnter: this.triggerItemsFetch }),
                _react2.default.createElement(_DropdownHeader2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Header.CartNav.header_title', defaultMessage: 'My Cart' }),
                    link: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Header.CartNav.header_link', defaultMessage: 'View All' }),
                    href: '/my/cart/'
                }),
                _react2.default.createElement(
                    _DropdownBody2.default,
                    null,
                    _react2.default.createElement(_CartNavDropdownContent2.default, {
                        currency: this.getCurrency(),
                        isEmptyState: this.isEmptyState(),
                        items: this.getItems()
                    })
                )
            ) : _react2.default.createElement(_CartNavDropdownTrigger2.default, null);
        }
    }]);

    return CartNav;
}(_react2.default.Component);

/* eslint-disable no-unused-expressions */
({
    financialAmount: {
        modern: function modern() {
            return __webpack_require__("./src/components/CartNav/__generated__/CartNav_financialAmount.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            fieldName: 'amount',
                            kind: 'Field',
                            metadata: {},
                            type: 'Float'
                        }, {
                            fieldName: 'currency',
                            kind: 'Field',
                            metadata: {},
                            type: 'Currency'
                        }, {
                            children: [{
                                fieldName: 'currency',
                                kind: 'Field',
                                metadata: {},
                                type: 'Currency'
                            }, {
                                fieldName: 'amount',
                                kind: 'Field',
                                metadata: {},
                                type: 'Float'
                            }],
                            fieldName: 'convertedAmountList',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'ConvertedAmountList'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'CartNav_financialAmount',
                        type: 'FinancialAmount'
                    };
                }()
            };
        }
    }
});

({
    item: {
        modern: function modern() {
            return __webpack_require__("./src/components/CartNav/__generated__/CartNav_item.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var CartNav_financialAmount = RelayQL_GENERATED.__getClassicFragment(CartNav.financialAmount.financialAmount || CartNav.financialAmount).node;

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            fieldName: 'pdpURL',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'title',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'isSold',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            children: [{
                                children: [{
                                    fieldName: 'webPath',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    children: [{
                                        fieldName: 'name',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'ImageVersionTypeName'
                                    }],
                                    fieldName: 'type',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'ImageVersionType'
                                }],
                                fieldName: 'versions',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'ItemPhotoVersion'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'photos',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'ItemPhoto'
                        }, {
                            children: [{
                                children: [].concat.apply([], [RelayQL_GENERATED.__frag(CartNav_financialAmount)]),
                                fieldName: 'netPrice',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'FinancialAmount'
                            }, {
                                children: [].concat.apply([], [RelayQL_GENERATED.__frag(CartNav_financialAmount)]),
                                fieldName: 'salePrice',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'FinancialAmount'
                            }, {
                                children: [].concat.apply([], [RelayQL_GENERATED.__frag(CartNav_financialAmount)]),
                                fieldName: 'retailPrice',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'FinancialAmount'
                            }],
                            fieldName: 'pricing',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemPricing'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'CartNav_item',
                        type: 'Item'
                    };
                }()
            };
        }
    }
});
/* eslint-enable no-unused-expressions */

exports.default = (0, _reactRelay.createRefetchContainer)(CartNav, {
    user: {
        modern: function modern() {
            return __webpack_require__("./src/components/CartNav/__generated__/CartNav_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            children: [{
                                fieldName: 'currency',
                                kind: 'Field',
                                metadata: {},
                                type: 'Currency'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'CartNav_user',
                        type: 'User'
                    };
                }()
            };
        }
    },
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/CartNav/__generated__/CartNav_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var CartNav_item = RelayQL_GENERATED.__getClassicFragment(CartNav.item.item || CartNav.item).node;

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    defaultValue: [],
                    kind: 'LocalArgument',
                    name: 'localItemIds'
                }, {
                    defaultValue: false,
                    kind: 'LocalArgument',
                    name: 'fetchLocalItems'
                }, {
                    kind: 'RootArgument',
                    name: 'userIds'
                }, {
                    kind: 'RootArgument',
                    name: 'hasUserId'
                }, {
                    defaultValue: false,
                    kind: 'LocalArgument',
                    name: 'fetchPortfolioItems'
                }],
                node: function () {
                    return {
                        children: [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'itemIds',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'localItemIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'first',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 3
                                }
                            }],
                            children: [{
                                children: [{
                                    children: [].concat.apply([], [{
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }, RelayQL_GENERATED.__frag(CartNav_item)]),
                                    fieldName: 'node',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        inferredRootCallName: 'node',
                                        inferredPrimaryKey: 'id',
                                        isRequisite: true
                                    },
                                    type: 'Item'
                                }, {
                                    fieldName: 'cursor',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'String'
                                }],
                                fieldName: 'edges',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'ItemsEdge'
                            }, {
                                children: [{
                                    fieldName: 'hasNextPage',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'Boolean'
                                }, {
                                    fieldName: 'hasPreviousPage',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'Boolean'
                                }],
                                fieldName: 'pageInfo',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'PageInfo'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'fetchLocalItems'
                                    }
                                }]
                            }],
                            fieldName: 'items',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'ItemsConnection'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userIds',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: '[PortfolioTypes]'
                                },
                                name: 'portfolioTypes',
                                value: [{
                                    kind: 'CallValue',
                                    callValue: 'CART'
                                }]
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'first',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 1
                                }
                            }],
                            children: [{
                                children: [{
                                    children: [{
                                        calls: [{
                                            kind: 'Call',
                                            metadata: {
                                                type: 'Int'
                                            },
                                            name: 'first',
                                            value: {
                                                kind: 'CallValue',
                                                callValue: 3
                                            }
                                        }],
                                        children: [{
                                            fieldName: 'totalResults',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'Int'
                                        }, {
                                            children: [{
                                                children: [{
                                                    children: [].concat.apply([], [{
                                                        fieldName: 'id',
                                                        kind: 'Field',
                                                        metadata: {
                                                            isGenerated: true,
                                                            isRequisite: true
                                                        },
                                                        type: 'ID'
                                                    }, RelayQL_GENERATED.__frag(CartNav_item)]),
                                                    fieldName: 'item',
                                                    kind: 'Field',
                                                    metadata: {
                                                        canHaveSubselections: true,
                                                        inferredRootCallName: 'node',
                                                        inferredPrimaryKey: 'id'
                                                    },
                                                    type: 'Item'
                                                }, {
                                                    fieldName: 'id',
                                                    kind: 'Field',
                                                    metadata: {
                                                        isGenerated: true,
                                                        isRequisite: true
                                                    },
                                                    type: 'ID'
                                                }],
                                                fieldName: 'node',
                                                kind: 'Field',
                                                metadata: {
                                                    canHaveSubselections: true,
                                                    inferredRootCallName: 'node',
                                                    inferredPrimaryKey: 'id',
                                                    isRequisite: true
                                                },
                                                type: 'PortfolioItemV2'
                                            }, {
                                                fieldName: 'cursor',
                                                kind: 'Field',
                                                metadata: {
                                                    isGenerated: true,
                                                    isRequisite: true
                                                },
                                                type: 'String'
                                            }],
                                            directives: [{
                                                kind: 'Directive',
                                                name: 'include',
                                                args: [{
                                                    name: 'if',
                                                    value: {
                                                        kind: 'CallVariable',
                                                        callVariableName: 'fetchPortfolioItems'
                                                    }
                                                }]
                                            }],
                                            fieldName: 'edges',
                                            kind: 'Field',
                                            metadata: {
                                                canHaveSubselections: true,
                                                isPlural: true
                                            },
                                            type: 'PortfolioItemsEdge'
                                        }, {
                                            children: [{
                                                fieldName: 'hasNextPage',
                                                kind: 'Field',
                                                metadata: {
                                                    isGenerated: true,
                                                    isRequisite: true
                                                },
                                                type: 'Boolean'
                                            }, {
                                                fieldName: 'hasPreviousPage',
                                                kind: 'Field',
                                                metadata: {
                                                    isGenerated: true,
                                                    isRequisite: true
                                                },
                                                type: 'Boolean'
                                            }],
                                            fieldName: 'pageInfo',
                                            kind: 'Field',
                                            metadata: {
                                                canHaveSubselections: true,
                                                isGenerated: true,
                                                isRequisite: true
                                            },
                                            type: 'PageInfo'
                                        }],
                                        fieldName: 'items',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            isConnection: true
                                        },
                                        type: 'PortfolioItemsConnection'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'node',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        inferredRootCallName: 'node',
                                        inferredPrimaryKey: 'id',
                                        isRequisite: true
                                    },
                                    type: 'PortfolioV2'
                                }, {
                                    fieldName: 'cursor',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'String'
                                }],
                                fieldName: 'edges',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'PortfoliosEdge'
                            }, {
                                children: [{
                                    fieldName: 'hasNextPage',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'Boolean'
                                }, {
                                    fieldName: 'hasPreviousPage',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'Boolean'
                                }],
                                fieldName: 'pageInfo',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'PageInfo'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            fieldName: 'portfolios',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'PortfoliosConnection'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'CartNav_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    }
}, {
    modern: function modern() {
        return __webpack_require__("./src/components/CartNav/__generated__/CartNavRefetchQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var CartNav_viewer_args1 = (CartNav.__container__ || CartNav).getFragment('viewer', {
            fetchLocalItems: {
                kind: 'CallVariable',
                callVariableName: 'fetchLocalItems'
            },
            fetchPortfolioItems: {
                kind: 'CallVariable',
                callVariableName: 'fetchPortfolioItems'
            },
            localItemIds: {
                kind: 'CallVariable',
                callVariableName: 'localItemIds'
            }
        });
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'fetchLocalItems'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'fetchPortfolioItems'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'hasUserId'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'localItemIds'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userIds'
            }],
            name: 'CartNavRefetchQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(CartNav_viewer_args1)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'CartNavRefetchQuery',
                    type: 'Query'
                };
            }()
        };
    }
});

/***/ }),

/***/ "./src/components/CartNav/CartNavDropdownContent.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _dibsOverlaySpinner = __webpack_require__("./node_modules/dibs-overlay-spinner/dist/index.js");

var _dibsOverlaySpinner2 = _interopRequireDefault(_dibsOverlaySpinner);

var _CartNavDropdownListContent = __webpack_require__("./src/components/CartNav/CartNavDropdownListContent.js");

var _CartNavDropdownListContent2 = _interopRequireDefault(_CartNavDropdownListContent);

var _CartNavStyle = __webpack_require__("./src/components/CartNav/CartNav-style.scss");

var _CartNavStyle2 = _interopRequireDefault(_CartNavStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartNavDropdownEmptyContent = function CartNavDropdownEmptyContent() {
    return _react2.default.createElement(
        'div',
        { className: _CartNavStyle2.default.emptyCart, 'data-tn': 'cart-nav-dropdown-cart-empty' },
        'Your cart is empty.'
    );
};

var CartNavDropdownLoadingContent = function CartNavDropdownLoadingContent() {
    return _react2.default.createElement(
        'div',
        { className: _CartNavStyle2.default.dropdownLoadingContent },
        _react2.default.createElement(_dibsOverlaySpinner2.default, {
            position: 'isStatic',
            size: 'medium'
        })
    );
};

var CartNavDropdownContent = function CartNavDropdownContent(_ref) {
    var currency = _ref.currency,
        isEmptyState = _ref.isEmptyState,
        isUserTypeTrade = _ref.isUserTypeTrade,
        items = _ref.items;

    items = items || {};

    if (isEmptyState) {
        return _react2.default.createElement(
            'div',
            { className: _CartNavStyle2.default.dropdownContent },
            _react2.default.createElement(CartNavDropdownEmptyContent, null)
        );
    }

    return _react2.default.createElement(
        'div',
        { className: _CartNavStyle2.default.dropdownContent },
        !items.edges ? _react2.default.createElement(CartNavDropdownLoadingContent, null) : _react2.default.createElement(_CartNavDropdownListContent2.default, {
            currency: currency,
            isUserTypeTrade: isUserTypeTrade,
            items: items
        })
    );
};

var mapStateToProps = function mapStateToProps(_ref2) {
    var header = _ref2.header;
    var isUserTypeTrade = header.isUserTypeTrade;


    return {
        isUserTypeTrade: isUserTypeTrade
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CartNavDropdownContent);

/***/ }),

/***/ "./src/components/CartNav/CartNavDropdownListContent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _intelligentFormat = __webpack_require__("./node_modules/dibs-currency-helpers/intelligentFormat.js");

var _intelligentFormat2 = _interopRequireDefault(_intelligentFormat);

var _CartNavStyle = __webpack_require__("./src/components/CartNav/CartNav-style.scss");

var _CartNavStyle2 = _interopRequireDefault(_CartNavStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleOnClick = function handleOnClick(url) {
    (0, _dibsTracking.trackEvent)({
        category: 'navigation',
        action: 'header navigation click',
        label: 'cart|pdp'
    });
    location.href = url;
};

var CartNavDropdownListContent = function CartNavDropdownListContent(_ref) {
    var isUserTypeTrade = _ref.isUserTypeTrade,
        items = _ref.items,
        userCurrency = _ref.currency;
    var edges = items.edges;


    return _react2.default.createElement(
        'div',
        null,
        edges.map(function (_ref2) {
            var _ref2$node = _ref2.node,
                node = _ref2$node === undefined ? {} : _ref2$node;

            var item = node.item || node;
            var title = item.title,
                isSold = item.isSold,
                photos = item.photos,
                pricing = item.pricing,
                pdpURL = item.pdpURL,
                serviceId = item.serviceId;

            var prices = [];

            if (!isSold) {
                var netPrices = (0, _lodash2.default)(pricing, 'netPrice.convertedAmountList');
                var salePrices = (0, _lodash2.default)(pricing, 'salePrice.convertedAmountList');
                prices = (0, _lodash2.default)(pricing, 'retailPrice.convertedAmountList');

                if (salePrices) {
                    prices = salePrices;
                } else if (isUserTypeTrade && netPrices) {
                    prices = netPrices;
                }
            }

            var price = void 0;
            var photoPath = void 0;

            prices.some(function (_ref3) {
                var currency = _ref3.currency,
                    amount = _ref3.amount;

                price = amount;
                return currency === userCurrency;
            });

            (0, _lodash2.default)(photos, '[0].versions', []).some(function (_ref4) {
                var type = _ref4.type,
                    webPath = _ref4.webPath;

                photoPath = webPath;
                return type.name === 'small';
            });

            return _react2.default.createElement(
                'div',
                { key: serviceId,
                    className: _CartNavStyle2.default.dropdownRow,
                    onClick: function onClick() {
                        handleOnClick(pdpURL);
                    }
                },
                _react2.default.createElement(
                    'div',
                    { className: _CartNavStyle2.default.dropdownColumn },
                    _react2.default.createElement(
                        'div',
                        { className: _CartNavStyle2.default.dropdownItemImageWrapper },
                        _react2.default.createElement('img', { className: _CartNavStyle2.default.dropdownItemImage, src: photoPath })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _CartNavStyle2.default.dropdownColumn },
                    _react2.default.createElement(
                        'div',
                        { className: _CartNavStyle2.default.dropdownItemTitle },
                        title
                    ),
                    _react2.default.createElement(
                        'div',
                        { 'data-tn': 'cart-nav-dropdown-item-price', className: _CartNavStyle2.default.dropdownItemPrice },
                        isSold ? _react2.default.createElement(
                            'span',
                            { className: _CartNavStyle2.default.isSold },
                            'Sold'
                        ) : (0, _intelligentFormat2.default)(price, userCurrency)
                    )
                )
            );
        })
    );
};

exports.default = CartNavDropdownListContent;

/***/ }),

/***/ "./src/components/CartNav/CartNavDropdownTrigger.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _cartOpen = __webpack_require__("./node_modules/dibs-vg/dist/react/cart-open.js");

var _cartOpen2 = _interopRequireDefault(_cartOpen);

var _CartNavStyle = __webpack_require__("./src/components/CartNav/CartNav-style.scss");

var _CartNavStyle2 = _interopRequireDefault(_CartNavStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_CART_COUNT_DISPLAY = 9;

function handleOnClick() {
    (0, _dibsTracking.trackEvent)({
        category: 'navigation',
        action: 'header navigation click',
        label: 'cart|cart header link'
    });
}

var CartNavCount = function CartNavCount(_ref) {
    var count = _ref.count;
    return _react2.default.createElement(
        'div',
        { className: _CartNavStyle2.default.countWrapper },
        _react2.default.createElement(
            'span',
            { className: _CartNavStyle2.default.count },
            count,
            count === MAX_CART_COUNT_DISPLAY ? _react2.default.createElement(
                'sup',
                null,
                '+'
            ) : null
        )
    );
};

var CartNavDropdownTrigger = function CartNavDropdownTrigger(_ref2) {
    var _ref2$count = _ref2.count,
        count = _ref2$count === undefined ? 0 : _ref2$count,
        handleMouseEnter = _ref2.handleMouseEnter;

    count = Math.min(count, MAX_CART_COUNT_DISPLAY);

    return _react2.default.createElement(
        'div',
        { 'data-tn': 'cart-nav-dropdown-trigger', className: _CartNavStyle2.default.iconWrapper, onMouseEnter: handleMouseEnter },
        _react2.default.createElement(
            'a',
            { className: _CartNavStyle2.default.icon, href: '/my/cart/', onClick: handleOnClick },
            count ? _react2.default.createElement(CartNavCount, { count: count }) : null,
            _react2.default.createElement(_cartOpen2.default, null)
        )
    );
};

CartNavDropdownTrigger.defaultProps = {
    handleMouseEnter: function handleMouseEnter() {}
};

exports.default = CartNavDropdownTrigger;

/***/ }),

/***/ "./src/components/CartNav/__generated__/AddCartItemMutation.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash fb59d4aa0ca6dd14f2855e52c7ca72fa
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AddCartItemMutationVariables = {|
  input: {
    action: "ADD" | "EDIT" | "REMOVE" | "REORDER";
    description?: ?string;
    endPortfolioId?: ?string;
    itemsIds?: ?$ReadOnlyArray<?string>;
    name?: ?string;
    note?: ?string;
    portfolioIds?: ?$ReadOnlyArray<?string>;
    portfoliosType: "CART" | "PROCUREMENT" | "HEART" | "FOLDER" | "PROJECT";
    privacyLevel?: ?"PRIVATE" | "PUBLIC" | "SHAREABLE";
    startPortfolioId?: ?string;
    targetPortfolioId?: ?string;
    userId: string;
    clientMutationId?: ?string;
  };
|};

export type AddCartItemMutationResponse = {|
  +modifyPortfolios: ?{|
    +portfolios: ?$ReadOnlyArray<?{|
      +items: ?{|
        +totalResults: ?number;
      |};
    |}>;
  |};
|};
*/

/*
mutation AddCartItemMutation(
  $input: ModifyPortfoliosInput!
) {
  modifyPortfolios(input: $input) {
    portfolios {
      items {
        totalResults
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "ModifyPortfoliosInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddCartItemMutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ModifyPortfoliosInput!"
      }],
      "concreteType": "ModifyPortfoliosPayload",
      "name": "modifyPortfolios",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "PortfolioV2",
        "name": "portfolios",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "PortfolioItemsConnection",
          "name": "items",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AddCartItemMutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "ModifyPortfoliosInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "AddCartItemMutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ModifyPortfoliosInput!"
      }],
      "concreteType": "ModifyPortfoliosPayload",
      "name": "modifyPortfolios",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "PortfolioV2",
        "name": "portfolios",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "PortfolioItemsConnection",
          "name": "items",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation AddCartItemMutation(\n  $input: ModifyPortfoliosInput!\n) {\n  modifyPortfolios(input: $input) {\n    portfolios {\n      items {\n        totalResults\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/CartNav/__generated__/CartNavRefetchQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 4a8d3519ea707224ea33f36664863ee8
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type CartNavRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query CartNavRefetchQuery(
  $fetchLocalItems: Boolean!
  $fetchPortfolioItems: Boolean!
  $hasUserId: Boolean!
  $localItemIds: [String]
  $userIds: [String!]
) {
  viewer {
    ...CartNav_viewer_6C3tX
    id
  }
}

fragment CartNav_viewer_6C3tX on Viewer {
  items(itemIds: $localItemIds, first: 3) @include(if: $fetchLocalItems) {
    edges {
      node {
        pdpURL
        serviceId
        title
        isSold
        photos {
          versions {
            webPath
            type {
              name
            }
          }
          id
        }
        pricing {
          netPrice {
            amount
            currency
            convertedAmountList {
              currency
              amount
            }
          }
          salePrice {
            amount
            currency
            convertedAmountList {
              currency
              amount
            }
          }
          retailPrice {
            amount
            currency
            convertedAmountList {
              currency
              amount
            }
          }
        }
        id
      }
    }
  }
  portfolios(userIds: $userIds, portfolioTypes: [CART], first: 1) @include(if: $hasUserId) {
    edges {
      node {
        items(first: 3) {
          totalResults
          edges @include(if: $fetchPortfolioItems) {
            node {
              item {
                pdpURL
                serviceId
                title
                isSold
                photos {
                  versions {
                    webPath
                    type {
                      name
                    }
                  }
                  id
                }
                pricing {
                  netPrice {
                    amount
                    currency
                    convertedAmountList {
                      currency
                      amount
                    }
                  }
                  salePrice {
                    amount
                    currency
                    convertedAmountList {
                      currency
                      amount
                    }
                  }
                  retailPrice {
                    amount
                    currency
                    convertedAmountList {
                      currency
                      amount
                    }
                  }
                }
                id
              }
              id
            }
          }
        }
        id
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "fetchLocalItems",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchPortfolioItems",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "localItemIds",
      "type": "[String]",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String!]",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "CartNavRefetchQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "CartNav_viewer",
        "args": [{
          "kind": "Variable",
          "name": "fetchLocalItems",
          "variableName": "fetchLocalItems",
          "type": null
        }, {
          "kind": "Variable",
          "name": "fetchPortfolioItems",
          "variableName": "fetchPortfolioItems",
          "type": null
        }, {
          "kind": "Variable",
          "name": "localItemIds",
          "variableName": "localItemIds",
          "type": null
        }]
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "CartNavRefetchQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "fetchLocalItems",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchPortfolioItems",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "localItemIds",
      "type": "[String]",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String!]",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "CartNavRefetchQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 1,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "portfolioTypes",
            "value": ["CART"],
            "type": "[PortfolioTypes]"
          }, {
            "kind": "Variable",
            "name": "userIds",
            "variableName": "userIds",
            "type": "[String]"
          }],
          "concreteType": "PortfoliosConnection",
          "name": "portfolios",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PortfoliosEdge",
            "name": "edges",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "PortfolioV2",
              "name": "node",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 3,
                  "type": "Int"
                }],
                "concreteType": "PortfolioItemsConnection",
                "name": "items",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "totalResults",
                  "storageKey": null
                }, {
                  "kind": "Condition",
                  "passingValue": true,
                  "condition": "fetchPortfolioItems",
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioItemsEdge",
                    "name": "edges",
                    "plural": true,
                    "selections": [{
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "PortfolioItemV2",
                      "name": "node",
                      "plural": false,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Item",
                        "name": "item",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "pdpURL",
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "serviceId",
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "title",
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "isSold",
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "ItemPhoto",
                          "name": "photos",
                          "plural": true,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPhotoVersion",
                            "name": "versions",
                            "plural": true,
                            "selections": [{
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "webPath",
                              "storageKey": null
                            }, {
                              "kind": "LinkedField",
                              "alias": null,
                              "args": null,
                              "concreteType": "ImageVersionType",
                              "name": "type",
                              "plural": false,
                              "selections": [{
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "name",
                                "storageKey": null
                              }],
                              "storageKey": null
                            }],
                            "storageKey": null
                          }, {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }],
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "ItemPricing",
                          "name": "pricing",
                          "plural": false,
                          "selections": [{
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "name": "netPrice",
                            "plural": false,
                            "selections": [{
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "amount",
                              "storageKey": null
                            }, {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "currency",
                              "storageKey": null
                            }, {
                              "kind": "LinkedField",
                              "alias": null,
                              "args": null,
                              "concreteType": "ConvertedAmountList",
                              "name": "convertedAmountList",
                              "plural": true,
                              "selections": [{
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "currency",
                                "storageKey": null
                              }, {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "amount",
                                "storageKey": null
                              }],
                              "storageKey": null
                            }],
                            "storageKey": null
                          }, {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "name": "salePrice",
                            "plural": false,
                            "selections": [{
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "amount",
                              "storageKey": null
                            }, {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "currency",
                              "storageKey": null
                            }, {
                              "kind": "LinkedField",
                              "alias": null,
                              "args": null,
                              "concreteType": "ConvertedAmountList",
                              "name": "convertedAmountList",
                              "plural": true,
                              "selections": [{
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "currency",
                                "storageKey": null
                              }, {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "amount",
                                "storageKey": null
                              }],
                              "storageKey": null
                            }],
                            "storageKey": null
                          }, {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "name": "retailPrice",
                            "plural": false,
                            "selections": [{
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "amount",
                              "storageKey": null
                            }, {
                              "kind": "ScalarField",
                              "alias": null,
                              "args": null,
                              "name": "currency",
                              "storageKey": null
                            }, {
                              "kind": "LinkedField",
                              "alias": null,
                              "args": null,
                              "concreteType": "ConvertedAmountList",
                              "name": "convertedAmountList",
                              "plural": true,
                              "selections": [{
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "currency",
                                "storageKey": null
                              }, {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "amount",
                                "storageKey": null
                              }],
                              "storageKey": null
                            }],
                            "storageKey": null
                          }],
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "id",
                          "storageKey": null
                        }],
                        "storageKey": null
                      }, {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }],
                      "storageKey": null
                    }],
                    "storageKey": null
                  }]
                }],
                "storageKey": "items{\"first\":3}"
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }]
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "fetchLocalItems",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 3,
            "type": "Int"
          }, {
            "kind": "Variable",
            "name": "itemIds",
            "variableName": "localItemIds",
            "type": "[String]"
          }],
          "concreteType": "ItemsConnection",
          "name": "items",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "ItemsEdge",
            "name": "edges",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "name": "node",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "pdpURL",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "serviceId",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "title",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "isSold",
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ItemPhoto",
                "name": "photos",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "ItemPhotoVersion",
                  "name": "versions",
                  "plural": true,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "webPath",
                    "storageKey": null
                  }, {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageVersionType",
                    "name": "type",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "name",
                      "storageKey": null
                    }],
                    "storageKey": null
                  }],
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ItemPricing",
                "name": "pricing",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "name": "netPrice",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "amount",
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "currency",
                    "storageKey": null
                  }, {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ConvertedAmountList",
                    "name": "convertedAmountList",
                    "plural": true,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "currency",
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "amount",
                      "storageKey": null
                    }],
                    "storageKey": null
                  }],
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "name": "salePrice",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "amount",
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "currency",
                    "storageKey": null
                  }, {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ConvertedAmountList",
                    "name": "convertedAmountList",
                    "plural": true,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "currency",
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "amount",
                      "storageKey": null
                    }],
                    "storageKey": null
                  }],
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "name": "retailPrice",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "amount",
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "currency",
                    "storageKey": null
                  }, {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ConvertedAmountList",
                    "name": "convertedAmountList",
                    "plural": true,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "currency",
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "amount",
                      "storageKey": null
                    }],
                    "storageKey": null
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query CartNavRefetchQuery(\n  $fetchLocalItems: Boolean!\n  $fetchPortfolioItems: Boolean!\n  $hasUserId: Boolean!\n  $localItemIds: [String]\n  $userIds: [String!]\n) {\n  viewer {\n    ...CartNav_viewer_6C3tX\n    id\n  }\n}\n\nfragment CartNav_viewer_6C3tX on Viewer {\n  items(itemIds: $localItemIds, first: 3) @include(if: $fetchLocalItems) {\n    edges {\n      node {\n        pdpURL\n        serviceId\n        title\n        isSold\n        photos {\n          versions {\n            webPath\n            type {\n              name\n            }\n          }\n          id\n        }\n        pricing {\n          netPrice {\n            amount\n            currency\n            convertedAmountList {\n              currency\n              amount\n            }\n          }\n          salePrice {\n            amount\n            currency\n            convertedAmountList {\n              currency\n              amount\n            }\n          }\n          retailPrice {\n            amount\n            currency\n            convertedAmountList {\n              currency\n              amount\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  portfolios(userIds: $userIds, portfolioTypes: [CART], first: 1) @include(if: $hasUserId) {\n    edges {\n      node {\n        items(first: 3) {\n          totalResults\n          edges @include(if: $fetchPortfolioItems) {\n            node {\n              item {\n                pdpURL\n                serviceId\n                title\n                isSold\n                photos {\n                  versions {\n                    webPath\n                    type {\n                      name\n                    }\n                  }\n                  id\n                }\n                pricing {\n                  netPrice {\n                    amount\n                    currency\n                    convertedAmountList {\n                      currency\n                      amount\n                    }\n                  }\n                  salePrice {\n                    amount\n                    currency\n                    convertedAmountList {\n                      currency\n                      amount\n                    }\n                  }\n                  retailPrice {\n                    amount\n                    currency\n                    convertedAmountList {\n                      currency\n                      amount\n                    }\n                  }\n                }\n                id\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/CartNav/__generated__/CartNav_financialAmount.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CartNav_financialAmount = {|
  +amount: ?number;
  +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
  +convertedAmountList: ?$ReadOnlyArray<?{|
    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
    +amount: ?number;
  |}>;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartNav_financialAmount",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "amount",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "currency",
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "currency",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "amount",
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "FinancialAmount"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/CartNav/__generated__/CartNav_item.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CartNav_item = {|
  +pdpURL: ?string;
  +serviceId: ?string;
  +title: ?string;
  +isSold: ?boolean;
  +photos: ?$ReadOnlyArray<?{|
    +versions: ?$ReadOnlyArray<?{|
      +webPath: ?string;
      +type: ?{|
        +name: ?"thumb" | "small" | "medium" | "large" | "zoom" | "original" | "master";
      |};
    |}>;
  |}>;
  +pricing: ?{|
    +netPrice: ?{|
      +amount: ?number;
      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      +convertedAmountList: ?$ReadOnlyArray<?{|
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
        +amount: ?number;
      |}>;
    |};
    +salePrice: ?{|
      +amount: ?number;
      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      +convertedAmountList: ?$ReadOnlyArray<?{|
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
        +amount: ?number;
      |}>;
    |};
    +retailPrice: ?{|
      +amount: ?number;
      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      +convertedAmountList: ?$ReadOnlyArray<?{|
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
        +amount: ?number;
      |}>;
    |};
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartNav_item",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "pdpURL",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "serviceId",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "title",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "isSold",
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "ItemPhoto",
    "name": "photos",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "ItemPhotoVersion",
      "name": "versions",
      "plural": true,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "webPath",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "ImageVersionType",
        "name": "type",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "ItemPricing",
    "name": "pricing",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "name": "netPrice",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "amount",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "currency",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "name": "convertedAmountList",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currency",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "amount",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "name": "salePrice",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "amount",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "currency",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "name": "convertedAmountList",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currency",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "amount",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "name": "retailPrice",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "amount",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "currency",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "name": "convertedAmountList",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currency",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "amount",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "Item"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/CartNav/__generated__/CartNav_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CartNav_user = {|
  +profile: ?{|
    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartNav_user",
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Profile",
    "name": "profile",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "currency",
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/CartNav/__generated__/CartNav_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CartNav_viewer = {|
  +items?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +pdpURL: ?string;
        +serviceId: ?string;
        +title: ?string;
        +isSold: ?boolean;
        +photos: ?$ReadOnlyArray<?{|
          +versions: ?$ReadOnlyArray<?{|
            +webPath: ?string;
            +type: ?{|
              +name: ?"thumb" | "small" | "medium" | "large" | "zoom" | "original" | "master";
            |};
          |}>;
        |}>;
        +pricing: ?{|
          +netPrice: ?{|
            +amount: ?number;
            +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
            +convertedAmountList: ?$ReadOnlyArray<?{|
              +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
              +amount: ?number;
            |}>;
          |};
          +salePrice: ?{|
            +amount: ?number;
            +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
            +convertedAmountList: ?$ReadOnlyArray<?{|
              +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
              +amount: ?number;
            |}>;
          |};
          +retailPrice: ?{|
            +amount: ?number;
            +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
            +convertedAmountList: ?$ReadOnlyArray<?{|
              +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
              +amount: ?number;
            |}>;
          |};
        |};
      |};
    |}>;
  |};
  +portfolios?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +items: ?{|
          +totalResults: ?number;
          +edges?: ?$ReadOnlyArray<?{|
            +node: ?{|
              +item: ?{|
                +pdpURL: ?string;
                +serviceId: ?string;
                +title: ?string;
                +isSold: ?boolean;
                +photos: ?$ReadOnlyArray<?{|
                  +versions: ?$ReadOnlyArray<?{|
                    +webPath: ?string;
                    +type: ?{|
                      +name: ?"thumb" | "small" | "medium" | "large" | "zoom" | "original" | "master";
                    |};
                  |}>;
                |}>;
                +pricing: ?{|
                  +netPrice: ?{|
                    +amount: ?number;
                    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
                    +convertedAmountList: ?$ReadOnlyArray<?{|
                      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
                      +amount: ?number;
                    |}>;
                  |};
                  +salePrice: ?{|
                    +amount: ?number;
                    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
                    +convertedAmountList: ?$ReadOnlyArray<?{|
                      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
                      +amount: ?number;
                    |}>;
                  |};
                  +retailPrice: ?{|
                    +amount: ?number;
                    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
                    +convertedAmountList: ?$ReadOnlyArray<?{|
                      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
                      +amount: ?number;
                    |}>;
                  |};
                |};
              |};
            |};
          |}>;
        |};
      |};
    |}>;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "fetchPortfolioItems",
    "type": "Boolean!",
    "defaultValue": false
  }, {
    "kind": "LocalArgument",
    "name": "fetchLocalItems",
    "type": "Boolean!",
    "defaultValue": false
  }, {
    "kind": "LocalArgument",
    "name": "localItemIds",
    "type": "[String]",
    "defaultValue": []
  }, {
    "kind": "RootArgument",
    "name": "userIds",
    "type": "[String]"
  }, {
    "kind": "RootArgument",
    "name": "hasUserId",
    "type": "Boolean"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartNav_viewer",
  "selections": [{
    "kind": "Condition",
    "passingValue": true,
    "condition": "hasUserId",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Literal",
        "name": "first",
        "value": 1,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "portfolioTypes",
        "value": ["CART"],
        "type": "[PortfolioTypes]"
      }, {
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds",
        "type": "[String]"
      }],
      "concreteType": "PortfoliosConnection",
      "name": "portfolios",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "PortfoliosEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "PortfolioV2",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": [{
              "kind": "Literal",
              "name": "first",
              "value": 3,
              "type": "Int"
            }],
            "concreteType": "PortfolioItemsConnection",
            "name": "items",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalResults",
              "storageKey": null
            }, {
              "kind": "Condition",
              "passingValue": true,
              "condition": "fetchPortfolioItems",
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "PortfolioItemsEdge",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "PortfolioItemV2",
                  "name": "node",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "name": "item",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "pdpURL",
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "serviceId",
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "title",
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "isSold",
                      "storageKey": null
                    }, {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "ItemPhoto",
                      "name": "photos",
                      "plural": true,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemPhotoVersion",
                        "name": "versions",
                        "plural": true,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "webPath",
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "ImageVersionType",
                          "name": "type",
                          "plural": false,
                          "selections": [{
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "name",
                            "storageKey": null
                          }],
                          "storageKey": null
                        }],
                        "storageKey": null
                      }],
                      "storageKey": null
                    }, {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "ItemPricing",
                      "name": "pricing",
                      "plural": false,
                      "selections": [{
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "name": "netPrice",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "amount",
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "currency",
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "ConvertedAmountList",
                          "name": "convertedAmountList",
                          "plural": true,
                          "selections": [{
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "currency",
                            "storageKey": null
                          }, {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "amount",
                            "storageKey": null
                          }],
                          "storageKey": null
                        }],
                        "storageKey": null
                      }, {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "name": "salePrice",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "amount",
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "currency",
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "ConvertedAmountList",
                          "name": "convertedAmountList",
                          "plural": true,
                          "selections": [{
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "currency",
                            "storageKey": null
                          }, {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "amount",
                            "storageKey": null
                          }],
                          "storageKey": null
                        }],
                        "storageKey": null
                      }, {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "name": "retailPrice",
                        "plural": false,
                        "selections": [{
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "amount",
                          "storageKey": null
                        }, {
                          "kind": "ScalarField",
                          "alias": null,
                          "args": null,
                          "name": "currency",
                          "storageKey": null
                        }, {
                          "kind": "LinkedField",
                          "alias": null,
                          "args": null,
                          "concreteType": "ConvertedAmountList",
                          "name": "convertedAmountList",
                          "plural": true,
                          "selections": [{
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "currency",
                            "storageKey": null
                          }, {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "amount",
                            "storageKey": null
                          }],
                          "storageKey": null
                        }],
                        "storageKey": null
                      }],
                      "storageKey": null
                    }],
                    "storageKey": null
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }]
            }],
            "storageKey": "items{\"first\":3}"
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  }, {
    "kind": "Condition",
    "passingValue": true,
    "condition": "fetchLocalItems",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Literal",
        "name": "first",
        "value": 3,
        "type": "Int"
      }, {
        "kind": "Variable",
        "name": "itemIds",
        "variableName": "localItemIds",
        "type": "[String]"
      }],
      "concreteType": "ItemsConnection",
      "name": "items",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "ItemsEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "pdpURL",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "title",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isSold",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "ItemPhoto",
            "name": "photos",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "ItemPhotoVersion",
              "name": "versions",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "webPath",
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ImageVersionType",
                "name": "type",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "name",
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "ItemPricing",
            "name": "pricing",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "name": "netPrice",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "amount",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "currency",
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ConvertedAmountList",
                "name": "convertedAmountList",
                "plural": true,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "currency",
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "amount",
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "name": "salePrice",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "amount",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "currency",
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ConvertedAmountList",
                "name": "convertedAmountList",
                "plural": true,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "currency",
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "amount",
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "name": "retailPrice",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "amount",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "currency",
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ConvertedAmountList",
                "name": "convertedAmountList",
                "plural": true,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "currency",
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "amount",
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/Drawer/Drawer-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"slideIn":"Drawer-style__slideIn__50c97140","slideOut":"Drawer-style__slideOut__50c97140","drawer":"Drawer-style__drawer__50c97140"};

/***/ }),

/***/ "./src/components/Drawer/Drawer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _constants = __webpack_require__("./src/actions/constants.js");

var _actions = __webpack_require__("./src/actions/index.js");

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _DrawerStyle = __webpack_require__("./src/components/Drawer/Drawer-style.scss");

var _DrawerStyle2 = _interopRequireDefault(_DrawerStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var drawerAnimations = _constants.actionValues.drawerAnimations;

var Drawer = function (_React$Component) {
    _inherits(Drawer, _React$Component);

    _createClass(Drawer, null, [{
        key: 'getWindowScrollY',
        value: function getWindowScrollY() {
            return window.pageYOffset || document.documentElement.scrollTop;
        }
    }]);

    function Drawer(props) {
        _classCallCheck(this, Drawer);

        var _this = _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).call(this, props));

        _this.windowScrollY = null;
        _this.animationFrameTicking = false;
        _this.animationFrameRequestId = 0;

        _this.handleScroll = _this.handleScroll.bind(_this);
        return _this;
    }

    _createClass(Drawer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.windowScrollY = Drawer.getWindowScrollY();
            window.addEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('scroll', this.handleScroll);
            window.cancelAnimationFrame(this.animationFrameRequestId);
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll() {
            var _this2 = this;

            var currScrollY = Drawer.getWindowScrollY();
            var prevScrollY = this.windowScrollY;

            if (typeof prevScrollY !== 'number' || prevScrollY < 0 || currScrollY < 0 || currScrollY < 100 && prevScrollY < 100) {
                return;
            }

            if (this.props.__disableAnimationFrameTicking || !this.animationFrameTicking) {
                // Since scroll events can fire at a high rate, the event handler shouldn't execute
                // computationally expensive operations--it is recommended to throttle the event
                // https://developer.mozilla.org/en-US/docs/Web/Events/scroll
                this.animationFrameRequestId = window.requestAnimationFrame(function () {
                    var animation = currScrollY > prevScrollY ? drawerAnimations.SLIDE_OUT : drawerAnimations.SLIDE_IN;

                    _this2.props.onScroll(animation);

                    _this2.animationFrameTicking = false;
                    _this2.windowScrollY = currScrollY;
                });
            }
            this.animationFrameTicking = true;
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var _props = this.props,
                animation = _props.animation,
                children = _props.children;


            var classes = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _DrawerStyle2.default.drawer, true), _defineProperty(_classnames, _DrawerStyle2.default.slideOut, animation === drawerAnimations.SLIDE_OUT), _defineProperty(_classnames, _DrawerStyle2.default.slideIn, animation === drawerAnimations.SLIDE_IN), _classnames));

            return _react2.default.createElement(
                'div',
                { className: classes },
                children
            );
        }
    }]);

    return Drawer;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
    var header = _ref.header;
    var animation = header.animation;


    return {
        animation: animation
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onScroll: function onScroll(animation) {
            dispatch(_actions.actionCreators.setDrawerAnimation(animation));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Drawer);

/***/ }),

/***/ "./src/components/Dropdown/Dropdown-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Dropdown-style__wrapper__296ffdc0","dropdown":"Dropdown-style__dropdown__296ffdc0","isVisible":"Dropdown-style__isVisible__296ffdc0","bodyWrapper":"Dropdown-style__bodyWrapper__296ffdc0","small":"Dropdown-style__small__296ffdc0","medium":"Dropdown-style__medium__296ffdc0","large":"Dropdown-style__large__296ffdc0","extraLarge":"Dropdown-style__extraLarge__296ffdc0","body":"Dropdown-style__body__296ffdc0","header":"Dropdown-style__header__296ffdc0","headerTitle":"Dropdown-style__headerTitle__296ffdc0","headerLink":"Dropdown-style__headerLink__296ffdc0"};

/***/ }),

/***/ "./src/components/Dropdown/Dropdown.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sizeConstants = exports.alignConstants = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _dropdownConstants = __webpack_require__("./src/components/Dropdown/dropdownConstants.js");

var _classnames4 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames5 = _interopRequireDefault(_classnames4);

var _DropdownStyle = __webpack_require__("./src/components/Dropdown/Dropdown-style.scss");

var _DropdownStyle2 = _interopRequireDefault(_DropdownStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALIGN_LEFT = _dropdownConstants.alignConstants.ALIGN_LEFT,
    ALIGN_RIGHT = _dropdownConstants.alignConstants.ALIGN_RIGHT,
    ALIGN_CENTER = _dropdownConstants.alignConstants.ALIGN_CENTER;
var SIZE_SMALL = _dropdownConstants.sizeConstants.SIZE_SMALL,
    SIZE_MEDIUM = _dropdownConstants.sizeConstants.SIZE_MEDIUM,
    SIZE_LARGE = _dropdownConstants.sizeConstants.SIZE_LARGE,
    SIZE_EXTRA_LARGE = _dropdownConstants.sizeConstants.SIZE_EXTRA_LARGE;

var Dropdown = function (_React$Component) {
    _inherits(Dropdown, _React$Component);

    function Dropdown(props) {
        _classCallCheck(this, Dropdown);

        var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

        _this.state = {
            isClient: false,
            isVisible: false
        };

        _this.dropdown = null;
        _this.hide = _this.hide.bind(_this);
        _this.show = _this.show.bind(_this);
        _this.adjustLeftStyle = _this.adjustLeftStyle.bind(_this);
        return _this;
    }

    _createClass(Dropdown, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            window.addEventListener('orientationchange', this.adjustLeftStyle);
            // Initialize alignments
            this.setState({ isClient: true }, function () {
                // eslint-disable-line react/no-did-mount-set-state
                _this2.adjustLeftStyle();
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('orientationchange', this.adjustLeftStyle);
        }
    }, {
        key: 'adjustLeftStyle',
        value: function adjustLeftStyle() {
            var align = this.props.align;

            var _dropdown$getBounding = this.dropdown.getBoundingClientRect(),
                width = _dropdown$getBounding.width;

            switch (align) {
                case ALIGN_RIGHT:
                    this.dropdown.style.right = 0;
                    // `right` alignments need no further checking / calculations, exit function
                    return;

                case ALIGN_CENTER:
                    this.dropdown.style.left = 'calc(50% - ' + width / 2 + 'px)';
                    break;

                case ALIGN_LEFT:
                    this.dropdown.style.left = 0;
                    break;
            }

            var _dropdown$getBounding2 = this.dropdown.getBoundingClientRect(),
                left = _dropdown$getBounding2.left;

            var screenWidth = document.body.getBoundingClientRect().width;

            // Check if initial position overflows window boundaries and re-position if true
            if (left + width > screenWidth) {
                var overflow = left + width - screenWidth;
                // Subtract overflow from initial position
                this.dropdown.style.left = align === ALIGN_LEFT ? -overflow + 'px' : 'calc(50% - ' + (width / 2 + overflow) + 'px)';
            }
        }
    }, {
        key: 'show',
        value: function show() {
            var _this3 = this;

            this.setState({ isVisible: true }, function () {
                var onShow = _this3.props.onShow;

                if (onShow) {
                    onShow();
                }
            });
        }
    }, {
        key: 'hide',
        value: function hide() {
            var _this4 = this;

            this.setState({ isVisible: false }, function () {
                var onHide = _this4.props.onHide;

                if (onHide) {
                    onHide();
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames2,
                _classnames3,
                _this5 = this;

            var _props = this.props,
                children = _props.children,
                className = _props.className,
                size = _props.size;
            var _state = this.state,
                isClient = _state.isClient,
                isVisible = _state.isVisible;


            var wrapperClasses = (0, _classnames5.default)((_classnames = {}, _defineProperty(_classnames, _DropdownStyle2.default.wrapper, true), _defineProperty(_classnames, _DropdownStyle2.default.isVisible, isVisible), _defineProperty(_classnames, className, !!className), _classnames));
            var dropdownClasses = (0, _classnames5.default)((_classnames2 = {}, _defineProperty(_classnames2, _DropdownStyle2.default.dropdown, true), _defineProperty(_classnames2, _DropdownStyle2.default.isVisible, isVisible), _classnames2));
            var bodyWrapperClasses = (0, _classnames5.default)((_classnames3 = {}, _defineProperty(_classnames3, _DropdownStyle2.default.bodyWrapper, true), _defineProperty(_classnames3, _DropdownStyle2.default.isVisible, isVisible), _defineProperty(_classnames3, _DropdownStyle2.default[size], !!size), _classnames3));

            if (!children) {
                return null;
            }

            var trigger = children[0];
            var body = children.length > 1 ? children.slice(1) : null;

            return _react2.default.createElement(
                'div',
                {
                    className: wrapperClasses,
                    onMouseEnter: this.show,
                    onMouseLeave: this.hide
                },
                trigger,
                isClient ? _react2.default.createElement(
                    'div',
                    { className: dropdownClasses },
                    _react2.default.createElement(
                        'div',
                        {
                            className: bodyWrapperClasses,
                            ref: function ref(element) {
                                _this5.dropdown = element;
                            }
                        },
                        body
                    )
                ) : null
            );
        }
    }]);

    return Dropdown;
}(_react2.default.Component);

Dropdown.defaultProps = {
    align: ALIGN_LEFT,
    size: SIZE_MEDIUM
};

exports.alignConstants = _dropdownConstants.alignConstants;
exports.sizeConstants = _dropdownConstants.sizeConstants;
exports.default = Dropdown;

/***/ }),

/***/ "./src/components/Dropdown/DropdownBody.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _DropdownStyle = __webpack_require__("./src/components/Dropdown/Dropdown-style.scss");

var _DropdownStyle2 = _interopRequireDefault(_DropdownStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownBody = function DropdownBody(_ref) {
    var children = _ref.children;

    return _react2.default.createElement(
        'div',
        { className: _DropdownStyle2.default.body },
        children
    );
};

exports.default = DropdownBody;

/***/ }),

/***/ "./src/components/Dropdown/DropdownHeader.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _DropdownStyle = __webpack_require__("./src/components/Dropdown/Dropdown-style.scss");

var _DropdownStyle2 = _interopRequireDefault(_DropdownStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownHeader = function DropdownHeader(props) {
    var title = props.title,
        link = props.link,
        href = props.href,
        onClick = props.onClick;


    return _react2.default.createElement(
        'div',
        { className: _DropdownStyle2.default.header },
        _react2.default.createElement(
            'div',
            { className: _DropdownStyle2.default.headerTitle },
            title
        ),
        link ? _react2.default.createElement(
            'a',
            {
                className: _DropdownStyle2.default.headerLink,
                onClick: onClick,
                href: href
            },
            link
        ) : null
    );
};

exports.default = DropdownHeader;

/***/ }),

/***/ "./src/components/Dropdown/dropdownConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var alignConstants = {
    ALIGN_LEFT: 'left',
    ALIGN_RIGHT: 'right',
    ALIGN_CENTER: 'center'
};

var sizeConstants = {
    SIZE_SMALL: 'small',
    SIZE_MEDIUM: 'medium',
    SIZE_LARGE: 'large',
    SIZE_EXTRA_LARGE: 'extraLarge'
};

exports.alignConstants = alignConstants;
exports.sizeConstants = sizeConstants;

/***/ }),

/***/ "./src/components/FavNotifications/FavNotifications-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stopScrolling":"FavNotifications-style__stopScrolling__ea774000","spinnerContainer":"FavNotifications-style__spinnerContainer__ea774000","favSpinnerWrapper":"FavNotifications-style__favSpinnerWrapper__ea774000","listContainer":"FavNotifications-style__listContainer__ea774000","tileList":"FavNotifications-style__tileList__ea774000"};

/***/ }),

/***/ "./src/components/FavNotifications/FavNotifications.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _FavNotificationsSpinner = __webpack_require__("./src/components/FavNotifications/FavNotificationsSpinner.jsx");

var _FavNotificationsSpinner2 = _interopRequireDefault(_FavNotificationsSpinner);

var _FavNotificationsTileList = __webpack_require__("./src/components/FavNotifications/FavNotificationsTileList.jsx");

var _FavNotificationsTileList2 = _interopRequireDefault(_FavNotificationsTileList);

var _FavNotificationsEmpty = __webpack_require__("./src/components/FavNotifications/FavNotificationsEmpty.jsx");

var _FavNotificationsEmpty2 = _interopRequireDefault(_FavNotificationsEmpty);

var _DropdownHeader = __webpack_require__("./src/components/Dropdown/DropdownHeader.jsx");

var _DropdownHeader2 = _interopRequireDefault(_DropdownHeader);

var _DropdownBody = __webpack_require__("./src/components/Dropdown/DropdownBody.jsx");

var _DropdownBody2 = _interopRequireDefault(_DropdownBody);

var _favNotificationsConstants = __webpack_require__("./src/components/FavNotifications/favNotificationsConstants.js");

var _trackingHelpers = __webpack_require__("./src/components/FavNotifications/trackingHelpers.es.js");

var _FavNotificationsStyle = __webpack_require__("./src/components/FavNotifications/FavNotifications-style.scss");

var _FavNotificationsStyle2 = _interopRequireDefault(_FavNotificationsStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INDICATOR_SHOWN_TRACKED = 'indicatorShownTracked';

var trackNewEventsIndicatorShown = function trackNewEventsIndicatorShown() {
    if (!_dibsBrowserStorage.sessionStorage.getItem(INDICATOR_SHOWN_TRACKED)) {
        (0, _dibsTracking.trackEvent)((0, _trackingHelpers.indicatorShownTrackingObj)());
        _dibsBrowserStorage.sessionStorage.setItem(INDICATOR_SHOWN_TRACKED, true);
    }
};

var toggleBodyScrolling = function toggleBodyScrolling() {
    document.body.classList.toggle(_FavNotificationsStyle2.default.stopScrolling);
};

var trackClick = function trackClick() {
    (0, _dibsTracking.trackEvent)((0, _trackingHelpers.getNotificationClickedTrackingObj)(_favNotificationsConstants.VIEW_ALL));
};

var FavNotifications = function FavNotifications(props) {
    var hasNewEvents = props.hasNewEvents,
        hasUserId = props.hasUserId,
        favoriteNotificationsTiles = props.favoriteNotificationsTiles,
        favoritesUrl = props.favoritesUrl;

    var _ref = favoriteNotificationsTiles || {},
        tiles = _ref.tiles;

    if (hasNewEvents) {
        trackNewEventsIndicatorShown();
    }

    var emptyState = !hasUserId || hasUserId && tiles && !tiles.length;

    if (emptyState) {
        (0, _dibsTracking.trackEvent)((0, _trackingHelpers.getNotificationsDisplayedTrackingObj)({
            types: [{ type: _favNotificationsConstants.EMPTY, displayed: true }]
        }));
    }

    return _react2.default.createElement(
        'div',
        { onMouseEnter: toggleBodyScrolling, onMouseLeave: toggleBodyScrolling },
        emptyState ? _react2.default.createElement(_FavNotificationsEmpty2.default, null) : _react2.default.createElement(_DropdownHeader2.default, {
            title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Header.FavNotifications.title', defaultMessage: 'Favorites' }),
            link: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Header.FavNotifications.link', defaultMessage: 'View All' }),
            href: favoritesUrl,
            onClick: trackClick
        }),
        !emptyState ? _react2.default.createElement(
            _DropdownBody2.default,
            null,
            !tiles ? _react2.default.createElement(_FavNotificationsSpinner2.default, null) : _react2.default.createElement(_FavNotificationsTileList2.default, {
                tiles: tiles,
                favoritesUrl: favoritesUrl,
                hasNewEvents: hasNewEvents
            })
        ) : null
    );
};

FavNotifications.defaultProps = {
    hasNewEvents: false
};

exports.default = (0, _reactRelay.createFragmentContainer)(FavNotifications, {
    favoriteNotificationsTiles: {
        modern: function modern() {
            return __webpack_require__("./src/components/FavNotifications/__generated__/FavNotifications_favoriteNotificationsTiles.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var FavNotificationsTileList_tiles = _FavNotificationsTileList2.default.getFragment('tiles');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    defaultValue: '',
                    kind: 'LocalArgument',
                    name: 'createdAfter'
                }, {
                    defaultValue: 0,
                    kind: 'LocalArgument',
                    name: 'eventsLimit'
                }, {
                    defaultValue: 0,
                    kind: 'LocalArgument',
                    name: 'notificationItemsLimit'
                }],
                node: function () {
                    return {
                        children: [{
                            alias: 'tiles',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'createdAfter',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'createdAfter'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'notificationsLimit',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'eventsLimit'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'notificationItemsLimit',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'notificationItemsLimit'
                                }
                            }],
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, RelayQL_GENERATED.__frag(FavNotificationsTileList_tiles)]),
                            fieldName: 'notificationsList',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'FavoriteNotification'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'FavNotifications_favoriteNotificationsTiles',
                        type: 'FavoriteNotifications'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/FavNotifications/FavNotificationsEmpty-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"FavNotificationsEmpty-style__container__a645cfd5","icon":"FavNotificationsEmpty-style__icon__a645cfd5","favoritesHeader":"FavNotificationsEmpty-style__favoritesHeader__a645cfd5","followHeader":"FavNotificationsEmpty-style__followHeader__a645cfd5","text":"FavNotificationsEmpty-style__text__a645cfd5","line":"FavNotificationsEmpty-style__line__a645cfd5"};

/***/ }),

/***/ "./src/components/FavNotifications/FavNotificationsEmpty.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _chairOutlined = __webpack_require__("./node_modules/dibs-vg/dist/react/chair-outlined.js");

var _chairOutlined2 = _interopRequireDefault(_chairOutlined);

var _FavNotificationsEmptyStyle = __webpack_require__("./src/components/FavNotifications/FavNotificationsEmpty-style.scss");

var _FavNotificationsEmptyStyle2 = _interopRequireDefault(_FavNotificationsEmptyStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavNotificationsEmpty = function FavNotificationsEmpty() {
    return _react2.default.createElement(
        'div',
        { className: _FavNotificationsEmptyStyle2.default.container },
        _react2.default.createElement(_chairOutlined2.default, { className: _FavNotificationsEmptyStyle2.default.icon }),
        _react2.default.createElement(
            'div',
            { className: _FavNotificationsEmptyStyle2.default.favoritesHeader },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'dbl.Header.FavNotificationsEmpty.favorites_header',
                defaultMessage: 'See something you like?'
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _FavNotificationsEmptyStyle2.default.text },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'dbl.Header.FavNotificationsEmpty.favorites_text',
                defaultMessage: 'Save items you love for updates on their status! Click the heart icon next to them.'
            })
        ),
        _react2.default.createElement('div', { className: _FavNotificationsEmptyStyle2.default.line }),
        _react2.default.createElement(
            'div',
            { className: _FavNotificationsEmptyStyle2.default.followHeader },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'dbl.Header.FavNotificationsEmpty.following_header',
                defaultMessage: 'Never miss out'
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _FavNotificationsEmptyStyle2.default.text },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'dbl.Header.FavNotificationsEmpty.following_text',
                defaultMessage: 'Follow categories, dealers, and interior designers to see new additions!'
            })
        ),
        _react2.default.createElement(
            'a',
            { href: '/' },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'dbl.Header.FavNotificationsEmpty.link_text',
                defaultMessage: 'Learn more'
            })
        )
    );
};

exports.default = FavNotificationsEmpty;

/***/ }),

/***/ "./src/components/FavNotifications/FavNotificationsSpinner.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _dibsOverlaySpinner = __webpack_require__("./node_modules/dibs-overlay-spinner/dist/index.js");

var _dibsOverlaySpinner2 = _interopRequireDefault(_dibsOverlaySpinner);

var _FavNotificationsStyle = __webpack_require__("./src/components/FavNotifications/FavNotifications-style.scss");

var _FavNotificationsStyle2 = _interopRequireDefault(_FavNotificationsStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavNotificationsSpinner = function FavNotificationsSpinner() {
    return _react2.default.createElement(
        'div',
        { className: _FavNotificationsStyle2.default.spinnerContainer },
        _react2.default.createElement(_dibsOverlaySpinner2.default, {
            additionalWrapperClasses: _FavNotificationsStyle2.default.favSpinnerWrapper,
            position: 'isStatic',
            size: 'medium'
        })
    );
};

exports.default = FavNotificationsSpinner;

/***/ }),

/***/ "./src/components/FavNotifications/FavNotificationsTile-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"FavNotificationsTile-style__container__77e16f4","notEmptyState":"FavNotificationsTile-style__notEmptyState__77e16f4","header":"FavNotificationsTile-style__header__77e16f4","headerAlert":"FavNotificationsTile-style__headerAlert__77e16f4","headerText":"FavNotificationsTile-style__headerText__77e16f4","headerTitleName":"FavNotificationsTile-style__headerTitleName__77e16f4","headerDate":"FavNotificationsTile-style__headerDate__77e16f4","itemsContainer":"FavNotificationsTile-style__itemsContainer__77e16f4","item":"FavNotificationsTile-style__item__77e16f4","itemImage":"FavNotificationsTile-style__itemImage__77e16f4","itemDescr":"FavNotificationsTile-style__itemDescr__77e16f4","itemDescrLink":"FavNotificationsTile-style__itemDescrLink__77e16f4","linkContainer":"FavNotificationsTile-style__linkContainer__77e16f4","arrow":"FavNotificationsTile-style__arrow__77e16f4","emptyText":"FavNotificationsTile-style__emptyText__77e16f4"};

/***/ }),

/***/ "./src/components/FavNotifications/FavNotificationsTile.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _arrowRight = __webpack_require__("./node_modules/dibs-vg/dist/react/arrow-right.js");

var _arrowRight2 = _interopRequireDefault(_arrowRight);

var _FavNotificationsTileItem = __webpack_require__("./src/components/FavNotifications/FavNotificationsTileItem.jsx");

var _FavNotificationsTileItem2 = _interopRequireDefault(_FavNotificationsTileItem);

var _FavNotificationsTileHeader = __webpack_require__("./src/components/FavNotifications/FavNotificationsTileHeader.jsx");

var _FavNotificationsTileHeader2 = _interopRequireDefault(_FavNotificationsTileHeader);

var _FavNotificationsTileDescription = __webpack_require__("./src/components/FavNotifications/FavNotificationsTileDescription.jsx");

var _FavNotificationsTileDescription2 = _interopRequireDefault(_FavNotificationsTileDescription);

var _favNotificationsConstants = __webpack_require__("./src/components/FavNotifications/favNotificationsConstants.js");

var _trackingHelpers = __webpack_require__("./src/components/FavNotifications/trackingHelpers.es.js");

var _FavNotificationsTileStyle = __webpack_require__("./src/components/FavNotifications/FavNotificationsTile-style.scss");

var _FavNotificationsTileStyle2 = _interopRequireDefault(_FavNotificationsTileStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getTilePage = function getTilePage(tile) {
    var type = tile.type,
        page = tile.page,
        items = tile.items,
        followingType = tile.followingType;


    if (!page && type === _favNotificationsConstants.ITEM_EVENT && items) {
        return items[0].pdpURL;
    }

    if (followingType === _favNotificationsConstants.FOLLOWING_TYPE_SEARCH) {
        var delimiter = page.indexOf('?') > 0 ? '&' : '?';
        return '' + page + delimiter + 'sort=newest';
    }

    return page;
};

var FavNotificationsTile = function (_Component) {
    _inherits(FavNotificationsTile, _Component);

    function FavNotificationsTile() {
        _classCallCheck(this, FavNotificationsTile);

        var _this = _possibleConstructorReturn(this, (FavNotificationsTile.__proto__ || Object.getPrototypeOf(FavNotificationsTile)).call(this));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(FavNotificationsTile, [{
        key: 'onClick',
        value: function onClick(event) {
            var _props = this.props,
                tile = _props.tile,
                favoritesUrl = _props.favoritesUrl;
            var eventType = tile.eventType,
                type = tile.type;

            (0, _dibsTracking.trackEvent)((0, _trackingHelpers.getNotificationClickedTrackingObj)(eventType || type));

            if (event.target.tagName !== 'A') {
                var tilePage = getTilePage(tile) || favoritesUrl;
                if (tilePage) {
                    window.location.href = tilePage;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var tile = this.props.tile;
            var type = tile.type,
                _tile$items = tile.items,
                items = _tile$items === undefined ? [] : _tile$items,
                _tile$totalResults = tile.totalResults,
                totalResults = _tile$totalResults === undefined ? 0 : _tile$totalResults;

            var moreItemsCount = totalResults - items.length;
            var containerClasses = _FavNotificationsTileStyle2.default.container + ' ' + _FavNotificationsTileStyle2.default.notEmptyState;

            if (!items.length) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: containerClasses, onClick: this.onClick },
                _react2.default.createElement(_FavNotificationsTileHeader2.default, { tile: tile }),
                _react2.default.createElement(
                    'div',
                    { className: _FavNotificationsTileStyle2.default.itemsContainer },
                    items.map(function (item) {
                        return _react2.default.createElement(_FavNotificationsTileItem2.default, { key: item.serviceId, item: item });
                    }),
                    type === _favNotificationsConstants.ITEM_EVENT && _react2.default.createElement(_FavNotificationsTileDescription2.default, { tile: tile }),
                    _react2.default.createElement(
                        'div',
                        { className: _FavNotificationsTileStyle2.default.linkContainer },
                        moreItemsCount > 0 && '+' + moreItemsCount,
                        _react2.default.createElement(_arrowRight2.default, { className: _FavNotificationsTileStyle2.default.arrow })
                    )
                )
            );
        }
    }]);

    return FavNotificationsTile;
}(_react.Component);

FavNotificationsTile.defaultProps = {
    favoritesUrl: null
};

exports.default = (0, _reactRelay.createFragmentContainer)(FavNotificationsTile, {
    tile: {
        modern: function modern() {
            return __webpack_require__("./src/components/FavNotifications/__generated__/FavNotificationsTile_tile.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var FavNotificationsTileItem_item = _FavNotificationsTileItem2.default.getFragment('item'),
                FavNotificationsTileHeader_tile = _FavNotificationsTileHeader2.default.getFragment('tile'),
                FavNotificationsTileDescription_tile = _FavNotificationsTileDescription2.default.getFragment('tile');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'type',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'eventType',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'followingType',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'page',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'totalResults',
                            kind: 'Field',
                            metadata: {},
                            type: 'Int'
                        }, {
                            children: [].concat.apply([], [{
                                fieldName: 'serviceId',
                                kind: 'Field',
                                metadata: {},
                                type: 'ID'
                            }, {
                                fieldName: 'pdpURL',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, RelayQL_GENERATED.__frag(FavNotificationsTileItem_item)]),
                            fieldName: 'items',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'Item'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(FavNotificationsTileHeader_tile), RelayQL_GENERATED.__frag(FavNotificationsTileDescription_tile)]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'FavNotificationsTile_tile',
                        type: 'FavoriteNotification'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/FavNotifications/FavNotificationsTileDescription.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _messages;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _favNotificationsConstants = __webpack_require__("./src/components/FavNotifications/favNotificationsConstants.js");

var _trackingHelpers = __webpack_require__("./src/components/FavNotifications/trackingHelpers.es.js");

var _FavNotificationsTileStyle = __webpack_require__("./src/components/FavNotifications/FavNotificationsTile-style.scss");

var _FavNotificationsTileStyle2 = _interopRequireDefault(_FavNotificationsTileStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeUrl = function makeUrl(_ref) {
    var item = _ref.item,
        eventType = _ref.eventType;

    if (eventType === _favNotificationsConstants.OFFER_MADE) {
        return item.pdpURL + '?modal=offer';
    } else if (eventType === _favNotificationsConstants.ON_SALE || eventType === _favNotificationsConstants.ITEM_SOLD) {
        return item.pdpURL;
    }
    return '';
};

var trackClick = function trackClick(_ref2) {
    var item = _ref2.item,
        eventType = _ref2.eventType;

    var trackingObjs = (0, _trackingHelpers.getItemEventLinkClickedTrackingObjs)({ item: item, eventType: eventType });
    trackingObjs.forEach(function (trackingObj) {
        return (0, _dibsTracking.trackEvent)(trackingObj);
    });
};

var messages = (_messages = {}, _defineProperty(_messages, _favNotificationsConstants.ON_SALE, {
    text: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Header.FavNotificationsTileDescription.sale_text',
        defaultMessage: 'This item\'s price has decreased.'
    }),
    link: {
        text: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'dbl.Header.FavNotificationsTileDescription.sale_link_text',
            defaultMessage: 'View Item'
        })
    }
}), _defineProperty(_messages, _favNotificationsConstants.OFFER_MADE, {
    text: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Header.FavNotificationsTileDescription.offer_text',
        defaultMessage: 'An offer has been made on this item.'
    }),
    link: {
        text: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'dbl.Header.FavNotificationsTileDescription.offer_link_text',
            defaultMessage: 'Make Offer'
        })
    }
}), _defineProperty(_messages, _favNotificationsConstants.ITEM_SOLD, {
    text: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Header.FavNotificationsTileDescription.sold_text',
        defaultMessage: 'This item was sold.'
    }),
    link: {
        text: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'dbl.Header.FavNotificationsTileDescription.sold_link_text',
            defaultMessage: 'View similar items'
        })
    }
}), _messages);

var FavNotificationsTileDescription = function FavNotificationsTileDescription(_ref3) {
    var tile = _ref3.tile;
    var items = tile.items,
        eventType = tile.eventType;

    var item = items[0];

    var _ref4 = messages[eventType] || {},
        text = _ref4.text,
        link = _ref4.link;

    var url = makeUrl({ item: item, eventType: eventType });

    return _react2.default.createElement(
        'div',
        { className: _FavNotificationsTileStyle2.default.itemDescr },
        text && text,
        link && link.text && url && _react2.default.createElement(
            'div',
            { className: _FavNotificationsTileStyle2.default.itemDescrLink },
            _react2.default.createElement(
                'a',
                { href: url, onClick: function onClick() {
                        trackClick({ item: item, eventType: eventType });
                    } },
                link.text
            )
        )
    );
};

exports.default = (0, _reactRelay.createFragmentContainer)(FavNotificationsTileDescription, {
    tile: {
        modern: function modern() {
            return __webpack_require__("./src/components/FavNotifications/__generated__/FavNotificationsTileDescription_tile.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            children: [{
                                fieldName: 'serviceId',
                                kind: 'Field',
                                metadata: {},
                                type: 'ID'
                            }, {
                                fieldName: 'pdpURL',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'items',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'Item'
                        }, {
                            fieldName: 'eventType',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'FavNotificationsTileDescription_tile',
                        type: 'FavoriteNotification'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/FavNotifications/FavNotificationsTileEmpty.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _messages;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _favNotificationsConstants = __webpack_require__("./src/components/FavNotifications/favNotificationsConstants.js");

var _FavNotificationsTileStyle = __webpack_require__("./src/components/FavNotifications/FavNotificationsTile-style.scss");

var _FavNotificationsTileStyle2 = _interopRequireDefault(_FavNotificationsTileStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var messages = (_messages = {}, _defineProperty(_messages, _favNotificationsConstants.FAVORITES, {
    header: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Header.FavNotificationsTileEmpty.favorites_header',
        defaultMessage: 'You have 0 likes'
    }),
    text: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Header.FavNotificationsTileEmpty.favorites_text',
        defaultMessage: 'Save items you love and get updates. Click on the heart next to each item to save.'
    })
}), _defineProperty(_messages, _favNotificationsConstants.FOLLOWING, {
    header: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Header.FavNotificationsTileEmpty.following_header',
        defaultMessage: 'You have 0 follows'
    }),
    text: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Header.FavNotificationsTileEmpty.following_text',
        defaultMessage: 'Follow categories, dealers and designers to see new additions.'
    })
}), _messages);

var FavNotificationsTileEmpty = function FavNotificationsTileEmpty(_ref) {
    var type = _ref.type;

    var staticContent = messages[type];

    return _react2.default.createElement(
        'div',
        { className: _FavNotificationsTileStyle2.default.container },
        _react2.default.createElement(
            'div',
            { className: _FavNotificationsTileStyle2.default.headerText },
            staticContent.header
        ),
        _react2.default.createElement(
            'div',
            { className: _FavNotificationsTileStyle2.default.emptyText },
            staticContent.text
        )
    );
};

exports.default = FavNotificationsTileEmpty;

/***/ }),

/***/ "./src/components/FavNotifications/FavNotificationsTileHeader.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _messages;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _favNotificationsConstants = __webpack_require__("./src/components/FavNotifications/favNotificationsConstants.js");

var _favNotificationsHelpers = __webpack_require__("./src/components/FavNotifications/favNotificationsHelpers.es.js");

var _FavNotificationsTileStyle = __webpack_require__("./src/components/FavNotifications/FavNotificationsTile-style.scss");

var _FavNotificationsTileStyle2 = _interopRequireDefault(_FavNotificationsTileStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Formats date string to MMM DD and if day number is one digit removes `0` in front, f.e. Jan 1
 */
var formatDate = function formatDate(date) {
    return date ? new Date(date).toDateString().match(' (.*) ')[1].replace(' 0', ' ') : '';
};

var messages = (_messages = {}, _defineProperty(_messages, _favNotificationsConstants.ITEM_EVENT, {
    header: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Header.FavNotificationsTileHeader.item_event_header',
        defaultMessage: 'Item Status'
    })
}), _defineProperty(_messages, _favNotificationsConstants.FAVORITES, {
    header: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Header.FavNotificationsTileHeader.favorites_header',
        defaultMessage: 'Recently Saved'
    })
}), _defineProperty(_messages, _favNotificationsConstants.FOLLOWING, {
    header: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Header.FavNotificationsTileHeader.following_header',
        defaultMessage: 'New Arrivals:'
    })
}), _messages);

var FavNotificationsTileHeader = function FavNotificationsTileHeader(_ref) {
    var tile = _ref.tile;
    var type = tile.type,
        name = tile.name,
        createdDate = tile.createdDate;

    var staticContent = messages[type] || {};
    var headerClasses = (0, _classnames2.default)(_FavNotificationsTileStyle2.default.header, _defineProperty({}, _FavNotificationsTileStyle2.default.headerAlert, (0, _favNotificationsHelpers.showAlert)(tile)));

    return _react2.default.createElement(
        'div',
        { className: headerClasses },
        _react2.default.createElement(
            'div',
            { className: _FavNotificationsTileStyle2.default.headerText },
            staticContent.header
        ),
        name && _react2.default.createElement(
            'div',
            { className: _FavNotificationsTileStyle2.default.headerTitleName },
            name
        ),
        createdDate && _react2.default.createElement(
            'div',
            { className: _FavNotificationsTileStyle2.default.headerDate },
            formatDate(createdDate)
        )
    );
};

exports.default = (0, _reactRelay.createFragmentContainer)(FavNotificationsTileHeader, {
    tile: {
        modern: function modern() {
            return __webpack_require__("./src/components/FavNotifications/__generated__/FavNotificationsTileHeader_tile.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            fieldName: 'type',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'name',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'createdDate',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'lastViewedDate',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'FavNotificationsTileHeader_tile',
                        type: 'FavoriteNotification'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/FavNotifications/FavNotificationsTileItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _FavNotificationsTileStyle = __webpack_require__("./src/components/FavNotifications/FavNotificationsTile-style.scss");

var _FavNotificationsTileStyle2 = _interopRequireDefault(_FavNotificationsTileStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavNotificationsTileItem = function FavNotificationsTileItem(_ref) {
    var item = _ref.item;

    return _react2.default.createElement(
        'div',
        { className: _FavNotificationsTileStyle2.default.item },
        _react2.default.createElement(
            'a',
            { href: item.pdpURL },
            _react2.default.createElement('img', { className: _FavNotificationsTileStyle2.default.itemImage, src: item.firstPhotoWebPath })
        )
    );
};

exports.default = (0, _reactRelay.createFragmentContainer)(FavNotificationsTileItem, {
    item: {
        modern: function modern() {
            return __webpack_require__("./src/components/FavNotifications/__generated__/FavNotificationsTileItem_item.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            fieldName: 'pdpURL',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {
                                    type: 'ImageVersionTypeName!'
                                },
                                name: 'size',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'thumb'
                                }
                            }],
                            fieldName: 'firstPhotoWebPath',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'FavNotificationsTileItem_item',
                        type: 'Item'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/FavNotifications/FavNotificationsTileList.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _FavNotificationsTile = __webpack_require__("./src/components/FavNotifications/FavNotificationsTile.jsx");

var _FavNotificationsTile2 = _interopRequireDefault(_FavNotificationsTile);

var _FavNotificationsTileEmpty = __webpack_require__("./src/components/FavNotifications/FavNotificationsTileEmpty.jsx");

var _FavNotificationsTileEmpty2 = _interopRequireDefault(_FavNotificationsTileEmpty);

var _favNotificationsConstants = __webpack_require__("./src/components/FavNotifications/favNotificationsConstants.js");

var _trackingHelpers = __webpack_require__("./src/components/FavNotifications/trackingHelpers.es.js");

var _favNotificationsHelpers = __webpack_require__("./src/components/FavNotifications/favNotificationsHelpers.es.js");

var _FollowingsShown = __webpack_require__("./src/components/FavNotifications/FollowingsShown.js");

var _FollowingsShown2 = _interopRequireDefault(_FollowingsShown);

var _FavNotificationsStyle = __webpack_require__("./src/components/FavNotifications/FavNotifications-style.scss");

var _FavNotificationsStyle2 = _interopRequireDefault(_FavNotificationsStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notificationsDisplayedTracked = false;

var followingsShown = function followingsShown(_ref) {
    var tiles = _ref.tiles,
        relay = _ref.relay;

    if (tiles.length) {
        _FollowingsShown2.default.commit({
            environment: relay.environment,
            ids: tiles.map(function (_ref2) {
                var serviceId = _ref2.serviceId;
                return serviceId;
            })
        });
    }
};

var FavNotificationsTileList = function FavNotificationsTileList(props) {
    var tiles = props.tiles,
        favoritesUrl = props.favoritesUrl,
        relay = props.relay,
        hasNewEvents = props.hasNewEvents;

    var hasFavorites = tiles.some(function (_ref3) {
        var type = _ref3.type;
        return type === _favNotificationsConstants.FAVORITES;
    });
    var hasFollowing = tiles.some(function (_ref4) {
        var type = _ref4.type;
        return type === _favNotificationsConstants.FOLLOWING;
    });

    if (!notificationsDisplayedTracked) {
        (0, _dibsTracking.trackEvent)((0, _trackingHelpers.getNotificationsDisplayedTrackingObj)({
            types: [{ type: _favNotificationsConstants.ON_SALE, displayed: tiles.some(function (_ref5) {
                    var eventType = _ref5.eventType;
                    return eventType === _favNotificationsConstants.ON_SALE;
                }) }, { type: _favNotificationsConstants.OFFER_MADE, displayed: tiles.some(function (_ref6) {
                    var eventType = _ref6.eventType;
                    return eventType === _favNotificationsConstants.OFFER_MADE;
                }) }, { type: _favNotificationsConstants.ITEM_SOLD, displayed: tiles.some(function (_ref7) {
                    var eventType = _ref7.eventType;
                    return eventType === _favNotificationsConstants.ITEM_SOLD;
                }) }, { type: _favNotificationsConstants.FAVORITES, displayed: hasFavorites }, { type: _favNotificationsConstants.FOLLOWING, displayed: hasFollowing }],
            hasNewEvents: hasNewEvents
        }));
        notificationsDisplayedTracked = true;
    }

    if (hasFollowing) {
        followingsShown({
            tiles: tiles.filter(function (tile) {
                return tile.type === _favNotificationsConstants.FOLLOWING && (0, _favNotificationsHelpers.showAlert)(tile);
            }),
            relay: relay
        });
    }

    return _react2.default.createElement(
        'div',
        { className: _FavNotificationsStyle2.default.listContainer },
        _react2.default.createElement(
            'div',
            { className: _FavNotificationsStyle2.default.tileList },
            tiles.map(function (tile) {
                return _react2.default.createElement(_FavNotificationsTile2.default, { key: tile.serviceId, tile: tile, favoritesUrl: favoritesUrl });
            }),
            !hasFavorites && _react2.default.createElement(_FavNotificationsTileEmpty2.default, { type: _favNotificationsConstants.FAVORITES }),
            !hasFollowing && _react2.default.createElement(_FavNotificationsTileEmpty2.default, { type: _favNotificationsConstants.FOLLOWING })
        )
    );
};

exports.default = (0, _reactRelay.createFragmentContainer)(FavNotificationsTileList, {
    tiles: {
        modern: function modern() {
            return __webpack_require__("./src/components/FavNotifications/__generated__/FavNotificationsTileList_tiles.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var FavNotificationsTile_tile = _FavNotificationsTile2.default.getFragment('tile');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'type',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'eventType',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'createdDate',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'lastViewedDate',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(FavNotificationsTile_tile)]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {
                            plural: true
                        },
                        name: 'FavNotificationsTileList_tiles',
                        type: 'FavoriteNotification'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/FavNotifications/FollowingsShown.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var mutation = {
    modern: function modern() {
        return __webpack_require__("./src/components/FavNotifications/__generated__/FollowingsShownMutation.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'input'
            }],
            name: 'FollowingsShownMutation',
            operation: 'mutation',
            node: function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'followingsShown',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'FollowingsShownInput!'
                    },
                    name: 'FollowingsShownMutation',
                    responseType: 'FollowingsShownPayload'
                };
            }()
        };
    }
};

function followingsShown(_ref) {
    var environment = _ref.environment,
        ids = _ref.ids;

    return (0, _reactRelay.commitMutation)(environment, {
        mutation: mutation,
        variables: {
            input: { ids: ids }
        }
    });
}

exports.default = { commit: followingsShown };

/***/ }),

/***/ "./src/components/FavNotifications/ItemEventsShownMutation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var mutation = {
    modern: function modern() {
        return __webpack_require__("./src/components/FavNotifications/__generated__/ItemEventsShownMutation.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'input'
            }],
            name: 'ItemEventsShownMutation',
            operation: 'mutation',
            node: function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'itemEventsShown',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        children: [{
                            fieldName: 'hasNewEvents',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'favoriteNotifications',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'FavoriteNotifications'
                    }, {
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'ItemEventsShownInput!'
                    },
                    name: 'ItemEventsShownMutation',
                    responseType: 'ItemEventsShownPayload'
                };
            }()
        };
    }
};

var updateItemEventsShown = function updateItemEventsShown(_ref) {
    var environment = _ref.environment,
        userId = _ref.userId;

    return (0, _reactRelay.commitMutation)(environment, {
        mutation: mutation,
        variables: {
            input: {
                userId: userId
            }
        }
    });
};

exports.default = { commit: updateItemEventsShown };

/***/ }),

/***/ "./src/components/FavNotifications/__generated__/FavNotificationsTileDescription_tile.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type FavNotificationsTileDescription_tile = {|
  +items: ?$ReadOnlyArray<?{|
    +serviceId: ?string;
    +pdpURL: ?string;
  |}>;
  +eventType: ?string;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavNotificationsTileDescription_tile",
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Item",
    "name": "items",
    "plural": true,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "pdpURL",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "eventType",
    "storageKey": null
  }],
  "type": "FavoriteNotification"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/FavNotifications/__generated__/FavNotificationsTileHeader_tile.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type FavNotificationsTileHeader_tile = {|
  +type: ?string;
  +name: ?string;
  +createdDate: ?string;
  +lastViewedDate: ?string;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavNotificationsTileHeader_tile",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "type",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "name",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "createdDate",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "lastViewedDate",
    "storageKey": null
  }],
  "type": "FavoriteNotification"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/FavNotifications/__generated__/FavNotificationsTileItem_item.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type FavNotificationsTileItem_item = {|
  +pdpURL: ?string;
  +firstPhotoWebPath: ?string;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavNotificationsTileItem_item",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "pdpURL",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": [{
      "kind": "Literal",
      "name": "size",
      "value": "thumb",
      "type": "ImageVersionTypeName!"
    }],
    "name": "firstPhotoWebPath",
    "storageKey": "firstPhotoWebPath{\"size\":\"thumb\"}"
  }],
  "type": "Item"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/FavNotifications/__generated__/FavNotificationsTileList_tiles.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type FavNotificationsTileList_tiles = $ReadOnlyArray<{|
  +serviceId: ?string;
  +type: ?string;
  +eventType: ?string;
  +createdDate: ?string;
  +lastViewedDate: ?string;
|}>;
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "FavNotificationsTileList_tiles",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "serviceId",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "type",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "eventType",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "createdDate",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "lastViewedDate",
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "FavNotificationsTile_tile",
    "args": null
  }],
  "type": "FavoriteNotification"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/FavNotifications/__generated__/FavNotificationsTile_tile.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type FavNotificationsTile_tile = {|
  +type: ?string;
  +eventType: ?string;
  +followingType: ?string;
  +page: ?string;
  +totalResults: ?number;
  +items: ?$ReadOnlyArray<?{|
    +serviceId: ?string;
    +pdpURL: ?string;
  |}>;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavNotificationsTile_tile",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "type",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "eventType",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "followingType",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "page",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "totalResults",
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Item",
    "name": "items",
    "plural": true,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "pdpURL",
      "storageKey": null
    }, {
      "kind": "FragmentSpread",
      "name": "FavNotificationsTileItem_item",
      "args": null
    }],
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "FavNotificationsTileHeader_tile",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "FavNotificationsTileDescription_tile",
    "args": null
  }],
  "type": "FavoriteNotification"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/FavNotifications/__generated__/FavNotifications_favoriteNotificationsTiles.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type FavNotifications_favoriteNotificationsTiles = {|
  +tiles: ?$ReadOnlyArray<?{| |}>;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "createdAfter",
    "type": "String!",
    "defaultValue": ""
  }, {
    "kind": "LocalArgument",
    "name": "eventsLimit",
    "type": "Int!",
    "defaultValue": 0
  }, {
    "kind": "LocalArgument",
    "name": "notificationItemsLimit",
    "type": "Int!",
    "defaultValue": 0
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavNotifications_favoriteNotificationsTiles",
  "selections": [{
    "kind": "LinkedField",
    "alias": "tiles",
    "args": [{
      "kind": "Variable",
      "name": "createdAfter",
      "variableName": "createdAfter",
      "type": "String"
    }, {
      "kind": "Variable",
      "name": "notificationItemsLimit",
      "variableName": "notificationItemsLimit",
      "type": "Int"
    }, {
      "kind": "Variable",
      "name": "notificationsLimit",
      "variableName": "eventsLimit",
      "type": "Int"
    }],
    "concreteType": "FavoriteNotification",
    "name": "notificationsList",
    "plural": true,
    "selections": [{
      "kind": "FragmentSpread",
      "name": "FavNotificationsTileList_tiles",
      "args": null
    }],
    "storageKey": null
  }],
  "type": "FavoriteNotifications"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/FavNotifications/__generated__/FollowingsShownMutation.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7aeaa5f4ae6065b271193b6580019ab5
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type FollowingsShownMutationVariables = {|
  input: {
    ids: $ReadOnlyArray<?string>;
    clientMutationId?: ?string;
  };
|};

export type FollowingsShownMutationResponse = {|
  +followingsShown: ?{|
    +clientMutationId: ?string;
  |};
|};
*/

/*
mutation FollowingsShownMutation(
  $input: FollowingsShownInput!
) {
  followingsShown(input: $input) {
    clientMutationId
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "FollowingsShownInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "FollowingsShownMutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "FollowingsShownInput!"
      }],
      "concreteType": "FollowingsShownPayload",
      "name": "followingsShown",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "clientMutationId",
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "FollowingsShownMutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "FollowingsShownInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "FollowingsShownMutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "FollowingsShownInput!"
      }],
      "concreteType": "FollowingsShownPayload",
      "name": "followingsShown",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "clientMutationId",
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation FollowingsShownMutation(\n  $input: FollowingsShownInput!\n) {\n  followingsShown(input: $input) {\n    clientMutationId\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/FavNotifications/__generated__/ItemEventsShownMutation.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7c2640580bfc0639184c86927382e3d6
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ItemEventsShownMutationVariables = {|
  input: {
    userId: string;
    clientMutationId?: ?string;
  };
|};

export type ItemEventsShownMutationResponse = {|
  +itemEventsShown: ?{|
    +favoriteNotifications: ?{|
      +hasNewEvents: ?boolean;
    |};
  |};
|};
*/

/*
mutation ItemEventsShownMutation(
  $input: ItemEventsShownInput!
) {
  itemEventsShown(input: $input) {
    favoriteNotifications {
      hasNewEvents
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "ItemEventsShownInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "ItemEventsShownMutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ItemEventsShownInput!"
      }],
      "concreteType": "ItemEventsShownPayload",
      "name": "itemEventsShown",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "FavoriteNotifications",
        "name": "favoriteNotifications",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "hasNewEvents",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ItemEventsShownMutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "ItemEventsShownInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "ItemEventsShownMutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ItemEventsShownInput!"
      }],
      "concreteType": "ItemEventsShownPayload",
      "name": "itemEventsShown",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "FavoriteNotifications",
        "name": "favoriteNotifications",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "hasNewEvents",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation ItemEventsShownMutation(\n  $input: ItemEventsShownInput!\n) {\n  itemEventsShown(input: $input) {\n    favoriteNotifications {\n      hasNewEvents\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/FavNotifications/favNotificationsConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MAX_TILES = exports.MAX_TILES = 20;
var MAX_TILE_ITEMS = exports.MAX_TILE_ITEMS = 3;
var ITEM_EVENTS_SHOWN_PERIODE_MS = exports.ITEM_EVENTS_SHOWN_PERIODE_MS = 2592000000; //30 days

var VIEW_ALL = exports.VIEW_ALL = 'View All';
var ITEM_EVENT = exports.ITEM_EVENT = 'itemEvent';
var FAVORITES = exports.FAVORITES = 'recentlySavedItems';
var FOLLOWING = exports.FOLLOWING = 'following';
var FOLLOWING_TYPE_SEARCH = exports.FOLLOWING_TYPE_SEARCH = 'SEARCH';
var EMPTY = exports.EMPTY = 'empty';
var ON_SALE = exports.ON_SALE = 'ON_SALE';
var OFFER_MADE = exports.OFFER_MADE = 'OFFER_MADE';
var ITEM_SOLD = exports.ITEM_SOLD = 'ITEM_SOLD';

/***/ }),

/***/ "./src/components/FavNotifications/favNotificationsHelpers.es.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var showAlert = exports.showAlert = function showAlert(_ref) {
  var createdDate = _ref.createdDate,
      lastViewedDate = _ref.lastViewedDate;
  return createdDate && lastViewedDate && new Date(createdDate).getTime() >= new Date(lastViewedDate).getTime();
};

/***/ }),

/***/ "./src/components/FavNotifications/trackingHelpers.es.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.indicatorShownTrackingObj = exports.getItemEventLinkClickedTrackingObjs = exports.getNotificationClickedTrackingObj = exports.getNotificationsDisplayedTrackingObj = undefined;

var _trackingLabels;

var _favNotificationsConstants = __webpack_require__("./src/components/FavNotifications/favNotificationsConstants.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var trackingLabels = (_trackingLabels = {}, _defineProperty(_trackingLabels, _favNotificationsConstants.EMPTY, 'empty state'), _defineProperty(_trackingLabels, _favNotificationsConstants.ON_SALE, 'item price update'), _defineProperty(_trackingLabels, _favNotificationsConstants.OFFER_MADE, 'item offer made'), _defineProperty(_trackingLabels, _favNotificationsConstants.ITEM_SOLD, 'item sold'), _defineProperty(_trackingLabels, _favNotificationsConstants.FAVORITES, 'recently saved'), _defineProperty(_trackingLabels, _favNotificationsConstants.FOLLOWING, 'new arrivals'), _defineProperty(_trackingLabels, _favNotificationsConstants.VIEW_ALL, 'view all'), _trackingLabels);

var getNotificationsDisplayedTrackingObj = exports.getNotificationsDisplayedTrackingObj = function getNotificationsDisplayedTrackingObj(_ref) {
    var types = _ref.types,
        hasNewEvents = _ref.hasNewEvents;
    return {
        category: 'navigation',
        action: 'header favorites notification displayed',
        label: types.filter(function (_ref2) {
            var displayed = _ref2.displayed;
            return displayed;
        }).map(function (_ref3) {
            var type = _ref3.type;
            return trackingLabels[type];
        }).join('|'),
        value: hasNewEvents ? 1 : 0
    };
};

var getNotificationClickedTrackingObj = exports.getNotificationClickedTrackingObj = function getNotificationClickedTrackingObj(type) {
    return {
        category: 'navigation',
        action: 'header favorites notification clicked',
        label: trackingLabels[type]
    };
};

var getItemEventLinkClickedTrackingObjs = exports.getItemEventLinkClickedTrackingObjs = function getItemEventLinkClickedTrackingObjs(_ref4) {
    var item = _ref4.item,
        eventType = _ref4.eventType;
    return eventType === _favNotificationsConstants.OFFER_MADE ? [{
        category: 'make offer click',
        action: 'header favorites notification',
        label: 'none'
    }, {
        category: 'ecommerce',
        action: 'add to cart',
        label: item.serviceId
    }] : [];
};

var indicatorShownTrackingObj = exports.indicatorShownTrackingObj = function indicatorShownTrackingObj() {
    return {
        category: 'navigation',
        action: 'header favorites notification alert displayed',
        label: 'none'
    };
};

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/ChangeCurrencyMutation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var mutation = {
    modern: function modern() {
        return __webpack_require__("./src/components/Footer/CurrencySelector/__generated__/ChangeCurrencyMutation.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'input'
            }],
            name: 'ChangeCurrencyMutation',
            operation: 'mutation',
            node: function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'editPersonalProfile',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        children: [{
                            children: [{
                                fieldName: 'currency',
                                kind: 'Field',
                                metadata: {},
                                type: 'Currency'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'user',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'User'
                    }, {
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'EditPersonalProfileInput!'
                    },
                    name: 'ChangeCurrencyMutation',
                    responseType: 'EditPersonalProfilePayload'
                };
            }()
        };
    }
};

var getOptimisticResponse = function getOptimisticResponse(id, currency) {
    return {
        editPersonalProfile: {
            user: {
                id: id,
                profile: {
                    currency: currency
                }
            }
        }
    };
};

var changeCurrency = function changeCurrency(_ref) {
    var environment = _ref.environment,
        user = _ref.user,
        currency = _ref.currency,
        onCompleted = _ref.onCompleted;
    var id = user.id,
        serviceId = user.serviceId;


    return (0, _reactRelay.commitMutation)(environment, {
        mutation: mutation,
        variables: {
            input: {
                userServiceId: serviceId,
                currency: currency
            }
        },
        optimisticResponse: function optimisticResponse() {
            return getOptimisticResponse(id, currency);
        },
        onCompleted: onCompleted
    });
};

exports.default = { commit: changeCurrency };

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/CurrencyDropdown-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"selector":"CurrencyDropdown-style__selector__e3020f64","label":"CurrencyDropdown-style__label__e3020f64","value":"CurrencyDropdown-style__value__e3020f64","arrow":"CurrencyDropdown-style__arrow__e3020f64","dropdown":"CurrencyDropdown-style__dropdown__e3020f64","option":"CurrencyDropdown-style__option__e3020f64","optionLabel":"CurrencyDropdown-style__optionLabel__e3020f64","checkmark":"CurrencyDropdown-style__checkmark__e3020f64"};

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/CurrencyDropdown.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _getCurrencySymbol = __webpack_require__("./node_modules/dibs-currency-helpers/getCurrencySymbol.js");

var _getCurrencySymbol2 = _interopRequireDefault(_getCurrencySymbol);

var _arrowDown = __webpack_require__("./node_modules/dibs-vg/dist/react/arrow-down.js");

var _arrowDown2 = _interopRequireDefault(_arrowDown);

var _checkmark = __webpack_require__("./node_modules/dibs-vg/dist/react/checkmark.js");

var _checkmark2 = _interopRequireDefault(_checkmark);

var _CurrencyDropdownStyle = __webpack_require__("./src/components/Footer/CurrencySelector/CurrencyDropdown-style.scss");

var _CurrencyDropdownStyle2 = _interopRequireDefault(_CurrencyDropdownStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurrencyDropdown = function (_React$Component) {
    _inherits(CurrencyDropdown, _React$Component);

    function CurrencyDropdown(props) {
        _classCallCheck(this, CurrencyDropdown);

        var _this = _possibleConstructorReturn(this, (CurrencyDropdown.__proto__ || Object.getPrototypeOf(CurrencyDropdown)).call(this, props));

        _this.state = {
            isExpanded: false
        };

        _this.handleSelectorClick = _this.handleSelectorClick.bind(_this);
        _this.handleOptionClick = _this.handleOptionClick.bind(_this);
        _this.closeDropdown = _this.closeDropdown.bind(_this);
        return _this;
    }

    _createClass(CurrencyDropdown, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('click', this.closeDropdown);
        }
    }, {
        key: 'openDropdown',
        value: function openDropdown() {
            this.setState({ isExpanded: true });
        }
    }, {
        key: 'closeDropdown',
        value: function closeDropdown() {
            this.setState({ isExpanded: false });
        }
    }, {
        key: 'handleSelectorClick',
        value: function handleSelectorClick(event) {
            event.stopPropagation();
            this.openDropdown();
        }
    }, {
        key: 'handleOptionClick',
        value: function handleOptionClick(event) {
            event.preventDefault();
            event.stopPropagation();

            var selectedCurrency = event.currentTarget.getAttribute('data-currency');

            this.props.onChange(selectedCurrency);
            this.closeDropdown();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: _CurrencyDropdownStyle2.default.selector },
                _react2.default.createElement(
                    'div',
                    { className: _CurrencyDropdownStyle2.default.label },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'dbl.Footer.CurrencyDropdown.label',
                        defaultMessage: 'Currency'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _CurrencyDropdownStyle2.default.value, onClick: this.handleSelectorClick },
                    (0, _getCurrencySymbol2.default)(this.props.currency),
                    ' ',
                    this.props.currency,
                    _react2.default.createElement(_arrowDown2.default, { className: _CurrencyDropdownStyle2.default.arrow }),
                    this.state.isExpanded ? _react2.default.createElement(
                        'ul',
                        { className: _CurrencyDropdownStyle2.default.dropdown },
                        this.props.currencies.map(function (currency) {
                            return _react2.default.createElement(
                                'li',
                                { key: currency },
                                _react2.default.createElement(
                                    'span',
                                    { onClick: _this2.handleOptionClick, className: _CurrencyDropdownStyle2.default.option, 'data-currency': currency },
                                    _this2.props.currency === currency ? _react2.default.createElement(_checkmark2.default, { className: _CurrencyDropdownStyle2.default.checkmark }) : null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: _CurrencyDropdownStyle2.default.optionLabel },
                                        (0, _getCurrencySymbol2.default)(currency),
                                        ' ',
                                        currency
                                    )
                                )
                            );
                        })
                    ) : null
                )
            );
        }
    }]);

    return CurrencyDropdown;
}(_react2.default.Component);

CurrencyDropdown.defaultProps = {
    onChange: function onChange() {}
};

exports.default = CurrencyDropdown;

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/CurrencySelector.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _actions = __webpack_require__("./src/actions/index.js");

var _CurrencyDropdown = __webpack_require__("./src/components/Footer/CurrencySelector/CurrencyDropdown.jsx");

var _CurrencyDropdown2 = _interopRequireDefault(_CurrencyDropdown);

var _ChangeCurrencyMutation = __webpack_require__("./src/components/Footer/CurrencySelector/ChangeCurrencyMutation.js");

var _ChangeCurrencyMutation2 = _interopRequireDefault(_ChangeCurrencyMutation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurrencySelector = function (_React$Component) {
    _inherits(CurrencySelector, _React$Component);

    function CurrencySelector(props) {
        _classCallCheck(this, CurrencySelector);

        var _this = _possibleConstructorReturn(this, (CurrencySelector.__proto__ || Object.getPrototypeOf(CurrencySelector)).call(this, props));

        _this.handleCurrencyChange = _this.handleCurrencyChange.bind(_this);
        return _this;
    }

    _createClass(CurrencySelector, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var currency = _dibsBrowserStorage.localStorage.getItem('userCurrency');
            this.props.setCurrency(currency);
        }
    }, {
        key: 'updateCurrency',
        value: function updateCurrency(currency) {
            var _this2 = this;

            if (this.props.user) {
                _ChangeCurrencyMutation2.default.commit({
                    environment: this.props.relay.environment,
                    user: this.props.user,
                    currency: currency,
                    onCompleted: function onCompleted() {
                        _this2.props.setCurrency(currency);
                        _dibsBrowserStorage.localStorage.setItem('userCurrency', currency);
                        window.location.reload();
                    }
                });
            } else {
                this.props.setCurrency(currency);
                _dibsBrowserStorage.localStorage.setItem('userCurrency', currency);
                window.location.reload();
            }
        }
    }, {
        key: 'handleCurrencyChange',
        value: function handleCurrencyChange(currency) {
            var category = 'navigation';
            var action = 'footer navigation click';
            var label = 'change currency|' + currency.toLowerCase();
            var value = 0;
            var additional = { defaultCurrency: currency + ' Selected' };

            (0, _dibsTracking.trackEvent)({ category: category, action: action, label: label, value: value, additional: additional });

            this.updateCurrency(currency);
        }
    }, {
        key: 'render',
        value: function render() {
            var currencies = (0, _lodash2.default)(this.props, 'viewer.currencies', []);
            var currency = (0, _lodash2.default)(this.props, 'user.profile.currency') || this.props.userCurrency;

            return _react2.default.createElement(_CurrencyDropdown2.default, {
                onChange: this.handleCurrencyChange,
                currencies: currencies,
                currency: currency
            });
        }
    }]);

    return CurrencySelector;
}(_react2.default.Component);

CurrencySelector.defaultProps = {
    userCurrency: 'USD'
};

var mapStateToProps = function mapStateToProps(state) {
    var userCurrency = (0, _lodash2.default)(state, 'footer.userCurrency');

    return { userCurrency: userCurrency };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        setCurrency: function setCurrency(currency) {
            dispatch(_actions.actionCreators.setCurrency(currency));
        }
    };
};

exports.default = (0, _reactRelay.createFragmentContainer)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CurrencySelector), {
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/Footer/CurrencySelector/__generated__/CurrencySelector_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            fieldName: 'currencies',
                            kind: 'Field',
                            metadata: {
                                isPlural: true
                            },
                            type: 'String'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'CurrencySelector_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    },
    user: {
        modern: function modern() {
            return __webpack_require__("./src/components/Footer/CurrencySelector/__generated__/CurrencySelector_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isRequisite: true
                            },
                            type: 'ID'
                        }, {
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'currency',
                                kind: 'Field',
                                metadata: {},
                                type: 'Currency'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'CurrencySelector_user',
                        type: 'User'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/__generated__/ChangeCurrencyMutation.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ee488b96b769df2b1931db21fe90bf5c
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ChangeCurrencyMutationVariables = {|
  input: {
    userServiceId: string;
    firstName?: ?string;
    lastName?: ?string;
    email?: ?string;
    currency?: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
    measurementUnit?: ?"CM" | "IN";
    zipCode?: ?string;
    clientMutationId?: ?string;
  };
|};

export type ChangeCurrencyMutationResponse = {|
  +editPersonalProfile: ?{|
    +user: ?{|
      +profile: ?{|
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      |};
    |};
  |};
|};
*/

/*
mutation ChangeCurrencyMutation(
  $input: EditPersonalProfileInput!
) {
  editPersonalProfile(input: $input) {
    user {
      profile {
        currency
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "EditPersonalProfileInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangeCurrencyMutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "EditPersonalProfileInput!"
      }],
      "concreteType": "EditPersonalProfilePayload",
      "name": "editPersonalProfile",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "User",
        "name": "user",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "name": "profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "currency",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ChangeCurrencyMutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "EditPersonalProfileInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "ChangeCurrencyMutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "EditPersonalProfileInput!"
      }],
      "concreteType": "EditPersonalProfilePayload",
      "name": "editPersonalProfile",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "User",
        "name": "user",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "name": "profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "currency",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation ChangeCurrencyMutation(\n  $input: EditPersonalProfileInput!\n) {\n  editPersonalProfile(input: $input) {\n    user {\n      profile {\n        currency\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/__generated__/CurrencySelector_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CurrencySelector_user = {|
  +id: string;
  +serviceId: ?string;
  +profile: ?{|
    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrencySelector_user",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "id",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "serviceId",
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Profile",
    "name": "profile",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "currency",
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/__generated__/CurrencySelector_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CurrencySelector_viewer = {|
  +currencies: ?$ReadOnlyArray<?string>;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrencySelector_viewer",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "currencies",
    "storageKey": null
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/Footer/Footer-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer-style__footer__2cb42400","divider":"Footer-style__divider__2cb42400","row":"Footer-style__row__2cb42400","cell":"Footer-style__cell__2cb42400","appStoreLink":"Footer-style__appStoreLink__2cb42400"};

/***/ }),

/***/ "./src/components/Footer/Footer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _appStore = __webpack_require__("./node_modules/dibs-vg/dist/react/app-store.js");

var _appStore2 = _interopRequireDefault(_appStore);

var _LinkRow = __webpack_require__("./src/components/Footer/LinkRow/LinkRow.jsx");

var _LinkRow2 = _interopRequireDefault(_LinkRow);

var _SocialLinkRow = __webpack_require__("./src/components/Footer/SocialLinkRow/SocialLinkRow.jsx");

var _SocialLinkRow2 = _interopRequireDefault(_SocialLinkRow);

var _CurrencySelector = __webpack_require__("./src/components/Footer/CurrencySelector/CurrencySelector.jsx");

var _CurrencySelector2 = _interopRequireDefault(_CurrencySelector);

var _links = __webpack_require__("./src/components/Footer/links.js");

var _FooterStyle = __webpack_require__("./src/components/Footer/Footer-style.scss");

var _FooterStyle2 = _interopRequireDefault(_FooterStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_React$Component) {
    _inherits(Footer, _React$Component);

    function Footer() {
        _classCallCheck(this, Footer);

        return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
    }

    _createClass(Footer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateUserState();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.updateUserState && !prevProps.updateUserState) {
                this.updateUserState();
            }
        }
    }, {
        key: 'updateUserState',
        value: function updateUserState() {
            var userId = (0, _dibsCookieJar.getUserId)(document.cookie, _dibsCookieJar.cookieJarConstants.MASQUERADE_BUYER);
            var hasUserId = !!userId;

            if (hasUserId) {
                var refetchVariables = function refetchVariables() {
                    return {
                        userId: userId,
                        hasUserId: hasUserId
                    };
                };

                this.props.relay.refetch(refetchVariables, null);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'footer',
                { className: _FooterStyle2.default.footer },
                _react2.default.createElement(_LinkRow2.default, { type: 'primary', items: _links.primaryLinks }),
                _react2.default.createElement('div', { className: _FooterStyle2.default.divider }),
                _react2.default.createElement(_LinkRow2.default, { type: 'site', items: _links.siteLinks }),
                _react2.default.createElement(_SocialLinkRow2.default, { items: _links.socialLinks }),
                _react2.default.createElement(_LinkRow2.default, { type: 'legal', items: _links.legalLinks }),
                _react2.default.createElement(
                    'div',
                    { className: _FooterStyle2.default.row },
                    _react2.default.createElement(
                        'div',
                        { className: _FooterStyle2.default.cell },
                        _react2.default.createElement(_CurrencySelector2.default, {
                            viewer: this.props.viewer,
                            user: this.props.viewer.user || null
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _FooterStyle2.default.cell },
                        _react2.default.createElement(
                            'a',
                            { className: _FooterStyle2.default.appStoreLink, href: _links.appLink.href, 'data-tn': _links.appLink.dataTn },
                            _react2.default.createElement(_appStore2.default, null)
                        )
                    )
                ),
                _react2.default.createElement(_LinkRow2.default, { type: 'sitemap', items: _links.sitemapLinks })
            );
        }
    }]);

    return Footer;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    var updateUserState = (0, _lodash2.default)(state, 'header.updateUserState');

    return { updateUserState: updateUserState };
};

Footer = (0, _reactRelay.createRefetchContainer)((0, _reactRedux.connect)(mapStateToProps)(Footer), {
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/Footer/__generated__/Footer_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var CurrencySelector_user = _CurrencySelector2.default.getFragment('user'),
                CurrencySelector_viewer = _CurrencySelector2.default.getFragment('viewer');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    kind: 'RootArgument',
                    name: 'userId'
                }, {
                    kind: 'RootArgument',
                    name: 'hasUserId'
                }],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [].concat.apply([], [{
                                fieldName: 'serviceId',
                                kind: 'Field',
                                metadata: {},
                                type: 'ID'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, RelayQL_GENERATED.__frag(CurrencySelector_user)]),
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            fieldName: 'user',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'User'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(CurrencySelector_viewer)]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'Footer_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    }
}, {
    modern: function modern() {
        return __webpack_require__("./src/components/Footer/__generated__/FooterRefetchQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var Footer_viewer = (Footer.__container__ || Footer).getFragment('viewer');
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userId'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'hasUserId'
            }],
            name: 'FooterRefetchQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(Footer_viewer)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'FooterRefetchQuery',
                    type: 'Query'
                };
            }()
        };
    }
});

exports.default = Footer;

/***/ }),

/***/ "./src/components/Footer/LinkRow/LegalLinks-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"LegalLinks-style__row__1a5e4630","item":"LegalLinks-style__item__1a5e4630","link":"LegalLinks-style__link__1a5e4630"};

/***/ }),

/***/ "./src/components/Footer/LinkRow/LinkRow.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _LinkRowItem = __webpack_require__("./src/components/Footer/LinkRow/LinkRowItem.jsx");

var _LinkRowItem2 = _interopRequireDefault(_LinkRowItem);

var _PrimaryLinksStyle = __webpack_require__("./src/components/Footer/LinkRow/PrimaryLinks-style.scss");

var _PrimaryLinksStyle2 = _interopRequireDefault(_PrimaryLinksStyle);

var _SiteLinksStyle = __webpack_require__("./src/components/Footer/LinkRow/SiteLinks-style.scss");

var _SiteLinksStyle2 = _interopRequireDefault(_SiteLinksStyle);

var _LegalLinksStyle = __webpack_require__("./src/components/Footer/LinkRow/LegalLinks-style.scss");

var _LegalLinksStyle2 = _interopRequireDefault(_LegalLinksStyle);

var _SitemapLinksStyle = __webpack_require__("./src/components/Footer/LinkRow/SitemapLinks-style.scss");

var _SitemapLinksStyle2 = _interopRequireDefault(_SitemapLinksStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleMap = {
    primary: _PrimaryLinksStyle2.default,
    site: _SiteLinksStyle2.default,
    legal: _LegalLinksStyle2.default,
    sitemap: _SitemapLinksStyle2.default
};

var LinkRow = function LinkRow(props) {
    var type = props.type,
        items = props.items;

    var style = styleMap[type] || {};

    return _react2.default.createElement(
        'nav',
        null,
        _react2.default.createElement(
            'div',
            { className: style.row },
            items.map(function (item) {
                return _react2.default.createElement(_LinkRowItem2.default, _extends({ key: item.dataTn }, item, { styles: style }));
            })
        )
    );
};

exports.default = LinkRow;

/***/ }),

/***/ "./src/components/Footer/LinkRow/LinkRowItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkRowItem = function (_Component) {
    _inherits(LinkRowItem, _Component);

    function LinkRowItem(props) {
        _classCallCheck(this, LinkRowItem);

        var _this = _possibleConstructorReturn(this, (LinkRowItem.__proto__ || Object.getPrototypeOf(LinkRowItem)).call(this, props));

        _this.trackClick = _this.trackClick.bind(_this);
        return _this;
    }

    _createClass(LinkRowItem, [{
        key: 'trackClick',
        value: function trackClick() {
            var trackingLabel = this.props.trackingLabel;


            var category = 'navigation';
            var action = 'footer navigation click';
            var label = trackingLabel.trim().toLowerCase();

            (0, _dibsTracking.trackEvent)({ category: category, action: action, label: label });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$styles = _props.styles,
                styles = _props$styles === undefined ? {} : _props$styles,
                target = _props.target,
                href = _props.href,
                dataTn = _props.dataTn,
                formattedMessage = _props.formattedMessage;


            return _react2.default.createElement(
                'div',
                { className: styles.item },
                href ? _react2.default.createElement(
                    'a',
                    { className: styles.link, target: target, href: href, onClick: this.trackClick, 'data-tn': dataTn },
                    formattedMessage
                ) : formattedMessage
            );
        }
    }]);

    return LinkRowItem;
}(_react.Component);

exports.default = LinkRowItem;

/***/ }),

/***/ "./src/components/Footer/LinkRow/PrimaryLinks-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"PrimaryLinks-style__row__e1bd129f","item":"PrimaryLinks-style__item__e1bd129f","link":"PrimaryLinks-style__link__e1bd129f"};

/***/ }),

/***/ "./src/components/Footer/LinkRow/SiteLinks-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"SiteLinks-style__row__53d960d8","item":"SiteLinks-style__item__53d960d8","link":"SiteLinks-style__link__53d960d8"};

/***/ }),

/***/ "./src/components/Footer/LinkRow/SitemapLinks-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"SitemapLinks-style__row__9332e0c4","item":"SitemapLinks-style__item__9332e0c4","link":"SitemapLinks-style__link__9332e0c4"};

/***/ }),

/***/ "./src/components/Footer/SocialLinkRow/SocialLinkRow-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"SocialLinkRow-style__row__c40521aa","item":"SocialLinkRow-style__item__c40521aa","link":"SocialLinkRow-style__link__c40521aa","twitter":"SocialLinkRow-style__twitter__c40521aa","facebook":"SocialLinkRow-style__facebook__c40521aa","pinterest":"SocialLinkRow-style__pinterest__c40521aa","instagram":"SocialLinkRow-style__instagram__c40521aa"};

/***/ }),

/***/ "./src/components/Footer/SocialLinkRow/SocialLinkRow.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _SocialLinkRowItem = __webpack_require__("./src/components/Footer/SocialLinkRow/SocialLinkRowItem.jsx");

var _SocialLinkRowItem2 = _interopRequireDefault(_SocialLinkRowItem);

var _SocialLinkRowStyle = __webpack_require__("./src/components/Footer/SocialLinkRow/SocialLinkRow-style.scss");

var _SocialLinkRowStyle2 = _interopRequireDefault(_SocialLinkRowStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialLinkRow = function SocialLinkRow(props) {
    var items = props.items;


    return _react2.default.createElement(
        'nav',
        null,
        _react2.default.createElement(
            'ul',
            { className: _SocialLinkRowStyle2.default.row },
            items.map(function (item) {
                return _react2.default.createElement(_SocialLinkRowItem2.default, _extends({ key: item.name }, item));
            })
        )
    );
};

exports.default = SocialLinkRow;

/***/ }),

/***/ "./src/components/Footer/SocialLinkRow/SocialLinkRowItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _twitter = __webpack_require__("./node_modules/dibs-vg/dist/react/twitter.js");

var _twitter2 = _interopRequireDefault(_twitter);

var _facebook = __webpack_require__("./node_modules/dibs-vg/dist/react/facebook.js");

var _facebook2 = _interopRequireDefault(_facebook);

var _pinterest = __webpack_require__("./node_modules/dibs-vg/dist/react/pinterest.js");

var _pinterest2 = _interopRequireDefault(_pinterest);

var _instagram = __webpack_require__("./node_modules/dibs-vg/dist/react/instagram.js");

var _instagram2 = _interopRequireDefault(_instagram);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _SocialLinkRowStyle = __webpack_require__("./src/components/Footer/SocialLinkRow/SocialLinkRow-style.scss");

var _SocialLinkRowStyle2 = _interopRequireDefault(_SocialLinkRowStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iconMap = {
    'twitter': _twitter2.default,
    'facebook': _facebook2.default,
    'pinterest': _pinterest2.default,
    'instagram': _instagram2.default
};

var SocialLinkRowItem = function (_Component) {
    _inherits(SocialLinkRowItem, _Component);

    function SocialLinkRowItem(props) {
        _classCallCheck(this, SocialLinkRowItem);

        var _this = _possibleConstructorReturn(this, (SocialLinkRowItem.__proto__ || Object.getPrototypeOf(SocialLinkRowItem)).call(this, props));

        _this.trackClick = _this.trackClick.bind(_this);
        return _this;
    }

    _createClass(SocialLinkRowItem, [{
        key: 'trackClick',
        value: function trackClick() {
            var _props = this.props,
                trackingLabel = _props.trackingLabel,
                href = _props.href;

            var eventName = 'fan page';

            (0, _dibsTracking.trackSocial)({
                name: trackingLabel,
                event: eventName,
                'opt_target': href,
                'opt_pagePath': href
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                name = _props2.name,
                href = _props2.href,
                dataTn = _props2.dataTn;


            if (!iconMap[name]) {
                return null;
            }

            var SocialIcon = iconMap[name];

            return _react2.default.createElement(
                'div',
                { className: _SocialLinkRowStyle2.default.item },
                _react2.default.createElement(
                    'a',
                    {
                        className: _SocialLinkRowStyle2.default.link + ' ' + _SocialLinkRowStyle2.default[name],
                        title: name,
                        href: href,
                        onClick: this.trackClick,
                        'data-tn': dataTn
                    },
                    _react2.default.createElement(SocialIcon, { type: name })
                )
            );
        }
    }]);

    return SocialLinkRowItem;
}(_react.Component);

exports.default = SocialLinkRowItem;

/***/ }),

/***/ "./src/components/Footer/__generated__/FooterRefetchQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash a81ae55572bc4ced5f07fee91d8933a2
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type FooterRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query FooterRefetchQuery(
  $userId: String!
  $hasUserId: Boolean!
) {
  viewer {
    ...Footer_viewer
    id
  }
}

fragment Footer_viewer on Viewer {
  user(userId: $userId) @include(if: $hasUserId) {
    serviceId
    ...CurrencySelector_user
    id
  }
  ...CurrencySelector_viewer
}

fragment CurrencySelector_user on User {
  id
  serviceId
  profile {
    currency
  }
}

fragment CurrencySelector_viewer on Viewer {
  currencies
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "FooterRefetchQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "Footer_viewer",
        "args": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "FooterRefetchQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "FooterRefetchQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "currencies",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String!"
          }],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "name": "profile",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query FooterRefetchQuery(\n  $userId: String!\n  $hasUserId: Boolean!\n) {\n  viewer {\n    ...Footer_viewer\n    id\n  }\n}\n\nfragment Footer_viewer on Viewer {\n  user(userId: $userId) @include(if: $hasUserId) {\n    serviceId\n    ...CurrencySelector_user\n    id\n  }\n  ...CurrencySelector_viewer\n}\n\nfragment CurrencySelector_user on User {\n  id\n  serviceId\n  profile {\n    currency\n  }\n}\n\nfragment CurrencySelector_viewer on Viewer {\n  currencies\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/Footer/__generated__/Footer_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Footer_viewer = {|
  +user?: ?{|
    +serviceId: ?string;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "userId",
    "type": "String!"
  }, {
    "kind": "RootArgument",
    "name": "hasUserId",
    "type": "Boolean"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "Footer_viewer",
  "selections": [{
    "kind": "FragmentSpread",
    "name": "CurrencySelector_viewer",
    "args": null
  }, {
    "kind": "Condition",
    "passingValue": true,
    "condition": "hasUserId",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId",
        "type": "String!"
      }],
      "concreteType": "User",
      "name": "user",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "serviceId",
        "storageKey": null
      }, {
        "kind": "FragmentSpread",
        "name": "CurrencySelector_user",
        "args": null
      }],
      "storageKey": null
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/Footer/links.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.legalLinks = exports.appLink = exports.sitemapLinks = exports.socialLinks = exports.siteLinks = exports.primaryLinks = undefined;

var _primaryLinks = __webpack_require__("./src/components/Footer/messages/primaryLinks.jsx");

var _primaryLinks2 = _interopRequireDefault(_primaryLinks);

var _siteLinks = __webpack_require__("./src/components/Footer/messages/siteLinks.jsx");

var _siteLinks2 = _interopRequireDefault(_siteLinks);

var _socialLinks = __webpack_require__("./src/components/Footer/messages/socialLinks.js");

var _socialLinks2 = _interopRequireDefault(_socialLinks);

var _legalLinks = __webpack_require__("./src/components/Footer/messages/legalLinks.jsx");

var _legalLinks2 = _interopRequireDefault(_legalLinks);

var _sitemapLinks = __webpack_require__("./src/components/Footer/messages/sitemapLinks.jsx");

var _sitemapLinks2 = _interopRequireDefault(_sitemapLinks);

var _appLink = __webpack_require__("./src/components/Footer/messages/appLink.jsx");

var _appLink2 = _interopRequireDefault(_appLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.primaryLinks = _primaryLinks2.default;
exports.siteLinks = _siteLinks2.default;
exports.socialLinks = _socialLinks2.default;
exports.sitemapLinks = _sitemapLinks2.default;
exports.appLink = _appLink2.default;
exports.legalLinks = _legalLinks2.default;

/***/ }),

/***/ "./src/components/Footer/messages/appLink.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    trackingLabel: 'Download on the App Store',
    icon: 'appStore',
    href: 'https://142876.measurementapi.com/serve?action=click&publisher_id=142876&site_id=90624&destination_id=171508&my_campaign=1stdibs-website&my_adgroup=sitewide-footer&my_ad=download-on-app-store-logo',
    dataTn: 'footer-download',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.app_link_download',
        defaultMessage: 'Download on the App Store'
    })
};

/***/ }),

/***/ "./src/components/Footer/messages/legalLinks.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    trackingLabel: 'Copyright',
    dataTn: 'footer-copyright',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.legal_links_copyright',
        defaultMessage: '\xA9 1stdibs, Inc. {year}',
        values: { year: new Date().getFullYear() }
    })
}, {
    trackingLabel: 'User Agreement',
    href: '/about/user-agreement/',
    target: '_blank',
    dataTn: 'footer-agreement',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.legal_links_agreement',
        defaultMessage: 'User Agreement'
    })
}, {
    trackingLabel: 'Privacy Policy',
    href: '/about/privacy-policy/',
    target: '_blank',
    dataTn: 'footer-privacy',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.legal_links_privacy',
        defaultMessage: 'Privacy Policy'
    })
}];

/***/ }),

/***/ "./src/components/Footer/messages/primaryLinks.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    trackingLabel: 'Trade Program',
    href: '/trade/apply/',
    dataTn: 'footer-designer-program',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.primary_links_trade_program',
        defaultMessage: 'Trade Program'
    })
}, {
    trackingLabel: 'Dealer Application',
    href: '/dealer/application-form/',
    dataTn: 'footer-dealer-application',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.primary_links.dealer_application',
        defaultMessage: 'Seller Application'
    })
}, {
    trackingLabel: 'Dealer Login',
    href: 'https://adminv2.1stdibs.com/login/dealer',
    dataTn: 'footer-dealer-login',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.primary_links_dealer_login',
        defaultMessage: 'Seller Login'
    })
}, {
    trackingLabel: 'Seller Directory',
    href: '/seller-directory/',
    dataTn: 'footer-seller-directory',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.primary_links_seller_directory',
        defaultMessage: 'Seller Directory'
    })
}];

/***/ }),

/***/ "./src/components/Footer/messages/siteLinks.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    trackingLabel: 'About Us',
    href: '/about/',
    dataTn: 'footer-about-us',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.site_links_about_us',
        defaultMessage: 'About Us'
    })
}, {
    trackingLabel: 'Support Center',
    href: 'https://support.1stdibs.com/',
    target: '_blank',
    dataTn: 'footer-support',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.site_links_support',
        defaultMessage: 'Support Center'
    })
}, {
    trackingLabel: 'Blog',
    href: 'https://www.1stdibs.com/blogs/the-study/',
    dataTn: 'footer-blog',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.site_links_blog',
        defaultMessage: 'Blog'
    })
}, {
    trackingLabel: 'Magazine',
    href: 'https://www.1stdibs.com/introspective-magazine/',
    dataTn: 'footer-magazine',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.site_links_magazine',
        defaultMessage: 'Magazine'
    })
}, {
    trackingLabel: 'Careers',
    href: '/about/careers/',
    dataTn: 'footer-jobs',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.site_links_jobs',
        defaultMessage: 'Careers'
    })
}, {
    trackingLabel: 'Press',
    href: '/about/press/',
    dataTn: 'footer-press',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.site_links_press',
        defaultMessage: 'Press'
    })
}, {
    trackingLabel: 'Contact Us',
    href: '/about/contact/',
    dataTn: 'footer-contact',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.site_links_contact',
        defaultMessage: 'Contact Us'
    })
}];

/***/ }),

/***/ "./src/components/Footer/messages/sitemapLinks.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    trackingLabel: 'Site Map',
    href: '/sitemap/',
    classname: 'sitemapMainLink',
    dataTn: 'sitemap-main',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.sitemap_links_main',
        defaultMessage: 'Site Map'
    })
}, {
    trackingLabel: 'Furniture',
    href: '/sitemap/furniture/',
    dataTn: 'sitemap-furniture',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.sitemap_links_furniture',
        defaultMessage: 'Furniture'
    })
}, {
    trackingLabel: 'Jewelry & Watches',
    href: '/sitemap/jewelry/',
    dataTn: 'sitemap-jewelry',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.sitemap_links_jewelry',
        defaultMessage: 'Jewelry & Watches'
    })
}, {
    trackingLabel: 'Fine Art',
    href: '/sitemap/art/',
    dataTn: 'sitemap-art',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.sitemap_links_art',
        defaultMessage: 'Fine Art'
    })
}, {
    trackingLabel: 'Fashion',
    href: '/sitemap/fashion/',
    dataTn: 'sitemap-fashion',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.sitemap_links_fashion',
        defaultMessage: 'Fashion'
    })
}, {
    trackingLabel: 'Creators',
    href: '/creators/',
    dataTn: 'creators',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.sitemap_links_creators',
        defaultMessage: 'Creators'
    })
}];

/***/ }),

/***/ "./src/components/Footer/messages/socialLinks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    trackingLabel: "twitter",
    name: "twitter",
    href: "https://twitter.com/1stdibs",
    icon: "twitter",
    dataTn: "social-twitter"
}, {
    trackingLabel: "facebook",
    name: "facebook",
    href: "https://www.facebook.com/1stdibs",
    icon: "facebook",
    dataTn: "social-facebook"
}, {
    trackingLabel: "pinterest",
    name: "pinterest",
    href: "https://www.pinterest.com/1stdibs/",
    icon: "pinterest",
    dataTn: "social-pinterest"
}, {
    trackingLabel: "instagram",
    name: "instagram",
    href: "https://instagram.com/1stdibs/",
    icon: "instagram",
    dataTn: "social-instagram"
}];

/***/ }),

/***/ "./src/components/FooterRenderer/FooterRenderer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _relayQueryLookupRenderer = __webpack_require__("./node_modules/relay-query-lookup-renderer/dist/index.js");

var _relayQueryLookupRenderer2 = _interopRequireDefault(_relayQueryLookupRenderer);

var _Footer = __webpack_require__("./src/components/Footer/Footer.jsx");

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterRenderer = function FooterRenderer(props) {
    var environment = props.environment,
        initialVariables = props.initialVariables,
        query = props.query;


    return _react2.default.createElement(_relayQueryLookupRenderer2.default, {
        lookup: true,
        environment: environment,
        query: query,
        variables: initialVariables,
        render: function render(_ref) {
            var error = _ref.error,
                rendererProps = _ref.props;
            // eslint-disable-line react/display-name, react/prop-types
            if (error) {
                return null;
            } else if (rendererProps) {
                return _react2.default.createElement(_Footer2.default, rendererProps);
            } else {
                return null;
            }
        }
    });
};

exports.default = FooterRenderer;

/***/ }),

/***/ "./src/components/Header/Header-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Header-style__wrapper__da67c0c0","header":"Header-style__header__da67c0c0","disableSticky":"Header-style__disableSticky__da67c0c0","bottomWrapper":"Header-style__bottomWrapper__da67c0c0","shadow":"Header-style__shadow__da67c0c0","bar":"Header-style__bar__da67c0c0","barContent":"Header-style__barContent__da67c0c0"};

/***/ }),

/***/ "./src/components/Header/Header.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _classnames5 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames6 = _interopRequireDefault(_classnames5);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Masthead = __webpack_require__("./src/components/Masthead/Masthead.jsx");

var _Masthead2 = _interopRequireDefault(_Masthead);

var _MessageBanner = __webpack_require__("./src/components/MessageBanner/MessageBanner.jsx");

var _MessageBanner2 = _interopRequireDefault(_MessageBanner);

var _TopBar = __webpack_require__("./src/components/TopBar/TopBar.jsx");

var _TopBar2 = _interopRequireDefault(_TopBar);

var _BottomBar = __webpack_require__("./src/components/BottomBar/BottomBar.jsx");

var _BottomBar2 = _interopRequireDefault(_BottomBar);

var _Drawer = __webpack_require__("./src/components/Drawer/Drawer.jsx");

var _Drawer2 = _interopRequireDefault(_Drawer);

var _actions = __webpack_require__("./src/actions/index.js");

var _HeaderStyle = __webpack_require__("./src/components/Header/Header-style.scss");

var _HeaderStyle2 = _interopRequireDefault(_HeaderStyle);

var _userTracking = __webpack_require__("./src/utils/userTracking.js");

var userTracking = _interopRequireWildcard(_userTracking);

var _chat = __webpack_require__("./src/utils/chat.js");

var _chat2 = _interopRequireDefault(_chat);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MASQUERADE_BUYER = _dibsCookieJar.cookieJarConstants.MASQUERADE_BUYER;

var Header = function (_Component) {
    _inherits(Header, _Component);

    function Header(props) {
        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

        _this.state = {
            isClient: false,

            fragmentVariables: {
                hasUserId: false,
                showMarketingMessages: _this.props.showMarketingMessages,
                userId: "",
                userIds: []
            }
        };
        return _this;
    }

    _createClass(Header, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ isClient: true }); // eslint-disable-line react/no-did-mount-set-state
            this.refetchViewer();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.updateUserState && !prevProps.updateUserState) {
                this.refetchViewer();
                this.props.resetUpdateUserState();
            }

            if ((0, _lodash2.default)(this.props.viewer, 'user.isVerifiedTrade') && !(0, _lodash2.default)(prevProps.viewer, 'user')) {
                this.props.updateUserTypeTrade();
            }
            if ((0, _lodash2.default)(this.props.viewer, 'user.isVip') && !(0, _lodash2.default)(prevProps.viewer, 'user')) {
                this.props.updateUserTypeVip();
            }

            if (this.state.isClient && !this.props.initialTrackingFired) {
                var viewer = this.props.viewer;

                var userId = (0, _dibsCookieJar.getUserId)(document.cookie, MASQUERADE_BUYER);
                var hasUserId = !!userId;
                var hasUser = !!viewer.user;

                if (!hasUserId) {
                    userTracking.init({ viewer: viewer });
                } else if (hasUser) {
                    var user = viewer.user;

                    _chat2.default.fillUserData(viewer, user);
                    userTracking.init({ viewer: viewer, user: user });
                }
            }
        }
    }, {
        key: 'getClassnames',
        value: function getClassnames() {
            var _classnames2, _classnames3, _classnames4;

            var _props = this.props,
                disableStickyNav = _props.disableStickyNav,
                isMobile = _props.isMobile;

            return {
                wrapperClasses: (0, _classnames6.default)(_defineProperty({}, _HeaderStyle2.default.wrapper, true)),
                headerClasses: (0, _classnames6.default)((_classnames2 = {}, _defineProperty(_classnames2, _HeaderStyle2.default.header, true), _defineProperty(_classnames2, _HeaderStyle2.default.disableSticky, disableStickyNav), _defineProperty(_classnames2, 'dbl-resp-width', !isMobile), _classnames2)),
                shadowClasses: (0, _classnames6.default)((_classnames3 = {}, _defineProperty(_classnames3, _HeaderStyle2.default.shadow, true), _defineProperty(_classnames3, _HeaderStyle2.default.disableSticky, disableStickyNav), _classnames3)),
                bottomWrapperClasses: (0, _classnames6.default)((_classnames4 = {}, _defineProperty(_classnames4, _HeaderStyle2.default.bottomWrapper, true), _defineProperty(_classnames4, _HeaderStyle2.default.disableSticky, disableStickyNav), _classnames4))
            };
        }
    }, {
        key: 'refetchViewer',
        value: function refetchViewer() {
            var _this2 = this;

            var userId = (0, _dibsCookieJar.getUserId)(document.cookie, MASQUERADE_BUYER) || '';
            var hasUserId = !!userId;

            if (hasUserId) {
                this.setState({
                    fragmentVariables: _extends({}, this.state.fragmentVariables, {
                        isClient: true,
                        hasUserId: !!userId,
                        userId: userId,
                        userIds: [userId]
                    })
                }, function () {
                    _this2.props.relay.refetch(_this2.state.fragmentVariables, null);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                disableStickyNav = _props2.disableStickyNav,
                viewer = _props2.viewer,
                navigation = _props2.navigation;
            var _viewer$user = viewer.user,
                user = _viewer$user === undefined ? null : _viewer$user;
            var _state = this.state,
                isClient = _state.isClient,
                fragmentVariables = _state.fragmentVariables;
            var hasUserId = fragmentVariables.hasUserId,
                showMarketingMessages = fragmentVariables.showMarketingMessages,
                userId = fragmentVariables.userId,
                userIds = fragmentVariables.userIds;


            var hasUser = !!user;
            var hasRootPendingRefetch = !hasUser && hasUserId;
            var BottomWrapperTag = disableStickyNav ? 'div' : _Drawer2.default;

            var _getClassnames = this.getClassnames(),
                wrapperClasses = _getClassnames.wrapperClasses,
                headerClasses = _getClassnames.headerClasses,
                shadowClasses = _getClassnames.shadowClasses,
                bottomWrapperClasses = _getClassnames.bottomWrapperClasses;

            return _react2.default.createElement(
                'div',
                { className: wrapperClasses },
                _react2.default.createElement(
                    'div',
                    { className: headerClasses },
                    _react2.default.createElement(_Masthead2.default, null),
                    _react2.default.createElement(_TopBar2.default, {
                        disableStickyNav: disableStickyNav,
                        hasRootPendingRefetch: hasRootPendingRefetch,
                        hasUser: hasUser,
                        hasUserId: hasUserId,
                        viewer: viewer,
                        isClient: isClient,
                        userId: userId,
                        user: user
                    }),
                    _react2.default.createElement(
                        BottomWrapperTag,
                        { className: bottomWrapperClasses },
                        _react2.default.createElement(_BottomBar2.default, {
                            navigation: navigation,
                            viewer: viewer,
                            isClient: isClient,
                            hasUserId: hasUserId,
                            userIds: userIds,
                            hasRootPendingRefetch: hasRootPendingRefetch
                        })
                    )
                ),
                _react2.default.createElement('div', { className: shadowClasses }),
                showMarketingMessages ? _react2.default.createElement(_MessageBanner2.default, {
                    hasRootPendingRefetch: hasRootPendingRefetch,
                    hasUserId: hasUserId,
                    isClient: isClient,
                    message: null,
                    showMarketingMessages: showMarketingMessages,
                    user: user,
                    userIds: userIds,
                    viewer: viewer
                }) : null
            );
        }
    }]);

    return Header;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
    var header = _ref.header;
    return {
        isMobile: header.isMobile,
        disableStickyNav: header.disableStickyNav,
        updateUserState: header.updateUserState,
        initialTrackingFired: header.initialTrackingFired
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        resetUpdateUserState: function resetUpdateUserState() {
            dispatch(_actions.actionCreators.setUpdateUserState(false));
        },
        updateUserTypeTrade: function updateUserTypeTrade() {
            dispatch(_actions.actionCreators.setUserTypeTrade(true));
        },
        updateUserTypeVip: function updateUserTypeVip() {
            dispatch(_actions.actionCreators.setUserTypeVip(true));
        },
        setInitialTrackingFired: function setInitialTrackingFired() {
            dispatch(_actions.actionCreators.setInitialTrackingFired());
        }
    };
};

Header = (0, _reactRelay.createRefetchContainer)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Header), {
    navigation: {
        modern: function modern() {
            return __webpack_require__("./src/components/Header/__generated__/Header_navigation.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var BottomBar_navigation = _BottomBar2.default.getFragment('navigation');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(BottomBar_navigation)]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'Header_navigation',
                        type: 'Navigation'
                    };
                }()
            };
        }
    },
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/Header/__generated__/Header_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var TopBar_viewer = _TopBar2.default.getFragment('viewer'),
                userTracking_viewer = RelayQL_GENERATED.__getClassicFragment(userTracking.viewer.viewer || userTracking.viewer).node,
                BottomBar_viewer = _BottomBar2.default.getFragment('viewer'),
                chat_viewer = RelayQL_GENERATED.__getClassicFragment(_chat2.default.viewer.viewer || _chat2.default.viewer).node,
                MessageBanner_viewer = _MessageBanner2.default.getFragment('viewer'),
                userTracking_user = RelayQL_GENERATED.__getClassicFragment(userTracking.user.user || userTracking.user).node,
                chat_user = RelayQL_GENERATED.__getClassicFragment(_chat2.default.user.user || _chat2.default.user).node,
                MessageBanner_user = _MessageBanner2.default.getFragment('user'),
                TopBar_user = _TopBar2.default.getFragment('user');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    kind: 'RootArgument',
                    name: 'hasUserId'
                }, {
                    kind: 'RootArgument',
                    name: 'showMarketingMessages'
                }, {
                    kind: 'RootArgument',
                    name: 'userId'
                }],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [].concat.apply([], [{
                                fieldName: 'isVip',
                                kind: 'Field',
                                metadata: {},
                                type: 'Boolean'
                            }, {
                                fieldName: 'isVerifiedTrade',
                                kind: 'Field',
                                metadata: {},
                                type: 'Boolean'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, RelayQL_GENERATED.__frag(userTracking_user), RelayQL_GENERATED.__frag(chat_user), {
                                children: [].concat.apply([], [{
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }, RelayQL_GENERATED.__frag(MessageBanner_user)]),
                                directives: [{
                                    kind: 'Directive',
                                    name: 'include',
                                    args: [{
                                        name: 'if',
                                        value: {
                                            kind: 'CallVariable',
                                            callVariableName: 'showMarketingMessages'
                                        }
                                    }]
                                }],
                                id: RelayQL_GENERATED.__id(),
                                kind: 'Fragment',
                                metadata: {},
                                name: 'User',
                                type: 'User'
                            }, RelayQL_GENERATED.__frag(TopBar_user)]),
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            fieldName: 'user',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'User'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(TopBar_viewer), RelayQL_GENERATED.__frag(userTracking_viewer), RelayQL_GENERATED.__frag(BottomBar_viewer), {
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, RelayQL_GENERATED.__frag(chat_viewer)]),
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            id: RelayQL_GENERATED.__id(),
                            kind: 'Fragment',
                            metadata: {},
                            name: 'Viewer',
                            type: 'Viewer'
                        }, {
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, RelayQL_GENERATED.__frag(MessageBanner_viewer)]),
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'showMarketingMessages'
                                    }
                                }]
                            }],
                            id: RelayQL_GENERATED.__id(),
                            kind: 'Fragment',
                            metadata: {},
                            name: 'Viewer',
                            type: 'Viewer'
                        }]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'Header_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    }
}, {
    modern: function modern() {
        return __webpack_require__("./src/components/Header/__generated__/HeaderRefetchQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var Header_viewer = (Header.__container__ || Header).getFragment('viewer');
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userId'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userIds'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'hasUserId'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'showMarketingMessages'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'fetchMarketingMessagesTransactions'
            }],
            name: 'HeaderRefetchQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(Header_viewer)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'HeaderRefetchQuery',
                    type: 'Query'
                };
            }()
        };
    }
});

exports.default = Header;

/***/ }),

/***/ "./src/components/Header/__generated__/HeaderRefetchQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 746a1f0d042e948511816407c7264e79
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type HeaderRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query HeaderRefetchQuery(
  $userId: String!
  $userIds: [String]!
  $hasUserId: Boolean!
  $showMarketingMessages: Boolean!
  $fetchMarketingMessagesTransactions: Boolean!
) {
  viewer {
    ...Header_viewer
    id
  }
}

fragment Header_viewer on Viewer {
  ...TopBar_viewer
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $hasUserId) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $hasUserId) {
    totalResults
  }
  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 1) @include(if: $hasUserId) {
    totalResults
    edges {
      node {
        mostRecentOffer {
          createdDate
          subTotalAmount {
            convertedAmounts {
              USD
            }
          }
          id
        }
        id
      }
    }
  }
  ... on Viewer @include(if: $hasUserId) {
    tradeChatEmail: userRelationships(userIds: $userIds, relationshipType: VIP) {
      userDataB {
        __typename
        ... on VipRepData {
          email
        }
      }
      id
    }
    vipChatEmail: userRelationships(userIds: $userIds, relationshipType: TRADE) {
      userDataB {
        __typename
        ... on TradeRepData {
          email
        }
      }
      id
    }
  }
  user(userId: $userId) @include(if: $hasUserId) {
    firstSessionDate
    isTrade: hasPermission(name: "B_TRADE_CHECKOUT")
    hasVipPermission: hasPermission(name: "B_VIP_CHECKOUT")
    profile {
      email
      zipCode
      currency
    }
    serviceId
    totalMessagesToDealers
    tradeFirm {
      serviceId
      tier
      id
    }
    verifiedTradeStatus
    isPromoCodeEligible(code: "SAVE15")
    isVip
    createdDate
    isVerifiedTrade
    ... on User @include(if: $showMarketingMessages) {
      ...MessageBanner_user
    }
    ...TopBar_user
    id
  }
  ... on Viewer @include(if: $showMarketingMessages) {
    ...MessageBanner_viewer
  }
}

fragment TopBar_viewer on Viewer {
  ...CartNav_viewer
  ...Notifications_initialViewer
}

fragment MessageBanner_user on User {
  isVip
  isVerifiedTrade
  verifiedTradeStatus
  verifiedTradeSubStatus
  tradeFirm {
    loyalty {
      status
    }
    id
  }
}

fragment TopBar_user on User {
  ...AccountNav_user
  ...CartNav_user
  ...Notifications_user
}

fragment MessageBanner_viewer on Viewer {
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  confirmedTransactions: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
}

fragment AccountNav_user on User {
  profile {
    firstName
  }
  conversationSummary {
    totalUnreadConversationCount
  }
  tradeFirm {
    loyalty {
      status
    }
    id
  }
}

fragment CartNav_user on User {
  profile {
    currency
  }
}

fragment Notifications_user on User {
  isPromoCodeEligible(code: "SAVE15")
}

fragment CartNav_viewer on Viewer {
  portfolios(userIds: $userIds, portfolioTypes: [CART], first: 1) @include(if: $hasUserId) {
    edges {
      node {
        items(first: 3) {
          totalResults
        }
        id
      }
    }
  }
}

fragment Notifications_initialViewer on Viewer {
  conversations(filter: "showUnreadOnly") @include(if: $hasUserId) {
    metadata {
      lastUnreadMessageDate
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "showMarketingMessages",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchMarketingMessagesTransactions",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "HeaderRefetchQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "Header_viewer",
        "args": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "HeaderRefetchQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "showMarketingMessages",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchMarketingMessagesTransactions",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "HeaderRefetchQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "showMarketingMessages",
        "selections": [{
          "kind": "InlineFragment",
          "type": "Viewer",
          "selections": [{
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchMarketingMessagesTransactions",
            "selections": [{
              "kind": "LinkedField",
              "alias": "allTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": "initiatedTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.initiated",
                "type": "String"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": "submittedTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.submitted",
                "type": "String"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": "confirmedTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "sort",
                "value": "createdDate asc",
                "type": "String"
              }, {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.confirmed",
                "type": "String"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }]
          }]
        }]
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 1,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "portfolioTypes",
            "value": ["CART"],
            "type": "[PortfolioTypes]"
          }, {
            "kind": "Variable",
            "name": "userIds",
            "variableName": "userIds",
            "type": "[String]"
          }],
          "concreteType": "PortfoliosConnection",
          "name": "portfolios",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PortfoliosEdge",
            "name": "edges",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "PortfolioV2",
              "name": "node",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 3,
                  "type": "Int"
                }],
                "concreteType": "PortfolioItemsConnection",
                "name": "items",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "totalResults",
                  "storageKey": null
                }],
                "storageKey": "items{\"first\":3}"
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Literal",
            "name": "filter",
            "value": "showUnreadOnly",
            "type": "String"
          }],
          "concreteType": "ConversationConnection",
          "name": "conversations",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "ConversationMetadata",
            "name": "metadata",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "lastUnreadMessageDate",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": "conversations{\"filter\":\"showUnreadOnly\"}"
        }, {
          "kind": "LinkedField",
          "alias": "allTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.initiated",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.submitted",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "confirmedTransactionsMostRecent",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 1,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "sort",
            "value": "createdDate asc",
            "type": "String"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.confirmed",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TransactionEdge",
            "name": "edges",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Transaction",
              "name": "node",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "name": "mostRecentOffer",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "createdDate",
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "name": "subTotalAmount",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ConvertedAmounts",
                    "name": "convertedAmounts",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "USD",
                      "storageKey": null
                    }],
                    "storageKey": null
                  }],
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String!"
          }],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "verifiedTradeStatus",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstSessionDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": "hasVipPermission",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_VIP_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "name": "profile",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "email",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "zipCode",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "firstName",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalMessagesToDealers",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "name": "tradeFirm",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "tier",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmLoyaltyType",
              "name": "loyalty",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "status",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": "isTrade",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_TRADE_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": [{
              "kind": "Literal",
              "name": "code",
              "value": "SAVE15",
              "type": "String!"
            }],
            "name": "isPromoCodeEligible",
            "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isVip",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "createdDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isVerifiedTrade",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Summary",
            "name": "conversationSummary",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalUnreadConversationCount",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "Condition",
            "passingValue": true,
            "condition": "showMarketingMessages",
            "selections": [{
              "kind": "InlineFragment",
              "type": "User",
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "verifiedTradeSubStatus",
                "storageKey": null
              }]
            }]
          }],
          "storageKey": null
        }, {
          "kind": "InlineFragment",
          "type": "Viewer",
          "selections": [{
            "kind": "LinkedField",
            "alias": "tradeChatEmail",
            "args": [{
              "kind": "Literal",
              "name": "relationshipType",
              "value": "VIP",
              "type": "relationshipType!"
            }, {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds",
              "type": "[String]!"
            }],
            "concreteType": "UserRelationship",
            "name": "userRelationships",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": null,
              "name": "userDataB",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "__typename",
                "storageKey": null
              }, {
                "kind": "InlineFragment",
                "type": "VipRepData",
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "email",
                  "storageKey": null
                }]
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": "vipChatEmail",
            "args": [{
              "kind": "Literal",
              "name": "relationshipType",
              "value": "TRADE",
              "type": "relationshipType!"
            }, {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds",
              "type": "[String]!"
            }],
            "concreteType": "UserRelationship",
            "name": "userRelationships",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": null,
              "name": "userDataB",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "__typename",
                "storageKey": null
              }, {
                "kind": "InlineFragment",
                "type": "TradeRepData",
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "email",
                  "storageKey": null
                }]
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }]
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query HeaderRefetchQuery(\n  $userId: String!\n  $userIds: [String]!\n  $hasUserId: Boolean!\n  $showMarketingMessages: Boolean!\n  $fetchMarketingMessagesTransactions: Boolean!\n) {\n  viewer {\n    ...Header_viewer\n    id\n  }\n}\n\nfragment Header_viewer on Viewer {\n  ...TopBar_viewer\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 1) @include(if: $hasUserId) {\n    totalResults\n    edges {\n      node {\n        mostRecentOffer {\n          createdDate\n          subTotalAmount {\n            convertedAmounts {\n              USD\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  ... on Viewer @include(if: $hasUserId) {\n    tradeChatEmail: userRelationships(userIds: $userIds, relationshipType: VIP) {\n      userDataB {\n        __typename\n        ... on VipRepData {\n          email\n        }\n      }\n      id\n    }\n    vipChatEmail: userRelationships(userIds: $userIds, relationshipType: TRADE) {\n      userDataB {\n        __typename\n        ... on TradeRepData {\n          email\n        }\n      }\n      id\n    }\n  }\n  user(userId: $userId) @include(if: $hasUserId) {\n    firstSessionDate\n    isTrade: hasPermission(name: \"B_TRADE_CHECKOUT\")\n    hasVipPermission: hasPermission(name: \"B_VIP_CHECKOUT\")\n    profile {\n      email\n      zipCode\n      currency\n    }\n    serviceId\n    totalMessagesToDealers\n    tradeFirm {\n      serviceId\n      tier\n      id\n    }\n    verifiedTradeStatus\n    isPromoCodeEligible(code: \"SAVE15\")\n    isVip\n    createdDate\n    isVerifiedTrade\n    ... on User @include(if: $showMarketingMessages) {\n      ...MessageBanner_user\n    }\n    ...TopBar_user\n    id\n  }\n  ... on Viewer @include(if: $showMarketingMessages) {\n    ...MessageBanner_viewer\n  }\n}\n\nfragment TopBar_viewer on Viewer {\n  ...CartNav_viewer\n  ...Notifications_initialViewer\n}\n\nfragment MessageBanner_user on User {\n  isVip\n  isVerifiedTrade\n  verifiedTradeStatus\n  verifiedTradeSubStatus\n  tradeFirm {\n    loyalty {\n      status\n    }\n    id\n  }\n}\n\nfragment TopBar_user on User {\n  ...AccountNav_user\n  ...CartNav_user\n  ...Notifications_user\n}\n\nfragment MessageBanner_viewer on Viewer {\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  confirmedTransactions: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n}\n\nfragment AccountNav_user on User {\n  profile {\n    firstName\n  }\n  conversationSummary {\n    totalUnreadConversationCount\n  }\n  tradeFirm {\n    loyalty {\n      status\n    }\n    id\n  }\n}\n\nfragment CartNav_user on User {\n  profile {\n    currency\n  }\n}\n\nfragment Notifications_user on User {\n  isPromoCodeEligible(code: \"SAVE15\")\n}\n\nfragment CartNav_viewer on Viewer {\n  portfolios(userIds: $userIds, portfolioTypes: [CART], first: 1) @include(if: $hasUserId) {\n    edges {\n      node {\n        items(first: 3) {\n          totalResults\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment Notifications_initialViewer on Viewer {\n  conversations(filter: \"showUnreadOnly\") @include(if: $hasUserId) {\n    metadata {\n      lastUnreadMessageDate\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/Header/__generated__/Header_navigation.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Header_navigation = {| |};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_navigation",
  "selections": [{
    "kind": "FragmentSpread",
    "name": "BottomBar_navigation",
    "args": null
  }],
  "type": "Navigation"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/Header/__generated__/Header_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Header_viewer = {|
  +allTransactions?: ?{|
    +totalResults: ?number;
  |};
  +initiatedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +submittedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +confirmedTransactionsMostRecent?: ?{|
    +totalResults: ?number;
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +mostRecentOffer: ?{|
          +createdDate: ?string;
          +subTotalAmount: ?{|
            +convertedAmounts: ?{|
              +USD: ?number;
            |};
          |};
        |};
      |};
    |}>;
  |};
  +user?: ?{|
    +firstSessionDate: ?string;
    +isTrade: ?boolean;
    +hasVipPermission: ?boolean;
    +profile: ?{|
      +email: ?string;
      +zipCode: ?string;
      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
    |};
    +serviceId: ?string;
    +totalMessagesToDealers: ?number;
    +tradeFirm: ?{|
      +serviceId: ?string;
      +tier: ?"TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "P_AND_M" | "UNKNOWN";
    |};
    +verifiedTradeStatus: ?string;
    +isPromoCodeEligible: ?boolean;
    +isVip: ?boolean;
    +createdDate: ?string;
    +isVerifiedTrade: ?boolean;
  |};
  +tradeChatEmail?: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string;
    |}>;
  |}>;
  +vipChatEmail?: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string;
    |}>;
  |}>;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "hasUserId",
    "type": "Boolean"
  }, {
    "kind": "RootArgument",
    "name": "showMarketingMessages",
    "type": "Boolean"
  }, {
    "kind": "RootArgument",
    "name": "userId",
    "type": "String!"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_viewer",
  "selections": [{
    "kind": "FragmentSpread",
    "name": "TopBar_viewer",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "BottomBar_viewer",
    "args": null
  }, {
    "kind": "Condition",
    "passingValue": true,
    "condition": "showMarketingMessages",
    "selections": [{
      "kind": "InlineFragment",
      "type": "Viewer",
      "selections": [{
        "kind": "FragmentSpread",
        "name": "MessageBanner_viewer",
        "args": null
      }]
    }]
  }, {
    "kind": "Condition",
    "passingValue": true,
    "condition": "hasUserId",
    "selections": [{
      "kind": "LinkedField",
      "alias": "allTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "initiatedTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.initiated",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "submittedTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.submitted",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "confirmedTransactionsMostRecent",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 1,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "sort",
        "value": "createdDate asc",
        "type": "String"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.confirmed",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "TransactionEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Transaction",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Offer",
            "name": "mostRecentOffer",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "createdDate",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "name": "subTotalAmount",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ConvertedAmounts",
                "name": "convertedAmounts",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "USD",
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId",
        "type": "String!"
      }],
      "concreteType": "User",
      "name": "user",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "verifiedTradeStatus",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "firstSessionDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": "hasVipPermission",
        "args": [{
          "kind": "Literal",
          "name": "name",
          "value": "B_VIP_CHECKOUT",
          "type": "String!"
        }],
        "name": "hasPermission",
        "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Profile",
        "name": "profile",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "email",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "zipCode",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currency",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "serviceId",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalMessagesToDealers",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "TradeFirmType",
        "name": "tradeFirm",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "serviceId",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tier",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": "isTrade",
        "args": [{
          "kind": "Literal",
          "name": "name",
          "value": "B_TRADE_CHECKOUT",
          "type": "String!"
        }],
        "name": "hasPermission",
        "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": [{
          "kind": "Literal",
          "name": "code",
          "value": "SAVE15",
          "type": "String!"
        }],
        "name": "isPromoCodeEligible",
        "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "isVip",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "createdDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "isVerifiedTrade",
        "storageKey": null
      }, {
        "kind": "FragmentSpread",
        "name": "TopBar_user",
        "args": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "showMarketingMessages",
        "selections": [{
          "kind": "InlineFragment",
          "type": "User",
          "selections": [{
            "kind": "FragmentSpread",
            "name": "MessageBanner_user",
            "args": null
          }]
        }]
      }],
      "storageKey": null
    }, {
      "kind": "InlineFragment",
      "type": "Viewer",
      "selections": [{
        "kind": "LinkedField",
        "alias": "tradeChatEmail",
        "args": [{
          "kind": "Literal",
          "name": "relationshipType",
          "value": "VIP",
          "type": "relationshipType!"
        }, {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds",
          "type": "[String]!"
        }],
        "concreteType": "UserRelationship",
        "name": "userRelationships",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": null,
          "name": "userDataB",
          "plural": true,
          "selections": [{
            "kind": "InlineFragment",
            "type": "VipRepData",
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "email",
              "storageKey": null
            }]
          }],
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": "vipChatEmail",
        "args": [{
          "kind": "Literal",
          "name": "relationshipType",
          "value": "TRADE",
          "type": "relationshipType!"
        }, {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds",
          "type": "[String]!"
        }],
        "concreteType": "UserRelationship",
        "name": "userRelationships",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": null,
          "name": "userDataB",
          "plural": true,
          "selections": [{
            "kind": "InlineFragment",
            "type": "TradeRepData",
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "email",
              "storageKey": null
            }]
          }],
          "storageKey": null
        }],
        "storageKey": null
      }]
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/HeaderRenderer/HeaderRenderer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _relayQueryLookupRenderer = __webpack_require__("./node_modules/relay-query-lookup-renderer/dist/index.js");

var _relayQueryLookupRenderer2 = _interopRequireDefault(_relayQueryLookupRenderer);

var _Header = __webpack_require__("./src/components/Header/Header.jsx");

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prevProps = {};

function HeaderRenderer(props) {
    var environment = props.environment,
        initialVariables = props.initialVariables,
        query = props.query,
        relayVariables = props.relayVariables;

    var variables = _extends({}, initialVariables, relayVariables);

    return _react2.default.createElement(_relayQueryLookupRenderer2.default, {
        lookup: true,
        environment: environment,
        query: query,
        variables: variables,
        render: function render(_ref) {
            var rendererProps = _ref.props;
            // eslint-disable-line react/display-name, react/prop-types
            var currentProps = _extends({}, prevProps, variables);

            if (rendererProps) {
                var serverViewer = rendererProps.serverViewer;


                if (serverViewer) {
                    currentProps = _extends({}, currentProps, serverViewer);
                }

                currentProps = _extends({}, currentProps, rendererProps);
            }

            prevProps = currentProps;
            return _react2.default.createElement(_Header2.default, currentProps);
        }
    });
}

var mapStateToProps = function mapStateToProps(_ref2) {
    var header = _ref2.header;

    return {
        relayVariables: header.relayVariables || {}
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(HeaderRenderer);

/***/ }),

/***/ "./src/components/Likes/Likes-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"iconWrapper":"Likes-style__iconWrapper__250bee40","icon":"Likes-style__icon__250bee40","hasUnread":"Likes-style__hasUnread__250bee40"};

/***/ }),

/***/ "./src/components/Likes/Likes.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _Dropdown = __webpack_require__("./src/components/Dropdown/Dropdown.jsx");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _LikesIcon = __webpack_require__("./src/components/Likes/LikesIcon.jsx");

var _LikesIcon2 = _interopRequireDefault(_LikesIcon);

var _favNotificationsConstants = __webpack_require__("./src/components/FavNotifications/favNotificationsConstants.js");

var _FavNotifications = __webpack_require__("./src/components/FavNotifications/FavNotifications.jsx");

var _FavNotifications2 = _interopRequireDefault(_FavNotifications);

var _ItemEventsShownMutation = __webpack_require__("./src/components/FavNotifications/ItemEventsShownMutation.js");

var _ItemEventsShownMutation2 = _interopRequireDefault(_ItemEventsShownMutation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hasNewEvents = function hasNewEvents(viewer) {
    return (0, _lodash2.default)(viewer, 'favoriteNotifications.hasNewEvents');
};
var getCreatedAfterDate = function getCreatedAfterDate() {
    return new Date(new Date().getTime() - _favNotificationsConstants.ITEM_EVENTS_SHOWN_PERIODE_MS).toJSON();
};

var LikesLink = function (_Component) {
    _inherits(LikesLink, _Component);

    function LikesLink(props) {
        _classCallCheck(this, LikesLink);

        var _this = _possibleConstructorReturn(this, (LikesLink.__proto__ || Object.getPrototypeOf(LikesLink)).call(this, props));

        _this.state = {
            fragmentVariables: {
                eventsLimit: _favNotificationsConstants.MAX_TILES,
                fetchNotifications: false,
                createdAfter: getCreatedAfterDate(),
                notificationItemsLimit: _favNotificationsConstants.MAX_TILE_ITEMS
            }
        };

        _this.triggerNotificationsFetch = _this.triggerNotificationsFetch.bind(_this);
        return _this;
    }

    _createClass(LikesLink, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.fetchNewEvents && !prevProps.fetchNewEvents) {
                var _props = this.props,
                    fetchNewEvents = _props.fetchNewEvents,
                    userId = _props.userId;

                this.fetchNewEvents({ fetchNewEvents: fetchNewEvents, userId: userId });
            }
        }
    }, {
        key: 'fetchNewEvents',
        value: function fetchNewEvents(variables) {
            var _this2 = this;

            this.setState({
                fragmentVariables: _extends({}, this.state.fragmentVariables, variables)
            }, function () {
                _this2.props.relay.refetch(_this2.state.fragmentVariables);
            });
        }
    }, {
        key: 'fetchNotifications',
        value: function fetchNotifications() {
            var _this3 = this;

            if (!this.state.fragmentVariables.fetchNotifications) {

                this.setState({
                    fragmentVariables: _extends({}, this.state.fragmentVariables, {
                        fetchNotifications: true,
                        notificationItemsLimit: _favNotificationsConstants.MAX_TILE_ITEMS
                    })

                }, function () {
                    _this3.props.relay.refetch(_this3.state.fragmentVariables, null, function () {
                        _this3.onNotificationsShown();
                    });
                });
            }
        }
    }, {
        key: 'onNotificationsShown',
        value: function onNotificationsShown() {
            var _props2 = this.props,
                viewer = _props2.viewer,
                userId = _props2.userId,
                relay = _props2.relay;


            if (hasNewEvents(viewer)) {
                var environment = relay.environment;
                var favoriteNotifications = viewer.favoriteNotifications;
                var id = favoriteNotifications.id;


                _ItemEventsShownMutation2.default.commit({
                    environment: environment,
                    id: id,
                    userId: userId
                });
            }
        }
    }, {
        key: 'triggerNotificationsFetch',
        value: function triggerNotificationsFetch() {
            var _props3 = this.props,
                hasUserId = _props3.hasUserId,
                hasRootPendingRefetch = _props3.hasRootPendingRefetch;


            if (hasUserId && !hasRootPendingRefetch) {
                this.fetchNotifications();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                favoritesUrl = _props4.favoritesUrl,
                isClient = _props4.isClient,
                hasUserId = _props4.hasUserId,
                viewer = _props4.viewer;
            var _viewer$favoriteNotif = viewer.favoriteNotificationsTiles,
                favoriteNotificationsTiles = _viewer$favoriteNotif === undefined ? null : _viewer$favoriteNotif;


            return isClient ? _react2.default.createElement(
                _Dropdown2.default,
                { align: _Dropdown.alignConstants.ALIGN_RIGHT },
                _react2.default.createElement(_LikesIcon2.default, {
                    hasUnread: hasNewEvents(viewer),
                    favoritesUrl: favoritesUrl,
                    onMouseEnter: this.triggerNotificationsFetch
                }),
                _react2.default.createElement(_FavNotifications2.default, {
                    hasUserId: hasUserId,
                    hasNewEvents: hasNewEvents(viewer),
                    favoriteNotificationsTiles: favoriteNotificationsTiles,
                    favoritesUrl: favoritesUrl,
                    viewer: viewer
                })
            ) : _react2.default.createElement(_LikesIcon2.default, { favoritesUrl: favoritesUrl });
        }
    }]);

    return LikesLink;
}(_react.Component);

LikesLink.defaultProps = {
    favoritesUrl: '/favorites/items/'
};

LikesLink = (0, _reactRelay.createRefetchContainer)(LikesLink, {
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/Likes/__generated__/Likes_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var FavNotifications_favoriteNotificationsTiles_args1 = _FavNotifications2.default.getFragment('favoriteNotificationsTiles', {
                createdAfter: {
                    kind: 'CallVariable',
                    callVariableName: 'createdAfter'
                },
                eventsLimit: {
                    kind: 'CallVariable',
                    callVariableName: 'eventsLimit'
                },
                notificationItemsLimit: {
                    kind: 'CallVariable',
                    callVariableName: 'notificationItemsLimit'
                }
            });

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    kind: 'RootArgument',
                    name: 'userId'
                }, {
                    defaultValue: false,
                    kind: 'LocalArgument',
                    name: 'fetchNewEvents'
                }, {
                    defaultValue: 0,
                    kind: 'LocalArgument',
                    name: 'eventsLimit'
                }, {
                    defaultValue: '',
                    kind: 'LocalArgument',
                    name: 'createdAfter'
                }, {
                    defaultValue: false,
                    kind: 'LocalArgument',
                    name: 'fetchNotifications'
                }, {
                    defaultValue: 0,
                    kind: 'LocalArgument',
                    name: 'notificationItemsLimit'
                }],
                node: function () {
                    return {
                        children: [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, {
                                calls: [{
                                    kind: 'Call',
                                    metadata: {
                                        type: 'Int'
                                    },
                                    name: 'eventsLimit',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'eventsLimit'
                                    }
                                }, {
                                    kind: 'Call',
                                    metadata: {},
                                    name: 'createdAfter',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'createdAfter'
                                    }
                                }],
                                fieldName: 'hasNewEvents',
                                kind: 'Field',
                                metadata: {},
                                type: 'Boolean'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'fetchNewEvents'
                                    }
                                }]
                            }],
                            fieldName: 'favoriteNotifications',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'FavoriteNotifications'
                        }, {
                            alias: 'favoriteNotificationsTiles',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, RelayQL_GENERATED.__frag(FavNotifications_favoriteNotificationsTiles_args1)]),
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'fetchNotifications'
                                    }
                                }]
                            }],
                            fieldName: 'favoriteNotifications',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'FavoriteNotifications'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'Likes_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    }
}, {
    modern: function modern() {
        return __webpack_require__("./src/components/Likes/__generated__/LikesRefetchQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var Likes_viewer_args1 = Likes.getFragment('viewer', {
            createdAfter: {
                kind: 'CallVariable',
                callVariableName: 'createdAfter'
            },
            eventsLimit: {
                kind: 'CallVariable',
                callVariableName: 'eventsLimit'
            },
            fetchNewEvents: {
                kind: 'CallVariable',
                callVariableName: 'fetchNewEvents'
            },
            fetchNotifications: {
                kind: 'CallVariable',
                callVariableName: 'fetchNotifications'
            },
            notificationItemsLimit: {
                kind: 'CallVariable',
                callVariableName: 'notificationItemsLimit'
            }
        });
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'createdAfter'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'eventsLimit'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'fetchNewEvents'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'fetchNotifications'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'notificationItemsLimit'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userId'
            }],
            name: 'LikesRefetchQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(Likes_viewer_args1)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'LikesRefetchQuery',
                    type: 'Query'
                };
            }()
        };
    }
});

exports.default = LikesLink;

/***/ }),

/***/ "./src/components/Likes/LikesIcon.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _heartOutlined = __webpack_require__("./node_modules/dibs-vg/dist/react/heart-outlined.js");

var _heartOutlined2 = _interopRequireDefault(_heartOutlined);

var _LikesStyle = __webpack_require__("./src/components/Likes/Likes-style.scss");

var _LikesStyle2 = _interopRequireDefault(_LikesStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
    label: 'my favorites|my favorites header icon'
};

var LikesIcon = function LikesIcon(props) {
    var onMouseEnter = props.onMouseEnter,
        favoritesUrl = props.favoritesUrl,
        hasUnread = props.hasUnread;


    var heartIconClasses = (0, _classnames3.default)(_LikesStyle2.default.icon, _defineProperty({}, _LikesStyle2.default.hasUnread, hasUnread));

    var iconWrapperProps = {
        className: _LikesStyle2.default.iconWrapper
    };

    if (onMouseEnter) {
        iconWrapperProps = _extends({}, iconWrapperProps, { onMouseEnter: onMouseEnter });
    }

    return _react2.default.createElement(
        'div',
        iconWrapperProps,
        _react2.default.createElement(
            'a',
            { 'data-tn': 'likes-link', href: favoritesUrl, className: heartIconClasses, onClick: function onClick() {
                    (0, _dibsTracking.trackEvent)(trackingObj);
                } },
            _react2.default.createElement(_heartOutlined2.default, null)
        )
    );
};

LikesIcon.defaultProps = {
    hasUnread: false
};

exports.default = LikesIcon;

/***/ }),

/***/ "./src/components/Likes/__generated__/LikesRefetchQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5b9f5afc89506ccaef4b6b45a82728fc
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type LikesRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query LikesRefetchQuery(
  $createdAfter: String!
  $eventsLimit: Int!
  $fetchNewEvents: Boolean!
  $fetchNotifications: Boolean!
  $notificationItemsLimit: Int!
  $userId: String!
) {
  viewer {
    ...Likes_viewer_2oXh8v
    id
  }
}

fragment Likes_viewer_2oXh8v on Viewer {
  favoriteNotifications(userId: $userId) @include(if: $fetchNewEvents) {
    id
    hasNewEvents(eventsLimit: $eventsLimit, createdAfter: $createdAfter)
  }
  favoriteNotificationsTiles: favoriteNotifications(userId: $userId) @include(if: $fetchNotifications) {
    ...FavNotifications_favoriteNotificationsTiles_33AUrW
    id
  }
}

fragment FavNotifications_favoriteNotificationsTiles_33AUrW on FavoriteNotifications {
  tiles: notificationsList(createdAfter: $createdAfter, notificationsLimit: $eventsLimit, notificationItemsLimit: $notificationItemsLimit) {
    ...FavNotificationsTileList_tiles
    id
  }
}

fragment FavNotificationsTileList_tiles on FavoriteNotification {
  serviceId
  type
  eventType
  createdDate
  lastViewedDate
  ...FavNotificationsTile_tile
}

fragment FavNotificationsTile_tile on FavoriteNotification {
  type
  eventType
  followingType
  page
  totalResults
  items {
    serviceId
    pdpURL
    ...FavNotificationsTileItem_item
    id
  }
  ...FavNotificationsTileHeader_tile
  ...FavNotificationsTileDescription_tile
}

fragment FavNotificationsTileItem_item on Item {
  pdpURL
  firstPhotoWebPath(size: thumb)
}

fragment FavNotificationsTileHeader_tile on FavoriteNotification {
  type
  name
  createdDate
  lastViewedDate
}

fragment FavNotificationsTileDescription_tile on FavoriteNotification {
  items {
    serviceId
    pdpURL
    id
  }
  eventType
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "createdAfter",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "eventsLimit",
      "type": "Int!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchNewEvents",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchNotifications",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "notificationItemsLimit",
      "type": "Int!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "LikesRefetchQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "Likes_viewer",
        "args": [{
          "kind": "Variable",
          "name": "createdAfter",
          "variableName": "createdAfter",
          "type": null
        }, {
          "kind": "Variable",
          "name": "eventsLimit",
          "variableName": "eventsLimit",
          "type": null
        }, {
          "kind": "Variable",
          "name": "fetchNewEvents",
          "variableName": "fetchNewEvents",
          "type": null
        }, {
          "kind": "Variable",
          "name": "fetchNotifications",
          "variableName": "fetchNotifications",
          "type": null
        }, {
          "kind": "Variable",
          "name": "notificationItemsLimit",
          "variableName": "notificationItemsLimit",
          "type": null
        }]
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "LikesRefetchQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "createdAfter",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "eventsLimit",
      "type": "Int!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchNewEvents",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchNotifications",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "notificationItemsLimit",
      "type": "Int!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "LikesRefetchQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "fetchNotifications",
        "selections": [{
          "kind": "LinkedField",
          "alias": "favoriteNotificationsTiles",
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String"
          }],
          "concreteType": "FavoriteNotifications",
          "name": "favoriteNotifications",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": "tiles",
            "args": [{
              "kind": "Variable",
              "name": "createdAfter",
              "variableName": "createdAfter",
              "type": "String"
            }, {
              "kind": "Variable",
              "name": "notificationItemsLimit",
              "variableName": "notificationItemsLimit",
              "type": "Int"
            }, {
              "kind": "Variable",
              "name": "notificationsLimit",
              "variableName": "eventsLimit",
              "type": "Int"
            }],
            "concreteType": "FavoriteNotification",
            "name": "notificationsList",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "InlineFragment",
              "type": "FavoriteNotification",
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "serviceId",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "type",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "eventType",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "createdDate",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "lastViewedDate",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "followingType",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "page",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Item",
                "name": "items",
                "plural": true,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "serviceId",
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "pdpURL",
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                }, {
                  "kind": "InlineFragment",
                  "type": "Item",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "args": [{
                      "kind": "Literal",
                      "name": "size",
                      "value": "thumb",
                      "type": "ImageVersionTypeName!"
                    }],
                    "name": "firstPhotoWebPath",
                    "storageKey": "firstPhotoWebPath{\"size\":\"thumb\"}"
                  }]
                }],
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              }]
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }]
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "fetchNewEvents",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String"
          }],
          "concreteType": "FavoriteNotifications",
          "name": "favoriteNotifications",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": [{
              "kind": "Variable",
              "name": "createdAfter",
              "variableName": "createdAfter",
              "type": "String"
            }, {
              "kind": "Variable",
              "name": "eventsLimit",
              "variableName": "eventsLimit",
              "type": "Int"
            }],
            "name": "hasNewEvents",
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query LikesRefetchQuery(\n  $createdAfter: String!\n  $eventsLimit: Int!\n  $fetchNewEvents: Boolean!\n  $fetchNotifications: Boolean!\n  $notificationItemsLimit: Int!\n  $userId: String!\n) {\n  viewer {\n    ...Likes_viewer_2oXh8v\n    id\n  }\n}\n\nfragment Likes_viewer_2oXh8v on Viewer {\n  favoriteNotifications(userId: $userId) @include(if: $fetchNewEvents) {\n    id\n    hasNewEvents(eventsLimit: $eventsLimit, createdAfter: $createdAfter)\n  }\n  favoriteNotificationsTiles: favoriteNotifications(userId: $userId) @include(if: $fetchNotifications) {\n    ...FavNotifications_favoriteNotificationsTiles_33AUrW\n    id\n  }\n}\n\nfragment FavNotifications_favoriteNotificationsTiles_33AUrW on FavoriteNotifications {\n  tiles: notificationsList(createdAfter: $createdAfter, notificationsLimit: $eventsLimit, notificationItemsLimit: $notificationItemsLimit) {\n    ...FavNotificationsTileList_tiles\n    id\n  }\n}\n\nfragment FavNotificationsTileList_tiles on FavoriteNotification {\n  serviceId\n  type\n  eventType\n  createdDate\n  lastViewedDate\n  ...FavNotificationsTile_tile\n}\n\nfragment FavNotificationsTile_tile on FavoriteNotification {\n  type\n  eventType\n  followingType\n  page\n  totalResults\n  items {\n    serviceId\n    pdpURL\n    ...FavNotificationsTileItem_item\n    id\n  }\n  ...FavNotificationsTileHeader_tile\n  ...FavNotificationsTileDescription_tile\n}\n\nfragment FavNotificationsTileItem_item on Item {\n  pdpURL\n  firstPhotoWebPath(size: thumb)\n}\n\nfragment FavNotificationsTileHeader_tile on FavoriteNotification {\n  type\n  name\n  createdDate\n  lastViewedDate\n}\n\nfragment FavNotificationsTileDescription_tile on FavoriteNotification {\n  items {\n    serviceId\n    pdpURL\n    id\n  }\n  eventType\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/Likes/__generated__/Likes_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Likes_viewer = {|
  +favoriteNotifications?: ?{|
    +id: string;
    +hasNewEvents: ?boolean;
  |};
  +favoriteNotificationsTiles?: ?{| |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "createdAfter",
    "type": "String!",
    "defaultValue": ""
  }, {
    "kind": "LocalArgument",
    "name": "eventsLimit",
    "type": "Int!",
    "defaultValue": 0
  }, {
    "kind": "LocalArgument",
    "name": "fetchNewEvents",
    "type": "Boolean!",
    "defaultValue": false
  }, {
    "kind": "LocalArgument",
    "name": "fetchNotifications",
    "type": "Boolean!",
    "defaultValue": false
  }, {
    "kind": "LocalArgument",
    "name": "notificationItemsLimit",
    "type": "Int!",
    "defaultValue": 0
  }, {
    "kind": "RootArgument",
    "name": "userId",
    "type": "String"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "Likes_viewer",
  "selections": [{
    "kind": "Condition",
    "passingValue": true,
    "condition": "fetchNotifications",
    "selections": [{
      "kind": "LinkedField",
      "alias": "favoriteNotificationsTiles",
      "args": [{
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId",
        "type": "String"
      }],
      "concreteType": "FavoriteNotifications",
      "name": "favoriteNotifications",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "FavNotifications_favoriteNotificationsTiles",
        "args": [{
          "kind": "Variable",
          "name": "createdAfter",
          "variableName": "createdAfter",
          "type": null
        }, {
          "kind": "Variable",
          "name": "eventsLimit",
          "variableName": "eventsLimit",
          "type": null
        }, {
          "kind": "Variable",
          "name": "notificationItemsLimit",
          "variableName": "notificationItemsLimit",
          "type": null
        }]
      }],
      "storageKey": null
    }]
  }, {
    "kind": "Condition",
    "passingValue": true,
    "condition": "fetchNewEvents",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId",
        "type": "String"
      }],
      "concreteType": "FavoriteNotifications",
      "name": "favoriteNotifications",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": [{
          "kind": "Variable",
          "name": "createdAfter",
          "variableName": "createdAfter",
          "type": "String"
        }, {
          "kind": "Variable",
          "name": "eventsLimit",
          "variableName": "eventsLimit",
          "type": "Int"
        }],
        "name": "hasNewEvents",
        "storageKey": null
      }],
      "storageKey": null
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/Logo/Logo-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Logo-style__wrapper__fdc13700","icon":"Logo-style__icon__fdc13700"};

/***/ }),

/***/ "./src/components/Logo/Logo.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _logo = __webpack_require__("./node_modules/dibs-vg/dist/react/logo.js");

var _logo2 = _interopRequireDefault(_logo);

var _logoTrade = __webpack_require__("./node_modules/dibs-vg/dist/react/logo-trade.js");

var _logoTrade2 = _interopRequireDefault(_logoTrade);

var _LogoStyle = __webpack_require__("./src/components/Logo/Logo-style.scss");

var _LogoStyle2 = _interopRequireDefault(_LogoStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
    label: 'home link|1stdibs logo'
};

var Logo = function Logo(_ref) {
    var isUserTypeTrade = _ref.isUserTypeTrade;

    return _react2.default.createElement(
        'div',
        { className: _LogoStyle2.default.wrapper },
        _react2.default.createElement(
            'a',
            {
                href: '/', className: _LogoStyle2.default.icon,
                onClick: function onClick() {
                    (0, _dibsTracking.trackEvent)(trackingObj);
                }
            },
            isUserTypeTrade ? _react2.default.createElement(_logoTrade2.default, null) : _react2.default.createElement(_logo2.default, null)
        )
    );
};

var mapStateToProps = function mapStateToProps(state) {
    var isUserTypeTrade = state.header.isUserTypeTrade;


    return {
        isUserTypeTrade: isUserTypeTrade
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Logo);

/***/ }),

/***/ "./src/components/Masthead/Masthead-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"masthead":"Masthead-style__masthead__4a0f200","isTrade":"Masthead-style__isTrade__4a0f200"};

/***/ }),

/***/ "./src/components/Masthead/Masthead.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _MastheadStyle = __webpack_require__("./src/components/Masthead/Masthead-style.scss");

var _MastheadStyle2 = _interopRequireDefault(_MastheadStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Masthead = function Masthead(_ref) {
    var _classnames;

    var isUserTypeTrade = _ref.isUserTypeTrade;

    var classes = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _MastheadStyle2.default.masthead, true), _defineProperty(_classnames, _MastheadStyle2.default.isTrade, isUserTypeTrade), _classnames));
    return _react2.default.createElement('div', { className: classes });
};

var mapStateToProps = function mapStateToProps(_ref2) {
    var header = _ref2.header;
    var isUserTypeTrade = header.isUserTypeTrade;


    return {
        isUserTypeTrade: isUserTypeTrade
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Masthead);

/***/ }),

/***/ "./src/components/MessageBanner/MessageBanner-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"slideLeft":"MessageBanner-style__slideLeft__e9a8dac0","slideRight":"MessageBanner-style__slideRight__e9a8dac0","bannerContainer":"MessageBanner-style__bannerContainer__e9a8dac0","carouselArrowRight":"MessageBanner-style__carouselArrowRight__e9a8dac0","carouselArrowLeft":"MessageBanner-style__carouselArrowLeft__e9a8dac0","isMobile":"MessageBanner-style__isMobile__e9a8dac0","isTrade":"MessageBanner-style__isTrade__e9a8dac0","carouselWrapper":"MessageBanner-style__carouselWrapper__e9a8dac0","hasPagination":"MessageBanner-style__hasPagination__e9a8dac0","carousel":"MessageBanner-style__carousel__e9a8dac0","carouselItems":"MessageBanner-style__carouselItems__e9a8dac0","carouselArrowWrapperLeft":"MessageBanner-style__carouselArrowWrapperLeft__e9a8dac0","carouselArrowWrapperRight":"MessageBanner-style__carouselArrowWrapperRight__e9a8dac0","itemWrapper":"MessageBanner-style__itemWrapper__e9a8dac0","ctaLink":"MessageBanner-style__ctaLink__e9a8dac0"};

/***/ }),

/***/ "./src/components/MessageBanner/MessageBanner.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _MessageBannerCarousel = __webpack_require__("./src/components/MessageBanner/MessageBannerCarousel.jsx");

var _MessageBannerCarousel2 = _interopRequireDefault(_MessageBannerCarousel);

var _messageHelpers = __webpack_require__("./src/components/MessageBanner/messageHelpers.js");

var _userTypeHelpers = __webpack_require__("./src/components/MessageBanner/userTypeHelpers.js");

var _MessageBannerStyle = __webpack_require__("./src/components/MessageBanner/MessageBanner-style.scss");

var _MessageBannerStyle2 = _interopRequireDefault(_MessageBannerStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MessageBanner = function (_Component) {
    _inherits(MessageBanner, _Component);

    function MessageBanner(props) {
        _classCallCheck(this, MessageBanner);

        var _this = _possibleConstructorReturn(this, (MessageBanner.__proto__ || Object.getPrototypeOf(MessageBanner)).call(this, props));

        _this.state = {
            fragmentVariables: {
                fetchMarketingMessagesTransactions: false,
                hasUserType: false,
                setId: '',
                userIds: '',
                userType: ''
            },
            messages: null
        };
        return _this;
    }

    _createClass(MessageBanner, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var _props = this.props,
                hasRootPendingRefetch = _props.hasRootPendingRefetch,
                hasUserId = _props.hasUserId,
                isClient = _props.isClient,
                viewer = _props.viewer;
            var messages = this.state.messages;


            if (!isClient || hasRootPendingRefetch || messages) {
                return;
            }

            if (viewer.messages) {
                this.setState({ messages: (0, _messageHelpers.getMessagesToShow)(viewer.messages) }); // eslint-disable-line react/no-did-update-set-state
                return;
            }

            if ((0, _messageHelpers.isPreview)()) {
                var _getPreview = (0, _messageHelpers.getPreview)(),
                    previewMessages = _getPreview.messages,
                    setParams = _getPreview.setParams;

                if (previewMessages) {
                    this.setState({ messages: previewMessages }); // eslint-disable-line react/no-did-update-set-state
                    return;
                }

                var userType = setParams.userType,
                    _setParams$setId = setParams.setId,
                    setId = _setParams$setId === undefined ? null : _setParams$setId;

                this.fetchMessages({ userType: userType, setId: setId });
            } else {
                var hasAllTransactions = !!viewer.allTransactions;

                if (hasUserId && !hasAllTransactions) {
                    this.fetchTransactions();
                    return;
                }

                var _userType = this.getUserType();

                if (_userType) {
                    this.getPromoCodeMessages(_userType);
                    this.fetchMessages({ userType: _userType });
                }
            }
        }
    }, {
        key: 'getUserType',
        value: function getUserType() {
            var _props2 = this.props,
                hasUserId = _props2.hasUserId,
                user = _props2.user,
                viewer = _props2.viewer;

            var userType = void 0;

            if (!!viewer.allTransactions && !!user) {
                userType = (0, _userTypeHelpers.getRegisteredUserType)(user, viewer);
            } else if (!hasUserId) {
                userType = (0, _userTypeHelpers.getUnregisteredUserType)();
            }

            return userType;
        }
    }, {
        key: 'getPromoCodeMessages',
        value: function getPromoCodeMessages(userType) {
            var _this2 = this;

            var marketingBannerPromoCodes = window.abExperiments.marketingBannerPromoCodes;


            if (marketingBannerPromoCodes) {

                marketingBannerPromoCodes.then(function () {
                    var promoCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                    var messages = promoCodes[userType] || promoCodes.default;

                    if (messages) {
                        _this2.setState({ messages: messages });
                    }
                });
            }
        }
    }, {
        key: 'fetchTransactions',
        value: function fetchTransactions() {
            var _this3 = this;

            if (!this.state.fragmentVariables.fetchMarketingMessagesTransactions) {
                this.setState({
                    fragmentVariables: _extends({}, this.state.fragmentVariables, {
                        fetchMarketingMessagesTransactions: true,
                        hasUserId: true,
                        userIds: this.props.userIds
                    })
                }, function () {
                    _this3.props.relay.refetch(_this3.state.fragmentVariables, null);
                });
            }
        }
    }, {
        key: 'fetchMessages',
        value: function fetchMessages() {
            var _this4 = this;

            var variables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (!this.state.fragmentVariables.hasUserType) {
                this.setState({
                    fragmentVariables: _extends({}, this.state.fragmentVariables, variables, {
                        hasUserType: true
                    })
                }, function () {
                    _this4.props.relay.refetch(_this4.state.fragmentVariables);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var _props3 = this.props,
                isClient = _props3.isClient,
                isMobile = _props3.isMobile,
                isUserTypeTrade = _props3.isUserTypeTrade;
            var messages = this.state.messages;


            var classes = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _MessageBannerStyle2.default.bannerContainer, true), _defineProperty(_classnames, _MessageBannerStyle2.default.isTrade, isUserTypeTrade), _defineProperty(_classnames, _MessageBannerStyle2.default.isMobile, isMobile), _classnames));

            if (!isClient || !messages) {
                return _react2.default.createElement('div', { className: classes });
            }

            return _react2.default.createElement(
                'div',
                { className: classes },
                _react2.default.createElement(_MessageBannerCarousel2.default, { messages: messages })
            );
        }
    }]);

    return MessageBanner;
}(_react.Component);

var mapStateToProps = function mapStateToProps(_ref) {
    var header = _ref.header;
    var isUserTypeTrade = header.isUserTypeTrade;


    return {
        isUserTypeTrade: isUserTypeTrade
    };
};

MessageBanner = (0, _reactRelay.createRefetchContainer)((0, _reactRedux.connect)(mapStateToProps)(MessageBanner), {
    message: {
        modern: function modern() {
            return __webpack_require__("./src/components/MessageBanner/__generated__/MessageBanner_message.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            children: [{
                                fieldName: 'title',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'message',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                children: [{
                                    fieldName: 'text',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    fieldName: 'url',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }],
                                fieldName: 'cta',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'MarketingMessageCta'
                            }],
                            fieldName: 'content',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'MarketingMessageContent'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MessageBanner_message',
                        type: 'MarketingMessage'
                    };
                }()
            };
        }
    },
    user: {
        modern: function modern() {
            return __webpack_require__("./src/components/MessageBanner/__generated__/MessageBanner_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            fieldName: 'isVip',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'isVerifiedTrade',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'verifiedTradeStatus',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            fieldName: 'verifiedTradeSubStatus',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            children: [{
                                children: [{
                                    fieldName: 'status',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'TradeFirmLoyaltyStatus'
                                }],
                                fieldName: 'loyalty',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'TradeFirmLoyaltyType'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'tradeFirm',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'TradeFirmType'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MessageBanner_user',
                        type: 'User'
                    };
                }()
            };
        }
    },
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/MessageBanner/__generated__/MessageBanner_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var MessageBanner_message = RelayQL_GENERATED.__getClassicFragment(MessageBanner.message.message || MessageBanner.message).node;

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    defaultValue: '',
                    kind: 'LocalArgument',
                    name: 'userType'
                }, {
                    defaultValue: '',
                    kind: 'LocalArgument',
                    name: 'setId'
                }, {
                    defaultValue: false,
                    kind: 'LocalArgument',
                    name: 'hasUserType'
                }, {
                    kind: 'RootArgument',
                    name: 'userIds'
                }, {
                    kind: 'RootArgument',
                    name: 'fetchMarketingMessagesTransactions'
                }],
                node: function () {
                    return {
                        children: [{
                            alias: 'messages',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userType',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userType'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {},
                                name: 'setId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'setId'
                                }
                            }],
                            children: [{
                                children: [{
                                    fieldName: 'impressionCap',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Int'
                                }, {
                                    children: [].concat.apply([], [{
                                        children: [].concat.apply([], [{
                                            fieldName: 'id',
                                            kind: 'Field',
                                            metadata: {
                                                isGenerated: true,
                                                isRequisite: true
                                            },
                                            type: 'ID'
                                        }, RelayQL_GENERATED.__frag(MessageBanner_message)]),
                                        fieldName: 'anchors',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            inferredRootCallName: 'node',
                                            inferredPrimaryKey: 'id',
                                            isPlural: true
                                        },
                                        type: 'MarketingMessage'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }, RelayQL_GENERATED.__frag(MessageBanner_message)]),
                                    fieldName: 'note',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        inferredRootCallName: 'node',
                                        inferredPrimaryKey: 'id'
                                    },
                                    type: 'MarketingMessage'
                                }],
                                fieldName: 'items',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'MessageSetItem'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserType'
                                    }
                                }]
                            }],
                            fieldName: 'messageSet',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'MessageSetModule'
                        }, {
                            alias: 'allTransactions',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'first',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 0
                                }
                            }],
                            children: [{
                                fieldName: 'totalResults',
                                kind: 'Field',
                                metadata: {},
                                type: 'Int'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'fetchMarketingMessagesTransactions'
                                    }
                                }]
                            }],
                            fieldName: 'transactions',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'TransactionConnection'
                        }, {
                            alias: 'initiatedTransactions',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {},
                                name: 'viewName',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'buyerTracking.initiated'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'first',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 0
                                }
                            }],
                            children: [{
                                fieldName: 'totalResults',
                                kind: 'Field',
                                metadata: {},
                                type: 'Int'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'fetchMarketingMessagesTransactions'
                                    }
                                }]
                            }],
                            fieldName: 'transactions',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'TransactionConnection'
                        }, {
                            alias: 'submittedTransactions',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {},
                                name: 'viewName',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'buyerTracking.submitted'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'first',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 0
                                }
                            }],
                            children: [{
                                fieldName: 'totalResults',
                                kind: 'Field',
                                metadata: {},
                                type: 'Int'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'fetchMarketingMessagesTransactions'
                                    }
                                }]
                            }],
                            fieldName: 'transactions',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'TransactionConnection'
                        }, {
                            alias: 'confirmedTransactions',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {},
                                name: 'sort',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'createdDate asc'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {},
                                name: 'viewName',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'buyerTracking.confirmed'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'first',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 0
                                }
                            }],
                            children: [{
                                fieldName: 'totalResults',
                                kind: 'Field',
                                metadata: {},
                                type: 'Int'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'fetchMarketingMessagesTransactions'
                                    }
                                }]
                            }],
                            fieldName: 'transactions',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'TransactionConnection'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MessageBanner_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    }
}, {
    modern: function modern() {
        return __webpack_require__("./src/components/MessageBanner/__generated__/MessageBannerRefetchQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var MessageBanner_viewer_args1 = (MessageBanner.__container__ || MessageBanner).getFragment('viewer', {
            hasUserType: {
                kind: 'CallVariable',
                callVariableName: 'hasUserType'
            },
            setId: {
                kind: 'CallVariable',
                callVariableName: 'setId'
            },
            userType: {
                kind: 'CallVariable',
                callVariableName: 'userType'
            }
        });
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'fetchMarketingMessagesTransactions'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'hasUserType'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'setId'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userIds'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userType'
            }],
            name: 'MessageBannerRefetchQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(MessageBanner_viewer_args1)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'MessageBannerRefetchQuery',
                    type: 'Query'
                };
            }()
        };
    }
});

exports.default = MessageBanner;

/***/ }),

/***/ "./src/components/MessageBanner/MessageBannerCarousel.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _actions = __webpack_require__("./src/actions/index.js");

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _arrowLeft = __webpack_require__("./node_modules/dibs-vg/dist/react/arrow-left.js");

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _arrowRight = __webpack_require__("./node_modules/dibs-vg/dist/react/arrow-right.js");

var _arrowRight2 = _interopRequireDefault(_arrowRight);

var _MessageBannerItem = __webpack_require__("./src/components/MessageBanner/MessageBannerItem.jsx");

var _MessageBannerItem2 = _interopRequireDefault(_MessageBannerItem);

var _MessageBannerStyle = __webpack_require__("./src/components/MessageBanner/MessageBanner-style.scss");

var _MessageBannerStyle2 = _interopRequireDefault(_MessageBannerStyle);

var _messageHelpers = __webpack_require__("./src/components/MessageBanner/messageHelpers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MessageBannerCarousel = function (_Component) {
    _inherits(MessageBannerCarousel, _Component);

    function MessageBannerCarousel(props) {
        _classCallCheck(this, MessageBannerCarousel);

        var _this = _possibleConstructorReturn(this, (MessageBannerCarousel.__proto__ || Object.getPrototypeOf(MessageBannerCarousel)).call(this, props));

        _this.state = {
            curr: 0
        };

        _this.handlePrevious = _this.handlePrevious.bind(_this);
        _this.handleNext = _this.handleNext.bind(_this);
        _this.fireTracking = _this.fireTracking.bind(_this);
        return _this;
    }

    _createClass(MessageBannerCarousel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.setMessages(this.props.messages);
        }
    }, {
        key: 'handlePrevious',
        value: function handlePrevious() {
            var index = this.state.curr - 1;

            if (index < 0) {
                index = this.props.messages.length - 1;
            }

            this.fireTracking(this.state.curr, 'previous', index);
            this.setState({ curr: index });
        }
    }, {
        key: 'handleNext',
        value: function handleNext() {
            var index = this.state.curr + 1;

            if (index > this.props.messages.length - 1) {
                index = 0;
            }

            this.fireTracking(this.state.curr, 'next', index);
            this.setState({ curr: index });
        }
    }, {
        key: 'fireTracking',
        value: function fireTracking(previous, type, current) {
            if (!(0, _messageHelpers.isPreview)()) {

                (0, _dibsTracking.trackEvent)((0, _messageHelpers.getTrackingObj)({
                    messageItem: this.props.messages[previous],
                    action: 'banner ' + type + ' clicked'
                }));
            }
            this.setItemValuesToStorage(this.props.messages[current]);
        }
    }, {
        key: 'setItemValuesToStorage',
        value: function setItemValuesToStorage(messageItem) {

            if (!(0, _messageHelpers.isPreview)() && !(0, _messageHelpers.wasShown)(messageItem)) {
                (0, _messageHelpers.setValuesToStorage)(messageItem);
                (0, _messageHelpers.addToShownList)(messageItem);

                (0, _dibsTracking.trackEvent)((0, _messageHelpers.getTrackingObj)({
                    messageItem: messageItem,
                    action: 'banner displayed'
                }));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var messages = this.props.messages;
            var curr = this.state.curr;

            var count = messages.length;
            var hasPagination = count && count > 1;

            var carouselItemsStyle = {
                width: count * 100 + '%',
                transform: 'translateX(' + -(curr / count) * 100 + '%)'
            };

            var wrapperClasses = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _MessageBannerStyle2.default.carouselWrapper, true), _defineProperty(_classnames, _MessageBannerStyle2.default.hasPagination, hasPagination), _classnames));

            this.setItemValuesToStorage(messages[0]);

            return _react2.default.createElement(
                'div',
                { className: wrapperClasses },
                hasPagination ? _react2.default.createElement(
                    'div',
                    { className: _MessageBannerStyle2.default.carouselArrowWrapperLeft, onClick: this.handlePrevious },
                    _react2.default.createElement(_arrowLeft2.default, { className: _MessageBannerStyle2.default.carouselArrowLeft })
                ) : null,
                _react2.default.createElement(
                    'div',
                    { className: _MessageBannerStyle2.default.carousel },
                    _react2.default.createElement(
                        'div',
                        { className: _MessageBannerStyle2.default.carouselItems, style: carouselItemsStyle },
                        messages.map(function (item) {
                            return _react2.default.createElement(_MessageBannerItem2.default, { key: item.note.serviceId, messageItem: item });
                        })
                    )
                ),
                hasPagination ? _react2.default.createElement(
                    'div',
                    { className: _MessageBannerStyle2.default.carouselArrowWrapperRight, onClick: this.handleNext },
                    _react2.default.createElement(_arrowRight2.default, { className: _MessageBannerStyle2.default.carouselArrowRight })
                ) : null
            );
        }
    }]);

    return MessageBannerCarousel;
}(_react.Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch) {

    return {
        setMessages: function setMessages(messages) {
            dispatch(_actions.actionCreators.setBannerMessages(messages));
        }
    };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(MessageBannerCarousel);

/***/ }),

/***/ "./src/components/MessageBanner/MessageBannerItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _messageHelpers = __webpack_require__("./src/components/MessageBanner/messageHelpers.js");

var _MessageBannerStyle = __webpack_require__("./src/components/MessageBanner/MessageBanner-style.scss");

var _MessageBannerStyle2 = _interopRequireDefault(_MessageBannerStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageBannerItem = function MessageBannerItem(props) {
    var messageItem = props.messageItem;

    var _get = (0, _lodash2.default)((0, _messageHelpers.getNoteByDevice)(messageItem), 'content', {}),
        message = _get.message,
        cta = _get.cta;

    var _trackCtaClick = function _trackCtaClick() {
        if (!(0, _messageHelpers.isPreview)()) {
            (0, _dibsTracking.trackEvent)((0, _messageHelpers.getTrackingObj)({
                messageItem: messageItem,
                action: 'banner cta clicked'
            }));
        }
    };

    return _react2.default.createElement(
        'div',
        { className: _MessageBannerStyle2.default.itemWrapper },
        message,
        ' ',
        cta && _react2.default.createElement(
            'a',
            { className: _MessageBannerStyle2.default.ctaLink, href: cta.url, onClick: _trackCtaClick, target: '_blank' },
            cta.text
        )
    );
};

exports.default = MessageBannerItem;

/***/ }),

/***/ "./src/components/MessageBanner/__generated__/MessageBannerRefetchQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash a979ece4d17071b9105606ec3e6b738c
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type MessageBannerRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query MessageBannerRefetchQuery(
  $fetchMarketingMessagesTransactions: Boolean!
  $hasUserType: Boolean!
  $setId: String!
  $userIds: [String!]
  $userType: String!
) {
  viewer {
    ...MessageBanner_viewer_2zw5Ym
    id
  }
}

fragment MessageBanner_viewer_2zw5Ym on Viewer {
  messages: messageSet(userType: $userType, setId: $setId) @include(if: $hasUserType) {
    items {
      impressionCap
      note {
        serviceId
        content {
          title
          message
          cta {
            text
            url
          }
        }
        anchors {
          ... on MarketingMessage {
            serviceId
            content {
              title
              message
              cta {
                text
                url
              }
            }
          }
          id
        }
        id
      }
    }
  }
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  confirmedTransactions: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "fetchMarketingMessagesTransactions",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasUserType",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "setId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String!]",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userType",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageBannerRefetchQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "MessageBanner_viewer",
        "args": [{
          "kind": "Variable",
          "name": "hasUserType",
          "variableName": "hasUserType",
          "type": null
        }, {
          "kind": "Variable",
          "name": "setId",
          "variableName": "setId",
          "type": null
        }, {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType",
          "type": null
        }]
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "MessageBannerRefetchQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "fetchMarketingMessagesTransactions",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasUserType",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "setId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String!]",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userType",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "MessageBannerRefetchQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "fetchMarketingMessagesTransactions",
        "selections": [{
          "kind": "LinkedField",
          "alias": "allTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.initiated",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.submitted",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "confirmedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "sort",
            "value": "createdDate asc",
            "type": "String"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.confirmed",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }]
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserType",
        "selections": [{
          "kind": "LinkedField",
          "alias": "messages",
          "args": [{
            "kind": "Variable",
            "name": "setId",
            "variableName": "setId",
            "type": "String"
          }, {
            "kind": "Variable",
            "name": "userType",
            "variableName": "userType",
            "type": "String!"
          }],
          "concreteType": "MessageSetModule",
          "name": "messageSet",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "MessageSetItem",
            "name": "items",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "impressionCap",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "MarketingMessage",
              "name": "note",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "serviceId",
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "MarketingMessageContent",
                "name": "content",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "title",
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "message",
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "MarketingMessageCta",
                  "name": "cta",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "text",
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "url",
                    "storageKey": null
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "MarketingMessage",
                "name": "anchors",
                "plural": true,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                }, {
                  "kind": "InlineFragment",
                  "type": "MarketingMessage",
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "serviceId",
                    "storageKey": null
                  }, {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "MarketingMessageContent",
                    "name": "content",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "title",
                      "storageKey": null
                    }, {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "message",
                      "storageKey": null
                    }, {
                      "kind": "LinkedField",
                      "alias": null,
                      "args": null,
                      "concreteType": "MarketingMessageCta",
                      "name": "cta",
                      "plural": false,
                      "selections": [{
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "text",
                        "storageKey": null
                      }, {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "url",
                        "storageKey": null
                      }],
                      "storageKey": null
                    }],
                    "storageKey": null
                  }]
                }],
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query MessageBannerRefetchQuery(\n  $fetchMarketingMessagesTransactions: Boolean!\n  $hasUserType: Boolean!\n  $setId: String!\n  $userIds: [String!]\n  $userType: String!\n) {\n  viewer {\n    ...MessageBanner_viewer_2zw5Ym\n    id\n  }\n}\n\nfragment MessageBanner_viewer_2zw5Ym on Viewer {\n  messages: messageSet(userType: $userType, setId: $setId) @include(if: $hasUserType) {\n    items {\n      impressionCap\n      note {\n        serviceId\n        content {\n          title\n          message\n          cta {\n            text\n            url\n          }\n        }\n        anchors {\n          ... on MarketingMessage {\n            serviceId\n            content {\n              title\n              message\n              cta {\n                text\n                url\n              }\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  confirmedTransactions: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/MessageBanner/__generated__/MessageBanner_message.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MessageBanner_message = {|
  +serviceId: ?string;
  +content: ?{|
    +title: ?string;
    +message: ?string;
    +cta: ?{|
      +text: ?string;
      +url: ?string;
    |};
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageBanner_message",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "serviceId",
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "MarketingMessageContent",
    "name": "content",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "title",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "message",
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "MarketingMessageCta",
      "name": "cta",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "text",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "url",
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "MarketingMessage"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MessageBanner/__generated__/MessageBanner_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MessageBanner_user = {|
  +isVip: ?boolean;
  +isVerifiedTrade: ?boolean;
  +verifiedTradeStatus: ?string;
  +verifiedTradeSubStatus: ?string;
  +tradeFirm: ?{|
    +loyalty: ?{|
      +status: ?"ENROLLED" | "ELIGIBLE" | "NOT_ELIGIBLE" | "BLACKLISTED";
    |};
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageBanner_user",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "isVip",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "isVerifiedTrade",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "verifiedTradeStatus",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "verifiedTradeSubStatus",
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "TradeFirmType",
    "name": "tradeFirm",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmLoyaltyType",
      "name": "loyalty",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "status",
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MessageBanner/__generated__/MessageBanner_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MessageBanner_viewer = {|
  +messages?: ?$ReadOnlyArray<?{|
    +items: ?$ReadOnlyArray<?{|
      +impressionCap: ?number;
      +note: ?{|
        +serviceId: ?string;
        +content: ?{|
          +title: ?string;
          +message: ?string;
          +cta: ?{|
            +text: ?string;
            +url: ?string;
          |};
        |};
        +anchors: ?$ReadOnlyArray<?{|
          +serviceId?: ?string;
          +content?: ?{|
            +title: ?string;
            +message: ?string;
            +cta: ?{|
              +text: ?string;
              +url: ?string;
            |};
          |};
        |}>;
      |};
    |}>;
  |}>;
  +allTransactions?: ?{|
    +totalResults: ?number;
  |};
  +initiatedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +submittedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +confirmedTransactions?: ?{|
    +totalResults: ?number;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "hasUserType",
    "type": "Boolean!",
    "defaultValue": false
  }, {
    "kind": "LocalArgument",
    "name": "setId",
    "type": "String!",
    "defaultValue": ""
  }, {
    "kind": "LocalArgument",
    "name": "userType",
    "type": "String!",
    "defaultValue": ""
  }, {
    "kind": "RootArgument",
    "name": "userIds",
    "type": "[String]"
  }, {
    "kind": "RootArgument",
    "name": "fetchMarketingMessagesTransactions",
    "type": "Boolean"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageBanner_viewer",
  "selections": [{
    "kind": "Condition",
    "passingValue": true,
    "condition": "fetchMarketingMessagesTransactions",
    "selections": [{
      "kind": "LinkedField",
      "alias": "allTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "initiatedTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.initiated",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "submittedTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.submitted",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "confirmedTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "sort",
        "value": "createdDate asc",
        "type": "String"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.confirmed",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }]
  }, {
    "kind": "Condition",
    "passingValue": true,
    "condition": "hasUserType",
    "selections": [{
      "kind": "LinkedField",
      "alias": "messages",
      "args": [{
        "kind": "Variable",
        "name": "setId",
        "variableName": "setId",
        "type": "String"
      }, {
        "kind": "Variable",
        "name": "userType",
        "variableName": "userType",
        "type": "String!"
      }],
      "concreteType": "MessageSetModule",
      "name": "messageSet",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "MessageSetItem",
        "name": "items",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "impressionCap",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "MarketingMessage",
          "name": "note",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "MarketingMessageContent",
            "name": "content",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "title",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "message",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "MarketingMessageCta",
              "name": "cta",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "text",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "url",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "MarketingMessage",
            "name": "anchors",
            "plural": true,
            "selections": [{
              "kind": "InlineFragment",
              "type": "MarketingMessage",
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "serviceId",
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "MarketingMessageContent",
                "name": "content",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "title",
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "message",
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "MarketingMessageCta",
                  "name": "cta",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "text",
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "url",
                    "storageKey": null
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }]
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MessageBanner/messageHelpers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMessagesToShow = exports.setValuesToStorage = exports.wasShown = exports.addToShownList = exports.getPreview = exports.isPreview = exports.getNoteByDevice = exports.getTrackingObj = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _dibsBrowserStorage2 = _interopRequireDefault(_dibsBrowserStorage);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LAST_BANNER_MESSAGE_ID = 'lastBannerMessageId';
var MESSAGE_IMPRESSION_CAPS = 'messageImpressionCaps';

var GLOBAL_FALLBACK_TEXT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'dbl.Header.MessageBanner.global_fallback_text',
    defaultMessage: '1stdibs is the world\'s leading marketplace for beautiful and rare objects'
});

var shownIds = {};

var getTrackingObj = exports.getTrackingObj = function getTrackingObj(_ref) {
    var messageItem = _ref.messageItem,
        action = _ref.action;

    return {
        category: 'promo interaction',
        action: action,
        label: (0, _lodash2.default)(messageItem, 'note.content.title')
    };
};

var messageItemTemplate = function messageItemTemplate(_ref2) {
    var _ref2$desktop = _ref2.desktop,
        desktop = _ref2$desktop === undefined ? null : _ref2$desktop,
        _ref2$mobile = _ref2.mobile,
        mobile = _ref2$mobile === undefined ? null : _ref2$mobile;

    return {
        note: {
            serviceId: 'template_id_1',
            content: desktop,
            anchors: [{
                serviceId: 'template_id_2',
                content: mobile
            }]
        }
    };
};

var globalFallbackMessage = function globalFallbackMessage() {
    var content = {
        title: 'global fallback',
        message: GLOBAL_FALLBACK_TEXT
    };
    return messageItemTemplate({
        desktop: content,
        mobile: content
    });
};

var getNoteByDevice = exports.getNoteByDevice = function getNoteByDevice(messageItem) {
    if (typeof window !== 'undefined' && window.innerWidth < 1024) {
        return (0, _lodash2.default)(messageItem, 'note.anchors[0]');
    }
    return (0, _lodash2.default)(messageItem, 'note');
};

var getNoteId = function getNoteId(messageItem) {
    return (0, _lodash2.default)(getNoteByDevice(messageItem), 'serviceId');
};

var hasAnyText = function hasAnyText(messageItem) {
    return !!(0, _lodash2.default)(getNoteByDevice(messageItem), 'content.message');
};

var messagePreviewMatch = function messagePreviewMatch() {
    return window.location.search.match(/cmsMessagePreview=([^&]+)/);
};

var messageSetsMatch = function messageSetsMatch() {
    return window.location.search.match(/message-sets:([^&]+)/);
};

var isPreview = exports.isPreview = function isPreview() {
    return !!(messagePreviewMatch() || messageSetsMatch());
};

var getMessagesFromUrl = function getMessagesFromUrl() {
    var match = messagePreviewMatch();
    if (match) {
        return [messageItemTemplate(JSON.parse(decodeURIComponent(match[1])))];
    }
    return null;
};

var getUserTypeAndSetIdFromUrl = function getUserTypeAndSetIdFromUrl() {
    var setMatch = messageSetsMatch();
    if (setMatch) {
        var splits = setMatch[1].split('=');
        return {
            userType: splits[0],
            setId: splits.length > 1 ? splits[1] : null
        };
    }
    return null;
};

var getPreview = exports.getPreview = function getPreview() {
    return {
        messages: getMessagesFromUrl(),
        setParams: getUserTypeAndSetIdFromUrl()
    };
};

var addToShownList = exports.addToShownList = function addToShownList(messageItem) {
    var noteId = getNoteId(messageItem);
    if (noteId) {
        shownIds[noteId] = true;
    }
};

var wasShown = exports.wasShown = function wasShown(messageItem) {
    return !!shownIds[getNoteId(messageItem)];
};

var increaseImpressionCap = function increaseImpressionCap(noteId) {
    var localStorage = _dibsBrowserStorage2.default.localStorage;

    var msgImpressCaps = localStorage.getItem(MESSAGE_IMPRESSION_CAPS) || {};

    msgImpressCaps[noteId] = msgImpressCaps[noteId] ? msgImpressCaps[noteId] + 1 : 1;

    localStorage.setItem(MESSAGE_IMPRESSION_CAPS, msgImpressCaps);
};

var setNoteIdToStorage = function setNoteIdToStorage(noteId) {
    var localStorage = _dibsBrowserStorage2.default.localStorage;

    localStorage.setItem(LAST_BANNER_MESSAGE_ID, noteId);
};

var setValuesToStorage = exports.setValuesToStorage = function setValuesToStorage(messageItem) {
    var noteId = getNoteId(messageItem);
    if (noteId) {
        increaseImpressionCap(noteId);
        setNoteIdToStorage(noteId);
    }
};

var validImpressionCap = function validImpressionCap(messageItem) {
    var noteId = getNoteId(messageItem);
    var localStorage = _dibsBrowserStorage2.default.localStorage;

    var msgImpressCaps = localStorage.getItem(MESSAGE_IMPRESSION_CAPS);
    if (msgImpressCaps && msgImpressCaps[noteId]) {
        return messageItem.impressionCap > msgImpressCaps[noteId];
    }
    return true;
};

var getNextMessageIndex = function getNextMessageIndex(allMessages, validMessages) {
    var localStorage = _dibsBrowserStorage2.default.localStorage;

    var lastMsgId = localStorage.getItem(LAST_BANNER_MESSAGE_ID);
    if (lastMsgId) {
        var lastMsgIndex = allMessages.findIndex(function (item) {
            return getNoteId(item) === lastMsgId.toString();
        });

        var _loop = function _loop(i) {
            var nextMsgItem = allMessages[(i + (lastMsgIndex + 1)) % allMessages.length];
            var indexInValidArray = validMessages.findIndex(function (item) {
                return getNoteId(item) === getNoteId(nextMsgItem);
            });
            if (indexInValidArray !== -1) {
                return {
                    v: indexInValidArray
                };
            }
        };

        for (var i = 0; i < allMessages.length; i++) {
            var _ret = _loop(i);

            if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
        }
    }
    return 0;
};

var countPrimaryMessages = function countPrimaryMessages(messageSet) {
    return messageSet ? messageSet[0].items.filter(function (item) {
        return hasAnyText(item);
    }).length : 0;
};

var getValidMessagesArray = function getValidMessagesArray(messages, primaryCount) {
    return messages.filter(function (item) {
        return hasAnyText(item) && validImpressionCap(item);
    }).slice(0, primaryCount);
};

var getFallbackMessagesArray = function getFallbackMessagesArray(messageSet) {
    var fallback = (0, _lodash2.default)(messageSet, '[2].items', []).filter(function (item) {
        return hasAnyText(item);
    });
    if (!fallback || !fallback.length) {
        fallback = [globalFallbackMessage()];
    }
    return fallback;
};

var moveItemToFront = function moveItemToFront(messages, index) {
    return messages.splice(index).concat(messages);
};

var getMessagesToShow = exports.getMessagesToShow = function getMessagesToShow(messageSet) {
    var primaryCount = countPrimaryMessages(messageSet);
    if (primaryCount) {
        var allMessages = messageSet[0].items.concat(messageSet[1].items);
        var validMessages = getValidMessagesArray(allMessages, primaryCount);
        if (validMessages && validMessages.length) {
            return moveItemToFront(validMessages, getNextMessageIndex(allMessages, validMessages));
        }
    }
    return getFallbackMessagesArray(messageSet);
};

/***/ }),

/***/ "./src/components/MessageBanner/userTypeHelpers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRegisteredUserType = exports.getUnregisteredUserType = undefined;

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _dibsBrowserStorage2 = _interopRequireDefault(_dibsBrowserStorage);

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
    UNREGISTERED: {
        FIRST_TIME: 'unregistered:first-time',
        RETURNING: 'unregistered:returning'
    },
    VIP: {
        ALL: 'vip:all'
    },
    CONSUMER: {
        SUSPECTED_TRADE: 'consumer:suspected-trade',
        NO_PURCHASES: 'consumer:no-purchases',
        PURCHASED: 'consumer:purchased'
    },
    TRADE: {
        LAST_MONTH: 'trade:approved-last-month',
        NO_PURCHASES: 'trade:no-purchases',
        PURCHASED: 'trade:purchased'
    }
};

var BUYER_STATUS_CONFIRMED_MULTIPLE = 'CONFIRMED_MULTIPLE';
var BUYER_STATUS_CONFIRMED_ONE = 'CONFIRMED_ONE';
var BUYER_STATUS_SUBMITTED = 'SUBMITTED';
var BUYER_STATUS_INITIATED = 'INITIATED';
var BUYER_STATUS_NONE = 'NONE';
var FIRM_LOYALTY_STATUS_ELIGIBLE = 'ELIGIBLE';

var getTradeBuyerUserType = function getTradeBuyerUserType(_ref) {
    var firmLoyaltyStatus = _ref.firmLoyaltyStatus,
        verifiedTradeSubStatus = _ref.verifiedTradeSubStatus;

    var userType = types.TRADE.NO_PURCHASES;

    if (firmLoyaltyStatus === FIRM_LOYALTY_STATUS_ELIGIBLE) {
        userType = types.TRADE.PURCHASED;
    } else if (verifiedTradeSubStatus && verifiedTradeSubStatus.indexOf('VERIFIED_IN_LAST_30_DAYS') !== -1) {
        userType = types.TRADE.LAST_MONTH;
    }

    return userType;
};

var getConsumerUserType = function getConsumerUserType(buyerStatus) {
    var verifiedTradeStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var userType = types.CONSUMER.NO_PURCHASES;

    if (verifiedTradeStatus && verifiedTradeStatus.indexOf('SUSPECTED') !== -1) {
        userType = types.CONSUMER.SUSPECTED_TRADE;
    } else if (buyerStatus.indexOf('CONFIRMED') !== -1) {
        userType = types.CONSUMER.PURCHASED;
    }

    return userType;
};

var getBuyerStatusFromTransactions = function getBuyerStatusFromTransactions(_ref2) {
    var initiatedTransactions = _ref2.initiatedTransactions,
        submittedTransactions = _ref2.submittedTransactions,
        confirmedTransactions = _ref2.confirmedTransactions;

    var buyerStatus = void 0;

    if (confirmedTransactions && confirmedTransactions.totalResults > 0) {
        buyerStatus = BUYER_STATUS_CONFIRMED_MULTIPLE;
    } else if (confirmedTransactions && confirmedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_CONFIRMED_ONE;
    } else if (submittedTransactions && submittedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_SUBMITTED;
    } else if (initiatedTransactions && initiatedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_INITIATED;
    } else {
        buyerStatus = BUYER_STATUS_NONE;
    }

    return { buyerStatus: buyerStatus };
};

var getUnregisteredUserType = exports.getUnregisteredUserType = function getUnregisteredUserType() {
    var localStorage = _dibsBrowserStorage2.default.localStorage;

    var totalVisitCount = localStorage.getItem('visitCount') || {};
    var session = localStorage.getItem('pseudoSessionVisitCount') || {};

    return totalVisitCount > session ? types.UNREGISTERED.RETURNING : types.UNREGISTERED.FIRST_TIME;
};

var getRegisteredUserType = exports.getRegisteredUserType = function getRegisteredUserType(user, viewer) {
    var initiatedTransactions = viewer.initiatedTransactions,
        submittedTransactions = viewer.submittedTransactions,
        confirmedTransactions = viewer.confirmedTransactions;
    var isVip = user.isVip,
        isVerifiedTrade = user.isVerifiedTrade,
        verifiedTradeStatus = user.verifiedTradeStatus,
        verifiedTradeSubStatus = user.verifiedTradeSubStatus;


    if (isVip) {
        return types.VIP.ALL;
    }

    var _getBuyerStatusFromTr = getBuyerStatusFromTransactions({ initiatedTransactions: initiatedTransactions, submittedTransactions: submittedTransactions, confirmedTransactions: confirmedTransactions }),
        buyerStatus = _getBuyerStatusFromTr.buyerStatus;

    if (isVerifiedTrade) {
        return getTradeBuyerUserType({
            firmLoyaltyStatus: (0, _lodash2.default)(user, 'tradeFirm.loyalty.status'),
            verifiedTradeSubStatus: verifiedTradeSubStatus
        });
    }

    return getConsumerUserType(buyerStatus, verifiedTradeStatus);
};

/***/ }),

/***/ "./src/components/MobileNav/MobileNav.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MobileNav = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _MobileNavHeader = __webpack_require__("./src/components/MobileNav/MobileNavHeader/MobileNavHeader.jsx");

var _MobileNavHeader2 = _interopRequireDefault(_MobileNavHeader);

var _MobileNavSearchBar = __webpack_require__("./src/components/MobileNav/MobileNavSearchBar/MobileNavSearchBar.jsx");

var _MobileNavSearchBar2 = _interopRequireDefault(_MobileNavSearchBar);

var _MobileNavMenu = __webpack_require__("./src/components/MobileNav/MobileNavMenu/MobileNavMenu.jsx");

var _MobileNavMenu2 = _interopRequireDefault(_MobileNavMenu);

var _mobileNav = __webpack_require__("./src/components/MobileNav/mobileNav.scss");

var _mobileNav2 = _interopRequireDefault(_mobileNav);

var _MobileNavAnimationSlide = __webpack_require__("./src/components/MobileNav/MobileNavAnimations/MobileNavAnimationSlide.jsx");

var _MobileNavAnimationSlide2 = _interopRequireDefault(_MobileNavAnimationSlide);

var _MobileNavDrawer = __webpack_require__("./src/components/MobileNav/MobileNavDrawer/MobileNavDrawer.jsx");

var _MobileNavDrawer2 = _interopRequireDefault(_MobileNavDrawer);

var _MessageBanner = __webpack_require__("./src/components/MessageBanner/MessageBanner.jsx");

var _MessageBanner2 = _interopRequireDefault(_MessageBanner);

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _actions = __webpack_require__("./src/actions/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MobileNav = exports.MobileNav = function (_React$Component) {
    _inherits(MobileNav, _React$Component);

    function MobileNav() {
        _classCallCheck(this, MobileNav);

        var _this = _possibleConstructorReturn(this, (MobileNav.__proto__ || Object.getPrototypeOf(MobileNav)).call(this));

        _this.state = {
            applyOpenStyle: false,
            isSearchOpen: false,
            searchValue: ''
        };

        _this.onHeaderActionClick = _this.onHeaderActionClick.bind(_this);
        _this.onAnimationEnd = _this.onAnimationEnd.bind(_this);
        _this.handleSearchInput = _this.handleSearchInput.bind(_this);
        _this.handleSearchOpen = _this.handleSearchOpen.bind(_this);
        _this.handleSearchClose = _this.handleSearchClose.bind(_this);
        return _this;
    }

    _createClass(MobileNav, [{
        key: 'onHeaderActionClick',
        value: function onHeaderActionClick() {
            this.props.dispatch(_actions.actionCreators.toggleMobileMenu(!this.props.isMobileMenuOpen));
            this.setState({
                applyOpenStyle: true
            });
        }
    }, {
        key: 'handleSearchInput',
        value: function handleSearchInput(searchValue) {
            this.setState({ searchValue: searchValue });
        }
    }, {
        key: 'handleSearchOpen',
        value: function handleSearchOpen() {
            this.setState({
                isSearchOpen: true,
                applyOpenStyle: true
            });
        }
    }, {
        key: 'handleSearchClose',
        value: function handleSearchClose() {
            this.setState({
                isSearchOpen: false,
                searchValue: ''
            });
        }
    }, {
        key: 'onAnimationEnd',
        value: function onAnimationEnd() {
            if (!this.props.isMobileMenuOpen && !this.state.isSearchOpen) {
                this.setState({
                    applyOpenStyle: false
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                applyOpenStyle = _state.applyOpenStyle,
                isSearchOpen = _state.isSearchOpen,
                searchValue = _state.searchValue;
            var _props = this.props,
                onAuthClick = _props.onAuthClick,
                handleNavigateAction = _props.handleNavigateAction,
                viewer = _props.viewer,
                user = _props.user,
                isMobileMenuOpen = _props.isMobileMenuOpen;
            var _props2 = this.props,
                hasUserId = _props2.hasUserId,
                isClient = _props2.isClient,
                showMarketingMessages = _props2.showMarketingMessages,
                userIds = _props2.userIds;

            var isDrawerDisabled = isMobileMenuOpen || isSearchOpen;
            var drawerClass = (0, _classnames3.default)(_mobileNav2.default.container, _defineProperty({}, _mobileNav2.default.isOpen, applyOpenStyle));
            var hasUser = !!user;
            var hasRootPendingRefetch = !hasUser && hasUserId;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _mobileNav2.default.spacer },
                    _react2.default.createElement(
                        _MobileNavDrawer2.default,
                        { className: drawerClass, disabled: isDrawerDisabled },
                        _react2.default.createElement(_MobileNavHeader2.default, {
                            user: user,
                            useCloseIcon: isMobileMenuOpen,
                            onActionClick: this.onHeaderActionClick,
                            handleNavigateAction: handleNavigateAction
                        }),
                        _react2.default.createElement(_MobileNavSearchBar2.default, {
                            viewer: viewer,
                            isOpen: isSearchOpen,
                            value: searchValue,
                            handleNavigateAction: handleNavigateAction,
                            onInput: this.handleSearchInput,
                            onClose: this.handleSearchClose,
                            onOpen: this.handleSearchOpen,
                            onAnimationEnd: this.onAnimationEnd
                        }),
                        _react2.default.createElement(
                            _MobileNavAnimationSlide2.default,
                            {
                                'in': isMobileMenuOpen,
                                onAnimationEnd: this.onAnimationEnd,
                                scrollLock: true
                            },
                            _react2.default.createElement(_MobileNavMenu2.default, {
                                onAuthClick: onAuthClick,
                                viewer: viewer,
                                user: user,
                                onCloseClick: this.closeMenu,
                                handleNavigateAction: handleNavigateAction
                            })
                        )
                    )
                ),
                showMarketingMessages ? _react2.default.createElement(_MessageBanner2.default, {
                    hasRootPendingRefetch: hasRootPendingRefetch,
                    hasUserId: hasUserId,
                    isClient: isClient,
                    isMobile: true,
                    message: null,
                    showMarketingMessages: showMarketingMessages,
                    user: user,
                    userIds: userIds,
                    viewer: viewer
                }) : null
            );
        }
    }]);

    return MobileNav;
}(_react2.default.Component);

function mapStateToProps(state) {
    return {
        isMobileMenuOpen: state.header.isMobileMenuOpen
    };
}

exports.default = (0, _reactRelay.createFragmentContainer)((0, _reactRedux.connect)(mapStateToProps)(MobileNav), {
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/MobileNav/__generated__/MobileNav_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var MobileNavMenu_viewer = _MobileNavMenu2.default.getFragment('viewer'),
                MobileNavSearchBar_viewer = _MobileNavSearchBar2.default.getFragment('viewer'),
                MessageBanner_viewer = _MessageBanner2.default.getFragment('viewer');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    kind: 'RootArgument',
                    name: 'showMarketingMessages'
                }],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(MobileNavMenu_viewer), RelayQL_GENERATED.__frag(MobileNavSearchBar_viewer), {
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, RelayQL_GENERATED.__frag(MessageBanner_viewer)]),
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'showMarketingMessages'
                                    }
                                }]
                            }],
                            id: RelayQL_GENERATED.__id(),
                            kind: 'Fragment',
                            metadata: {},
                            name: 'Viewer',
                            type: 'Viewer'
                        }]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MobileNav_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    },
    user: {
        modern: function modern() {
            return __webpack_require__("./src/components/MobileNav/__generated__/MobileNav_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var MobileNavMenu_user = _MobileNavMenu2.default.getFragment('user'),
                MobileNavHeader_user = _MobileNavHeader2.default.getFragment('user'),
                MessageBanner_user = _MessageBanner2.default.getFragment('user');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    kind: 'RootArgument',
                    name: 'showMarketingMessages'
                }],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(MobileNavMenu_user), RelayQL_GENERATED.__frag(MobileNavHeader_user), {
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, RelayQL_GENERATED.__frag(MessageBanner_user)]),
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'showMarketingMessages'
                                    }
                                }]
                            }],
                            id: RelayQL_GENERATED.__id(),
                            kind: 'Fragment',
                            metadata: {},
                            name: 'User',
                            type: 'User'
                        }]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MobileNav_user',
                        type: 'User'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/MobileNav/MobileNavAnimations/MobileNavAnimationSlide.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactTransitionGroup = __webpack_require__("./node_modules/react-transition-group/index.js");

var _mobileNavAnimations = __webpack_require__("./src/components/MobileNav/MobileNavAnimations/mobileNavAnimations.scss");

var _mobileNavAnimations2 = _interopRequireDefault(_mobileNavAnimations);

var _ScrollLock = __webpack_require__("./src/components/MobileNav/ScrollLock.jsx");

var _ScrollLock2 = _interopRequireDefault(_ScrollLock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MobileNavAnimationSlide = function (_React$Component) {
    _inherits(MobileNavAnimationSlide, _React$Component);

    function MobileNavAnimationSlide() {
        _classCallCheck(this, MobileNavAnimationSlide);

        var _this = _possibleConstructorReturn(this, (MobileNavAnimationSlide.__proto__ || Object.getPrototypeOf(MobileNavAnimationSlide)).call(this));

        _this.state = {
            isScrollLocked: false
        };

        _this.lockScroll = _this.toggleScroll.bind(_this, true);
        _this.unlockScroll = _this.toggleScroll.bind(_this, false);
        return _this;
    }

    _createClass(MobileNavAnimationSlide, [{
        key: 'toggleScroll',
        value: function toggleScroll(isScrollLocked) {
            if (this.props.scrollLock) {
                this.setState({
                    isScrollLocked: isScrollLocked
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                appear = _props.appear,
                leave = _props.leave,
                children = _props.children,
                onAnimationEnd = _props.onAnimationEnd;

            var classNames = {
                enter: _mobileNavAnimations2.default[appear + 'Enter'],
                enterActive: _mobileNavAnimations2.default[appear + 'ActiveEnter'],
                exit: _mobileNavAnimations2.default.exit,
                exitActive: _mobileNavAnimations2.default[leave + 'ActiveExit']
            };

            return _react2.default.createElement(
                _ScrollLock2.default,
                { isLocked: this.state.isScrollLocked },
                _react2.default.createElement(
                    _reactTransitionGroup.CSSTransition,
                    {
                        classNames: classNames,
                        timeout: 20000 // addEndListener does the magic, the lib just requires this to be set
                        , 'in': this.props.in,
                        mountOnEnter: true,
                        unmountOnExit: true,
                        onExit: this.unlockScroll,
                        onEntered: this.lockScroll,
                        onExited: onAnimationEnd,
                        addEndListener: function addEndListener(node, done) {
                            // use the css transitionend event to mark the finish of a transition
                            node.addEventListener('transitionend', done, false);
                        }
                    },
                    children
                )
            );
        }
    }]);

    return MobileNavAnimationSlide;
}(_react2.default.Component);

exports.default = MobileNavAnimationSlide;


MobileNavAnimationSlide.defaultProps = {
    appear: 'left',
    leave: 'left',
    onAnimationEnd: function onAnimationEnd() {}
};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavAnimations/mobileNavAnimations.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"leftEnter":"mobileNavAnimations__leftEnter__85eb3bac","rightEnter":"mobileNavAnimations__rightEnter__85eb3bac","exit":"mobileNavAnimations__exit__85eb3bac","leftActiveExit":"mobileNavAnimations__leftActiveExit__85eb3bac","rightActiveEnter":"mobileNavAnimations__rightActiveEnter__85eb3bac","leftActiveEnter":"mobileNavAnimations__leftActiveEnter__85eb3bac","rightActiveExit":"mobileNavAnimations__rightActiveExit__85eb3bac"};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavAuthButtons/MobileNavAuthButtons.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MobileNavAuthButtons = MobileNavAuthButtons;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _Secondary = __webpack_require__("./node_modules/dibs-elements/dist/Button/Secondary.js");

var _Secondary2 = _interopRequireDefault(_Secondary);

__webpack_require__("./node_modules/dibs-elements/dist/Button/buyer/Secondary.css");

var _mobileNavConstants = __webpack_require__("./src/components/MobileNav/utils/mobileNavConstants.js");

var _mobileNavAuthButtonsStyles = __webpack_require__("./src/components/MobileNav/MobileNavAuthButtons/mobileNavAuthButtonsStyles.scss");

var _mobileNavAuthButtonsStyles2 = _interopRequireDefault(_mobileNavAuthButtonsStyles);

var _MobileNavAuthButtonsCopy = __webpack_require__("./src/components/MobileNav/MobileNavAuthButtons/MobileNavAuthButtonsCopy.json");

var _MobileNavAuthButtonsCopy2 = _interopRequireDefault(_MobileNavAuthButtonsCopy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Button(props) {
    return _react2.default.createElement(
        _Secondary2.default,
        { size: 'medium', className: _mobileNavAuthButtonsStyles2.default.button, onClick: function onClick() {
                return props.onAuthClick(props.clickAction);
            } },
        props.text
    );
}

function MobileNavAuthButtons(props) {
    if (props.user) {
        return _react2.default.createElement(
            'div',
            { className: _mobileNavAuthButtonsStyles2.default.container },
            _react2.default.createElement(Button, { text: _MobileNavAuthButtonsCopy2.default.logout, onAuthClick: props.onAuthClick, clickAction: _mobileNavConstants.AUTH_CLICK_LOGOUT })
        );
    } else {
        return _react2.default.createElement(
            'div',
            { className: _mobileNavAuthButtonsStyles2.default.container },
            _react2.default.createElement(Button, { text: _MobileNavAuthButtonsCopy2.default.login, onAuthClick: props.onAuthClick, clickAction: _mobileNavConstants.AUTH_CLICK_LOGIN }),
            _react2.default.createElement(Button, { text: _MobileNavAuthButtonsCopy2.default.register, onAuthClick: props.onAuthClick, clickAction: _mobileNavConstants.AUTH_CLICK_REGISTER })
        );
    }
}

exports.default = (0, _reactRelay.createFragmentContainer)(MobileNavAuthButtons, {
    user: {
        modern: function modern() {
            return __webpack_require__("./src/components/MobileNav/MobileNavAuthButtons/__generated__/MobileNavAuthButtons_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MobileNavAuthButtons_user',
                        type: 'User'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/MobileNav/MobileNavAuthButtons/MobileNavAuthButtonsCopy.json":
/***/ (function(module, exports) {

module.exports = {"logout":"Logout","login":"Login","register":"Register"}

/***/ }),

/***/ "./src/components/MobileNav/MobileNavAuthButtons/__generated__/MobileNavAuthButtons_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MobileNavAuthButtons_user = {|
  +serviceId: ?string;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileNavAuthButtons_user",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "serviceId",
    "storageKey": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MobileNav/MobileNavAuthButtons/mobileNavAuthButtonsStyles.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mobileNavAuthButtonsStyles__container__df610608","button":"mobileNavAuthButtonsStyles__button__df610608"};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavDisplayAmount/MobileNavDisplayAmount.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = MobileNavDisplayAmount;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MobileNavDisplayAmount(props) {
    var isMax = props.amount > props.max;
    var amount = isMax ? props.max : props.amount;
    return _react2.default.createElement(
        'span',
        { className: props.className },
        amount,
        isMax && _react2.default.createElement(
            'sup',
            null,
            '+'
        )
    );
}

MobileNavDisplayAmount.defaultProps = {
    className: '',
    max: 99
};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavDrawer/MobileNavDrawer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _MobileNavDrawer = __webpack_require__("./src/components/MobileNav/MobileNavDrawer/MobileNavDrawer.scss");

var _MobileNavDrawer2 = _interopRequireDefault(_MobileNavDrawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DURATION_SCROLL_DATA_RESET = 250;
var PIXELS_SCROLL_DISTANCE = 50;
var PIXELS_FORCE_APPEAR = 100;

var MobileNavDrawer = function (_React$Component) {
    _inherits(MobileNavDrawer, _React$Component);

    function MobileNavDrawer() {
        _classCallCheck(this, MobileNavDrawer);

        var _this = _possibleConstructorReturn(this, (MobileNavDrawer.__proto__ || Object.getPrototypeOf(MobileNavDrawer)).call(this));

        _this.state = {
            isOpen: true
        };

        _this.scroll = {
            last: 0,
            distance: 0
        };
        _this.rafTick = null;
        _this.resetTimeout = null;

        _this.onScroll = _this.onScroll.bind(_this);
        return _this;
    }

    _createClass(MobileNavDrawer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('scroll', this.onScroll);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('scroll', this.onScroll);
        }
    }, {
        key: 'getScrollY',
        value: function getScrollY() {
            return Math.round(window.pageYOffset);
        }
    }, {
        key: 'resetScrollData',
        value: function resetScrollData() {
            this.scroll = {
                last: 0,
                distance: 0
            };
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            var _this2 = this;

            if (!this.rafTick && !this.props.disabled) {
                this.rafTick = requestAnimationFrame(function () {
                    var currentScroll = _this2.getScrollY();
                    var scrollData = _this2.scroll;

                    if (scrollData.last === 0) {
                        scrollData.last = currentScroll;
                    }

                    // Number of pixels scrolled.
                    var scrollDelta = scrollData.last - currentScroll;
                    // Total distance scrolled since the first scroll event has been captured.
                    var scrollDistance = scrollData.distance += scrollDelta;
                    var forceOpen = currentScroll <= PIXELS_FORCE_APPEAR;
                    var shouldClose = !forceOpen && scrollDistance < -PIXELS_SCROLL_DISTANCE;
                    var shouldOpen = scrollDistance > PIXELS_SCROLL_DISTANCE || forceOpen;
                    if (!_this2.state.isOpen && shouldOpen) {
                        _this2.setState({
                            isOpen: true
                        });
                    } else if (_this2.state.isOpen && shouldClose && !shouldOpen) {
                        _this2.setState({
                            isOpen: false
                        });
                    }

                    scrollData.last = currentScroll;
                    _this2.rafTick = null;

                    /**
                     * We mimick a scroll start event by reseting the scroll state if a scroll event hasn't been captured
                     * for a specified amount of time.
                     */
                    clearTimeout(_this2.resetTimeout);
                    _this2.resetTimeout = setTimeout(function () {
                        return _this2.resetScrollData();
                    }, DURATION_SCROLL_DATA_RESET);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var isOpen = this.state.isOpen;

            var classes = (0, _classnames3.default)(this.props.className, (_classnames = {}, _defineProperty(_classnames, _MobileNavDrawer2.default.slideIn, isOpen), _defineProperty(_classnames, _MobileNavDrawer2.default.slideOut, !isOpen), _classnames));

            return _react2.default.createElement(
                'div',
                { className: classes },
                this.props.children
            );
        }
    }]);

    return MobileNavDrawer;
}(_react2.default.Component);

exports.default = MobileNavDrawer;

/***/ }),

/***/ "./src/components/MobileNav/MobileNavDrawer/MobileNavDrawer.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"slideIn":"MobileNavDrawer__slideIn__e0ea7acc","slideOut":"MobileNavDrawer__slideOut__e0ea7acc"};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavDrilldown/MobileNavDrilldown.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = MobileNavDrilldown;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _mobileNavDrilldown = __webpack_require__("./src/components/MobileNav/MobileNavDrilldown/mobileNavDrilldown.scss");

var _mobileNavDrilldown2 = _interopRequireDefault(_mobileNavDrilldown);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _arrowLeft = __webpack_require__("./node_modules/dibs-vg/dist/react/arrow-left.js");

var _arrowLeft2 = _interopRequireDefault(_arrowLeft);

var _MobileNavDrilldownList = __webpack_require__("./src/components/MobileNav/MobileNavDrilldown/MobileNavDrilldownList.jsx");

var _MobileNavDrilldownList2 = _interopRequireDefault(_MobileNavDrilldownList);

var _mobileNavDrilldownCopy = __webpack_require__("./src/components/MobileNav/MobileNavDrilldown/mobileNavDrilldownCopy.json");

var _mobileNavDrilldownCopy2 = _interopRequireDefault(_mobileNavDrilldownCopy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MobileNavDrilldown(props) {
    var className = props.className,
        onItemClick = props.onItemClick,
        onBackClick = props.onBackClick;

    var containerClass = (0, _classnames2.default)(_mobileNavDrilldown2.default.container, className);

    return _react2.default.createElement(
        'div',
        { className: containerClass },
        _react2.default.createElement(
            'div',
            { className: _mobileNavDrilldown2.default.back, onClick: onBackClick },
            _react2.default.createElement(_arrowLeft2.default, { className: _mobileNavDrilldown2.default.backIcon }),
            _react2.default.createElement(
                'span',
                null,
                _mobileNavDrilldownCopy2.default.back
            )
        ),
        props.sections.map(function (module) {
            return _react2.default.createElement(
                'div',
                { key: module.name },
                _react2.default.createElement(
                    'div',
                    { className: _mobileNavDrilldown2.default.title },
                    module.name
                ),
                _react2.default.createElement(_MobileNavDrilldownList2.default, {
                    key: module.name,
                    onItemClick: onItemClick,
                    items: module.items
                })
            );
        })
    );
}

/***/ }),

/***/ "./src/components/MobileNav/MobileNavDrilldown/MobileNavDrilldownList.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _MobileNavDrilldownList = __webpack_require__("./src/components/MobileNav/MobileNavDrilldown/MobileNavDrilldownList.scss");

var _MobileNavDrilldownList2 = _interopRequireDefault(_MobileNavDrilldownList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checks if it's possible to format numbers using the new-ish Intl API that browsers provide. In the future we might
 * have a polyfill. This isn't and should not be rendered on the server, so there's no worries of content mismatch.
 */
function formatNumber(number) {
    if (typeof Intl !== 'undefined' && typeof number === 'number') {
        return new Intl.NumberFormat().format(number);
    } else {
        return number;
    }
}

function MobileNavDrilldownList(props) {
    return _react2.default.createElement(
        'div',
        null,
        props.items.map(function (item) {
            var formattedCount = formatNumber(item.count);
            var name = item.name,
                url = item.url;

            var path = item.path || url;
            return _react2.default.createElement(
                'div',
                { onClick: function onClick() {
                        return props.onItemClick({ path: path, name: name });
                    }, className: _MobileNavDrilldownList2.default.item, key: item.name },
                _react2.default.createElement(
                    'span',
                    null,
                    item.name
                ),
                !!item.count && _react2.default.createElement(
                    'span',
                    { className: _MobileNavDrilldownList2.default.count },
                    formattedCount
                )
            );
        })
    );
}

exports.default = MobileNavDrilldownList;

/***/ }),

/***/ "./src/components/MobileNav/MobileNavDrilldown/MobileNavDrilldownList.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"item":"MobileNavDrilldownList__item__4630a8ee","count":"MobileNavDrilldownList__count__4630a8ee"};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavDrilldown/mobileNavDrilldown.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mobileNavDrilldown__container__1862c24c","title":"mobileNavDrilldown__title__1862c24c","back":"mobileNavDrilldown__back__1862c24c","backIcon":"mobileNavDrilldown__backIcon__1862c24c"};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavDrilldown/mobileNavDrilldownCopy.json":
/***/ (function(module, exports) {

module.exports = {"back":"Back"}

/***/ }),

/***/ "./src/components/MobileNav/MobileNavHeader/MobileNavHeader.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MobileNavHeader = MobileNavHeader;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _classnames3 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames4 = _interopRequireDefault(_classnames3);

var _mobileNavHeader = __webpack_require__("./src/components/MobileNav/MobileNavHeader/mobileNavHeader.scss");

var _mobileNavHeader2 = _interopRequireDefault(_mobileNavHeader);

var _hamburgerMenu = __webpack_require__("./node_modules/dibs-vg/dist/react/hamburger-menu.js");

var _hamburgerMenu2 = _interopRequireDefault(_hamburgerMenu);

var _logo = __webpack_require__("./node_modules/dibs-vg/dist/react/logo.js");

var _logo2 = _interopRequireDefault(_logo);

var _close = __webpack_require__("./node_modules/dibs-vg/dist/react/close.js");

var _close2 = _interopRequireDefault(_close);

var _MobileNavFavorite = __webpack_require__("./src/components/MobileNav/MobileNavIcons/MobileNavFavorite.jsx");

var _MobileNavFavorite2 = _interopRequireDefault(_MobileNavFavorite);

var _MobileNavCartContainer = __webpack_require__("./src/components/MobileNav/MobileNavIcons/MobileNavCartContainer.jsx");

var _MobileNavCartContainer2 = _interopRequireDefault(_MobileNavCartContainer);

var _MobileNavDisplayAmount = __webpack_require__("./src/components/MobileNav/MobileNavDisplayAmount/MobileNavDisplayAmount.jsx");

var _MobileNavDisplayAmount2 = _interopRequireDefault(_MobileNavDisplayAmount);

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AMOUNT_MAX_MESSAGES = 99;

function MobileNavHeader(props) {
    var useCloseIcon = props.useCloseIcon,
        user = props.user,
        isUserTypeTrade = props.isUserTypeTrade;

    var isUserTrade = isUserTypeTrade || (0, _lodash2.default)(user, 'isVerifiedTrade');
    var iconClass = (0, _classnames4.default)(_mobileNavHeader2.default.actionIcon, _defineProperty({}, _mobileNavHeader2.default.closeIcon, useCloseIcon));
    var containerClass = (0, _classnames4.default)(_mobileNavHeader2.default.container, _defineProperty({}, _mobileNavHeader2.default.isTrade, isUserTrade));
    var Icon = useCloseIcon ? _close2.default : _hamburgerMenu2.default;
    var unreadMessageCount = (0, _lodash2.default)(user, 'conversationSummary.totalUnreadConversationCount') || 0;
    var showUnreadMessageCount = !!unreadMessageCount && !useCloseIcon;
    return _react2.default.createElement(
        'div',
        { className: containerClass },
        _react2.default.createElement(
            'div',
            { className: _mobileNavHeader2.default.icon, onClick: props.onActionClick },
            showUnreadMessageCount && _react2.default.createElement(
                'i',
                { className: _mobileNavHeader2.default.messages },
                _react2.default.createElement(_MobileNavDisplayAmount2.default, {
                    className: _mobileNavHeader2.default.messagesCount,
                    amount: unreadMessageCount,
                    max: AMOUNT_MAX_MESSAGES
                })
            ),
            _react2.default.createElement(Icon, { className: iconClass })
        ),
        _react2.default.createElement(
            'div',
            { className: _mobileNavHeader2.default.logoContainer, onClick: props.handleNavigateAction },
            _react2.default.createElement(_logo2.default, { className: _mobileNavHeader2.default.logo }),
            isUserTrade && _react2.default.createElement(
                'div',
                { className: _mobileNavHeader2.default.trade },
                'TRADE'
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _mobileNavHeader2.default.iconWrapper },
            _react2.default.createElement(_MobileNavFavorite2.default, { onClick: props.handleNavigateAction, className: _mobileNavHeader2.default.icon }),
            _react2.default.createElement(_MobileNavCartContainer2.default, { onClick: props.handleNavigateAction,
                user: props.user,
                className: _mobileNavHeader2.default.icon
            })
        )
    );
}

MobileNavHeader.defaultProps = {
    onActionClick: function onActionClick() {},
    handleNavigateAction: function handleNavigateAction() {}
};

function mapStateToProps(state) {
    return {
        isUserTypeTrade: state.header.isUserTypeTrade
    };
}

exports.default = (0, _reactRelay.createFragmentContainer)((0, _reactRedux.connect)(mapStateToProps)(MobileNavHeader), {
    user: {
        modern: function modern() {
            return __webpack_require__("./src/components/MobileNav/MobileNavHeader/__generated__/MobileNavHeader_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var MobileNavCartContainer_user = _MobileNavCartContainer2.default.getFragment('user');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'isVerifiedTrade',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            children: [{
                                fieldName: 'totalUnreadConversationCount',
                                kind: 'Field',
                                metadata: {},
                                type: 'Int'
                            }],
                            fieldName: 'conversationSummary',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Summary'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(MobileNavCartContainer_user)]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MobileNavHeader_user',
                        type: 'User'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/MobileNav/MobileNavHeader/__generated__/MobileNavHeader_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MobileNavHeader_user = {|
  +isVerifiedTrade: ?boolean;
  +conversationSummary: ?{|
    +totalUnreadConversationCount: ?number;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileNavHeader_user",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "isVerifiedTrade",
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Summary",
    "name": "conversationSummary",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "totalUnreadConversationCount",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "MobileNavCartContainer_user",
    "args": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MobileNav/MobileNavHeader/mobileNavHeader.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mobileNavHeader__container__3c79aac","isTrade":"mobileNavHeader__isTrade__3c79aac","actionIcon":"mobileNavHeader__actionIcon__3c79aac","closeIcon":"mobileNavHeader__closeIcon__3c79aac","logoContainer":"mobileNavHeader__logoContainer__3c79aac","logo":"mobileNavHeader__logo__3c79aac","iconWrapper":"mobileNavHeader__iconWrapper__3c79aac","icon":"mobileNavHeader__icon__3c79aac","trade":"mobileNavHeader__trade__3c79aac","messages":"mobileNavHeader__messages__3c79aac","messagesCount":"mobileNavHeader__messagesCount__3c79aac"};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavIcons/MobileNavCart.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = MobileNavCart;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _cartOpen = __webpack_require__("./node_modules/dibs-vg/dist/react/cart-open.js");

var _cartOpen2 = _interopRequireDefault(_cartOpen);

var _mobileNavIcons = __webpack_require__("./src/components/MobileNav/MobileNavIcons/mobileNavIcons.scss");

var _mobileNavIcons2 = _interopRequireDefault(_mobileNavIcons);

var _MobileNavDisplayAmount = __webpack_require__("./src/components/MobileNav/MobileNavDisplayAmount/MobileNavDisplayAmount.jsx");

var _MobileNavDisplayAmount2 = _interopRequireDefault(_MobileNavDisplayAmount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The maximum amount of cart items to display. We just append a plus sign if it's bigger than this number.
var MAX_CART_COUNT = 9;
var URL_PATH_CART = '/my/cart/';

function MobileNavCart(props) {
    return _react2.default.createElement(
        'a',
        { className: _mobileNavIcons2.default.container, onClick: function onClick() {
                return props.onClick({ path: URL_PATH_CART });
            } },
        !!props.cartItemCount && _react2.default.createElement(_MobileNavDisplayAmount2.default, { amount: props.cartItemCount, className: _mobileNavIcons2.default.count, max: MAX_CART_COUNT }),
        _react2.default.createElement(_cartOpen2.default, { className: _mobileNavIcons2.default.icon })
    );
}

/***/ }),

/***/ "./src/components/MobileNav/MobileNavIcons/MobileNavCartContainer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _cartActions = __webpack_require__("./src/actions/cartActions.js");

var _MobileNavCart = __webpack_require__("./src/components/MobileNav/MobileNavIcons/MobileNavCart.jsx");

var _MobileNavCart2 = _interopRequireDefault(_MobileNavCart);

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _AddCartItemMutation = __webpack_require__("./src/mutations/AddCartItemMutation.js");

var _AddCartItemMutation2 = _interopRequireDefault(_AddCartItemMutation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MobileNavCartContainer = function (_React$Component) {
    _inherits(MobileNavCartContainer, _React$Component);

    function MobileNavCartContainer() {
        _classCallCheck(this, MobileNavCartContainer);

        return _possibleConstructorReturn(this, (MobileNavCartContainer.__proto__ || Object.getPrototypeOf(MobileNavCartContainer)).apply(this, arguments));
    }

    _createClass(MobileNavCartContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.dispatch((0, _cartActions.loadLocalCart)());
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var cartItems = nextProps.cartItems,
                dispatch = nextProps.dispatch,
                relay = nextProps.relay,
                user = nextProps.user;

            if (user && cartItems.length) {
                _AddCartItemMutation2.default.commit(relay.environment, {
                    itemIds: cartItems.map(function (c) {
                        return c.id;
                    }),
                    onCompleted: function onCompleted(res, errors) {
                        if (errors) {
                            return;
                        }
                        dispatch((0, _cartActions.consolidateCart)({ res: res, cartItems: cartItems }));
                    },
                    onError: function onError(error) {
                        console.error(error);
                    }
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                serviceCart = _props.serviceCart,
                cartItems = _props.cartItems,
                onClick = _props.onClick;

            var cartItemCount = cartItems.length || serviceCart.length;
            return _react2.default.createElement(_MobileNavCart2.default, { onClick: onClick, cartItemCount: cartItemCount });
        }
    }]);

    return MobileNavCartContainer;
}(_react2.default.Component);

MobileNavCartContainer = (0, _reactRedux.connect)(function (state, props) {
    var cartItems = (0, _lodash2.default)(state, 'cart.items', []);
    var serviceCart = (0, _lodash2.default)(props, 'user.cart.items') || [];

    return {
        cartItems: cartItems,
        serviceCart: serviceCart
    };
})(MobileNavCartContainer);

exports.default = (0, _reactRelay.createFragmentContainer)(MobileNavCartContainer, {
    user: {
        modern: function modern() {
            return __webpack_require__("./src/components/MobileNav/MobileNavIcons/__generated__/MobileNavCartContainer_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            children: [{
                                children: [{
                                    children: [{
                                        fieldName: 'itemId',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }],
                                    fieldName: 'item',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true
                                    },
                                    type: 'ItemSummary'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'items',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isPlural: true
                                },
                                type: 'PortfolioItemV1'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'cart',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'PortfolioV1'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MobileNavCartContainer_user',
                        type: 'User'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/MobileNav/MobileNavIcons/MobileNavFavorite.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = MobileNavFavorite;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _heartOutlined = __webpack_require__("./node_modules/dibs-vg/dist/react/heart-outlined.js");

var _heartOutlined2 = _interopRequireDefault(_heartOutlined);

var _mobileNavIcons = __webpack_require__("./src/components/MobileNav/MobileNavIcons/mobileNavIcons.scss");

var _mobileNavIcons2 = _interopRequireDefault(_mobileNavIcons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var URL_PATH_FAVORITES = '/favorites/items/';

function MobileNavFavorite(props) {
    return _react2.default.createElement(
        'a',
        { className: props.className, onClick: function onClick() {
                return props.onClick({ path: URL_PATH_FAVORITES });
            } },
        _react2.default.createElement(_heartOutlined2.default, { className: _mobileNavIcons2.default.icon + ' ' + _mobileNavIcons2.default.favorite })
    );
}

/***/ }),

/***/ "./src/components/MobileNav/MobileNavIcons/__generated__/MobileNavCartContainer_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MobileNavCartContainer_user = {|
  +cart: ?{|
    +items: ?$ReadOnlyArray<?{|
      +item: ?{|
        +itemId: ?string;
      |};
    |}>;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileNavCartContainer_user",
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "PortfolioV1",
    "name": "cart",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "PortfolioItemV1",
      "name": "items",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "ItemSummary",
        "name": "item",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "itemId",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MobileNav/MobileNavIcons/mobileNavIcons.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"mobileNavIcons__icon__a4365a2c","favorite":"mobileNavIcons__favorite__a4365a2c","container":"mobileNavIcons__container__a4365a2c","count":"mobileNavIcons__count__a4365a2c"};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavMenu/MobileNavMenu.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _OverlayView = __webpack_require__("./src/components/MobileNav/OverlayView/OverlayView.jsx");

var _OverlayView2 = _interopRequireDefault(_OverlayView);

var _MobileNavMenuBody = __webpack_require__("./src/components/MobileNav/MobileNavMenu/MobileNavMenuBody.jsx");

var _MobileNavMenuBody2 = _interopRequireDefault(_MobileNavMenuBody);

var _MobileNavDrilldown = __webpack_require__("./src/components/MobileNav/MobileNavDrilldown/MobileNavDrilldown.jsx");

var _MobileNavDrilldown2 = _interopRequireDefault(_MobileNavDrilldown);

var _MobileNavAnimationSlide = __webpack_require__("./src/components/MobileNav/MobileNavAnimations/MobileNavAnimationSlide.jsx");

var _MobileNavAnimationSlide2 = _interopRequireDefault(_MobileNavAnimationSlide);

var _mobileNavMenu = __webpack_require__("./src/components/MobileNav/MobileNavMenu/mobileNavMenu.scss");

var _mobileNavMenu2 = _interopRequireDefault(_mobileNavMenu);

var _mobileNavMenuCopy = __webpack_require__("./src/components/MobileNav/MobileNavMenu/mobileNavMenuCopy.json");

var _mobileNavMenuCopy2 = _interopRequireDefault(_mobileNavMenuCopy);

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var messagesSection = {
    name: 'Messages',
    path: '/my/conversations/'
};

var ordersSection = {
    name: 'Orders',
    path: '/my/orders/'
};

var accountSection = {
    name: 'Account Information',
    path: '/my/account/'
};

function getVerticalData(navModule) {
    var categories = navModule.categories,
        name = navModule.name,
        path = navModule.url;

    var totalCount = categories.map(function (category) {
        return category.count;
    }).reduce(function (prevCount, currCount) {
        return prevCount + currCount;
    });

    var topItem = {
        name: _mobileNavMenuCopy2.default.seeAll + ' ' + name,
        count: totalCount,
        path: path
    };

    var items = categories.map(function (category) {
        return {
            name: category.name,
            count: category.count,
            path: '' + path + category.label + '/'
        };
    });

    items.unshift(topItem);

    return [{ items: items, name: name }];
}

function getNonVerticalData(navModule) {
    return navModule.items.filter(function (item) {
        return item.visible && item.type === 'primary';
    });
}

function getModuleIdentifier(module) {
    return module.name.toLowerCase();
}

function findModuleByIdentifier(modules, identifier) {
    return modules.find(function (module) {
        return getModuleIdentifier(module) === identifier;
    });
}

var MobileNavMenu = function (_React$Component) {
    _inherits(MobileNavMenu, _React$Component);

    function MobileNavMenu() {
        _classCallCheck(this, MobileNavMenu);

        var _this = _possibleConstructorReturn(this, (MobileNavMenu.__proto__ || Object.getPrototypeOf(MobileNavMenu)).call(this));

        _this.onMainMenuItemClick = _this.onMainMenuItemClick.bind(_this);
        _this.onBackClick = _this.onBackClick.bind(_this);

        _this.state = {
            activeDrilldown: null,
            isDrilldownOpen: false
        };
        return _this;
    }

    _createClass(MobileNavMenu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.getNavModules().length === 0) {
                this.props.relay.refetch();
            }
        }
    }, {
        key: 'onMainMenuItemClick',
        value: function onMainMenuItemClick(menuItem) {
            var module = findModuleByIdentifier(this.getNavModules(), getModuleIdentifier(menuItem));

            /**
             * If there's no module found, we assume that the drilldown shouldn't be actived and we just fire the click
             * handler.
             */
            if (module) {
                var drilldownSectionData = module.isVertical ? getVerticalData(module) : getNonVerticalData(module);

                this.setState({
                    isDrilldownOpen: true,
                    drilldownSectionData: drilldownSectionData
                });
            } else {
                this.props.handleNavigateAction(menuItem);
            }
        }
    }, {
        key: 'getNavModules',
        value: function getNavModules() {
            return (0, _lodash2.default)(this.props.viewer, 'navigation.modules') || [];
        }
    }, {
        key: 'onBackClick',
        value: function onBackClick() {
            this.setState({
                isDrilldownOpen: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                isDrilldownOpen = _state.isDrilldownOpen,
                drilldownSectionData = _state.drilldownSectionData;
            var _props = this.props,
                onAuthClick = _props.onAuthClick,
                user = _props.user;

            var accountSections = [Object.assign({}, messagesSection, {
                count: (0, _lodash2.default)(user, 'conversationSummary.totalUnreadConversationCount') || 0
            }), ordersSection, accountSection];
            var categoriesSections = this.getNavModules();
            var categoriesSection = {
                title: _mobileNavMenuCopy2.default.categories,
                items: categoriesSections
            };
            var sections = [categoriesSection, {
                title: _mobileNavMenuCopy2.default.account,
                items: user ? accountSections : []
            }];

            return _react2.default.createElement(
                _OverlayView2.default,
                { className: _mobileNavMenu2.default.container + ' ' + _mobileNavMenu2.default.isOpen },
                _react2.default.createElement(
                    'div',
                    { className: _mobileNavMenu2.default.bodyContainer },
                    _react2.default.createElement(
                        _MobileNavAnimationSlide2.default,
                        { 'in': !isDrilldownOpen },
                        _react2.default.createElement(_MobileNavMenuBody2.default, {
                            user: user,
                            onAuthClick: onAuthClick,
                            className: _mobileNavMenu2.default.bodyItem,
                            onItemClick: this.onMainMenuItemClick,
                            sections: sections
                        })
                    ),
                    _react2.default.createElement(
                        _MobileNavAnimationSlide2.default,
                        { 'in': isDrilldownOpen, leave: 'right', appear: 'right' },
                        _react2.default.createElement(_MobileNavDrilldown2.default, {
                            onBackClick: this.onBackClick,
                            sections: drilldownSectionData || [],
                            onItemClick: this.props.handleNavigateAction
                        })
                    )
                )
            );
        }
    }]);

    return MobileNavMenu;
}(_react2.default.Component);

;

exports.default = (0, _reactRelay.createRefetchContainer)(MobileNavMenu, {
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/MobileNav/MobileNavMenu/__generated__/MobileNavMenu_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            children: [{
                                children: [{
                                    fieldName: 'name',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    fieldName: 'isVertical',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'Boolean'
                                }, {
                                    fieldName: 'url',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    children: [{
                                        fieldName: 'visible',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'Boolean'
                                    }, {
                                        fieldName: 'type',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'name',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        children: [{
                                            fieldName: 'name',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'String'
                                        }, {
                                            fieldName: 'url',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'String'
                                        }, {
                                            fieldName: 'id',
                                            kind: 'Field',
                                            metadata: {
                                                isGenerated: true,
                                                isRequisite: true
                                            },
                                            type: 'ID'
                                        }],
                                        fieldName: 'items',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            inferredRootCallName: 'node',
                                            inferredPrimaryKey: 'id',
                                            isPlural: true
                                        },
                                        type: 'NavigationItem'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'items',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        inferredRootCallName: 'node',
                                        inferredPrimaryKey: 'id',
                                        isPlural: true
                                    },
                                    type: 'NavigationTopLevel'
                                }, {
                                    children: [{
                                        fieldName: 'name',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'count',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'Int'
                                    }, {
                                        fieldName: 'label',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'categories',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        inferredRootCallName: 'node',
                                        inferredPrimaryKey: 'id',
                                        isPlural: true
                                    },
                                    type: 'NavigationModuleCategories'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'modules',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isPlural: true
                                },
                                type: 'NavigationModule'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'navigation',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'Navigation'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MobileNavMenu_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    },
    user: {
        modern: function modern() {
            return __webpack_require__("./src/components/MobileNav/MobileNavMenu/__generated__/MobileNavMenu_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var MobileNavMenuBody_user = _MobileNavMenuBody2.default.getFragment('user');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            children: [{
                                fieldName: 'totalUnreadConversationCount',
                                kind: 'Field',
                                metadata: {},
                                type: 'Int'
                            }],
                            fieldName: 'conversationSummary',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Summary'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(MobileNavMenuBody_user)]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MobileNavMenu_user',
                        type: 'User'
                    };
                }()
            };
        }
    }
}, {
    modern: function modern() {
        return __webpack_require__("./src/components/MobileNav/MobileNavMenu/__generated__/MobileNavMenuRefetchQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var MobileNavMenu_viewer = (MobileNavMenu.__container__ || MobileNavMenu).getFragment('viewer');
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [],
            name: 'MobileNavMenuRefetchQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(MobileNavMenu_viewer)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'MobileNavMenuRefetchQuery',
                    type: 'Query'
                };
            }()
        };
    }
});

/***/ }),

/***/ "./src/components/MobileNav/MobileNavMenu/MobileNavMenuBody.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _mobileNavMenuBody = __webpack_require__("./src/components/MobileNav/MobileNavMenu/mobileNavMenuBody.scss");

var _mobileNavMenuBody2 = _interopRequireDefault(_mobileNavMenuBody);

var _MobileNavAuthButtons = __webpack_require__("./src/components/MobileNav/MobileNavAuthButtons/MobileNavAuthButtons.jsx");

var _MobileNavAuthButtons2 = _interopRequireDefault(_MobileNavAuthButtons);

var _MobileNavDrilldownList = __webpack_require__("./src/components/MobileNav/MobileNavDrilldown/MobileNavDrilldownList.jsx");

var _MobileNavDrilldownList2 = _interopRequireDefault(_MobileNavDrilldownList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MobileNavMenuBody(props) {
    return _react2.default.createElement(
        'div',
        { className: props.className },
        props.sections.map(function (section) {
            return _react2.default.createElement(
                'div',
                { key: section.title },
                _react2.default.createElement(
                    'div',
                    { className: _mobileNavMenuBody2.default.item + ' ' + _mobileNavMenuBody2.default.sectionTitle },
                    section.title
                ),
                _react2.default.createElement(_MobileNavDrilldownList2.default, { items: section.items, onItemClick: props.onItemClick })
            );
        }),
        _react2.default.createElement(_MobileNavAuthButtons2.default, { user: props.user, onAuthClick: props.onAuthClick })
    );
}

MobileNavMenuBody.defaultProps = {
    className: ''
};

exports.default = (0, _reactRelay.createFragmentContainer)(MobileNavMenuBody, {
    user: {
        modern: function modern() {
            return __webpack_require__("./src/components/MobileNav/MobileNavMenu/__generated__/MobileNavMenuBody_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var MobileNavAuthButtons_user = _MobileNavAuthButtons2.default.getFragment('user');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(MobileNavAuthButtons_user)]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MobileNavMenuBody_user',
                        type: 'User'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/MobileNav/MobileNavMenu/__generated__/MobileNavMenuBody_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MobileNavMenuBody_user = {| |};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileNavMenuBody_user",
  "selections": [{
    "kind": "FragmentSpread",
    "name": "MobileNavAuthButtons_user",
    "args": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MobileNav/MobileNavMenu/__generated__/MobileNavMenuRefetchQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 438c96bc93a9b96b3488bc216bf5111c
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type MobileNavMenuRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query MobileNavMenuRefetchQuery {
  viewer {
    ...MobileNavMenu_viewer
    id
  }
}

fragment MobileNavMenu_viewer on Viewer {
  navigation {
    modules {
      name
      isVertical
      url
      items {
        visible
        type
        name
        items {
          name
          url
          id
        }
        id
      }
      categories {
        name
        count
        label
        id
      }
      id
    }
    id
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MobileNavMenuRefetchQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "MobileNavMenu_viewer",
        "args": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "MobileNavMenuRefetchQuery",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "MobileNavMenuRefetchQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Navigation",
        "name": "navigation",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "NavigationModule",
          "name": "modules",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isVertical",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "url",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "NavigationTopLevel",
            "name": "items",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "visible",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "type",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "NavigationItem",
              "name": "items",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "url",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "NavigationModuleCategories",
            "name": "categories",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "count",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "label",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query MobileNavMenuRefetchQuery {\n  viewer {\n    ...MobileNavMenu_viewer\n    id\n  }\n}\n\nfragment MobileNavMenu_viewer on Viewer {\n  navigation {\n    modules {\n      name\n      isVertical\n      url\n      items {\n        visible\n        type\n        name\n        items {\n          name\n          url\n          id\n        }\n        id\n      }\n      categories {\n        name\n        count\n        label\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/MobileNav/MobileNavMenu/__generated__/MobileNavMenu_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MobileNavMenu_user = {|
  +conversationSummary: ?{|
    +totalUnreadConversationCount: ?number;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileNavMenu_user",
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Summary",
    "name": "conversationSummary",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "totalUnreadConversationCount",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "FragmentSpread",
    "name": "MobileNavMenuBody_user",
    "args": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MobileNav/MobileNavMenu/__generated__/MobileNavMenu_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MobileNavMenu_viewer = {|
  +navigation: ?{|
    +modules: ?$ReadOnlyArray<?{|
      +name: ?string;
      +isVertical: ?boolean;
      +url: ?string;
      +items: ?$ReadOnlyArray<?{|
        +visible: ?boolean;
        +type: ?string;
        +name: ?string;
        +items: ?$ReadOnlyArray<?{|
          +name: ?string;
          +url: ?string;
        |}>;
      |}>;
      +categories: ?$ReadOnlyArray<?{|
        +name: ?string;
        +count: ?number;
        +label: ?string;
      |}>;
    |}>;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileNavMenu_viewer",
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Navigation",
    "name": "navigation",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "NavigationModule",
      "name": "modules",
      "plural": true,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "name",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "isVertical",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "url",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "NavigationTopLevel",
        "name": "items",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "visible",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "type",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "NavigationItem",
          "name": "items",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "url",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "NavigationModuleCategories",
        "name": "categories",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "count",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "label",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MobileNav/MobileNavMenu/mobileNavMenu.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mobileNavMenu__container__e10f4aac","isOpen":"mobileNavMenu__isOpen__e10f4aac","bodyContainer":"mobileNavMenu__bodyContainer__e10f4aac","bodyItem":"mobileNavMenu__bodyItem__e10f4aac"};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavMenu/mobileNavMenuBody.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"item":"mobileNavMenuBody__item__59a3c75c","sectionTitle":"mobileNavMenuBody__sectionTitle__59a3c75c","sectionItem":"mobileNavMenuBody__sectionItem__59a3c75c"};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavMenu/mobileNavMenuCopy.json":
/***/ (function(module, exports) {

module.exports = {"account":"Account","categories":"Categories","seeAll":"See all"}

/***/ }),

/***/ "./src/components/MobileNav/MobileNavSearchBar/MobileNavSearchBar.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _MobileNavSearchInput = __webpack_require__("./src/components/MobileNav/MobileNavSearchInput/MobileNavSearchInput.jsx");

var _MobileNavSearchInput2 = _interopRequireDefault(_MobileNavSearchInput);

var _MobileNavSearchResults = __webpack_require__("./src/components/MobileNav/MobileNavSearchResults/MobileNavSearchResults.jsx");

var _MobileNavSearchResults2 = _interopRequireDefault(_MobileNavSearchResults);

var _OverlayView = __webpack_require__("./src/components/MobileNav/OverlayView/OverlayView.jsx");

var _OverlayView2 = _interopRequireDefault(_OverlayView);

var _mobileNavSearchBar = __webpack_require__("./src/components/MobileNav/MobileNavSearchBar/mobileNavSearchBar.scss");

var _mobileNavSearchBar2 = _interopRequireDefault(_mobileNavSearchBar);

var _MobileNavAnimationSlide = __webpack_require__("./src/components/MobileNav/MobileNavAnimations/MobileNavAnimationSlide.jsx");

var _MobileNavAnimationSlide2 = _interopRequireDefault(_MobileNavAnimationSlide);

var _mobileNavSearchResultsUtils = __webpack_require__("./src/components/MobileNav/MobileNavSearchResults/mobileNavSearchResultsUtils.js");

var _debounce = __webpack_require__("./src/utils/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MobileNavSearchBar = function (_React$Component) {
    _inherits(MobileNavSearchBar, _React$Component);

    function MobileNavSearchBar() {
        _classCallCheck(this, MobileNavSearchBar);

        var _this = _possibleConstructorReturn(this, (MobileNavSearchBar.__proto__ || Object.getPrototypeOf(MobileNavSearchBar)).call(this));

        _this.fetchData = (0, _debounce2.default)(_this.fetchData.bind(_this), 300);
        _this.onInput = _this.onInput.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onCloseClick = _this.onCloseClick.bind(_this);
        return _this;
    }

    _createClass(MobileNavSearchBar, [{
        key: 'fetchData',
        value: function fetchData() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var callback = arguments[1];

            this.props.relay.refetch({
                query: value,
                hasQuery: true
            }, null, callback);
        }
    }, {
        key: 'onInput',
        value: function onInput(e) {
            var _this2 = this;

            var value = e.target.value;


            if (value) {
                this.props.onInput(value);
                this.fetchData(value, function () {
                    /**
                     * Might be possible that the user has cleared the search input by the time this callback is called.
                     * In that case we don't wan't to open the search result view.
                     */
                    if (!_this2.props.isOpen && _this2.props.value) {
                        _this2.props.onOpen();
                    }
                });
            } else {
                this.props.onClose();
            }
        }
    }, {
        key: 'onSubmit',
        value: function onSubmit(e) {
            e.preventDefault();
            var term = this.props.value;

            if (term) {
                this.props.handleNavigateAction({
                    path: (0, _mobileNavSearchResultsUtils.createSearchLinkPath)({ term: term })
                });
            }
        }
    }, {
        key: 'onCloseClick',
        value: function onCloseClick() {
            this.props.onClose();
        }
    }, {
        key: 'onFocus',
        value: function onFocus(e) {
            this.onInput(e);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                viewer = _props.viewer,
                handleNavigateAction = _props.handleNavigateAction,
                isOpen = _props.isOpen,
                value = _props.value,
                onAnimationEnd = _props.onAnimationEnd;
            // Search suggestions can be undefined even after the refetch callback was fired, so we need to account for that.

            var showSearchResults = isOpen && !!viewer.searchSuggestions;

            return _react2.default.createElement(
                'div',
                { className: _mobileNavSearchBar2.default.container },
                _react2.default.createElement(_MobileNavSearchInput2.default, {
                    showClose: showSearchResults,
                    onFocus: this.onInput,
                    onInput: this.onInput,
                    onCloseClick: this.onCloseClick,
                    onIconClick: this.onSubmit,
                    onSubmit: this.onSubmit,
                    value: value
                }),
                _react2.default.createElement(
                    _MobileNavAnimationSlide2.default,
                    {
                        'in': showSearchResults,
                        appear: 'left',
                        leave: 'left',
                        onAnimationEnd: onAnimationEnd,
                        scrollLock: true
                    },
                    _react2.default.createElement(
                        _OverlayView2.default,
                        { className: _mobileNavSearchBar2.default.overlay },
                        _react2.default.createElement(_MobileNavSearchResults2.default, {
                            handleNavigateAction: handleNavigateAction,
                            searchSuggestions: viewer.searchSuggestions
                        })
                    )
                )
            );
        }
    }]);

    return MobileNavSearchBar;
}(_react2.default.Component);

exports.default = (0, _reactRelay.createRefetchContainer)(MobileNavSearchBar, {
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/MobileNav/MobileNavSearchBar/__generated__/MobileNavSearchBar_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var MobileNavSearchResults_searchSuggestions = _MobileNavSearchResults2.default.getFragment('searchSuggestions');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    defaultValue: '',
                    kind: 'LocalArgument',
                    name: 'query'
                }, {
                    defaultValue: false,
                    kind: 'LocalArgument',
                    name: 'hasQuery'
                }],
                node: function () {
                    return {
                        children: [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'query',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'query'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {},
                                name: 'includeTypes',
                                value: [{
                                    kind: 'CallValue',
                                    callValue: 'POPULAR'
                                }, {
                                    kind: 'CallValue',
                                    callValue: 'SELLER'
                                }]
                            }],
                            children: [].concat.apply([], [RelayQL_GENERATED.__frag(MobileNavSearchResults_searchSuggestions)]),
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasQuery'
                                    }
                                }]
                            }],
                            fieldName: 'searchSuggestions',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'SearchSuggestion'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MobileNavSearchBar_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    }
}, {
    modern: function modern() {
        return __webpack_require__("./src/components/MobileNav/MobileNavSearchBar/__generated__/MobileNavSearchBarViewerQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var MobileNavSearchBar_viewer_args1 = (MobileNavSearchBar.__container__ || MobileNavSearchBar).getFragment('viewer', {
            query: {
                kind: 'CallVariable',
                callVariableName: 'query'
            },
            hasQuery: {
                kind: 'CallVariable',
                callVariableName: 'hasQuery'
            }
        });
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: '',
                kind: 'LocalArgument',
                name: 'query'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'hasQuery'
            }],
            name: 'MobileNavSearchBarViewerQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(MobileNavSearchBar_viewer_args1)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'MobileNavSearchBarViewerQuery',
                    type: 'Query'
                };
            }()
        };
    }
});

/***/ }),

/***/ "./src/components/MobileNav/MobileNavSearchBar/__generated__/MobileNavSearchBarViewerQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 6dbd845b800a4172d670bae95669d26f
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type MobileNavSearchBarViewerQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query MobileNavSearchBarViewerQuery(
  $query: String = ""
  $hasQuery: Boolean!
) {
  viewer {
    ...MobileNavSearchBar_viewer_4cP5Kl
    id
  }
}

fragment MobileNavSearchBar_viewer_4cP5Kl on Viewer {
  searchSuggestions(query: $query, includeTypes: ["POPULAR", "SELLER"]) @include(if: $hasQuery) {
    ...MobileNavSearchResults_searchSuggestions
  }
}

fragment MobileNavSearchResults_searchSuggestions on SearchSuggestion {
  suggestions {
    type
    terms {
      term
      urlLabel
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "query",
      "type": "String",
      "defaultValue": ""
    }, {
      "kind": "LocalArgument",
      "name": "hasQuery",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "MobileNavSearchBarViewerQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "MobileNavSearchBar_viewer",
        "args": [{
          "kind": "Variable",
          "name": "hasQuery",
          "variableName": "hasQuery",
          "type": null
        }, {
          "kind": "Variable",
          "name": "query",
          "variableName": "query",
          "type": null
        }]
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "MobileNavSearchBarViewerQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "query",
      "type": "String",
      "defaultValue": ""
    }, {
      "kind": "LocalArgument",
      "name": "hasQuery",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "MobileNavSearchBarViewerQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasQuery",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Literal",
            "name": "includeTypes",
            "value": ["POPULAR", "SELLER"],
            "type": "[String]"
          }, {
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": "String!"
          }],
          "concreteType": "SearchSuggestion",
          "name": "searchSuggestions",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "SearchSuggestionList",
            "name": "suggestions",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "type",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "SearchSuggestionTerm",
              "name": "terms",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "term",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "urlLabel",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query MobileNavSearchBarViewerQuery(\n  $query: String = \"\"\n  $hasQuery: Boolean!\n) {\n  viewer {\n    ...MobileNavSearchBar_viewer_4cP5Kl\n    id\n  }\n}\n\nfragment MobileNavSearchBar_viewer_4cP5Kl on Viewer {\n  searchSuggestions(query: $query, includeTypes: [\"POPULAR\", \"SELLER\"]) @include(if: $hasQuery) {\n    ...MobileNavSearchResults_searchSuggestions\n  }\n}\n\nfragment MobileNavSearchResults_searchSuggestions on SearchSuggestion {\n  suggestions {\n    type\n    terms {\n      term\n      urlLabel\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/MobileNav/MobileNavSearchBar/__generated__/MobileNavSearchBar_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MobileNavSearchBar_viewer = {|
  +searchSuggestions?: ?{| |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": ""
  }, {
    "kind": "LocalArgument",
    "name": "hasQuery",
    "type": "Boolean!",
    "defaultValue": false
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileNavSearchBar_viewer",
  "selections": [{
    "kind": "Condition",
    "passingValue": true,
    "condition": "hasQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Literal",
        "name": "includeTypes",
        "value": ["POPULAR", "SELLER"],
        "type": "[String]"
      }, {
        "kind": "Variable",
        "name": "query",
        "variableName": "query",
        "type": "String!"
      }],
      "concreteType": "SearchSuggestion",
      "name": "searchSuggestions",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "MobileNavSearchResults_searchSuggestions",
        "args": null
      }],
      "storageKey": null
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MobileNav/MobileNavSearchBar/mobileNavSearchBar.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"mobileNavSearchBar__container__88ee950c","overlay":"mobileNavSearchBar__overlay__88ee950c"};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavSearchInput/MobileNavSearchInput.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = MobileNavSearchInput;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _mobileNavSearchInput = __webpack_require__("./src/components/MobileNav/MobileNavSearchInput/mobileNavSearchInput.scss");

var _mobileNavSearchInput2 = _interopRequireDefault(_mobileNavSearchInput);

var _magnifyingGlass = __webpack_require__("./node_modules/dibs-vg/dist/react/magnifying-glass.js");

var _magnifyingGlass2 = _interopRequireDefault(_magnifyingGlass);

var _close = __webpack_require__("./node_modules/dibs-vg/dist/react/close.js");

var _close2 = _interopRequireDefault(_close);

var _mobileNavSearchInputCopy = __webpack_require__("./src/components/MobileNav/MobileNavSearchInput/mobileNavSearchInputCopy.json");

var _mobileNavSearchInputCopy2 = _interopRequireDefault(_mobileNavSearchInputCopy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MobileNavSearchInput(props) {
    return _react2.default.createElement(
        'div',
        { className: _mobileNavSearchInput2.default.container },
        _react2.default.createElement(
            'div',
            { className: _mobileNavSearchInput2.default.iconWrapper, onClick: props.onIconClick },
            _react2.default.createElement(_magnifyingGlass2.default, { className: _mobileNavSearchInput2.default.searchIcon })
        ),
        _react2.default.createElement(
            'form',
            { onSubmit: function onSubmit(e) {
                    return props.onSubmit(e);
                }, className: _mobileNavSearchInput2.default.form, action: '/search/' },
            _react2.default.createElement('input', {
                autoCorrect: 'off',
                autoCapitalize: 'off',
                autoComplete: 'off',
                spellCheck: 'false',
                name: 'q',
                onFocus: props.onFocus,
                onInput: props.onInput,
                type: 'search',
                placeholder: _mobileNavSearchInputCopy2.default.placeholder,
                value: props.value,
                className: _mobileNavSearchInput2.default.input
            })
        ),
        props.showClose && _react2.default.createElement(
            'div',
            { className: _mobileNavSearchInput2.default.iconWrapper, onClick: props.onCloseClick },
            _react2.default.createElement(_close2.default, { className: _mobileNavSearchInput2.default.closeIcon })
        )
    );
}

MobileNavSearchInput.defaultProps = {
    onInput: function onInput() {},
    onIconClick: function onIconClick() {}
};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavSearchInput/mobileNavSearchInput.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"mobileNavSearchInput__wrapper__5ecf252c","container":"mobileNavSearchInput__container__5ecf252c","form":"mobileNavSearchInput__form__5ecf252c","input":"mobileNavSearchInput__input__5ecf252c","iconWrapper":"mobileNavSearchInput__iconWrapper__5ecf252c","searchIcon":"mobileNavSearchInput__searchIcon__5ecf252c","closeIcon":"mobileNavSearchInput__closeIcon__5ecf252c"};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavSearchInput/mobileNavSearchInputCopy.json":
/***/ (function(module, exports) {

module.exports = {"placeholder":"Search"}

/***/ }),

/***/ "./src/components/MobileNav/MobileNavSearchResults/MobileNavSearchResults.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MobileNavSearchResults = MobileNavSearchResults;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _mobileNavSearchResults = __webpack_require__("./src/components/MobileNav/MobileNavSearchResults/mobileNavSearchResults.scss");

var _mobileNavSearchResults2 = _interopRequireDefault(_mobileNavSearchResults);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _mobileNavSearchResultsUtils = __webpack_require__("./src/components/MobileNav/MobileNavSearchResults/mobileNavSearchResultsUtils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Results(props) {
    var _ref = _mobileNavSearchResultsUtils.SECTIONS_BY_TYPE[props.type] || {},
        title = _ref.title,
        urlSection = _ref.urlSection;

    return _react2.default.createElement(
        'div',
        { className: _mobileNavSearchResults2.default.results },
        _react2.default.createElement(
            'span',
            { className: _mobileNavSearchResults2.default.title },
            title
        ),
        props.items.map(function (result) {
            var term = result.term,
                urlLabel = result.urlLabel;

            var searchResultUrl = (0, _mobileNavSearchResultsUtils.createSearchLinkPath)({ term: term, urlSection: urlSection, urlLabel: urlLabel });
            return _react2.default.createElement(
                'div',
                { key: term,
                    onClick: function onClick() {
                        return props.handleNavigateAction({ path: searchResultUrl });
                    },
                    className: _mobileNavSearchResults2.default.item
                },
                term
            );
        })
    );
}
// TODO: https://1stdibs.atlassian.net/browse/MW-489


Results.defaultProps = {
    items: []
};

function MobileNavSearchResults(props) {
    var suggestions = ((0, _lodash2.default)(props, 'searchSuggestions.suggestions') || []).filter(function (suggestion) {
        return suggestion.terms.length;
    });

    return _react2.default.createElement(
        'div',
        null,
        suggestions.map(function (suggestion) {
            var type = suggestion.type,
                terms = suggestion.terms;

            return _react2.default.createElement(Results, { key: type, type: type, items: terms, handleNavigateAction: props.handleNavigateAction });
        })
    );
}

exports.default = (0, _reactRelay.createFragmentContainer)(MobileNavSearchResults, {
    searchSuggestions: {
        modern: function modern() {
            return __webpack_require__("./src/components/MobileNav/MobileNavSearchResults/__generated__/MobileNavSearchResults_searchSuggestions.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            children: [{
                                fieldName: 'type',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                children: [{
                                    fieldName: 'term',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    fieldName: 'urlLabel',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }],
                                fieldName: 'terms',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'SearchSuggestionTerm'
                            }],
                            fieldName: 'suggestions',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isPlural: true
                            },
                            type: 'SearchSuggestionList'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MobileNavSearchResults_searchSuggestions',
                        type: 'SearchSuggestion'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/MobileNav/MobileNavSearchResults/__generated__/MobileNavSearchResults_searchSuggestions.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MobileNavSearchResults_searchSuggestions = {|
  +suggestions: ?$ReadOnlyArray<?{|
    +type: ?string;
    +terms: ?$ReadOnlyArray<?{|
      +term: ?string;
      +urlLabel: ?string;
    |}>;
  |}>;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileNavSearchResults_searchSuggestions",
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "SearchSuggestionList",
    "name": "suggestions",
    "plural": true,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "type",
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "SearchSuggestionTerm",
      "name": "terms",
      "plural": true,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "term",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "urlLabel",
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "SearchSuggestion"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MobileNav/MobileNavSearchResults/mobileNavSearchResults.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overlay":"mobileNavSearchResults__overlay__6a0657ec","results":"mobileNavSearchResults__results__6a0657ec","title":"mobileNavSearchResults__title__6a0657ec","item":"mobileNavSearchResults__item__6a0657ec"};

/***/ }),

/***/ "./src/components/MobileNav/MobileNavSearchResults/mobileNavSearchResultsUtils.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createSearchLinkPath = createSearchLinkPath;
// TODO: https://1stdibs.atlassian.net/browse/MW-489
var SECTIONS_BY_TYPE = exports.SECTIONS_BY_TYPE = {
    'RECENT': {
        title: 'Recent Searches',
        urlSection: null
    },
    'POPULAR': {
        title: 'Popular Searches',
        urlSection: null
    },
    'CREATOR': {
        title: 'Creators',
        urlSection: 'creators'
    },
    'STYLE': {
        title: 'Styles',
        urlSection: 'styles'
    },
    'SELLER': {
        title: 'Dealers',
        urlSection: 'dealers'
    }
};

var getSearchType = exports.getSearchType = function getSearchType(type) {
    return SECTIONS_BY_TYPE[type] || {};
};
var getSearchUrlSection = exports.getSearchUrlSection = function getSearchUrlSection(type) {
    return SECTIONS_BY_TYPE[type] || {};
};

function createSearchLinkPath(_ref) {
    var term = _ref.term,
        urlSection = _ref.urlSection,
        urlLabel = _ref.urlLabel;

    var convertedValue = encodeURIComponent(term.toLowerCase());
    var href = urlSection && urlLabel ? '/' + urlSection + '/' + urlLabel + '/?search=' + convertedValue : '/search/?q=' + convertedValue;

    return href;
};

/***/ }),

/***/ "./src/components/MobileNav/OverlayView/OverlayView.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _overlayView = __webpack_require__("./src/components/MobileNav/OverlayView/overlayView.scss");

var _overlayView2 = _interopRequireDefault(_overlayView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OverlayView(props) {
    var children = props.children,
        className = props.className;

    var overlayClasses = (0, _classnames2.default)(_overlayView2.default.body, className);
    return _react2.default.createElement(
        'div',
        { className: overlayClasses },
        children
    );
}

exports.default = OverlayView;

/***/ }),

/***/ "./src/components/MobileNav/OverlayView/overlayView.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"noScroll":"overlayView__noScroll__fd76dd6c","body":"overlayView__body__fd76dd6c"};

/***/ }),

/***/ "./src/components/MobileNav/ScrollLock.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _overlayView = __webpack_require__("./src/components/MobileNav/OverlayView/overlayView.scss");

var _overlayView2 = _interopRequireDefault(_overlayView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScrollLock = function (_React$Component) {
    _inherits(ScrollLock, _React$Component);

    function ScrollLock() {
        _classCallCheck(this, ScrollLock);

        return _possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }

    _createClass(ScrollLock, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.isLocked !== this.props.isLocked) {
                this.toggleBodyScroll(nextProps.isLocked);
            }
        }
    }, {
        key: 'saveScrollPosition',
        value: function saveScrollPosition() {
            this.scrollY = window.pageYOffset;
        }
    }, {
        key: 'restoreScrollPosition',
        value: function restoreScrollPosition() {
            return window.scrollTo(0, this.scrollY);
        }
    }, {
        key: 'toggleBodyScroll',
        value: function toggleBodyScroll(isLocked) {
            var body = document.body;
            if (isLocked) {
                this.saveScrollPosition();
                body.classList.add(_overlayView2.default.noScroll);
                /**
                 * This component is primaraly used with an overlay. There are cases where the overlay can be triggered
                 * by an input element. In that case iOS safari opens up the keyboard and in certain cases introduces
                 * a scrollbar. This causes the overlay element to scroll down. The goal is to keep the scroll position
                 * always at the top and we force it by calling `scrollTo`.
                 */
                window.scrollTo(0, 0);
            } else {
                body.classList.remove(_overlayView2.default.noScroll);
                this.restoreScrollPosition();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return this.props.children;
        }
    }]);

    return ScrollLock;
}(_react2.default.Component);

exports.default = ScrollLock;

/***/ }),

/***/ "./src/components/MobileNav/__generated__/MobileNav_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MobileNav_user = {| |};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "showMarketingMessages",
    "type": "Boolean"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileNav_user",
  "selections": [{
    "kind": "FragmentSpread",
    "name": "MobileNavMenu_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "MobileNavHeader_user",
    "args": null
  }, {
    "kind": "Condition",
    "passingValue": true,
    "condition": "showMarketingMessages",
    "selections": [{
      "kind": "InlineFragment",
      "type": "User",
      "selections": [{
        "kind": "FragmentSpread",
        "name": "MessageBanner_user",
        "args": null
      }]
    }]
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MobileNav/__generated__/MobileNav_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MobileNav_viewer = {| |};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "showMarketingMessages",
    "type": "Boolean"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileNav_viewer",
  "selections": [{
    "kind": "FragmentSpread",
    "name": "MobileNavMenu_viewer",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "MobileNavSearchBar_viewer",
    "args": null
  }, {
    "kind": "Condition",
    "passingValue": true,
    "condition": "showMarketingMessages",
    "selections": [{
      "kind": "InlineFragment",
      "type": "Viewer",
      "selections": [{
        "kind": "FragmentSpread",
        "name": "MessageBanner_viewer",
        "args": null
      }]
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MobileNav/mobileNav.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"spacer":"mobileNav__spacer__f8022b1a","container":"mobileNav__container__f8022b1a","isOpen":"mobileNav__isOpen__f8022b1a"};

/***/ }),

/***/ "./src/components/MobileNav/utils/mobileNavConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AUTH_CLICK_LOGIN = exports.AUTH_CLICK_LOGIN = 'AUTH_CLICK_LOGIN';
var AUTH_CLICK_REGISTER = exports.AUTH_CLICK_REGISTER = 'AUTH_CLICK_REGISTER';
var AUTH_CLICK_LOGOUT = exports.AUTH_CLICK_LOGOUT = 'AUTH_CLICK_LOGOUT';

/***/ }),

/***/ "./src/components/MobileNavWrapper/MobileNavWrapper.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _actions = __webpack_require__("./src/actions/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _MobileNav = __webpack_require__("./src/components/MobileNav/MobileNav.jsx");

var _MobileNav2 = _interopRequireDefault(_MobileNav);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _mobileNavConstants = __webpack_require__("./src/components/MobileNav/utils/mobileNavConstants.js");

var _accountConstants = __webpack_require__("./src/components/AccountNav/accountConstants.js");

var _userTracking = __webpack_require__("./src/utils/userTracking.js");

var userTracking = _interopRequireWildcard(_userTracking);

var _AuthModalLoader = __webpack_require__("./src/utils/AuthModalLoader.js");

var _AuthModalLoader2 = _interopRequireDefault(_AuthModalLoader);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MASQUERADE_BUYER = _dibsCookieJar.cookieJarConstants.MASQUERADE_BUYER;

var MobileNavWrapper = function (_React$Component) {
    _inherits(MobileNavWrapper, _React$Component);

    function MobileNavWrapper(props) {
        _classCallCheck(this, MobileNavWrapper);

        var _this = _possibleConstructorReturn(this, (MobileNavWrapper.__proto__ || Object.getPrototypeOf(MobileNavWrapper)).call(this, props));

        _this.state = {
            isClient: false,
            fragmentVariables: {
                showMarketingMessages: _this.props.showMarketingMessages,
                userId: '',
                userIds: [],
                hasUserId: false
            }
        };
        _this.onAuthClick = _this.onAuthClick.bind(_this);
        return _this;
    }

    _createClass(MobileNavWrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ isClient: true }); // eslint-disable-line react/no-did-mount-set-state
            this.updateUser();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.updateUserState && !prevProps.updateUserState) {
                this.updateUser();
            }

            if ((0, _lodash2.default)(this.props.viewer, 'user.isVerifiedTrade') && !(0, _lodash2.default)(prevProps.viewer, 'user')) {
                this.props.updateUserTypeTrade();
            }

            if (this.state.isClient && !this.props.initialTrackingFired) {
                var viewer = this.props.viewer;

                var userId = (0, _dibsCookieJar.getUserId)(document.cookie, MASQUERADE_BUYER);
                var hasUserId = !!userId;
                var hasUser = !!viewer.user;

                if (!hasUserId) {
                    userTracking.init({ viewer: viewer });
                } else if (hasUser) {
                    var user = viewer.user;

                    userTracking.init({ viewer: viewer, user: user });
                }
            }
        }
    }, {
        key: 'updateUser',
        value: function updateUser() {
            var _this2 = this;

            if (typeof document === 'undefined') {
                return;
            }
            var userId = (0, _dibsCookieJar.getUserId)(document.cookie, MASQUERADE_BUYER);
            var hasUserId = !!userId;

            if (hasUserId) {
                this.setState({
                    fragmentVariables: _extends({}, this.state.fragmentVariables, {
                        hasUserId: hasUserId,
                        userId: userId,
                        userIds: [userId]
                    })
                }, function () {
                    _this2.props.relay.refetch(_this2.state.fragmentVariables);
                });
            }
        }
    }, {
        key: 'handleNavigateAction',
        value: function handleNavigateAction(_ref) {
            var _ref$path = _ref.path,
                path = _ref$path === undefined ? '/' : _ref$path;

            window.location = path;
        }
    }, {
        key: 'onAuthClick',
        value: function onAuthClick(clickType) {
            switch (clickType) {
                case _mobileNavConstants.AUTH_CLICK_LOGIN:
                    _AuthModalLoader2.default.show({
                        relayEnvironment: this.props.relay.environment,
                        email: localStorage.getItem('userEmail'),
                        action: _accountConstants.ACTION_LOGIN
                    }).then(this.props.closeMobileMenu);
                    break;
                case _mobileNavConstants.AUTH_CLICK_REGISTER:
                    _AuthModalLoader2.default.show({
                        relayEnvironment: this.props.relay.environment,
                        email: localStorage.getItem('userEmail'),
                        action: _accountConstants.ACTION_REGISTER
                    }).then(this.props.closeMobileMenu);
                    break;
                case _mobileNavConstants.AUTH_CLICK_LOGOUT:
                    this.props.logoutUser();
                    break;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var viewer = this.props.viewer;
            var _viewer$user = viewer.user,
                user = _viewer$user === undefined ? null : _viewer$user;
            var _state = this.state,
                isClient = _state.isClient,
                fragmentVariables = _state.fragmentVariables;
            var hasUserId = fragmentVariables.hasUserId,
                showMarketingMessages = fragmentVariables.showMarketingMessages,
                userIds = fragmentVariables.userIds;


            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_MobileNav2.default, {
                    handleNavigateAction: this.handleNavigateAction,
                    showMarketingMessages: showMarketingMessages,
                    isClient: isClient,
                    onAuthClick: this.onAuthClick,
                    viewer: viewer,
                    hasUserId: hasUserId,
                    user: user,
                    userIds: userIds
                })
            );
        }
    }]);

    return MobileNavWrapper;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref2) {
    var header = _ref2.header;
    return {
        updateUserState: header.updateUserState,
        logoutUser: header.logoutUser
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        updateUserTypeTrade: function updateUserTypeTrade() {
            dispatch(_actions.actionCreators.setUserTypeTrade(true));
        },
        closeMobileMenu: function closeMobileMenu() {
            dispatch(_actions.actionCreators.toggleMobileMenu(false));
        }
    };
};

exports.default = (0, _reactRelay.createRefetchContainer)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MobileNavWrapper), {
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/MobileNavWrapper/__generated__/MobileNavWrapper_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var MobileNav_viewer = _MobileNav2.default.getFragment('viewer'),
                userTracking_viewer = RelayQL_GENERATED.__getClassicFragment(userTracking.viewer.viewer || userTracking.viewer).node,
                userTracking_user = RelayQL_GENERATED.__getClassicFragment(userTracking.user.user || userTracking.user).node,
                MobileNav_user = _MobileNav2.default.getFragment('user');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    kind: 'RootArgument',
                    name: 'userId'
                }, {
                    kind: 'RootArgument',
                    name: 'hasUserId'
                }],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [].concat.apply([], [{
                                fieldName: 'isVerifiedTrade',
                                kind: 'Field',
                                metadata: {},
                                type: 'Boolean'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, RelayQL_GENERATED.__frag(userTracking_user), RelayQL_GENERATED.__frag(MobileNav_user)]),
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            fieldName: 'user',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'User'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(MobileNav_viewer), RelayQL_GENERATED.__frag(userTracking_viewer)]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'MobileNavWrapper_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    }
}, {
    modern: function modern() {
        return __webpack_require__("./src/components/MobileNavWrapper/__generated__/MobileNavWrapperRefetchQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var MobileNavWrapper_viewer = (MobileNavWrapper.__container__ || MobileNavWrapper).getFragment('viewer');
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userId'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userIds'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'hasUserId'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'showMarketingMessages'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'fetchMarketingMessagesTransactions'
            }],
            name: 'MobileNavWrapperRefetchQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(MobileNavWrapper_viewer)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'MobileNavWrapperRefetchQuery',
                    type: 'Query'
                };
            }()
        };
    }
});

/***/ }),

/***/ "./src/components/MobileNavWrapper/__generated__/MobileNavWrapperRefetchQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 09404f97daf0c67bdc9fa9a8c5601a84
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type MobileNavWrapperRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query MobileNavWrapperRefetchQuery(
  $userId: String!
  $userIds: [String!]
  $hasUserId: Boolean!
  $showMarketingMessages: Boolean!
  $fetchMarketingMessagesTransactions: Boolean!
) {
  viewer {
    ...MobileNavWrapper_viewer
    id
  }
}

fragment MobileNavWrapper_viewer on Viewer {
  ...MobileNav_viewer
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $hasUserId) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $hasUserId) {
    totalResults
  }
  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 1) @include(if: $hasUserId) {
    totalResults
    edges {
      node {
        mostRecentOffer {
          createdDate
          subTotalAmount {
            convertedAmounts {
              USD
            }
          }
          id
        }
        id
      }
    }
  }
  user(userId: $userId) @include(if: $hasUserId) {
    isVerifiedTrade
    firstSessionDate
    isTrade: hasPermission(name: "B_TRADE_CHECKOUT")
    hasVipPermission: hasPermission(name: "B_VIP_CHECKOUT")
    profile {
      email
      zipCode
      currency
    }
    serviceId
    totalMessagesToDealers
    tradeFirm {
      serviceId
      tier
      id
    }
    verifiedTradeStatus
    isPromoCodeEligible(code: "SAVE15")
    ...MobileNav_user
    id
  }
}

fragment MobileNav_viewer on Viewer {
  ...MobileNavMenu_viewer
  ... on Viewer @include(if: $showMarketingMessages) {
    ...MessageBanner_viewer
  }
}

fragment MobileNav_user on User {
  ...MobileNavMenu_user
  ...MobileNavHeader_user
  ... on User @include(if: $showMarketingMessages) {
    ...MessageBanner_user
  }
}

fragment MobileNavMenu_user on User {
  conversationSummary {
    totalUnreadConversationCount
  }
  ...MobileNavMenuBody_user
}

fragment MobileNavHeader_user on User {
  isVerifiedTrade
  conversationSummary {
    totalUnreadConversationCount
  }
  ...MobileNavCartContainer_user
}

fragment MessageBanner_user on User {
  isVip
  isVerifiedTrade
  verifiedTradeStatus
  verifiedTradeSubStatus
  tradeFirm {
    loyalty {
      status
    }
    id
  }
}

fragment MobileNavCartContainer_user on User {
  cart {
    items {
      item {
        itemId
      }
      id
    }
    id
  }
}

fragment MobileNavMenuBody_user on User {
  ...MobileNavAuthButtons_user
}

fragment MobileNavAuthButtons_user on User {
  serviceId
}

fragment MobileNavMenu_viewer on Viewer {
  navigation {
    modules {
      name
      isVertical
      url
      items {
        visible
        type
        name
        items {
          name
          url
          id
        }
        id
      }
      categories {
        name
        count
        label
        id
      }
      id
    }
    id
  }
}

fragment MessageBanner_viewer on Viewer {
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  confirmedTransactions: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String!]",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "showMarketingMessages",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchMarketingMessagesTransactions",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "MobileNavWrapperRefetchQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "MobileNavWrapper_viewer",
        "args": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "MobileNavWrapperRefetchQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String!]",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "showMarketingMessages",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchMarketingMessagesTransactions",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "MobileNavWrapperRefetchQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Navigation",
        "name": "navigation",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "NavigationModule",
          "name": "modules",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isVertical",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "url",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "NavigationTopLevel",
            "name": "items",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "visible",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "type",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "NavigationItem",
              "name": "items",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "url",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "NavigationModuleCategories",
            "name": "categories",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "count",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "label",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": "allTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.initiated",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.submitted",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "confirmedTransactionsMostRecent",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 1,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "sort",
            "value": "createdDate asc",
            "type": "String"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.confirmed",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TransactionEdge",
            "name": "edges",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Transaction",
              "name": "node",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "name": "mostRecentOffer",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "createdDate",
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "name": "subTotalAmount",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ConvertedAmounts",
                    "name": "convertedAmounts",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "USD",
                      "storageKey": null
                    }],
                    "storageKey": null
                  }],
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String!"
          }],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "name": "tradeFirm",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "tier",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isVerifiedTrade",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": "isTrade",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_TRADE_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
          }, {
            "kind": "ScalarField",
            "alias": "hasVipPermission",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_VIP_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "name": "profile",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "email",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "zipCode",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalMessagesToDealers",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstSessionDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "verifiedTradeStatus",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": [{
              "kind": "Literal",
              "name": "code",
              "value": "SAVE15",
              "type": "String!"
            }],
            "name": "isPromoCodeEligible",
            "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Summary",
            "name": "conversationSummary",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalUnreadConversationCount",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PortfolioV1",
            "name": "cart",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "PortfolioItemV1",
              "name": "items",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ItemSummary",
                "name": "item",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "itemId",
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "Condition",
            "passingValue": true,
            "condition": "showMarketingMessages",
            "selections": [{
              "kind": "InlineFragment",
              "type": "User",
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "isVip",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "verifiedTradeSubStatus",
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "TradeFirmType",
                "name": "tradeFirm",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "TradeFirmLoyaltyType",
                  "name": "loyalty",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "status",
                    "storageKey": null
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }]
            }]
          }],
          "storageKey": null
        }]
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "showMarketingMessages",
        "selections": [{
          "kind": "InlineFragment",
          "type": "Viewer",
          "selections": [{
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchMarketingMessagesTransactions",
            "selections": [{
              "kind": "LinkedField",
              "alias": "allTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": "initiatedTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.initiated",
                "type": "String"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": "submittedTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.submitted",
                "type": "String"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": "confirmedTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "sort",
                "value": "createdDate asc",
                "type": "String"
              }, {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.confirmed",
                "type": "String"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }]
          }]
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query MobileNavWrapperRefetchQuery(\n  $userId: String!\n  $userIds: [String!]\n  $hasUserId: Boolean!\n  $showMarketingMessages: Boolean!\n  $fetchMarketingMessagesTransactions: Boolean!\n) {\n  viewer {\n    ...MobileNavWrapper_viewer\n    id\n  }\n}\n\nfragment MobileNavWrapper_viewer on Viewer {\n  ...MobileNav_viewer\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 1) @include(if: $hasUserId) {\n    totalResults\n    edges {\n      node {\n        mostRecentOffer {\n          createdDate\n          subTotalAmount {\n            convertedAmounts {\n              USD\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  user(userId: $userId) @include(if: $hasUserId) {\n    isVerifiedTrade\n    firstSessionDate\n    isTrade: hasPermission(name: \"B_TRADE_CHECKOUT\")\n    hasVipPermission: hasPermission(name: \"B_VIP_CHECKOUT\")\n    profile {\n      email\n      zipCode\n      currency\n    }\n    serviceId\n    totalMessagesToDealers\n    tradeFirm {\n      serviceId\n      tier\n      id\n    }\n    verifiedTradeStatus\n    isPromoCodeEligible(code: \"SAVE15\")\n    ...MobileNav_user\n    id\n  }\n}\n\nfragment MobileNav_viewer on Viewer {\n  ...MobileNavMenu_viewer\n  ... on Viewer @include(if: $showMarketingMessages) {\n    ...MessageBanner_viewer\n  }\n}\n\nfragment MobileNav_user on User {\n  ...MobileNavMenu_user\n  ...MobileNavHeader_user\n  ... on User @include(if: $showMarketingMessages) {\n    ...MessageBanner_user\n  }\n}\n\nfragment MobileNavMenu_user on User {\n  conversationSummary {\n    totalUnreadConversationCount\n  }\n  ...MobileNavMenuBody_user\n}\n\nfragment MobileNavHeader_user on User {\n  isVerifiedTrade\n  conversationSummary {\n    totalUnreadConversationCount\n  }\n  ...MobileNavCartContainer_user\n}\n\nfragment MessageBanner_user on User {\n  isVip\n  isVerifiedTrade\n  verifiedTradeStatus\n  verifiedTradeSubStatus\n  tradeFirm {\n    loyalty {\n      status\n    }\n    id\n  }\n}\n\nfragment MobileNavCartContainer_user on User {\n  cart {\n    items {\n      item {\n        itemId\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment MobileNavMenuBody_user on User {\n  ...MobileNavAuthButtons_user\n}\n\nfragment MobileNavAuthButtons_user on User {\n  serviceId\n}\n\nfragment MobileNavMenu_viewer on Viewer {\n  navigation {\n    modules {\n      name\n      isVertical\n      url\n      items {\n        visible\n        type\n        name\n        items {\n          name\n          url\n          id\n        }\n        id\n      }\n      categories {\n        name\n        count\n        label\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment MessageBanner_viewer on Viewer {\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  confirmedTransactions: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/MobileNavWrapper/__generated__/MobileNavWrapper_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type MobileNavWrapper_viewer = {|
  +allTransactions?: ?{|
    +totalResults: ?number;
  |};
  +initiatedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +submittedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +confirmedTransactionsMostRecent?: ?{|
    +totalResults: ?number;
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +mostRecentOffer: ?{|
          +createdDate: ?string;
          +subTotalAmount: ?{|
            +convertedAmounts: ?{|
              +USD: ?number;
            |};
          |};
        |};
      |};
    |}>;
  |};
  +user?: ?{|
    +isVerifiedTrade: ?boolean;
    +firstSessionDate: ?string;
    +isTrade: ?boolean;
    +hasVipPermission: ?boolean;
    +profile: ?{|
      +email: ?string;
      +zipCode: ?string;
      +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
    |};
    +serviceId: ?string;
    +totalMessagesToDealers: ?number;
    +tradeFirm: ?{|
      +serviceId: ?string;
      +tier: ?"TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "P_AND_M" | "UNKNOWN";
    |};
    +verifiedTradeStatus: ?string;
    +isPromoCodeEligible: ?boolean;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "userId",
    "type": "String!"
  }, {
    "kind": "RootArgument",
    "name": "hasUserId",
    "type": "Boolean"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "MobileNavWrapper_viewer",
  "selections": [{
    "kind": "FragmentSpread",
    "name": "MobileNav_viewer",
    "args": null
  }, {
    "kind": "Condition",
    "passingValue": true,
    "condition": "hasUserId",
    "selections": [{
      "kind": "LinkedField",
      "alias": "allTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "initiatedTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.initiated",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "submittedTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.submitted",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "confirmedTransactionsMostRecent",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 1,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "sort",
        "value": "createdDate asc",
        "type": "String"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.confirmed",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "TransactionEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Transaction",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Offer",
            "name": "mostRecentOffer",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "createdDate",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "name": "subTotalAmount",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ConvertedAmounts",
                "name": "convertedAmounts",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "USD",
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId",
        "type": "String!"
      }],
      "concreteType": "User",
      "name": "user",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "serviceId",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "isVerifiedTrade",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": "isTrade",
        "args": [{
          "kind": "Literal",
          "name": "name",
          "value": "B_TRADE_CHECKOUT",
          "type": "String!"
        }],
        "name": "hasPermission",
        "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
      }, {
        "kind": "ScalarField",
        "alias": "hasVipPermission",
        "args": [{
          "kind": "Literal",
          "name": "name",
          "value": "B_VIP_CHECKOUT",
          "type": "String!"
        }],
        "name": "hasPermission",
        "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Profile",
        "name": "profile",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "email",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "zipCode",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currency",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "firstSessionDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalMessagesToDealers",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "TradeFirmType",
        "name": "tradeFirm",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "serviceId",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tier",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "verifiedTradeStatus",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": [{
          "kind": "Literal",
          "name": "code",
          "value": "SAVE15",
          "type": "String!"
        }],
        "name": "isPromoCodeEligible",
        "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
      }, {
        "kind": "FragmentSpread",
        "name": "MobileNav_user",
        "args": null
      }],
      "storageKey": null
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/MobileNavWrapperRenderer/MobileNavWrapperRenderer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _relayQueryLookupRenderer = __webpack_require__("./node_modules/relay-query-lookup-renderer/dist/index.js");

var _relayQueryLookupRenderer2 = _interopRequireDefault(_relayQueryLookupRenderer);

var _MobileNavWrapper = __webpack_require__("./src/components/MobileNavWrapper/MobileNavWrapper.jsx");

var _MobileNavWrapper2 = _interopRequireDefault(_MobileNavWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prevProps = {};

function MobileNavRenderer() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var environment = props.environment,
        initialVariables = props.initialVariables,
        query = props.query,
        relayVariables = props.relayVariables;


    var variables = _extends({}, initialVariables, relayVariables);

    return _react2.default.createElement(_relayQueryLookupRenderer2.default, {
        lookup: true,
        environment: environment,
        query: query,
        variables: variables,
        render: function render(_ref) {
            var rendererProps = _ref.props;
            // eslint-disable-line react/display-name, react/prop-types
            var currentProps = _extends({}, prevProps, variables);

            if (rendererProps) {

                currentProps = _extends({}, currentProps, rendererProps);
            }

            prevProps = currentProps;

            return _react2.default.createElement(_MobileNavWrapper2.default, currentProps);
        }
    });
}

var mapStateToProps = function mapStateToProps(_ref2) {
    var header = _ref2.header;

    return {
        relayVariables: header.relayVariables || {}
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(MobileNavRenderer);

/***/ }),

/***/ "./src/components/Notifications/InfiniteScroll.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteScroll = function (_Component) {
    _inherits(InfiniteScroll, _Component);

    function InfiniteScroll(props) {
        _classCallCheck(this, InfiniteScroll);

        var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

        _this._removeListeners = null;
        _this.handleScroll = _this.handleScroll.bind(_this);
        return _this;
    }

    _createClass(InfiniteScroll, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addListeners();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this._removeListeners) {
                this.addListeners();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.removeListeners();
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            var _this2 = this;

            var _props = this.props,
                hasMore = _props.hasMore,
                useCapture = _props.useCapture;


            if (!hasMore || this._removeListeners) {
                return;
            }

            this._infiniteScroll.parentNode.addEventListener('scroll', this.handleScroll, useCapture);
            this._removeListeners = function () {
                return _this2._infiniteScroll.parentNode.removeEventListener('scroll', _this2.handleScroll, useCapture);
            };
        }
    }, {
        key: 'removeListeners',
        value: function removeListeners() {
            if (typeof this._removeListeners === "function") {
                this._removeListeners();
                this._removeListeners = null;
            }
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll() {
            var _infiniteScroll = this._infiniteScroll,
                _props2 = this.props,
                threshold = _props2.threshold,
                loadMore = _props2.loadMore;


            var offset = _infiniteScroll.scrollHeight - _infiniteScroll.parentNode.scrollTop - _infiniteScroll.parentNode.clientHeight;

            if (offset < threshold) {
                this.removeListeners();

                if (typeof loadMore === "function") {
                    loadMore();
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props3 = this.props,
                children = _props3.children,
                hasMore = _props3.hasMore,
                loader = _props3.loader,
                className = _props3.className;


            var childrenArray = [children];
            if (hasMore && loader) {
                childrenArray.push(loader);
            }
            return _react2.default.createElement(
                'div',
                { className: className, ref: function ref(node) {
                        _this3._infiniteScroll = node;
                    } },
                childrenArray
            );
        }
    }]);

    return InfiniteScroll;
}(_react.Component);

exports.default = InfiniteScroll;


InfiniteScroll.defaultProps = {
    threshold: 150,
    useCapture: false,
    loader: null
};

/***/ }),

/***/ "./src/components/Notifications/NotificationCard.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NotificationsStyle = __webpack_require__("./src/components/Notifications/Notifications-style.scss");

var _NotificationsStyle2 = _interopRequireDefault(_NotificationsStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var monthStrings = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

var MAX_CHARS_IN_CARD_BODY = 78;

var NotificationCard = function NotificationCard(props) {
    var thumbnail = props.thumbnail,
        thumbnailAlt = props.thumbnailAlt,
        subject = props.subject,
        actionURL = props.actionURL,
        date = props.date,
        onClick = props.onClick,
        rightSecondary = props.rightSecondary;
    var actionTitle = props.actionTitle;


    if (actionTitle && String(actionTitle).length > MAX_CHARS_IN_CARD_BODY) {
        actionTitle = String(actionTitle).substr(0, MAX_CHARS_IN_CARD_BODY) + '...';
    }

    var dateObj = new Date(date);
    var month = dateObj.getMonth();
    var dateNum = dateObj.getDate();
    var dateString = !isNaN(month) && !isNaN(dateNum) ? monthStrings[month].substr(0, 3) + ' ' + dateNum : '';
    var detailsSecondary = actionURL ? _react2.default.createElement(
        'a',
        { href: actionURL },
        actionTitle
    ) : _react2.default.createElement(
        'p',
        null,
        actionTitle
    );

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: _NotificationsStyle2.default.row, onClick: onClick },
            _react2.default.createElement(
                'div',
                { className: _NotificationsStyle2.default.thumbnail },
                _react2.default.createElement('img', { src: thumbnail, alt: thumbnailAlt, className: _NotificationsStyle2.default.thumbnailImage })
            ),
            _react2.default.createElement(
                'div',
                { className: _NotificationsStyle2.default.details },
                _react2.default.createElement(
                    'div',
                    { className: _NotificationsStyle2.default.detailsLeft },
                    _react2.default.createElement(
                        'p',
                        { className: _NotificationsStyle2.default.detailsSubject },
                        subject
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _NotificationsStyle2.default.detailsSecondary },
                        detailsSecondary
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _NotificationsStyle2.default.detailsRight },
                    _react2.default.createElement(
                        'div',
                        null,
                        dateString
                    ),
                    rightSecondary
                )
            )
        )
    );
};

exports.default = NotificationCard;

/***/ }),

/***/ "./src/components/Notifications/Notifications-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"iconWrapper":"Notifications-style__iconWrapper__553c280","icon":"Notifications-style__icon__553c280","hasUnread":"Notifications-style__hasUnread__553c280","contentContainer":"Notifications-style__contentContainer__553c280","emptyContainer":"Notifications-style__emptyContainer__553c280","content":"Notifications-style__content__553c280","row":"Notifications-style__row__553c280","thumbnail":"Notifications-style__thumbnail__553c280","thumbnailImage":"Notifications-style__thumbnailImage__553c280","details":"Notifications-style__details__553c280","detailsSecondary":"Notifications-style__detailsSecondary__553c280","detailsLeft":"Notifications-style__detailsLeft__553c280","detailsRight":"Notifications-style__detailsRight__553c280","detailsSubject":"Notifications-style__detailsSubject__553c280","spinnerContainer":"Notifications-style__spinnerContainer__553c280","spinnerBlock":"Notifications-style__spinnerBlock__553c280","emailIcon":"Notifications-style__emailIcon__553c280","hideOverlay":"Notifications-style__hideOverlay__553c280"};

/***/ }),

/***/ "./src/components/Notifications/Notifications.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _dibsBrowserStorage2 = _interopRequireDefault(_dibsBrowserStorage);

var _Dropdown = __webpack_require__("./src/components/Dropdown/Dropdown.jsx");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _DropdownHeader = __webpack_require__("./src/components/Dropdown/DropdownHeader.jsx");

var _DropdownHeader2 = _interopRequireDefault(_DropdownHeader);

var _DropdownBody = __webpack_require__("./src/components/Dropdown/DropdownBody.jsx");

var _DropdownBody2 = _interopRequireDefault(_DropdownBody);

var _NotificationsIcon = __webpack_require__("./src/components/Notifications/NotificationsIcon.jsx");

var _NotificationsIcon2 = _interopRequireDefault(_NotificationsIcon);

var _NotificationsEmpty = __webpack_require__("./src/components/Notifications/NotificationsEmpty.jsx");

var _NotificationsEmpty2 = _interopRequireDefault(_NotificationsEmpty);

var _NotificationsList = __webpack_require__("./src/components/Notifications/NotificationsList.jsx");

var _NotificationsList2 = _interopRequireDefault(_NotificationsList);

var _NotificationsSpinner = __webpack_require__("./src/components/Notifications/NotificationsSpinner.jsx");

var _NotificationsSpinner2 = _interopRequireDefault(_NotificationsSpinner);

var _promoCode = __webpack_require__("./src/utils/promoCode.es.js");

var _NotificationsStyle = __webpack_require__("./src/components/Notifications/Notifications-style.scss");

var _NotificationsStyle2 = _interopRequireDefault(_NotificationsStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BATCH_SIZE = 5;
var LOCAL_STORAGE_KEY_NAME = "NAV_NOTIFICATIONS_DROPDOWN_LAST_OPEN_TIME";
var VIEW_ALL_LINK_URL = "/my/conversations/?filter=showUnreadOnly";

var resetState = function resetState() {
    return {
        isOpen: false,
        fetchingNotifications: true,
        fetchingMore: false,
        first: BATCH_SIZE
    };
};
var loadMore = function loadMore(previousFirst) {
    return { first: previousFirst + BATCH_SIZE, fetchingMore: true };
};
var stopFetching = function stopFetching() {
    var isMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var defaultReturn = { fetchingNotifications: false };
    return isMore ? Object.assign({}, defaultReturn, { fetchingMore: false }) : defaultReturn;
};
var startFetching = function startFetching() {
    return { fetchingNotifications: true };
};
var openDropdown = function openDropdown() {
    return { isOpen: true };
};

var Notifications = function (_Component) {
    _inherits(Notifications, _Component);

    function Notifications(props) {
        _classCallCheck(this, Notifications);

        var _this = _possibleConstructorReturn(this, (Notifications.__proto__ || Object.getPrototypeOf(Notifications)).call(this, props));

        _this.state = resetState();

        _this.loadNotifications = _this.loadNotifications.bind(_this);
        _this.onMouseEnterIcon = _this.onMouseEnterIcon.bind(_this);
        return _this;
    }

    _createClass(Notifications, [{
        key: 'loadNotifications',
        value: function loadNotifications() {
            var _this2 = this;

            var isInitial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var localStorage = _dibsBrowserStorage2.default.localStorage;
            var _props = this.props,
                hasRootPendingRefetch = _props.hasRootPendingRefetch,
                relay = _props.relay,
                userId = _props.userId,
                user = _props.user;
            var _state = this.state,
                fetchingMore = _state.fetchingMore,
                first = _state.first;

            var fetchNotificationVariables = { fetchNotifications: true, userId: userId, hasUserId: !!userId };

            if (hasRootPendingRefetch) {
                return;
            }

            if (isInitial) {
                var refetchVariables = function refetchVariables(fragmentVariables) {
                    return Object.assign({}, fragmentVariables, fetchNotificationVariables);
                };
                var refetchCallback = function refetchCallback() {
                    localStorage.setItem(LOCAL_STORAGE_KEY_NAME, Date.now());
                    if ((0, _lodash2.default)(user, 'isPromoCodeEligible')) {
                        (0, _promoCode.setPromoCodeNotificationShown)();
                    }
                    _this2.setState(stopFetching);
                };

                this.setState(startFetching, function () {
                    return relay.refetch(refetchVariables, null, refetchCallback, { force: true });
                });
            } else if (!fetchingMore) {
                var _refetchVariables = function _refetchVariables(fragmentVariables) {
                    return Object.assign({}, fragmentVariables, { first: first + BATCH_SIZE }, fetchNotificationVariables);
                };
                var _refetchCallback = function _refetchCallback() {
                    return _this2.setState(stopFetching(true));
                };
                this.setState(loadMore(first), function () {
                    return relay.refetch(_refetchVariables, null, _refetchCallback);
                });
            }
        }
    }, {
        key: 'onMouseEnterIcon',
        value: function onMouseEnterIcon(e) {
            e.stopPropagation();
            if (!this.state.isOpen) {
                this.loadNotifications(true);
                this.setState(openDropdown);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var localStorage = _dibsBrowserStorage2.default.localStorage;
            var _props2 = this.props,
                hasUserId = _props2.hasUserId,
                isClient = _props2.isClient,
                user = _props2.user;
            var fetchingNotifications = this.state.fetchingNotifications;

            var conversations = (0, _lodash2.default)(this.props, 'initialViewer.conversations');
            var hasConversations = !!conversations;
            var hasNextPage = (0, _lodash2.default)(this.props, 'viewer.conversations.pageInfo.hasNextPage');
            var isPromoCodeEligible = !!(0, _lodash2.default)(user, 'isPromoCodeEligible');

            if (!isClient || hasUserId && !hasConversations || !hasUserId) {
                return null;
            }

            var conversationEdges = (0, _lodash2.default)(this.props, 'viewer.conversations.edges');
            var lastUnreadMessageDate = (0, _lodash2.default)(this.props, 'initialViewer.conversations.metadata.lastUnreadMessageDate');

            var hasNotifications = conversationEdges && conversationEdges.length > 0 || isPromoCodeEligible;
            var lastOpenedTime = Number(localStorage.getItem(LOCAL_STORAGE_KEY_NAME)) || 0;

            var mostRecentMessageReceivedAt = lastUnreadMessageDate ? new Date(lastUnreadMessageDate).getTime() : 0;

            var spinner = _react2.default.createElement(_NotificationsSpinner2.default, { size: 'medium', isBlock: true });
            var content = hasNotifications ? _react2.default.createElement(_NotificationsList2.default, {
                conversationEdges: conversationEdges,
                loadMore: this.loadNotifications,
                hasMore: hasNextPage !== false,
                isPromoCodeEligible: isPromoCodeEligible
            }) : _react2.default.createElement(_NotificationsEmpty2.default, null);

            return _react2.default.createElement(
                _Dropdown2.default,
                { align: _Dropdown.alignConstants.ALIGN_RIGHT, onHide: function onHide() {
                        _this3.setState(resetState);
                    } },
                _react2.default.createElement(_NotificationsIcon2.default, {
                    onMouseEnter: this.onMouseEnterIcon,
                    hasUnread: mostRecentMessageReceivedAt > lastOpenedTime || isPromoCodeEligible && !(0, _promoCode.wasPromoCodeNotificationShown)()
                }),
                _react2.default.createElement(_DropdownHeader2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Header.Notifications.header_title', defaultMessage: 'Notifications' }),
                    link: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Header.Notifications.header_link', defaultMessage: 'View All' }),
                    href: VIEW_ALL_LINK_URL
                }),
                _react2.default.createElement(
                    _DropdownBody2.default,
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: _NotificationsStyle2.default.contentContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _NotificationsStyle2.default.content },
                            fetchingNotifications ? spinner : content
                        )
                    )
                )
            );
        }
    }]);

    return Notifications;
}(_react.Component);

exports.default = (0, _reactRelay.createRefetchContainer)(Notifications, {
    initialViewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/Notifications/__generated__/Notifications_initialViewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    kind: 'RootArgument',
                    name: 'hasUserId'
                }],
                node: function () {
                    return {
                        children: [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'filter',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'showUnreadOnly'
                                }
                            }],
                            children: [{
                                children: [{
                                    fieldName: 'lastUnreadMessageDate',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }],
                                fieldName: 'metadata',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'ConversationMetadata'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            fieldName: 'conversations',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'ConversationConnection'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'Notifications_initialViewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    },
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/Notifications/__generated__/Notifications_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    defaultValue: 5,
                    kind: 'LocalArgument',
                    name: 'first'
                }, {
                    defaultValue: false,
                    kind: 'LocalArgument',
                    name: 'fetchNotifications'
                }, {
                    kind: 'RootArgument',
                    name: 'userId'
                }],
                node: function () {
                    return {
                        children: [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'filter',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'showUnreadOnly'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'first',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'first'
                                }
                            }],
                            children: [{
                                children: [{
                                    children: [{
                                        fieldName: 'serviceId',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'ID'
                                    }, {
                                        fieldName: 'inboxImage',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        calls: [{
                                            kind: 'Call',
                                            metadata: {},
                                            name: 'currentUserId',
                                            value: {
                                                kind: 'CallVariable',
                                                callVariableName: 'userId'
                                            }
                                        }],
                                        children: [{
                                            children: [{
                                                children: [{
                                                    fieldName: 'company',
                                                    kind: 'Field',
                                                    metadata: {},
                                                    type: 'String'
                                                }],
                                                fieldName: 'sellerProfile',
                                                kind: 'Field',
                                                metadata: {
                                                    canHaveSubselections: true
                                                },
                                                type: 'SellerProfile'
                                            }, {
                                                fieldName: 'id',
                                                kind: 'Field',
                                                metadata: {
                                                    isGenerated: true,
                                                    isRequisite: true
                                                },
                                                type: 'ID'
                                            }],
                                            fieldName: 'seller',
                                            kind: 'Field',
                                            metadata: {
                                                canHaveSubselections: true,
                                                inferredRootCallName: 'node',
                                                inferredPrimaryKey: 'id'
                                            },
                                            type: 'Seller'
                                        }, {
                                            fieldName: 'id',
                                            kind: 'Field',
                                            metadata: {
                                                isGenerated: true,
                                                isRequisite: true
                                            },
                                            type: 'ID'
                                        }],
                                        fieldName: 'otherMember',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            inferredRootCallName: 'node',
                                            inferredPrimaryKey: 'id'
                                        },
                                        type: 'ConversationMember'
                                    }, {
                                        fieldName: 'latestMessage',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'latestMessageReceivedAt',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'node',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        inferredRootCallName: 'node',
                                        inferredPrimaryKey: 'id',
                                        isRequisite: true
                                    },
                                    type: 'Conversation'
                                }, {
                                    fieldName: 'cursor',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'String'
                                }],
                                fieldName: 'edges',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'ConversationEdge'
                            }, {
                                children: [{
                                    fieldName: 'hasNextPage',
                                    kind: 'Field',
                                    metadata: {
                                        isRequisite: true
                                    },
                                    type: 'Boolean'
                                }, {
                                    fieldName: 'hasPreviousPage',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'Boolean'
                                }],
                                fieldName: 'pageInfo',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isRequisite: true
                                },
                                type: 'PageInfo'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'fetchNotifications'
                                    }
                                }]
                            }],
                            fieldName: 'conversations',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'ConversationConnection'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'Notifications_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    },
    user: {
        modern: function modern() {
            return __webpack_require__("./src/components/Notifications/__generated__/Notifications_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'code',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'SAVE15'
                                }
                            }],
                            fieldName: 'isPromoCodeEligible',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'Notifications_user',
                        type: 'User'
                    };
                }()
            };
        }
    }
}, {
    modern: function modern() {
        return __webpack_require__("./src/components/Notifications/__generated__/NotificationsRefetchQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var Notifications_viewer_args1 = (Notifications.__container__ || Notifications).getFragment('viewer', {
            first: {
                kind: 'CallVariable',
                callVariableName: 'first'
            },
            fetchNotifications: {
                kind: 'CallVariable',
                callVariableName: 'fetchNotifications'
            }
        });
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'first'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'fetchNotifications'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userId'
            }],
            name: 'NotificationsRefetchQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(Notifications_viewer_args1)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'NotificationsRefetchQuery',
                    type: 'Query'
                };
            }()
        };
    }
});

/***/ }),

/***/ "./src/components/Notifications/NotificationsEmpty.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _NotificationsStyle = __webpack_require__("./src/components/Notifications/Notifications-style.scss");

var _NotificationsStyle2 = _interopRequireDefault(_NotificationsStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationsEmpty = function NotificationsEmpty() {
    return _react2.default.createElement(
        'div',
        { className: _NotificationsStyle2.default.emptyContainer },
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'dbl.Header.Notifications.empty_content',
                defaultMessage: 'We\'ll notify you of new and unread messages here!'
            })
        )
    );
};

exports.default = NotificationsEmpty;

/***/ }),

/***/ "./src/components/Notifications/NotificationsIcon.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _alertBell = __webpack_require__("./node_modules/dibs-vg/dist/react/alert-bell.js");

var _alertBell2 = _interopRequireDefault(_alertBell);

var _NotificationsStyle = __webpack_require__("./src/components/Notifications/Notifications-style.scss");

var _NotificationsStyle2 = _interopRequireDefault(_NotificationsStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NotificationsIcon = function NotificationsIcon(props) {
    var onMouseEnter = props.onMouseEnter,
        hasUnread = props.hasUnread;


    var alertBellIconClasses = (0, _classnames3.default)(_NotificationsStyle2.default.icon, _defineProperty({}, _NotificationsStyle2.default.hasUnread, hasUnread));

    var iconWrapperProps = {
        className: _NotificationsStyle2.default.iconWrapper
    };

    if (onMouseEnter) {
        iconWrapperProps = _extends({}, iconWrapperProps, { onMouseEnter: onMouseEnter });
    }

    return _react2.default.createElement(
        'div',
        iconWrapperProps,
        _react2.default.createElement(
            'span',
            { 'data-tn': 'notifications-link', className: alertBellIconClasses },
            _react2.default.createElement(_alertBell2.default, null)
        )
    );
};

NotificationsIcon.defaultProps = {
    hasUnread: false
};

exports.default = NotificationsIcon;

/***/ }),

/***/ "./src/components/Notifications/NotificationsList.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _NotificationsSpinner = __webpack_require__("./src/components/Notifications/NotificationsSpinner.jsx");

var _NotificationsSpinner2 = _interopRequireDefault(_NotificationsSpinner);

var _NotificationCard = __webpack_require__("./src/components/Notifications/NotificationCard.jsx");

var _NotificationCard2 = _interopRequireDefault(_NotificationCard);

var _InfiniteScroll = __webpack_require__("./src/components/Notifications/InfiniteScroll.jsx");

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _email = __webpack_require__("./node_modules/dibs-vg/dist/react/email.js");

var _email2 = _interopRequireDefault(_email);

var _NotificationsPromoCode = __webpack_require__("./src/components/Notifications/NotificationsPromoCode.jsx");

var _NotificationsPromoCode2 = _interopRequireDefault(_NotificationsPromoCode);

var _NotificationsStyle = __webpack_require__("./src/components/Notifications/Notifications-style.scss");

var _NotificationsStyle2 = _interopRequireDefault(_NotificationsStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getConversationsURL = function getConversationsURL(conversationID) {
    return '/my/conversations/' + conversationID;
};

var NotificationsList = function NotificationsList(_ref) {
    var conversationEdges = _ref.conversationEdges,
        loadMore = _ref.loadMore,
        hasMore = _ref.hasMore,
        isPromoCodeEligible = _ref.isPromoCodeEligible;

    var notificationNodes = conversationEdges.map(function (_ref2) {
        var node = _ref2.node;

        var dealerName = (0, _lodash2.default)(node, 'otherMember.seller.sellerProfile.company') || _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'dbl.Header.Notifications.dealer_name',
            defaultMessage: '1stdibs Seller'
        });
        return _react2.default.createElement(_NotificationCard2.default, {
            key: node.serviceId,
            thumbnail: node.inboxImage,
            thumbnailAlt: (0, _lodash2.default)(node, 'item.title'),
            subject: '' + dealerName,
            actionTitle: node.latestMessage,
            date: node.latestMessageReceivedAt,
            onClick: function onClick() {
                window.location.href = getConversationsURL(node.serviceId);
            },
            rightSecondary: _react2.default.createElement(
                'div',
                { className: _NotificationsStyle2.default.emailIcon },
                _react2.default.createElement(_email2.default, null)
            )
        });
    });

    return _react2.default.createElement(
        _InfiniteScroll2.default,
        {
            loadMore: loadMore,
            hasMore: hasMore,
            loader: _react2.default.createElement(_NotificationsSpinner2.default, { key: 'notificationsLoading', size: 'small', hideOverlay: true })
        },
        notificationNodes,
        isPromoCodeEligible && _react2.default.createElement(_NotificationsPromoCode2.default, null)
    );
};

NotificationsList.defaultProps = {
    isPromoCodeEligible: false
};

exports.default = NotificationsList;

/***/ }),

/***/ "./src/components/Notifications/NotificationsPromoCode.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _promoCode = __webpack_require__("./src/utils/promoCode.es.js");

var _NotificationsPromoCode = __webpack_require__("./src/components/Notifications/NotificationsPromoCode.scss");

var _NotificationsPromoCode2 = _interopRequireDefault(_NotificationsPromoCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationsPromoCode = function NotificationsPromoCode() {

    return _react2.default.createElement(
        'div',
        { className: _NotificationsPromoCode2.default.row },
        _react2.default.createElement(
            'div',
            { className: _NotificationsPromoCode2.default.description },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'dbl.NotificationsPromoCode.description',
                defaultMessage: 'Exclusive Offer: Save {discount}% on your first purchase',
                values: { discount: _promoCode.discount }
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _NotificationsPromoCode2.default.codeContainer },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'dbl.NotificationsPromoCode.codeText',
                defaultMessage: 'Code:'
            }),
            _react2.default.createElement(
                'span',
                { className: _NotificationsPromoCode2.default.code },
                _promoCode.code
            ),
            _react2.default.createElement(
                'a',
                { href: '/promotions/terms/?promo=' + _promoCode.code },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'dbl.NotificationsPromoCode.details',
                    defaultMessage: 'See Details'
                })
            )
        )
    );
};

exports.default = NotificationsPromoCode;

/***/ }),

/***/ "./src/components/Notifications/NotificationsPromoCode.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"NotificationsPromoCode__row__628cd0f8","description":"NotificationsPromoCode__description__628cd0f8","codeContainer":"NotificationsPromoCode__codeContainer__628cd0f8","code":"NotificationsPromoCode__code__628cd0f8 NotificationsPromoCode__description__628cd0f8"};

/***/ }),

/***/ "./src/components/Notifications/NotificationsSpinner.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _dibsOverlaySpinner = __webpack_require__("./node_modules/dibs-overlay-spinner/dist/index.js");

var _dibsOverlaySpinner2 = _interopRequireDefault(_dibsOverlaySpinner);

var _NotificationsStyle = __webpack_require__("./src/components/Notifications/Notifications-style.scss");

var _NotificationsStyle2 = _interopRequireDefault(_NotificationsStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NotificationsSpinner = function NotificationsSpinner(_ref) {
    var size = _ref.size,
        isBlock = _ref.isBlock,
        hideOverlay = _ref.hideOverlay;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames3.default)(_NotificationsStyle2.default.spinnerContainer, _defineProperty({}, _NotificationsStyle2.default.spinnerBlock, isBlock)) },
        _react2.default.createElement(_dibsOverlaySpinner2.default, {
            additionalOverlayClasses: hideOverlay ? _NotificationsStyle2.default.hideOverlay : '',
            additionalWrapperClasses: _NotificationsStyle2.default.spinnerWrapper,
            position: 'isStatic',
            size: size
        })
    );
};

exports.default = NotificationsSpinner;

/***/ }),

/***/ "./src/components/Notifications/__generated__/NotificationsRefetchQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 09d5c57342fd13b400bf708150328705
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type NotificationsRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query NotificationsRefetchQuery(
  $first: Int
  $fetchNotifications: Boolean!
  $userId: String!
) {
  viewer {
    ...Notifications_viewer_24uArK
    id
  }
}

fragment Notifications_viewer_24uArK on Viewer {
  conversations(filter: "showUnreadOnly", first: $first) @include(if: $fetchNotifications) {
    edges {
      node {
        serviceId
        inboxImage
        otherMember(currentUserId: $userId) {
          seller {
            sellerProfile {
              company
            }
            id
          }
          id
        }
        latestMessage
        latestMessageReceivedAt
        id
      }
    }
    pageInfo {
      hasNextPage
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchNotifications",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsRefetchQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "Notifications_viewer",
        "args": [{
          "kind": "Variable",
          "name": "fetchNotifications",
          "variableName": "fetchNotifications",
          "type": null
        }, {
          "kind": "Variable",
          "name": "first",
          "variableName": "first",
          "type": null
        }]
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "NotificationsRefetchQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchNotifications",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "NotificationsRefetchQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "fetchNotifications",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Literal",
            "name": "filter",
            "value": "showUnreadOnly",
            "type": "String"
          }, {
            "kind": "Variable",
            "name": "first",
            "variableName": "first",
            "type": "Int"
          }],
          "concreteType": "ConversationConnection",
          "name": "conversations",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "ConversationEdge",
            "name": "edges",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Conversation",
              "name": "node",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "serviceId",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "inboxImage",
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": [{
                  "kind": "Variable",
                  "name": "currentUserId",
                  "variableName": "userId",
                  "type": "String!"
                }],
                "concreteType": "ConversationMember",
                "name": "otherMember",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "Seller",
                  "name": "seller",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "SellerProfile",
                    "name": "sellerProfile",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "company",
                      "storageKey": null
                    }],
                    "storageKey": null
                  }, {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }],
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "latestMessage",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "latestMessageReceivedAt",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "name": "pageInfo",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "hasNextPage",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query NotificationsRefetchQuery(\n  $first: Int\n  $fetchNotifications: Boolean!\n  $userId: String!\n) {\n  viewer {\n    ...Notifications_viewer_24uArK\n    id\n  }\n}\n\nfragment Notifications_viewer_24uArK on Viewer {\n  conversations(filter: \"showUnreadOnly\", first: $first) @include(if: $fetchNotifications) {\n    edges {\n      node {\n        serviceId\n        inboxImage\n        otherMember(currentUserId: $userId) {\n          seller {\n            sellerProfile {\n              company\n            }\n            id\n          }\n          id\n        }\n        latestMessage\n        latestMessageReceivedAt\n        id\n      }\n    }\n    pageInfo {\n      hasNextPage\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/Notifications/__generated__/Notifications_initialViewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Notifications_initialViewer = {|
  +conversations?: ?{|
    +metadata: ?{|
      +lastUnreadMessageDate: ?string;
    |};
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "hasUserId",
    "type": "Boolean"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "Notifications_initialViewer",
  "selections": [{
    "kind": "Condition",
    "passingValue": true,
    "condition": "hasUserId",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Literal",
        "name": "filter",
        "value": "showUnreadOnly",
        "type": "String"
      }],
      "concreteType": "ConversationConnection",
      "name": "conversations",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "ConversationMetadata",
        "name": "metadata",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "lastUnreadMessageDate",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": "conversations{\"filter\":\"showUnreadOnly\"}"
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/Notifications/__generated__/Notifications_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Notifications_user = {|
  +isPromoCodeEligible: ?boolean;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Notifications_user",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": [{
      "kind": "Literal",
      "name": "code",
      "value": "SAVE15",
      "type": "String!"
    }],
    "name": "isPromoCodeEligible",
    "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/Notifications/__generated__/Notifications_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Notifications_viewer = {|
  +conversations?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +serviceId: ?string;
        +inboxImage: ?string;
        +otherMember: ?{|
          +seller: ?{|
            +sellerProfile: ?{|
              +company: ?string;
            |};
          |};
        |};
        +latestMessage: ?string;
        +latestMessageReceivedAt: ?string;
      |};
    |}>;
    +pageInfo: {|
      +hasNextPage: boolean;
    |};
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": 5
  }, {
    "kind": "LocalArgument",
    "name": "fetchNotifications",
    "type": "Boolean!",
    "defaultValue": false
  }, {
    "kind": "RootArgument",
    "name": "userId",
    "type": "String!"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "Notifications_viewer",
  "selections": [{
    "kind": "Condition",
    "passingValue": true,
    "condition": "fetchNotifications",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Literal",
        "name": "filter",
        "value": "showUnreadOnly",
        "type": "String"
      }, {
        "kind": "Variable",
        "name": "first",
        "variableName": "first",
        "type": "Int"
      }],
      "concreteType": "ConversationConnection",
      "name": "conversations",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "ConversationEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Conversation",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "inboxImage",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": [{
              "kind": "Variable",
              "name": "currentUserId",
              "variableName": "userId",
              "type": "String!"
            }],
            "concreteType": "ConversationMember",
            "name": "otherMember",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Seller",
              "name": "seller",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "SellerProfile",
                "name": "sellerProfile",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "company",
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "latestMessage",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "latestMessageReceivedAt",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "name": "pageInfo",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "hasNextPage",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/SearchBar/ClearButton.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _close = __webpack_require__("./node_modules/dibs-vg/dist/react/close.js");

var _close2 = _interopRequireDefault(_close);

var _SearchBarStyle = __webpack_require__("./src/components/SearchBar/SearchBar-style.scss");

var _SearchBarStyle2 = _interopRequireDefault(_SearchBarStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var ClearButton = function ClearButton(_ref) {
    var onClick = _ref.onClick;

    return _react2.default.createElement(
        'div',
        {
            className: _SearchBarStyle2.default.button,
            onClick: onClick
        },
        _react2.default.createElement(
            'div',
            { className: _SearchBarStyle2.default.icon + ' ' + _SearchBarStyle2.default.clear },
            _react2.default.createElement(_close2.default, null)
        )
    );
};

// Styles
exports.default = ClearButton;

/***/ }),

/***/ "./src/components/SearchBar/SearchBar-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SearchBar-style__wrapper__9443a340","form":"SearchBar-style__form__9443a340","input":"SearchBar-style__input__9443a340","hasTerm":"SearchBar-style__hasTerm__9443a340","button":"SearchBar-style__button__9443a340","icon":"SearchBar-style__icon__9443a340","clear":"SearchBar-style__clear__9443a340","overlayWrapper":"SearchBar-style__overlayWrapper__9443a340","overlay":"SearchBar-style__overlay__9443a340","isVisible":"SearchBar-style__isVisible__9443a340","section":"SearchBar-style__section__9443a340","header":"SearchBar-style__header__9443a340","item":"SearchBar-style__item__9443a340","link":"SearchBar-style__link__9443a340"};

/***/ }),

/***/ "./src/components/SearchBar/SearchBar.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchBar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _SearchBarOverlay = __webpack_require__("./src/components/SearchBar/SearchBarOverlay.jsx");

var _SearchBarOverlay2 = _interopRequireDefault(_SearchBarOverlay);

var _SearchButton = __webpack_require__("./src/components/SearchBar/SearchButton.jsx");

var _SearchButton2 = _interopRequireDefault(_SearchButton);

var _ClearButton = __webpack_require__("./src/components/SearchBar/ClearButton.jsx");

var _ClearButton2 = _interopRequireDefault(_ClearButton);

var _searchBarConstants = __webpack_require__("./src/components/SearchBar/searchBarConstants.js");

var _debounce = __webpack_require__("./src/utils/debounce.js");

var _debounce2 = _interopRequireDefault(_debounce);

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _SearchBarStyle = __webpack_require__("./src/components/SearchBar/SearchBar-style.scss");

var _SearchBarStyle2 = _interopRequireDefault(_SearchBarStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var messages = (0, _reactIntl.defineMessages)({
    placeholder: {
        'id': 'dbl.Header.SearchBar.placeholder',
        'defaultMessage': 'Search for items, creators, or styles'
    }
});

var SearchBar = exports.SearchBar = function (_React$Component) {
    _inherits(SearchBar, _React$Component);

    function SearchBar(props) {
        _classCallCheck(this, SearchBar);

        var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));

        _this.state = {
            value: '',
            focused: false,
            hovered: false
        };

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleRowClick = _this.handleRowClick.bind(_this);
        _this.handleClearSearch = _this.handleClearSearch.bind(_this);
        _this.fetchSuggestions = (0, _debounce2.default)(_this.fetchSuggestions.bind(_this), 250);

        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.onMouseOver = _this.onMouseOver.bind(_this);
        _this.onMouseOut = _this.onMouseOut.bind(_this);
        return _this;
    }

    _createClass(SearchBar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.input.addEventListener('focus', this.onFocus);
            this.input.addEventListener('blur', this.onBlur);
            this.overlayWrapper.addEventListener('mouseover', this.onMouseOver);
            this.overlayWrapper.addEventListener('mouseout', this.onMouseOut);
            this.setSearchTermFromParams();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.viewer.searchSuggestions && !prevProps.viewer.searchSuggestions) {
                (0, _dibsTracking.trackEvent)({
                    category: _searchBarConstants.TRACKING.CATEGORY,
                    action: 'search suggestion displayed',
                    label: 'none'
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.input.removeEventListener('focus', this.onFocus);
            this.input.removeEventListener('blur', this.onBlur);
            this.overlayWrapper.removeEventListener('mouseover', this.onMouseOver);
            this.overlayWrapper.removeEventListener('mouseout', this.onMouseOut);
        }
    }, {
        key: 'setSearchTermFromParams',
        value: function setSearchTermFromParams() {
            var queryString = location.search ? location.search.split('?')[1] : '';
            var searchTermFromParams = decodeURIComponent(_querystring2.default.parse(queryString)[_searchBarConstants.SEARCH_QUERY_PARAM]);
            if (location.href.indexOf(_searchBarConstants.SEARCH_PAGE_PATH) !== -1 && searchTermFromParams) {
                this.setState({ value: searchTermFromParams });
            }
        }
    }, {
        key: 'onFocus',
        value: function onFocus() {
            this.setState({ focused: true });
        }
    }, {
        key: 'onBlur',
        value: function onBlur() {
            this.setState({ focused: false });
        }
    }, {
        key: 'onMouseOver',
        value: function onMouseOver() {
            this.setState({ hovered: true });
        }
    }, {
        key: 'onMouseOut',
        value: function onMouseOut() {
            this.setState({ hovered: false });
        }
    }, {
        key: 'handleRowClick',
        value: function handleRowClick(value, href) {
            var label = this.props.viewer.searchSuggestions ? 'global search|auto-complete selected' : 'recent search';
            this.input.value = value;
            this.setState({ value: value, focused: false, hovered: false });

            (0, _dibsTracking.trackEvent)({
                category: _searchBarConstants.TRACKING.CATEGORY,
                action: _searchBarConstants.TRACKING.ACTION,
                label: label
            });

            location.href = href;
        }
    }, {
        key: 'handleKeyDown',
        value: function handleKeyDown(event) {
            if (event.keyCode === 27) {
                this.input.blur();
                this.setState({ visible: false });
            }
        }
    }, {
        key: 'handleChange',
        value: function handleChange(event) {
            var value = event.target.value || '';
            this.setState({ value: value }, this.fetchSuggestions);
        }
    }, {
        key: 'handleClearSearch',
        value: function handleClearSearch() {
            this.setState({ value: '' });
        }
    }, {
        key: 'fetchSuggestions',
        value: function fetchSuggestions() {
            var value = this.state.value;
            var hasRootPendingRefetch = this.props.hasRootPendingRefetch;

            if (!hasRootPendingRefetch) {
                this.props.relay.refetch(function () {
                    return {
                        hasQuery: value.length > 1,
                        query: value.toLowerCase()

                    };
                }, null);
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(event) {
            event.preventDefault();
            var term = this.state.value;

            var urlLabel = void 0;

            if (term) {
                urlLabel = location.origin + '/search/?q=' + encodeURIComponent(term.toLowerCase());
                (0, _dibsTracking.trackEvent)({
                    category: _searchBarConstants.TRACKING.CATEGORY,
                    action: _searchBarConstants.TRACKING.ACTION,
                    label: 'global search'
                });
                this.handleRecentStorage(term, urlLabel);
                location.href = urlLabel;
            }
        }
    }, {
        key: 'handleRecentStorage',
        value: function handleRecentStorage(term, urlLabel) {
            var search = { term: term, urlLabel: urlLabel };
            var recentSearches = _dibsBrowserStorage.localStorage.getItem(_searchBarConstants.RECENT_SEARCHES.LOCAL_STORAGE) || [];
            var recentTerms = [];

            if (!recentSearches.length) {
                recentSearches = [{
                    type: _searchBarConstants.RECENT_SEARCHES.TYPE,
                    terms: [search]
                }];
            } else {
                recentTerms = recentSearches[0].terms;
                if (recentTerms.length === _searchBarConstants.RECENT_SEARCHES.MAX_TERMS) {
                    recentTerms.pop();
                }
                recentTerms.unshift(search);
            }

            _dibsBrowserStorage.localStorage.setItem(_searchBarConstants.RECENT_SEARCHES.LOCAL_STORAGE, JSON.stringify(recentSearches));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                intl = _props.intl,
                isClient = _props.isClient,
                viewer = _props.viewer;
            var value = this.state.value;

            var _ref = viewer.searchSuggestions || {},
                suggestions = _ref.suggestions;

            var recentSearches = _dibsBrowserStorage.localStorage.getItem(_searchBarConstants.RECENT_SEARCHES.LOCAL_STORAGE) || [];
            var visible = this.state.focused || this.state.hovered;

            var inputClasses = (0, _classnames3.default)(_SearchBarStyle2.default.input, _defineProperty({}, _SearchBarStyle2.default.hasTerm, !!value));

            return _react2.default.createElement(
                'div',
                { className: _SearchBarStyle2.default.wrapper },
                _react2.default.createElement(
                    'form',
                    { className: _SearchBarStyle2.default.form, action: '/search/', onSubmit: this.handleSubmit },
                    _react2.default.createElement('input', {
                        ref: function ref(input) {
                            _this2.input = input;
                        },
                        autoCorrect: 'off',
                        autoCapitalize: 'off',
                        autoComplete: 'off',
                        spellCheck: 'false',
                        className: inputClasses,
                        type: 'text',
                        name: 'q',
                        placeholder: intl.formatMessage(messages.placeholder),
                        value: value,
                        onChange: this.handleChange,
                        onKeyDown: this.handleKeyDown,
                        'data-tn': 'global-header-search-input'
                    }),
                    value && _react2.default.createElement(_ClearButton2.default, { onClick: this.handleClearSearch }),
                    _react2.default.createElement(_SearchButton2.default, { hasSearchTerm: !!value })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _SearchBarStyle2.default.overlayWrapper, ref: function ref(overlayWrapper) {
                            _this2.overlayWrapper = overlayWrapper;
                        } },
                    isClient ? _react2.default.createElement(_SearchBarOverlay2.default, {
                        handleRowClick: this.handleRowClick,
                        visible: visible,
                        suggestions: suggestions || recentSearches
                    }) : null
                )
            );
        }
    }]);

    return SearchBar;
}(_react2.default.Component);

exports.default = (0, _reactRelay.createRefetchContainer)((0, _reactIntl.injectIntl)(SearchBar), {
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/SearchBar/__generated__/SearchBar_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    defaultValue: '',
                    kind: 'LocalArgument',
                    name: 'query'
                }, {
                    defaultValue: false,
                    kind: 'LocalArgument',
                    name: 'hasQuery'
                }],
                node: function () {
                    return {
                        children: [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'query',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'query'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {},
                                name: 'includeTypes',
                                value: [{
                                    kind: 'CallValue',
                                    callValue: 'POPULAR'
                                }, {
                                    kind: 'CallValue',
                                    callValue: 'SELLER'
                                }]
                            }],
                            children: [{
                                children: [{
                                    fieldName: 'type',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    children: [{
                                        fieldName: 'term',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'urlLabel',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }],
                                    fieldName: 'terms',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        isPlural: true
                                    },
                                    type: 'SearchSuggestionTerm'
                                }],
                                fieldName: 'suggestions',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'SearchSuggestionList'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasQuery'
                                    }
                                }]
                            }],
                            fieldName: 'searchSuggestions',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'SearchSuggestion'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'SearchBar_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    }
}, {
    modern: function modern() {
        return __webpack_require__("./src/components/SearchBar/__generated__/SearchBarRefetchQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var SearchBar_viewer_args1 = (SearchBar.__container__ || SearchBar).getFragment('viewer', {
            query: {
                kind: 'CallVariable',
                callVariableName: 'query'
            },
            hasQuery: {
                kind: 'CallVariable',
                callVariableName: 'hasQuery'
            }
        });
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'query'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'hasQuery'
            }],
            name: 'SearchBarRefetchQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(SearchBar_viewer_args1)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'SearchBarRefetchQuery',
                    type: 'Query'
                };
            }()
        };
    }
});

/***/ }),

/***/ "./src/components/SearchBar/SearchBarOverlay.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _SearchBarSection = __webpack_require__("./src/components/SearchBar/SearchBarSection.jsx");

var _SearchBarSection2 = _interopRequireDefault(_SearchBarSection);

var _searchBarHelpers = __webpack_require__("./src/components/SearchBar/searchBarHelpers.js");

var _SearchBarStyle = __webpack_require__("./src/components/SearchBar/SearchBar-style.scss");

var _SearchBarStyle2 = _interopRequireDefault(_SearchBarStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SearchBarOverlay = function SearchBarOverlay(_ref) {
    var _classnames;

    var visible = _ref.visible,
        suggestions = _ref.suggestions,
        handleRowClick = _ref.handleRowClick;

    var overlayClasses = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _SearchBarStyle2.default.overlay, true), _defineProperty(_classnames, _SearchBarStyle2.default.isVisible, visible), _classnames));

    if (!suggestions) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: overlayClasses },
        suggestions.map(function (section) {
            var _getSectionPropsByTyp = (0, _searchBarHelpers.getSectionPropsByType)(section.type),
                title = _getSectionPropsByTyp.title,
                urlSection = _getSectionPropsByTyp.urlSection;

            var terms = section.terms;

            return terms && terms.length ? _react2.default.createElement(_SearchBarSection2.default, {
                key: title,
                title: title,
                urlSection: urlSection,
                terms: terms,
                handleRowClick: handleRowClick
            }) : null;
        })
    );
};

exports.default = SearchBarOverlay;

/***/ }),

/***/ "./src/components/SearchBar/SearchBarSection.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _SearchBarTerm = __webpack_require__("./src/components/SearchBar/SearchBarTerm.jsx");

var _SearchBarTerm2 = _interopRequireDefault(_SearchBarTerm);

var _SearchBarStyle = __webpack_require__("./src/components/SearchBar/SearchBar-style.scss");

var _SearchBarStyle2 = _interopRequireDefault(_SearchBarStyle);

var _searchBarHelpers = __webpack_require__("./src/components/SearchBar/searchBarHelpers.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBarSection = function SearchBarSection(_ref) {
    var urlSection = _ref.urlSection,
        title = _ref.title,
        terms = _ref.terms,
        handleRowClick = _ref.handleRowClick;
    return _react2.default.createElement(
        'div',
        { className: _SearchBarStyle2.default.section },
        _react2.default.createElement(
            'div',
            { className: _SearchBarStyle2.default.header },
            title
        ),
        terms.map(function (_ref2) {
            var term = _ref2.term,
                urlLabel = _ref2.urlLabel;

            var href = (0, _searchBarHelpers.createSearchLink)(term, urlSection, urlLabel);
            return _react2.default.createElement(_SearchBarTerm2.default, {
                key: term,
                term: term,
                href: href,
                handleRowClick: handleRowClick
            });
        })
    );
};

exports.default = SearchBarSection;

/***/ }),

/***/ "./src/components/SearchBar/SearchBarTerm.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _SearchBarStyle = __webpack_require__("./src/components/SearchBar/SearchBar-style.scss");

var _SearchBarStyle2 = _interopRequireDefault(_SearchBarStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBarTerm = function SearchBarTerm(_ref) {
    var href = _ref.href,
        term = _ref.term,
        handleRowClick = _ref.handleRowClick;
    return _react2.default.createElement(
        'div',
        { className: _SearchBarStyle2.default.item },
        _react2.default.createElement(
            'span',
            {
                className: _SearchBarStyle2.default.link,
                onClick: function onClick() {
                    handleRowClick(term, href);
                }
            },
            term
        )
    );
};

exports.default = SearchBarTerm;

/***/ }),

/***/ "./src/components/SearchBar/SearchButton.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _magnifyingGlass = __webpack_require__("./node_modules/dibs-vg/dist/react/magnifying-glass.js");

var _magnifyingGlass2 = _interopRequireDefault(_magnifyingGlass);

var _SearchBarStyle = __webpack_require__("./src/components/SearchBar/SearchBar-style.scss");

var _SearchBarStyle2 = _interopRequireDefault(_SearchBarStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Components


// Styles


var SearchButton = function SearchButton(_ref) {
    var hasSearchTerm = _ref.hasSearchTerm;

    var iconClasses = (0, _classnames3.default)(_SearchBarStyle2.default.icon, _defineProperty({}, _SearchBarStyle2.default.hasTerm, hasSearchTerm));

    return _react2.default.createElement(
        'button',
        {
            className: _SearchBarStyle2.default.button,
            type: 'submit',
            value: 'Submit',
            'data-tn': 'global-header-search-submit'
        },
        _react2.default.createElement(
            'div',
            { className: iconClasses },
            _react2.default.createElement(_magnifyingGlass2.default, null)
        )
    );
};

SearchButton.defaultProps = {
    hasSearchTerm: false
};

exports.default = SearchButton;

/***/ }),

/***/ "./src/components/SearchBar/__generated__/SearchBarRefetchQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 1312e5308764fe9d3cf30034dbe79e37
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SearchBarRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query SearchBarRefetchQuery(
  $query: String!
  $hasQuery: Boolean!
) {
  viewer {
    ...SearchBar_viewer_4cP5Kl
    id
  }
}

fragment SearchBar_viewer_4cP5Kl on Viewer {
  searchSuggestions(query: $query, includeTypes: ["POPULAR", "SELLER"]) @include(if: $hasQuery) {
    suggestions {
      type
      terms {
        term
        urlLabel
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "query",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasQuery",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "SearchBarRefetchQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "SearchBar_viewer",
        "args": [{
          "kind": "Variable",
          "name": "hasQuery",
          "variableName": "hasQuery",
          "type": null
        }, {
          "kind": "Variable",
          "name": "query",
          "variableName": "query",
          "type": null
        }]
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "SearchBarRefetchQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "query",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasQuery",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "SearchBarRefetchQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasQuery",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Literal",
            "name": "includeTypes",
            "value": ["POPULAR", "SELLER"],
            "type": "[String]"
          }, {
            "kind": "Variable",
            "name": "query",
            "variableName": "query",
            "type": "String!"
          }],
          "concreteType": "SearchSuggestion",
          "name": "searchSuggestions",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "SearchSuggestionList",
            "name": "suggestions",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "type",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "SearchSuggestionTerm",
              "name": "terms",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "term",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "urlLabel",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query SearchBarRefetchQuery(\n  $query: String!\n  $hasQuery: Boolean!\n) {\n  viewer {\n    ...SearchBar_viewer_4cP5Kl\n    id\n  }\n}\n\nfragment SearchBar_viewer_4cP5Kl on Viewer {\n  searchSuggestions(query: $query, includeTypes: [\"POPULAR\", \"SELLER\"]) @include(if: $hasQuery) {\n    suggestions {\n      type\n      terms {\n        term\n        urlLabel\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/SearchBar/__generated__/SearchBar_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SearchBar_viewer = {|
  +searchSuggestions?: ?{|
    +suggestions: ?$ReadOnlyArray<?{|
      +type: ?string;
      +terms: ?$ReadOnlyArray<?{|
        +term: ?string;
        +urlLabel: ?string;
      |}>;
    |}>;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "query",
    "type": "String!",
    "defaultValue": ""
  }, {
    "kind": "LocalArgument",
    "name": "hasQuery",
    "type": "Boolean!",
    "defaultValue": false
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchBar_viewer",
  "selections": [{
    "kind": "Condition",
    "passingValue": true,
    "condition": "hasQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Literal",
        "name": "includeTypes",
        "value": ["POPULAR", "SELLER"],
        "type": "[String]"
      }, {
        "kind": "Variable",
        "name": "query",
        "variableName": "query",
        "type": "String!"
      }],
      "concreteType": "SearchSuggestion",
      "name": "searchSuggestions",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "SearchSuggestionList",
        "name": "suggestions",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "type",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "SearchSuggestionTerm",
          "name": "terms",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "term",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "urlLabel",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/SearchBar/searchBarConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SECTIONS_BY_TYPE = {
    'RECENT': {
        title: 'Recent Searches',
        urlSection: null
    },
    'POPULAR': {
        title: 'Popular Searches',
        urlSection: null
    },
    'CREATOR': {
        title: 'Creators',
        urlSection: 'creators'
    },
    'STYLE': {
        title: 'Styles',
        urlSection: 'styles'
    },
    'SELLER': {
        title: 'Dealers',
        urlSection: 'dealers'
    }
};

var RECENT_SEARCHES = {
    TYPE: 'RECENT',
    LOCAL_STORAGE: 'recentSearches',
    MAX_TERMS: 6
};

var SEARCH_PAGE_PATH = '/search/';

var SEARCH_QUERY_PARAM = 'q';

var TRACKING = {
    CATEGORY: 'navigation',
    ACTION: 'header navigation click'
};

exports.SECTIONS_BY_TYPE = SECTIONS_BY_TYPE;
exports.RECENT_SEARCHES = RECENT_SEARCHES;
exports.SEARCH_PAGE_PATH = SEARCH_PAGE_PATH;
exports.SEARCH_QUERY_PARAM = SEARCH_QUERY_PARAM;
exports.TRACKING = TRACKING;

/***/ }),

/***/ "./src/components/SearchBar/searchBarHelpers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createSearchLink = exports.getSectionPropsByType = undefined;

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _searchBarConstants = __webpack_require__("./src/components/SearchBar/searchBarConstants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSectionPropsByType = function getSectionPropsByType(type) {
    return (0, _lodash2.default)(_searchBarConstants.SECTIONS_BY_TYPE, type) || {};
};

// analytics needs full `term` value for dealer storefront click through
var createSearchLink = function createSearchLink(term, urlSection, urlLabel) {
    var convertedValue = encodeURIComponent(term.toLowerCase());
    var href = urlSection && urlLabel ? '/' + urlSection + '/' + urlLabel + '/?search=' + convertedValue : '/search/?q=' + convertedValue;

    return href;
};

exports.getSectionPropsByType = getSectionPropsByType;
exports.createSearchLink = createSearchLink;

/***/ }),

/***/ "./src/components/SiteNav/SiteNav-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SiteNav-style__wrapper__75368980","items":"SiteNav-style__items__75368980","item":"SiteNav-style__item__75368980","itemLink":"SiteNav-style__itemLink__75368980","dropdownContent":"SiteNav-style__dropdownContent__75368980","dropdownHeader":"SiteNav-style__dropdownHeader__75368980 Dropdown-style__headerTitle__296ffdc0","dropdownCol":"SiteNav-style__dropdownCol__75368980","dropdownSection":"SiteNav-style__dropdownSection__75368980","dropdownLink":"SiteNav-style__dropdownLink__75368980"};

/***/ }),

/***/ "./src/components/SiteNav/SiteNav.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _SiteNavItem = __webpack_require__("./src/components/SiteNav/SiteNavItem.jsx");

var _SiteNavItem2 = _interopRequireDefault(_SiteNavItem);

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _SiteNavStyle = __webpack_require__("./src/components/SiteNav/SiteNav-style.scss");

var _SiteNavStyle2 = _interopRequireDefault(_SiteNavStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SiteNav = function SiteNav(props) {
    return _react2.default.createElement(
        'div',
        { className: _SiteNavStyle2.default.wrapper },
        _react2.default.createElement(
            'div',
            { className: _SiteNavStyle2.default.items },
            (0, _lodash2.default)(props.navigation || {}, 'modules', []).map(function (module) {
                return _react2.default.createElement(_SiteNavItem2.default, _extends({ key: module.serviceId }, module));
            })
        )
    );
};

exports.default = (0, _reactRelay.createFragmentContainer)(SiteNav, {
    navigation: {
        modern: function modern() {
            return __webpack_require__("./src/components/SiteNav/__generated__/SiteNav_navigation.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            children: [{
                                fieldName: 'isVertical',
                                kind: 'Field',
                                metadata: {},
                                type: 'Boolean'
                            }, {
                                fieldName: 'serviceId',
                                kind: 'Field',
                                metadata: {},
                                type: 'ID'
                            }, {
                                fieldName: 'name',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'url',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                children: [{
                                    fieldName: 'serviceId',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'ID'
                                }, {
                                    fieldName: 'name',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    fieldName: 'type',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }, {
                                    children: [{
                                        fieldName: 'serviceId',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'ID'
                                    }, {
                                        fieldName: 'name',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'url',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'visible',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'Boolean'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'items',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        inferredRootCallName: 'node',
                                        inferredPrimaryKey: 'id',
                                        isPlural: true
                                    },
                                    type: 'NavigationItem'
                                }, {
                                    fieldName: 'id',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'ID'
                                }],
                                fieldName: 'items',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    inferredRootCallName: 'node',
                                    inferredPrimaryKey: 'id',
                                    isPlural: true
                                },
                                type: 'NavigationTopLevel'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'modules',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'NavigationModule'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'SiteNav_navigation',
                        type: 'Navigation'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/SiteNav/SiteNavDropdownColumn.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _SiteNavStyle = __webpack_require__("./src/components/SiteNav/SiteNav-style.scss");

var _SiteNavStyle2 = _interopRequireDefault(_SiteNavStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackingObj = {
    category: 'navigation',
    action: 'header navigation click'
};

var SiteNavDropdownColumn = function SiteNavDropdownColumn(_ref) {
    var items = _ref.items,
        trackingLabelPrefix = _ref.trackingLabelPrefix;
    return _react2.default.createElement(
        'div',
        { className: _SiteNavStyle2.default.dropdownCol },
        items.map(function (item) {
            return _react2.default.createElement(
                'div',
                { key: item.serviceId, className: _SiteNavStyle2.default.dropdownSection },
                item.name ? _react2.default.createElement(
                    'div',
                    { className: _SiteNavStyle2.default.dropdownHeader },
                    item.name
                ) : null,
                (item.items || []).map(function (_ref2) {
                    var visible = _ref2.visible,
                        url = _ref2.url,
                        name = _ref2.name,
                        serviceId = _ref2.serviceId;

                    var label = trackingLabelPrefix + '|' + item.name + '|' + name;
                    return visible ? _react2.default.createElement(
                        'div',
                        { key: serviceId },
                        _react2.default.createElement(
                            'a',
                            {
                                className: _SiteNavStyle2.default.dropdownLink,
                                href: url,
                                onClick: function onClick() {
                                    (0, _dibsTracking.trackEvent)(Object.assign({}, trackingObj, { label: label.toLowerCase() }));
                                },
                                'data-tn': 'global-nav-item-link-' + label.toLowerCase().replace(/[^a-zA-Z0-9]+/gi, '-')
                            },
                            name
                        )
                    ) : null;
                })
            );
        })
    );
};

exports.default = SiteNavDropdownColumn;

/***/ }),

/***/ "./src/components/SiteNav/SiteNavDropdownContent.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _SiteNavDropdownColumn = __webpack_require__("./src/components/SiteNav/SiteNavDropdownColumn.jsx");

var _SiteNavDropdownColumn2 = _interopRequireDefault(_SiteNavDropdownColumn);

var _SiteNavStyle = __webpack_require__("./src/components/SiteNav/SiteNav-style.scss");

var _SiteNavStyle2 = _interopRequireDefault(_SiteNavStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SiteNavDropdownContent = function SiteNavDropdownContent(_ref) {
    var moduleItems = _ref.items,
        trackingLabelPrefix = _ref.trackingLabelPrefix;


    var itemsCols = moduleItems.reduce(function (acc, moduleItem) {
        var type = moduleItem.type;


        switch (type) {
            case 'primary':
                acc.primary.push(moduleItem);
                break;
            default:
                acc.secondary.push(moduleItem);
        }
        return acc;
    }, { primary: [], secondary: [] });

    var primary = itemsCols.primary,
        secondary = itemsCols.secondary;


    return _react2.default.createElement(
        'div',
        { className: _SiteNavStyle2.default.dropdownContent },
        primary.length ? _react2.default.createElement(_SiteNavDropdownColumn2.default, {
            items: primary,
            trackingLabelPrefix: trackingLabelPrefix
        }) : null,
        secondary.length ? _react2.default.createElement(_SiteNavDropdownColumn2.default, {
            items: secondary,
            trackingLabelPrefix: trackingLabelPrefix
        }) : null
    );
};

exports.default = SiteNavDropdownContent;

/***/ }),

/***/ "./src/components/SiteNav/SiteNavItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _Dropdown = __webpack_require__("./src/components/Dropdown/Dropdown.jsx");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _SiteNavDropdownContent = __webpack_require__("./src/components/SiteNav/SiteNavDropdownContent.jsx");

var _SiteNavDropdownContent2 = _interopRequireDefault(_SiteNavDropdownContent);

var _SiteNavStyle = __webpack_require__("./src/components/SiteNav/SiteNav-style.scss");

var _SiteNavStyle2 = _interopRequireDefault(_SiteNavStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SiteNavItem = function (_React$Component) {
    _inherits(SiteNavItem, _React$Component);

    function SiteNavItem(props) {
        _classCallCheck(this, SiteNavItem);

        var _this = _possibleConstructorReturn(this, (SiteNavItem.__proto__ || Object.getPrototypeOf(SiteNavItem)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(SiteNavItem, [{
        key: 'handleClick',
        value: function handleClick() {
            var name = this.props.name;


            (0, _dibsTracking.trackEvent)({
                action: 'header navigation click',
                category: 'navigation',
                label: name.toLowerCase() + ' header link|' + name.toLowerCase()
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                url = _props.url,
                items = _props.items;

            return _react2.default.createElement(
                'div',
                { className: _SiteNavStyle2.default.item },
                _react2.default.createElement(
                    _Dropdown2.default,
                    { size: _Dropdown.sizeConstants.SIZE_EXTRA_LARGE },
                    _react2.default.createElement(
                        'a',
                        {
                            className: _SiteNavStyle2.default.itemLink,
                            href: url,
                            'data-tn': 'global-nav-item-link-' + name.toLowerCase().replace(/[^a-zA-Z0-9]+/gi, '-'),
                            onClick: this.handleClick
                        },
                        name
                    ),
                    items && items.length ? _react2.default.createElement(_SiteNavDropdownContent2.default, {
                        items: items,
                        trackingLabelPrefix: name
                    }) : null
                )
            );
        }
    }]);

    return SiteNavItem;
}(_react2.default.Component);

exports.default = SiteNavItem;

/***/ }),

/***/ "./src/components/SiteNav/__generated__/SiteNav_navigation.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SiteNav_navigation = {|
  +modules: ?$ReadOnlyArray<?{|
    +isVertical: ?boolean;
    +serviceId: ?string;
    +name: ?string;
    +url: ?string;
    +items: ?$ReadOnlyArray<?{|
      +serviceId: ?string;
      +name: ?string;
      +type: ?string;
      +items: ?$ReadOnlyArray<?{|
        +serviceId: ?string;
        +name: ?string;
        +url: ?string;
        +visible: ?boolean;
      |}>;
    |}>;
  |}>;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SiteNav_navigation",
  "selections": [{
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "NavigationModule",
    "name": "modules",
    "plural": true,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isVertical",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "name",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "url",
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "NavigationTopLevel",
      "name": "items",
      "plural": true,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "serviceId",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "name",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "type",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "NavigationItem",
        "name": "items",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "serviceId",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "url",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "visible",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "Navigation"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/TopBar/TopBar-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bar":"TopBar-style__bar__6a9d0f20 Header-style__bar__da67c0c0","disableSticky":"TopBar-style__disableSticky__6a9d0f20","barContent":"TopBar-style__barContent__6a9d0f20 Header-style__barContent__da67c0c0","leftContainer":"TopBar-style__leftContainer__6a9d0f20","rightContainer":"TopBar-style__rightContainer__6a9d0f20"};

/***/ }),

/***/ "./src/components/TopBar/TopBar.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _classnames2 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames3 = _interopRequireDefault(_classnames2);

var _constants = __webpack_require__("./src/actions/constants.js");

var _actions = __webpack_require__("./src/actions/index.js");

var _Logo = __webpack_require__("./src/components/Logo/Logo.jsx");

var _Logo2 = _interopRequireDefault(_Logo);

var _Notifications = __webpack_require__("./src/components/Notifications/Notifications.jsx");

var _Notifications2 = _interopRequireDefault(_Notifications);

var _SearchBar = __webpack_require__("./src/components/SearchBar/SearchBar.jsx");

var _SearchBar2 = _interopRequireDefault(_SearchBar);

var _AccountNav = __webpack_require__("./src/components/AccountNav/AccountNav.jsx");

var _AccountNav2 = _interopRequireDefault(_AccountNav);

var _Likes = __webpack_require__("./src/components/Likes/Likes.jsx");

var _Likes2 = _interopRequireDefault(_Likes);

var _CartNav = __webpack_require__("./src/components/CartNav/CartNav.jsx");

var _CartNav2 = _interopRequireDefault(_CartNav);

var _TopBarStyle = __webpack_require__("./src/components/TopBar/TopBar-style.scss");

var _TopBarStyle2 = _interopRequireDefault(_TopBarStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TopBar = function TopBar(props) {
    var _classnames;

    var disableStickyNav = props.disableStickyNav,
        hasRootPendingRefetch = props.hasRootPendingRefetch,
        hasUserId = props.hasUserId,
        hasUser = props.hasUser,
        isClient = props.isClient,
        openDrawer = props.openDrawer,
        user = props.user,
        userId = props.userId,
        viewer = props.viewer;


    var barClasses = (0, _classnames3.default)((_classnames = {}, _defineProperty(_classnames, _TopBarStyle2.default.bar, true), _defineProperty(_classnames, _TopBarStyle2.default.disableSticky, disableStickyNav), _classnames));

    return _react2.default.createElement(
        'div',
        { className: barClasses, onMouseOver: openDrawer },
        _react2.default.createElement(
            'div',
            { className: _TopBarStyle2.default.barContent + ' js-nav-utils-wrap' },
            _react2.default.createElement(
                'div',
                { className: _TopBarStyle2.default.leftContainer },
                _react2.default.createElement(_Logo2.default, null),
                _react2.default.createElement(_SearchBar2.default, {
                    hasRootPendingRefetch: hasRootPendingRefetch,
                    isClient: isClient,
                    viewer: viewer
                })
            ),
            _react2.default.createElement(
                'div',
                { className: _TopBarStyle2.default.rightContainer },
                _react2.default.createElement(_AccountNav2.default, {
                    isClient: isClient,
                    hasUser: hasUser,
                    hasUserId: hasUserId,
                    user: user
                }),
                _react2.default.createElement(_Notifications2.default, {
                    hasRootPendingRefetch: hasRootPendingRefetch,
                    hasUserId: hasUserId,
                    isClient: isClient,
                    userId: userId,
                    viewer: viewer,
                    initialViewer: viewer,
                    user: user
                }),
                _react2.default.createElement(_Likes2.default, {
                    hasRootPendingRefetch: hasRootPendingRefetch,
                    hasUserId: hasUserId,
                    fetchNewEvents: hasUserId && isClient && !hasRootPendingRefetch,
                    isClient: isClient,
                    userId: userId,
                    viewer: viewer
                }),
                _react2.default.createElement(_CartNav2.default, {
                    hasRootPendingRefetch: hasRootPendingRefetch,
                    hasUserId: hasUserId,
                    isClient: isClient,
                    user: user,
                    userId: userId,
                    viewer: viewer
                })
            )
        )
    );
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        openDrawer: function openDrawer() {
            dispatch(_actions.actionCreators.setDrawerAnimation(_constants.actionValues.drawerAnimations.SLIDE_IN));
        }
    };
};

TopBar = (0, _reactRedux.connect)(null, mapDispatchToProps)(TopBar);

exports.default = (0, _reactRelay.createFragmentContainer)(TopBar, {
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/TopBar/__generated__/TopBar_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var CartNav_viewer = _CartNav2.default.getFragment('viewer'),
                Likes_viewer = _Likes2.default.getFragment('viewer'),
                Notifications_viewer = _Notifications2.default.getFragment('viewer'),
                Notifications_initialViewer = _Notifications2.default.getFragment('initialViewer'),
                SearchBar_viewer = _SearchBar2.default.getFragment('viewer');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(CartNav_viewer), RelayQL_GENERATED.__frag(Likes_viewer), RelayQL_GENERATED.__frag(Notifications_viewer), RelayQL_GENERATED.__frag(Notifications_initialViewer), RelayQL_GENERATED.__frag(SearchBar_viewer)]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'TopBar_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    },
    user: {
        modern: function modern() {
            return __webpack_require__("./src/components/TopBar/__generated__/TopBar_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            var AccountNav_user = _AccountNav2.default.getFragment('user'),
                CartNav_user = _CartNav2.default.getFragment('user'),
                Notifications_user = _Notifications2.default.getFragment('user');

            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(AccountNav_user), RelayQL_GENERATED.__frag(CartNav_user), RelayQL_GENERATED.__frag(Notifications_user)]),
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'TopBar_user',
                        type: 'User'
                    };
                }()
            };
        }
    }
});

/***/ }),

/***/ "./src/components/TopBar/__generated__/TopBar_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type TopBar_user = {| |};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopBar_user",
  "selections": [{
    "kind": "FragmentSpread",
    "name": "AccountNav_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "CartNav_user",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "Notifications_user",
    "args": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/TopBar/__generated__/TopBar_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type TopBar_viewer = {| |};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopBar_viewer",
  "selections": [{
    "kind": "FragmentSpread",
    "name": "CartNav_viewer",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "Likes_viewer",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "Notifications_viewer",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "Notifications_initialViewer",
    "args": null
  }, {
    "kind": "FragmentSpread",
    "name": "SearchBar_viewer",
    "args": null
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/VipAccountManagerLink/VipAccountContent.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _Spinner = __webpack_require__("./node_modules/dibs-elements/dist/Spinner/index.js");

var _Spinner2 = _interopRequireDefault(_Spinner);

__webpack_require__("./node_modules/dibs-elements/dist/Spinner/buyer/Default.css");

var _phone = __webpack_require__("./node_modules/dibs-vg/dist/react/phone.js");

var _phone2 = _interopRequireDefault(_phone);

var _email = __webpack_require__("./node_modules/dibs-vg/dist/react/email.js");

var _email2 = _interopRequireDefault(_email);

var _VipAccountManagerLinkStyle = __webpack_require__("./src/components/VipAccountManagerLink/VipAccountManagerLink-style.scss");

var _VipAccountManagerLinkStyle2 = _interopRequireDefault(_VipAccountManagerLinkStyle);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VipAccountContent(_ref) {
    var userRelationships = _ref.userRelationships;

    var vipSalesRep = (0, _lodash2.default)(userRelationships, '[0].userDataB[0]') || {};
    var displayName = vipSalesRep.displayName,
        email = vipSalesRep.email,
        phoneNumber = vipSalesRep.phoneNumber;


    var messageTitle = _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Header.VipAccountManagerLink.header',
        defaultMessage: 'Contact your private client specialist:'
    });

    var messagePhone = _react2.default.createElement(
        'div',
        { className: _VipAccountManagerLinkStyle2.default.vipContent },
        _react2.default.createElement(_phone2.default, { className: _VipAccountManagerLinkStyle2.default.icon }),
        phoneNumber
    );

    var messageEmail = _react2.default.createElement(
        'div',
        { className: _VipAccountManagerLinkStyle2.default.vipContent },
        _react2.default.createElement(_email2.default, { className: _VipAccountManagerLinkStyle2.default.icon }),
        email
    );
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_VipAccountManagerLinkStyle2.default.section, _VipAccountManagerLinkStyle2.default.sectionWrapper, _VipAccountManagerLinkStyle2.default.content) },
        _react2.default.createElement(
            'div',
            { className: _VipAccountManagerLinkStyle2.default.title },
            messageTitle
        ),
        _react2.default.createElement(
            'div',
            { className: _VipAccountManagerLinkStyle2.default.copy },
            !userRelationships ? _react2.default.createElement(_Spinner2.default, { dark: true, containerClass: _VipAccountManagerLinkStyle2.default.tooltip }) : _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _VipAccountManagerLinkStyle2.default.vipContent },
                    displayName
                ),
                _react2.default.createElement(
                    'div',
                    { className: _VipAccountManagerLinkStyle2.default.vipContent },
                    messagePhone
                ),
                _react2.default.createElement(
                    'div',
                    { className: _VipAccountManagerLinkStyle2.default.vipContent },
                    messageEmail
                )
            )
        )
    );
};

exports.default = VipAccountContent;

/***/ }),

/***/ "./src/components/VipAccountManagerLink/VipAccountManagerLink-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"VipAccountManagerLink-style__wrapper__e470e980","link":"VipAccountManagerLink-style__link__e470e980","vipContent":"VipAccountManagerLink-style__vipContent__e470e980","separator":"VipAccountManagerLink-style__separator__e470e980","sectionWrapper":"VipAccountManagerLink-style__sectionWrapper__e470e980","icon":"VipAccountManagerLink-style__icon__e470e980","section":"VipAccountManagerLink-style__section__e470e980","title":"VipAccountManagerLink-style__title__e470e980","copy":"VipAccountManagerLink-style__copy__e470e980","cta":"VipAccountManagerLink-style__cta__e470e980","content":"VipAccountManagerLink-style__content__e470e980"};

/***/ }),

/***/ "./src/components/VipAccountManagerLink/VipAccountManagerLink.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VipAccountManagerLink = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _Dropdown = __webpack_require__("./src/components/Dropdown/Dropdown.jsx");

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _VipAccountContent = __webpack_require__("./src/components/VipAccountManagerLink/VipAccountContent.jsx");

var _VipAccountContent2 = _interopRequireDefault(_VipAccountContent);

var _VipAccountManagerLinkStyle = __webpack_require__("./src/components/VipAccountManagerLink/VipAccountManagerLink-style.scss");

var _VipAccountManagerLinkStyle2 = _interopRequireDefault(_VipAccountManagerLinkStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var vipLink = _react2.default.createElement(
    'div',
    { className: _VipAccountManagerLinkStyle2.default.link },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Header.BottomBar.vipAccountManagerLink.link',
        defaultMessage: 'Client Services'
    })
);

var VipAccountManagerLink = exports.VipAccountManagerLink = function (_React$Component) {
    _inherits(VipAccountManagerLink, _React$Component);

    function VipAccountManagerLink(props) {
        _classCallCheck(this, VipAccountManagerLink);

        var _this = _possibleConstructorReturn(this, (VipAccountManagerLink.__proto__ || Object.getPrototypeOf(VipAccountManagerLink)).call(this, props));

        _this.state = {
            fragmentVariables: {
                fetchRep: false,
                userIds: _this.props.userIds || []
            }
        };

        _this.triggerRepFetch = _this.triggerRepFetch.bind(_this);
        return _this;
    }

    _createClass(VipAccountManagerLink, [{
        key: 'triggerRepFetch',
        value: function triggerRepFetch() {
            var _this2 = this;

            var _props = this.props,
                hasRootPendingRefetch = _props.hasRootPendingRefetch,
                hasUserId = _props.hasUserId,
                userIds = _props.userIds;


            if (hasRootPendingRefetch) {
                return;
            }
            if (!this.state.fragmentVariables.fetchRep) {
                this.setState({
                    fragmentVariables: _extends({}, this.state.fragmentVariables, {
                        fetchRep: hasUserId,
                        userIds: userIds
                    })
                }, function () {
                    _this2.props.relay.refetch(_this2.state.fragmentVariables, null);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var viewer = this.props.viewer;


            return _react2.default.createElement(
                _Dropdown2.default,
                { align: _Dropdown.alignConstants.ALIGN_RIGHT, size: _Dropdown.sizeConstants.SIZE_SMALL, className: _VipAccountManagerLinkStyle2.default.wrapper, onShow: this.triggerRepFetch },
                vipLink,
                _react2.default.createElement(_VipAccountContent2.default, { userRelationships: viewer.userRelationships })
            );
        }
    }]);

    return VipAccountManagerLink;
}(_react2.default.Component);

VipAccountManagerLink.defaultProps = {
    hasRootPendingRefetch: false,
    hasUserId: false,
    isClient: false,
    userIds: []
};

exports.default = (0, _reactRelay.createRefetchContainer)(VipAccountManagerLink, {
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/components/VipAccountManagerLink/__generated__/VipAccountManagerLink_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    kind: 'RootArgument',
                    name: 'userIds'
                }, {
                    defaultValue: false,
                    kind: 'LocalArgument',
                    name: 'fetchRep'
                }],
                node: function () {
                    return {
                        children: [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userIds',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'relationshipType!'
                                },
                                name: 'relationshipType',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'VIP'
                                }
                            }],
                            children: [{
                                children: [{
                                    fieldName: '__typename',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'String'
                                }, {
                                    children: [{
                                        fieldName: 'displayName',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        calls: [{
                                            kind: 'Call',
                                            metadata: {
                                                type: 'formatPhoneNumberTypes'
                                            },
                                            name: 'formatType',
                                            value: {
                                                kind: 'CallValue',
                                                callValue: 'INTERNATIONAL'
                                            }
                                        }],
                                        fieldName: 'phoneNumber',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }, {
                                        fieldName: 'email',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }],
                                    id: RelayQL_GENERATED.__id(),
                                    kind: 'Fragment',
                                    metadata: {},
                                    name: 'VipRepData',
                                    type: 'VipRepData'
                                }],
                                fieldName: 'userDataB',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isAbstract: true,
                                    isPlural: true
                                },
                                type: 'UserDataB'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'fetchRep'
                                    }
                                }]
                            }],
                            fieldName: 'userRelationships',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'UserRelationship'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'VipAccountManagerLink_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    }
}, {
    modern: function modern() {
        return __webpack_require__("./src/components/VipAccountManagerLink/__generated__/VipAccountManagerLinkRefetchQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var VipAccountManagerLink_viewer_args1 = (VipAccountManagerLink.__container__ || VipAccountManagerLink).getFragment('viewer', {
            fetchRep: {
                kind: 'CallVariable',
                callVariableName: 'fetchRep'
            }
        });
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userIds'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'fetchRep'
            }],
            name: 'VipAccountManagerLinkRefetchQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(VipAccountManagerLink_viewer_args1)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'VipAccountManagerLinkRefetchQuery',
                    type: 'Query'
                };
            }()
        };
    }
});

/***/ }),

/***/ "./src/components/VipAccountManagerLink/__generated__/VipAccountManagerLinkRefetchQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 0bbf38bdba508f043cb83f4ee014af66
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type VipAccountManagerLinkRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query VipAccountManagerLinkRefetchQuery(
  $userIds: [String]!
  $fetchRep: Boolean!
) {
  viewer {
    ...VipAccountManagerLink_viewer_1EqXkF
    id
  }
}

fragment VipAccountManagerLink_viewer_1EqXkF on Viewer {
  userRelationships(userIds: $userIds, relationshipType: VIP) @include(if: $fetchRep) {
    userDataB {
      __typename
      ... on VipRepData {
        displayName
        phoneNumber(formatType: INTERNATIONAL)
        email
      }
    }
    id
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchRep",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "VipAccountManagerLinkRefetchQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "VipAccountManagerLink_viewer",
        "args": [{
          "kind": "Variable",
          "name": "fetchRep",
          "variableName": "fetchRep",
          "type": null
        }]
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "VipAccountManagerLinkRefetchQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchRep",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "VipAccountManagerLinkRefetchQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "fetchRep",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Literal",
            "name": "relationshipType",
            "value": "VIP",
            "type": "relationshipType!"
          }, {
            "kind": "Variable",
            "name": "userIds",
            "variableName": "userIds",
            "type": "[String]!"
          }],
          "concreteType": "UserRelationship",
          "name": "userRelationships",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": null,
            "name": "userDataB",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "__typename",
              "storageKey": null
            }, {
              "kind": "InlineFragment",
              "type": "VipRepData",
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "displayName",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": [{
                  "kind": "Literal",
                  "name": "formatType",
                  "value": "INTERNATIONAL",
                  "type": "formatPhoneNumberTypes"
                }],
                "name": "phoneNumber",
                "storageKey": "phoneNumber{\"formatType\":\"INTERNATIONAL\"}"
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "email",
                "storageKey": null
              }]
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query VipAccountManagerLinkRefetchQuery(\n  $userIds: [String]!\n  $fetchRep: Boolean!\n) {\n  viewer {\n    ...VipAccountManagerLink_viewer_1EqXkF\n    id\n  }\n}\n\nfragment VipAccountManagerLink_viewer_1EqXkF on Viewer {\n  userRelationships(userIds: $userIds, relationshipType: VIP) @include(if: $fetchRep) {\n    userDataB {\n      __typename\n      ... on VipRepData {\n        displayName\n        phoneNumber(formatType: INTERNATIONAL)\n        email\n      }\n    }\n    id\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/VipAccountManagerLink/__generated__/VipAccountManagerLink_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type VipAccountManagerLink_viewer = {|
  +userRelationships?: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +displayName?: ?string;
      +phoneNumber?: ?string;
      +email?: ?string;
    |}>;
  |}>;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "LocalArgument",
    "name": "fetchRep",
    "type": "Boolean!",
    "defaultValue": false
  }, {
    "kind": "RootArgument",
    "name": "userIds",
    "type": "[String]!"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "VipAccountManagerLink_viewer",
  "selections": [{
    "kind": "Condition",
    "passingValue": true,
    "condition": "fetchRep",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Literal",
        "name": "relationshipType",
        "value": "VIP",
        "type": "relationshipType!"
      }, {
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds",
        "type": "[String]!"
      }],
      "concreteType": "UserRelationship",
      "name": "userRelationships",
      "plural": true,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": null,
        "name": "userDataB",
        "plural": true,
        "selections": [{
          "kind": "InlineFragment",
          "type": "VipRepData",
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "displayName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": [{
              "kind": "Literal",
              "name": "formatType",
              "value": "INTERNATIONAL",
              "type": "formatPhoneNumberTypes"
            }],
            "name": "phoneNumber",
            "storageKey": "phoneNumber{\"formatType\":\"INTERNATIONAL\"}"
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "email",
            "storageKey": null
          }]
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.footerInitialVariables = exports.footerRootQuery = exports.FooterRenderer = exports.mobileNavWrapperInitialVariables = exports.mobileNavWrapperRootQuery = exports.MobileNavWrapperRenderer = exports.headerInitialVariables = exports.headerRootQuery = exports.HeaderRenderer = undefined;

var _HeaderRenderer = __webpack_require__("./src/components/HeaderRenderer/HeaderRenderer.jsx");

var _HeaderRenderer2 = _interopRequireDefault(_HeaderRenderer);

var _headerRootQuery = __webpack_require__("./src/queries/headerRootQuery.js");

var _headerRootQuery2 = _interopRequireDefault(_headerRootQuery);

var _MobileNavWrapperRenderer = __webpack_require__("./src/components/MobileNavWrapperRenderer/MobileNavWrapperRenderer.jsx");

var _MobileNavWrapperRenderer2 = _interopRequireDefault(_MobileNavWrapperRenderer);

var _mobileNavWrapperRootQuery = __webpack_require__("./src/queries/mobileNavWrapperRootQuery.js");

var _mobileNavWrapperRootQuery2 = _interopRequireDefault(_mobileNavWrapperRootQuery);

var _FooterRenderer = __webpack_require__("./src/components/FooterRenderer/FooterRenderer.jsx");

var _FooterRenderer2 = _interopRequireDefault(_FooterRenderer);

var _footerRootQuery = __webpack_require__("./src/queries/footerRootQuery.js");

var _footerRootQuery2 = _interopRequireDefault(_footerRootQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.HeaderRenderer = _HeaderRenderer2.default;
exports.headerRootQuery = _headerRootQuery2.default;
exports.headerInitialVariables = _headerRootQuery.initialVariables;
exports.MobileNavWrapperRenderer = _MobileNavWrapperRenderer2.default;
exports.mobileNavWrapperRootQuery = _mobileNavWrapperRootQuery2.default;
exports.mobileNavWrapperInitialVariables = _mobileNavWrapperRootQuery.initialVariables;
exports.FooterRenderer = _FooterRenderer2.default;
exports.footerRootQuery = _footerRootQuery2.default;
exports.footerInitialVariables = _footerRootQuery.initialVariables;

/***/ }),

/***/ "./src/contactModal/async.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = contactModal;
function contactModal() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "./src/contactModal/index.js")).then(function (mod) {
        return mod.default;
    });
};

/***/ }),

/***/ "./src/entries/footer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBuyerFooterClient = undefined;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _serverVars = __webpack_require__("./node_modules/server-vars/index.js");

var _serverVars2 = _interopRequireDefault(_serverVars);

var _actions = __webpack_require__("./src/actions/index.js");

var _components = __webpack_require__("./src/components/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBuyerFooterClient = function getBuyerFooterClient(_ref) {
    var node = _ref.node,
        store = _ref.store,
        relayEnv = _ref.relayEnv;

    var localeDataKey = _serverVars2.default.get('localeDataKey');
    var messages = _serverVars2.default.get('dblMessages');

    if (window.ReactIntlLocaleData) {
        (0, _reactIntl.addLocaleData)(window.ReactIntlLocaleData[localeDataKey]);
    }

    (0, _reactDom.render)(_react2.default.createElement(
        _reactIntl.IntlProvider,
        { locale: localeDataKey, messages: messages },
        _react2.default.createElement(
            _reactRedux.Provider,
            { store: store },
            _react2.default.createElement(_components.FooterRenderer, {
                environment: relayEnv,
                initialVariables: _components.footerInitialVariables,
                query: _components.footerRootQuery
            })
        )
    ), node);

    return {
        updateUserState: store.dispatch.bind(null, _actions.actionCreators.setUpdateUserState(true))
    };
};

exports.getBuyerFooterClient = getBuyerFooterClient;

/***/ }),

/***/ "./src/entries/header.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBuyerHeaderClient = undefined;

var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__("./node_modules/react-redux/lib/index.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _serverVars = __webpack_require__("./node_modules/server-vars/index.js");

var _serverVars2 = _interopRequireDefault(_serverVars);

var _loginHandlers = __webpack_require__("./src/utils/loginHandlers.js");

var _actions = __webpack_require__("./src/actions/index.js");

var _components = __webpack_require__("./src/components/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBuyerHeaderClient = function getBuyerHeaderClient(_ref) {
    var node = _ref.node,
        store = _ref.store,
        relayEnv = _ref.relayEnv;


    var isMobile = _serverVars2.default.get('settings.isMobile');

    var initialVariables = isMobile ? _components.mobileNavWrapperInitialVariables : _components.headerInitialVariables;
    var query = isMobile ? _components.mobileNavWrapperRootQuery : _components.headerRootQuery;

    var localeDataKey = _serverVars2.default.get('localeDataKey');
    var messages = _serverVars2.default.get('dblMessages');

    if (window.ReactIntlLocaleData) {
        (0, _reactIntl.addLocaleData)(window.ReactIntlLocaleData[localeDataKey]);
    }

    var props = {
        initialVariables: initialVariables,
        environment: relayEnv,
        query: query
    };

    (0, _loginHandlers.addLoginHandlers)(function () {
        store.dispatch(_actions.actionCreators.setUpdateUserState(true));
    });

    _reactDom2.default.render(_react2.default.createElement(
        _reactIntl.IntlProvider,
        { locale: localeDataKey, messages: messages },
        _react2.default.createElement(
            _reactRedux.Provider,
            { store: store },
            isMobile ? _react2.default.createElement(_components.MobileNavWrapperRenderer, props) : _react2.default.createElement(_components.HeaderRenderer, props)
        )
    ), node);

    return {
        store: store,
        getBuyerHeaderUiState: store.getState
    };
};

exports.getBuyerHeaderClient = getBuyerHeaderClient;

/***/ }),

/***/ "./src/entries/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.runNotificationQueue = exports._getNotificationQueue = exports.scriptInjector = exports.pageTypes = exports.makeOfferLauncher = exports.isPageType = exports.initialize = exports.initializeTracking = exports.contactModal = exports.autoModalHelpers = exports.AutoModal = exports.addLoginHandlers = exports.abExperiments = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _header = __webpack_require__("./src/entries/header.js");

var _footer = __webpack_require__("./src/entries/footer.js");

var _initializeTracking = __webpack_require__("./src/utils/initializeTracking.js");

var _initializeTracking2 = _interopRequireDefault(_initializeTracking);

var _loginHandlers = __webpack_require__("./src/utils/loginHandlers.js");

var _reduxThunk = __webpack_require__("./node_modules/redux-thunk/lib/index.js");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reducers = __webpack_require__("./src/reducers/index.js");

var _reducers2 = _interopRequireDefault(_reducers);

var _Queue = __webpack_require__("./src/notificationQueue/Queue.js");

var _Queue2 = _interopRequireDefault(_Queue);

var _serverVars = __webpack_require__("./node_modules/server-vars/index.js");

var _serverVars2 = _interopRequireDefault(_serverVars);

var _relayClientEnvironment = __webpack_require__("./src/relayClientEnvironment.js");

var _relayClientEnvironment2 = _interopRequireDefault(_relayClientEnvironment);

var _AuthModalCheck = __webpack_require__("./src/utils/AuthModalCheck.js");

var _AuthModalCheck2 = _interopRequireDefault(_AuthModalCheck);

var _isPageType = __webpack_require__("./src/utils/isPageType.js");

var _isPageType2 = _interopRequireDefault(_isPageType);

var _abExperiments = __webpack_require__("./src/utils/abExperiments.js");

var _abExperiments2 = _interopRequireDefault(_abExperiments);

var _makeOfferLauncher = __webpack_require__("./src/abandonedCheckout/components/makeOfferLauncher.jsx");

var _makeOfferLauncher2 = _interopRequireDefault(_makeOfferLauncher);

var _pageConstants = __webpack_require__("./src/utils/pageConstants.js");

var _pageConstants2 = _interopRequireDefault(_pageConstants);

var _scriptInjector = __webpack_require__("./src/utils/scriptInjector.js");

var _scriptInjector2 = _interopRequireDefault(_scriptInjector);

var _AutoModal = __webpack_require__("./src/abandonedCheckout/components/AutoModal.jsx");

var _AutoModal2 = _interopRequireDefault(_AutoModal);

var _chat = __webpack_require__("./src/utils/chat.js");

var _chat2 = _interopRequireDefault(_chat);

var _autoModalHelper = __webpack_require__("./src/abandonedCheckout/autoModalHelper.jsx");

var autoModalHelpers = _interopRequireWildcard(_autoModalHelper);

var _async = __webpack_require__("./src/contactModal/async.js");

var _async2 = _interopRequireDefault(_async);

__webpack_require__("./src/scss/dibs.scss");

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _jsCookie = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var USER = _dibsCookieJar.cookieJarConstants.USER,
    MASQUERADE_BUYER = _dibsCookieJar.cookieJarConstants.MASQUERADE_BUYER,
    USER_EMAIL = _dibsCookieJar.cookieJarConstants.USER_EMAIL,
    USER_TYPE = _dibsCookieJar.cookieJarConstants.USER_TYPE;


var dblMiddleware = [_reduxThunk2.default];

// will be used to store the queue so that functions exported from dbl can interact with it
var queue = void 0;

function createGlobalStore(reducers, middlewares, state) {
    var reducer = (0, _redux.combineReducers)(_extends({}, reducers, _reducers2.default));
    var middleware = middlewares.concat(dblMiddleware).filter(function (value, index, self) {
        return self.indexOf(value) === index;
    });
    return (0, _redux.createStore)(reducer, state, _redux.applyMiddleware.apply(undefined, _toConsumableArray(middleware)));
};

_jsCookie2.default.defaults = {
    domain: '.1stdibs.com',
    expires: 182,
    path: '/'
};

function logoutFunc() {
    if ((0, _dibsCookieJar.isMasqueradingAsBuyer)(document.cookie)) {
        _jsCookie2.default.remove(MASQUERADE_BUYER);
    } else {
        _jsCookie2.default.remove(USER);
        _jsCookie2.default.remove(USER_EMAIL);
        _jsCookie2.default.remove(USER_TYPE);
    }
    location.reload();
};

function initialize() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$reducers = _ref.reducers,
        reducers = _ref$reducers === undefined ? {} : _ref$reducers,
        _ref$middleware = _ref.middleware,
        middleware = _ref$middleware === undefined ? [] : _ref$middleware,
        _ref$logoutUser = _ref.logoutUser,
        logoutUser = _ref$logoutUser === undefined ? logoutFunc : _ref$logoutUser,
        _ref$notifications = _ref.notifications,
        notifications = _ref$notifications === undefined ? [] : _ref$notifications,
        _ref$state = _ref.state,
        state = _ref$state === undefined ? {} : _ref$state;

    if (state.hasOwnProperty('cart') || state.hasOwnProperty('header') || state.hasOwnProperty('footer')) {
        throw new Error('state cannot include cart, header, footer');
    }
    var data = JSON.parse(_serverVars2.default.get('headerRelayPreloadedData'));
    var relayEnv = (0, _relayClientEnvironment2.default)(data);

    var _ref2 = _serverVars2.default.get('header') || {},
        header = _ref2.header,
        cart = _ref2.cart;

    var _ref3 = _serverVars2.default.get('footer') || {},
        footer = _ref3.footer;

    header.logoutUser = logoutUser;

    var store = createGlobalStore(reducers, middleware, _extends({ header: header, footer: footer, cart: cart }, state));
    (0, _header.getBuyerHeaderClient)({
        node: document.getElementById('js-header'),
        store: store,
        relayEnv: relayEnv
    });
    (0, _footer.getBuyerFooterClient)({
        node: document.getElementById('js-footer'),
        store: store,
        relayEnv: relayEnv
    });
    _AuthModalCheck2.default.init();
    queue = new _Queue2.default(notifications, store);
    _chat2.default.start();
    return store;
};

function _getNotificationQueue() {
    return queue._getNotificationQueue();
};

function runNotificationQueue() {
    queue.runQueue();
};

exports.abExperiments = _abExperiments2.default;
exports.addLoginHandlers = _loginHandlers.addLoginHandlers;
exports.AutoModal = _AutoModal2.default;
exports.autoModalHelpers = autoModalHelpers;
exports.contactModal = _async2.default;
exports.initializeTracking = _initializeTracking2.default;
exports.initialize = initialize;
exports.isPageType = _isPageType2.default;
exports.makeOfferLauncher = _makeOfferLauncher2.default;
exports.pageTypes = _pageConstants2.default;
exports.scriptInjector = _scriptInjector2.default;
exports._getNotificationQueue = _getNotificationQueue;
exports.runNotificationQueue = runNotificationQueue;

/***/ }),

/***/ "./src/mobileAds/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    NOTIFICATION_TYPE: 'mobileInterstitial',
    ITUNES_LINK: 'https://itunes.apple.com/us/app/1stdibs/id938157117',
    FULLSCREEN_NAME: 'fullscreen',
    MC_APP_BANNER: 'messageCenterAppBanner',
    FULLSCREEN_GA_ACTION: 'app interstitial - full screen on second page'
};

/***/ }),

/***/ "./src/mobileAds/helpers/deeplink.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deepLinkSupported = exports.deepLinkQueries = exports.deepLinkRegexes = undefined;
exports.createDeepLink = createDeepLink;

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEEP_LINK_BASE = 'dibs://www.1stdibs.com';
var DEEP_LINK_BASE_MC = 'dibsmc://www.1stdibs.com';

var deepLinkRegexes = exports.deepLinkRegexes = [/\/(?:furniture|art|jewelry|fashion)\/section\//, /\/sale\/saturday-sale/, /\/(?:collections|dealers|locations|creators|shopping-with)/, /(?:metal|stone|style|origin|period|material|technique)/, /\/(?:furniture|art|jewelry|fashion)/, /\/search\//, /^\/my\/conversations/, /^\/checkout\/id/];

var deepLinkQueries = exports.deepLinkQueries = {
    'collection': true,
    'creator': true,
    'dealer': true,
    'gender': true,
    'height': true,
    'latest': true,
    'material': true,
    'metal': true,
    'origin': true,
    'per': true,
    'price': true,
    'section': true,
    'shipping': true,
    'sort': true,
    'stone': true,
    'style': true,
    'width': true,
    'technique': true,
    'utm_medium': true,
    'utm_source': true,
    'utm_campaign': true,
    'utm_content': true,
    'q': true,
    'display_title': true,
    'launch': true
};

var deepLinkSupported = exports.deepLinkSupported = function deepLinkSupported(path) {
    path = path || window.location.pathname;

    var supported = deepLinkRegexes.reduce(function (acc, item) {
        if (acc || item.test(path)) {
            return true;
        }
        return false;
    }, false);

    if (path === '/') {
        // home page
        supported = true;
    }

    return supported;
};

function getDeepLinkBase(path) {
    return (/^\/my\/conversations/.test(path) ? DEEP_LINK_BASE_MC : DEEP_LINK_BASE
    );
}

function createDeepLinkPath(path, query) {
    var params = _querystring2.default.parse(query);
    var supported = Object.keys(params).reduce(function (acc, item) {
        if (deepLinkQueries[item]) {
            acc[item] = params[item];
        }
        return acc;
    }, {});
    return path + '?' + _querystring2.default.stringify(supported);
}

function createDeepLink() {
    var path = window.location.pathname;
    var query = window.location.search.substr(1);
    return '' + getDeepLinkBase(path) + createDeepLinkPath(path, query);
}

/***/ }),

/***/ "./src/mutations/AddCartItemMutation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var mutation = {
    modern: function modern() {
        return __webpack_require__("./src/mutations/__generated__/AddCartItemMutation.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'input'
            }],
            name: 'AddCartItemMutation',
            operation: 'mutation',
            node: function () {
                return {
                    calls: [{
                        kind: 'Call',
                        metadata: {},
                        name: 'addCartItem',
                        value: {
                            kind: 'CallVariable',
                            callVariableName: 'input'
                        }
                    }],
                    children: [{
                        children: [{
                            children: [{
                                fieldName: 'itemId',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'item',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'ItemSummary'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'portfolioItems',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id',
                            isPlural: true
                        },
                        type: 'PortfolioItemV1'
                    }, {
                        fieldName: 'clientMutationId',
                        kind: 'Field',
                        metadata: {
                            isGenerated: true,
                            isRequisite: true
                        },
                        type: 'String'
                    }],
                    kind: 'Mutation',
                    metadata: {
                        inputType: 'AddCartItemInput!'
                    },
                    name: 'AddCartItemMutation',
                    responseType: 'AddCartItemPayload'
                };
            }()
        };
    }
};

function commit(environment, _ref) {
    var itemIds = _ref.itemIds,
        onCompleted = _ref.onCompleted,
        onError = _ref.onError;

    var variables = { input: { itemIds: itemIds } };

    (0, _reactRelay.commitMutation)(environment, {
        mutation: mutation,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError
    });
}

exports.default = { commit: commit };

/***/ }),

/***/ "./src/mutations/__generated__/AddCartItemMutation.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This file was generated by:
 *   relay-compiler
 *
 * @providesModule AddCartItemMutation.graphql
 * @generated SignedSource<<ada58ce9e72c921dc9766d572c8346e7>>
 * @relayHash dd85178d55dcaee6f48cacbe8c593036
 * 
 * @nogrep
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AddCartItemInput = {
  itemIds?: ?string;
};

export type AddCartItemMutationResponse = {
  portfolioItems?: ?Array<?AddCartItemMutationResponse_portfolioItems>;
};

export type AddCartItemMutationResponse_portfolioItems_item = {
  itemId?: ?string;
};

export type AddCartItemMutationResponse_portfolioItems = {
  item?: ?AddCartItemMutationResponse_portfolioItems_item;
};
*/

/*
mutation AddCartItemMutation(
  $input: AddCartItemInput!
) {
  addCartItem(input: $input) {
    portfolioItems {
      item {
        itemId
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "AddCartItemInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddCartItemMutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddCartItemInput!"
      }],
      "concreteType": "AddCartItemPayload",
      "name": "addCartItem",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "PortfolioItemV1",
        "name": "portfolioItems",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "ItemSummary",
          "name": "item",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "itemId",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AddCartItemMutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "AddCartItemInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "AddCartItemMutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddCartItemInput!"
      }],
      "concreteType": "AddCartItemPayload",
      "name": "addCartItem",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "PortfolioItemV1",
        "name": "portfolioItems",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "ItemSummary",
          "name": "item",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "itemId",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation AddCartItemMutation(\n  $input: AddCartItemInput!\n) {\n  addCartItem(input: $input) {\n    portfolioItems {\n      item {\n        itemId\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/notificationQueue/Queue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._testReset = exports.KEY_ISOLATE_NOTIFICATION = exports.KEY_DISABLE_NOTIFICATIONS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _globalNotifications = __webpack_require__("./src/notificationQueue/globalNotifications/index.js");

var _globalNotifications2 = _interopRequireDefault(_globalNotifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KEY_DISABLE_NOTIFICATIONS = exports.KEY_DISABLE_NOTIFICATIONS = 'no-notif';
var KEY_ISOLATE_NOTIFICATION = exports.KEY_ISOLATE_NOTIFICATION = 'isolate-notification';

var hasBeenInitialized = false;
var queue = void 0;

var Queue = function () {
    function Queue(notifications, store) {
        _classCallCheck(this, Queue);

        this.store = store;
        if (!hasBeenInitialized) {
            queue = this.buildQueue(notifications);
            hasBeenInitialized = true;
            this.runQueue();
        } else {
            throw new Error("Only one notification queue may be initialized");
        }
    }

    _createClass(Queue, [{
        key: 'buildQueue',
        value: function buildQueue(notifications) {
            var query = _querystring2.default.parse(window.location.search.substr(1));
            var isolatedNotification = query[KEY_ISOLATE_NOTIFICATION];
            var fullQueue = [].concat(_globalNotifications2.default, notifications).sort(function (a, b) {
                return b.priority - a.priority;
            });
            if (isolatedNotification) {
                return [fullQueue.find(function (item) {
                    return item.name === isolatedNotification;
                })];
            }
            if (this.noNotifications(query)) {
                return [];
            }
            return fullQueue;
        }
    }, {
        key: 'noNotifications',
        value: function noNotifications(query) {
            if (_dibsBrowserStorage.sessionStorage.getItem(KEY_DISABLE_NOTIFICATIONS) === true) {
                return true;
            }
            if (query[KEY_DISABLE_NOTIFICATIONS] === 'true') {
                _dibsBrowserStorage.sessionStorage.setItem(KEY_DISABLE_NOTIFICATIONS, true);
                return true;
            }

            return false;
        }
    }, {
        key: '_getNotificationQueue',
        value: function _getNotificationQueue() {
            if (true) {
                console.error("this method is for development purposes only");
            }
            return queue;
        }
    }, {
        key: 'runQueue',
        value: function runQueue() {
            var _this = this;

            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (index < queue.length) {
                return queue[index].rule().then(function (bool) {
                    if (bool) {
                        return _this.store.dispatch(queue[index].action());
                    } else {
                        return _this.runQueue(++index);
                    }
                });
            } else {
                return Promise.resolve();
            }
        }
    }]);

    return Queue;
}();

exports.default = Queue;
var _testReset = exports._testReset = function _testReset() {
    hasBeenInitialized = false;
};

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/abandonCheckout.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by Lior Elrom
 * Date: 8/16/16
 * Time: 10:04 AM
 */



Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var get = __webpack_require__("./node_modules/lodash.get/index.js");
var React = __webpack_require__("./node_modules/react/react.js");
var ReactDOM = __webpack_require__("./node_modules/react-dom/index.js");

var _require = __webpack_require__("./node_modules/dibs-browser-storage/index.js"),
    localStorage = _require.localStorage;

var _require2 = __webpack_require__("./src/utils/pageConstants.js"),
    PAGE_TYPE = _require2.PAGE_TYPE;

var isPageType = __webpack_require__("./src/utils/isPageType.js");

var _require3 = __webpack_require__("./src/utils/checkoutStorageConstants.js"),
    STORAGE = _require3.STORAGE;

// components
var CheckoutSurvey = __webpack_require__("./src/abandonedCheckout/components/CheckoutSurvey.jsx");
var CheckoutAutoModal = __webpack_require__("./src/abandonedCheckout/components/CheckoutAutoModal.jsx").default;

var makeOfferLauncher = __webpack_require__("./src/abandonedCheckout/components/makeOfferLauncher.jsx");

var thirtyMinutesPassed = function thirtyMinutesPassed(time) {
    var date = new Date(time);
    return (Date.now() - date.getTime()) / (1000 * 60) >= 0.01;
};

var isBlacklistedPage = isPageType([PAGE_TYPE.CHECKOUT, PAGE_TYPE.ABOUT]);

var preAuthOfferModal = function preAuthOfferModal() {
    return function (dispatch) {
        var preAuthOfferModalInfo = localStorage.getItem('checkoutPreAuthOfferModalInfo');
        var surveyInfo = localStorage.getItem(STORAGE.SURVEY_INFO);
        if (preAuthOfferModalInfo) {
            var itemId = preAuthOfferModalInfo.itemId,
                offerAmount = preAuthOfferModalInfo.offerAmount,
                offerCurrency = preAuthOfferModalInfo.offerCurrency,
                offerMessage = preAuthOfferModalInfo.offerMessage,
                sellerId = preAuthOfferModalInfo.sellerId,
                quantity = preAuthOfferModalInfo.quantity,
                name = preAuthOfferModalInfo.name;

            makeOfferLauncher({
                item: {
                    id: itemId,
                    seller: {
                        id: sellerId
                    }
                },
                currency: offerCurrency,
                currentStep: 'abandonMakeOffer',
                preloadedState: {
                    fields: {
                        offerFieldValue: offerAmount,
                        messageFieldValue: offerMessage,
                        nameFieldValue: name,
                        quantityFieldValue: quantity
                    }
                }
            });
            localStorage.setItem('hasSeenPreAuthOfferModal', { itemId: itemId });
            dispatch({ type: 'noop' });
        }
        if (surveyInfo) {
            var el = window.document.createElement('div');
            root.document.body.appendChild(el);
            ReactDOM.render(React.createElement(CheckoutSurvey, {}), el);
            dispatch({ type: 'noop' });
        }
    };
};

var preAuthOfferModalAndSurveyRule = function preAuthOfferModalAndSurveyRule() {
    if (isBlacklistedPage) {
        return Promise.resolve(false);
    }

    var isAfterTimer = void 0;

    // checkoutPreAuthOfferModal display logic
    // if checkoutPreAuthOfferModalInfo is present, it overrides checkoutSurveyInfo
    var preAuthOfferModalInfo = localStorage.getItem('checkoutPreAuthOfferModalInfo');
    if (preAuthOfferModalInfo) {
        var itemId = preAuthOfferModalInfo.itemId;

        var hasSeenPreAuthOfferModal = itemId === get(localStorage.getItem('hasSeenPreAuthOfferModal'), 'itemId');

        isAfterTimer = thirtyMinutesPassed(preAuthOfferModalInfo.checkoutTime);

        if (!isAfterTimer && !hasSeenPreAuthOfferModal) {
            return Promise.resolve(true);
        }
    }

    // Old checkout survey
    var surveyInfo = localStorage.getItem(STORAGE.SURVEY_INFO);
    var hasSeenSurvey = !!localStorage.getItem('hasSeenCheckoutSurvey');
    if (surveyInfo && !hasSeenSurvey) {
        isAfterTimer = thirtyMinutesPassed(surveyInfo.checkoutTime);
        if (!isAfterTimer) {
            return Promise.resolve(true);
        }
    }

    return Promise.resolve(false);
};

var autoModal = function autoModal() {
    return function (dispatch) {
        var autoModalInfo = localStorage.getItem(STORAGE.AUTO_MODAL_INFO);

        var item = autoModalInfo.item,
            email = autoModalInfo.email;

        localStorage.deleteItem(STORAGE.SURVEY_INFO);
        localStorage.deleteItem(STORAGE.AUTO_MODAL_INFO);
        setTimeout(function () {
            var div = document.createElement('div');
            document.body.appendChild(div);
            ReactDOM.render(React.createElement(CheckoutAutoModal, { item: item, email: email }), div);
            dispatch({ type: 'noop' });
        }, 2000);
    };
};

var autoModalRule = function autoModalRule() {
    var autoModalInfo = localStorage.getItem(STORAGE.AUTO_MODAL_INFO);
    return Promise.resolve(!(0, _dibsCookieJar.getUserId)(document.cookie) && !isBlacklistedPage && autoModalInfo);
};

exports.default = [{
    name: 'preAuthOfferModal',
    rule: preAuthOfferModalAndSurveyRule,
    action: preAuthOfferModal,
    priority: 100
}, {
    name: 'autoModal',
    rule: autoModalRule,
    action: autoModal,
    priority: 350
}];

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/helpers/mobileAdsHelper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shouldShowAd = undefined;

var _mobileCheck = __webpack_require__("./node_modules/dibs-client-check/dist/mobileCheck.js");

var _mobileCheck2 = _interopRequireDefault(_mobileCheck);

var _jsCookie = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _deeplink = __webpack_require__("./src/mobileAds/helpers/deeplink.js");

var _referrerHelper = __webpack_require__("./src/notificationQueue/globalNotifications/helpers/referrerHelper.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasInterstitualCookie = function hasInterstitualCookie() {
    return _jsCookie2.default.getJSON().dibsMobileInterstitial || undefined;
};

var shouldShowAd = exports.shouldShowAd = function shouldShowAd() {
    var isAppPage = _mobileCheck2.default.iPhone() && !hasInterstitualCookie() && (0, _deeplink.deepLinkSupported)();
    return isAppPage && !(0, _referrerHelper.isPlaReferrer)();
};

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/helpers/postAuthLoader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.autoPromptRegistration = autoPromptRegistration;

var _actions = __webpack_require__("./src/actions/index.js");

var _relayClientEnvironment = __webpack_require__("./src/relayClientEnvironment.js");

var _relayClientEnvironment2 = _interopRequireDefault(_relayClientEnvironment);

var _authFlowConstants = __webpack_require__("./src/authModal/authentication/authFlowConstants.js");

var _async = __webpack_require__("./src/authModal/async.js");

var _async2 = _interopRequireDefault(_async);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onTradeApplicationPage = function onTradeApplicationPage() {
    var path = location.pathname;
    return path.split('/trade/apply').length > 1;
};

var deferred = function deferred() {
    var resolveRef = void 0;

    var promise = new Promise(function (resolve) {
        resolveRef = resolve;
    });

    promise.resolve = resolveRef;
    return promise;
};

var postAuthDeferred = deferred();
var moduleLoaded = false;

var loadPostAuthModule = function loadPostAuthModule() {
    var relayEnv = (0, _relayClientEnvironment2.default)();
    if (!moduleLoaded) {
        (0, _async2.default)().then(function (mod) {
            var postAuth = mod;
            postAuth.init(relayEnv);
            postAuthDeferred.resolve(postAuth);
        }, 'authModal');
        moduleLoaded = true;
    }

    return postAuthDeferred;
};

function autoPromptRegistration() {
    var setUpdateUserState = _actions.actionCreators.setUpdateUserState;


    return new Promise(function (res) {
        if (onTradeApplicationPage()) {
            res(setUpdateUserState(false));
        }
        loadPostAuthModule().then(function (postAuth) {
            var relayEnv = (0, _relayClientEnvironment2.default)();
            postAuth.init(relayEnv);
            postAuth.run(_authFlowConstants.AUTO_PROMPT_REGISTER).onUserChanged(function () {
                res(setUpdateUserState(true));
            });
        });
    });
};

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/helpers/referrerHelper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isPlaReferrer = exports.isEmailReferrer = exports.isAmpReferrer = undefined;

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getReferringMedium = function getReferringMedium(query) {
    query = query || _querystring2.default.parse(window.location.search.substr(1));
    return query.utm_medium ? query.utm_medium.toLowerCase() : '';
};

var isAmpReferrer = exports.isAmpReferrer = function isAmpReferrer() {
    return document.referrer.match(/\/amp\//g) !== null;
};

var isEmailReferrer = exports.isEmailReferrer = function isEmailReferrer(query) {
    return getReferringMedium(query) === 'email';
};

var isPlaReferrer = exports.isPlaReferrer = function isPlaReferrer() {
    var query = _querystring2.default.parse(window.location.search.substr(1));
    return getReferringMedium() === 'pla' || typeof query.product !== "undefined" && typeof query.gclid !== "undefined";
};

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _loginPrompt = __webpack_require__("./src/notificationQueue/globalNotifications/loginPrompt.js");

var _loginPrompt2 = _interopRequireDefault(_loginPrompt);

var _tradeOnboarding = __webpack_require__("./src/notificationQueue/globalNotifications/tradeOnboarding.js");

var _tradeOnboarding2 = _interopRequireDefault(_tradeOnboarding);

var _mobileAds = __webpack_require__("./src/notificationQueue/globalNotifications/mobileAds.js");

var _mobileAds2 = _interopRequireDefault(_mobileAds);

var _abandonCheckout = __webpack_require__("./src/notificationQueue/globalNotifications/abandonCheckout.js");

var _abandonCheckout2 = _interopRequireDefault(_abandonCheckout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = [_loginPrompt2.default, _tradeOnboarding2.default, _mobileAds2.default].concat(_toConsumableArray(_abandonCheckout2.default));

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/loginPrompt.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _serverVars = __webpack_require__("./node_modules/server-vars/index.js");

var _serverVars2 = _interopRequireDefault(_serverVars);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _pageConstants = __webpack_require__("./src/utils/pageConstants.js");

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

var _dibsVisitTracking = __webpack_require__("./node_modules/dibs-visit-tracking/dist/index.js");

var _AuthModalLoader = __webpack_require__("./src/utils/AuthModalLoader.js");

var _AuthModalLoader2 = _interopRequireDefault(_AuthModalLoader);

var _postAuthLoader = __webpack_require__("./src/notificationQueue/globalNotifications/helpers/postAuthLoader.js");

var postAuthLoader = _interopRequireWildcard(_postAuthLoader);

var _isPageType = __webpack_require__("./src/utils/isPageType.js");

var _isPageType2 = _interopRequireDefault(_isPageType);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isPlaReferrer = function isPlaReferrer() {
    var query = _querystring2.default.parse(location.search);
    var utmMedium = query.utm_medium ? query.utm_medium.toLowerCase() : '';
    return utmMedium === "pla" || typeof query.product !== 'undefined' && typeof query.gclid !== 'undefined';
};

var isAllowedPageType = function isAllowedPageType() {
    var isPdpPrintPage = _serverVars2.default.get('settings.isPrintPDP');
    var allowedPageTypes = [_pageConstants.PAGE_TYPE.HOME, _pageConstants.PAGE_TYPE.CREATOR, _pageConstants.PAGE_TYPE.DEALER, _pageConstants.PAGE_TYPE.PDP];

    var isAllowedPage = (0, _isPageType2.default)([].concat(allowedPageTypes, _toConsumableArray(_pageConstants.BROWSE_TYPES)));

    return isAllowedPage && !isPdpPrintPage;
};

/**
 * should visitor be prompted to login?
 * @returns {boolean}
 */
var isBlocked = function isBlocked() {
    var query = _querystring2.default.parse(location.search);
    var loggedIn = (0, _dibsCookieJar.getUserId)(document.cookie);
    if (loggedIn || query.modal || !isAllowedPageType() || isPlaReferrer()) {
        return true;
    }
    return false;
};

var shouldPromptLoginRegistration = function shouldPromptLoginRegistration(visitCountModel) {
    return visitCountModel.get('session') === visitCountModel.get('regPromptLimit');
};

var canAutoPromptUser = function canAutoPromptUser() {
    var visitCountModel = new _dibsVisitTracking.VisitCountModel();
    var isModalBlocked = isBlocked();
    var shouldOpenModal = shouldPromptLoginRegistration(visitCountModel);
    if (shouldOpenModal && !isModalBlocked) {
        return true;
    } else if (shouldOpenModal && isModalBlocked) {
        visitCountModel.increment('regPromptLimit');
        visitCountModel.save();
        return false;
    } else {
        return false;
    }
};

var getActionAndFlow = function getActionAndFlow() {
    var action = _AuthModalLoader2.default.constants.REGISTER;
    var flow = _AuthModalLoader2.default.constants.PAGEVIEW_LIMIT_FLOW;
    var ga = {};
    var everLoggedIn = (0, _dibsCookieJar.getEverLoggedIn)(document.cookie);
    if (everLoggedIn) {
        action = _AuthModalLoader2.default.constants.LOGIN;
        flow = _AuthModalLoader2.default.constants.PAGEVIEW_LIMIT_FLOW;
        if (everLoggedIn.toLowerCase() === "trade") {
            flow = _AuthModalLoader2.default.constants.PAGEVIEW_LIMIT_FLOW;
            ga.label = 'pageview limit reached - trade';
        }
    }

    return { action: action, flow: flow, ga: ga };
};

/**
 * prompts visitor to register if it's due
 * @return {boolean} true if login prompted
 */
var openLoginModal = function openLoginModal() {
    return function (dispatch) {
        var _getActionAndFlow = getActionAndFlow(),
            action = _getActionAndFlow.action,
            flow = _getActionAndFlow.flow,
            ga = _getActionAndFlow.ga;

        _dibsBrowserStorage.sessionStorage.setItem('authModalShown', true);

        if (action === _AuthModalLoader2.default.constants.REGISTER && flow === _AuthModalLoader2.default.constants.PAGEVIEW_LIMIT_FLOW) {
            postAuthLoader.autoPromptRegistration({ flow: flow });
        } else {
            _AuthModalLoader2.default.show({
                action: action,
                flow: flow,
                ga: Object.assign({
                    label: 'pageview limit reached'
                }, ga)
            });
        }
        dispatch({ type: 'noop' });
    };
};

/**
 * Checks condition for auto prompt user.
 * Opens modal if condition is satisfied.
 * Condition:
 * page view >= 3,
 * home / browse / creator / pdp (not print) page type,
 * User is not logged in and AuthModal is not opened.
 *
 * @return {Promise}
 */
var loginPromptRule = function loginPromptRule() {
    if (canAutoPromptUser()) {
        return Promise.resolve(true);
    }
    return Promise.resolve(false);
};

module.exports = {
    name: "loginPrompt",
    rule: loginPromptRule,
    action: openLoginModal,
    priority: 250
};

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/mobileAds.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

var _referrerHelper = __webpack_require__("./src/notificationQueue/globalNotifications/helpers/referrerHelper.js");

var _mobileAdsHelper = __webpack_require__("./src/notificationQueue/globalNotifications/helpers/mobileAdsHelper.js");

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _pageConstants = __webpack_require__("./src/utils/pageConstants.js");

var _isPageType = __webpack_require__("./src/utils/isPageType.js");

var _isPageType2 = _interopRequireDefault(_isPageType);

var _dibsVisitTracking = __webpack_require__("./node_modules/dibs-visit-tracking/dist/index.js");

var _constants = __webpack_require__("./src/mobileAds/constants.js");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAllowedPageType = function isAllowedPageType() {
    return !(0, _isPageType2.default)(_pageConstants.PAGE_TYPE.CHECKOUT);
};

var checkPageViewCount = function checkPageViewCount() {
    var visitCountModel = new _dibsVisitTracking.VisitCountModel();
    return visitCountModel.get('session') >= 2;
};

var shouldSeeInterstitial = function shouldSeeInterstitial() {
    var _qs$parse = _querystring2.default.parse(location.search),
        emailToken = _qs$parse.emailToken;

    var emailReferrer = _dibsBrowserStorage.sessionStorage.getItem('emailReferrer');

    if ((0, _referrerHelper.isEmailReferrer)() || emailToken) {
        _dibsBrowserStorage.sessionStorage.setItem('emailReferrer', true);
        emailReferrer = true;
    }

    return !!(0, _dibsCookieJar.getUserId)(document.cookie) && (0, _mobileAdsHelper.shouldShowAd)() && !emailReferrer && isAllowedPageType() && !(0, _referrerHelper.isAmpReferrer)() && checkPageViewCount();
};

/**
 * Condition:
 * second page view,
 * logged in user,
 * no cookie "dibsMobileInterstitial",
 * not PlaReferrer, not email referrer,
 * not checkout
 * iphone
 *
 * @return {Promise}
 */
var mobileAdsAction = function mobileAdsAction() {
    return function (dispatch) {
        var NOTIFICATION_TYPE = _constants2.default.NOTIFICATION_TYPE;

        __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "./src/mobileAds/index.jsx")).then(function (_ref) {
            var initMobileModal = _ref.initMobileModal;

            initMobileModal();
            dispatch({ type: NOTIFICATION_TYPE });
        });
    };
};

exports.default = {
    name: "mobileAd",
    rule: function rule() {
        return Promise.resolve(shouldSeeInterstitial());
    },
    action: mobileAdsAction,
    priority: 150
};

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/tradeOnboarding.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _abExperiments = __webpack_require__("./src/utils/abExperiments.js");

var _abExperiments2 = _interopRequireDefault(_abExperiments);

var _isPageType = __webpack_require__("./src/utils/isPageType.js");

var _isPageType2 = _interopRequireDefault(_isPageType);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__("./src/scss/tradeOnboarding.scss");

var _require = __webpack_require__("./src/utils/pageConstants.js"),
    PAGE_TYPE = _require.PAGE_TYPE;

var _require2 = __webpack_require__("./src/utils/tradeOnboardingHelper.js"),
    loadOnboardingModal = _require2.loadOnboardingModal,
    hasSeenModal = _require2.hasSeenModal,
    getModalType = _require2.getModalType,
    fetchTradeUserData = _require2.fetchTradeUserData,
    LABEL_PDP = _require2.LABEL_PDP,
    LABEL_SEARCH_BROWSE = _require2.LABEL_SEARCH_BROWSE;

var showNewOnboardingFlow = function showNewOnboardingFlow() {
    if (_abExperiments2.default.tradeOnboardingFlow) {
        setTimeout(function () {
            return _abExperiments2.default.tradeOnboardingFlow.resolve(false);
        }, 1500);
        return _abExperiments2.default.tradeOnboardingFlow;
    } else {
        return Promise.resolve(false);
    }
};

function tradeOnboardingRule() {
    var isBlacklistedPage = (0, _isPageType2.default)([PAGE_TYPE.CHECKOUT, PAGE_TYPE.SOURCING]);
    if (!(0, _dibsCookieJar.getUserId)(document.cookie) || isBlacklistedPage || hasSeenModal()) {
        return Promise.resolve(false);
    }

    return fetchTradeUserData().then(function (_ref) {
        var isVerifiedTrade = _ref.isVerifiedTrade;

        if (!isVerifiedTrade) {
            return Promise.resolve(false);
        } else {
            return Promise.resolve(true);
        }
    }).catch(function (err) {
        console.error(err);
        return Promise.resolve(false);
    });
};

var tradeOnboardingShow = function tradeOnboardingShow() {
    return function (dispatch) {
        var label = (0, _isPageType2.default)(PAGE_TYPE.PDP) ? LABEL_PDP : LABEL_SEARCH_BROWSE;
        return Promise.all([fetchTradeUserData(), showNewOnboardingFlow()]).then(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                email = _ref3[0].email,
                showNewFlow = _ref3[1];

            return loadOnboardingModal({
                buyerEmail: email,
                showNewFlow: showNewFlow,
                trackingLabel: 'modal - ' + label
            }).then(function () {
                return dispatch({
                    success: true,
                    type: getModalType()
                });
            });
        });
    };
};

module.exports = {
    name: "tradeOnboarding",
    priority: 450,
    rule: tradeOnboardingRule,
    action: tradeOnboardingShow
};

/***/ }),

/***/ "./src/queries/__generated__/footerRootQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash f8aacf239149fda76f4543f579f70411
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type footerRootQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query footerRootQuery(
  $hasUserId: Boolean!
  $userId: String!
) {
  viewer {
    ...Footer_viewer
    id
  }
}

fragment Footer_viewer on Viewer {
  user(userId: $userId) @include(if: $hasUserId) {
    serviceId
    ...CurrencySelector_user
    id
  }
  ...CurrencySelector_viewer
}

fragment CurrencySelector_user on User {
  id
  serviceId
  profile {
    currency
  }
}

fragment CurrencySelector_viewer on Viewer {
  currencies
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "footerRootQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "Footer_viewer",
        "args": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "footerRootQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "footerRootQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "currencies",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String!"
          }],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "name": "profile",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query footerRootQuery(\n  $hasUserId: Boolean!\n  $userId: String!\n) {\n  viewer {\n    ...Footer_viewer\n    id\n  }\n}\n\nfragment Footer_viewer on Viewer {\n  user(userId: $userId) @include(if: $hasUserId) {\n    serviceId\n    ...CurrencySelector_user\n    id\n  }\n  ...CurrencySelector_viewer\n}\n\nfragment CurrencySelector_user on User {\n  id\n  serviceId\n  profile {\n    currency\n  }\n}\n\nfragment CurrencySelector_viewer on Viewer {\n  currencies\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/queries/__generated__/headerRootQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 926f52b9a57bdc88dd4953979259f5bf
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type headerRootQueryResponse = {|
  +viewer: ?{| |};
  +serverViewer: ?{|
    +navigation: ?{| |};
  |};
|};
*/

/*
query headerRootQuery(
  $hasUserId: Boolean!
  $previewKey: String = ""
  $showMarketingMessages: Boolean!
  $fetchMarketingMessagesTransactions: Boolean = false
  $userId: String!
  $userIds: [String]!
) {
  viewer {
    ...Header_viewer
    id
  }
  serverViewer: viewer {
    navigation(rootId: $previewKey) {
      ...Header_navigation
      id
    }
    id
  }
}

fragment Header_viewer on Viewer {
  ...TopBar_viewer
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $hasUserId) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $hasUserId) {
    totalResults
  }
  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 1) @include(if: $hasUserId) {
    totalResults
    edges {
      node {
        mostRecentOffer {
          createdDate
          subTotalAmount {
            convertedAmounts {
              USD
            }
          }
          id
        }
        id
      }
    }
  }
  ... on Viewer @include(if: $hasUserId) {
    tradeChatEmail: userRelationships(userIds: $userIds, relationshipType: VIP) {
      userDataB {
        __typename
        ... on VipRepData {
          email
        }
      }
      id
    }
    vipChatEmail: userRelationships(userIds: $userIds, relationshipType: TRADE) {
      userDataB {
        __typename
        ... on TradeRepData {
          email
        }
      }
      id
    }
  }
  user(userId: $userId) @include(if: $hasUserId) {
    firstSessionDate
    isTrade: hasPermission(name: "B_TRADE_CHECKOUT")
    hasVipPermission: hasPermission(name: "B_VIP_CHECKOUT")
    profile {
      email
      zipCode
      currency
    }
    serviceId
    totalMessagesToDealers
    tradeFirm {
      serviceId
      tier
      id
    }
    verifiedTradeStatus
    isPromoCodeEligible(code: "SAVE15")
    isVip
    createdDate
    isVerifiedTrade
    ... on User @include(if: $showMarketingMessages) {
      ...MessageBanner_user
    }
    ...TopBar_user
    id
  }
  ... on Viewer @include(if: $showMarketingMessages) {
    ...MessageBanner_viewer
  }
}

fragment Header_navigation on Navigation {
  ...BottomBar_navigation
}

fragment BottomBar_navigation on Navigation {
  ...SiteNav_navigation
}

fragment SiteNav_navigation on Navigation {
  modules {
    isVertical
    serviceId
    name
    url
    items {
      serviceId
      name
      type
      items {
        serviceId
        name
        url
        visible
        id
      }
      id
    }
    id
  }
}

fragment TopBar_viewer on Viewer {
  ...CartNav_viewer
  ...Notifications_initialViewer
}

fragment MessageBanner_user on User {
  isVip
  isVerifiedTrade
  verifiedTradeStatus
  verifiedTradeSubStatus
  tradeFirm {
    loyalty {
      status
    }
    id
  }
}

fragment TopBar_user on User {
  ...AccountNav_user
  ...CartNav_user
  ...Notifications_user
}

fragment MessageBanner_viewer on Viewer {
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  confirmedTransactions: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
}

fragment AccountNav_user on User {
  profile {
    firstName
  }
  conversationSummary {
    totalUnreadConversationCount
  }
  tradeFirm {
    loyalty {
      status
    }
    id
  }
}

fragment CartNav_user on User {
  profile {
    currency
  }
}

fragment Notifications_user on User {
  isPromoCodeEligible(code: "SAVE15")
}

fragment CartNav_viewer on Viewer {
  portfolios(userIds: $userIds, portfolioTypes: [CART], first: 1) @include(if: $hasUserId) {
    edges {
      node {
        items(first: 3) {
          totalResults
        }
        id
      }
    }
  }
}

fragment Notifications_initialViewer on Viewer {
  conversations(filter: "showUnreadOnly") @include(if: $hasUserId) {
    metadata {
      lastUnreadMessageDate
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "previewKey",
      "type": "String",
      "defaultValue": ""
    }, {
      "kind": "LocalArgument",
      "name": "showMarketingMessages",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchMarketingMessagesTransactions",
      "type": "Boolean",
      "defaultValue": false
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "headerRootQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "Header_viewer",
        "args": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "serverViewer",
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": [{
          "kind": "Variable",
          "name": "rootId",
          "variableName": "previewKey",
          "type": "String"
        }],
        "concreteType": "Navigation",
        "name": "navigation",
        "plural": false,
        "selections": [{
          "kind": "FragmentSpread",
          "name": "Header_navigation",
          "args": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "headerRootQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "previewKey",
      "type": "String",
      "defaultValue": ""
    }, {
      "kind": "LocalArgument",
      "name": "showMarketingMessages",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchMarketingMessagesTransactions",
      "type": "Boolean",
      "defaultValue": false
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String]!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "headerRootQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "showMarketingMessages",
        "selections": [{
          "kind": "InlineFragment",
          "type": "Viewer",
          "selections": [{
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchMarketingMessagesTransactions",
            "selections": [{
              "kind": "LinkedField",
              "alias": "allTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": "initiatedTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.initiated",
                "type": "String"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": "submittedTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.submitted",
                "type": "String"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": "confirmedTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "sort",
                "value": "createdDate asc",
                "type": "String"
              }, {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.confirmed",
                "type": "String"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }]
          }]
        }]
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Literal",
            "name": "first",
            "value": 1,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "portfolioTypes",
            "value": ["CART"],
            "type": "[PortfolioTypes]"
          }, {
            "kind": "Variable",
            "name": "userIds",
            "variableName": "userIds",
            "type": "[String]"
          }],
          "concreteType": "PortfoliosConnection",
          "name": "portfolios",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PortfoliosEdge",
            "name": "edges",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "PortfolioV2",
              "name": "node",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": [{
                  "kind": "Literal",
                  "name": "first",
                  "value": 3,
                  "type": "Int"
                }],
                "concreteType": "PortfolioItemsConnection",
                "name": "items",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "totalResults",
                  "storageKey": null
                }],
                "storageKey": "items{\"first\":3}"
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Literal",
            "name": "filter",
            "value": "showUnreadOnly",
            "type": "String"
          }],
          "concreteType": "ConversationConnection",
          "name": "conversations",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "ConversationMetadata",
            "name": "metadata",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "lastUnreadMessageDate",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": "conversations{\"filter\":\"showUnreadOnly\"}"
        }, {
          "kind": "LinkedField",
          "alias": "allTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.initiated",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.submitted",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "confirmedTransactionsMostRecent",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 1,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "sort",
            "value": "createdDate asc",
            "type": "String"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.confirmed",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TransactionEdge",
            "name": "edges",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Transaction",
              "name": "node",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "name": "mostRecentOffer",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "createdDate",
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "name": "subTotalAmount",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ConvertedAmounts",
                    "name": "convertedAmounts",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "USD",
                      "storageKey": null
                    }],
                    "storageKey": null
                  }],
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String!"
          }],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "verifiedTradeStatus",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstSessionDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": "hasVipPermission",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_VIP_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "name": "profile",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "email",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "zipCode",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "firstName",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalMessagesToDealers",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "name": "tradeFirm",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "tier",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmLoyaltyType",
              "name": "loyalty",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "status",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": "isTrade",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_TRADE_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": [{
              "kind": "Literal",
              "name": "code",
              "value": "SAVE15",
              "type": "String!"
            }],
            "name": "isPromoCodeEligible",
            "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isVip",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "createdDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isVerifiedTrade",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Summary",
            "name": "conversationSummary",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalUnreadConversationCount",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "Condition",
            "passingValue": true,
            "condition": "showMarketingMessages",
            "selections": [{
              "kind": "InlineFragment",
              "type": "User",
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "verifiedTradeSubStatus",
                "storageKey": null
              }]
            }]
          }],
          "storageKey": null
        }, {
          "kind": "InlineFragment",
          "type": "Viewer",
          "selections": [{
            "kind": "LinkedField",
            "alias": "tradeChatEmail",
            "args": [{
              "kind": "Literal",
              "name": "relationshipType",
              "value": "VIP",
              "type": "relationshipType!"
            }, {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds",
              "type": "[String]!"
            }],
            "concreteType": "UserRelationship",
            "name": "userRelationships",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": null,
              "name": "userDataB",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "__typename",
                "storageKey": null
              }, {
                "kind": "InlineFragment",
                "type": "VipRepData",
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "email",
                  "storageKey": null
                }]
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": "vipChatEmail",
            "args": [{
              "kind": "Literal",
              "name": "relationshipType",
              "value": "TRADE",
              "type": "relationshipType!"
            }, {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds",
              "type": "[String]!"
            }],
            "concreteType": "UserRelationship",
            "name": "userRelationships",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": null,
              "name": "userDataB",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "__typename",
                "storageKey": null
              }, {
                "kind": "InlineFragment",
                "type": "TradeRepData",
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "email",
                  "storageKey": null
                }]
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }]
        }]
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "serverViewer",
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": [{
          "kind": "Variable",
          "name": "rootId",
          "variableName": "previewKey",
          "type": "String"
        }],
        "concreteType": "Navigation",
        "name": "navigation",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "NavigationModule",
          "name": "modules",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isVertical",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "url",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "NavigationTopLevel",
            "name": "items",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "type",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "NavigationItem",
              "name": "items",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "serviceId",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "url",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "visible",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query headerRootQuery(\n  $hasUserId: Boolean!\n  $previewKey: String = \"\"\n  $showMarketingMessages: Boolean!\n  $fetchMarketingMessagesTransactions: Boolean = false\n  $userId: String!\n  $userIds: [String]!\n) {\n  viewer {\n    ...Header_viewer\n    id\n  }\n  serverViewer: viewer {\n    navigation(rootId: $previewKey) {\n      ...Header_navigation\n      id\n    }\n    id\n  }\n}\n\nfragment Header_viewer on Viewer {\n  ...TopBar_viewer\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 1) @include(if: $hasUserId) {\n    totalResults\n    edges {\n      node {\n        mostRecentOffer {\n          createdDate\n          subTotalAmount {\n            convertedAmounts {\n              USD\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  ... on Viewer @include(if: $hasUserId) {\n    tradeChatEmail: userRelationships(userIds: $userIds, relationshipType: VIP) {\n      userDataB {\n        __typename\n        ... on VipRepData {\n          email\n        }\n      }\n      id\n    }\n    vipChatEmail: userRelationships(userIds: $userIds, relationshipType: TRADE) {\n      userDataB {\n        __typename\n        ... on TradeRepData {\n          email\n        }\n      }\n      id\n    }\n  }\n  user(userId: $userId) @include(if: $hasUserId) {\n    firstSessionDate\n    isTrade: hasPermission(name: \"B_TRADE_CHECKOUT\")\n    hasVipPermission: hasPermission(name: \"B_VIP_CHECKOUT\")\n    profile {\n      email\n      zipCode\n      currency\n    }\n    serviceId\n    totalMessagesToDealers\n    tradeFirm {\n      serviceId\n      tier\n      id\n    }\n    verifiedTradeStatus\n    isPromoCodeEligible(code: \"SAVE15\")\n    isVip\n    createdDate\n    isVerifiedTrade\n    ... on User @include(if: $showMarketingMessages) {\n      ...MessageBanner_user\n    }\n    ...TopBar_user\n    id\n  }\n  ... on Viewer @include(if: $showMarketingMessages) {\n    ...MessageBanner_viewer\n  }\n}\n\nfragment Header_navigation on Navigation {\n  ...BottomBar_navigation\n}\n\nfragment BottomBar_navigation on Navigation {\n  ...SiteNav_navigation\n}\n\nfragment SiteNav_navigation on Navigation {\n  modules {\n    isVertical\n    serviceId\n    name\n    url\n    items {\n      serviceId\n      name\n      type\n      items {\n        serviceId\n        name\n        url\n        visible\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment TopBar_viewer on Viewer {\n  ...CartNav_viewer\n  ...Notifications_initialViewer\n}\n\nfragment MessageBanner_user on User {\n  isVip\n  isVerifiedTrade\n  verifiedTradeStatus\n  verifiedTradeSubStatus\n  tradeFirm {\n    loyalty {\n      status\n    }\n    id\n  }\n}\n\nfragment TopBar_user on User {\n  ...AccountNav_user\n  ...CartNav_user\n  ...Notifications_user\n}\n\nfragment MessageBanner_viewer on Viewer {\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  confirmedTransactions: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n}\n\nfragment AccountNav_user on User {\n  profile {\n    firstName\n  }\n  conversationSummary {\n    totalUnreadConversationCount\n  }\n  tradeFirm {\n    loyalty {\n      status\n    }\n    id\n  }\n}\n\nfragment CartNav_user on User {\n  profile {\n    currency\n  }\n}\n\nfragment Notifications_user on User {\n  isPromoCodeEligible(code: \"SAVE15\")\n}\n\nfragment CartNav_viewer on Viewer {\n  portfolios(userIds: $userIds, portfolioTypes: [CART], first: 1) @include(if: $hasUserId) {\n    edges {\n      node {\n        items(first: 3) {\n          totalResults\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment Notifications_initialViewer on Viewer {\n  conversations(filter: \"showUnreadOnly\") @include(if: $hasUserId) {\n    metadata {\n      lastUnreadMessageDate\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/queries/__generated__/mobileNavWrapperRootQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 1e2f305134460c2eb7840618648f1526
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type mobileNavWrapperRootQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query mobileNavWrapperRootQuery(
  $hasUserId: Boolean!
  $showMarketingMessages: Boolean!
  $fetchMarketingMessagesTransactions: Boolean = false
  $userId: String!
  $userIds: [String!]
) {
  viewer {
    ...MobileNavWrapper_viewer
    id
  }
}

fragment MobileNavWrapper_viewer on Viewer {
  ...MobileNav_viewer
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $hasUserId) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $hasUserId) {
    totalResults
  }
  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 1) @include(if: $hasUserId) {
    totalResults
    edges {
      node {
        mostRecentOffer {
          createdDate
          subTotalAmount {
            convertedAmounts {
              USD
            }
          }
          id
        }
        id
      }
    }
  }
  user(userId: $userId) @include(if: $hasUserId) {
    isVerifiedTrade
    firstSessionDate
    isTrade: hasPermission(name: "B_TRADE_CHECKOUT")
    hasVipPermission: hasPermission(name: "B_VIP_CHECKOUT")
    profile {
      email
      zipCode
      currency
    }
    serviceId
    totalMessagesToDealers
    tradeFirm {
      serviceId
      tier
      id
    }
    verifiedTradeStatus
    isPromoCodeEligible(code: "SAVE15")
    ...MobileNav_user
    id
  }
}

fragment MobileNav_viewer on Viewer {
  ...MobileNavMenu_viewer
  ... on Viewer @include(if: $showMarketingMessages) {
    ...MessageBanner_viewer
  }
}

fragment MobileNav_user on User {
  ...MobileNavMenu_user
  ...MobileNavHeader_user
  ... on User @include(if: $showMarketingMessages) {
    ...MessageBanner_user
  }
}

fragment MobileNavMenu_user on User {
  conversationSummary {
    totalUnreadConversationCount
  }
  ...MobileNavMenuBody_user
}

fragment MobileNavHeader_user on User {
  isVerifiedTrade
  conversationSummary {
    totalUnreadConversationCount
  }
  ...MobileNavCartContainer_user
}

fragment MessageBanner_user on User {
  isVip
  isVerifiedTrade
  verifiedTradeStatus
  verifiedTradeSubStatus
  tradeFirm {
    loyalty {
      status
    }
    id
  }
}

fragment MobileNavCartContainer_user on User {
  cart {
    items {
      item {
        itemId
      }
      id
    }
    id
  }
}

fragment MobileNavMenuBody_user on User {
  ...MobileNavAuthButtons_user
}

fragment MobileNavAuthButtons_user on User {
  serviceId
}

fragment MobileNavMenu_viewer on Viewer {
  navigation {
    modules {
      name
      isVertical
      url
      items {
        visible
        type
        name
        items {
          name
          url
          id
        }
        id
      }
      categories {
        name
        count
        label
        id
      }
      id
    }
    id
  }
}

fragment MessageBanner_viewer on Viewer {
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  confirmedTransactions: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "showMarketingMessages",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchMarketingMessagesTransactions",
      "type": "Boolean",
      "defaultValue": false
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String!]",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "mobileNavWrapperRootQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "MobileNavWrapper_viewer",
        "args": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "mobileNavWrapperRootQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "showMarketingMessages",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "fetchMarketingMessagesTransactions",
      "type": "Boolean",
      "defaultValue": false
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String!]",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "mobileNavWrapperRootQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Navigation",
        "name": "navigation",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "NavigationModule",
          "name": "modules",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isVertical",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "url",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "NavigationTopLevel",
            "name": "items",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "visible",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "type",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "NavigationItem",
              "name": "items",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "url",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "NavigationModuleCategories",
            "name": "categories",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "count",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "label",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": "allTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.initiated",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.submitted",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "confirmedTransactionsMostRecent",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 1,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "sort",
            "value": "createdDate asc",
            "type": "String"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.confirmed",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TransactionEdge",
            "name": "edges",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Transaction",
              "name": "node",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "name": "mostRecentOffer",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "createdDate",
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "name": "subTotalAmount",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ConvertedAmounts",
                    "name": "convertedAmounts",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "USD",
                      "storageKey": null
                    }],
                    "storageKey": null
                  }],
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String!"
          }],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "name": "tradeFirm",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "tier",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isVerifiedTrade",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": "isTrade",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_TRADE_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
          }, {
            "kind": "ScalarField",
            "alias": "hasVipPermission",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_VIP_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "name": "profile",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "email",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "zipCode",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalMessagesToDealers",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstSessionDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "verifiedTradeStatus",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": [{
              "kind": "Literal",
              "name": "code",
              "value": "SAVE15",
              "type": "String!"
            }],
            "name": "isPromoCodeEligible",
            "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Summary",
            "name": "conversationSummary",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "totalUnreadConversationCount",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "PortfolioV1",
            "name": "cart",
            "plural": false,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "PortfolioItemV1",
              "name": "items",
              "plural": true,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ItemSummary",
                "name": "item",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "itemId",
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "Condition",
            "passingValue": true,
            "condition": "showMarketingMessages",
            "selections": [{
              "kind": "InlineFragment",
              "type": "User",
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "isVip",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "verifiedTradeSubStatus",
                "storageKey": null
              }, {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "TradeFirmType",
                "name": "tradeFirm",
                "plural": false,
                "selections": [{
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "TradeFirmLoyaltyType",
                  "name": "loyalty",
                  "plural": false,
                  "selections": [{
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "status",
                    "storageKey": null
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }]
            }]
          }],
          "storageKey": null
        }]
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "showMarketingMessages",
        "selections": [{
          "kind": "InlineFragment",
          "type": "Viewer",
          "selections": [{
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchMarketingMessagesTransactions",
            "selections": [{
              "kind": "LinkedField",
              "alias": "allTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": "initiatedTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.initiated",
                "type": "String"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": "submittedTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.submitted",
                "type": "String"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": "confirmedTransactions",
              "args": [{
                "kind": "Variable",
                "name": "buyerId",
                "variableName": "userIds",
                "type": "[String]"
              }, {
                "kind": "Literal",
                "name": "first",
                "value": 0,
                "type": "Int"
              }, {
                "kind": "Literal",
                "name": "sort",
                "value": "createdDate asc",
                "type": "String"
              }, {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.confirmed",
                "type": "String"
              }],
              "concreteType": "TransactionConnection",
              "name": "transactions",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "totalResults",
                "storageKey": null
              }],
              "storageKey": null
            }]
          }]
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query mobileNavWrapperRootQuery(\n  $hasUserId: Boolean!\n  $showMarketingMessages: Boolean!\n  $fetchMarketingMessagesTransactions: Boolean = false\n  $userId: String!\n  $userIds: [String!]\n) {\n  viewer {\n    ...MobileNavWrapper_viewer\n    id\n  }\n}\n\nfragment MobileNavWrapper_viewer on Viewer {\n  ...MobileNav_viewer\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 1) @include(if: $hasUserId) {\n    totalResults\n    edges {\n      node {\n        mostRecentOffer {\n          createdDate\n          subTotalAmount {\n            convertedAmounts {\n              USD\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  user(userId: $userId) @include(if: $hasUserId) {\n    isVerifiedTrade\n    firstSessionDate\n    isTrade: hasPermission(name: \"B_TRADE_CHECKOUT\")\n    hasVipPermission: hasPermission(name: \"B_VIP_CHECKOUT\")\n    profile {\n      email\n      zipCode\n      currency\n    }\n    serviceId\n    totalMessagesToDealers\n    tradeFirm {\n      serviceId\n      tier\n      id\n    }\n    verifiedTradeStatus\n    isPromoCodeEligible(code: \"SAVE15\")\n    ...MobileNav_user\n    id\n  }\n}\n\nfragment MobileNav_viewer on Viewer {\n  ...MobileNavMenu_viewer\n  ... on Viewer @include(if: $showMarketingMessages) {\n    ...MessageBanner_viewer\n  }\n}\n\nfragment MobileNav_user on User {\n  ...MobileNavMenu_user\n  ...MobileNavHeader_user\n  ... on User @include(if: $showMarketingMessages) {\n    ...MessageBanner_user\n  }\n}\n\nfragment MobileNavMenu_user on User {\n  conversationSummary {\n    totalUnreadConversationCount\n  }\n  ...MobileNavMenuBody_user\n}\n\nfragment MobileNavHeader_user on User {\n  isVerifiedTrade\n  conversationSummary {\n    totalUnreadConversationCount\n  }\n  ...MobileNavCartContainer_user\n}\n\nfragment MessageBanner_user on User {\n  isVip\n  isVerifiedTrade\n  verifiedTradeStatus\n  verifiedTradeSubStatus\n  tradeFirm {\n    loyalty {\n      status\n    }\n    id\n  }\n}\n\nfragment MobileNavCartContainer_user on User {\n  cart {\n    items {\n      item {\n        itemId\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment MobileNavMenuBody_user on User {\n  ...MobileNavAuthButtons_user\n}\n\nfragment MobileNavAuthButtons_user on User {\n  serviceId\n}\n\nfragment MobileNavMenu_viewer on Viewer {\n  navigation {\n    modules {\n      name\n      isVertical\n      url\n      items {\n        visible\n        type\n        name\n        items {\n          name\n          url\n          id\n        }\n        id\n      }\n      categories {\n        name\n        count\n        label\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment MessageBanner_viewer on Viewer {\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  confirmedTransactions: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/queries/footerRootQuery.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialVariables = undefined;

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

exports.default = {
    modern: function modern() {
        return __webpack_require__("./src/queries/__generated__/footerRootQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var Footer_viewer = Footer.getFragment('viewer');
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'hasUserId'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userId'
            }],
            name: 'footerRootQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(Footer_viewer)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'FooterRootQuery',
                    type: 'Query'
                };
            }()
        };
    }
};
var initialVariables = exports.initialVariables = {
    hasUserId: false,
    userId: ''
};

/***/ }),

/***/ "./src/queries/headerRootQuery.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialVariables = undefined;

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

exports.default = {
    modern: function modern() {
        return __webpack_require__("./src/queries/__generated__/headerRootQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var Header_viewer = Header.getFragment("viewer"),
            Header_navigation = Header.getFragment("navigation");
        return {
            kind: "OperationDefinition",
            argumentDefinitions: [{
                defaultValue: null,
                kind: "LocalArgument",
                name: "hasUserId"
            }, {
                defaultValue: "",
                kind: "LocalArgument",
                name: "previewKey"
            }, {
                defaultValue: null,
                kind: "LocalArgument",
                name: "showMarketingMessages"
            }, {
                defaultValue: false,
                kind: "LocalArgument",
                name: "fetchMarketingMessagesTransactions"
            }, {
                defaultValue: null,
                kind: "LocalArgument",
                name: "userId"
            }, {
                defaultValue: null,
                kind: "LocalArgument",
                name: "userIds"
            }],
            name: "headerRootQuery",
            operation: "query",
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: "id",
                            kind: "Field",
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: "ID"
                        }, RelayQL_GENERATED.__frag(Header_viewer)]),
                        fieldName: "viewer",
                        kind: "Field",
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: "node",
                            inferredPrimaryKey: "id"
                        },
                        type: "Viewer"
                    }, {
                        alias: "serverViewer",
                        children: [{
                            calls: [{
                                kind: "Call",
                                metadata: {},
                                name: "rootId",
                                value: {
                                    kind: "CallVariable",
                                    callVariableName: "previewKey"
                                }
                            }],
                            children: [].concat.apply([], [{
                                fieldName: "id",
                                kind: "Field",
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: "ID"
                            }, RelayQL_GENERATED.__frag(Header_navigation)]),
                            fieldName: "navigation",
                            kind: "Field",
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: "node",
                                inferredPrimaryKey: "id"
                            },
                            type: "Navigation"
                        }, {
                            fieldName: "id",
                            kind: "Field",
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: "ID"
                        }],
                        fieldName: "viewer",
                        kind: "Field",
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: "node",
                            inferredPrimaryKey: "id"
                        },
                        type: "Viewer"
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: "Fragment",
                    metadata: {},
                    name: "HeaderRootQuery",
                    type: "Query"
                };
            }()
        };
    }
};
var initialVariables = exports.initialVariables = {
    hasUserId: false,
    previewKey: "",
    showMarketingMessages: false,
    userId: "",
    userIds: []
};

/***/ }),

/***/ "./src/queries/mobileNavWrapperRootQuery.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialVariables = undefined;

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

exports.default = {
    modern: function modern() {
        return __webpack_require__("./src/queries/__generated__/mobileNavWrapperRootQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var MobileNavWrapper_viewer = MobileNavWrapper.getFragment('viewer');
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'hasUserId'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'showMarketingMessages'
            }, {
                defaultValue: false,
                kind: 'LocalArgument',
                name: 'fetchMarketingMessagesTransactions'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userId'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userIds'
            }],
            name: 'mobileNavWrapperRootQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(MobileNavWrapper_viewer)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'MobileNavWrapperRootQuery',
                    type: 'Query'
                };
            }()
        };
    }
};
var initialVariables = exports.initialVariables = {
    hasUserId: false,
    fetchMarketingMessagesTransactions: false,
    showMarketingMessages: false,
    userId: '',
    userIds: []
};

/***/ }),

/***/ "./src/reducers/cartReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__("./src/actions/constants.js");

var defaultState = {
    items: []
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {
        case _constants.actionTypes.SET_CART_ITEMS:
            return Object.assign({}, state, {
                items: action.payload.items
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/footerReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = footerReducer;

var _constants = __webpack_require__("./src/actions/constants.js");

function footerReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];


    switch (action.type) {
        case _constants.actionTypes.SET_CURRENCY:
            return _extends({}, state, {
                userCurrency: action.currency
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/headerReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = headerReducer;

var _constants = __webpack_require__("./src/actions/constants.js");

function headerReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { initialTrackingFired: false };
    var action = arguments[1];


    switch (action.type) {
        case _constants.actionTypes.SET_DRAWER_ANIMATION:
            var animation = action.animation;
            var _actionValues$drawerA = _constants.actionValues.drawerAnimations,
                SLIDE_IN = _actionValues$drawerA.SLIDE_IN,
                NONE = _actionValues$drawerA.NONE;


            if (state.animation === NONE && animation === SLIDE_IN) {
                return state;
            }

            return _extends({}, state, {
                animation: action.animation
            });

        case _constants.actionTypes.SET_UPDATE_USER_STATE:
            return _extends({}, state, {
                updateUserState: action.updateUserState,
                initialTrackingFired: false
            });
        case _constants.actionTypes.INITIAL_TRACKING_FIRED:
            return _extends({}, state, {
                initialTrackingFired: true
            });
        case _constants.actionTypes.SET_USER_TYPE_TRADE:
            return _extends({}, state, {
                isUserTypeTrade: action.isUserTypeTrade
            });
        case _constants.actionTypes.SET_USER_TYPE_VIP:
            return _extends({}, state, {
                isUserTypeVip: action.isUserTypeVip
            });
        case _constants.actionTypes.SET_BANNER_MESSAGES:
            return _extends({}, state, {
                bannerMessages: action.bannerMessages
            });
        case _constants.actionTypes.SET_DEVICE_TYPE:
            return _extends({}, state, {
                deviceType: action.deviceType
            });
        case _constants.actionTypes.TOGGLE_MOBILE_MENU:
            return _extends({}, state, {
                isMobileMenuOpen: action.isMobileMenuOpen
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cartReducer = __webpack_require__("./src/reducers/cartReducer.js");

var _cartReducer2 = _interopRequireDefault(_cartReducer);

var _headerReducer = __webpack_require__("./src/reducers/headerReducer.js");

var _headerReducer2 = _interopRequireDefault(_headerReducer);

var _footerReducer = __webpack_require__("./src/reducers/footerReducer.js");

var _footerReducer2 = _interopRequireDefault(_footerReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    cart: _cartReducer2.default,
    header: _headerReducer2.default,
    footer: _footerReducer2.default
};

/***/ }),

/***/ "./src/relayClientEnvironment.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getRelayEnvironment;

var _relayRuntime = __webpack_require__("./node_modules/relay-runtime/index.js");

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var path = '/soa/graphql/';

function getUrl() {
    var _getBuyerToken = (0, _dibsCookieJar.getBuyerToken)(document.cookie),
        userToken = _getBuyerToken.userToken;

    var query = userToken ? '?userToken=' + userToken : '';

    return '' + path + query;
}

function fetchQuery(operation, variables) {
    return fetch(getUrl(), {
        method: 'post',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            query: operation.text, // GraphQL text from input
            variables: variables
        })
    }).then(function (response) {
        return response.json();
    });
}

var environment = void 0;

function getRelayEnvironment() {
    var records = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!environment) {
        var network = _relayRuntime.Network.create(fetchQuery);
        var source = new _relayRuntime.RecordSource(records);
        var store = new _relayRuntime.Store(source);
        environment = new _relayRuntime.Environment({ network: network, store: store });
    }
    return environment;
}

/***/ }),

/***/ "./src/scss/chat.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/scss/dibs.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headerPrimaryLarge":"_12g_EbVCCS-8VvIlOUVyGU","headerPrimaryMedium":"_3y27iiasoDuphZZ4VQBBj3","headerPrimarySmall":"_1Q0ag9I7c4C-pviW7O_cKO","headerSecondaryLarge":"nrWNR3thdRLtOX8XKly7a","headerSecondaryMedium":"_2JBaaLcXmx0k5VqQByARDW","headerSecondarySmall":"_1cQPwULQDLIh3Lo-nuNaBK","bodyHeaderPrimaryLarge":"EDgy12CdYb_zZ6JgVrAAm","bodyHeaderPrimaryMedium":"mupKZebWUyrhQB0NTYXE4","bodyHeaderPrimarySmall":"_1XAwFrGXDdDcrvh-x80jLX"};

/***/ }),

/***/ "./src/scss/tradeOnboarding.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/utils/AuthModalCheck.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by theodora on 6/12/14.
 */



var _require = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js"),
    getUserId = _require.getUserId;

var authModalLoader = __webpack_require__("./src/utils/AuthModalLoader.js").default;
var qs = __webpack_require__("./node_modules/querystring-es3/index.js");

var authModals = [authModalLoader.constants.LOGIN, authModalLoader.constants.REGISTER, authModalLoader.constants.RESET_PASSWORD, authModalLoader.constants.RESET_INVALID];

/**
 *
 * @param uri
 * @returns {string}
 */
var getRedirectDestination = function getRedirectDestination() {
    var queryKey = qs.parse(window.location.search.substr(1));
    var dest = queryKey.ep ? decodeURIComponent(queryKey.ep) : null;
    if (dest && dest.indexOf('//') > -1) {
        // id ep contains '//' then redirect to current page
        // if phishing is happening, just redirect to the homepage (uri.path = '/')
        dest = window.location.href;
    }

    return dest;
};

module.exports = {

    /**
     * Changed window object to parameter for easier testing
     * @param {object} win Mock window object
     * @param {object} uri Mock object mainly for testing
     */
    init: function checkForAuthModal() {
        var destination = getRedirectDestination();
        var action = qs.parse(window.location.search.substr(1)).modal || '';
        var gaAction = action.replace('_', ' ');
        action = action.replace('_', '-');
        var authOptions = {
            action: action,
            ga: {
                label: gaAction + ' query param - address bar',
                value: window.scrollY ? 1 : 0
            }
        };

        if (action) {
            if (authModals.indexOf(action) > -1) {
                // Need to make sure we have fresh user state
                // and don't get into infinite redirect loops
                if (getUserId(document.cookie) && destination) {
                    window.location.href = destination;
                } else {
                    authModalLoader.show(authOptions).then(function (authResponse) {
                        if (destination && !authResponse.err) {
                            window.location.href = destination;
                        }
                    });
                }
            }
        }
    }
};

/***/ }),

/***/ "./src/utils/AuthModalLoader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _yaDeferred = __webpack_require__("./node_modules/yaDeferred/index.js");

var _yaDeferred2 = _interopRequireDefault(_yaDeferred);

var _relayClientEnvironment = __webpack_require__("./src/relayClientEnvironment.js");

var _relayClientEnvironment2 = _interopRequireDefault(_relayClientEnvironment);

var _authFlowConstants = __webpack_require__("./src/authModal/authentication/authFlowConstants.js");

var constants = _interopRequireWildcard(_authFlowConstants);

var _async = __webpack_require__("./src/authModal/async.js");

var _async2 = _interopRequireDefault(_async);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Auth = void 0;

var authModalLoader = {
    _onLoaded: (0, _yaDeferred2.default)(),

    /**
     * Splits the AuthModal to a separate chunk during build time. Loads the authModal when called.
     * For now there's no way to handle errors. Should be possible when we switch to webpack 2.
     * This is mostly an espace hatch if you need direct access to the authModal instance.
     *
     * @example
     * authModalLoader.load().then(AuthModal => DO STUFF)
     *
     * @returns {Promise} - A promise that resolves with the AuthModal module.
     */
    load: function load() {
        (0, _async2.default)().then(function (mod) {
            Auth = mod;
            authModalLoader._onLoaded.resolve(mod);
        });
        return authModalLoader._onLoaded;
    },


    /**
     * Usefull when you don't want to load the AuthModal but want to get the instance.
     *
     * @example
     * authModalLoader.getLoadPromise().then(AuthModal => DO STUFF)
     *
     * @returns {Promise} - A promise that resolves with the AuthModal module.
     */
    getLoadPromise: function getLoadPromise() {
        return authModalLoader._onLoaded;
    },


    /**
     * Shortcut to AuthModal.show.
     *
     * @example
     * authModalLoader.show(options).then((authResponse) => if (authResponse.err) FAILURE else SUCCESS);
     * authResponse.user will be an object containing user data: user.userId, user.userToken, user.profile {}.
     * authResponse.err will be an object with shape {err: 'closed'}.
     * it will contain the reason for authentication failure. which is most likely because the user closed the modal.
     * @returns {Promise}
     */
    show: function show() {
        var _this = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var environment = options.relayEnvironment || (0, _relayClientEnvironment2.default)();
        return new Promise(function (resolve) {
            _this.load().then(function (AuthModal) {
                AuthModal.initAuth({ environment: environment });
                switch (options.action) {
                    case constants.LOGIN:
                        Auth.launchLogin(_extends({}, options, { resolve: resolve }));
                        break;
                    case constants.RESET_PASSWORD:
                        Auth.launchResetPassword(_extends({}, options, { resolve: resolve }));
                        break;
                    case constants.UPDATE_PASSWORD:
                        Auth.launchUpdatePassword(_extends({}, options, { resolve: resolve }));
                        break;
                    case constants.RESET_INVALID:
                        Auth.launchResetInvalid(_extends({}, options, { resolve: resolve }));
                        break;
                    default:
                        Auth.launchRegistration(_extends({}, options, { resolve: resolve }));
                        break;
                }
            });
        }).then(function (authResult) {
            var isRegister = authResult.modal === constants.REGISTER;
            authResult = _extends({}, authResult, { newUser: isRegister });
            return authResult;
        });
    },


    /**
     * Used for testing only.
     */
    _clearAuthModal: function _clearAuthModal() {
        Auth = undefined;
        authModalLoader._onLoaded = (0, _yaDeferred2.default)();
    },


    /**
     * Used for testing only.
     */
    _setAuthModal: function _setAuthModal(m) {
        Auth = m;
    }
};

authModalLoader = Object.assign(authModalLoader, { constants: constants });

exports.default = authModalLoader;

/***/ }),

/***/ "./src/utils/__generated__/chat_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type chat_user = {|
  +createdDate: ?string;
  +isTrade: ?boolean;
  +hasVipPermission: ?boolean;
  +profile: ?{|
    +email: ?string;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "chat_user",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "createdDate",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": "isTrade",
    "args": [{
      "kind": "Literal",
      "name": "name",
      "value": "B_TRADE_CHECKOUT",
      "type": "String!"
    }],
    "name": "hasPermission",
    "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
  }, {
    "kind": "ScalarField",
    "alias": "hasVipPermission",
    "args": [{
      "kind": "Literal",
      "name": "name",
      "value": "B_VIP_CHECKOUT",
      "type": "String!"
    }],
    "name": "hasPermission",
    "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Profile",
    "name": "profile",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "email",
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/utils/__generated__/chat_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type chat_viewer = {|
  +tradeChatEmail: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string;
    |}>;
  |}>;
  +vipChatEmail: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string;
    |}>;
  |}>;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "userIds",
    "type": "[String]!"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "chat_viewer",
  "selections": [{
    "kind": "LinkedField",
    "alias": "tradeChatEmail",
    "args": [{
      "kind": "Literal",
      "name": "relationshipType",
      "value": "VIP",
      "type": "relationshipType!"
    }, {
      "kind": "Variable",
      "name": "userIds",
      "variableName": "userIds",
      "type": "[String]!"
    }],
    "concreteType": "UserRelationship",
    "name": "userRelationships",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": null,
      "name": "userDataB",
      "plural": true,
      "selections": [{
        "kind": "InlineFragment",
        "type": "VipRepData",
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "email",
          "storageKey": null
        }]
      }],
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": "vipChatEmail",
    "args": [{
      "kind": "Literal",
      "name": "relationshipType",
      "value": "TRADE",
      "type": "relationshipType!"
    }, {
      "kind": "Variable",
      "name": "userIds",
      "variableName": "userIds",
      "type": "[String]!"
    }],
    "concreteType": "UserRelationship",
    "name": "userRelationships",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": null,
      "name": "userDataB",
      "plural": true,
      "selections": [{
        "kind": "InlineFragment",
        "type": "TradeRepData",
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "email",
          "storageKey": null
        }]
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/utils/__generated__/initializeTrackingQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash b3e3d9ccde19641c3dd2ba84c978ddd7
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type initializeTrackingQueryResponse = {|
  +viewer: ?{|
    +allTransactions?: ?{|
      +totalResults: ?number;
    |};
    +initiatedTransactions?: ?{|
      +totalResults: ?number;
    |};
    +submittedTransactions?: ?{|
      +totalResults: ?number;
    |};
    +confirmedTransactionsMostRecent?: ?{|
      +totalResults: ?number;
      +edges: ?$ReadOnlyArray<?{|
        +node: ?{|
          +mostRecentOffer: ?{|
            +createdDate: ?string;
            +subTotalAmount: ?{|
              +convertedAmounts: ?{|
                +USD: ?number;
              |};
            |};
          |};
        |};
      |}>;
    |};
    +user?: ?{|
      +firstSessionDate: ?string;
      +isTrade: ?boolean;
      +hasVipPermission: ?boolean;
      +profile: ?{|
        +email: ?string;
        +zipCode: ?string;
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      |};
      +serviceId: ?string;
      +totalMessagesToDealers: ?number;
      +tradeFirm: ?{|
        +serviceId: ?string;
        +tier: ?"TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "P_AND_M" | "UNKNOWN";
      |};
      +verifiedTradeStatus: ?string;
      +isPromoCodeEligible: ?boolean;
    |};
  |};
|};
*/

/*
query initializeTrackingQuery(
  $hasUserId: Boolean!
  $userId: String!
  $userIds: [String!]
) {
  viewer {
    allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {
      totalResults
    }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $hasUserId) {
      totalResults
    }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $hasUserId) {
      totalResults
    }
  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 1) @include(if: $hasUserId) {
      totalResults
      edges {
        node {
          mostRecentOffer {
            createdDate
            subTotalAmount {
              convertedAmounts {
                USD
              }
            }
            id
          }
          id
        }
      }
    }
  user(userId: $userId) @include(if: $hasUserId) {
      firstSessionDate
      isTrade: hasPermission(name: "B_TRADE_CHECKOUT")
      hasVipPermission: hasPermission(name: "B_VIP_CHECKOUT")
      profile {
        email
        zipCode
        currency
      }
      serviceId
      totalMessagesToDealers
      tradeFirm {
        serviceId
        tier
        id
      }
      verifiedTradeStatus
      isPromoCodeEligible(code: "SAVE15")
      id
    }
    id
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String!]",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "initializeTrackingQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": "allTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.initiated",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.submitted",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "confirmedTransactionsMostRecent",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 1,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "sort",
            "value": "createdDate asc",
            "type": "String"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.confirmed",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TransactionEdge",
            "name": "edges",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Transaction",
              "name": "node",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "name": "mostRecentOffer",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "createdDate",
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "name": "subTotalAmount",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ConvertedAmounts",
                    "name": "convertedAmounts",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "USD",
                      "storageKey": null
                    }],
                    "storageKey": null
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String!"
          }],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstSessionDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": "isTrade",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_TRADE_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
          }, {
            "kind": "ScalarField",
            "alias": "hasVipPermission",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_VIP_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "name": "profile",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "email",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "zipCode",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalMessagesToDealers",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "name": "tradeFirm",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "tier",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "verifiedTradeStatus",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": [{
              "kind": "Literal",
              "name": "code",
              "value": "SAVE15",
              "type": "String!"
            }],
            "name": "isPromoCodeEligible",
            "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "initializeTrackingQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String!]",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "initializeTrackingQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": "allTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.initiated",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.submitted",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "confirmedTransactionsMostRecent",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 1,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "sort",
            "value": "createdDate asc",
            "type": "String"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.confirmed",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TransactionEdge",
            "name": "edges",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Transaction",
              "name": "node",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Offer",
                "name": "mostRecentOffer",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "createdDate",
                  "storageKey": null
                }, {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "name": "subTotalAmount",
                  "plural": false,
                  "selections": [{
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "ConvertedAmounts",
                    "name": "convertedAmounts",
                    "plural": false,
                    "selections": [{
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "USD",
                      "storageKey": null
                    }],
                    "storageKey": null
                  }],
                  "storageKey": null
                }, {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "id",
                  "storageKey": null
                }],
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String!"
          }],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstSessionDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": "isTrade",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_TRADE_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
          }, {
            "kind": "ScalarField",
            "alias": "hasVipPermission",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_VIP_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "name": "profile",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "email",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "zipCode",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalMessagesToDealers",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "name": "tradeFirm",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "tier",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "verifiedTradeStatus",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": [{
              "kind": "Literal",
              "name": "code",
              "value": "SAVE15",
              "type": "String!"
            }],
            "name": "isPromoCodeEligible",
            "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query initializeTrackingQuery(\n  $hasUserId: Boolean!\n  $userId: String!\n  $userIds: [String!]\n) {\n  viewer {\n    allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {\n      totalResults\n    }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $hasUserId) {\n      totalResults\n    }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $hasUserId) {\n      totalResults\n    }\n  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 1) @include(if: $hasUserId) {\n      totalResults\n      edges {\n        node {\n          mostRecentOffer {\n            createdDate\n            subTotalAmount {\n              convertedAmounts {\n                USD\n              }\n            }\n            id\n          }\n          id\n        }\n      }\n    }\n  user(userId: $userId) @include(if: $hasUserId) {\n      firstSessionDate\n      isTrade: hasPermission(name: \"B_TRADE_CHECKOUT\")\n      hasVipPermission: hasPermission(name: \"B_VIP_CHECKOUT\")\n      profile {\n        email\n        zipCode\n        currency\n      }\n      serviceId\n      totalMessagesToDealers\n      tradeFirm {\n        serviceId\n        tier\n        id\n      }\n      verifiedTradeStatus\n      isPromoCodeEligible(code: \"SAVE15\")\n      id\n    }\n    id\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/utils/__generated__/tradeOnboardingHelper_Query.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 088e3040e6b841e9c47e66249ef084ae
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type tradeOnboardingHelper_QueryResponse = {|
  +viewer: ?{|
    +user: ?{|
      +isVerifiedTrade: ?boolean;
      +profile: ?{|
        +email: ?string;
      |};
    |};
  |};
|};
*/

/*
query tradeOnboardingHelper_Query(
  $userId: String!
) {
  viewer {
    user(userId: $userId) {
      isVerifiedTrade: hasPermission(name: "B_NET_PRICE")
      profile {
        email
      }
      id
    }
    id
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "tradeOnboardingHelper_Query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": [{
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId",
          "type": "String!"
        }],
        "concreteType": "User",
        "name": "user",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": "isVerifiedTrade",
          "args": [{
            "kind": "Literal",
            "name": "name",
            "value": "B_NET_PRICE",
            "type": "String!"
          }],
          "name": "hasPermission",
          "storageKey": "hasPermission{\"name\":\"B_NET_PRICE\"}"
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "name": "profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "email",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "tradeOnboardingHelper_Query",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "tradeOnboardingHelper_Query",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": [{
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId",
          "type": "String!"
        }],
        "concreteType": "User",
        "name": "user",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": "isVerifiedTrade",
          "args": [{
            "kind": "Literal",
            "name": "name",
            "value": "B_NET_PRICE",
            "type": "String!"
          }],
          "name": "hasPermission",
          "storageKey": "hasPermission{\"name\":\"B_NET_PRICE\"}"
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "name": "profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "email",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query tradeOnboardingHelper_Query(\n  $userId: String!\n) {\n  viewer {\n    user(userId: $userId) {\n      isVerifiedTrade: hasPermission(name: \"B_NET_PRICE\")\n      profile {\n        email\n      }\n      id\n    }\n    id\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/utils/__generated__/userTracking_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type userTracking_user = {|
  +firstSessionDate: ?string;
  +isTrade: ?boolean;
  +hasVipPermission: ?boolean;
  +profile: ?{|
    +email: ?string;
    +zipCode: ?string;
    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
  |};
  +serviceId: ?string;
  +totalMessagesToDealers: ?number;
  +tradeFirm: ?{|
    +serviceId: ?string;
    +tier: ?"TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "P_AND_M" | "UNKNOWN";
  |};
  +verifiedTradeStatus: ?string;
  +isPromoCodeEligible: ?boolean;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userTracking_user",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "firstSessionDate",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": "isTrade",
    "args": [{
      "kind": "Literal",
      "name": "name",
      "value": "B_TRADE_CHECKOUT",
      "type": "String!"
    }],
    "name": "hasPermission",
    "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
  }, {
    "kind": "ScalarField",
    "alias": "hasVipPermission",
    "args": [{
      "kind": "Literal",
      "name": "name",
      "value": "B_VIP_CHECKOUT",
      "type": "String!"
    }],
    "name": "hasPermission",
    "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Profile",
    "name": "profile",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "email",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "zipCode",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "currency",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "serviceId",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "totalMessagesToDealers",
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "TradeFirmType",
    "name": "tradeFirm",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "tier",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "verifiedTradeStatus",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": [{
      "kind": "Literal",
      "name": "code",
      "value": "SAVE15",
      "type": "String!"
    }],
    "name": "isPromoCodeEligible",
    "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/utils/__generated__/userTracking_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type userTracking_viewer = {|
  +allTransactions?: ?{|
    +totalResults: ?number;
  |};
  +initiatedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +submittedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +confirmedTransactionsMostRecent?: ?{|
    +totalResults: ?number;
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +mostRecentOffer: ?{|
          +createdDate: ?string;
          +subTotalAmount: ?{|
            +convertedAmounts: ?{|
              +USD: ?number;
            |};
          |};
        |};
      |};
    |}>;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "userIds",
    "type": "[String]"
  }, {
    "kind": "RootArgument",
    "name": "hasUserId",
    "type": "Boolean"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "userTracking_viewer",
  "selections": [{
    "kind": "Condition",
    "passingValue": true,
    "condition": "hasUserId",
    "selections": [{
      "kind": "LinkedField",
      "alias": "allTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "initiatedTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.initiated",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "submittedTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.submitted",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "confirmedTransactionsMostRecent",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 1,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "sort",
        "value": "createdDate asc",
        "type": "String"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.confirmed",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "TransactionEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Transaction",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Offer",
            "name": "mostRecentOffer",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "createdDate",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "name": "subTotalAmount",
              "plural": false,
              "selections": [{
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "ConvertedAmounts",
                "name": "convertedAmounts",
                "plural": false,
                "selections": [{
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "USD",
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/utils/abExperiments.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var root = typeof window === 'undefined' ? global : window;

root.abExperiments = root.abExperiments || {};

module.exports = root.abExperiments;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/utils/chat.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

__webpack_require__("./src/scss/chat.scss");

var SV = __webpack_require__("./node_modules/server-vars/index.js");
var get = __webpack_require__("./node_modules/lodash.get/index.js");
var root = typeof window === 'undefined' ? global : window;

var _require = __webpack_require__("./node_modules/dibs-browser-storage/index.js"),
    localStorage = _require.localStorage,
    sessionStorage = _require.sessionStorage;

var printRegex = /^\/print\//;
var isPrintPDP = root.location && printRegex.test(root.location.pathname);
var qs = __webpack_require__("./node_modules/querystring-es3/index.js");

var _require2 = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js"),
    getUserId = _require2.getUserId;

var _require3 = __webpack_require__("./node_modules/react-relay/compat.js"),
    graphql = _require3.graphql;

var ScriptInjector = __webpack_require__("./src/utils/scriptInjector.js");

var isPageType = __webpack_require__("./src/utils/isPageType.js");

var _require4 = __webpack_require__("./src/utils/pageConstants.js"),
    PAGE_TYPE = _require4.PAGE_TYPE,
    BROWSE_TYPES = _require4.BROWSE_TYPES;

var _ref = root.location && qs.parse(root.location.search) || {},
    tradePromoDate = _ref.tradePromoDate;

var TYPE_SEARCH = 'SEARCH';
var TYPE_DEALER = 'SELLER';
var CHAT_STARTED_STORAGE_KEY = '__chatStarted';
var ARGUMENTS_STORAGE_KEY = '__chatArguments';
var CHECKOUT_UNLOAD_KEY = '__checkoutUnload';
var CHECKOUT_TYPE_KEY = '__checkoutTransactionType';
var CUSTOMER_TYPE_VIP = 'VIP';
var CUSTOMER_TYPE_TRADE = 'Trade';
var CUSTOMER_TYPE_CONSUMER = 'Consumer';

var ITEMS_ABOVE_PRICE_VIEWED_KEY = 'itemsAbovePriceViewed';
var ITEMS_ABOVE_PRICE_VIEWED_THRESHOLD = 3;

var PRICE_LIMIT_10K = 10000;
var PRICE_LIMIT_50K = 50000;

var TRADE_PROMO_DATE_FROM = tradePromoDate || '2017-01-16';

var intercomId = SV.get('intercomId');

var PAGE_TYPE_WHITELIST = [BROWSE_TYPES, PAGE_TYPE.FAVORITES, // Cart + Favorites has same pageType
PAGE_TYPE.HOME, PAGE_TYPE.INVOICE, PAGE_TYPE.PDP, PAGE_TYPE.SEARCH, PAGE_TYPE.SOURCING];

var loadPromise = null;

function loadIntercom() {
    loadPromise = ScriptInjector.inject('https://widget.intercom.io/widget/' + intercomId).then(function () {
        var intercom = root.Intercom;
        intercom('boot', {
            'app_id': intercomId
        });

        return intercom;
    });
    return loadPromise;
};

function getIntercom() {
    if (root.intercom || loadPromise) {
        return loadPromise;
    }
    return loadIntercom();
}

function getDate() {
    var date = new Date();
    return date.toJSON();
}

function getIntercomDate(date) {
    date = new Date(date);
    return date.getTime() / 1000; // get UTC seconds
}

function applyArgumentQueue(intercom) {
    var argumentQueue = sessionStorage.getItem(ARGUMENTS_STORAGE_KEY) || [];

    if (argumentQueue.length) {
        argumentQueue.forEach(function (args) {
            intercom.apply(intercom, args);
        });
    }

    sessionStorage.setItem(ARGUMENTS_STORAGE_KEY, []);
}

function load() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    var chatStarted = sessionStorage.getItem(CHAT_STARTED_STORAGE_KEY);
    var pageTypeValid = isPageType(PAGE_TYPE_WHITELIST);

    if (chatStarted && !isPrintPDP && pageTypeValid) {
        return getIntercom().then(function (intercom) {
            applyArgumentQueue(intercom);
            if (args.length) {
                intercom.apply(intercom, args);
            }
        });
    } else if (!isPrintPDP) {
        var argumentQueue = sessionStorage.getItem(ARGUMENTS_STORAGE_KEY) || [];
        argumentQueue.push(args);
        sessionStorage.setItem(ARGUMENTS_STORAGE_KEY, argumentQueue);
    }

    // if `chat_intercom` is not enabled resolve
    return Promise.resolve();
}

function trackEvent() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
    }

    return load.apply(undefined, ['trackEvent'].concat(args));
}

function update(data) {
    return load('update', data);
}

function getUserTestGroup(tradeUserCreateDate) {
    var userId = getUserId(document.cookie);
    var lastIdNumber = Number.parseInt(userId.slice(-1));
    var testGroupData = {};

    // User ids end up with 1 or 2, ~20% of users
    if ([1, 2].indexOf(lastIdNumber) > -1) {
        testGroupData.user_test_group = 'Holdout'; // eslint-disable-line camelcase
    }

    testGroupData.user_test_group = 'Test'; // eslint-disable-line camelcase

    if (tradeUserCreateDate) {
        var secontToLastIdNumber = Number.parseInt(userId.slice(-2, -1));
        if ([4, 5].indexOf(secontToLastIdNumber) > -1 && new Date(tradeUserCreateDate) > new Date(TRADE_PROMO_DATE_FROM)) {
            testGroupData.user_trade_promo_group = 'Test'; // eslint-disable-line camelcase
        } else {
            testGroupData.user_trade_promo_group = 'Control'; // eslint-disable-line camelcase
        }
    }

    return testGroupData;
};

function getCustomerType(user) {
    var customerType = [];

    if (user && user.isTrade) {
        customerType.push(CUSTOMER_TYPE_TRADE);
    }

    if (user && user.hasVipPermission) {
        customerType.push(CUSTOMER_TYPE_VIP);
    }

    if (!customerType.length) {
        return CUSTOMER_TYPE_CONSUMER;
    }

    return customerType.length ? customerType.join(' and ') : undefined;
};

var chat = {
    start: function start() {
        sessionStorage.setItem(CHAT_STARTED_STORAGE_KEY, true);
        return load();
    },
    show: function show() {
        return load('show');
    },
    fillUserData: function fillUserData(viewer, user) {
        var tradeChatEmail = viewer.tradeChatEmail,
            vipChatEmail = viewer.vipChatEmail;
        var tradeUserCreateDate = user.tradeUserCreateDate;

        if (!getUserId(root.document.cookie)) {
            return Promise.resolve();
        }

        var userType = getCustomerType(user);
        var userId = getUserId(document.cookie);
        var createdDate = user.createdDate,
            _user$profile = user.profile,
            firstName = _user$profile.firstName,
            lastName = _user$profile.lastName,
            email = _user$profile.email;


        var userData = Object.assign({
            'user_id': userId,
            'name': ((firstName || '') + ' ' + (lastName || '')).trim(),
            'email': email,
            'user_type': userType,
            'registered_at': getIntercomDate(createdDate),
            'trade_account_manager': get(tradeChatEmail, '0.userDataB.0.email'),
            'vip_account_manager': get(vipChatEmail, '0.userDataB.0.email')
        }, getUserTestGroup(tradeUserCreateDate));

        return update(userData);
    },


    customAttribute: {
        transactionsStatus: function transactionsStatus(_ref2) {
            var buyerStatus = _ref2.buyerStatus,
                totalTransactions = _ref2.totalTransactions;

            return update({
                'buyer_status': buyerStatus,
                'total_transactions': totalTransactions
            });
        },
        tradeStatus: function tradeStatus(status) {
            return update({ 'trade_status': status });
        },
        verifiedTradeDate: function verifiedTradeDate(date) {
            return update({ 'verified_trade_at': getIntercomDate(date) });
        },
        itemsInCart: function itemsInCart(itemCount) {
            return update({ 'items_in_cart': itemCount });
        },
        registeredOnPage: function registeredOnPage() {
            var pathname = root.location.pathname;

            return update({ 'registered_on_page': pathname });
        },
        loyaltyStatus: function loyaltyStatus(status) {
            return update({ 'LoyaltyStatus': status });
        }
    },

    track: {
        abandonFavorite: function abandonFavorite(type) {
            switch (type) {
                case TYPE_SEARCH:
                    return trackEvent('abandon_follow_search');

                case TYPE_DEALER:
                    return trackEvent('abandon_follow_dealer');
            }

            return Promise.resolve();
        },
        abandonRequestNetPrice: function abandonRequestNetPrice() {
            return trackEvent('abandon_request_net_price', {
                'fired_at': getDate()
            });
        },
        requestNetPrice: function requestNetPrice() {
            return trackEvent('success_request_net_price', {
                'fired_at': getDate()
            });
        },
        abandonMakeOffer: function abandonMakeOffer() {
            return trackEvent('make_offer_abandon', {
                'fired_at': getDate()
            });
        },
        makeOfferComplete: function makeOfferComplete() {
            return trackEvent('make_offer_complete', {
                'fired_at': getDate()
            });
        },
        abandonContactDealer: function abandonContactDealer() {
            return trackEvent('abandon_contact_dealer', {
                'fired_at': getDate()
            });
        },
        contactDealer: function contactDealer() {
            return trackEvent('contact_dealer', {
                'fired_at': getDate()
            });
        },
        addToCart: function addToCart() {
            return trackEvent('item_added_to_cart', {
                'fired_at': getDate()
            });
        },
        itemSaved: function itemSaved() {
            return trackEvent('success_save_item');
        },
        shippingDetailsClick: function shippingDetailsClick() {
            return trackEvent('view_shipping_details');
        },
        buyerAssuranceClick: function buyerAssuranceClick() {
            return trackEvent('buyer_protection');
        },
        checkoutReached: function checkoutReached(data, isNegotiable) {
            sessionStorage.setItem(CHECKOUT_TYPE_KEY, { isNegotiable: isNegotiable });
            return trackEvent('checkout_reached', data);
        },
        checkoutComplete: function checkoutComplete() {
            return trackEvent('checkout_completed');
        },
        checkoutAbandon: function checkoutAbandon() {
            return trackEvent('checkout_abandon');
        },
        checkoutSurveySubmitted: function checkoutSurveySubmitted(data) {
            return trackEvent('checkout_survey_submitted', data);
        },
        tradeBasicInfoCompleted: function tradeBasicInfoCompleted(noWebsite) {
            var prefix = noWebsite ? 'no ' : '';
            return trackEvent('trade application step 1 - ' + prefix + 'website');
        },
        sourcingRequestSubmitted: function sourcingRequestSubmitted() {
            return trackEvent('SourcingRequest');
        }
    }

};

function checkAbandonCheckout() {
    if (!root.location) {
        return;
    }
    var pathname = root.location.pathname;

    var isCheckoutPage = pathname.indexOf('checkout') > -1;
    var isCheckoutConfirmationPage = pathname.indexOf('checkout/confirmation') > -1;
    var isMyOrdersPage = pathname.indexOf('my/orders') > -1;

    if (isCheckoutPage && !isCheckoutConfirmationPage) {
        root.onbeforeunload = function () {
            sessionStorage.setItem(CHECKOUT_UNLOAD_KEY, true);
        };
    } else if (!isCheckoutConfirmationPage && !isMyOrdersPage && sessionStorage.getItem(CHECKOUT_UNLOAD_KEY)) {
        var isNegotiable = get(sessionStorage.getItem(CHECKOUT_TYPE_KEY), 'isNegotiable');

        if (isNegotiable) {
            chat.track.abandonMakeOffer();
        } else {
            chat.track.checkoutAbandon();
        }
    }

    sessionStorage.deleteItem(CHECKOUT_UNLOAD_KEY);
};

function checkConductSearch() {
    if (!root.location) {
        return;
    }
    var _root$location = root.location,
        pathname = _root$location.pathname,
        search = _root$location.search;


    if (pathname.indexOf('/search') === 0 && search.indexOf('?q=') === 0) {
        update({ 'user_conduct_search': 'Yes' });
    }
};

function checkItemsAbovePrice(key, eventName) {
    var items = localStorage.getItem(ITEMS_ABOVE_PRICE_VIEWED_KEY) || {};
    var newValue = (items[key] || 0) + 1;

    if (newValue >= ITEMS_ABOVE_PRICE_VIEWED_THRESHOLD) {
        trackEvent(eventName);
        newValue = 0;
    }
    localStorage.setItem(ITEMS_ABOVE_PRICE_VIEWED_KEY, _extends({}, items, _defineProperty({}, key, newValue)));
};

function checkPdp() {
    if (isPageType([PAGE_TYPE.PDP])) {
        var pk = SV.get('item.pk');
        trackEvent('pdp_view', { pk: pk });

        var isUserTypeTrade = SV.get('settings.isUserTypeTrade');

        if (isUserTypeTrade) {
            var _ref3 = SV.get('data') || {},
                netPrice = _ref3.netPrice,
                price = _ref3.price;

            var tradePrice = netPrice || price;
            if (tradePrice > PRICE_LIMIT_50K) {
                checkItemsAbovePrice(PRICE_LIMIT_50K, 'ItemView50k');
            } else if (tradePrice > PRICE_LIMIT_10K) {
                checkItemsAbovePrice(PRICE_LIMIT_10K, 'ItemView10k');
            }
        }
    }
};

checkAbandonCheckout();
checkConductSearch();
checkPdp();

var userFragment = exports.userFragment = {
    user: {
        modern: function modern() {
            return __webpack_require__("./src/utils/__generated__/chat_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            fieldName: 'createdDate',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            alias: 'isTrade',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'name',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'B_TRADE_CHECKOUT'
                                }
                            }],
                            fieldName: 'hasPermission',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            alias: 'hasVipPermission',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'name',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'B_VIP_CHECKOUT'
                                }
                            }],
                            fieldName: 'hasPermission',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            children: [{
                                fieldName: 'email',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'Chat_user',
                        type: 'User'
                    };
                }()
            };
        }
    }
};

var viewerFrgament = exports.viewerFrgament = {
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/utils/__generated__/chat_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    kind: 'RootArgument',
                    name: 'userIds'
                }],
                node: function () {
                    return {
                        children: [{
                            alias: 'tradeChatEmail',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userIds',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'relationshipType!'
                                },
                                name: 'relationshipType',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'VIP'
                                }
                            }],
                            children: [{
                                children: [{
                                    fieldName: '__typename',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'String'
                                }, {
                                    children: [{
                                        fieldName: 'email',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }],
                                    id: RelayQL_GENERATED.__id(),
                                    kind: 'Fragment',
                                    metadata: {},
                                    name: 'VipRepData',
                                    type: 'VipRepData'
                                }],
                                fieldName: 'userDataB',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isAbstract: true,
                                    isPlural: true
                                },
                                type: 'UserDataB'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'userRelationships',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'UserRelationship'
                        }, {
                            alias: 'vipChatEmail',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userIds',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'relationshipType!'
                                },
                                name: 'relationshipType',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'TRADE'
                                }
                            }],
                            children: [{
                                children: [{
                                    fieldName: '__typename',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'String'
                                }, {
                                    children: [{
                                        fieldName: 'email',
                                        kind: 'Field',
                                        metadata: {},
                                        type: 'String'
                                    }],
                                    id: RelayQL_GENERATED.__id(),
                                    kind: 'Fragment',
                                    metadata: {},
                                    name: 'TradeRepData',
                                    type: 'TradeRepData'
                                }],
                                fieldName: 'userDataB',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isAbstract: true,
                                    isPlural: true
                                },
                                type: 'UserDataB'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'userRelationships',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id',
                                isPlural: true
                            },
                            type: 'UserRelationship'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'Chat_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    }
};

exports.default = chat;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/utils/checkoutStorageConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var STORAGE = exports.STORAGE = {
    AUTO_MODAL_INFO: 'checkoutAutoModalInfo',
    SURVEY_INFO: 'checkoutSurveyInfo'
};

/***/ }),

/***/ "./src/utils/debounce.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = debounce;
function debounce(func, time) {
    var timeout = void 0;
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var executeFunction = function executeFunction() {
            timeout = null;
            func.apply(undefined, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(executeFunction, time);
    };
};

/***/ }),

/***/ "./src/utils/initializeTracking.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackingQuery = undefined;

exports.default = function (environment) {
    environment = environment || (0, _relayClientEnvironment2.default)();
    var userId = (0, _dibsCookieJar.getUserId)(document.cookie) || "";
    var hasUserId = !!userId;
    var operation = (0, _relayRuntime.createOperationSelector)((0, _relayRuntime.getOperation)(trackingQuery), {
        userId: userId,
        hasUserId: hasUserId,
        userIds: [userId]
    });

    environment.retain(operation.root);
    return new Promise(function (resolve, reject) {
        environment.sendQuery({
            operation: operation,
            onNext: function onNext() {
                var viewer = environment.lookup(operation.fragment).data.viewer;

                (0, _userTracking.init)({ viewer: viewer, user: viewer.user });
            },
            onError: function onError(error) {
                reject(error);
            }
        });
    });
};

var _relayRuntime = __webpack_require__("./node_modules/relay-runtime/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _relayClientEnvironment = __webpack_require__("./src/relayClientEnvironment.js");

var _relayClientEnvironment2 = _interopRequireDefault(_relayClientEnvironment);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _userTracking = __webpack_require__("./src/utils/userTracking.js");

var _userTracking2 = _interopRequireDefault(_userTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var trackingQuery = exports.trackingQuery = {
    modern: function modern() {
        return __webpack_require__("./src/utils/__generated__/initializeTrackingQuery.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        var userTracking_viewer = RelayQL_GENERATED.__getClassicFragment(_userTracking2.default.viewer.viewer || _userTracking2.default.viewer).node,
            userTracking_user = RelayQL_GENERATED.__getClassicFragment(_userTracking2.default.user.user || _userTracking2.default.user).node;

        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'hasUserId'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userId'
            }, {
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userIds'
            }],
            name: 'initializeTrackingQuery',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [].concat.apply([], [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [].concat.apply([], [{
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }, RelayQL_GENERATED.__frag(userTracking_user)]),
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            fieldName: 'user',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'User'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }, RelayQL_GENERATED.__frag(userTracking_viewer)]),
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'InitializeTrackingQuery',
                    type: 'Query'
                };
            }()
        };
    }
};
// relay needs this import

/***/ }),

/***/ "./src/utils/isPageType.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _serverVars = __webpack_require__("./node_modules/server-vars/index.js");

var _serverVars2 = _interopRequireDefault(_serverVars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function isPageType(pageTypes) {
    var pageType = _serverVars2.default.get('settings.pageType');
    return pageTypes.indexOf(pageType) > -1;
};

/***/ }),

/***/ "./src/utils/loginHandlers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var cbs = [];

var addLoginHandlers = exports.addLoginHandlers = function addLoginHandlers() {
    var args = Array.prototype.slice.call(arguments);
    cbs.push.apply(cbs, _toConsumableArray(args.reduce(function (acc, item) {
        if (Array.isArray(item)) {
            acc.push.apply(acc, _toConsumableArray(item));
        } else {
            acc.push(item);
        }
        return acc;
    }, [])));
};

var fireLoginHandlers = exports.fireLoginHandlers = function fireLoginHandlers(arg) {
    cbs.forEach(function (func) {
        return func(arg);
    });
};

var getLoginHandlers = exports.getLoginHandlers = function getLoginHandlers() {
    return [].concat(cbs);
};

var dumpHandlers = exports.dumpHandlers = function dumpHandlers() {
    cbs.length = 0;
};

/***/ }),

/***/ "./src/utils/pageConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PAGE_TYPE = Object.freeze({
    ABOUT: 'about',
    ASSOCIATION: 'association',
    ATTRIBUTE: 'attribute',
    BROWSE: 'browse',
    CHECKOUT: 'checkout',
    COLLECTION: 'collection',
    CREATOR: 'creator',
    DEALER: 'dealer',
    FAVORITES: 'favorites',
    HOME: 'home',
    INVOICE: 'invoice',
    LOCATION: 'location',
    MATERIAL: 'material',
    MESSAGE_CENTER: 'messageCenter',
    METAL: 'metal',
    ORIGIN: 'origin',
    PDP: 'pdp',
    PERIOD: 'period',
    RECOGNIZED_DEALERS: 'recognized_dealers',
    SEARCH: 'search',
    SECTION: 'section',
    STONE: 'stone',
    STYLE: 'style',
    TECHNIQUE: 'technique',
    TRADE_PROFILE: 'trade',
    SOURCING: 'sourcing'
});

var BROWSE_TYPES = Object.freeze([PAGE_TYPE.ASSOCIATION, PAGE_TYPE.ATTRIBUTE, PAGE_TYPE.BROWSE, PAGE_TYPE.COLLECTION, PAGE_TYPE.CREATOR, PAGE_TYPE.LOCATION, PAGE_TYPE.MATERIAL, PAGE_TYPE.METAL, PAGE_TYPE.ORIGIN, PAGE_TYPE.PERIOD, PAGE_TYPE.RECOGNIZED_DEALERS, PAGE_TYPE.SECTION, PAGE_TYPE.STONE, PAGE_TYPE.STYLE, PAGE_TYPE.TECHNIQUE]);

module.exports = Object.freeze({
    PAGE_TYPE: PAGE_TYPE,
    BROWSE_TYPES: BROWSE_TYPES
});

/***/ }),

/***/ "./src/utils/promoCode.es.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wasPromoCodeNotificationShown = exports.setPromoCodeNotificationShown = exports.code = exports.discount = undefined;

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var PROMO_CODE_STORAGE_KEY = 'promoCodeNotificationShown';

var discount = exports.discount = 15;
var code = exports.code = 'SAVE15';

var setPromoCodeNotificationShown = exports.setPromoCodeNotificationShown = function setPromoCodeNotificationShown() {
    _dibsBrowserStorage.localStorage.setItem(PROMO_CODE_STORAGE_KEY, true);
};

var wasPromoCodeNotificationShown = exports.wasPromoCodeNotificationShown = function wasPromoCodeNotificationShown() {
    return !!_dibsBrowserStorage.localStorage.getItem(PROMO_CODE_STORAGE_KEY);
};

/***/ }),

/***/ "./src/utils/scriptInjector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ScriptInjector = {

    /**
     * [inject description]
     * @param  {String} url     Url of the script
     * @param  {Object} params  Parameters passed to script loading url
     * @return {Promise}
     */
    inject: function inject(url) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { async: true };

        return new Promise(function (resolve) {
            var prop = void 0;

            var script = document.createElement('script');
            script.src = url;

            for (prop in params) {
                if (params.hasOwnProperty(prop)) {
                    script[prop] = params[prop];
                }
            }

            if (script.readyState) {
                // IE
                script.onreadystatechange = function () {
                    if (script.readyState === 'loaded' || script.readyState === 'complete') {
                        script.onreadystatechange = null;
                        resolve();
                    }
                };
            } else {
                // Others
                script.onload = function () {
                    resolve();
                };
            }

            var scriptTag = document.getElementsByTagName('script')[0];
            scriptTag.parentNode.insertBefore(script, scriptTag);
        });
    }
};

module.exports = ScriptInjector;

/***/ }),

/***/ "./src/utils/tradeOnboardingHelper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadSourcingModal = exports.loadOnboardingModalWithOrigin = exports.loadOnboardingModal = exports.fetchTradeUserData = exports.getContainerElement = exports.markModalShown = exports.hasSeenModal = exports.getModalType = exports.LABEL_SEARCH_BROWSE = exports.LABEL_PDP = exports.ORIGIN_FOLDER = exports.ORIGIN_FAVORITE = exports.ORIGIN_HOLD = exports.ORIGIN_SOLD = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // eslint-disable-line no-unused-vars


var _react = __webpack_require__("./node_modules/react/react.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _relayClientEnvironment = __webpack_require__("./src/relayClientEnvironment.js");

var _relayClientEnvironment2 = _interopRequireDefault(_relayClientEnvironment);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _isPageType = __webpack_require__("./src/utils/isPageType.js");

var _isPageType2 = _interopRequireDefault(_isPageType);

var _pageConstants = __webpack_require__("./src/utils/pageConstants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LAST_SHOWN_TOKEN = 'last_shown_trade_onboarding_modal';
var MODAL_TYPE = 'tradeOnboardingModal';
var CONTAINER_CLASSNAME = 'tradeSourcingCTAModalContainer';

var ORIGIN_SOLD = exports.ORIGIN_SOLD = 'Sold PDP';
var ORIGIN_HOLD = exports.ORIGIN_HOLD = 'Hold PDP';
var ORIGIN_FAVORITE = exports.ORIGIN_FAVORITE = 'Post Favorite';
var ORIGIN_FOLDER = exports.ORIGIN_FOLDER = 'Post Folder';
var LABEL_PDP = exports.LABEL_PDP = 'pdp';
var LABEL_SEARCH_BROWSE = exports.LABEL_SEARCH_BROWSE = 'search/browse';

var getModalType = exports.getModalType = function getModalType() {
    return MODAL_TYPE;
};
var hasSeenModal = exports.hasSeenModal = function hasSeenModal() {
    return !!_dibsBrowserStorage.localStorage.getItem(LAST_SHOWN_TOKEN);
};
var markModalShown = exports.markModalShown = function markModalShown() {
    return _dibsBrowserStorage.localStorage.setItem(LAST_SHOWN_TOKEN, Date.now());
};

var getContainerElement = exports.getContainerElement = function getContainerElement() {
    var containerElement = document.querySelector('.' + CONTAINER_CLASSNAME);
    if (!containerElement) {
        containerElement = document.createElement('div');
        containerElement.classList.add(CONTAINER_CLASSNAME);
        document.body.appendChild(containerElement);
    }
    return containerElement;
};

var query = {
    modern: function modern() {
        return __webpack_require__("./src/utils/__generated__/tradeOnboardingHelper_Query.graphql.js");
    },
    classic: function classic(RelayQL_GENERATED) {
        return {
            kind: 'OperationDefinition',
            argumentDefinitions: [{
                defaultValue: null,
                kind: 'LocalArgument',
                name: 'userId'
            }],
            name: 'tradeOnboardingHelper_Query',
            operation: 'query',
            node: function () {
                return {
                    children: [{
                        children: [{
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'userId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userId'
                                }
                            }],
                            children: [{
                                alias: 'isVerifiedTrade',
                                calls: [{
                                    kind: 'Call',
                                    metadata: {},
                                    name: 'name',
                                    value: {
                                        kind: 'CallValue',
                                        callValue: 'B_NET_PRICE'
                                    }
                                }],
                                fieldName: 'hasPermission',
                                kind: 'Field',
                                metadata: {},
                                type: 'Boolean'
                            }, {
                                children: [{
                                    fieldName: 'email',
                                    kind: 'Field',
                                    metadata: {},
                                    type: 'String'
                                }],
                                fieldName: 'profile',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true
                                },
                                type: 'Profile'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'user',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'User'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        fieldName: 'viewer',
                        kind: 'Field',
                        metadata: {
                            canHaveSubselections: true,
                            inferredRootCallName: 'node',
                            inferredPrimaryKey: 'id'
                        },
                        type: 'Viewer'
                    }],
                    id: RelayQL_GENERATED.__id(),
                    kind: 'Fragment',
                    metadata: {},
                    name: 'TradeOnboardingHelper_Query',
                    type: 'Query'
                };
            }()
        };
    }
};

var fetchTradeUserData = exports.fetchTradeUserData = function fetchTradeUserData() {
    var userId = (0, _dibsCookieJar.getUserId)(document.cookie, _dibsCookieJar.cookieJarConstants.MASQUERADE_BUYER);

    if (!userId) {
        return Promise.resolve(false);
    }

    return new Promise(function (resolve, reject) {
        (0, _reactRelay.fetchQuery)((0, _relayClientEnvironment2.default)(), query, {
            userId: userId
        }).then(function (data) {
            var userData = (0, _lodash2.default)(data, 'viewer.user') || {};
            resolve({
                isVerifiedTrade: (0, _lodash2.default)(userData, 'isVerifiedTrade'),
                email: (0, _lodash2.default)(userData, 'profile.email')
            });
        }).catch(function (error) {
            reject(error);
        });
    });
};

var loadOnboardingModal = exports.loadOnboardingModal = function loadOnboardingModal(options) {
    var chatUtils = __webpack_require__("./src/utils/chat.js").default;

    return new Promise(function (resolve, reject) {
        __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./node_modules/dibs-trade-onboarding/dist/bundle.js")).then(function (_ref) {
            var onboardingModal = _ref.onboardingModal;

            var modalOptions = _extends({}, options, {
                onSendSourcingDataSuccess: function onSendSourcingDataSuccess() {
                    return chatUtils.track.sourcingRequestSubmitted();
                }
            });

            var _onboardingModal = onboardingModal(modalOptions),
                Modal = _onboardingModal.Modal;

            _reactDom2.default.render(_react2.default.createElement(Modal), getContainerElement());
            markModalShown();
            resolve(true);
        }).catch(reject);
    });
};

var loadOnboardingModalWithOrigin = exports.loadOnboardingModalWithOrigin = function loadOnboardingModalWithOrigin(requestOrigin) {
    if (hasSeenModal()) {
        return;
    }

    var label = (0, _isPageType2.default)(_pageConstants.PAGE_TYPE.PDP) ? LABEL_PDP : LABEL_SEARCH_BROWSE;

    fetchTradeUserData().then(function (_ref2) {
        var email = _ref2.email,
            isVerifiedTrade = _ref2.isVerifiedTrade;

        if (isVerifiedTrade) {
            loadOnboardingModal({
                buyerEmail: email,
                requestOrigin: requestOrigin,
                trackingLabel: 'modal - ' + label
            });
        }
    });
};

var loadSourcingModal = exports.loadSourcingModal = function loadSourcingModal(options) {
    var chatUtils = __webpack_require__("./src/utils/chat.js").default;

    return new Promise(function (resolve, reject) {
        __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./node_modules/dibs-trade-onboarding/dist/bundle.js")).then(function (_ref3) {
            var sourcingModal = _ref3.sourcingModal;

            var modalOptions = _extends({}, options, {
                onSendSourcingDataSuccess: function onSendSourcingDataSuccess() {
                    return chatUtils.track.sourcingRequestSubmitted();
                }
            });

            var _sourcingModal = sourcingModal(modalOptions),
                SourcingModal = _sourcingModal.SourcingModal;

            _reactDom2.default.render(_react2.default.createElement(SourcingModal), getContainerElement());
            resolve(true);
        }).catch(reject);
    });
};

/***/ }),

/***/ "./src/utils/userTracking.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.viewerFragment = exports.userFragment = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _BUYER_STATUSES_MAP;

exports.init = init;

var _reactRelay = __webpack_require__("./node_modules/react-relay/compat.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _dibsTracking2 = _interopRequireDefault(_dibsTracking);

var _md = __webpack_require__("./node_modules/md5/md5.js");

var _md2 = _interopRequireDefault(_md);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var USER_EMAIL_TOKEN = 'userEmailToken';
var USER_EMAIL = 'userEmail';
var STORAGE_TRANSACTIONS_STATUS = 'userTransactionsStatus';
var BUYER_STATUS_NONE = 'NONE';
var BUYER_STATUS_CONFIRMED_MULTIPLE = 'CONFIRMED_MULTIPLE';
var BUYER_STATUS_CONFIRMED_ONE = 'CONFIRMED_ONE';
var BUYER_STATUS_SUBMITTED = 'SUBMITTED';
var BUYER_STATUS_INITIATED = 'INITIATED';
var FIRST_PURCHASE_RANGES = {
    10000: '> $10K',
    5000: '$5K to $10K',
    3000: '$3K to $5K',
    1000: '$1K to $3K',
    0: '< $1K'
};
var BUYER_STATUSES_MAP = (_BUYER_STATUSES_MAP = {}, _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_CONFIRMED_MULTIPLE, 'confirmed|multiple orders'), _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_CONFIRMED_ONE, 'confirmed|one order'), _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_SUBMITTED, 'submitted|none confirmed'), _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_INITIATED, 'initiated|none submitted'), _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_NONE, 'no orders initiated'), _BUYER_STATUSES_MAP);

function formatDate(dateString) {
    var date = new Date(dateString);
    return date.getMonth() + 1 + '-' + date.getFullYear();
}

/*
 * depending on transaction history, determine which value to add for the BUYER_STATUSES_MAP
*/
function getBuyerStatusFromTransactions(transactions) {
    var initiatedTransactions = transactions.initiatedTransactions,
        submittedTransactions = transactions.submittedTransactions,
        confirmedTransactions = transactions.confirmedTransactions;

    var buyerStatus = void 0;

    if (confirmedTransactions && confirmedTransactions.totalResults > 1) {
        buyerStatus = BUYER_STATUS_CONFIRMED_MULTIPLE;
    } else if (confirmedTransactions && confirmedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_CONFIRMED_ONE;
    } else if (submittedTransactions && submittedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_SUBMITTED;
    } else if (initiatedTransactions && initiatedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_INITIATED;
    } else {
        buyerStatus = BUYER_STATUS_NONE;
    }

    return { buyerStatus: buyerStatus };
}

/*
 * determines the USD amount of the most recent purchase so it can map it to FIRST_PURCHASE_RANGES.
*/
function getFirstPurchaseInfo(transactions) {
    var confirmedTransactions = transactions.confirmedTransactions;

    var firstPurchasePrice = void 0;
    var firstPurchaseDate = void 0;

    if (confirmedTransactions && confirmedTransactions.totalResults) {
        var price = (0, _lodash2.default)(confirmedTransactions, 'edges[0].node.mostRecentOffer.subTotalAmount.convertedAmounts.USD');
        var date = (0, _lodash2.default)(confirmedTransactions, 'edges[0].node.mostRecentOffer.createdDate');
        // Format date
        if (date) {
            firstPurchaseDate = formatDate(date);
        }

        // Format price range
        if (price) {
            for (var range in FIRST_PURCHASE_RANGES) {
                if (price >= range) {
                    firstPurchasePrice = FIRST_PURCHASE_RANGES[range];
                }
            }
        }
    }
    return {
        firstPurchasePrice: firstPurchasePrice,
        firstPurchaseDate: firstPurchaseDate
    };
}

/*
 * fetches all transactions created by user using different filters
 * in order to track order history
*/
function getTransactionsStatus(transactions) {
    var totalTransactions = 0;
    var transactionsStatus = {
        buyerStatus: BUYER_STATUS_NONE,
        totalTransactions: totalTransactions
    };
    // if user has any transactions, go through them to determine which value from BUYER_STATUSES_MAP it should have
    if (transactions.allTransactions) {
        totalTransactions = transactions.allTransactions.totalResults;
        transactionsStatus = getBuyerStatusFromTransactions(transactions);
        Object.assign(transactionsStatus, getFirstPurchaseInfo(transactions), { totalTransactions: totalTransactions });

        _dibsBrowserStorage.sessionStorage.setItem(STORAGE_TRANSACTIONS_STATUS, transactionsStatus);
    } else {
        // otherwise default to sessionStorage (dont think we currently use it in mobile) or no transactions at all
        transactionsStatus = _dibsBrowserStorage.sessionStorage.getItem(STORAGE_TRANSACTIONS_STATUS) || transactionsStatus;
    }
    if (transactionsStatus) {
        transactionsStatus.buyerStatus = BUYER_STATUSES_MAP[transactionsStatus.buyerStatus];
    }

    return transactionsStatus;
}

/*
 * create the userType tag according to user permissions.
 * VIP|Trade|Unknown|undefined (logged out)
*/
function getCustomerType(user) {
    if (user.serviceId) {
        var isTrade = user.isTrade ? 'Trade' : '';
        var hasVipPermission = user.hasVipPermission ? 'VIP' : '';
        return '' + isTrade + (isTrade && hasVipPermission ? ' and ' : '') + hasVipPermission || 'consumer';
    } else if (user.everLoggedIn) {
        return undefined;
    } else {
        return 'Unknown';
    }
}

/*
 * creates the user tracking data.
*/
function trackUserAttributes(_ref) {
    var _ref$transactions = _ref.transactions,
        transactions = _ref$transactions === undefined ? {} : _ref$transactions,
        _ref$user = _ref.user,
        user = _ref$user === undefined ? {} : _ref$user;

    var userEmail = (0, _lodash2.default)(user, 'profile.email') || _dibsBrowserStorage.localStorage.getItem(USER_EMAIL);
    var transactionsStatus = getTransactionsStatus(transactions);

    /*
    * Appends cdn test value to data layer tracking object.
    * Here it only adds the value to global object variable,
    * tracking itself is done with 'tracking.addUserAttributes'
    */
    _dibsTracking2.default.updateGtmPageInfo({
        cdnTest3: 'newregpromo=' + !!(0, _lodash2.default)(user, 'isPromoCodeEligible')
    });

    _dibsTracking2.default.addUserAttributes({
        loginStatus: user.serviceId ? 'Logged In' : 'Logged Out',
        registrationStatus: user.everLoggedIn ? 'Registered' : 'Not Registered',
        userID: user.serviceId,
        guestID: (0, _dibsCookieJar.getGuestId)(document.cookie),
        userEmail: userEmail ? (0, _md2.default)(userEmail) : undefined,
        userEmailAddress: user.serviceId ? userEmail : undefined,
        emailToken: _dibsBrowserStorage.localStorage.getItem(USER_EMAIL_TOKEN),
        userZip: (0, _lodash2.default)(user, 'profile.zipCode'),
        defaultCurrency: (0, _lodash2.default)(user, 'profile.currency'),
        firstSessionDate: user.firstSessionDate || undefined,
        contactDealerStatus: user.totalMessagesToDealers ? 'dealer contacted' : 'no dealer contacted',
        buyerStatus: transactionsStatus.buyerStatus,
        firstPurchasePrice: transactionsStatus.firstPurchasePrice || 'na',
        firstPurchaseDate: transactionsStatus.firstPurchaseDate || 'na',
        tradeStatus: user.verifiedTradeStatus,
        customerType: getCustomerType(user),
        tradeTier: (0, _lodash2.default)(user, 'tradeFirm.tier'),
        tradeFirmId: (0, _lodash2.default)(user, 'tradeFirm.serviceId')
    });
}

var userFragment = exports.userFragment = {
    user: {
        modern: function modern() {
            return __webpack_require__("./src/utils/__generated__/userTracking_user.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [],
                node: function () {
                    return {
                        children: [{
                            fieldName: 'firstSessionDate',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            alias: 'isTrade',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'name',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'B_TRADE_CHECKOUT'
                                }
                            }],
                            fieldName: 'hasPermission',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            alias: 'hasVipPermission',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'name',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'B_VIP_CHECKOUT'
                                }
                            }],
                            fieldName: 'hasPermission',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            children: [{
                                fieldName: 'email',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'zipCode',
                                kind: 'Field',
                                metadata: {},
                                type: 'String'
                            }, {
                                fieldName: 'currency',
                                kind: 'Field',
                                metadata: {},
                                type: 'Currency'
                            }],
                            fieldName: 'profile',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true
                            },
                            type: 'Profile'
                        }, {
                            fieldName: 'serviceId',
                            kind: 'Field',
                            metadata: {},
                            type: 'ID'
                        }, {
                            fieldName: 'totalMessagesToDealers',
                            kind: 'Field',
                            metadata: {},
                            type: 'Int'
                        }, {
                            children: [{
                                fieldName: 'serviceId',
                                kind: 'Field',
                                metadata: {},
                                type: 'ID'
                            }, {
                                fieldName: 'tier',
                                kind: 'Field',
                                metadata: {},
                                type: 'TradeFirmSalesTier'
                            }, {
                                fieldName: 'id',
                                kind: 'Field',
                                metadata: {
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'ID'
                            }],
                            fieldName: 'tradeFirm',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                inferredRootCallName: 'node',
                                inferredPrimaryKey: 'id'
                            },
                            type: 'TradeFirmType'
                        }, {
                            fieldName: 'verifiedTradeStatus',
                            kind: 'Field',
                            metadata: {},
                            type: 'String'
                        }, {
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'code',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'SAVE15'
                                }
                            }],
                            fieldName: 'isPromoCodeEligible',
                            kind: 'Field',
                            metadata: {},
                            type: 'Boolean'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'UserTracking_user',
                        type: 'User'
                    };
                }()
            };
        }
    }
};

function getUserFragmentData(user) {
    var firstSessionDate = user.firstSessionDate,
        isTrade = user.isTrade,
        hasVipPermission = user.hasVipPermission,
        profile = user.profile,
        serviceId = user.serviceId,
        totalMessagesToDealers = user.totalMessagesToDealers,
        tradeFirm = user.tradeFirm,
        verifiedTradeStatus = user.verifiedTradeStatus,
        isPromoCodeEligible = user.isPromoCodeEligible;

    return { firstSessionDate: firstSessionDate, isTrade: isTrade, hasVipPermission: hasVipPermission, profile: profile, serviceId: serviceId, totalMessagesToDealers: totalMessagesToDealers, tradeFirm: tradeFirm, verifiedTradeStatus: verifiedTradeStatus, isPromoCodeEligible: isPromoCodeEligible };
}

var viewerFragment = exports.viewerFragment = {
    viewer: {
        modern: function modern() {
            return __webpack_require__("./src/utils/__generated__/userTracking_viewer.graphql.js");
        },
        classic: function classic(RelayQL_GENERATED) {
            return {
                kind: 'FragmentDefinition',
                argumentDefinitions: [{
                    kind: 'RootArgument',
                    name: 'userIds'
                }, {
                    kind: 'RootArgument',
                    name: 'hasUserId'
                }],
                node: function () {
                    return {
                        children: [{
                            alias: 'allTransactions',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'first',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 0
                                }
                            }],
                            children: [{
                                fieldName: 'totalResults',
                                kind: 'Field',
                                metadata: {},
                                type: 'Int'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            fieldName: 'transactions',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'TransactionConnection'
                        }, {
                            alias: 'initiatedTransactions',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {},
                                name: 'viewName',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'buyerTracking.initiated'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'first',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 0
                                }
                            }],
                            children: [{
                                fieldName: 'totalResults',
                                kind: 'Field',
                                metadata: {},
                                type: 'Int'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            fieldName: 'transactions',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'TransactionConnection'
                        }, {
                            alias: 'submittedTransactions',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {},
                                name: 'viewName',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'buyerTracking.submitted'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'first',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 0
                                }
                            }],
                            children: [{
                                fieldName: 'totalResults',
                                kind: 'Field',
                                metadata: {},
                                type: 'Int'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            fieldName: 'transactions',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'TransactionConnection'
                        }, {
                            alias: 'confirmedTransactionsMostRecent',
                            calls: [{
                                kind: 'Call',
                                metadata: {},
                                name: 'buyerId',
                                value: {
                                    kind: 'CallVariable',
                                    callVariableName: 'userIds'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {},
                                name: 'sort',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'createdDate asc'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {},
                                name: 'viewName',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 'buyerTracking.confirmed'
                                }
                            }, {
                                kind: 'Call',
                                metadata: {
                                    type: 'Int'
                                },
                                name: 'first',
                                value: {
                                    kind: 'CallValue',
                                    callValue: 1
                                }
                            }],
                            children: [{
                                fieldName: 'totalResults',
                                kind: 'Field',
                                metadata: {},
                                type: 'Int'
                            }, {
                                children: [{
                                    children: [{
                                        children: [{
                                            fieldName: 'createdDate',
                                            kind: 'Field',
                                            metadata: {},
                                            type: 'String'
                                        }, {
                                            children: [{
                                                children: [{
                                                    fieldName: 'USD',
                                                    kind: 'Field',
                                                    metadata: {},
                                                    type: 'Float'
                                                }],
                                                fieldName: 'convertedAmounts',
                                                kind: 'Field',
                                                metadata: {
                                                    canHaveSubselections: true
                                                },
                                                type: 'ConvertedAmounts'
                                            }],
                                            fieldName: 'subTotalAmount',
                                            kind: 'Field',
                                            metadata: {
                                                canHaveSubselections: true
                                            },
                                            type: 'FinancialAmount'
                                        }, {
                                            fieldName: 'id',
                                            kind: 'Field',
                                            metadata: {
                                                isGenerated: true,
                                                isRequisite: true
                                            },
                                            type: 'ID'
                                        }],
                                        fieldName: 'mostRecentOffer',
                                        kind: 'Field',
                                        metadata: {
                                            canHaveSubselections: true,
                                            inferredRootCallName: 'node',
                                            inferredPrimaryKey: 'id'
                                        },
                                        type: 'Offer'
                                    }, {
                                        fieldName: 'id',
                                        kind: 'Field',
                                        metadata: {
                                            isGenerated: true,
                                            isRequisite: true
                                        },
                                        type: 'ID'
                                    }],
                                    fieldName: 'node',
                                    kind: 'Field',
                                    metadata: {
                                        canHaveSubselections: true,
                                        inferredRootCallName: 'node',
                                        inferredPrimaryKey: 'id',
                                        isRequisite: true
                                    },
                                    type: 'Transaction'
                                }, {
                                    fieldName: 'cursor',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'String'
                                }],
                                fieldName: 'edges',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isPlural: true
                                },
                                type: 'TransactionEdge'
                            }, {
                                children: [{
                                    fieldName: 'hasNextPage',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'Boolean'
                                }, {
                                    fieldName: 'hasPreviousPage',
                                    kind: 'Field',
                                    metadata: {
                                        isGenerated: true,
                                        isRequisite: true
                                    },
                                    type: 'Boolean'
                                }],
                                fieldName: 'pageInfo',
                                kind: 'Field',
                                metadata: {
                                    canHaveSubselections: true,
                                    isGenerated: true,
                                    isRequisite: true
                                },
                                type: 'PageInfo'
                            }],
                            directives: [{
                                kind: 'Directive',
                                name: 'include',
                                args: [{
                                    name: 'if',
                                    value: {
                                        kind: 'CallVariable',
                                        callVariableName: 'hasUserId'
                                    }
                                }]
                            }],
                            fieldName: 'transactions',
                            kind: 'Field',
                            metadata: {
                                canHaveSubselections: true,
                                isConnection: true
                            },
                            type: 'TransactionConnection'
                        }, {
                            fieldName: 'id',
                            kind: 'Field',
                            metadata: {
                                isGenerated: true,
                                isRequisite: true
                            },
                            type: 'ID'
                        }],
                        id: RelayQL_GENERATED.__id(),
                        kind: 'Fragment',
                        metadata: {},
                        name: 'UserTracking_viewer',
                        type: 'Viewer'
                    };
                }()
            };
        }
    }
};

function getViewerFragmentData(viewer) {
    var allTransactions = viewer.allTransactions,
        initiatedTransactions = viewer.initiatedTransactions,
        submittedTransactions = viewer.submittedTransactions,
        confirmedTransactionsMostRecent = viewer.confirmedTransactionsMostRecent;

    return { allTransactions: allTransactions, initiatedTransactions: initiatedTransactions, submittedTransactions: submittedTransactions, confirmedTransactions: confirmedTransactionsMostRecent };
}

/*
 * should be called on initial page load for all entries.
 * determines user tracking data to send to dibs-tracking.
 */
function init(_ref2) {
    var _ref2$viewer = _ref2.viewer,
        viewer = _ref2$viewer === undefined ? {} : _ref2$viewer,
        user = _ref2.user;

    var transactions = getViewerFragmentData(viewer);
    var everLoggedIn = (0, _dibsCookieJar.getEverLoggedIn)(document.cookie);
    var userFragmentData = user ? getUserFragmentData(user) : undefined;

    trackUserAttributes({ user: _extends({}, userFragmentData, { everLoggedIn: everLoggedIn }), transactions: transactions });
}

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "dll-reference dibs_vendor":
/***/ (function(module, exports) {

module.exports = dibs_vendor;

/***/ })

/******/ });


// WEBPACK FOOTER //
// dibs_buyer_layout_14.0.7_88ae53ee0fe598c268fd.js